"use strict";(()=>{var a2=Object.create;var d1=Object.defineProperty;var s2=Object.getOwnPropertyDescriptor;var l2=Object.getOwnPropertyNames;var c2=Object.getPrototypeOf,d2=Object.prototype.hasOwnProperty;var zn=(e,t)=>()=>(t||e((t={exports:{}}).exports,t),t.exports);var u2=(e,t,r,n)=>{if(t&&typeof t=="object"||typeof t=="function")for(let o of l2(t))!d2.call(e,o)&&o!==r&&d1(e,o,{get:()=>t[o],enumerable:!(n=s2(t,o))||n.enumerable});return e};var T=(e,t,r)=>(r=e!=null?a2(c2(e)):{},u2(t||!e||!e.__esModule?d1(r,"default",{value:e,enumerable:!0}):r,e));var b1=zn(ke=>{"use strict";var Kc=Symbol.for("react.element"),p2=Symbol.for("react.portal"),m2=Symbol.for("react.fragment"),f2=Symbol.for("react.strict_mode"),h2=Symbol.for("react.profiler"),g2=Symbol.for("react.provider"),Y2=Symbol.for("react.context"),S2=Symbol.for("react.forward_ref"),y2=Symbol.for("react.suspense"),x2=Symbol.for("react.memo"),b2=Symbol.for("react.lazy"),u1=Symbol.iterator;function C2(e){return e===null||typeof e!="object"?null:(e=u1&&e[u1]||e["@@iterator"],typeof e=="function"?e:null)}var f1={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},h1=Object.assign,g1={};function il(e,t,r){this.props=e,this.context=t,this.refs=g1,this.updater=r||f1}il.prototype.isReactComponent={};il.prototype.setState=function(e,t){if(typeof e!="object"&&typeof e!="function"&&e!=null)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,e,t,"setState")};il.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")};function Y1(){}Y1.prototype=il.prototype;function ig(e,t,r){this.props=e,this.context=t,this.refs=g1,this.updater=r||f1}var ag=ig.prototype=new Y1;ag.constructor=ig;h1(ag,il.prototype);ag.isPureReactComponent=!0;var p1=Array.isArray,S1=Object.prototype.hasOwnProperty,sg={current:null},y1={key:!0,ref:!0,__self:!0,__source:!0};function x1(e,t,r){var n,o={},i=null,a=null;if(t!=null)for(n in t.ref!==void 0&&(a=t.ref),t.key!==void 0&&(i=""+t.key),t)S1.call(t,n)&&!y1.hasOwnProperty(n)&&(o[n]=t[n]);var s=arguments.length-2;if(s===1)o.children=r;else if(1<s){for(var l=Array(s),c=0;c<s;c++)l[c]=arguments[c+2];o.children=l}if(e&&e.defaultProps)for(n in s=e.defaultProps,s)o[n]===void 0&&(o[n]=s[n]);return{$$typeof:Kc,type:e,key:i,ref:a,props:o,_owner:sg.current}}function P2(e,t){return{$$typeof:Kc,type:e.type,key:t,ref:e.ref,props:e.props,_owner:e._owner}}function lg(e){return typeof e=="object"&&e!==null&&e.$$typeof===Kc}function W2(e){var t={"=":"=0",":":"=2"};return"$"+e.replace(/[=:]/g,function(r){return t[r]})}var m1=/\/+/g;function og(e,t){return typeof e=="object"&&e!==null&&e.key!=null?W2(""+e.key):t.toString(36)}function lp(e,t,r,n,o){var i=typeof e;(i==="undefined"||i==="boolean")&&(e=null);var a=!1;if(e===null)a=!0;else switch(i){case"string":case"number":a=!0;break;case"object":switch(e.$$typeof){case Kc:case p2:a=!0}}if(a)return a=e,o=o(a),e=n===""?"."+og(a,0):n,p1(o)?(r="",e!=null&&(r=e.replace(m1,"$&/")+"/"),lp(o,t,r,"",function(c){return c})):o!=null&&(lg(o)&&(o=P2(o,r+(!o.key||a&&a.key===o.key?"":(""+o.key).replace(m1,"$&/")+"/")+e)),t.push(o)),1;if(a=0,n=n===""?".":n+":",p1(e))for(var s=0;s<e.length;s++){i=e[s];var l=n+og(i,s);a+=lp(i,t,r,l,o)}else if(l=C2(e),typeof l=="function")for(e=l.call(e),s=0;!(i=e.next()).done;)i=i.value,l=n+og(i,s++),a+=lp(i,t,r,l,o);else if(i==="object")throw t=String(e),Error("Objects are not valid as a React child (found: "+(t==="[object Object]"?"object with keys {"+Object.keys(e).join(", ")+"}":t)+"). If you meant to render a collection of children, use an array instead.");return a}function sp(e,t,r){if(e==null)return e;var n=[],o=0;return lp(e,n,"","",function(i){return t.call(r,i,o++)}),n}function v2(e){if(e._status===-1){var t=e._result;t=t(),t.then(function(r){(e._status===0||e._status===-1)&&(e._status=1,e._result=r)},function(r){(e._status===0||e._status===-1)&&(e._status=2,e._result=r)}),e._status===-1&&(e._status=0,e._result=t)}if(e._status===1)return e._result.default;throw e._result}var Ur={current:null},cp={transition:null},w2={ReactCurrentDispatcher:Ur,ReactCurrentBatchConfig:cp,ReactCurrentOwner:sg};ke.Children={map:sp,forEach:function(e,t,r){sp(e,function(){t.apply(this,arguments)},r)},count:function(e){var t=0;return sp(e,function(){t++}),t},toArray:function(e){return sp(e,function(t){return t})||[]},only:function(e){if(!lg(e))throw Error("React.Children.only expected to receive a single React element child.");return e}};ke.Component=il;ke.Fragment=m2;ke.Profiler=h2;ke.PureComponent=ig;ke.StrictMode=f2;ke.Suspense=y2;ke.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=w2;ke.cloneElement=function(e,t,r){if(e==null)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+e+".");var n=h1({},e.props),o=e.key,i=e.ref,a=e._owner;if(t!=null){if(t.ref!==void 0&&(i=t.ref,a=sg.current),t.key!==void 0&&(o=""+t.key),e.type&&e.type.defaultProps)var s=e.type.defaultProps;for(l in t)S1.call(t,l)&&!y1.hasOwnProperty(l)&&(n[l]=t[l]===void 0&&s!==void 0?s[l]:t[l])}var l=arguments.length-2;if(l===1)n.children=r;else if(1<l){s=Array(l);for(var c=0;c<l;c++)s[c]=arguments[c+2];n.children=s}return{$$typeof:Kc,type:e.type,key:o,ref:i,props:n,_owner:a}};ke.createContext=function(e){return e={$$typeof:Y2,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null},e.Provider={$$typeof:g2,_context:e},e.Consumer=e};ke.createElement=x1;ke.createFactory=function(e){var t=x1.bind(null,e);return t.type=e,t};ke.createRef=function(){return{current:null}};ke.forwardRef=function(e){return{$$typeof:S2,render:e}};ke.isValidElement=lg;ke.lazy=function(e){return{$$typeof:b2,_payload:{_status:-1,_result:e},_init:v2}};ke.memo=function(e,t){return{$$typeof:x2,type:e,compare:t===void 0?null:t}};ke.startTransition=function(e){var t=cp.transition;cp.transition={};try{e()}finally{cp.transition=t}};ke.unstable_act=function(){throw Error("act(...) is not supported in production builds of React.")};ke.useCallback=function(e,t){return Ur.current.useCallback(e,t)};ke.useContext=function(e){return Ur.current.useContext(e)};ke.useDebugValue=function(){};ke.useDeferredValue=function(e){return Ur.current.useDeferredValue(e)};ke.useEffect=function(e,t){return Ur.current.useEffect(e,t)};ke.useId=function(){return Ur.current.useId()};ke.useImperativeHandle=function(e,t,r){return Ur.current.useImperativeHandle(e,t,r)};ke.useInsertionEffect=function(e,t){return Ur.current.useInsertionEffect(e,t)};ke.useLayoutEffect=function(e,t){return Ur.current.useLayoutEffect(e,t)};ke.useMemo=function(e,t){return Ur.current.useMemo(e,t)};ke.useReducer=function(e,t,r){return Ur.current.useReducer(e,t,r)};ke.useRef=function(e){return Ur.current.useRef(e)};ke.useState=function(e){return Ur.current.useState(e)};ke.useSyncExternalStore=function(e,t,r){return Ur.current.useSyncExternalStore(e,t,r)};ke.useTransition=function(){return Ur.current.useTransition()};ke.version="18.2.0"});var oe=zn((z_,C1)=>{"use strict";C1.exports=b1()});var W1=zn(dp=>{"use strict";var T2=oe(),M2=Symbol.for("react.element"),U2=Symbol.for("react.fragment"),I2=Object.prototype.hasOwnProperty,V2=T2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,k2={key:!0,ref:!0,__self:!0,__source:!0};function P1(e,t,r){var n,o={},i=null,a=null;r!==void 0&&(i=""+r),t.key!==void 0&&(i=""+t.key),t.ref!==void 0&&(a=t.ref);for(n in t)I2.call(t,n)&&!k2.hasOwnProperty(n)&&(o[n]=t[n]);if(e&&e.defaultProps)for(n in t=e.defaultProps,t)o[n]===void 0&&(o[n]=t[n]);return{$$typeof:M2,type:e,key:i,ref:a,props:o,_owner:V2.current}}dp.Fragment=U2;dp.jsx=P1;dp.jsxs=P1});var k=zn((H_,v1)=>{"use strict";v1.exports=W1()});var A1=zn(et=>{"use strict";function pg(e,t){var r=e.length;e.push(t);e:for(;0<r;){var n=r-1>>>1,o=e[n];if(0<pp(o,t))e[n]=t,e[r]=o,r=n;else break e}}function Kn(e){return e.length===0?null:e[0]}function fp(e){if(e.length===0)return null;var t=e[0],r=e.pop();if(r!==t){e[0]=r;e:for(var n=0,o=e.length,i=o>>>1;n<i;){var a=2*(n+1)-1,s=e[a],l=a+1,c=e[l];if(0>pp(s,r))l<o&&0>pp(c,s)?(e[n]=c,e[l]=r,n=l):(e[n]=s,e[a]=r,n=a);else if(l<o&&0>pp(c,r))e[n]=c,e[l]=r,n=l;else break e}}return t}function pp(e,t){var r=e.sortIndex-t.sortIndex;return r!==0?r:e.id-t.id}typeof performance=="object"&&typeof performance.now=="function"?(M1=performance,et.unstable_now=function(){return M1.now()}):(cg=Date,U1=cg.now(),et.unstable_now=function(){return cg.now()-U1});var M1,cg,U1,Po=[],Oi=[],L2=1,Un=null,Yr=3,hp=!1,Qa=!1,Qc=!1,k1=typeof setTimeout=="function"?setTimeout:null,L1=typeof clearTimeout=="function"?clearTimeout:null,I1=typeof setImmediate!="undefined"?setImmediate:null;typeof navigator!="undefined"&&navigator.scheduling!==void 0&&navigator.scheduling.isInputPending!==void 0&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function mg(e){for(var t=Kn(Oi);t!==null;){if(t.callback===null)fp(Oi);else if(t.startTime<=e)fp(Oi),t.sortIndex=t.expirationTime,pg(Po,t);else break;t=Kn(Oi)}}function fg(e){if(Qc=!1,mg(e),!Qa)if(Kn(Po)!==null)Qa=!0,gg(hg);else{var t=Kn(Oi);t!==null&&Yg(fg,t.startTime-e)}}function hg(e,t){Qa=!1,Qc&&(Qc=!1,L1(jc),jc=-1),hp=!0;var r=Yr;try{for(mg(t),Un=Kn(Po);Un!==null&&(!(Un.expirationTime>t)||e&&!E1());){var n=Un.callback;if(typeof n=="function"){Un.callback=null,Yr=Un.priorityLevel;var o=n(Un.expirationTime<=t);t=et.unstable_now(),typeof o=="function"?Un.callback=o:Un===Kn(Po)&&fp(Po),mg(t)}else fp(Po);Un=Kn(Po)}if(Un!==null)var i=!0;else{var a=Kn(Oi);a!==null&&Yg(fg,a.startTime-t),i=!1}return i}finally{Un=null,Yr=r,hp=!1}}var gp=!1,mp=null,jc=-1,X1=5,N1=-1;function E1(){return!(et.unstable_now()-N1<X1)}function dg(){if(mp!==null){var e=et.unstable_now();N1=e;var t=!0;try{t=mp(!0,e)}finally{t?Hc():(gp=!1,mp=null)}}else gp=!1}var Hc;typeof I1=="function"?Hc=function(){I1(dg)}:typeof MessageChannel!="undefined"?(ug=new MessageChannel,V1=ug.port2,ug.port1.onmessage=dg,Hc=function(){V1.postMessage(null)}):Hc=function(){k1(dg,0)};var ug,V1;function gg(e){mp=e,gp||(gp=!0,Hc())}function Yg(e,t){jc=k1(function(){e(et.unstable_now())},t)}et.unstable_IdlePriority=5;et.unstable_ImmediatePriority=1;et.unstable_LowPriority=4;et.unstable_NormalPriority=3;et.unstable_Profiling=null;et.unstable_UserBlockingPriority=2;et.unstable_cancelCallback=function(e){e.callback=null};et.unstable_continueExecution=function(){Qa||hp||(Qa=!0,gg(hg))};et.unstable_forceFrameRate=function(e){0>e||125<e?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):X1=0<e?Math.floor(1e3/e):5};et.unstable_getCurrentPriorityLevel=function(){return Yr};et.unstable_getFirstCallbackNode=function(){return Kn(Po)};et.unstable_next=function(e){switch(Yr){case 1:case 2:case 3:var t=3;break;default:t=Yr}var r=Yr;Yr=t;try{return e()}finally{Yr=r}};et.unstable_pauseExecution=function(){};et.unstable_requestPaint=function(){};et.unstable_runWithPriority=function(e,t){switch(e){case 1:case 2:case 3:case 4:case 5:break;default:e=3}var r=Yr;Yr=e;try{return t()}finally{Yr=r}};et.unstable_scheduleCallback=function(e,t,r){var n=et.unstable_now();switch(typeof r=="object"&&r!==null?(r=r.delay,r=typeof r=="number"&&0<r?n+r:n):r=n,e){case 1:var o=-1;break;case 2:o=250;break;case 5:o=1073741823;break;case 4:o=1e4;break;default:o=5e3}return o=r+o,e={id:L2++,callback:t,priorityLevel:e,startTime:r,expirationTime:o,sortIndex:-1},r>n?(e.sortIndex=r,pg(Oi,e),Kn(Po)===null&&e===Kn(Oi)&&(Qc?(L1(jc),jc=-1):Qc=!0,Yg(fg,r-n))):(e.sortIndex=o,pg(Po,e),Qa||hp||(Qa=!0,gg(hg))),e};et.unstable_shouldYield=E1;et.unstable_wrapCallback=function(e){var t=Yr;return function(){var r=Yr;Yr=t;try{return e.apply(this,arguments)}finally{Yr=r}}}});var G1=zn((q_,R1)=>{"use strict";R1.exports=A1()});var FC=zn(pn=>{"use strict";var Dx=oe(),dn=G1();function F(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,r=1;r<arguments.length;r++)t+="&args[]="+encodeURIComponent(arguments[r]);return"Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var zx=new Set,yd={};function cs(e,t){wl(e,t),wl(e+"Capture",t)}function wl(e,t){for(yd[e]=t,e=0;e<t.length;e++)zx.add(t[e])}var hi=!(typeof window=="undefined"||typeof window.document=="undefined"||typeof window.document.createElement=="undefined"),_g=Object.prototype.hasOwnProperty,X2=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,_1={},B1={};function N2(e){return _g.call(B1,e)?!0:_g.call(_1,e)?!1:X2.test(e)?B1[e]=!0:(_1[e]=!0,!1)}function E2(e,t,r,n){if(r!==null&&r.type===0)return!1;switch(typeof t){case"function":case"symbol":return!0;case"boolean":return n?!1:r!==null?!r.acceptsBooleans:(e=e.toLowerCase().slice(0,5),e!=="data-"&&e!=="aria-");default:return!1}}function A2(e,t,r,n){if(t===null||typeof t=="undefined"||E2(e,t,r,n))return!0;if(n)return!1;if(r!==null)switch(r.type){case 3:return!t;case 4:return t===!1;case 5:return isNaN(t);case 6:return isNaN(t)||1>t}return!1}function kr(e,t,r,n,o,i,a){this.acceptsBooleans=t===2||t===3||t===4,this.attributeName=n,this.attributeNamespace=o,this.mustUseProperty=r,this.propertyName=e,this.type=t,this.sanitizeURL=i,this.removeEmptyString=a}var sr={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e){sr[e]=new kr(e,0,!1,e,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(e){var t=e[0];sr[t]=new kr(t,1,!1,e[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(e){sr[e]=new kr(e,2,!1,e.toLowerCase(),null,!1,!1)});["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(e){sr[e]=new kr(e,2,!1,e,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e){sr[e]=new kr(e,3,!1,e.toLowerCase(),null,!1,!1)});["checked","multiple","muted","selected"].forEach(function(e){sr[e]=new kr(e,3,!0,e,null,!1,!1)});["capture","download"].forEach(function(e){sr[e]=new kr(e,4,!1,e,null,!1,!1)});["cols","rows","size","span"].forEach(function(e){sr[e]=new kr(e,6,!1,e,null,!1,!1)});["rowSpan","start"].forEach(function(e){sr[e]=new kr(e,5,!1,e.toLowerCase(),null,!1,!1)});var kY=/[\-:]([a-z])/g;function LY(e){return e[1].toUpperCase()}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e){var t=e.replace(kY,LY);sr[t]=new kr(t,1,!1,e,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e){var t=e.replace(kY,LY);sr[t]=new kr(t,1,!1,e,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(e){var t=e.replace(kY,LY);sr[t]=new kr(t,1,!1,e,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(e){sr[e]=new kr(e,1,!1,e.toLowerCase(),null,!1,!1)});sr.xlinkHref=new kr("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(e){sr[e]=new kr(e,1,!1,e.toLowerCase(),null,!0,!0)});function XY(e,t,r,n){var o=sr.hasOwnProperty(t)?sr[t]:null;(o!==null?o.type!==0:n||!(2<t.length)||t[0]!=="o"&&t[0]!=="O"||t[1]!=="n"&&t[1]!=="N")&&(A2(t,r,o,n)&&(r=null),n||o===null?N2(t)&&(r===null?e.removeAttribute(t):e.setAttribute(t,""+r)):o.mustUseProperty?e[o.propertyName]=r===null?o.type===3?!1:"":r:(t=o.attributeName,n=o.attributeNamespace,r===null?e.removeAttribute(t):(o=o.type,r=o===3||o===4&&r===!0?"":""+r,n?e.setAttributeNS(n,t,r):e.setAttribute(t,r))))}var yi=Dx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yp=Symbol.for("react.element"),ll=Symbol.for("react.portal"),cl=Symbol.for("react.fragment"),NY=Symbol.for("react.strict_mode"),Bg=Symbol.for("react.profiler"),Kx=Symbol.for("react.provider"),Hx=Symbol.for("react.context"),EY=Symbol.for("react.forward_ref"),Zg=Symbol.for("react.suspense"),$g=Symbol.for("react.suspense_list"),AY=Symbol.for("react.memo"),Di=Symbol.for("react.lazy");Symbol.for("react.scope");Symbol.for("react.debug_trace_mode");var Qx=Symbol.for("react.offscreen");Symbol.for("react.legacy_hidden");Symbol.for("react.cache");Symbol.for("react.tracing_marker");var Z1=Symbol.iterator;function qc(e){return e===null||typeof e!="object"?null:(e=Z1&&e[Z1]||e["@@iterator"],typeof e=="function"?e:null)}var xt=Object.assign,Sg;function ad(e){if(Sg===void 0)try{throw Error()}catch(r){var t=r.stack.trim().match(/\n( *(at )?)/);Sg=t&&t[1]||""}return`
`+Sg+e}var yg=!1;function xg(e,t){if(!e||yg)return"";yg=!0;var r=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(t)if(t=function(){throw Error()},Object.defineProperty(t.prototype,"props",{set:function(){throw Error()}}),typeof Reflect=="object"&&Reflect.construct){try{Reflect.construct(t,[])}catch(c){var n=c}Reflect.construct(e,[],t)}else{try{t.call()}catch(c){n=c}e.call(t.prototype)}else{try{throw Error()}catch(c){n=c}e()}}catch(c){if(c&&n&&typeof c.stack=="string"){for(var o=c.stack.split(`
`),i=n.stack.split(`
`),a=o.length-1,s=i.length-1;1<=a&&0<=s&&o[a]!==i[s];)s--;for(;1<=a&&0<=s;a--,s--)if(o[a]!==i[s]){if(a!==1||s!==1)do if(a--,s--,0>s||o[a]!==i[s]){var l=`
`+o[a].replace(" at new "," at ");return e.displayName&&l.includes("<anonymous>")&&(l=l.replace("<anonymous>",e.displayName)),l}while(1<=a&&0<=s);break}}}finally{yg=!1,Error.prepareStackTrace=r}return(e=e?e.displayName||e.name:"")?ad(e):""}function R2(e){switch(e.tag){case 5:return ad(e.type);case 16:return ad("Lazy");case 13:return ad("Suspense");case 19:return ad("SuspenseList");case 0:case 2:case 15:return e=xg(e.type,!1),e;case 11:return e=xg(e.type.render,!1),e;case 1:return e=xg(e.type,!0),e;default:return""}}function Og(e){if(e==null)return null;if(typeof e=="function")return e.displayName||e.name||null;if(typeof e=="string")return e;switch(e){case cl:return"Fragment";case ll:return"Portal";case Bg:return"Profiler";case NY:return"StrictMode";case Zg:return"Suspense";case $g:return"SuspenseList"}if(typeof e=="object")switch(e.$$typeof){case Hx:return(e.displayName||"Context")+".Consumer";case Kx:return(e._context.displayName||"Context")+".Provider";case EY:var t=e.render;return e=e.displayName,e||(e=t.displayName||t.name||"",e=e!==""?"ForwardRef("+e+")":"ForwardRef"),e;case AY:return t=e.displayName||null,t!==null?t:Og(e.type)||"Memo";case Di:t=e._payload,e=e._init;try{return Og(e(t))}catch(r){}}return null}function G2(e){var t=e.type;switch(e.tag){case 24:return"Cache";case 9:return(t.displayName||"Context")+".Consumer";case 10:return(t._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return e=t.render,e=e.displayName||e.name||"",t.displayName||(e!==""?"ForwardRef("+e+")":"ForwardRef");case 7:return"Fragment";case 5:return t;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return Og(t);case 8:return t===NY?"StrictMode":"Mode";case 22:return"Offscreen";case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if(typeof t=="function")return t.displayName||t.name||null;if(typeof t=="string")return t}return null}function aa(e){switch(typeof e){case"boolean":case"number":case"string":case"undefined":return e;case"object":return e;default:return""}}function jx(e){var t=e.type;return(e=e.nodeName)&&e.toLowerCase()==="input"&&(t==="checkbox"||t==="radio")}function _2(e){var t=jx(e)?"checked":"value",r=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),n=""+e[t];if(!e.hasOwnProperty(t)&&typeof r!="undefined"&&typeof r.get=="function"&&typeof r.set=="function"){var o=r.get,i=r.set;return Object.defineProperty(e,t,{configurable:!0,get:function(){return o.call(this)},set:function(a){n=""+a,i.call(this,a)}}),Object.defineProperty(e,t,{enumerable:r.enumerable}),{getValue:function(){return n},setValue:function(a){n=""+a},stopTracking:function(){e._valueTracker=null,delete e[t]}}}}function Sp(e){e._valueTracker||(e._valueTracker=_2(e))}function qx(e){if(!e)return!1;var t=e._valueTracker;if(!t)return!0;var r=t.getValue(),n="";return e&&(n=jx(e)?e.checked?"true":"false":e.value),e=n,e!==r?(t.setValue(e),!0):!1}function Dp(e){if(e=e||(typeof document!="undefined"?document:void 0),typeof e=="undefined")return null;try{return e.activeElement||e.body}catch(t){return e.body}}function Fg(e,t){var r=t.checked;return xt({},t,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:r!=null?r:e._wrapperState.initialChecked})}function $1(e,t){var r=t.defaultValue==null?"":t.defaultValue,n=t.checked!=null?t.checked:t.defaultChecked;r=aa(t.value!=null?t.value:r),e._wrapperState={initialChecked:n,initialValue:r,controlled:t.type==="checkbox"||t.type==="radio"?t.checked!=null:t.value!=null}}function Jx(e,t){t=t.checked,t!=null&&XY(e,"checked",t,!1)}function Dg(e,t){Jx(e,t);var r=aa(t.value),n=t.type;if(r!=null)n==="number"?(r===0&&e.value===""||e.value!=r)&&(e.value=""+r):e.value!==""+r&&(e.value=""+r);else if(n==="submit"||n==="reset"){e.removeAttribute("value");return}t.hasOwnProperty("value")?zg(e,t.type,r):t.hasOwnProperty("defaultValue")&&zg(e,t.type,aa(t.defaultValue)),t.checked==null&&t.defaultChecked!=null&&(e.defaultChecked=!!t.defaultChecked)}function O1(e,t,r){if(t.hasOwnProperty("value")||t.hasOwnProperty("defaultValue")){var n=t.type;if(!(n!=="submit"&&n!=="reset"||t.value!==void 0&&t.value!==null))return;t=""+e._wrapperState.initialValue,r||t===e.value||(e.value=t),e.defaultValue=t}r=e.name,r!==""&&(e.name=""),e.defaultChecked=!!e._wrapperState.initialChecked,r!==""&&(e.name=r)}function zg(e,t,r){(t!=="number"||Dp(e.ownerDocument)!==e)&&(r==null?e.defaultValue=""+e._wrapperState.initialValue:e.defaultValue!==""+r&&(e.defaultValue=""+r))}var sd=Array.isArray;function xl(e,t,r,n){if(e=e.options,t){t={};for(var o=0;o<r.length;o++)t["$"+r[o]]=!0;for(r=0;r<e.length;r++)o=t.hasOwnProperty("$"+e[r].value),e[r].selected!==o&&(e[r].selected=o),o&&n&&(e[r].defaultSelected=!0)}else{for(r=""+aa(r),t=null,o=0;o<e.length;o++){if(e[o].value===r){e[o].selected=!0,n&&(e[o].defaultSelected=!0);return}t!==null||e[o].disabled||(t=e[o])}t!==null&&(t.selected=!0)}}function Kg(e,t){if(t.dangerouslySetInnerHTML!=null)throw Error(F(91));return xt({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function F1(e,t){var r=t.value;if(r==null){if(r=t.children,t=t.defaultValue,r!=null){if(t!=null)throw Error(F(92));if(sd(r)){if(1<r.length)throw Error(F(93));r=r[0]}t=r}t==null&&(t=""),r=t}e._wrapperState={initialValue:aa(r)}}function eb(e,t){var r=aa(t.value),n=aa(t.defaultValue);r!=null&&(r=""+r,r!==e.value&&(e.value=r),t.defaultValue==null&&e.defaultValue!==r&&(e.defaultValue=r)),n!=null&&(e.defaultValue=""+n)}function D1(e){var t=e.textContent;t===e._wrapperState.initialValue&&t!==""&&t!==null&&(e.value=t)}function tb(e){switch(e){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Hg(e,t){return e==null||e==="http://www.w3.org/1999/xhtml"?tb(t):e==="http://www.w3.org/2000/svg"&&t==="foreignObject"?"http://www.w3.org/1999/xhtml":e}var yp,rb=function(e){return typeof MSApp!="undefined"&&MSApp.execUnsafeLocalFunction?function(t,r,n,o){MSApp.execUnsafeLocalFunction(function(){return e(t,r,n,o)})}:e}(function(e,t){if(e.namespaceURI!=="http://www.w3.org/2000/svg"||"innerHTML"in e)e.innerHTML=t;else{for(yp=yp||document.createElement("div"),yp.innerHTML="<svg>"+t.valueOf().toString()+"</svg>",t=yp.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild)}});function xd(e,t){if(t){var r=e.firstChild;if(r&&r===e.lastChild&&r.nodeType===3){r.nodeValue=t;return}}e.textContent=t}var dd={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},B2=["Webkit","ms","Moz","O"];Object.keys(dd).forEach(function(e){B2.forEach(function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),dd[t]=dd[e]})});function nb(e,t,r){return t==null||typeof t=="boolean"||t===""?"":r||typeof t!="number"||t===0||dd.hasOwnProperty(e)&&dd[e]?(""+t).trim():t+"px"}function ob(e,t){e=e.style;for(var r in t)if(t.hasOwnProperty(r)){var n=r.indexOf("--")===0,o=nb(r,t[r],n);r==="float"&&(r="cssFloat"),n?e.setProperty(r,o):e[r]=o}}var Z2=xt({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function Qg(e,t){if(t){if(Z2[e]&&(t.children!=null||t.dangerouslySetInnerHTML!=null))throw Error(F(137,e));if(t.dangerouslySetInnerHTML!=null){if(t.children!=null)throw Error(F(60));if(typeof t.dangerouslySetInnerHTML!="object"||!("__html"in t.dangerouslySetInnerHTML))throw Error(F(61))}if(t.style!=null&&typeof t.style!="object")throw Error(F(62))}}function jg(e,t){if(e.indexOf("-")===-1)return typeof t.is=="string";switch(e){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}var qg=null;function RY(e){return e=e.target||e.srcElement||window,e.correspondingUseElement&&(e=e.correspondingUseElement),e.nodeType===3?e.parentNode:e}var Jg=null,bl=null,Cl=null;function z1(e){if(e=Rd(e)){if(typeof Jg!="function")throw Error(F(280));var t=e.stateNode;t&&(t=xm(t),Jg(e.stateNode,e.type,t))}}function ib(e){bl?Cl?Cl.push(e):Cl=[e]:bl=e}function ab(){if(bl){var e=bl,t=Cl;if(Cl=bl=null,z1(e),t)for(e=0;e<t.length;e++)z1(t[e])}}function sb(e,t){return e(t)}function lb(){}var bg=!1;function cb(e,t,r){if(bg)return e(t,r);bg=!0;try{return sb(e,t,r)}finally{bg=!1,(bl!==null||Cl!==null)&&(lb(),ab())}}function bd(e,t){var r=e.stateNode;if(r===null)return null;var n=xm(r);if(n===null)return null;r=n[t];e:switch(t){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":(n=!n.disabled)||(e=e.type,n=!(e==="button"||e==="input"||e==="select"||e==="textarea")),e=!n;break e;default:e=!1}if(e)return null;if(r&&typeof r!="function")throw Error(F(231,t,typeof r));return r}var eY=!1;if(hi)try{al={},Object.defineProperty(al,"passive",{get:function(){eY=!0}}),window.addEventListener("test",al,al),window.removeEventListener("test",al,al)}catch(e){eY=!1}var al;function $2(e,t,r,n,o,i,a,s,l){var c=Array.prototype.slice.call(arguments,3);try{t.apply(r,c)}catch(d){this.onError(d)}}var ud=!1,zp=null,Kp=!1,tY=null,O2={onError:function(e){ud=!0,zp=e}};function F2(e,t,r,n,o,i,a,s,l){ud=!1,zp=null,$2.apply(O2,arguments)}function D2(e,t,r,n,o,i,a,s,l){if(F2.apply(this,arguments),ud){if(ud){var c=zp;ud=!1,zp=null}else throw Error(F(198));Kp||(Kp=!0,tY=c)}}function ds(e){var t=e,r=e;if(e.alternate)for(;t.return;)t=t.return;else{e=t;do t=e,t.flags&4098&&(r=t.return),e=t.return;while(e)}return t.tag===3?r:null}function db(e){if(e.tag===13){var t=e.memoizedState;if(t===null&&(e=e.alternate,e!==null&&(t=e.memoizedState)),t!==null)return t.dehydrated}return null}function K1(e){if(ds(e)!==e)throw Error(F(188))}function z2(e){var t=e.alternate;if(!t){if(t=ds(e),t===null)throw Error(F(188));return t!==e?null:e}for(var r=e,n=t;;){var o=r.return;if(o===null)break;var i=o.alternate;if(i===null){if(n=o.return,n!==null){r=n;continue}break}if(o.child===i.child){for(i=o.child;i;){if(i===r)return K1(o),e;if(i===n)return K1(o),t;i=i.sibling}throw Error(F(188))}if(r.return!==n.return)r=o,n=i;else{for(var a=!1,s=o.child;s;){if(s===r){a=!0,r=o,n=i;break}if(s===n){a=!0,n=o,r=i;break}s=s.sibling}if(!a){for(s=i.child;s;){if(s===r){a=!0,r=i,n=o;break}if(s===n){a=!0,n=i,r=o;break}s=s.sibling}if(!a)throw Error(F(189))}}if(r.alternate!==n)throw Error(F(190))}if(r.tag!==3)throw Error(F(188));return r.stateNode.current===r?e:t}function ub(e){return e=z2(e),e!==null?pb(e):null}function pb(e){if(e.tag===5||e.tag===6)return e;for(e=e.child;e!==null;){var t=pb(e);if(t!==null)return t;e=e.sibling}return null}var mb=dn.unstable_scheduleCallback,H1=dn.unstable_cancelCallback,K2=dn.unstable_shouldYield,H2=dn.unstable_requestPaint,Vt=dn.unstable_now,Q2=dn.unstable_getCurrentPriorityLevel,GY=dn.unstable_ImmediatePriority,fb=dn.unstable_UserBlockingPriority,Hp=dn.unstable_NormalPriority,j2=dn.unstable_LowPriority,hb=dn.unstable_IdlePriority,gm=null,To=null;function q2(e){if(To&&typeof To.onCommitFiberRoot=="function")try{To.onCommitFiberRoot(gm,e,void 0,(e.current.flags&128)===128)}catch(t){}}var Jn=Math.clz32?Math.clz32:tI,J2=Math.log,eI=Math.LN2;function tI(e){return e>>>=0,e===0?32:31-(J2(e)/eI|0)|0}var xp=64,bp=4194304;function ld(e){switch(e&-e){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return e&4194240;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return e&130023424;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;default:return e}}function Qp(e,t){var r=e.pendingLanes;if(r===0)return 0;var n=0,o=e.suspendedLanes,i=e.pingedLanes,a=r&268435455;if(a!==0){var s=a&~o;s!==0?n=ld(s):(i&=a,i!==0&&(n=ld(i)))}else a=r&~o,a!==0?n=ld(a):i!==0&&(n=ld(i));if(n===0)return 0;if(t!==0&&t!==n&&!(t&o)&&(o=n&-n,i=t&-t,o>=i||o===16&&(i&4194240)!==0))return t;if(n&4&&(n|=r&16),t=e.entangledLanes,t!==0)for(e=e.entanglements,t&=n;0<t;)r=31-Jn(t),o=1<<r,n|=e[r],t&=~o;return n}function rI(e,t){switch(e){case 1:case 2:case 4:return t+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return t+5e3;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return-1;case 134217728:case 268435456:case 536870912:case 1073741824:return-1;default:return-1}}function nI(e,t){for(var r=e.suspendedLanes,n=e.pingedLanes,o=e.expirationTimes,i=e.pendingLanes;0<i;){var a=31-Jn(i),s=1<<a,l=o[a];l===-1?(!(s&r)||s&n)&&(o[a]=rI(s,t)):l<=t&&(e.expiredLanes|=s),i&=~s}}function rY(e){return e=e.pendingLanes&-1073741825,e!==0?e:e&1073741824?1073741824:0}function gb(){var e=xp;return xp<<=1,!(xp&4194240)&&(xp=64),e}function Cg(e){for(var t=[],r=0;31>r;r++)t.push(e);return t}function Ed(e,t,r){e.pendingLanes|=t,t!==536870912&&(e.suspendedLanes=0,e.pingedLanes=0),e=e.eventTimes,t=31-Jn(t),e[t]=r}function oI(e,t){var r=e.pendingLanes&~t;e.pendingLanes=t,e.suspendedLanes=0,e.pingedLanes=0,e.expiredLanes&=t,e.mutableReadLanes&=t,e.entangledLanes&=t,t=e.entanglements;var n=e.eventTimes;for(e=e.expirationTimes;0<r;){var o=31-Jn(r),i=1<<o;t[o]=0,n[o]=-1,e[o]=-1,r&=~i}}function _Y(e,t){var r=e.entangledLanes|=t;for(e=e.entanglements;r;){var n=31-Jn(r),o=1<<n;o&t|e[n]&t&&(e[n]|=t),r&=~o}}var De=0;function Yb(e){return e&=-e,1<e?4<e?e&268435455?16:536870912:4:1}var Sb,BY,yb,xb,bb,nY=!1,Cp=[],qi=null,Ji=null,ea=null,Cd=new Map,Pd=new Map,Ki=[],iI="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");function Q1(e,t){switch(e){case"focusin":case"focusout":qi=null;break;case"dragenter":case"dragleave":Ji=null;break;case"mouseover":case"mouseout":ea=null;break;case"pointerover":case"pointerout":Cd.delete(t.pointerId);break;case"gotpointercapture":case"lostpointercapture":Pd.delete(t.pointerId)}}function Jc(e,t,r,n,o,i){return e===null||e.nativeEvent!==i?(e={blockedOn:t,domEventName:r,eventSystemFlags:n,nativeEvent:i,targetContainers:[o]},t!==null&&(t=Rd(t),t!==null&&BY(t)),e):(e.eventSystemFlags|=n,t=e.targetContainers,o!==null&&t.indexOf(o)===-1&&t.push(o),e)}function aI(e,t,r,n,o){switch(t){case"focusin":return qi=Jc(qi,e,t,r,n,o),!0;case"dragenter":return Ji=Jc(Ji,e,t,r,n,o),!0;case"mouseover":return ea=Jc(ea,e,t,r,n,o),!0;case"pointerover":var i=o.pointerId;return Cd.set(i,Jc(Cd.get(i)||null,e,t,r,n,o)),!0;case"gotpointercapture":return i=o.pointerId,Pd.set(i,Jc(Pd.get(i)||null,e,t,r,n,o)),!0}return!1}function Cb(e){var t=Ja(e.target);if(t!==null){var r=ds(t);if(r!==null){if(t=r.tag,t===13){if(t=db(r),t!==null){e.blockedOn=t,bb(e.priority,function(){yb(r)});return}}else if(t===3&&r.stateNode.current.memoizedState.isDehydrated){e.blockedOn=r.tag===3?r.stateNode.containerInfo:null;return}}}e.blockedOn=null}function Ep(e){if(e.blockedOn!==null)return!1;for(var t=e.targetContainers;0<t.length;){var r=oY(e.domEventName,e.eventSystemFlags,t[0],e.nativeEvent);if(r===null){r=e.nativeEvent;var n=new r.constructor(r.type,r);qg=n,r.target.dispatchEvent(n),qg=null}else return t=Rd(r),t!==null&&BY(t),e.blockedOn=r,!1;t.shift()}return!0}function j1(e,t,r){Ep(e)&&r.delete(t)}function sI(){nY=!1,qi!==null&&Ep(qi)&&(qi=null),Ji!==null&&Ep(Ji)&&(Ji=null),ea!==null&&Ep(ea)&&(ea=null),Cd.forEach(j1),Pd.forEach(j1)}function ed(e,t){e.blockedOn===t&&(e.blockedOn=null,nY||(nY=!0,dn.unstable_scheduleCallback(dn.unstable_NormalPriority,sI)))}function Wd(e){function t(o){return ed(o,e)}if(0<Cp.length){ed(Cp[0],e);for(var r=1;r<Cp.length;r++){var n=Cp[r];n.blockedOn===e&&(n.blockedOn=null)}}for(qi!==null&&ed(qi,e),Ji!==null&&ed(Ji,e),ea!==null&&ed(ea,e),Cd.forEach(t),Pd.forEach(t),r=0;r<Ki.length;r++)n=Ki[r],n.blockedOn===e&&(n.blockedOn=null);for(;0<Ki.length&&(r=Ki[0],r.blockedOn===null);)Cb(r),r.blockedOn===null&&Ki.shift()}var Pl=yi.ReactCurrentBatchConfig,jp=!0;function lI(e,t,r,n){var o=De,i=Pl.transition;Pl.transition=null;try{De=1,ZY(e,t,r,n)}finally{De=o,Pl.transition=i}}function cI(e,t,r,n){var o=De,i=Pl.transition;Pl.transition=null;try{De=4,ZY(e,t,r,n)}finally{De=o,Pl.transition=i}}function ZY(e,t,r,n){if(jp){var o=oY(e,t,r,n);if(o===null)Ug(e,t,n,qp,r),Q1(e,n);else if(aI(o,e,t,r,n))n.stopPropagation();else if(Q1(e,n),t&4&&-1<iI.indexOf(e)){for(;o!==null;){var i=Rd(o);if(i!==null&&Sb(i),i=oY(e,t,r,n),i===null&&Ug(e,t,n,qp,r),i===o)break;o=i}o!==null&&n.stopPropagation()}else Ug(e,t,n,null,r)}}var qp=null;function oY(e,t,r,n){if(qp=null,e=RY(n),e=Ja(e),e!==null)if(t=ds(e),t===null)e=null;else if(r=t.tag,r===13){if(e=db(t),e!==null)return e;e=null}else if(r===3){if(t.stateNode.current.memoizedState.isDehydrated)return t.tag===3?t.stateNode.containerInfo:null;e=null}else t!==e&&(e=null);return qp=e,null}function Pb(e){switch(e){case"cancel":case"click":case"close":case"contextmenu":case"copy":case"cut":case"auxclick":case"dblclick":case"dragend":case"dragstart":case"drop":case"focusin":case"focusout":case"input":case"invalid":case"keydown":case"keypress":case"keyup":case"mousedown":case"mouseup":case"paste":case"pause":case"play":case"pointercancel":case"pointerdown":case"pointerup":case"ratechange":case"reset":case"resize":case"seeked":case"submit":case"touchcancel":case"touchend":case"touchstart":case"volumechange":case"change":case"selectionchange":case"textInput":case"compositionstart":case"compositionend":case"compositionupdate":case"beforeblur":case"afterblur":case"beforeinput":case"blur":case"fullscreenchange":case"focus":case"hashchange":case"popstate":case"select":case"selectstart":return 1;case"drag":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"mousemove":case"mouseout":case"mouseover":case"pointermove":case"pointerout":case"pointerover":case"scroll":case"toggle":case"touchmove":case"wheel":case"mouseenter":case"mouseleave":case"pointerenter":case"pointerleave":return 4;case"message":switch(Q2()){case GY:return 1;case fb:return 4;case Hp:case j2:return 16;case hb:return 536870912;default:return 16}default:return 16}}var Qi=null,$Y=null,Ap=null;function Wb(){if(Ap)return Ap;var e,t=$Y,r=t.length,n,o="value"in Qi?Qi.value:Qi.textContent,i=o.length;for(e=0;e<r&&t[e]===o[e];e++);var a=r-e;for(n=1;n<=a&&t[r-n]===o[i-n];n++);return Ap=o.slice(e,1<n?1-n:void 0)}function Rp(e){var t=e.keyCode;return"charCode"in e?(e=e.charCode,e===0&&t===13&&(e=13)):e=t,e===10&&(e=13),32<=e||e===13?e:0}function Pp(){return!0}function q1(){return!1}function un(e){function t(r,n,o,i,a){this._reactName=r,this._targetInst=o,this.type=n,this.nativeEvent=i,this.target=a,this.currentTarget=null;for(var s in e)e.hasOwnProperty(s)&&(r=e[s],this[s]=r?r(i):i[s]);return this.isDefaultPrevented=(i.defaultPrevented!=null?i.defaultPrevented:i.returnValue===!1)?Pp:q1,this.isPropagationStopped=q1,this}return xt(t.prototype,{preventDefault:function(){this.defaultPrevented=!0;var r=this.nativeEvent;r&&(r.preventDefault?r.preventDefault():typeof r.returnValue!="unknown"&&(r.returnValue=!1),this.isDefaultPrevented=Pp)},stopPropagation:function(){var r=this.nativeEvent;r&&(r.stopPropagation?r.stopPropagation():typeof r.cancelBubble!="unknown"&&(r.cancelBubble=!0),this.isPropagationStopped=Pp)},persist:function(){},isPersistent:Pp}),t}var Ll={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},OY=un(Ll),Ad=xt({},Ll,{view:0,detail:0}),dI=un(Ad),Pg,Wg,td,Ym=xt({},Ad,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:FY,button:0,buttons:0,relatedTarget:function(e){return e.relatedTarget===void 0?e.fromElement===e.srcElement?e.toElement:e.fromElement:e.relatedTarget},movementX:function(e){return"movementX"in e?e.movementX:(e!==td&&(td&&e.type==="mousemove"?(Pg=e.screenX-td.screenX,Wg=e.screenY-td.screenY):Wg=Pg=0,td=e),Pg)},movementY:function(e){return"movementY"in e?e.movementY:Wg}}),J1=un(Ym),uI=xt({},Ym,{dataTransfer:0}),pI=un(uI),mI=xt({},Ad,{relatedTarget:0}),vg=un(mI),fI=xt({},Ll,{animationName:0,elapsedTime:0,pseudoElement:0}),hI=un(fI),gI=xt({},Ll,{clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}}),YI=un(gI),SI=xt({},Ll,{data:0}),ex=un(SI),yI={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},xI={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},bI={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function CI(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):(e=bI[e])?!!t[e]:!1}function FY(){return CI}var PI=xt({},Ad,{key:function(e){if(e.key){var t=yI[e.key]||e.key;if(t!=="Unidentified")return t}return e.type==="keypress"?(e=Rp(e),e===13?"Enter":String.fromCharCode(e)):e.type==="keydown"||e.type==="keyup"?xI[e.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:FY,charCode:function(e){return e.type==="keypress"?Rp(e):0},keyCode:function(e){return e.type==="keydown"||e.type==="keyup"?e.keyCode:0},which:function(e){return e.type==="keypress"?Rp(e):e.type==="keydown"||e.type==="keyup"?e.keyCode:0}}),WI=un(PI),vI=xt({},Ym,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),tx=un(vI),wI=xt({},Ad,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:FY}),TI=un(wI),MI=xt({},Ll,{propertyName:0,elapsedTime:0,pseudoElement:0}),UI=un(MI),II=xt({},Ym,{deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:0,deltaMode:0}),VI=un(II),kI=[9,13,27,32],DY=hi&&"CompositionEvent"in window,pd=null;hi&&"documentMode"in document&&(pd=document.documentMode);var LI=hi&&"TextEvent"in window&&!pd,vb=hi&&(!DY||pd&&8<pd&&11>=pd),rx=String.fromCharCode(32),nx=!1;function wb(e,t){switch(e){case"keyup":return kI.indexOf(t.keyCode)!==-1;case"keydown":return t.keyCode!==229;case"keypress":case"mousedown":case"focusout":return!0;default:return!1}}function Tb(e){return e=e.detail,typeof e=="object"&&"data"in e?e.data:null}var dl=!1;function XI(e,t){switch(e){case"compositionend":return Tb(t);case"keypress":return t.which!==32?null:(nx=!0,rx);case"textInput":return e=t.data,e===rx&&nx?null:e;default:return null}}function NI(e,t){if(dl)return e==="compositionend"||!DY&&wb(e,t)?(e=Wb(),Ap=$Y=Qi=null,dl=!1,e):null;switch(e){case"paste":return null;case"keypress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case"compositionend":return vb&&t.locale!=="ko"?null:t.data;default:return null}}var EI={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ox(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t==="input"?!!EI[e.type]:t==="textarea"}function Mb(e,t,r,n){ib(n),t=Jp(t,"onChange"),0<t.length&&(r=new OY("onChange","change",null,r,n),e.push({event:r,listeners:t}))}var md=null,vd=null;function AI(e){Gb(e,0)}function Sm(e){var t=ml(e);if(qx(t))return e}function RI(e,t){if(e==="change")return t}var Ub=!1;hi&&(hi?(vp="oninput"in document,vp||(wg=document.createElement("div"),wg.setAttribute("oninput","return;"),vp=typeof wg.oninput=="function"),Wp=vp):Wp=!1,Ub=Wp&&(!document.documentMode||9<document.documentMode));var Wp,vp,wg;function ix(){md&&(md.detachEvent("onpropertychange",Ib),vd=md=null)}function Ib(e){if(e.propertyName==="value"&&Sm(vd)){var t=[];Mb(t,vd,e,RY(e)),cb(AI,t)}}function GI(e,t,r){e==="focusin"?(ix(),md=t,vd=r,md.attachEvent("onpropertychange",Ib)):e==="focusout"&&ix()}function _I(e){if(e==="selectionchange"||e==="keyup"||e==="keydown")return Sm(vd)}function BI(e,t){if(e==="click")return Sm(t)}function ZI(e,t){if(e==="input"||e==="change")return Sm(t)}function $I(e,t){return e===t&&(e!==0||1/e===1/t)||e!==e&&t!==t}var to=typeof Object.is=="function"?Object.is:$I;function wd(e,t){if(to(e,t))return!0;if(typeof e!="object"||e===null||typeof t!="object"||t===null)return!1;var r=Object.keys(e),n=Object.keys(t);if(r.length!==n.length)return!1;for(n=0;n<r.length;n++){var o=r[n];if(!_g.call(t,o)||!to(e[o],t[o]))return!1}return!0}function ax(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function sx(e,t){var r=ax(e);e=0;for(var n;r;){if(r.nodeType===3){if(n=e+r.textContent.length,e<=t&&n>=t)return{node:r,offset:t-e};e=n}e:{for(;r;){if(r.nextSibling){r=r.nextSibling;break e}r=r.parentNode}r=void 0}r=ax(r)}}function Vb(e,t){return e&&t?e===t?!0:e&&e.nodeType===3?!1:t&&t.nodeType===3?Vb(e,t.parentNode):"contains"in e?e.contains(t):e.compareDocumentPosition?!!(e.compareDocumentPosition(t)&16):!1:!1}function kb(){for(var e=window,t=Dp();t instanceof e.HTMLIFrameElement;){try{var r=typeof t.contentWindow.location.href=="string"}catch(n){r=!1}if(r)e=t.contentWindow;else break;t=Dp(e.document)}return t}function zY(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&(t==="input"&&(e.type==="text"||e.type==="search"||e.type==="tel"||e.type==="url"||e.type==="password")||t==="textarea"||e.contentEditable==="true")}function OI(e){var t=kb(),r=e.focusedElem,n=e.selectionRange;if(t!==r&&r&&r.ownerDocument&&Vb(r.ownerDocument.documentElement,r)){if(n!==null&&zY(r)){if(t=n.start,e=n.end,e===void 0&&(e=t),"selectionStart"in r)r.selectionStart=t,r.selectionEnd=Math.min(e,r.value.length);else if(e=(t=r.ownerDocument||document)&&t.defaultView||window,e.getSelection){e=e.getSelection();var o=r.textContent.length,i=Math.min(n.start,o);n=n.end===void 0?i:Math.min(n.end,o),!e.extend&&i>n&&(o=n,n=i,i=o),o=sx(r,i);var a=sx(r,n);o&&a&&(e.rangeCount!==1||e.anchorNode!==o.node||e.anchorOffset!==o.offset||e.focusNode!==a.node||e.focusOffset!==a.offset)&&(t=t.createRange(),t.setStart(o.node,o.offset),e.removeAllRanges(),i>n?(e.addRange(t),e.extend(a.node,a.offset)):(t.setEnd(a.node,a.offset),e.addRange(t)))}}for(t=[],e=r;e=e.parentNode;)e.nodeType===1&&t.push({element:e,left:e.scrollLeft,top:e.scrollTop});for(typeof r.focus=="function"&&r.focus(),r=0;r<t.length;r++)e=t[r],e.element.scrollLeft=e.left,e.element.scrollTop=e.top}}var FI=hi&&"documentMode"in document&&11>=document.documentMode,ul=null,iY=null,fd=null,aY=!1;function lx(e,t,r){var n=r.window===r?r.document:r.nodeType===9?r:r.ownerDocument;aY||ul==null||ul!==Dp(n)||(n=ul,"selectionStart"in n&&zY(n)?n={start:n.selectionStart,end:n.selectionEnd}:(n=(n.ownerDocument&&n.ownerDocument.defaultView||window).getSelection(),n={anchorNode:n.anchorNode,anchorOffset:n.anchorOffset,focusNode:n.focusNode,focusOffset:n.focusOffset}),fd&&wd(fd,n)||(fd=n,n=Jp(iY,"onSelect"),0<n.length&&(t=new OY("onSelect","select",null,t,r),e.push({event:t,listeners:n}),t.target=ul)))}function wp(e,t){var r={};return r[e.toLowerCase()]=t.toLowerCase(),r["Webkit"+e]="webkit"+t,r["Moz"+e]="moz"+t,r}var pl={animationend:wp("Animation","AnimationEnd"),animationiteration:wp("Animation","AnimationIteration"),animationstart:wp("Animation","AnimationStart"),transitionend:wp("Transition","TransitionEnd")},Tg={},Lb={};hi&&(Lb=document.createElement("div").style,"AnimationEvent"in window||(delete pl.animationend.animation,delete pl.animationiteration.animation,delete pl.animationstart.animation),"TransitionEvent"in window||delete pl.transitionend.transition);function ym(e){if(Tg[e])return Tg[e];if(!pl[e])return e;var t=pl[e],r;for(r in t)if(t.hasOwnProperty(r)&&r in Lb)return Tg[e]=t[r];return e}var Xb=ym("animationend"),Nb=ym("animationiteration"),Eb=ym("animationstart"),Ab=ym("transitionend"),Rb=new Map,cx="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");function la(e,t){Rb.set(e,t),cs(t,[e])}for(Tp=0;Tp<cx.length;Tp++)Mp=cx[Tp],dx=Mp.toLowerCase(),ux=Mp[0].toUpperCase()+Mp.slice(1),la(dx,"on"+ux);var Mp,dx,ux,Tp;la(Xb,"onAnimationEnd");la(Nb,"onAnimationIteration");la(Eb,"onAnimationStart");la("dblclick","onDoubleClick");la("focusin","onFocus");la("focusout","onBlur");la(Ab,"onTransitionEnd");wl("onMouseEnter",["mouseout","mouseover"]);wl("onMouseLeave",["mouseout","mouseover"]);wl("onPointerEnter",["pointerout","pointerover"]);wl("onPointerLeave",["pointerout","pointerover"]);cs("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));cs("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));cs("onBeforeInput",["compositionend","keypress","textInput","paste"]);cs("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));cs("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));cs("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var cd="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),DI=new Set("cancel close invalid load scroll toggle".split(" ").concat(cd));function px(e,t,r){var n=e.type||"unknown-event";e.currentTarget=r,D2(n,t,void 0,e),e.currentTarget=null}function Gb(e,t){t=(t&4)!==0;for(var r=0;r<e.length;r++){var n=e[r],o=n.event;n=n.listeners;e:{var i=void 0;if(t)for(var a=n.length-1;0<=a;a--){var s=n[a],l=s.instance,c=s.currentTarget;if(s=s.listener,l!==i&&o.isPropagationStopped())break e;px(o,s,c),i=l}else for(a=0;a<n.length;a++){if(s=n[a],l=s.instance,c=s.currentTarget,s=s.listener,l!==i&&o.isPropagationStopped())break e;px(o,s,c),i=l}}}if(Kp)throw e=tY,Kp=!1,tY=null,e}function lt(e,t){var r=t[uY];r===void 0&&(r=t[uY]=new Set);var n=e+"__bubble";r.has(n)||(_b(t,e,2,!1),r.add(n))}function Mg(e,t,r){var n=0;t&&(n|=4),_b(r,e,n,t)}var Up="_reactListening"+Math.random().toString(36).slice(2);function Td(e){if(!e[Up]){e[Up]=!0,zx.forEach(function(r){r!=="selectionchange"&&(DI.has(r)||Mg(r,!1,e),Mg(r,!0,e))});var t=e.nodeType===9?e:e.ownerDocument;t===null||t[Up]||(t[Up]=!0,Mg("selectionchange",!1,t))}}function _b(e,t,r,n){switch(Pb(t)){case 1:var o=lI;break;case 4:o=cI;break;default:o=ZY}r=o.bind(null,t,r,e),o=void 0,!eY||t!=="touchstart"&&t!=="touchmove"&&t!=="wheel"||(o=!0),n?o!==void 0?e.addEventListener(t,r,{capture:!0,passive:o}):e.addEventListener(t,r,!0):o!==void 0?e.addEventListener(t,r,{passive:o}):e.addEventListener(t,r,!1)}function Ug(e,t,r,n,o){var i=n;if(!(t&1)&&!(t&2)&&n!==null)e:for(;;){if(n===null)return;var a=n.tag;if(a===3||a===4){var s=n.stateNode.containerInfo;if(s===o||s.nodeType===8&&s.parentNode===o)break;if(a===4)for(a=n.return;a!==null;){var l=a.tag;if((l===3||l===4)&&(l=a.stateNode.containerInfo,l===o||l.nodeType===8&&l.parentNode===o))return;a=a.return}for(;s!==null;){if(a=Ja(s),a===null)return;if(l=a.tag,l===5||l===6){n=i=a;continue e}s=s.parentNode}}n=n.return}cb(function(){var c=i,d=RY(r),u=[];e:{var p=Rb.get(e);if(p!==void 0){var m=OY,g=e;switch(e){case"keypress":if(Rp(r)===0)break e;case"keydown":case"keyup":m=WI;break;case"focusin":g="focus",m=vg;break;case"focusout":g="blur",m=vg;break;case"beforeblur":case"afterblur":m=vg;break;case"click":if(r.button===2)break e;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":m=J1;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":m=pI;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":m=TI;break;case Xb:case Nb:case Eb:m=hI;break;case Ab:m=UI;break;case"scroll":m=dI;break;case"wheel":m=VI;break;case"copy":case"cut":case"paste":m=YI;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":m=tx}var y=(t&4)!==0,P=!y&&e==="scroll",Y=y?p!==null?p+"Capture":null:p;y=[];for(var h=c,S;h!==null;){S=h;var b=S.stateNode;if(S.tag===5&&b!==null&&(S=b,Y!==null&&(b=bd(h,Y),b!=null&&y.push(Md(h,b,S)))),P)break;h=h.return}0<y.length&&(p=new m(p,g,null,r,d),u.push({event:p,listeners:y}))}}if(!(t&7)){e:{if(p=e==="mouseover"||e==="pointerover",m=e==="mouseout"||e==="pointerout",p&&r!==qg&&(g=r.relatedTarget||r.fromElement)&&(Ja(g)||g[gi]))break e;if((m||p)&&(p=d.window===d?d:(p=d.ownerDocument)?p.defaultView||p.parentWindow:window,m?(g=r.relatedTarget||r.toElement,m=c,g=g?Ja(g):null,g!==null&&(P=ds(g),g!==P||g.tag!==5&&g.tag!==6)&&(g=null)):(m=null,g=c),m!==g)){if(y=J1,b="onMouseLeave",Y="onMouseEnter",h="mouse",(e==="pointerout"||e==="pointerover")&&(y=tx,b="onPointerLeave",Y="onPointerEnter",h="pointer"),P=m==null?p:ml(m),S=g==null?p:ml(g),p=new y(b,h+"leave",m,r,d),p.target=P,p.relatedTarget=S,b=null,Ja(d)===c&&(y=new y(Y,h+"enter",g,r,d),y.target=S,y.relatedTarget=P,b=y),P=b,m&&g)t:{for(y=m,Y=g,h=0,S=y;S;S=sl(S))h++;for(S=0,b=Y;b;b=sl(b))S++;for(;0<h-S;)y=sl(y),h--;for(;0<S-h;)Y=sl(Y),S--;for(;h--;){if(y===Y||Y!==null&&y===Y.alternate)break t;y=sl(y),Y=sl(Y)}y=null}else y=null;m!==null&&mx(u,p,m,y,!1),g!==null&&P!==null&&mx(u,P,g,y,!0)}}e:{if(p=c?ml(c):window,m=p.nodeName&&p.nodeName.toLowerCase(),m==="select"||m==="input"&&p.type==="file")var W=RI;else if(ox(p))if(Ub)W=ZI;else{W=_I;var C=GI}else(m=p.nodeName)&&m.toLowerCase()==="input"&&(p.type==="checkbox"||p.type==="radio")&&(W=BI);if(W&&(W=W(e,c))){Mb(u,W,r,d);break e}C&&C(e,p,c),e==="focusout"&&(C=p._wrapperState)&&C.controlled&&p.type==="number"&&zg(p,"number",p.value)}switch(C=c?ml(c):window,e){case"focusin":(ox(C)||C.contentEditable==="true")&&(ul=C,iY=c,fd=null);break;case"focusout":fd=iY=ul=null;break;case"mousedown":aY=!0;break;case"contextmenu":case"mouseup":case"dragend":aY=!1,lx(u,r,d);break;case"selectionchange":if(FI)break;case"keydown":case"keyup":lx(u,r,d)}var w;if(DY)e:{switch(e){case"compositionstart":var I="onCompositionStart";break e;case"compositionend":I="onCompositionEnd";break e;case"compositionupdate":I="onCompositionUpdate";break e}I=void 0}else dl?wb(e,r)&&(I="onCompositionEnd"):e==="keydown"&&r.keyCode===229&&(I="onCompositionStart");I&&(vb&&r.locale!=="ko"&&(dl||I!=="onCompositionStart"?I==="onCompositionEnd"&&dl&&(w=Wb()):(Qi=d,$Y="value"in Qi?Qi.value:Qi.textContent,dl=!0)),C=Jp(c,I),0<C.length&&(I=new ex(I,e,null,r,d),u.push({event:I,listeners:C}),w?I.data=w:(w=Tb(r),w!==null&&(I.data=w)))),(w=LI?XI(e,r):NI(e,r))&&(c=Jp(c,"onBeforeInput"),0<c.length&&(d=new ex("onBeforeInput","beforeinput",null,r,d),u.push({event:d,listeners:c}),d.data=w))}Gb(u,t)})}function Md(e,t,r){return{instance:e,listener:t,currentTarget:r}}function Jp(e,t){for(var r=t+"Capture",n=[];e!==null;){var o=e,i=o.stateNode;o.tag===5&&i!==null&&(o=i,i=bd(e,r),i!=null&&n.unshift(Md(e,i,o)),i=bd(e,t),i!=null&&n.push(Md(e,i,o))),e=e.return}return n}function sl(e){if(e===null)return null;do e=e.return;while(e&&e.tag!==5);return e||null}function mx(e,t,r,n,o){for(var i=t._reactName,a=[];r!==null&&r!==n;){var s=r,l=s.alternate,c=s.stateNode;if(l!==null&&l===n)break;s.tag===5&&c!==null&&(s=c,o?(l=bd(r,i),l!=null&&a.unshift(Md(r,l,s))):o||(l=bd(r,i),l!=null&&a.push(Md(r,l,s)))),r=r.return}a.length!==0&&e.push({event:t,listeners:a})}var zI=/\r\n?/g,KI=/\u0000|\uFFFD/g;function fx(e){return(typeof e=="string"?e:""+e).replace(zI,`
`).replace(KI,"")}function Ip(e,t,r){if(t=fx(t),fx(e)!==t&&r)throw Error(F(425))}function em(){}var sY=null,lY=null;function cY(e,t){return e==="textarea"||e==="noscript"||typeof t.children=="string"||typeof t.children=="number"||typeof t.dangerouslySetInnerHTML=="object"&&t.dangerouslySetInnerHTML!==null&&t.dangerouslySetInnerHTML.__html!=null}var dY=typeof setTimeout=="function"?setTimeout:void 0,HI=typeof clearTimeout=="function"?clearTimeout:void 0,hx=typeof Promise=="function"?Promise:void 0,QI=typeof queueMicrotask=="function"?queueMicrotask:typeof hx!="undefined"?function(e){return hx.resolve(null).then(e).catch(jI)}:dY;function jI(e){setTimeout(function(){throw e})}function Ig(e,t){var r=t,n=0;do{var o=r.nextSibling;if(e.removeChild(r),o&&o.nodeType===8)if(r=o.data,r==="/$"){if(n===0){e.removeChild(o),Wd(t);return}n--}else r!=="$"&&r!=="$?"&&r!=="$!"||n++;r=o}while(r);Wd(t)}function ta(e){for(;e!=null;e=e.nextSibling){var t=e.nodeType;if(t===1||t===3)break;if(t===8){if(t=e.data,t==="$"||t==="$!"||t==="$?")break;if(t==="/$")return null}}return e}function gx(e){e=e.previousSibling;for(var t=0;e;){if(e.nodeType===8){var r=e.data;if(r==="$"||r==="$!"||r==="$?"){if(t===0)return e;t--}else r==="/$"&&t++}e=e.previousSibling}return null}var Xl=Math.random().toString(36).slice(2),wo="__reactFiber$"+Xl,Ud="__reactProps$"+Xl,gi="__reactContainer$"+Xl,uY="__reactEvents$"+Xl,qI="__reactListeners$"+Xl,JI="__reactHandles$"+Xl;function Ja(e){var t=e[wo];if(t)return t;for(var r=e.parentNode;r;){if(t=r[gi]||r[wo]){if(r=t.alternate,t.child!==null||r!==null&&r.child!==null)for(e=gx(e);e!==null;){if(r=e[wo])return r;e=gx(e)}return t}e=r,r=e.parentNode}return null}function Rd(e){return e=e[wo]||e[gi],!e||e.tag!==5&&e.tag!==6&&e.tag!==13&&e.tag!==3?null:e}function ml(e){if(e.tag===5||e.tag===6)return e.stateNode;throw Error(F(33))}function xm(e){return e[Ud]||null}var pY=[],fl=-1;function ca(e){return{current:e}}function ct(e){0>fl||(e.current=pY[fl],pY[fl]=null,fl--)}function tt(e,t){fl++,pY[fl]=e.current,e.current=t}var sa={},br=ca(sa),$r=ca(!1),os=sa;function Tl(e,t){var r=e.type.contextTypes;if(!r)return sa;var n=e.stateNode;if(n&&n.__reactInternalMemoizedUnmaskedChildContext===t)return n.__reactInternalMemoizedMaskedChildContext;var o={},i;for(i in r)o[i]=t[i];return n&&(e=e.stateNode,e.__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=o),o}function Or(e){return e=e.childContextTypes,e!=null}function tm(){ct($r),ct(br)}function Yx(e,t,r){if(br.current!==sa)throw Error(F(168));tt(br,t),tt($r,r)}function Bb(e,t,r){var n=e.stateNode;if(t=t.childContextTypes,typeof n.getChildContext!="function")return r;n=n.getChildContext();for(var o in n)if(!(o in t))throw Error(F(108,G2(e)||"Unknown",o));return xt({},r,n)}function rm(e){return e=(e=e.stateNode)&&e.__reactInternalMemoizedMergedChildContext||sa,os=br.current,tt(br,e),tt($r,$r.current),!0}function Sx(e,t,r){var n=e.stateNode;if(!n)throw Error(F(169));r?(e=Bb(e,t,os),n.__reactInternalMemoizedMergedChildContext=e,ct($r),ct(br),tt(br,e)):ct($r),tt($r,r)}var ui=null,bm=!1,Vg=!1;function Zb(e){ui===null?ui=[e]:ui.push(e)}function eV(e){bm=!0,Zb(e)}function da(){if(!Vg&&ui!==null){Vg=!0;var e=0,t=De;try{var r=ui;for(De=1;e<r.length;e++){var n=r[e];do n=n(!0);while(n!==null)}ui=null,bm=!1}catch(o){throw ui!==null&&(ui=ui.slice(e+1)),mb(GY,da),o}finally{De=t,Vg=!1}}return null}var hl=[],gl=0,nm=null,om=0,In=[],Vn=0,is=null,pi=1,mi="";function ja(e,t){hl[gl++]=om,hl[gl++]=nm,nm=e,om=t}function $b(e,t,r){In[Vn++]=pi,In[Vn++]=mi,In[Vn++]=is,is=e;var n=pi;e=mi;var o=32-Jn(n)-1;n&=~(1<<o),r+=1;var i=32-Jn(t)+o;if(30<i){var a=o-o%5;i=(n&(1<<a)-1).toString(32),n>>=a,o-=a,pi=1<<32-Jn(t)+o|r<<o|n,mi=i+e}else pi=1<<i|r<<o|n,mi=e}function KY(e){e.return!==null&&(ja(e,1),$b(e,1,0))}function HY(e){for(;e===nm;)nm=hl[--gl],hl[gl]=null,om=hl[--gl],hl[gl]=null;for(;e===is;)is=In[--Vn],In[Vn]=null,mi=In[--Vn],In[Vn]=null,pi=In[--Vn],In[Vn]=null}var cn=null,ln=null,ft=!1,qn=null;function Ob(e,t){var r=kn(5,null,null,0);r.elementType="DELETED",r.stateNode=t,r.return=e,t=e.deletions,t===null?(e.deletions=[r],e.flags|=16):t.push(r)}function yx(e,t){switch(e.tag){case 5:var r=e.type;return t=t.nodeType!==1||r.toLowerCase()!==t.nodeName.toLowerCase()?null:t,t!==null?(e.stateNode=t,cn=e,ln=ta(t.firstChild),!0):!1;case 6:return t=e.pendingProps===""||t.nodeType!==3?null:t,t!==null?(e.stateNode=t,cn=e,ln=null,!0):!1;case 13:return t=t.nodeType!==8?null:t,t!==null?(r=is!==null?{id:pi,overflow:mi}:null,e.memoizedState={dehydrated:t,treeContext:r,retryLane:1073741824},r=kn(18,null,null,0),r.stateNode=t,r.return=e,e.child=r,cn=e,ln=null,!0):!1;default:return!1}}function mY(e){return(e.mode&1)!==0&&(e.flags&128)===0}function fY(e){if(ft){var t=ln;if(t){var r=t;if(!yx(e,t)){if(mY(e))throw Error(F(418));t=ta(r.nextSibling);var n=cn;t&&yx(e,t)?Ob(n,r):(e.flags=e.flags&-4097|2,ft=!1,cn=e)}}else{if(mY(e))throw Error(F(418));e.flags=e.flags&-4097|2,ft=!1,cn=e}}}function xx(e){for(e=e.return;e!==null&&e.tag!==5&&e.tag!==3&&e.tag!==13;)e=e.return;cn=e}function Vp(e){if(e!==cn)return!1;if(!ft)return xx(e),ft=!0,!1;var t;if((t=e.tag!==3)&&!(t=e.tag!==5)&&(t=e.type,t=t!=="head"&&t!=="body"&&!cY(e.type,e.memoizedProps)),t&&(t=ln)){if(mY(e))throw Fb(),Error(F(418));for(;t;)Ob(e,t),t=ta(t.nextSibling)}if(xx(e),e.tag===13){if(e=e.memoizedState,e=e!==null?e.dehydrated:null,!e)throw Error(F(317));e:{for(e=e.nextSibling,t=0;e;){if(e.nodeType===8){var r=e.data;if(r==="/$"){if(t===0){ln=ta(e.nextSibling);break e}t--}else r!=="$"&&r!=="$!"&&r!=="$?"||t++}e=e.nextSibling}ln=null}}else ln=cn?ta(e.stateNode.nextSibling):null;return!0}function Fb(){for(var e=ln;e;)e=ta(e.nextSibling)}function Ml(){ln=cn=null,ft=!1}function QY(e){qn===null?qn=[e]:qn.push(e)}var tV=yi.ReactCurrentBatchConfig;function Qn(e,t){if(e&&e.defaultProps){t=xt({},t),e=e.defaultProps;for(var r in e)t[r]===void 0&&(t[r]=e[r]);return t}return t}var im=ca(null),am=null,Yl=null,jY=null;function qY(){jY=Yl=am=null}function JY(e){var t=im.current;ct(im),e._currentValue=t}function hY(e,t,r){for(;e!==null;){var n=e.alternate;if((e.childLanes&t)!==t?(e.childLanes|=t,n!==null&&(n.childLanes|=t)):n!==null&&(n.childLanes&t)!==t&&(n.childLanes|=t),e===r)break;e=e.return}}function Wl(e,t){am=e,jY=Yl=null,e=e.dependencies,e!==null&&e.firstContext!==null&&(e.lanes&t&&(Zr=!0),e.firstContext=null)}function Xn(e){var t=e._currentValue;if(jY!==e)if(e={context:e,memoizedValue:t,next:null},Yl===null){if(am===null)throw Error(F(308));Yl=e,am.dependencies={lanes:0,firstContext:e}}else Yl=Yl.next=e;return t}var es=null;function eS(e){es===null?es=[e]:es.push(e)}function Db(e,t,r,n){var o=t.interleaved;return o===null?(r.next=r,eS(t)):(r.next=o.next,o.next=r),t.interleaved=r,Yi(e,n)}function Yi(e,t){e.lanes|=t;var r=e.alternate;for(r!==null&&(r.lanes|=t),r=e,e=e.return;e!==null;)e.childLanes|=t,r=e.alternate,r!==null&&(r.childLanes|=t),r=e,e=e.return;return r.tag===3?r.stateNode:null}var zi=!1;function tS(e){e.updateQueue={baseState:e.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}function zb(e,t){e=e.updateQueue,t.updateQueue===e&&(t.updateQueue={baseState:e.baseState,firstBaseUpdate:e.firstBaseUpdate,lastBaseUpdate:e.lastBaseUpdate,shared:e.shared,effects:e.effects})}function fi(e,t){return{eventTime:e,lane:t,tag:0,payload:null,callback:null,next:null}}function ra(e,t,r){var n=e.updateQueue;if(n===null)return null;if(n=n.shared,Re&2){var o=n.pending;return o===null?t.next=t:(t.next=o.next,o.next=t),n.pending=t,Yi(e,r)}return o=n.interleaved,o===null?(t.next=t,eS(n)):(t.next=o.next,o.next=t),n.interleaved=t,Yi(e,r)}function Gp(e,t,r){if(t=t.updateQueue,t!==null&&(t=t.shared,(r&4194240)!==0)){var n=t.lanes;n&=e.pendingLanes,r|=n,t.lanes=r,_Y(e,r)}}function bx(e,t){var r=e.updateQueue,n=e.alternate;if(n!==null&&(n=n.updateQueue,r===n)){var o=null,i=null;if(r=r.firstBaseUpdate,r!==null){do{var a={eventTime:r.eventTime,lane:r.lane,tag:r.tag,payload:r.payload,callback:r.callback,next:null};i===null?o=i=a:i=i.next=a,r=r.next}while(r!==null);i===null?o=i=t:i=i.next=t}else o=i=t;r={baseState:n.baseState,firstBaseUpdate:o,lastBaseUpdate:i,shared:n.shared,effects:n.effects},e.updateQueue=r;return}e=r.lastBaseUpdate,e===null?r.firstBaseUpdate=t:e.next=t,r.lastBaseUpdate=t}function sm(e,t,r,n){var o=e.updateQueue;zi=!1;var i=o.firstBaseUpdate,a=o.lastBaseUpdate,s=o.shared.pending;if(s!==null){o.shared.pending=null;var l=s,c=l.next;l.next=null,a===null?i=c:a.next=c,a=l;var d=e.alternate;d!==null&&(d=d.updateQueue,s=d.lastBaseUpdate,s!==a&&(s===null?d.firstBaseUpdate=c:s.next=c,d.lastBaseUpdate=l))}if(i!==null){var u=o.baseState;a=0,d=c=l=null,s=i;do{var p=s.lane,m=s.eventTime;if((n&p)===p){d!==null&&(d=d.next={eventTime:m,lane:0,tag:s.tag,payload:s.payload,callback:s.callback,next:null});e:{var g=e,y=s;switch(p=t,m=r,y.tag){case 1:if(g=y.payload,typeof g=="function"){u=g.call(m,u,p);break e}u=g;break e;case 3:g.flags=g.flags&-65537|128;case 0:if(g=y.payload,p=typeof g=="function"?g.call(m,u,p):g,p==null)break e;u=xt({},u,p);break e;case 2:zi=!0}}s.callback!==null&&s.lane!==0&&(e.flags|=64,p=o.effects,p===null?o.effects=[s]:p.push(s))}else m={eventTime:m,lane:p,tag:s.tag,payload:s.payload,callback:s.callback,next:null},d===null?(c=d=m,l=u):d=d.next=m,a|=p;if(s=s.next,s===null){if(s=o.shared.pending,s===null)break;p=s,s=p.next,p.next=null,o.lastBaseUpdate=p,o.shared.pending=null}}while(1);if(d===null&&(l=u),o.baseState=l,o.firstBaseUpdate=c,o.lastBaseUpdate=d,t=o.shared.interleaved,t!==null){o=t;do a|=o.lane,o=o.next;while(o!==t)}else i===null&&(o.shared.lanes=0);ss|=a,e.lanes=a,e.memoizedState=u}}function Cx(e,t,r){if(e=t.effects,t.effects=null,e!==null)for(t=0;t<e.length;t++){var n=e[t],o=n.callback;if(o!==null){if(n.callback=null,n=r,typeof o!="function")throw Error(F(191,o));o.call(n)}}}var Kb=new Dx.Component().refs;function gY(e,t,r,n){t=e.memoizedState,r=r(n,t),r=r==null?t:xt({},t,r),e.memoizedState=r,e.lanes===0&&(e.updateQueue.baseState=r)}var Cm={isMounted:function(e){return(e=e._reactInternals)?ds(e)===e:!1},enqueueSetState:function(e,t,r){e=e._reactInternals;var n=Vr(),o=oa(e),i=fi(n,o);i.payload=t,r!=null&&(i.callback=r),t=ra(e,i,o),t!==null&&(eo(t,e,o,n),Gp(t,e,o))},enqueueReplaceState:function(e,t,r){e=e._reactInternals;var n=Vr(),o=oa(e),i=fi(n,o);i.tag=1,i.payload=t,r!=null&&(i.callback=r),t=ra(e,i,o),t!==null&&(eo(t,e,o,n),Gp(t,e,o))},enqueueForceUpdate:function(e,t){e=e._reactInternals;var r=Vr(),n=oa(e),o=fi(r,n);o.tag=2,t!=null&&(o.callback=t),t=ra(e,o,n),t!==null&&(eo(t,e,n,r),Gp(t,e,n))}};function Px(e,t,r,n,o,i,a){return e=e.stateNode,typeof e.shouldComponentUpdate=="function"?e.shouldComponentUpdate(n,i,a):t.prototype&&t.prototype.isPureReactComponent?!wd(r,n)||!wd(o,i):!0}function Hb(e,t,r){var n=!1,o=sa,i=t.contextType;return typeof i=="object"&&i!==null?i=Xn(i):(o=Or(t)?os:br.current,n=t.contextTypes,i=(n=n!=null)?Tl(e,o):sa),t=new t(r,i),e.memoizedState=t.state!==null&&t.state!==void 0?t.state:null,t.updater=Cm,e.stateNode=t,t._reactInternals=e,n&&(e=e.stateNode,e.__reactInternalMemoizedUnmaskedChildContext=o,e.__reactInternalMemoizedMaskedChildContext=i),t}function Wx(e,t,r,n){e=t.state,typeof t.componentWillReceiveProps=="function"&&t.componentWillReceiveProps(r,n),typeof t.UNSAFE_componentWillReceiveProps=="function"&&t.UNSAFE_componentWillReceiveProps(r,n),t.state!==e&&Cm.enqueueReplaceState(t,t.state,null)}function YY(e,t,r,n){var o=e.stateNode;o.props=r,o.state=e.memoizedState,o.refs=Kb,tS(e);var i=t.contextType;typeof i=="object"&&i!==null?o.context=Xn(i):(i=Or(t)?os:br.current,o.context=Tl(e,i)),o.state=e.memoizedState,i=t.getDerivedStateFromProps,typeof i=="function"&&(gY(e,t,i,r),o.state=e.memoizedState),typeof t.getDerivedStateFromProps=="function"||typeof o.getSnapshotBeforeUpdate=="function"||typeof o.UNSAFE_componentWillMount!="function"&&typeof o.componentWillMount!="function"||(t=o.state,typeof o.componentWillMount=="function"&&o.componentWillMount(),typeof o.UNSAFE_componentWillMount=="function"&&o.UNSAFE_componentWillMount(),t!==o.state&&Cm.enqueueReplaceState(o,o.state,null),sm(e,r,o,n),o.state=e.memoizedState),typeof o.componentDidMount=="function"&&(e.flags|=4194308)}function rd(e,t,r){if(e=r.ref,e!==null&&typeof e!="function"&&typeof e!="object"){if(r._owner){if(r=r._owner,r){if(r.tag!==1)throw Error(F(309));var n=r.stateNode}if(!n)throw Error(F(147,e));var o=n,i=""+e;return t!==null&&t.ref!==null&&typeof t.ref=="function"&&t.ref._stringRef===i?t.ref:(t=function(a){var s=o.refs;s===Kb&&(s=o.refs={}),a===null?delete s[i]:s[i]=a},t._stringRef=i,t)}if(typeof e!="string")throw Error(F(284));if(!r._owner)throw Error(F(290,e))}return e}function kp(e,t){throw e=Object.prototype.toString.call(t),Error(F(31,e==="[object Object]"?"object with keys {"+Object.keys(t).join(", ")+"}":e))}function vx(e){var t=e._init;return t(e._payload)}function Qb(e){function t(Y,h){if(e){var S=Y.deletions;S===null?(Y.deletions=[h],Y.flags|=16):S.push(h)}}function r(Y,h){if(!e)return null;for(;h!==null;)t(Y,h),h=h.sibling;return null}function n(Y,h){for(Y=new Map;h!==null;)h.key!==null?Y.set(h.key,h):Y.set(h.index,h),h=h.sibling;return Y}function o(Y,h){return Y=ia(Y,h),Y.index=0,Y.sibling=null,Y}function i(Y,h,S){return Y.index=S,e?(S=Y.alternate,S!==null?(S=S.index,S<h?(Y.flags|=2,h):S):(Y.flags|=2,h)):(Y.flags|=1048576,h)}function a(Y){return e&&Y.alternate===null&&(Y.flags|=2),Y}function s(Y,h,S,b){return h===null||h.tag!==6?(h=Rg(S,Y.mode,b),h.return=Y,h):(h=o(h,S),h.return=Y,h)}function l(Y,h,S,b){var W=S.type;return W===cl?d(Y,h,S.props.children,b,S.key):h!==null&&(h.elementType===W||typeof W=="object"&&W!==null&&W.$$typeof===Di&&vx(W)===h.type)?(b=o(h,S.props),b.ref=rd(Y,h,S),b.return=Y,b):(b=Fp(S.type,S.key,S.props,null,Y.mode,b),b.ref=rd(Y,h,S),b.return=Y,b)}function c(Y,h,S,b){return h===null||h.tag!==4||h.stateNode.containerInfo!==S.containerInfo||h.stateNode.implementation!==S.implementation?(h=Gg(S,Y.mode,b),h.return=Y,h):(h=o(h,S.children||[]),h.return=Y,h)}function d(Y,h,S,b,W){return h===null||h.tag!==7?(h=ns(S,Y.mode,b,W),h.return=Y,h):(h=o(h,S),h.return=Y,h)}function u(Y,h,S){if(typeof h=="string"&&h!==""||typeof h=="number")return h=Rg(""+h,Y.mode,S),h.return=Y,h;if(typeof h=="object"&&h!==null){switch(h.$$typeof){case Yp:return S=Fp(h.type,h.key,h.props,null,Y.mode,S),S.ref=rd(Y,null,h),S.return=Y,S;case ll:return h=Gg(h,Y.mode,S),h.return=Y,h;case Di:var b=h._init;return u(Y,b(h._payload),S)}if(sd(h)||qc(h))return h=ns(h,Y.mode,S,null),h.return=Y,h;kp(Y,h)}return null}function p(Y,h,S,b){var W=h!==null?h.key:null;if(typeof S=="string"&&S!==""||typeof S=="number")return W!==null?null:s(Y,h,""+S,b);if(typeof S=="object"&&S!==null){switch(S.$$typeof){case Yp:return S.key===W?l(Y,h,S,b):null;case ll:return S.key===W?c(Y,h,S,b):null;case Di:return W=S._init,p(Y,h,W(S._payload),b)}if(sd(S)||qc(S))return W!==null?null:d(Y,h,S,b,null);kp(Y,S)}return null}function m(Y,h,S,b,W){if(typeof b=="string"&&b!==""||typeof b=="number")return Y=Y.get(S)||null,s(h,Y,""+b,W);if(typeof b=="object"&&b!==null){switch(b.$$typeof){case Yp:return Y=Y.get(b.key===null?S:b.key)||null,l(h,Y,b,W);case ll:return Y=Y.get(b.key===null?S:b.key)||null,c(h,Y,b,W);case Di:var C=b._init;return m(Y,h,S,C(b._payload),W)}if(sd(b)||qc(b))return Y=Y.get(S)||null,d(h,Y,b,W,null);kp(h,b)}return null}function g(Y,h,S,b){for(var W=null,C=null,w=h,I=h=0,U=null;w!==null&&I<S.length;I++){w.index>I?(U=w,w=null):U=w.sibling;var L=p(Y,w,S[I],b);if(L===null){w===null&&(w=U);break}e&&w&&L.alternate===null&&t(Y,w),h=i(L,h,I),C===null?W=L:C.sibling=L,C=L,w=U}if(I===S.length)return r(Y,w),ft&&ja(Y,I),W;if(w===null){for(;I<S.length;I++)w=u(Y,S[I],b),w!==null&&(h=i(w,h,I),C===null?W=w:C.sibling=w,C=w);return ft&&ja(Y,I),W}for(w=n(Y,w);I<S.length;I++)U=m(w,Y,I,S[I],b),U!==null&&(e&&U.alternate!==null&&w.delete(U.key===null?I:U.key),h=i(U,h,I),C===null?W=U:C.sibling=U,C=U);return e&&w.forEach(function(X){return t(Y,X)}),ft&&ja(Y,I),W}function y(Y,h,S,b){var W=qc(S);if(typeof W!="function")throw Error(F(150));if(S=W.call(S),S==null)throw Error(F(151));for(var C=W=null,w=h,I=h=0,U=null,L=S.next();w!==null&&!L.done;I++,L=S.next()){w.index>I?(U=w,w=null):U=w.sibling;var X=p(Y,w,L.value,b);if(X===null){w===null&&(w=U);break}e&&w&&X.alternate===null&&t(Y,w),h=i(X,h,I),C===null?W=X:C.sibling=X,C=X,w=U}if(L.done)return r(Y,w),ft&&ja(Y,I),W;if(w===null){for(;!L.done;I++,L=S.next())L=u(Y,L.value,b),L!==null&&(h=i(L,h,I),C===null?W=L:C.sibling=L,C=L);return ft&&ja(Y,I),W}for(w=n(Y,w);!L.done;I++,L=S.next())L=m(w,Y,I,L.value,b),L!==null&&(e&&L.alternate!==null&&w.delete(L.key===null?I:L.key),h=i(L,h,I),C===null?W=L:C.sibling=L,C=L);return e&&w.forEach(function(N){return t(Y,N)}),ft&&ja(Y,I),W}function P(Y,h,S,b){if(typeof S=="object"&&S!==null&&S.type===cl&&S.key===null&&(S=S.props.children),typeof S=="object"&&S!==null){switch(S.$$typeof){case Yp:e:{for(var W=S.key,C=h;C!==null;){if(C.key===W){if(W=S.type,W===cl){if(C.tag===7){r(Y,C.sibling),h=o(C,S.props.children),h.return=Y,Y=h;break e}}else if(C.elementType===W||typeof W=="object"&&W!==null&&W.$$typeof===Di&&vx(W)===C.type){r(Y,C.sibling),h=o(C,S.props),h.ref=rd(Y,C,S),h.return=Y,Y=h;break e}r(Y,C);break}else t(Y,C);C=C.sibling}S.type===cl?(h=ns(S.props.children,Y.mode,b,S.key),h.return=Y,Y=h):(b=Fp(S.type,S.key,S.props,null,Y.mode,b),b.ref=rd(Y,h,S),b.return=Y,Y=b)}return a(Y);case ll:e:{for(C=S.key;h!==null;){if(h.key===C)if(h.tag===4&&h.stateNode.containerInfo===S.containerInfo&&h.stateNode.implementation===S.implementation){r(Y,h.sibling),h=o(h,S.children||[]),h.return=Y,Y=h;break e}else{r(Y,h);break}else t(Y,h);h=h.sibling}h=Gg(S,Y.mode,b),h.return=Y,Y=h}return a(Y);case Di:return C=S._init,P(Y,h,C(S._payload),b)}if(sd(S))return g(Y,h,S,b);if(qc(S))return y(Y,h,S,b);kp(Y,S)}return typeof S=="string"&&S!==""||typeof S=="number"?(S=""+S,h!==null&&h.tag===6?(r(Y,h.sibling),h=o(h,S),h.return=Y,Y=h):(r(Y,h),h=Rg(S,Y.mode,b),h.return=Y,Y=h),a(Y)):r(Y,h)}return P}var Ul=Qb(!0),jb=Qb(!1),Gd={},Mo=ca(Gd),Id=ca(Gd),Vd=ca(Gd);function ts(e){if(e===Gd)throw Error(F(174));return e}function rS(e,t){switch(tt(Vd,t),tt(Id,e),tt(Mo,Gd),e=t.nodeType,e){case 9:case 11:t=(t=t.documentElement)?t.namespaceURI:Hg(null,"");break;default:e=e===8?t.parentNode:t,t=e.namespaceURI||null,e=e.tagName,t=Hg(t,e)}ct(Mo),tt(Mo,t)}function Il(){ct(Mo),ct(Id),ct(Vd)}function qb(e){ts(Vd.current);var t=ts(Mo.current),r=Hg(t,e.type);t!==r&&(tt(Id,e),tt(Mo,r))}function nS(e){Id.current===e&&(ct(Mo),ct(Id))}var St=ca(0);function lm(e){for(var t=e;t!==null;){if(t.tag===13){var r=t.memoizedState;if(r!==null&&(r=r.dehydrated,r===null||r.data==="$?"||r.data==="$!"))return t}else if(t.tag===19&&t.memoizedProps.revealOrder!==void 0){if(t.flags&128)return t}else if(t.child!==null){t.child.return=t,t=t.child;continue}if(t===e)break;for(;t.sibling===null;){if(t.return===null||t.return===e)return null;t=t.return}t.sibling.return=t.return,t=t.sibling}return null}var kg=[];function oS(){for(var e=0;e<kg.length;e++)kg[e]._workInProgressVersionPrimary=null;kg.length=0}var _p=yi.ReactCurrentDispatcher,Lg=yi.ReactCurrentBatchConfig,as=0,yt=null,Kt=null,qt=null,cm=!1,hd=!1,kd=0,rV=0;function Sr(){throw Error(F(321))}function iS(e,t){if(t===null)return!1;for(var r=0;r<t.length&&r<e.length;r++)if(!to(e[r],t[r]))return!1;return!0}function aS(e,t,r,n,o,i){if(as=i,yt=t,t.memoizedState=null,t.updateQueue=null,t.lanes=0,_p.current=e===null||e.memoizedState===null?aV:sV,e=r(n,o),hd){i=0;do{if(hd=!1,kd=0,25<=i)throw Error(F(301));i+=1,qt=Kt=null,t.updateQueue=null,_p.current=lV,e=r(n,o)}while(hd)}if(_p.current=dm,t=Kt!==null&&Kt.next!==null,as=0,qt=Kt=yt=null,cm=!1,t)throw Error(F(300));return e}function sS(){var e=kd!==0;return kd=0,e}function vo(){var e={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return qt===null?yt.memoizedState=qt=e:qt=qt.next=e,qt}function Nn(){if(Kt===null){var e=yt.alternate;e=e!==null?e.memoizedState:null}else e=Kt.next;var t=qt===null?yt.memoizedState:qt.next;if(t!==null)qt=t,Kt=e;else{if(e===null)throw Error(F(310));Kt=e,e={memoizedState:Kt.memoizedState,baseState:Kt.baseState,baseQueue:Kt.baseQueue,queue:Kt.queue,next:null},qt===null?yt.memoizedState=qt=e:qt=qt.next=e}return qt}function Ld(e,t){return typeof t=="function"?t(e):t}function Xg(e){var t=Nn(),r=t.queue;if(r===null)throw Error(F(311));r.lastRenderedReducer=e;var n=Kt,o=n.baseQueue,i=r.pending;if(i!==null){if(o!==null){var a=o.next;o.next=i.next,i.next=a}n.baseQueue=o=i,r.pending=null}if(o!==null){i=o.next,n=n.baseState;var s=a=null,l=null,c=i;do{var d=c.lane;if((as&d)===d)l!==null&&(l=l.next={lane:0,action:c.action,hasEagerState:c.hasEagerState,eagerState:c.eagerState,next:null}),n=c.hasEagerState?c.eagerState:e(n,c.action);else{var u={lane:d,action:c.action,hasEagerState:c.hasEagerState,eagerState:c.eagerState,next:null};l===null?(s=l=u,a=n):l=l.next=u,yt.lanes|=d,ss|=d}c=c.next}while(c!==null&&c!==i);l===null?a=n:l.next=s,to(n,t.memoizedState)||(Zr=!0),t.memoizedState=n,t.baseState=a,t.baseQueue=l,r.lastRenderedState=n}if(e=r.interleaved,e!==null){o=e;do i=o.lane,yt.lanes|=i,ss|=i,o=o.next;while(o!==e)}else o===null&&(r.lanes=0);return[t.memoizedState,r.dispatch]}function Ng(e){var t=Nn(),r=t.queue;if(r===null)throw Error(F(311));r.lastRenderedReducer=e;var n=r.dispatch,o=r.pending,i=t.memoizedState;if(o!==null){r.pending=null;var a=o=o.next;do i=e(i,a.action),a=a.next;while(a!==o);to(i,t.memoizedState)||(Zr=!0),t.memoizedState=i,t.baseQueue===null&&(t.baseState=i),r.lastRenderedState=i}return[i,n]}function Jb(){}function eC(e,t){var r=yt,n=Nn(),o=t(),i=!to(n.memoizedState,o);if(i&&(n.memoizedState=o,Zr=!0),n=n.queue,lS(nC.bind(null,r,n,e),[e]),n.getSnapshot!==t||i||qt!==null&&qt.memoizedState.tag&1){if(r.flags|=2048,Xd(9,rC.bind(null,r,n,o,t),void 0,null),Jt===null)throw Error(F(349));as&30||tC(r,t,o)}return o}function tC(e,t,r){e.flags|=16384,e={getSnapshot:t,value:r},t=yt.updateQueue,t===null?(t={lastEffect:null,stores:null},yt.updateQueue=t,t.stores=[e]):(r=t.stores,r===null?t.stores=[e]:r.push(e))}function rC(e,t,r,n){t.value=r,t.getSnapshot=n,oC(t)&&iC(e)}function nC(e,t,r){return r(function(){oC(t)&&iC(e)})}function oC(e){var t=e.getSnapshot;e=e.value;try{var r=t();return!to(e,r)}catch(n){return!0}}function iC(e){var t=Yi(e,1);t!==null&&eo(t,e,1,-1)}function wx(e){var t=vo();return typeof e=="function"&&(e=e()),t.memoizedState=t.baseState=e,e={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:Ld,lastRenderedState:e},t.queue=e,e=e.dispatch=iV.bind(null,yt,e),[t.memoizedState,e]}function Xd(e,t,r,n){return e={tag:e,create:t,destroy:r,deps:n,next:null},t=yt.updateQueue,t===null?(t={lastEffect:null,stores:null},yt.updateQueue=t,t.lastEffect=e.next=e):(r=t.lastEffect,r===null?t.lastEffect=e.next=e:(n=r.next,r.next=e,e.next=n,t.lastEffect=e)),e}function aC(){return Nn().memoizedState}function Bp(e,t,r,n){var o=vo();yt.flags|=e,o.memoizedState=Xd(1|t,r,void 0,n===void 0?null:n)}function Pm(e,t,r,n){var o=Nn();n=n===void 0?null:n;var i=void 0;if(Kt!==null){var a=Kt.memoizedState;if(i=a.destroy,n!==null&&iS(n,a.deps)){o.memoizedState=Xd(t,r,i,n);return}}yt.flags|=e,o.memoizedState=Xd(1|t,r,i,n)}function Tx(e,t){return Bp(8390656,8,e,t)}function lS(e,t){return Pm(2048,8,e,t)}function sC(e,t){return Pm(4,2,e,t)}function lC(e,t){return Pm(4,4,e,t)}function cC(e,t){if(typeof t=="function")return e=e(),t(e),function(){t(null)};if(t!=null)return e=e(),t.current=e,function(){t.current=null}}function dC(e,t,r){return r=r!=null?r.concat([e]):null,Pm(4,4,cC.bind(null,t,e),r)}function cS(){}function uC(e,t){var r=Nn();t=t===void 0?null:t;var n=r.memoizedState;return n!==null&&t!==null&&iS(t,n[1])?n[0]:(r.memoizedState=[e,t],e)}function pC(e,t){var r=Nn();t=t===void 0?null:t;var n=r.memoizedState;return n!==null&&t!==null&&iS(t,n[1])?n[0]:(e=e(),r.memoizedState=[e,t],e)}function mC(e,t,r){return as&21?(to(r,t)||(r=gb(),yt.lanes|=r,ss|=r,e.baseState=!0),t):(e.baseState&&(e.baseState=!1,Zr=!0),e.memoizedState=r)}function nV(e,t){var r=De;De=r!==0&&4>r?r:4,e(!0);var n=Lg.transition;Lg.transition={};try{e(!1),t()}finally{De=r,Lg.transition=n}}function fC(){return Nn().memoizedState}function oV(e,t,r){var n=oa(e);if(r={lane:n,action:r,hasEagerState:!1,eagerState:null,next:null},hC(e))gC(t,r);else if(r=Db(e,t,r,n),r!==null){var o=Vr();eo(r,e,n,o),YC(r,t,n)}}function iV(e,t,r){var n=oa(e),o={lane:n,action:r,hasEagerState:!1,eagerState:null,next:null};if(hC(e))gC(t,o);else{var i=e.alternate;if(e.lanes===0&&(i===null||i.lanes===0)&&(i=t.lastRenderedReducer,i!==null))try{var a=t.lastRenderedState,s=i(a,r);if(o.hasEagerState=!0,o.eagerState=s,to(s,a)){var l=t.interleaved;l===null?(o.next=o,eS(t)):(o.next=l.next,l.next=o),t.interleaved=o;return}}catch(c){}finally{}r=Db(e,t,o,n),r!==null&&(o=Vr(),eo(r,e,n,o),YC(r,t,n))}}function hC(e){var t=e.alternate;return e===yt||t!==null&&t===yt}function gC(e,t){hd=cm=!0;var r=e.pending;r===null?t.next=t:(t.next=r.next,r.next=t),e.pending=t}function YC(e,t,r){if(r&4194240){var n=t.lanes;n&=e.pendingLanes,r|=n,t.lanes=r,_Y(e,r)}}var dm={readContext:Xn,useCallback:Sr,useContext:Sr,useEffect:Sr,useImperativeHandle:Sr,useInsertionEffect:Sr,useLayoutEffect:Sr,useMemo:Sr,useReducer:Sr,useRef:Sr,useState:Sr,useDebugValue:Sr,useDeferredValue:Sr,useTransition:Sr,useMutableSource:Sr,useSyncExternalStore:Sr,useId:Sr,unstable_isNewReconciler:!1},aV={readContext:Xn,useCallback:function(e,t){return vo().memoizedState=[e,t===void 0?null:t],e},useContext:Xn,useEffect:Tx,useImperativeHandle:function(e,t,r){return r=r!=null?r.concat([e]):null,Bp(4194308,4,cC.bind(null,t,e),r)},useLayoutEffect:function(e,t){return Bp(4194308,4,e,t)},useInsertionEffect:function(e,t){return Bp(4,2,e,t)},useMemo:function(e,t){var r=vo();return t=t===void 0?null:t,e=e(),r.memoizedState=[e,t],e},useReducer:function(e,t,r){var n=vo();return t=r!==void 0?r(t):t,n.memoizedState=n.baseState=t,e={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:e,lastRenderedState:t},n.queue=e,e=e.dispatch=oV.bind(null,yt,e),[n.memoizedState,e]},useRef:function(e){var t=vo();return e={current:e},t.memoizedState=e},useState:wx,useDebugValue:cS,useDeferredValue:function(e){return vo().memoizedState=e},useTransition:function(){var e=wx(!1),t=e[0];return e=nV.bind(null,e[1]),vo().memoizedState=e,[t,e]},useMutableSource:function(){},useSyncExternalStore:function(e,t,r){var n=yt,o=vo();if(ft){if(r===void 0)throw Error(F(407));r=r()}else{if(r=t(),Jt===null)throw Error(F(349));as&30||tC(n,t,r)}o.memoizedState=r;var i={value:r,getSnapshot:t};return o.queue=i,Tx(nC.bind(null,n,i,e),[e]),n.flags|=2048,Xd(9,rC.bind(null,n,i,r,t),void 0,null),r},useId:function(){var e=vo(),t=Jt.identifierPrefix;if(ft){var r=mi,n=pi;r=(n&~(1<<32-Jn(n)-1)).toString(32)+r,t=":"+t+"R"+r,r=kd++,0<r&&(t+="H"+r.toString(32)),t+=":"}else r=rV++,t=":"+t+"r"+r.toString(32)+":";return e.memoizedState=t},unstable_isNewReconciler:!1},sV={readContext:Xn,useCallback:uC,useContext:Xn,useEffect:lS,useImperativeHandle:dC,useInsertionEffect:sC,useLayoutEffect:lC,useMemo:pC,useReducer:Xg,useRef:aC,useState:function(){return Xg(Ld)},useDebugValue:cS,useDeferredValue:function(e){var t=Nn();return mC(t,Kt.memoizedState,e)},useTransition:function(){var e=Xg(Ld)[0],t=Nn().memoizedState;return[e,t]},useMutableSource:Jb,useSyncExternalStore:eC,useId:fC,unstable_isNewReconciler:!1},lV={readContext:Xn,useCallback:uC,useContext:Xn,useEffect:lS,useImperativeHandle:dC,useInsertionEffect:sC,useLayoutEffect:lC,useMemo:pC,useReducer:Ng,useRef:aC,useState:function(){return Ng(Ld)},useDebugValue:cS,useDeferredValue:function(e){var t=Nn();return Kt===null?t.memoizedState=e:mC(t,Kt.memoizedState,e)},useTransition:function(){var e=Ng(Ld)[0],t=Nn().memoizedState;return[e,t]},useMutableSource:Jb,useSyncExternalStore:eC,useId:fC,unstable_isNewReconciler:!1};function Vl(e,t){try{var r="",n=t;do r+=R2(n),n=n.return;while(n);var o=r}catch(i){o=`
Error generating stack: `+i.message+`
`+i.stack}return{value:e,source:t,stack:o,digest:null}}function Eg(e,t,r){return{value:e,source:null,stack:r!=null?r:null,digest:t!=null?t:null}}function SY(e,t){try{console.error(t.value)}catch(r){setTimeout(function(){throw r})}}var cV=typeof WeakMap=="function"?WeakMap:Map;function SC(e,t,r){r=fi(-1,r),r.tag=3,r.payload={element:null};var n=t.value;return r.callback=function(){pm||(pm=!0,MY=n),SY(e,t)},r}function yC(e,t,r){r=fi(-1,r),r.tag=3;var n=e.type.getDerivedStateFromError;if(typeof n=="function"){var o=t.value;r.payload=function(){return n(o)},r.callback=function(){SY(e,t)}}var i=e.stateNode;return i!==null&&typeof i.componentDidCatch=="function"&&(r.callback=function(){SY(e,t),typeof n!="function"&&(na===null?na=new Set([this]):na.add(this));var a=t.stack;this.componentDidCatch(t.value,{componentStack:a!==null?a:""})}),r}function Mx(e,t,r){var n=e.pingCache;if(n===null){n=e.pingCache=new cV;var o=new Set;n.set(t,o)}else o=n.get(t),o===void 0&&(o=new Set,n.set(t,o));o.has(r)||(o.add(r),e=PV.bind(null,e,t,r),t.then(e,e))}function Ux(e){do{var t;if((t=e.tag===13)&&(t=e.memoizedState,t=t!==null?t.dehydrated!==null:!0),t)return e;e=e.return}while(e!==null);return null}function Ix(e,t,r,n,o){return e.mode&1?(e.flags|=65536,e.lanes=o,e):(e===t?e.flags|=65536:(e.flags|=128,r.flags|=131072,r.flags&=-52805,r.tag===1&&(r.alternate===null?r.tag=17:(t=fi(-1,1),t.tag=2,ra(r,t,1))),r.lanes|=1),e)}var dV=yi.ReactCurrentOwner,Zr=!1;function Ir(e,t,r,n){t.child=e===null?jb(t,null,r,n):Ul(t,e.child,r,n)}function Vx(e,t,r,n,o){r=r.render;var i=t.ref;return Wl(t,o),n=aS(e,t,r,n,i,o),r=sS(),e!==null&&!Zr?(t.updateQueue=e.updateQueue,t.flags&=-2053,e.lanes&=~o,Si(e,t,o)):(ft&&r&&KY(t),t.flags|=1,Ir(e,t,n,o),t.child)}function kx(e,t,r,n,o){if(e===null){var i=r.type;return typeof i=="function"&&!YS(i)&&i.defaultProps===void 0&&r.compare===null&&r.defaultProps===void 0?(t.tag=15,t.type=i,xC(e,t,i,n,o)):(e=Fp(r.type,null,n,t,t.mode,o),e.ref=t.ref,e.return=t,t.child=e)}if(i=e.child,!(e.lanes&o)){var a=i.memoizedProps;if(r=r.compare,r=r!==null?r:wd,r(a,n)&&e.ref===t.ref)return Si(e,t,o)}return t.flags|=1,e=ia(i,n),e.ref=t.ref,e.return=t,t.child=e}function xC(e,t,r,n,o){if(e!==null){var i=e.memoizedProps;if(wd(i,n)&&e.ref===t.ref)if(Zr=!1,t.pendingProps=n=i,(e.lanes&o)!==0)e.flags&131072&&(Zr=!0);else return t.lanes=e.lanes,Si(e,t,o)}return yY(e,t,r,n,o)}function bC(e,t,r){var n=t.pendingProps,o=n.children,i=e!==null?e.memoizedState:null;if(n.mode==="hidden")if(!(t.mode&1))t.memoizedState={baseLanes:0,cachePool:null,transitions:null},tt(yl,sn),sn|=r;else{if(!(r&1073741824))return e=i!==null?i.baseLanes|r:r,t.lanes=t.childLanes=1073741824,t.memoizedState={baseLanes:e,cachePool:null,transitions:null},t.updateQueue=null,tt(yl,sn),sn|=e,null;t.memoizedState={baseLanes:0,cachePool:null,transitions:null},n=i!==null?i.baseLanes:r,tt(yl,sn),sn|=n}else i!==null?(n=i.baseLanes|r,t.memoizedState=null):n=r,tt(yl,sn),sn|=n;return Ir(e,t,o,r),t.child}function CC(e,t){var r=t.ref;(e===null&&r!==null||e!==null&&e.ref!==r)&&(t.flags|=512,t.flags|=2097152)}function yY(e,t,r,n,o){var i=Or(r)?os:br.current;return i=Tl(t,i),Wl(t,o),r=aS(e,t,r,n,i,o),n=sS(),e!==null&&!Zr?(t.updateQueue=e.updateQueue,t.flags&=-2053,e.lanes&=~o,Si(e,t,o)):(ft&&n&&KY(t),t.flags|=1,Ir(e,t,r,o),t.child)}function Lx(e,t,r,n,o){if(Or(r)){var i=!0;rm(t)}else i=!1;if(Wl(t,o),t.stateNode===null)Zp(e,t),Hb(t,r,n),YY(t,r,n,o),n=!0;else if(e===null){var a=t.stateNode,s=t.memoizedProps;a.props=s;var l=a.context,c=r.contextType;typeof c=="object"&&c!==null?c=Xn(c):(c=Or(r)?os:br.current,c=Tl(t,c));var d=r.getDerivedStateFromProps,u=typeof d=="function"||typeof a.getSnapshotBeforeUpdate=="function";u||typeof a.UNSAFE_componentWillReceiveProps!="function"&&typeof a.componentWillReceiveProps!="function"||(s!==n||l!==c)&&Wx(t,a,n,c),zi=!1;var p=t.memoizedState;a.state=p,sm(t,n,a,o),l=t.memoizedState,s!==n||p!==l||$r.current||zi?(typeof d=="function"&&(gY(t,r,d,n),l=t.memoizedState),(s=zi||Px(t,r,s,n,p,l,c))?(u||typeof a.UNSAFE_componentWillMount!="function"&&typeof a.componentWillMount!="function"||(typeof a.componentWillMount=="function"&&a.componentWillMount(),typeof a.UNSAFE_componentWillMount=="function"&&a.UNSAFE_componentWillMount()),typeof a.componentDidMount=="function"&&(t.flags|=4194308)):(typeof a.componentDidMount=="function"&&(t.flags|=4194308),t.memoizedProps=n,t.memoizedState=l),a.props=n,a.state=l,a.context=c,n=s):(typeof a.componentDidMount=="function"&&(t.flags|=4194308),n=!1)}else{a=t.stateNode,zb(e,t),s=t.memoizedProps,c=t.type===t.elementType?s:Qn(t.type,s),a.props=c,u=t.pendingProps,p=a.context,l=r.contextType,typeof l=="object"&&l!==null?l=Xn(l):(l=Or(r)?os:br.current,l=Tl(t,l));var m=r.getDerivedStateFromProps;(d=typeof m=="function"||typeof a.getSnapshotBeforeUpdate=="function")||typeof a.UNSAFE_componentWillReceiveProps!="function"&&typeof a.componentWillReceiveProps!="function"||(s!==u||p!==l)&&Wx(t,a,n,l),zi=!1,p=t.memoizedState,a.state=p,sm(t,n,a,o);var g=t.memoizedState;s!==u||p!==g||$r.current||zi?(typeof m=="function"&&(gY(t,r,m,n),g=t.memoizedState),(c=zi||Px(t,r,c,n,p,g,l)||!1)?(d||typeof a.UNSAFE_componentWillUpdate!="function"&&typeof a.componentWillUpdate!="function"||(typeof a.componentWillUpdate=="function"&&a.componentWillUpdate(n,g,l),typeof a.UNSAFE_componentWillUpdate=="function"&&a.UNSAFE_componentWillUpdate(n,g,l)),typeof a.componentDidUpdate=="function"&&(t.flags|=4),typeof a.getSnapshotBeforeUpdate=="function"&&(t.flags|=1024)):(typeof a.componentDidUpdate!="function"||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=4),typeof a.getSnapshotBeforeUpdate!="function"||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=1024),t.memoizedProps=n,t.memoizedState=g),a.props=n,a.state=g,a.context=l,n=c):(typeof a.componentDidUpdate!="function"||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=4),typeof a.getSnapshotBeforeUpdate!="function"||s===e.memoizedProps&&p===e.memoizedState||(t.flags|=1024),n=!1)}return xY(e,t,r,n,i,o)}function xY(e,t,r,n,o,i){CC(e,t);var a=(t.flags&128)!==0;if(!n&&!a)return o&&Sx(t,r,!1),Si(e,t,i);n=t.stateNode,dV.current=t;var s=a&&typeof r.getDerivedStateFromError!="function"?null:n.render();return t.flags|=1,e!==null&&a?(t.child=Ul(t,e.child,null,i),t.child=Ul(t,null,s,i)):Ir(e,t,s,i),t.memoizedState=n.state,o&&Sx(t,r,!0),t.child}function PC(e){var t=e.stateNode;t.pendingContext?Yx(e,t.pendingContext,t.pendingContext!==t.context):t.context&&Yx(e,t.context,!1),rS(e,t.containerInfo)}function Xx(e,t,r,n,o){return Ml(),QY(o),t.flags|=256,Ir(e,t,r,n),t.child}var bY={dehydrated:null,treeContext:null,retryLane:0};function CY(e){return{baseLanes:e,cachePool:null,transitions:null}}function WC(e,t,r){var n=t.pendingProps,o=St.current,i=!1,a=(t.flags&128)!==0,s;if((s=a)||(s=e!==null&&e.memoizedState===null?!1:(o&2)!==0),s?(i=!0,t.flags&=-129):(e===null||e.memoizedState!==null)&&(o|=1),tt(St,o&1),e===null)return fY(t),e=t.memoizedState,e!==null&&(e=e.dehydrated,e!==null)?(t.mode&1?e.data==="$!"?t.lanes=8:t.lanes=1073741824:t.lanes=1,null):(a=n.children,e=n.fallback,i?(n=t.mode,i=t.child,a={mode:"hidden",children:a},!(n&1)&&i!==null?(i.childLanes=0,i.pendingProps=a):i=wm(a,n,0,null),e=ns(e,n,r,null),i.return=t,e.return=t,i.sibling=e,t.child=i,t.child.memoizedState=CY(r),t.memoizedState=bY,e):dS(t,a));if(o=e.memoizedState,o!==null&&(s=o.dehydrated,s!==null))return uV(e,t,a,n,s,o,r);if(i){i=n.fallback,a=t.mode,o=e.child,s=o.sibling;var l={mode:"hidden",children:n.children};return!(a&1)&&t.child!==o?(n=t.child,n.childLanes=0,n.pendingProps=l,t.deletions=null):(n=ia(o,l),n.subtreeFlags=o.subtreeFlags&14680064),s!==null?i=ia(s,i):(i=ns(i,a,r,null),i.flags|=2),i.return=t,n.return=t,n.sibling=i,t.child=n,n=i,i=t.child,a=e.child.memoizedState,a=a===null?CY(r):{baseLanes:a.baseLanes|r,cachePool:null,transitions:a.transitions},i.memoizedState=a,i.childLanes=e.childLanes&~r,t.memoizedState=bY,n}return i=e.child,e=i.sibling,n=ia(i,{mode:"visible",children:n.children}),!(t.mode&1)&&(n.lanes=r),n.return=t,n.sibling=null,e!==null&&(r=t.deletions,r===null?(t.deletions=[e],t.flags|=16):r.push(e)),t.child=n,t.memoizedState=null,n}function dS(e,t){return t=wm({mode:"visible",children:t},e.mode,0,null),t.return=e,e.child=t}function Lp(e,t,r,n){return n!==null&&QY(n),Ul(t,e.child,null,r),e=dS(t,t.pendingProps.children),e.flags|=2,t.memoizedState=null,e}function uV(e,t,r,n,o,i,a){if(r)return t.flags&256?(t.flags&=-257,n=Eg(Error(F(422))),Lp(e,t,a,n)):t.memoizedState!==null?(t.child=e.child,t.flags|=128,null):(i=n.fallback,o=t.mode,n=wm({mode:"visible",children:n.children},o,0,null),i=ns(i,o,a,null),i.flags|=2,n.return=t,i.return=t,n.sibling=i,t.child=n,t.mode&1&&Ul(t,e.child,null,a),t.child.memoizedState=CY(a),t.memoizedState=bY,i);if(!(t.mode&1))return Lp(e,t,a,null);if(o.data==="$!"){if(n=o.nextSibling&&o.nextSibling.dataset,n)var s=n.dgst;return n=s,i=Error(F(419)),n=Eg(i,n,void 0),Lp(e,t,a,n)}if(s=(a&e.childLanes)!==0,Zr||s){if(n=Jt,n!==null){switch(a&-a){case 4:o=2;break;case 16:o=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:o=32;break;case 536870912:o=268435456;break;default:o=0}o=o&(n.suspendedLanes|a)?0:o,o!==0&&o!==i.retryLane&&(i.retryLane=o,Yi(e,o),eo(n,e,o,-1))}return gS(),n=Eg(Error(F(421))),Lp(e,t,a,n)}return o.data==="$?"?(t.flags|=128,t.child=e.child,t=WV.bind(null,e),o._reactRetry=t,null):(e=i.treeContext,ln=ta(o.nextSibling),cn=t,ft=!0,qn=null,e!==null&&(In[Vn++]=pi,In[Vn++]=mi,In[Vn++]=is,pi=e.id,mi=e.overflow,is=t),t=dS(t,n.children),t.flags|=4096,t)}function Nx(e,t,r){e.lanes|=t;var n=e.alternate;n!==null&&(n.lanes|=t),hY(e.return,t,r)}function Ag(e,t,r,n,o){var i=e.memoizedState;i===null?e.memoizedState={isBackwards:t,rendering:null,renderingStartTime:0,last:n,tail:r,tailMode:o}:(i.isBackwards=t,i.rendering=null,i.renderingStartTime=0,i.last=n,i.tail=r,i.tailMode=o)}function vC(e,t,r){var n=t.pendingProps,o=n.revealOrder,i=n.tail;if(Ir(e,t,n.children,r),n=St.current,n&2)n=n&1|2,t.flags|=128;else{if(e!==null&&e.flags&128)e:for(e=t.child;e!==null;){if(e.tag===13)e.memoizedState!==null&&Nx(e,r,t);else if(e.tag===19)Nx(e,r,t);else if(e.child!==null){e.child.return=e,e=e.child;continue}if(e===t)break e;for(;e.sibling===null;){if(e.return===null||e.return===t)break e;e=e.return}e.sibling.return=e.return,e=e.sibling}n&=1}if(tt(St,n),!(t.mode&1))t.memoizedState=null;else switch(o){case"forwards":for(r=t.child,o=null;r!==null;)e=r.alternate,e!==null&&lm(e)===null&&(o=r),r=r.sibling;r=o,r===null?(o=t.child,t.child=null):(o=r.sibling,r.sibling=null),Ag(t,!1,o,r,i);break;case"backwards":for(r=null,o=t.child,t.child=null;o!==null;){if(e=o.alternate,e!==null&&lm(e)===null){t.child=o;break}e=o.sibling,o.sibling=r,r=o,o=e}Ag(t,!0,r,null,i);break;case"together":Ag(t,!1,null,null,void 0);break;default:t.memoizedState=null}return t.child}function Zp(e,t){!(t.mode&1)&&e!==null&&(e.alternate=null,t.alternate=null,t.flags|=2)}function Si(e,t,r){if(e!==null&&(t.dependencies=e.dependencies),ss|=t.lanes,!(r&t.childLanes))return null;if(e!==null&&t.child!==e.child)throw Error(F(153));if(t.child!==null){for(e=t.child,r=ia(e,e.pendingProps),t.child=r,r.return=t;e.sibling!==null;)e=e.sibling,r=r.sibling=ia(e,e.pendingProps),r.return=t;r.sibling=null}return t.child}function pV(e,t,r){switch(t.tag){case 3:PC(t),Ml();break;case 5:qb(t);break;case 1:Or(t.type)&&rm(t);break;case 4:rS(t,t.stateNode.containerInfo);break;case 10:var n=t.type._context,o=t.memoizedProps.value;tt(im,n._currentValue),n._currentValue=o;break;case 13:if(n=t.memoizedState,n!==null)return n.dehydrated!==null?(tt(St,St.current&1),t.flags|=128,null):r&t.child.childLanes?WC(e,t,r):(tt(St,St.current&1),e=Si(e,t,r),e!==null?e.sibling:null);tt(St,St.current&1);break;case 19:if(n=(r&t.childLanes)!==0,e.flags&128){if(n)return vC(e,t,r);t.flags|=128}if(o=t.memoizedState,o!==null&&(o.rendering=null,o.tail=null,o.lastEffect=null),tt(St,St.current),n)break;return null;case 22:case 23:return t.lanes=0,bC(e,t,r)}return Si(e,t,r)}var wC,PY,TC,MC;wC=function(e,t){for(var r=t.child;r!==null;){if(r.tag===5||r.tag===6)e.appendChild(r.stateNode);else if(r.tag!==4&&r.child!==null){r.child.return=r,r=r.child;continue}if(r===t)break;for(;r.sibling===null;){if(r.return===null||r.return===t)return;r=r.return}r.sibling.return=r.return,r=r.sibling}};PY=function(){};TC=function(e,t,r,n){var o=e.memoizedProps;if(o!==n){e=t.stateNode,ts(Mo.current);var i=null;switch(r){case"input":o=Fg(e,o),n=Fg(e,n),i=[];break;case"select":o=xt({},o,{value:void 0}),n=xt({},n,{value:void 0}),i=[];break;case"textarea":o=Kg(e,o),n=Kg(e,n),i=[];break;default:typeof o.onClick!="function"&&typeof n.onClick=="function"&&(e.onclick=em)}Qg(r,n);var a;r=null;for(c in o)if(!n.hasOwnProperty(c)&&o.hasOwnProperty(c)&&o[c]!=null)if(c==="style"){var s=o[c];for(a in s)s.hasOwnProperty(a)&&(r||(r={}),r[a]="")}else c!=="dangerouslySetInnerHTML"&&c!=="children"&&c!=="suppressContentEditableWarning"&&c!=="suppressHydrationWarning"&&c!=="autoFocus"&&(yd.hasOwnProperty(c)?i||(i=[]):(i=i||[]).push(c,null));for(c in n){var l=n[c];if(s=o!=null?o[c]:void 0,n.hasOwnProperty(c)&&l!==s&&(l!=null||s!=null))if(c==="style")if(s){for(a in s)!s.hasOwnProperty(a)||l&&l.hasOwnProperty(a)||(r||(r={}),r[a]="");for(a in l)l.hasOwnProperty(a)&&s[a]!==l[a]&&(r||(r={}),r[a]=l[a])}else r||(i||(i=[]),i.push(c,r)),r=l;else c==="dangerouslySetInnerHTML"?(l=l?l.__html:void 0,s=s?s.__html:void 0,l!=null&&s!==l&&(i=i||[]).push(c,l)):c==="children"?typeof l!="string"&&typeof l!="number"||(i=i||[]).push(c,""+l):c!=="suppressContentEditableWarning"&&c!=="suppressHydrationWarning"&&(yd.hasOwnProperty(c)?(l!=null&&c==="onScroll"&&lt("scroll",e),i||s===l||(i=[])):(i=i||[]).push(c,l))}r&&(i=i||[]).push("style",r);var c=i;(t.updateQueue=c)&&(t.flags|=4)}};MC=function(e,t,r,n){r!==n&&(t.flags|=4)};function nd(e,t){if(!ft)switch(e.tailMode){case"hidden":t=e.tail;for(var r=null;t!==null;)t.alternate!==null&&(r=t),t=t.sibling;r===null?e.tail=null:r.sibling=null;break;case"collapsed":r=e.tail;for(var n=null;r!==null;)r.alternate!==null&&(n=r),r=r.sibling;n===null?t||e.tail===null?e.tail=null:e.tail.sibling=null:n.sibling=null}}function yr(e){var t=e.alternate!==null&&e.alternate.child===e.child,r=0,n=0;if(t)for(var o=e.child;o!==null;)r|=o.lanes|o.childLanes,n|=o.subtreeFlags&14680064,n|=o.flags&14680064,o.return=e,o=o.sibling;else for(o=e.child;o!==null;)r|=o.lanes|o.childLanes,n|=o.subtreeFlags,n|=o.flags,o.return=e,o=o.sibling;return e.subtreeFlags|=n,e.childLanes=r,t}function mV(e,t,r){var n=t.pendingProps;switch(HY(t),t.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return yr(t),null;case 1:return Or(t.type)&&tm(),yr(t),null;case 3:return n=t.stateNode,Il(),ct($r),ct(br),oS(),n.pendingContext&&(n.context=n.pendingContext,n.pendingContext=null),(e===null||e.child===null)&&(Vp(t)?t.flags|=4:e===null||e.memoizedState.isDehydrated&&!(t.flags&256)||(t.flags|=1024,qn!==null&&(VY(qn),qn=null))),PY(e,t),yr(t),null;case 5:nS(t);var o=ts(Vd.current);if(r=t.type,e!==null&&t.stateNode!=null)TC(e,t,r,n,o),e.ref!==t.ref&&(t.flags|=512,t.flags|=2097152);else{if(!n){if(t.stateNode===null)throw Error(F(166));return yr(t),null}if(e=ts(Mo.current),Vp(t)){n=t.stateNode,r=t.type;var i=t.memoizedProps;switch(n[wo]=t,n[Ud]=i,e=(t.mode&1)!==0,r){case"dialog":lt("cancel",n),lt("close",n);break;case"iframe":case"object":case"embed":lt("load",n);break;case"video":case"audio":for(o=0;o<cd.length;o++)lt(cd[o],n);break;case"source":lt("error",n);break;case"img":case"image":case"link":lt("error",n),lt("load",n);break;case"details":lt("toggle",n);break;case"input":$1(n,i),lt("invalid",n);break;case"select":n._wrapperState={wasMultiple:!!i.multiple},lt("invalid",n);break;case"textarea":F1(n,i),lt("invalid",n)}Qg(r,i),o=null;for(var a in i)if(i.hasOwnProperty(a)){var s=i[a];a==="children"?typeof s=="string"?n.textContent!==s&&(i.suppressHydrationWarning!==!0&&Ip(n.textContent,s,e),o=["children",s]):typeof s=="number"&&n.textContent!==""+s&&(i.suppressHydrationWarning!==!0&&Ip(n.textContent,s,e),o=["children",""+s]):yd.hasOwnProperty(a)&&s!=null&&a==="onScroll"&&lt("scroll",n)}switch(r){case"input":Sp(n),O1(n,i,!0);break;case"textarea":Sp(n),D1(n);break;case"select":case"option":break;default:typeof i.onClick=="function"&&(n.onclick=em)}n=o,t.updateQueue=n,n!==null&&(t.flags|=4)}else{a=o.nodeType===9?o:o.ownerDocument,e==="http://www.w3.org/1999/xhtml"&&(e=tb(r)),e==="http://www.w3.org/1999/xhtml"?r==="script"?(e=a.createElement("div"),e.innerHTML="<script><\/script>",e=e.removeChild(e.firstChild)):typeof n.is=="string"?e=a.createElement(r,{is:n.is}):(e=a.createElement(r),r==="select"&&(a=e,n.multiple?a.multiple=!0:n.size&&(a.size=n.size))):e=a.createElementNS(e,r),e[wo]=t,e[Ud]=n,wC(e,t,!1,!1),t.stateNode=e;e:{switch(a=jg(r,n),r){case"dialog":lt("cancel",e),lt("close",e),o=n;break;case"iframe":case"object":case"embed":lt("load",e),o=n;break;case"video":case"audio":for(o=0;o<cd.length;o++)lt(cd[o],e);o=n;break;case"source":lt("error",e),o=n;break;case"img":case"image":case"link":lt("error",e),lt("load",e),o=n;break;case"details":lt("toggle",e),o=n;break;case"input":$1(e,n),o=Fg(e,n),lt("invalid",e);break;case"option":o=n;break;case"select":e._wrapperState={wasMultiple:!!n.multiple},o=xt({},n,{value:void 0}),lt("invalid",e);break;case"textarea":F1(e,n),o=Kg(e,n),lt("invalid",e);break;default:o=n}Qg(r,o),s=o;for(i in s)if(s.hasOwnProperty(i)){var l=s[i];i==="style"?ob(e,l):i==="dangerouslySetInnerHTML"?(l=l?l.__html:void 0,l!=null&&rb(e,l)):i==="children"?typeof l=="string"?(r!=="textarea"||l!=="")&&xd(e,l):typeof l=="number"&&xd(e,""+l):i!=="suppressContentEditableWarning"&&i!=="suppressHydrationWarning"&&i!=="autoFocus"&&(yd.hasOwnProperty(i)?l!=null&&i==="onScroll"&&lt("scroll",e):l!=null&&XY(e,i,l,a))}switch(r){case"input":Sp(e),O1(e,n,!1);break;case"textarea":Sp(e),D1(e);break;case"option":n.value!=null&&e.setAttribute("value",""+aa(n.value));break;case"select":e.multiple=!!n.multiple,i=n.value,i!=null?xl(e,!!n.multiple,i,!1):n.defaultValue!=null&&xl(e,!!n.multiple,n.defaultValue,!0);break;default:typeof o.onClick=="function"&&(e.onclick=em)}switch(r){case"button":case"input":case"select":case"textarea":n=!!n.autoFocus;break e;case"img":n=!0;break e;default:n=!1}}n&&(t.flags|=4)}t.ref!==null&&(t.flags|=512,t.flags|=2097152)}return yr(t),null;case 6:if(e&&t.stateNode!=null)MC(e,t,e.memoizedProps,n);else{if(typeof n!="string"&&t.stateNode===null)throw Error(F(166));if(r=ts(Vd.current),ts(Mo.current),Vp(t)){if(n=t.stateNode,r=t.memoizedProps,n[wo]=t,(i=n.nodeValue!==r)&&(e=cn,e!==null))switch(e.tag){case 3:Ip(n.nodeValue,r,(e.mode&1)!==0);break;case 5:e.memoizedProps.suppressHydrationWarning!==!0&&Ip(n.nodeValue,r,(e.mode&1)!==0)}i&&(t.flags|=4)}else n=(r.nodeType===9?r:r.ownerDocument).createTextNode(n),n[wo]=t,t.stateNode=n}return yr(t),null;case 13:if(ct(St),n=t.memoizedState,e===null||e.memoizedState!==null&&e.memoizedState.dehydrated!==null){if(ft&&ln!==null&&t.mode&1&&!(t.flags&128))Fb(),Ml(),t.flags|=98560,i=!1;else if(i=Vp(t),n!==null&&n.dehydrated!==null){if(e===null){if(!i)throw Error(F(318));if(i=t.memoizedState,i=i!==null?i.dehydrated:null,!i)throw Error(F(317));i[wo]=t}else Ml(),!(t.flags&128)&&(t.memoizedState=null),t.flags|=4;yr(t),i=!1}else qn!==null&&(VY(qn),qn=null),i=!0;if(!i)return t.flags&65536?t:null}return t.flags&128?(t.lanes=r,t):(n=n!==null,n!==(e!==null&&e.memoizedState!==null)&&n&&(t.child.flags|=8192,t.mode&1&&(e===null||St.current&1?Ht===0&&(Ht=3):gS())),t.updateQueue!==null&&(t.flags|=4),yr(t),null);case 4:return Il(),PY(e,t),e===null&&Td(t.stateNode.containerInfo),yr(t),null;case 10:return JY(t.type._context),yr(t),null;case 17:return Or(t.type)&&tm(),yr(t),null;case 19:if(ct(St),i=t.memoizedState,i===null)return yr(t),null;if(n=(t.flags&128)!==0,a=i.rendering,a===null)if(n)nd(i,!1);else{if(Ht!==0||e!==null&&e.flags&128)for(e=t.child;e!==null;){if(a=lm(e),a!==null){for(t.flags|=128,nd(i,!1),n=a.updateQueue,n!==null&&(t.updateQueue=n,t.flags|=4),t.subtreeFlags=0,n=r,r=t.child;r!==null;)i=r,e=n,i.flags&=14680066,a=i.alternate,a===null?(i.childLanes=0,i.lanes=e,i.child=null,i.subtreeFlags=0,i.memoizedProps=null,i.memoizedState=null,i.updateQueue=null,i.dependencies=null,i.stateNode=null):(i.childLanes=a.childLanes,i.lanes=a.lanes,i.child=a.child,i.subtreeFlags=0,i.deletions=null,i.memoizedProps=a.memoizedProps,i.memoizedState=a.memoizedState,i.updateQueue=a.updateQueue,i.type=a.type,e=a.dependencies,i.dependencies=e===null?null:{lanes:e.lanes,firstContext:e.firstContext}),r=r.sibling;return tt(St,St.current&1|2),t.child}e=e.sibling}i.tail!==null&&Vt()>kl&&(t.flags|=128,n=!0,nd(i,!1),t.lanes=4194304)}else{if(!n)if(e=lm(a),e!==null){if(t.flags|=128,n=!0,r=e.updateQueue,r!==null&&(t.updateQueue=r,t.flags|=4),nd(i,!0),i.tail===null&&i.tailMode==="hidden"&&!a.alternate&&!ft)return yr(t),null}else 2*Vt()-i.renderingStartTime>kl&&r!==1073741824&&(t.flags|=128,n=!0,nd(i,!1),t.lanes=4194304);i.isBackwards?(a.sibling=t.child,t.child=a):(r=i.last,r!==null?r.sibling=a:t.child=a,i.last=a)}return i.tail!==null?(t=i.tail,i.rendering=t,i.tail=t.sibling,i.renderingStartTime=Vt(),t.sibling=null,r=St.current,tt(St,n?r&1|2:r&1),t):(yr(t),null);case 22:case 23:return hS(),n=t.memoizedState!==null,e!==null&&e.memoizedState!==null!==n&&(t.flags|=8192),n&&t.mode&1?sn&1073741824&&(yr(t),t.subtreeFlags&6&&(t.flags|=8192)):yr(t),null;case 24:return null;case 25:return null}throw Error(F(156,t.tag))}function fV(e,t){switch(HY(t),t.tag){case 1:return Or(t.type)&&tm(),e=t.flags,e&65536?(t.flags=e&-65537|128,t):null;case 3:return Il(),ct($r),ct(br),oS(),e=t.flags,e&65536&&!(e&128)?(t.flags=e&-65537|128,t):null;case 5:return nS(t),null;case 13:if(ct(St),e=t.memoizedState,e!==null&&e.dehydrated!==null){if(t.alternate===null)throw Error(F(340));Ml()}return e=t.flags,e&65536?(t.flags=e&-65537|128,t):null;case 19:return ct(St),null;case 4:return Il(),null;case 10:return JY(t.type._context),null;case 22:case 23:return hS(),null;case 24:return null;default:return null}}var Xp=!1,xr=!1,hV=typeof WeakSet=="function"?WeakSet:Set,ae=null;function Sl(e,t){var r=e.ref;if(r!==null)if(typeof r=="function")try{r(null)}catch(n){vt(e,t,n)}else r.current=null}function WY(e,t,r){try{r()}catch(n){vt(e,t,n)}}var Ex=!1;function gV(e,t){if(sY=jp,e=kb(),zY(e)){if("selectionStart"in e)var r={start:e.selectionStart,end:e.selectionEnd};else e:{r=(r=e.ownerDocument)&&r.defaultView||window;var n=r.getSelection&&r.getSelection();if(n&&n.rangeCount!==0){r=n.anchorNode;var o=n.anchorOffset,i=n.focusNode;n=n.focusOffset;try{r.nodeType,i.nodeType}catch(b){r=null;break e}var a=0,s=-1,l=-1,c=0,d=0,u=e,p=null;t:for(;;){for(var m;u!==r||o!==0&&u.nodeType!==3||(s=a+o),u!==i||n!==0&&u.nodeType!==3||(l=a+n),u.nodeType===3&&(a+=u.nodeValue.length),(m=u.firstChild)!==null;)p=u,u=m;for(;;){if(u===e)break t;if(p===r&&++c===o&&(s=a),p===i&&++d===n&&(l=a),(m=u.nextSibling)!==null)break;u=p,p=u.parentNode}u=m}r=s===-1||l===-1?null:{start:s,end:l}}else r=null}r=r||{start:0,end:0}}else r=null;for(lY={focusedElem:e,selectionRange:r},jp=!1,ae=t;ae!==null;)if(t=ae,e=t.child,(t.subtreeFlags&1028)!==0&&e!==null)e.return=t,ae=e;else for(;ae!==null;){t=ae;try{var g=t.alternate;if(t.flags&1024)switch(t.tag){case 0:case 11:case 15:break;case 1:if(g!==null){var y=g.memoizedProps,P=g.memoizedState,Y=t.stateNode,h=Y.getSnapshotBeforeUpdate(t.elementType===t.type?y:Qn(t.type,y),P);Y.__reactInternalSnapshotBeforeUpdate=h}break;case 3:var S=t.stateNode.containerInfo;S.nodeType===1?S.textContent="":S.nodeType===9&&S.documentElement&&S.removeChild(S.documentElement);break;case 5:case 6:case 4:case 17:break;default:throw Error(F(163))}}catch(b){vt(t,t.return,b)}if(e=t.sibling,e!==null){e.return=t.return,ae=e;break}ae=t.return}return g=Ex,Ex=!1,g}function gd(e,t,r){var n=t.updateQueue;if(n=n!==null?n.lastEffect:null,n!==null){var o=n=n.next;do{if((o.tag&e)===e){var i=o.destroy;o.destroy=void 0,i!==void 0&&WY(t,r,i)}o=o.next}while(o!==n)}}function Wm(e,t){if(t=t.updateQueue,t=t!==null?t.lastEffect:null,t!==null){var r=t=t.next;do{if((r.tag&e)===e){var n=r.create;r.destroy=n()}r=r.next}while(r!==t)}}function vY(e){var t=e.ref;if(t!==null){var r=e.stateNode;switch(e.tag){case 5:e=r;break;default:e=r}typeof t=="function"?t(e):t.current=e}}function UC(e){var t=e.alternate;t!==null&&(e.alternate=null,UC(t)),e.child=null,e.deletions=null,e.sibling=null,e.tag===5&&(t=e.stateNode,t!==null&&(delete t[wo],delete t[Ud],delete t[uY],delete t[qI],delete t[JI])),e.stateNode=null,e.return=null,e.dependencies=null,e.memoizedProps=null,e.memoizedState=null,e.pendingProps=null,e.stateNode=null,e.updateQueue=null}function IC(e){return e.tag===5||e.tag===3||e.tag===4}function Ax(e){e:for(;;){for(;e.sibling===null;){if(e.return===null||IC(e.return))return null;e=e.return}for(e.sibling.return=e.return,e=e.sibling;e.tag!==5&&e.tag!==6&&e.tag!==18;){if(e.flags&2||e.child===null||e.tag===4)continue e;e.child.return=e,e=e.child}if(!(e.flags&2))return e.stateNode}}function wY(e,t,r){var n=e.tag;if(n===5||n===6)e=e.stateNode,t?r.nodeType===8?r.parentNode.insertBefore(e,t):r.insertBefore(e,t):(r.nodeType===8?(t=r.parentNode,t.insertBefore(e,r)):(t=r,t.appendChild(e)),r=r._reactRootContainer,r!=null||t.onclick!==null||(t.onclick=em));else if(n!==4&&(e=e.child,e!==null))for(wY(e,t,r),e=e.sibling;e!==null;)wY(e,t,r),e=e.sibling}function TY(e,t,r){var n=e.tag;if(n===5||n===6)e=e.stateNode,t?r.insertBefore(e,t):r.appendChild(e);else if(n!==4&&(e=e.child,e!==null))for(TY(e,t,r),e=e.sibling;e!==null;)TY(e,t,r),e=e.sibling}var ir=null,jn=!1;function Fi(e,t,r){for(r=r.child;r!==null;)VC(e,t,r),r=r.sibling}function VC(e,t,r){if(To&&typeof To.onCommitFiberUnmount=="function")try{To.onCommitFiberUnmount(gm,r)}catch(s){}switch(r.tag){case 5:xr||Sl(r,t);case 6:var n=ir,o=jn;ir=null,Fi(e,t,r),ir=n,jn=o,ir!==null&&(jn?(e=ir,r=r.stateNode,e.nodeType===8?e.parentNode.removeChild(r):e.removeChild(r)):ir.removeChild(r.stateNode));break;case 18:ir!==null&&(jn?(e=ir,r=r.stateNode,e.nodeType===8?Ig(e.parentNode,r):e.nodeType===1&&Ig(e,r),Wd(e)):Ig(ir,r.stateNode));break;case 4:n=ir,o=jn,ir=r.stateNode.containerInfo,jn=!0,Fi(e,t,r),ir=n,jn=o;break;case 0:case 11:case 14:case 15:if(!xr&&(n=r.updateQueue,n!==null&&(n=n.lastEffect,n!==null))){o=n=n.next;do{var i=o,a=i.destroy;i=i.tag,a!==void 0&&(i&2||i&4)&&WY(r,t,a),o=o.next}while(o!==n)}Fi(e,t,r);break;case 1:if(!xr&&(Sl(r,t),n=r.stateNode,typeof n.componentWillUnmount=="function"))try{n.props=r.memoizedProps,n.state=r.memoizedState,n.componentWillUnmount()}catch(s){vt(r,t,s)}Fi(e,t,r);break;case 21:Fi(e,t,r);break;case 22:r.mode&1?(xr=(n=xr)||r.memoizedState!==null,Fi(e,t,r),xr=n):Fi(e,t,r);break;default:Fi(e,t,r)}}function Rx(e){var t=e.updateQueue;if(t!==null){e.updateQueue=null;var r=e.stateNode;r===null&&(r=e.stateNode=new hV),t.forEach(function(n){var o=vV.bind(null,e,n);r.has(n)||(r.add(n),n.then(o,o))})}}function Hn(e,t){var r=t.deletions;if(r!==null)for(var n=0;n<r.length;n++){var o=r[n];try{var i=e,a=t,s=a;e:for(;s!==null;){switch(s.tag){case 5:ir=s.stateNode,jn=!1;break e;case 3:ir=s.stateNode.containerInfo,jn=!0;break e;case 4:ir=s.stateNode.containerInfo,jn=!0;break e}s=s.return}if(ir===null)throw Error(F(160));VC(i,a,o),ir=null,jn=!1;var l=o.alternate;l!==null&&(l.return=null),o.return=null}catch(c){vt(o,t,c)}}if(t.subtreeFlags&12854)for(t=t.child;t!==null;)kC(t,e),t=t.sibling}function kC(e,t){var r=e.alternate,n=e.flags;switch(e.tag){case 0:case 11:case 14:case 15:if(Hn(t,e),Wo(e),n&4){try{gd(3,e,e.return),Wm(3,e)}catch(y){vt(e,e.return,y)}try{gd(5,e,e.return)}catch(y){vt(e,e.return,y)}}break;case 1:Hn(t,e),Wo(e),n&512&&r!==null&&Sl(r,r.return);break;case 5:if(Hn(t,e),Wo(e),n&512&&r!==null&&Sl(r,r.return),e.flags&32){var o=e.stateNode;try{xd(o,"")}catch(y){vt(e,e.return,y)}}if(n&4&&(o=e.stateNode,o!=null)){var i=e.memoizedProps,a=r!==null?r.memoizedProps:i,s=e.type,l=e.updateQueue;if(e.updateQueue=null,l!==null)try{s==="input"&&i.type==="radio"&&i.name!=null&&Jx(o,i),jg(s,a);var c=jg(s,i);for(a=0;a<l.length;a+=2){var d=l[a],u=l[a+1];d==="style"?ob(o,u):d==="dangerouslySetInnerHTML"?rb(o,u):d==="children"?xd(o,u):XY(o,d,u,c)}switch(s){case"input":Dg(o,i);break;case"textarea":eb(o,i);break;case"select":var p=o._wrapperState.wasMultiple;o._wrapperState.wasMultiple=!!i.multiple;var m=i.value;m!=null?xl(o,!!i.multiple,m,!1):p!==!!i.multiple&&(i.defaultValue!=null?xl(o,!!i.multiple,i.defaultValue,!0):xl(o,!!i.multiple,i.multiple?[]:"",!1))}o[Ud]=i}catch(y){vt(e,e.return,y)}}break;case 6:if(Hn(t,e),Wo(e),n&4){if(e.stateNode===null)throw Error(F(162));o=e.stateNode,i=e.memoizedProps;try{o.nodeValue=i}catch(y){vt(e,e.return,y)}}break;case 3:if(Hn(t,e),Wo(e),n&4&&r!==null&&r.memoizedState.isDehydrated)try{Wd(t.containerInfo)}catch(y){vt(e,e.return,y)}break;case 4:Hn(t,e),Wo(e);break;case 13:Hn(t,e),Wo(e),o=e.child,o.flags&8192&&(i=o.memoizedState!==null,o.stateNode.isHidden=i,!i||o.alternate!==null&&o.alternate.memoizedState!==null||(mS=Vt())),n&4&&Rx(e);break;case 22:if(d=r!==null&&r.memoizedState!==null,e.mode&1?(xr=(c=xr)||d,Hn(t,e),xr=c):Hn(t,e),Wo(e),n&8192){if(c=e.memoizedState!==null,(e.stateNode.isHidden=c)&&!d&&e.mode&1)for(ae=e,d=e.child;d!==null;){for(u=ae=d;ae!==null;){switch(p=ae,m=p.child,p.tag){case 0:case 11:case 14:case 15:gd(4,p,p.return);break;case 1:Sl(p,p.return);var g=p.stateNode;if(typeof g.componentWillUnmount=="function"){n=p,r=p.return;try{t=n,g.props=t.memoizedProps,g.state=t.memoizedState,g.componentWillUnmount()}catch(y){vt(n,r,y)}}break;case 5:Sl(p,p.return);break;case 22:if(p.memoizedState!==null){_x(u);continue}}m!==null?(m.return=p,ae=m):_x(u)}d=d.sibling}e:for(d=null,u=e;;){if(u.tag===5){if(d===null){d=u;try{o=u.stateNode,c?(i=o.style,typeof i.setProperty=="function"?i.setProperty("display","none","important"):i.display="none"):(s=u.stateNode,l=u.memoizedProps.style,a=l!=null&&l.hasOwnProperty("display")?l.display:null,s.style.display=nb("display",a))}catch(y){vt(e,e.return,y)}}}else if(u.tag===6){if(d===null)try{u.stateNode.nodeValue=c?"":u.memoizedProps}catch(y){vt(e,e.return,y)}}else if((u.tag!==22&&u.tag!==23||u.memoizedState===null||u===e)&&u.child!==null){u.child.return=u,u=u.child;continue}if(u===e)break e;for(;u.sibling===null;){if(u.return===null||u.return===e)break e;d===u&&(d=null),u=u.return}d===u&&(d=null),u.sibling.return=u.return,u=u.sibling}}break;case 19:Hn(t,e),Wo(e),n&4&&Rx(e);break;case 21:break;default:Hn(t,e),Wo(e)}}function Wo(e){var t=e.flags;if(t&2){try{e:{for(var r=e.return;r!==null;){if(IC(r)){var n=r;break e}r=r.return}throw Error(F(160))}switch(n.tag){case 5:var o=n.stateNode;n.flags&32&&(xd(o,""),n.flags&=-33);var i=Ax(e);TY(e,i,o);break;case 3:case 4:var a=n.stateNode.containerInfo,s=Ax(e);wY(e,s,a);break;default:throw Error(F(161))}}catch(l){vt(e,e.return,l)}e.flags&=-3}t&4096&&(e.flags&=-4097)}function YV(e,t,r){ae=e,LC(e,t,r)}function LC(e,t,r){for(var n=(e.mode&1)!==0;ae!==null;){var o=ae,i=o.child;if(o.tag===22&&n){var a=o.memoizedState!==null||Xp;if(!a){var s=o.alternate,l=s!==null&&s.memoizedState!==null||xr;s=Xp;var c=xr;if(Xp=a,(xr=l)&&!c)for(ae=o;ae!==null;)a=ae,l=a.child,a.tag===22&&a.memoizedState!==null?Bx(o):l!==null?(l.return=a,ae=l):Bx(o);for(;i!==null;)ae=i,LC(i,t,r),i=i.sibling;ae=o,Xp=s,xr=c}Gx(e,t,r)}else o.subtreeFlags&8772&&i!==null?(i.return=o,ae=i):Gx(e,t,r)}}function Gx(e){for(;ae!==null;){var t=ae;if(t.flags&8772){var r=t.alternate;try{if(t.flags&8772)switch(t.tag){case 0:case 11:case 15:xr||Wm(5,t);break;case 1:var n=t.stateNode;if(t.flags&4&&!xr)if(r===null)n.componentDidMount();else{var o=t.elementType===t.type?r.memoizedProps:Qn(t.type,r.memoizedProps);n.componentDidUpdate(o,r.memoizedState,n.__reactInternalSnapshotBeforeUpdate)}var i=t.updateQueue;i!==null&&Cx(t,i,n);break;case 3:var a=t.updateQueue;if(a!==null){if(r=null,t.child!==null)switch(t.child.tag){case 5:r=t.child.stateNode;break;case 1:r=t.child.stateNode}Cx(t,a,r)}break;case 5:var s=t.stateNode;if(r===null&&t.flags&4){r=s;var l=t.memoizedProps;switch(t.type){case"button":case"input":case"select":case"textarea":l.autoFocus&&r.focus();break;case"img":l.src&&(r.src=l.src)}}break;case 6:break;case 4:break;case 12:break;case 13:if(t.memoizedState===null){var c=t.alternate;if(c!==null){var d=c.memoizedState;if(d!==null){var u=d.dehydrated;u!==null&&Wd(u)}}}break;case 19:case 17:case 21:case 22:case 23:case 25:break;default:throw Error(F(163))}xr||t.flags&512&&vY(t)}catch(p){vt(t,t.return,p)}}if(t===e){ae=null;break}if(r=t.sibling,r!==null){r.return=t.return,ae=r;break}ae=t.return}}function _x(e){for(;ae!==null;){var t=ae;if(t===e){ae=null;break}var r=t.sibling;if(r!==null){r.return=t.return,ae=r;break}ae=t.return}}function Bx(e){for(;ae!==null;){var t=ae;try{switch(t.tag){case 0:case 11:case 15:var r=t.return;try{Wm(4,t)}catch(l){vt(t,r,l)}break;case 1:var n=t.stateNode;if(typeof n.componentDidMount=="function"){var o=t.return;try{n.componentDidMount()}catch(l){vt(t,o,l)}}var i=t.return;try{vY(t)}catch(l){vt(t,i,l)}break;case 5:var a=t.return;try{vY(t)}catch(l){vt(t,a,l)}}}catch(l){vt(t,t.return,l)}if(t===e){ae=null;break}var s=t.sibling;if(s!==null){s.return=t.return,ae=s;break}ae=t.return}}var SV=Math.ceil,um=yi.ReactCurrentDispatcher,uS=yi.ReactCurrentOwner,Ln=yi.ReactCurrentBatchConfig,Re=0,Jt=null,Bt=null,ar=0,sn=0,yl=ca(0),Ht=0,Nd=null,ss=0,vm=0,pS=0,Yd=null,Br=null,mS=0,kl=1/0,di=null,pm=!1,MY=null,na=null,Np=!1,ji=null,mm=0,Sd=0,UY=null,$p=-1,Op=0;function Vr(){return Re&6?Vt():$p!==-1?$p:$p=Vt()}function oa(e){return e.mode&1?Re&2&&ar!==0?ar&-ar:tV.transition!==null?(Op===0&&(Op=gb()),Op):(e=De,e!==0||(e=window.event,e=e===void 0?16:Pb(e.type)),e):1}function eo(e,t,r,n){if(50<Sd)throw Sd=0,UY=null,Error(F(185));Ed(e,r,n),(!(Re&2)||e!==Jt)&&(e===Jt&&(!(Re&2)&&(vm|=r),Ht===4&&Hi(e,ar)),Fr(e,n),r===1&&Re===0&&!(t.mode&1)&&(kl=Vt()+500,bm&&da()))}function Fr(e,t){var r=e.callbackNode;nI(e,t);var n=Qp(e,e===Jt?ar:0);if(n===0)r!==null&&H1(r),e.callbackNode=null,e.callbackPriority=0;else if(t=n&-n,e.callbackPriority!==t){if(r!=null&&H1(r),t===1)e.tag===0?eV(Zx.bind(null,e)):Zb(Zx.bind(null,e)),QI(function(){!(Re&6)&&da()}),r=null;else{switch(Yb(n)){case 1:r=GY;break;case 4:r=fb;break;case 16:r=Hp;break;case 536870912:r=hb;break;default:r=Hp}r=BC(r,XC.bind(null,e))}e.callbackPriority=t,e.callbackNode=r}}function XC(e,t){if($p=-1,Op=0,Re&6)throw Error(F(327));var r=e.callbackNode;if(vl()&&e.callbackNode!==r)return null;var n=Qp(e,e===Jt?ar:0);if(n===0)return null;if(n&30||n&e.expiredLanes||t)t=fm(e,n);else{t=n;var o=Re;Re|=2;var i=EC();(Jt!==e||ar!==t)&&(di=null,kl=Vt()+500,rs(e,t));do try{bV();break}catch(s){NC(e,s)}while(1);qY(),um.current=i,Re=o,Bt!==null?t=0:(Jt=null,ar=0,t=Ht)}if(t!==0){if(t===2&&(o=rY(e),o!==0&&(n=o,t=IY(e,o))),t===1)throw r=Nd,rs(e,0),Hi(e,n),Fr(e,Vt()),r;if(t===6)Hi(e,n);else{if(o=e.current.alternate,!(n&30)&&!yV(o)&&(t=fm(e,n),t===2&&(i=rY(e),i!==0&&(n=i,t=IY(e,i))),t===1))throw r=Nd,rs(e,0),Hi(e,n),Fr(e,Vt()),r;switch(e.finishedWork=o,e.finishedLanes=n,t){case 0:case 1:throw Error(F(345));case 2:qa(e,Br,di);break;case 3:if(Hi(e,n),(n&130023424)===n&&(t=mS+500-Vt(),10<t)){if(Qp(e,0)!==0)break;if(o=e.suspendedLanes,(o&n)!==n){Vr(),e.pingedLanes|=e.suspendedLanes&o;break}e.timeoutHandle=dY(qa.bind(null,e,Br,di),t);break}qa(e,Br,di);break;case 4:if(Hi(e,n),(n&4194240)===n)break;for(t=e.eventTimes,o=-1;0<n;){var a=31-Jn(n);i=1<<a,a=t[a],a>o&&(o=a),n&=~i}if(n=o,n=Vt()-n,n=(120>n?120:480>n?480:1080>n?1080:1920>n?1920:3e3>n?3e3:4320>n?4320:1960*SV(n/1960))-n,10<n){e.timeoutHandle=dY(qa.bind(null,e,Br,di),n);break}qa(e,Br,di);break;case 5:qa(e,Br,di);break;default:throw Error(F(329))}}}return Fr(e,Vt()),e.callbackNode===r?XC.bind(null,e):null}function IY(e,t){var r=Yd;return e.current.memoizedState.isDehydrated&&(rs(e,t).flags|=256),e=fm(e,t),e!==2&&(t=Br,Br=r,t!==null&&VY(t)),e}function VY(e){Br===null?Br=e:Br.push.apply(Br,e)}function yV(e){for(var t=e;;){if(t.flags&16384){var r=t.updateQueue;if(r!==null&&(r=r.stores,r!==null))for(var n=0;n<r.length;n++){var o=r[n],i=o.getSnapshot;o=o.value;try{if(!to(i(),o))return!1}catch(a){return!1}}}if(r=t.child,t.subtreeFlags&16384&&r!==null)r.return=t,t=r;else{if(t===e)break;for(;t.sibling===null;){if(t.return===null||t.return===e)return!0;t=t.return}t.sibling.return=t.return,t=t.sibling}}return!0}function Hi(e,t){for(t&=~pS,t&=~vm,e.suspendedLanes|=t,e.pingedLanes&=~t,e=e.expirationTimes;0<t;){var r=31-Jn(t),n=1<<r;e[r]=-1,t&=~n}}function Zx(e){if(Re&6)throw Error(F(327));vl();var t=Qp(e,0);if(!(t&1))return Fr(e,Vt()),null;var r=fm(e,t);if(e.tag!==0&&r===2){var n=rY(e);n!==0&&(t=n,r=IY(e,n))}if(r===1)throw r=Nd,rs(e,0),Hi(e,t),Fr(e,Vt()),r;if(r===6)throw Error(F(345));return e.finishedWork=e.current.alternate,e.finishedLanes=t,qa(e,Br,di),Fr(e,Vt()),null}function fS(e,t){var r=Re;Re|=1;try{return e(t)}finally{Re=r,Re===0&&(kl=Vt()+500,bm&&da())}}function ls(e){ji!==null&&ji.tag===0&&!(Re&6)&&vl();var t=Re;Re|=1;var r=Ln.transition,n=De;try{if(Ln.transition=null,De=1,e)return e()}finally{De=n,Ln.transition=r,Re=t,!(Re&6)&&da()}}function hS(){sn=yl.current,ct(yl)}function rs(e,t){e.finishedWork=null,e.finishedLanes=0;var r=e.timeoutHandle;if(r!==-1&&(e.timeoutHandle=-1,HI(r)),Bt!==null)for(r=Bt.return;r!==null;){var n=r;switch(HY(n),n.tag){case 1:n=n.type.childContextTypes,n!=null&&tm();break;case 3:Il(),ct($r),ct(br),oS();break;case 5:nS(n);break;case 4:Il();break;case 13:ct(St);break;case 19:ct(St);break;case 10:JY(n.type._context);break;case 22:case 23:hS()}r=r.return}if(Jt=e,Bt=e=ia(e.current,null),ar=sn=t,Ht=0,Nd=null,pS=vm=ss=0,Br=Yd=null,es!==null){for(t=0;t<es.length;t++)if(r=es[t],n=r.interleaved,n!==null){r.interleaved=null;var o=n.next,i=r.pending;if(i!==null){var a=i.next;i.next=o,n.next=a}r.pending=n}es=null}return e}function NC(e,t){do{var r=Bt;try{if(qY(),_p.current=dm,cm){for(var n=yt.memoizedState;n!==null;){var o=n.queue;o!==null&&(o.pending=null),n=n.next}cm=!1}if(as=0,qt=Kt=yt=null,hd=!1,kd=0,uS.current=null,r===null||r.return===null){Ht=1,Nd=t,Bt=null;break}e:{var i=e,a=r.return,s=r,l=t;if(t=ar,s.flags|=32768,l!==null&&typeof l=="object"&&typeof l.then=="function"){var c=l,d=s,u=d.tag;if(!(d.mode&1)&&(u===0||u===11||u===15)){var p=d.alternate;p?(d.updateQueue=p.updateQueue,d.memoizedState=p.memoizedState,d.lanes=p.lanes):(d.updateQueue=null,d.memoizedState=null)}var m=Ux(a);if(m!==null){m.flags&=-257,Ix(m,a,s,i,t),m.mode&1&&Mx(i,c,t),t=m,l=c;var g=t.updateQueue;if(g===null){var y=new Set;y.add(l),t.updateQueue=y}else g.add(l);break e}else{if(!(t&1)){Mx(i,c,t),gS();break e}l=Error(F(426))}}else if(ft&&s.mode&1){var P=Ux(a);if(P!==null){!(P.flags&65536)&&(P.flags|=256),Ix(P,a,s,i,t),QY(Vl(l,s));break e}}i=l=Vl(l,s),Ht!==4&&(Ht=2),Yd===null?Yd=[i]:Yd.push(i),i=a;do{switch(i.tag){case 3:i.flags|=65536,t&=-t,i.lanes|=t;var Y=SC(i,l,t);bx(i,Y);break e;case 1:s=l;var h=i.type,S=i.stateNode;if(!(i.flags&128)&&(typeof h.getDerivedStateFromError=="function"||S!==null&&typeof S.componentDidCatch=="function"&&(na===null||!na.has(S)))){i.flags|=65536,t&=-t,i.lanes|=t;var b=yC(i,s,t);bx(i,b);break e}}i=i.return}while(i!==null)}RC(r)}catch(W){t=W,Bt===r&&r!==null&&(Bt=r=r.return);continue}break}while(1)}function EC(){var e=um.current;return um.current=dm,e===null?dm:e}function gS(){(Ht===0||Ht===3||Ht===2)&&(Ht=4),Jt===null||!(ss&268435455)&&!(vm&268435455)||Hi(Jt,ar)}function fm(e,t){var r=Re;Re|=2;var n=EC();(Jt!==e||ar!==t)&&(di=null,rs(e,t));do try{xV();break}catch(o){NC(e,o)}while(1);if(qY(),Re=r,um.current=n,Bt!==null)throw Error(F(261));return Jt=null,ar=0,Ht}function xV(){for(;Bt!==null;)AC(Bt)}function bV(){for(;Bt!==null&&!K2();)AC(Bt)}function AC(e){var t=_C(e.alternate,e,sn);e.memoizedProps=e.pendingProps,t===null?RC(e):Bt=t,uS.current=null}function RC(e){var t=e;do{var r=t.alternate;if(e=t.return,t.flags&32768){if(r=fV(r,t),r!==null){r.flags&=32767,Bt=r;return}if(e!==null)e.flags|=32768,e.subtreeFlags=0,e.deletions=null;else{Ht=6,Bt=null;return}}else if(r=mV(r,t,sn),r!==null){Bt=r;return}if(t=t.sibling,t!==null){Bt=t;return}Bt=t=e}while(t!==null);Ht===0&&(Ht=5)}function qa(e,t,r){var n=De,o=Ln.transition;try{Ln.transition=null,De=1,CV(e,t,r,n)}finally{Ln.transition=o,De=n}return null}function CV(e,t,r,n){do vl();while(ji!==null);if(Re&6)throw Error(F(327));r=e.finishedWork;var o=e.finishedLanes;if(r===null)return null;if(e.finishedWork=null,e.finishedLanes=0,r===e.current)throw Error(F(177));e.callbackNode=null,e.callbackPriority=0;var i=r.lanes|r.childLanes;if(oI(e,i),e===Jt&&(Bt=Jt=null,ar=0),!(r.subtreeFlags&2064)&&!(r.flags&2064)||Np||(Np=!0,BC(Hp,function(){return vl(),null})),i=(r.flags&15990)!==0,r.subtreeFlags&15990||i){i=Ln.transition,Ln.transition=null;var a=De;De=1;var s=Re;Re|=4,uS.current=null,gV(e,r),kC(r,e),OI(lY),jp=!!sY,lY=sY=null,e.current=r,YV(r,e,o),H2(),Re=s,De=a,Ln.transition=i}else e.current=r;if(Np&&(Np=!1,ji=e,mm=o),i=e.pendingLanes,i===0&&(na=null),q2(r.stateNode,n),Fr(e,Vt()),t!==null)for(n=e.onRecoverableError,r=0;r<t.length;r++)o=t[r],n(o.value,{componentStack:o.stack,digest:o.digest});if(pm)throw pm=!1,e=MY,MY=null,e;return mm&1&&e.tag!==0&&vl(),i=e.pendingLanes,i&1?e===UY?Sd++:(Sd=0,UY=e):Sd=0,da(),null}function vl(){if(ji!==null){var e=Yb(mm),t=Ln.transition,r=De;try{if(Ln.transition=null,De=16>e?16:e,ji===null)var n=!1;else{if(e=ji,ji=null,mm=0,Re&6)throw Error(F(331));var o=Re;for(Re|=4,ae=e.current;ae!==null;){var i=ae,a=i.child;if(ae.flags&16){var s=i.deletions;if(s!==null){for(var l=0;l<s.length;l++){var c=s[l];for(ae=c;ae!==null;){var d=ae;switch(d.tag){case 0:case 11:case 15:gd(8,d,i)}var u=d.child;if(u!==null)u.return=d,ae=u;else for(;ae!==null;){d=ae;var p=d.sibling,m=d.return;if(UC(d),d===c){ae=null;break}if(p!==null){p.return=m,ae=p;break}ae=m}}}var g=i.alternate;if(g!==null){var y=g.child;if(y!==null){g.child=null;do{var P=y.sibling;y.sibling=null,y=P}while(y!==null)}}ae=i}}if(i.subtreeFlags&2064&&a!==null)a.return=i,ae=a;else e:for(;ae!==null;){if(i=ae,i.flags&2048)switch(i.tag){case 0:case 11:case 15:gd(9,i,i.return)}var Y=i.sibling;if(Y!==null){Y.return=i.return,ae=Y;break e}ae=i.return}}var h=e.current;for(ae=h;ae!==null;){a=ae;var S=a.child;if(a.subtreeFlags&2064&&S!==null)S.return=a,ae=S;else e:for(a=h;ae!==null;){if(s=ae,s.flags&2048)try{switch(s.tag){case 0:case 11:case 15:Wm(9,s)}}catch(W){vt(s,s.return,W)}if(s===a){ae=null;break e}var b=s.sibling;if(b!==null){b.return=s.return,ae=b;break e}ae=s.return}}if(Re=o,da(),To&&typeof To.onPostCommitFiberRoot=="function")try{To.onPostCommitFiberRoot(gm,e)}catch(W){}n=!0}return n}finally{De=r,Ln.transition=t}}return!1}function $x(e,t,r){t=Vl(r,t),t=SC(e,t,1),e=ra(e,t,1),t=Vr(),e!==null&&(Ed(e,1,t),Fr(e,t))}function vt(e,t,r){if(e.tag===3)$x(e,e,r);else for(;t!==null;){if(t.tag===3){$x(t,e,r);break}else if(t.tag===1){var n=t.stateNode;if(typeof t.type.getDerivedStateFromError=="function"||typeof n.componentDidCatch=="function"&&(na===null||!na.has(n))){e=Vl(r,e),e=yC(t,e,1),t=ra(t,e,1),e=Vr(),t!==null&&(Ed(t,1,e),Fr(t,e));break}}t=t.return}}function PV(e,t,r){var n=e.pingCache;n!==null&&n.delete(t),t=Vr(),e.pingedLanes|=e.suspendedLanes&r,Jt===e&&(ar&r)===r&&(Ht===4||Ht===3&&(ar&130023424)===ar&&500>Vt()-mS?rs(e,0):pS|=r),Fr(e,t)}function GC(e,t){t===0&&(e.mode&1?(t=bp,bp<<=1,!(bp&130023424)&&(bp=4194304)):t=1);var r=Vr();e=Yi(e,t),e!==null&&(Ed(e,t,r),Fr(e,r))}function WV(e){var t=e.memoizedState,r=0;t!==null&&(r=t.retryLane),GC(e,r)}function vV(e,t){var r=0;switch(e.tag){case 13:var n=e.stateNode,o=e.memoizedState;o!==null&&(r=o.retryLane);break;case 19:n=e.stateNode;break;default:throw Error(F(314))}n!==null&&n.delete(t),GC(e,r)}var _C;_C=function(e,t,r){if(e!==null)if(e.memoizedProps!==t.pendingProps||$r.current)Zr=!0;else{if(!(e.lanes&r)&&!(t.flags&128))return Zr=!1,pV(e,t,r);Zr=!!(e.flags&131072)}else Zr=!1,ft&&t.flags&1048576&&$b(t,om,t.index);switch(t.lanes=0,t.tag){case 2:var n=t.type;Zp(e,t),e=t.pendingProps;var o=Tl(t,br.current);Wl(t,r),o=aS(null,t,n,e,o,r);var i=sS();return t.flags|=1,typeof o=="object"&&o!==null&&typeof o.render=="function"&&o.$$typeof===void 0?(t.tag=1,t.memoizedState=null,t.updateQueue=null,Or(n)?(i=!0,rm(t)):i=!1,t.memoizedState=o.state!==null&&o.state!==void 0?o.state:null,tS(t),o.updater=Cm,t.stateNode=o,o._reactInternals=t,YY(t,n,e,r),t=xY(null,t,n,!0,i,r)):(t.tag=0,ft&&i&&KY(t),Ir(null,t,o,r),t=t.child),t;case 16:n=t.elementType;e:{switch(Zp(e,t),e=t.pendingProps,o=n._init,n=o(n._payload),t.type=n,o=t.tag=TV(n),e=Qn(n,e),o){case 0:t=yY(null,t,n,e,r);break e;case 1:t=Lx(null,t,n,e,r);break e;case 11:t=Vx(null,t,n,e,r);break e;case 14:t=kx(null,t,n,Qn(n.type,e),r);break e}throw Error(F(306,n,""))}return t;case 0:return n=t.type,o=t.pendingProps,o=t.elementType===n?o:Qn(n,o),yY(e,t,n,o,r);case 1:return n=t.type,o=t.pendingProps,o=t.elementType===n?o:Qn(n,o),Lx(e,t,n,o,r);case 3:e:{if(PC(t),e===null)throw Error(F(387));n=t.pendingProps,i=t.memoizedState,o=i.element,zb(e,t),sm(t,n,null,r);var a=t.memoizedState;if(n=a.element,i.isDehydrated)if(i={element:n,isDehydrated:!1,cache:a.cache,pendingSuspenseBoundaries:a.pendingSuspenseBoundaries,transitions:a.transitions},t.updateQueue.baseState=i,t.memoizedState=i,t.flags&256){o=Vl(Error(F(423)),t),t=Xx(e,t,n,r,o);break e}else if(n!==o){o=Vl(Error(F(424)),t),t=Xx(e,t,n,r,o);break e}else for(ln=ta(t.stateNode.containerInfo.firstChild),cn=t,ft=!0,qn=null,r=jb(t,null,n,r),t.child=r;r;)r.flags=r.flags&-3|4096,r=r.sibling;else{if(Ml(),n===o){t=Si(e,t,r);break e}Ir(e,t,n,r)}t=t.child}return t;case 5:return qb(t),e===null&&fY(t),n=t.type,o=t.pendingProps,i=e!==null?e.memoizedProps:null,a=o.children,cY(n,o)?a=null:i!==null&&cY(n,i)&&(t.flags|=32),CC(e,t),Ir(e,t,a,r),t.child;case 6:return e===null&&fY(t),null;case 13:return WC(e,t,r);case 4:return rS(t,t.stateNode.containerInfo),n=t.pendingProps,e===null?t.child=Ul(t,null,n,r):Ir(e,t,n,r),t.child;case 11:return n=t.type,o=t.pendingProps,o=t.elementType===n?o:Qn(n,o),Vx(e,t,n,o,r);case 7:return Ir(e,t,t.pendingProps,r),t.child;case 8:return Ir(e,t,t.pendingProps.children,r),t.child;case 12:return Ir(e,t,t.pendingProps.children,r),t.child;case 10:e:{if(n=t.type._context,o=t.pendingProps,i=t.memoizedProps,a=o.value,tt(im,n._currentValue),n._currentValue=a,i!==null)if(to(i.value,a)){if(i.children===o.children&&!$r.current){t=Si(e,t,r);break e}}else for(i=t.child,i!==null&&(i.return=t);i!==null;){var s=i.dependencies;if(s!==null){a=i.child;for(var l=s.firstContext;l!==null;){if(l.context===n){if(i.tag===1){l=fi(-1,r&-r),l.tag=2;var c=i.updateQueue;if(c!==null){c=c.shared;var d=c.pending;d===null?l.next=l:(l.next=d.next,d.next=l),c.pending=l}}i.lanes|=r,l=i.alternate,l!==null&&(l.lanes|=r),hY(i.return,r,t),s.lanes|=r;break}l=l.next}}else if(i.tag===10)a=i.type===t.type?null:i.child;else if(i.tag===18){if(a=i.return,a===null)throw Error(F(341));a.lanes|=r,s=a.alternate,s!==null&&(s.lanes|=r),hY(a,r,t),a=i.sibling}else a=i.child;if(a!==null)a.return=i;else for(a=i;a!==null;){if(a===t){a=null;break}if(i=a.sibling,i!==null){i.return=a.return,a=i;break}a=a.return}i=a}Ir(e,t,o.children,r),t=t.child}return t;case 9:return o=t.type,n=t.pendingProps.children,Wl(t,r),o=Xn(o),n=n(o),t.flags|=1,Ir(e,t,n,r),t.child;case 14:return n=t.type,o=Qn(n,t.pendingProps),o=Qn(n.type,o),kx(e,t,n,o,r);case 15:return xC(e,t,t.type,t.pendingProps,r);case 17:return n=t.type,o=t.pendingProps,o=t.elementType===n?o:Qn(n,o),Zp(e,t),t.tag=1,Or(n)?(e=!0,rm(t)):e=!1,Wl(t,r),Hb(t,n,o),YY(t,n,o,r),xY(null,t,n,!0,e,r);case 19:return vC(e,t,r);case 22:return bC(e,t,r)}throw Error(F(156,t.tag))};function BC(e,t){return mb(e,t)}function wV(e,t,r,n){this.tag=e,this.key=r,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=t,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=n,this.subtreeFlags=this.flags=0,this.deletions=null,this.childLanes=this.lanes=0,this.alternate=null}function kn(e,t,r,n){return new wV(e,t,r,n)}function YS(e){return e=e.prototype,!(!e||!e.isReactComponent)}function TV(e){if(typeof e=="function")return YS(e)?1:0;if(e!=null){if(e=e.$$typeof,e===EY)return 11;if(e===AY)return 14}return 2}function ia(e,t){var r=e.alternate;return r===null?(r=kn(e.tag,t,e.key,e.mode),r.elementType=e.elementType,r.type=e.type,r.stateNode=e.stateNode,r.alternate=e,e.alternate=r):(r.pendingProps=t,r.type=e.type,r.flags=0,r.subtreeFlags=0,r.deletions=null),r.flags=e.flags&14680064,r.childLanes=e.childLanes,r.lanes=e.lanes,r.child=e.child,r.memoizedProps=e.memoizedProps,r.memoizedState=e.memoizedState,r.updateQueue=e.updateQueue,t=e.dependencies,r.dependencies=t===null?null:{lanes:t.lanes,firstContext:t.firstContext},r.sibling=e.sibling,r.index=e.index,r.ref=e.ref,r}function Fp(e,t,r,n,o,i){var a=2;if(n=e,typeof e=="function")YS(e)&&(a=1);else if(typeof e=="string")a=5;else e:switch(e){case cl:return ns(r.children,o,i,t);case NY:a=8,o|=8;break;case Bg:return e=kn(12,r,t,o|2),e.elementType=Bg,e.lanes=i,e;case Zg:return e=kn(13,r,t,o),e.elementType=Zg,e.lanes=i,e;case $g:return e=kn(19,r,t,o),e.elementType=$g,e.lanes=i,e;case Qx:return wm(r,o,i,t);default:if(typeof e=="object"&&e!==null)switch(e.$$typeof){case Kx:a=10;break e;case Hx:a=9;break e;case EY:a=11;break e;case AY:a=14;break e;case Di:a=16,n=null;break e}throw Error(F(130,e==null?e:typeof e,""))}return t=kn(a,r,t,o),t.elementType=e,t.type=n,t.lanes=i,t}function ns(e,t,r,n){return e=kn(7,e,n,t),e.lanes=r,e}function wm(e,t,r,n){return e=kn(22,e,n,t),e.elementType=Qx,e.lanes=r,e.stateNode={isHidden:!1},e}function Rg(e,t,r){return e=kn(6,e,null,t),e.lanes=r,e}function Gg(e,t,r){return t=kn(4,e.children!==null?e.children:[],e.key,t),t.lanes=r,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function MV(e,t,r,n,o){this.tag=t,this.containerInfo=e,this.finishedWork=this.pingCache=this.current=this.pendingChildren=null,this.timeoutHandle=-1,this.callbackNode=this.pendingContext=this.context=null,this.callbackPriority=0,this.eventTimes=Cg(0),this.expirationTimes=Cg(-1),this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0,this.entanglements=Cg(0),this.identifierPrefix=n,this.onRecoverableError=o,this.mutableSourceEagerHydrationData=null}function SS(e,t,r,n,o,i,a,s,l){return e=new MV(e,t,r,s,l),t===1?(t=1,i===!0&&(t|=8)):t=0,i=kn(3,null,null,t),e.current=i,i.stateNode=e,i.memoizedState={element:n,isDehydrated:r,cache:null,transitions:null,pendingSuspenseBoundaries:null},tS(i),e}function UV(e,t,r){var n=3<arguments.length&&arguments[3]!==void 0?arguments[3]:null;return{$$typeof:ll,key:n==null?null:""+n,children:e,containerInfo:t,implementation:r}}function ZC(e){if(!e)return sa;e=e._reactInternals;e:{if(ds(e)!==e||e.tag!==1)throw Error(F(170));var t=e;do{switch(t.tag){case 3:t=t.stateNode.context;break e;case 1:if(Or(t.type)){t=t.stateNode.__reactInternalMemoizedMergedChildContext;break e}}t=t.return}while(t!==null);throw Error(F(171))}if(e.tag===1){var r=e.type;if(Or(r))return Bb(e,r,t)}return t}function $C(e,t,r,n,o,i,a,s,l){return e=SS(r,n,!0,e,o,i,a,s,l),e.context=ZC(null),r=e.current,n=Vr(),o=oa(r),i=fi(n,o),i.callback=t!=null?t:null,ra(r,i,o),e.current.lanes=o,Ed(e,o,n),Fr(e,n),e}function Tm(e,t,r,n){var o=t.current,i=Vr(),a=oa(o);return r=ZC(r),t.context===null?t.context=r:t.pendingContext=r,t=fi(i,a),t.payload={element:e},n=n===void 0?null:n,n!==null&&(t.callback=n),e=ra(o,t,a),e!==null&&(eo(e,o,a,i),Gp(e,o,a)),a}function hm(e){if(e=e.current,!e.child)return null;switch(e.child.tag){case 5:return e.child.stateNode;default:return e.child.stateNode}}function Ox(e,t){if(e=e.memoizedState,e!==null&&e.dehydrated!==null){var r=e.retryLane;e.retryLane=r!==0&&r<t?r:t}}function yS(e,t){Ox(e,t),(e=e.alternate)&&Ox(e,t)}function IV(){return null}var OC=typeof reportError=="function"?reportError:function(e){console.error(e)};function xS(e){this._internalRoot=e}Mm.prototype.render=xS.prototype.render=function(e){var t=this._internalRoot;if(t===null)throw Error(F(409));Tm(e,t,null,null)};Mm.prototype.unmount=xS.prototype.unmount=function(){var e=this._internalRoot;if(e!==null){this._internalRoot=null;var t=e.containerInfo;ls(function(){Tm(null,e,null,null)}),t[gi]=null}};function Mm(e){this._internalRoot=e}Mm.prototype.unstable_scheduleHydration=function(e){if(e){var t=xb();e={blockedOn:null,target:e,priority:t};for(var r=0;r<Ki.length&&t!==0&&t<Ki[r].priority;r++);Ki.splice(r,0,e),r===0&&Cb(e)}};function bS(e){return!(!e||e.nodeType!==1&&e.nodeType!==9&&e.nodeType!==11)}function Um(e){return!(!e||e.nodeType!==1&&e.nodeType!==9&&e.nodeType!==11&&(e.nodeType!==8||e.nodeValue!==" react-mount-point-unstable "))}function Fx(){}function VV(e,t,r,n,o){if(o){if(typeof n=="function"){var i=n;n=function(){var c=hm(a);i.call(c)}}var a=$C(t,n,e,0,null,!1,!1,"",Fx);return e._reactRootContainer=a,e[gi]=a.current,Td(e.nodeType===8?e.parentNode:e),ls(),a}for(;o=e.lastChild;)e.removeChild(o);if(typeof n=="function"){var s=n;n=function(){var c=hm(l);s.call(c)}}var l=SS(e,0,!1,null,null,!1,!1,"",Fx);return e._reactRootContainer=l,e[gi]=l.current,Td(e.nodeType===8?e.parentNode:e),ls(function(){Tm(t,l,r,n)}),l}function Im(e,t,r,n,o){var i=r._reactRootContainer;if(i){var a=i;if(typeof o=="function"){var s=o;o=function(){var l=hm(a);s.call(l)}}Tm(t,a,e,o)}else a=VV(r,t,e,o,n);return hm(a)}Sb=function(e){switch(e.tag){case 3:var t=e.stateNode;if(t.current.memoizedState.isDehydrated){var r=ld(t.pendingLanes);r!==0&&(_Y(t,r|1),Fr(t,Vt()),!(Re&6)&&(kl=Vt()+500,da()))}break;case 13:ls(function(){var n=Yi(e,1);if(n!==null){var o=Vr();eo(n,e,1,o)}}),yS(e,1)}};BY=function(e){if(e.tag===13){var t=Yi(e,134217728);if(t!==null){var r=Vr();eo(t,e,134217728,r)}yS(e,134217728)}};yb=function(e){if(e.tag===13){var t=oa(e),r=Yi(e,t);if(r!==null){var n=Vr();eo(r,e,t,n)}yS(e,t)}};xb=function(){return De};bb=function(e,t){var r=De;try{return De=e,t()}finally{De=r}};Jg=function(e,t,r){switch(t){case"input":if(Dg(e,r),t=r.name,r.type==="radio"&&t!=null){for(r=e;r.parentNode;)r=r.parentNode;for(r=r.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<r.length;t++){var n=r[t];if(n!==e&&n.form===e.form){var o=xm(n);if(!o)throw Error(F(90));qx(n),Dg(n,o)}}}break;case"textarea":eb(e,r);break;case"select":t=r.value,t!=null&&xl(e,!!r.multiple,t,!1)}};sb=fS;lb=ls;var kV={usingClientEntryPoint:!1,Events:[Rd,ml,xm,ib,ab,fS]},od={findFiberByHostInstance:Ja,bundleType:0,version:"18.2.0",rendererPackageName:"react-dom"},LV={bundleType:od.bundleType,version:od.version,rendererPackageName:od.rendererPackageName,rendererConfig:od.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:yi.ReactCurrentDispatcher,findHostInstanceByFiber:function(e){return e=ub(e),e===null?null:e.stateNode},findFiberByHostInstance:od.findFiberByHostInstance||IV,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.2.0-next-9e3b772b8-20220608"};if(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__!="undefined"&&(id=__REACT_DEVTOOLS_GLOBAL_HOOK__,!id.isDisabled&&id.supportsFiber))try{gm=id.inject(LV),To=id}catch(e){}var id;pn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=kV;pn.createPortal=function(e,t){var r=2<arguments.length&&arguments[2]!==void 0?arguments[2]:null;if(!bS(t))throw Error(F(200));return UV(e,t,null,r)};pn.createRoot=function(e,t){if(!bS(e))throw Error(F(299));var r=!1,n="",o=OC;return t!=null&&(t.unstable_strictMode===!0&&(r=!0),t.identifierPrefix!==void 0&&(n=t.identifierPrefix),t.onRecoverableError!==void 0&&(o=t.onRecoverableError)),t=SS(e,1,!1,null,null,r,!1,n,o),e[gi]=t.current,Td(e.nodeType===8?e.parentNode:e),new xS(t)};pn.findDOMNode=function(e){if(e==null)return null;if(e.nodeType===1)return e;var t=e._reactInternals;if(t===void 0)throw typeof e.render=="function"?Error(F(188)):(e=Object.keys(e).join(","),Error(F(268,e)));return e=ub(t),e=e===null?null:e.stateNode,e};pn.flushSync=function(e){return ls(e)};pn.hydrate=function(e,t,r){if(!Um(t))throw Error(F(200));return Im(null,e,t,!0,r)};pn.hydrateRoot=function(e,t,r){if(!bS(e))throw Error(F(405));var n=r!=null&&r.hydratedSources||null,o=!1,i="",a=OC;if(r!=null&&(r.unstable_strictMode===!0&&(o=!0),r.identifierPrefix!==void 0&&(i=r.identifierPrefix),r.onRecoverableError!==void 0&&(a=r.onRecoverableError)),t=$C(t,null,e,1,r!=null?r:null,o,!1,i,a),e[gi]=t.current,Td(e),n)for(e=0;e<n.length;e++)r=n[e],o=r._getVersion,o=o(r._source),t.mutableSourceEagerHydrationData==null?t.mutableSourceEagerHydrationData=[r,o]:t.mutableSourceEagerHydrationData.push(r,o);return new Mm(t)};pn.render=function(e,t,r){if(!Um(t))throw Error(F(200));return Im(null,e,t,!1,r)};pn.unmountComponentAtNode=function(e){if(!Um(e))throw Error(F(40));return e._reactRootContainer?(ls(function(){Im(null,null,e,!1,function(){e._reactRootContainer=null,e[gi]=null})}),!0):!1};pn.unstable_batchedUpdates=fS;pn.unstable_renderSubtreeIntoContainer=function(e,t,r,n){if(!Um(r))throw Error(F(200));if(e==null||e._reactInternals===void 0)throw Error(F(38));return Im(e,t,r,!1,n)};pn.version="18.2.0-next-9e3b772b8-20220608"});var ua=zn((eB,zC)=>{"use strict";function DC(){if(!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__=="undefined"||typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE!="function"))try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(DC)}catch(e){console.error(e)}}DC(),zC.exports=FC()});var PS=zn(CS=>{"use strict";var KC=ua();CS.createRoot=KC.createRoot,CS.hydrateRoot=KC.hydrateRoot;var tB});var zW=zn((c$,DW)=>{DW.exports=function(t,r,n,o){var i=n?n.call(o,t,r):void 0;if(i!==void 0)return!!i;if(t===r)return!0;if(typeof t!="object"||!t||typeof r!="object"||!r)return!1;var a=Object.keys(t),s=Object.keys(r);if(a.length!==s.length)return!1;for(var l=Object.prototype.hasOwnProperty.bind(r),c=0;c<a.length;c++){var d=a[c];if(!l(d))return!1;var u=t[d],p=r[d];if(i=n?n.call(o,u,p,d):void 0,i===!1||i===void 0&&u!==p)return!1}return!0}});var xw=zn((aF,e0)=>{function vX(e,t){"use strict";var r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n=["Africa/Abidjan","Africa/Accra","Africa/Addis_Ababa","Africa/Algiers","Africa/Asmara","Africa/Bamako","Africa/Bangui","Africa/Banjul","Africa/Bissau","Africa/Blantyre","Africa/Brazzaville","Africa/Bujumbura","Africa/Cairo","Africa/Casablanca","Africa/Ceuta","Africa/Conakry","Africa/Dakar","Africa/Dar_es_Salaam","Africa/Djibouti","Africa/Douala","Africa/El_Aaiun","Africa/Freetown","Africa/Gaborone","Africa/Harare","Africa/Johannesburg","Africa/Juba","Africa/Kampala","Africa/Khartoum","Africa/Kigali","Africa/Kinshasa","Africa/Lagos","Africa/Libreville","Africa/Lome","Africa/Luanda","Africa/Lubumbashi","Africa/Lusaka","Africa/Malabo","Africa/Maputo","Africa/Maseru","Africa/Mbabane","Africa/Mogadishu","Africa/Monrovia","Africa/Nairobi","Africa/Ndjamena","Africa/Niamey","Africa/Nouakchott","Africa/Ouagadougou","Africa/Porto-Novo","Africa/Sao_Tome","Africa/Tripoli","Africa/Tunis","Africa/Windhoek","America/Adak","America/Anchorage","America/Anguilla","America/Antigua","America/Araguaina","America/Argentina/Buenos_Aires","America/Argentina/Catamarca","America/Argentina/Cordoba","America/Argentina/Jujuy","America/Argentina/La_Rioja","America/Argentina/Mendoza","America/Argentina/Rio_Gallegos","America/Argentina/Salta","America/Argentina/San_Juan","America/Argentina/San_Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Aruba","America/Asuncion","America/Atikokan","America/Bahia","America/Bahia_Banderas","America/Barbados","America/Belem","America/Belize","America/Blanc-Sablon","America/Boa_Vista","America/Bogota","America/Boise","America/Cambridge_Bay","America/Campo_Grande","America/Cancun","America/Caracas","America/Cayenne","America/Cayman","America/Chicago","America/Chihuahua","America/Costa_Rica","America/Creston","America/Cuiaba","America/Curacao","America/Danmarkshavn","America/Dawson_Creek","America/Denver","America/Detroit","America/Dominica","America/Edmonton","America/Eirunepe","America/El_Salvador","America/Fort_Nelson","America/Fortaleza","America/Glace_Bay","America/Godthab","America/Goose_Bay","America/Grand_Turk","America/Grenada","America/Guadeloupe","America/Guatemala","America/Guayaquil","America/Guyana","America/Halifax","America/Havana","America/Hermosillo","America/Indiana/Indianapolis","America/Indiana/Knox","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Tell_City","America/Indiana/Vincennes","America/Iqaluit","America/Jamaica","America/Juneau","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Kralendijk","America/La_Paz","America/Lima","America/Los_Angeles","America/Lower_Princes","America/Maceio","America/Managua","America/Manaus","America/Marigot","America/Martinique","America/Matamoros","America/Mazatlan","America/Menominee","America/Merida","America/Mexico_City","America/Miquelon","America/Moncton","America/Monterrey","America/Montevideo","America/Montserrat","America/Nassau","America/New_York","America/Nome","America/Noronha","America/North_Dakota/Beulah","America/North_Dakota/New_Salem","America/Ojinaga","America/Panama","America/Pangnirtung","America/Paramaribo","America/Phoenix","America/Port-au-Prince","America/Port_of_Spain","America/Porto_Velho","America/Puerto_Rico","America/Punta_Arenas","America/Rankin_Inlet","America/Recife","America/Regina","America/Rio_Branco","America/Santarem","America/Santiago","America/Santo_Domingo","America/Sao_Paulo","America/Scoresbysund","America/Sitka","America/St_Barthelemy","America/St_Johns","America/St_Kitts","America/St_Lucia","America/St_Thomas","America/St_Vincent","America/Tegucigalpa","America/Thule","America/Thunder_Bay","America/Tijuana","America/Toronto","America/Tortola","America/Vancouver","America/Whitehorse","America/Winnipeg","America/Yakutat","America/Yellowknife","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Macquarie","Antarctica/Mawson","Antarctica/McMurdo","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","Arctic/Longyearbyen","Asia/Aden","Asia/Almaty","Asia/Amman","Asia/Anadyr","Asia/Aqtau","Asia/Aqtobe","Asia/Ashgabat","Asia/Atyrau","Asia/Baghdad","Asia/Bahrain","Asia/Baku","Asia/Bangkok","Asia/Barnaul","Asia/Beirut","Asia/Bishkek","Asia/Brunei","Asia/Chita","Asia/Choibalsan","Asia/Colombo","Asia/Damascus","Asia/Dhaka","Asia/Dili","Asia/Dubai","Asia/Dushanbe","Asia/Famagusta","Asia/Gaza","Asia/Hebron","Asia/Ho_Chi_Minh","Asia/Hong_Kong","Asia/Hovd","Asia/Irkutsk","Asia/Jakarta","Asia/Jayapura","Asia/Jerusalem","Asia/Kabul","Asia/Kamchatka","Asia/Karachi","Asia/Kathmandu","Asia/Khandyga","Asia/Kolkata","Asia/Krasnoyarsk","Asia/Kuala_Lumpur","Asia/Kuching","Asia/Kuwait","Asia/Macau","Asia/Magadan","Asia/Makassar","Asia/Manila","Asia/Muscat","Asia/Nicosia","Asia/Novokuznetsk","Asia/Novosibirsk","Asia/Omsk","Asia/Oral","Asia/Phnom_Penh","Asia/Pontianak","Asia/Pyongyang","Asia/Qatar","Asia/Qostanay","Asia/Qyzylorda","Asia/Riyadh","Asia/Sakhalin","Asia/Samarkand","Asia/Seoul","Asia/Shanghai","Asia/Singapore","Asia/Srednekolymsk","Asia/Taipei","Asia/Tashkent","Asia/Tbilisi","Asia/Tehran","Asia/Thimphu","Asia/Tokyo","Asia/Tomsk","Asia/Ulaanbaatar","Asia/Urumqi","Asia/Ust-Nera","Asia/Vientiane","Asia/Vladivostok","Asia/Yakutsk","Asia/Yangon","Asia/Yekaterinburg","Asia/Yerevan","Atlantic/Azores","Atlantic/Bermuda","Atlantic/Canary","Atlantic/Cape_Verde","Atlantic/Faroe","Atlantic/Madeira","Atlantic/Reykjavik","Atlantic/South_Georgia","Atlantic/St_Helena","Atlantic/Stanley","Australia/Adelaide","Australia/Brisbane","Australia/Broken_Hill","Australia/Currie","Australia/Darwin","Australia/Eucla","Australia/Hobart","Australia/Lord_Howe","Australia/Melbourne","Australia/Perth","Australia/Sydney","Etc/GMT","Etc/GMT+1","Etc/GMT+10","Etc/GMT+11","Etc/GMT+12","Etc/GMT+2","Etc/GMT+3","Etc/GMT+4","Etc/GMT+5","Etc/GMT+6","Etc/GMT+7","Etc/GMT+8","Etc/GMT+9","Etc/GMT-1","Etc/GMT-10","Etc/GMT-11","Etc/GMT-12","Etc/GMT-2","Etc/GMT-3","Etc/GMT-4","Etc/GMT-5","Etc/GMT-6","Etc/GMT-7","Etc/GMT-8","Etc/GMT-9","Etc/UTC","Europe/Amsterdam","Europe/Andorra","Europe/Astrakhan","Europe/Athens","Europe/Belgrade","Europe/Berlin","Europe/Bratislava","Europe/Brussels","Europe/Bucharest","Europe/Budapest","Europe/Busingen","Europe/Chisinau","Europe/Copenhagen","Europe/Dublin","Europe/Gibraltar","Europe/Guernsey","Europe/Helsinki","Europe/Isle_of_Man","Europe/Istanbul","Europe/Jersey","Europe/Kaliningrad","Europe/Kiev","Europe/Kirov","Europe/Lisbon","Europe/Ljubljana","Europe/London","Europe/Luxembourg","Europe/Madrid","Europe/Malta","Europe/Mariehamn","Europe/Minsk","Europe/Monaco","Europe/Moscow","Europe/Oslo","Europe/Paris","Europe/Podgorica","Europe/Prague","Europe/Riga","Europe/Rome","Europe/Samara","Europe/San_Marino","Europe/Sarajevo","Europe/Saratov","Europe/Simferopol","Europe/Skopje","Europe/Sofia","Europe/Stockholm","Europe/Tallinn","Europe/Tirane","Europe/Ulyanovsk","Europe/Uzhgorod","Europe/Vaduz","Europe/Vienna","Europe/Vilnius","Europe/Volgograd","Europe/Warsaw","Europe/Zagreb","Europe/Zaporozhye","Europe/Zurich","Indian/Antananarivo","Indian/Chagos","Indian/Christmas","Indian/Cocos","Indian/Comoro","Indian/Kerguelen","Indian/Mahe","Indian/Maldives","Indian/Mauritius","Indian/Mayotte","Indian/Reunion","Pacific/Apia","Pacific/Auckland","Pacific/Bougainville","Pacific/Chatham","Pacific/Chuuk","Pacific/Easter","Pacific/Efate","Pacific/Enderbury","Pacific/Fakaofo","Pacific/Fiji","Pacific/Funafuti","Pacific/Galapagos","Pacific/Gambier","Pacific/Guadalcanal","Pacific/Guam","Pacific/Honolulu","Pacific/Kiritimati","Pacific/Kosrae","Pacific/Kwajalein","Pacific/Majuro","Pacific/Marquesas","Pacific/Midway","Pacific/Nauru","Pacific/Niue","Pacific/Norfolk","Pacific/Noumea","Pacific/Pago_Pago","Pacific/Palau","Pacific/Pitcairn","Pacific/Pohnpei","Pacific/Port_Moresby","Pacific/Rarotonga","Pacific/Saipan","Pacific/Tahiti","Pacific/Tarawa","Pacific/Tongatapu","Pacific/Wake","Pacific/Wallis"];if(t=+t,!(-90<=(e=+e)&&e<=90&&-180<=t&&t<=180))throw new RangeError("invalid coordinates");if(90<=e)return"Etc/GMT";var o=-1,i=48*(180+t)/360.00000000000006,a=24*(90-e)/180.00000000000003,s=0|i,l=0|a,c=96*l+2*s;for(c=56*r.charCodeAt(c)+r.charCodeAt(c+1)-1995;c+n.length<3136;)c=56*r.charCodeAt(c=8*(o=o+c+1)+4*(l=0|(a=2*(a-l)%2))+2*(s=0|(i=2*(i-s)%2))+2304)+r.charCodeAt(c+1)-1995;return n[c+n.length-3136]}typeof e0!="undefined"&&(e0.exports=vX)});var up=T(oe()),T1=T(k()),w1=(0,up.createContext)({appearance:"purchase-master"});function Oe(){return(0,up.useContext)(w1)}function Mn({appearance:e,stepKey:t,view:r,children:n}){let o=Oe();return(0,T1.jsx)(w1.Provider,{value:{appearance:e!=null?e:o.appearance,stepKey:t!=null?t:o.stepKey,view:r!=null?r:o.view},children:n})}var zu=T(PS());function Le(e){return String(e||"").split("/").pop()||""}function ne(e){return e&&(e.label||e.value)&&(e.label||e.value)||""}function Fe(e,t){let r=_d(t);return(e||[]).find(n=>n&&[n.value,n.label].map(_d).includes(r))}function Xe(e,t=800){var n;let r=String(e||"").trim();if(!r)return"";try{let o=typeof window!="undefined"&&((n=window.location)!=null&&n.origin)?window.location.origin:"https://trufitcustoms.com",i=new URL(r,o);if(i.hostname==="cdn.sanity.io"){let a=Math.max(800,Number(t)||0),s=Number(i.searchParams.get("w")||0);return(!s||s>a)&&i.searchParams.set("w",String(a)),i.searchParams.set("fit","max"),i.searchParams.set("auto","format"),i.searchParams.has("q")||i.searchParams.set("q","80"),i.toString()}if(i.hostname.includes("shopify")||i.searchParams.has("width")){let a=Number(i.searchParams.get("width")||0),s=Math.max(800,Number(t)||0);return(!a||a<s)&&i.searchParams.set("width",String(s)),i.toString()}}catch(o){return r}return r}var XV="https://cdn.sanity.io/images/";function Uo(e){if(typeof e=="string"){if(e.startsWith(XV))return Xe(e,1e3)||e;let t=e.trim();if(e.includes("cdn.sanity.io/images/")&&(t.startsWith("{")||t.startsWith("[")))try{return JSON.stringify(Uo(JSON.parse(t)))}catch(r){return e}return e}if(Array.isArray(e))return e.map(t=>Uo(t));if(e&&typeof e=="object"){let t={};return Object.entries(e).forEach(([r,n])=>{t[r]=Uo(n)}),t}return e}function Ge(e){return Array.isArray(e)&&e.length>0}function Bd(e,t){var o;let r=t.map(_d),n=(e||[]).find(i=>[i.value,i.label].map(_d).some(s=>r.includes(s)));return String((n==null?void 0:n.value)||((o=e==null?void 0:e[0])==null?void 0:o.value)||"")}function Io(e){return e&&(e.imageUrl||e.thumbnailUrl||e.sizeImageUrl||e.bannerImageUrl)||""}function us(e){return typeof e=="string"?Boolean(e.trim()):Array.isArray(e)?e.length>0:Boolean(e&&typeof e=="object")}function QC(e){return e?Io(e)||us(e.image)||us(e.images)?!0:qC(e).some(t=>us(t.imageUrl)||us(t.thumbnailUrl)||us(t.images)||us(t.splittedImageUrls)||us(t.splitImageUrls)):!1}function _d(e){return String(e||"").trim().toLowerCase()}function jC(e){return String(e||"").split(",").map(t=>t.trim()).filter(Boolean)}function Vm(e){return jC(e).map(_d).filter(Boolean)}function HC(e){return e.impressionTypeSlug||e.impressionType||e.position||e.value||""}function km(e){let t=new Set;return e.forEach(r=>{if(r==="dual"||r==="both"||r==="upper-lower"){t.add("upper"),t.add("lower");return}t.add(r)}),t}function NV(e,t){let r=Vm(e),n=Vm(t);if(!r.length||!n.length)return!1;let o=km(r),i=km(n);return o.size!==i.size?!1:Array.from(o).every(a=>i.has(a))}function EV(e,t){let r=Vm(e),n=Vm(t);if(!r.length||!n.length)return!1;let o=km(r),i=km(n);return Array.from(o).some(a=>i.has(a))}function qC(e){if(!(e!=null&&e.imagesByImpressionTypeJson))return[];try{let t=JSON.parse(e.imagesByImpressionTypeJson);return Array.isArray(t)?t:[]}catch(t){return[]}}function JC(e,t){let r=qC(e);return r.find(o=>NV(HC(o),t))||r.find(o=>EV(HC(o),t))||r[0]||null}function WS(e,t){let r=JC(e,t);return r&&(r.imageUrl||r.thumbnailUrl)||""}function AV(e,t){let r=JC(e,t),n=r?r.splittedImageUrls||r.splitImageUrls||r.images:[];return Array.isArray(n)?n.filter(Boolean):[]}function Zd(e,t){return WS(e,t)||Io(e)}function eP(e,t,r){let n=jC(t),i=(n.length>1?n:n[0]?[n[0],n[0],n[0]]:[]).map((a,s)=>{let l=Fe(e,a);return AV(l,r)[s]||""}).filter(Boolean);return i.length?i:n.map(a=>Zd(Fe(e,a),r)).filter(Boolean)}function Nl(e){return!!e&&typeof e=="object"&&!Array.isArray(e)}function Xm(){if(typeof window=="undefined")return null;let e=window.TrufitTypedPriceConversion;if(!Nl(e))return null;let t=Number(e.rate),r=String(e.currency||"").toUpperCase(),n=String(e.sourceCurrency||"USD").toUpperCase();return!r||!Number.isFinite(t)||!(t>0)||r===n?null:{currency:r,sourceCurrency:n,rate:t}}function Lm(e,t){return!Number.isFinite(e)||!(e>0)?e:Math.ceil(e*t-1e-9)}var RV=/^\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/,GV=/\$\s?((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)(?![\d,])/g,_V=/^(?:https?:)?\/\//i,BV=/price(?:s)?$/i,ZV=/^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?$/;function vS(e){return Number(e.replace(/,/g,""))}function tP(e){return"$"+(Number.isInteger(e)?String(e):e.toFixed(2))}function $V(e,t){let r=e.trim();if(r.indexOf("$")===-1||_V.test(r))return e;if(RV.test(r)){let n=vS(r.replace(/^\$\s?/,""));return Number.isFinite(n)?tP(Lm(n,t)):e}return e.replace(GV,(n,o)=>{let i=vS(o);return Number.isFinite(i)?tP(Lm(i,t)):n})}var OV=["variantPrice","variantPriceCents","compareAtPrice","compareAtPriceCents","price","priceCents","productVariants","impressionKitProductVariants","initials","currentProduct","catalogProducts","stepProducts","recommendations"];function ps(e,t,r=!1){let n=(o,i,a)=>{if(typeof o=="string"){let s=o.trim();if(BV.test(i)&&ZV.test(s)){let l=vS(s);return Number.isFinite(l)?String(Lm(l,t)):o}return $V(o,t)}if(typeof o=="number")return/Cents$/.test(i)&&Number.isFinite(o)&&o>0?Math.round(Lm(o/100,t)*100):o;if(Array.isArray(o))return o.map(s=>n(s,i,a+1));if(Nl(o)){let s={};for(let l of Object.keys(o)){let c=o[l];s[l]=a===0&&r&&OV.indexOf(l)!==-1?c:n(c,l,a+1)}return s}return o};return n(e,"",0)}function wS(e,t){if(!Nl(e))return e;let r={...e};for(let n of["purchaseMasterOptions","pricingPalette","newCustomerOffer","bundlePackages","bundleImpressionKitProduct","impressionKitProduct"])(Nl(e[n])||Array.isArray(e[n]))&&(r[n]=ps(e[n],t));return r}function rP(e,t){let r={...e};return"global"in e||"product"in e?(Nl(e.global)&&(r.global=ps(e.global,t)),Nl(e.product)&&(r.product=ps(e.product,t))):Object.assign(r,ps(e,t,!0)),Array.isArray(e.catalogProducts)&&(r.catalogProducts=e.catalogProducts.map(n=>wS(n,t))),r}function El(e){return Boolean(e)&&typeof e=="object"&&!Array.isArray(e)}function nP(e){return El(e)}function oP(e){let t=El(e.impressionKitProduct)?e.impressionKitProduct:void 0,r=El(e.bundleImpressionKitProduct)?e.bundleImpressionKitProduct:void 0;return(o=>Boolean(String((o==null?void 0:o.variantGid)||(o==null?void 0:o.productGid)||(o==null?void 0:o.productHandle)||"").trim()))(t)?t:r||t||{}}function FV(e){return String(e||"").trim().toLowerCase().replace(/_/g,"-")==="clinic"?"clinic":"impression-kit"}function iP(){return typeof window=="undefined"?"":new URLSearchParams(window.location.search).get("flow")||""}function aP({configuredFlow:e,datasetFlow:t,queryFlow:r}){let o=[r,e,t].find(i=>["clinic","impression-kit","impression_kit"].includes(String(i||"").trim().toLowerCase()));return FV(o)}function $d(e){let t=e.querySelector("[data-purchase-master-config]"),r=null;if(!t)return null;try{r=Uo(JSON.parse(t.textContent||"{}"))}catch(g){return null}if(!El(r))return null;let n=Xm();n&&Object.assign(r,rP(r,n.rate));let o=Number(r.discountNowEpoch),i=Number.isFinite(o)?o:void 0,a=i?Date.now()/1e3:void 0,s={newCustomerCardImageUrl:e.dataset.newCustomerCardImageUrl||"",newCustomerModalImageUrl:e.dataset.newCustomerModalImageUrl||"",newCustomerCloseIconUrl:e.dataset.newCustomerCloseIconUrl||"",newCustomerCheckIconUrl:e.dataset.newCustomerCheckIconUrl||"",selectChevronIconUrl:e.dataset.selectChevronIconUrl||"",bundleTrashIconUrl:e.dataset.bundleTrashIconUrl||"",bundleWarningIconUrl:e.dataset.bundleWarningIconUrl||"",bundleGuardIconUrl:e.dataset.bundleGuardIconUrl||"",bundleDowngradeArrowIconUrl:e.dataset.bundleDowngradeArrowIconUrl||"",recommendedBadgeUrl:e.dataset.recommendedBadgeUrl||"",upsellStarsIconUrl:e.dataset.upsellStarsIconUrl||"",quantityMinusIconUrl:e.dataset.quantityMinusIconUrl||"",quantityDisabledMinusIconUrl:e.dataset.quantityDisabledMinusIconUrl||"",quantityPlusIconUrl:e.dataset.quantityPlusIconUrl||"",backIconUrl:e.dataset.backIconUrl||"",closeIconUrl:e.dataset.closeIconUrl||"",clinicApiUrl:e.dataset.clinicApiUrl||"",googleMapsApiKey:e.dataset.googleMapsApiKey||""};if(!("global"in r)&&!("product"in r)){let g=oP(r);return{...r,impressionKitProduct:g,bundleImpressionKitProduct:g,purchaseMasterFlow:aP({queryFlow:iP(),configuredFlow:r.purchaseMasterFlow,datasetFlow:e.dataset.purchaseMasterFlow}),...s,discountNowEpoch:i,discountNowCapturedAtEpoch:a}}let l=nP(r.global)?r.global:{},c=nP(r.product)?r.product:{},d=oP({...l,...c}),u=Array.isArray(r.productVariants)?r.productVariants:Array.isArray(c.productVariants)?c.productVariants:[],p=Array.isArray(r.impressionKitProductVariants)?r.impressionKitProductVariants:Array.isArray(c.impressionKitProductVariants)?c.impressionKitProductVariants:[],m=Array.isArray(r.stepProducts)?r.stepProducts:null;return{...l,...c,impressionKitProduct:d,bundleImpressionKitProduct:d,initials:El(r.initials)?r.initials:c.initials||l.initials,purchaseMasterFlow:aP({queryFlow:iP(),configuredFlow:c.purchaseMasterFlow,datasetFlow:e.dataset.purchaseMasterFlow}),...s,discountNowEpoch:i,discountNowCapturedAtEpoch:a,currentProduct:El(r.currentProduct)?r.currentProduct:c.currentProduct,catalogProducts:Array.isArray(r.catalogProducts)?r.catalogProducts:[],productVariants:u,impressionKitProductVariants:p,stepsImages:Array.isArray(l.stepsImages)?l.stepsImages:[],stepsRecommendedProducts:m||(Array.isArray(l.stepsRecommendedProducts)?l.stepsRecommendedProducts:[]),stepSettings:Array.isArray(l.stepSettings)?l.stepSettings:[],bundleTierUpsellProducts:Array.isArray(l.bundleTierUpsellProducts)?l.bundleTierUpsellProducts:[],showBundleTierUpsellOnLastPassOnly:l.showBundleTierUpsellOnLastPassOnly!==!1}}var Be=T(oe()),fM=T(ua());var sP=T(oe());function lP({form:e,onSubmit:t}){(0,sP.useEffect)(()=>{let r=n=>{n.preventDefault(),t()};return e.addEventListener("submit",r),()=>{e.removeEventListener("submit",r)}},[e,t])}var Em=T(oe()),Od="data-trufit-purchase-master-open",TS="usercentrics-cmp-ui",MS="data-trufit-purchase-master-visibility-style",Al=new Set,US=new Set,Rl=null,Vo=null,ms=null,Nm=!1;function IS(e){[document.documentElement,document.body].filter(r=>r instanceof HTMLElement).forEach(r=>{e?r.setAttribute(Od,""):r.removeAttribute(Od)})}function cP(e){var t,r;e.removeAttribute(Od),(r=(t=e.shadowRoot)==null?void 0:t.querySelector(`style[${MS}]`))==null||r.remove()}function dP(e){let t=e.shadowRoot;if(!t)return;let r=t.querySelector(`style[${MS}]`);r||(r=document.createElement("style"),r.setAttribute(MS,""),r.textContent=`
      :host([${Od}]) #uc-privacy-button {
        display: none !important;
      }
    `,t.appendChild(r)),e.setAttribute(Od,""),US.add(e)}function DV(e){return e instanceof Element?e.id===TS||Boolean(e.querySelector(`#${TS}`)):!1}function zV(e){e!==ms&&(Vo==null||Vo.disconnect(),Vo=null,ms=e,e!=null&&e.shadowRoot&&(Vo=new MutationObserver(()=>{Al.size>0&&ms===e&&dP(e)}),Vo.observe(e.shadowRoot,{childList:!0,subtree:!0})))}function VS(){let e=document.getElementById(TS);ms&&ms!==e&&cP(ms),zV(e),e&&dP(e)}function KV(){Nm||(Nm=!0,Promise.resolve().then(()=>{Nm=!1,Al.size>0&&VS()}))}function HV(){VS();let e=document.body;e&&(Rl=new MutationObserver(t=>{t.some(r=>[...r.addedNodes,...r.removedNodes].some(DV))&&KV()}),Rl.observe(e,{childList:!0,subtree:!0}))}function QV(){Rl==null||Rl.disconnect(),Rl=null,Vo==null||Vo.disconnect(),Vo=null,ms=null,Nm=!1}function jV(){IS(!0),HV()}function qV(){QV(),US.forEach(cP),US.clear(),IS(!1)}function Am(e){let t=(0,Em.useRef)(null);t.current||(t.current={}),(0,Em.useEffect)(()=>{if(!e||!t.current)return;let r=t.current,n=Al.size===0;return Al.add(r),n?jV():(IS(!0),VS()),()=>{Al.delete(r),Al.size===0&&qV()}},[e])}function Gl(e,t){let r=t instanceof Error&&t.name?t.name:"UnknownError",n=t instanceof Error&&t.message?`:${t.message.slice(0,120)}`:"",o=t&&typeof t=="object"&&typeof t.status=="number"?`:${t.status}`:"",i=t&&typeof t=="object"&&typeof t.operation=="string"?`:${t.operation}`:"",a=t&&typeof t=="object"&&typeof t.reason=="string"&&t.reason?`:${t.reason}`:"";console.warn(`TRUFIT cart mutation failed ${e} ${r}${i}${o}${n}${a}`)}var uP={purchaseMasterFlow:"__purchaseMasterFlow",position:"Position",strength:"Strength",edgeType:"Edge type",guardItemId:"__guardItemId",purchaseMasterItemRole:"__purchaseMasterItemRole",purchaseMasterAddonType:"__purchaseMasterAddonType",purchaseMasterPaidGuardAddon:"__purchaseMasterPaidGuardAddon",personCreatedAt:"__personCreatedAt"},uB=Object.keys(uP);function pP(e){return Array.isArray(e)?Object.fromEntries(e.map(t=>{var r,n;return Array.isArray(t)?[t[0],t[1]]:t&&typeof t=="object"?[(r=t.first)!=null?r:t.key,(n=t.last)!=null?n:t.value]:["",""]}).filter(([t])=>t!=null&&String(t)).map(([t,r])=>[String(t),String(r!=null?r:"")])):e&&typeof e=="object"?{...e}:{}}function JV(e){let t=String(e!=null?e:"");for(let r=0;r<2;r+=1){let n=t.replace(/&amp;(quot|#34|#x22);/gi,"&$1;").replace(/&quot;|&#34;|&#x22;/gi,'"').replace(/&#x5c;|&#92;/gi,"\\");if(n===t)break;t=n}return t}function mP(e){let t=String(e!=null?e:"");if(!t)return null;for(let r=0;r<2;r++){let n=r===0?t:JV(t);try{let o=JSON.parse(n);if((o==null?void 0:o.purchaseMaster)===1&&o.selections&&typeof o.selections=="object"&&!Array.isArray(o.selections))return o}catch(o){}if(!t.includes("&"))break}return null}function lr(e={}){let t=pP(e),r=mP(t.__bundlePayload);return r?{...t,__bundlePayload:JSON.stringify(r)}:t}function ko(e={}){if(e=pP(e),e.__purchaseMasterSource!=="online-store")return e;let t=e.__purchaseMasterVariantModel==="shop-v2"||e.__bundleTransform==="shop-v2",r=lr(e);t?r.__bundleTransform="shop-v2":delete r.__bundleTransform;let n=mP(r.__bundlePayload),o={...(n==null?void 0:n.selections)||{}};for(let[i,a]of Object.entries(uP)){if(!Object.hasOwn(r,a))continue;let s=String(r[a]||"");s?o[i]=s:delete o[i]}return{...r,__bundlePayload:JSON.stringify({purchaseMaster:1,selections:o})}}function he(e){let t=lr(e.properties),r=t.__personId||t.__purchaseMasterPersonId||"",n=t.__itemId||t.__purchaseMasterItemId||"",o=t.__parentItemId||"",i=String(t.__category||t.__purchaseMasterCategory||"").replace(/\s+/g,"").toLowerCase(),a=Boolean(o||["extraproducts","impressionkits"].includes(i));return{properties:t,personId:r,itemId:n,parentItemId:o,category:i,isChild:a,isPurchaseMaster:t.__purchaseMasterSource==="online-store",rootKey:JSON.stringify([r,o||n])}}function bt(e){var n;let{properties:t,isPurchaseMaster:r}=he(e);return r&&Boolean(e.has_components||((n=e.item_components)==null?void 0:n.length)||t.__purchaseMasterBundle==="true"&&!t.__personId&&!t.__itemId)}function fs(e){let{properties:t,isPurchaseMaster:r,parentItemId:n}=he(e),o=String(t.__purchaseMasterItemRole||"").trim();return Boolean(r&&!n&&(t.__purchaseMasterVariantModel==="shop-v2"||t.__bundleTransform==="shop-v2")&&!o)}function cr(e){if(fs(e)&&!bt(e))return!1;if(!bt(e))return!0;let t=he(e),r=e.item_components;if(!(r!=null&&r.length)||!t.personId||!t.itemId)return!1;let n=new Set,o=0;for(let i of r){let a=he(i);if(!i.key||n.has(i.key)||!i.variant_id||!Number.isSafeInteger(i.quantity)||i.quantity<=0||bt(i)||!a.isPurchaseMaster||a.personId!==t.personId||a.rootKey!==t.rootKey)return!1;n.add(i.key),a.isChild||o++}return o===1}function xe(e){return e.items.flatMap(t=>bt(t)&&!cr(t)?[]:(bt(t)?t.item_components:[t]).map(n=>({...n,properties:lr(n.properties)})))}function dt(e,t={}){return JSON.stringify([String(e),Object.entries(lr(t)).sort(([r],[n])=>r.localeCompare(n))])}function ek(){var r;if(typeof document=="undefined")return"";let e=document.querySelector("[data-purchase-master-cart-snapshot]");return((r=e==null?void 0:e.closest("[id^='shopify-section-']"))==null?void 0:r.id.replace(/^shopify-section-/,"").trim())||""}function hP(e,t){let r=e.purchaseMasterReceiptItems||e.purchaseMasterSnapshotItems||e.items;if(r.length!==t.items.length||new Set(r.map(o=>o.key)).size!==r.length)return!1;let n=new Map(t.items.map(o=>[o.key,o]));return n.size!==t.items.length?!1:r.every(o=>{let i=n.get(o.key);return Boolean(i&&String(i.variant_id)===String(o.variant_id)&&i.quantity===o.quantity)})}function kS(e){if(!e||typeof e!="object"||!Array.isArray(e.items))throw new Error("Invalid cart response.");return e}async function gP(e,t,r={}){let n=kS(await t.json());if(r.allowRenderedFallback===!1)return n;let o=n.sections,i=o?Object.values(o).find(l=>typeof l=="string"&&l.includes("data-purchase-master-cart-snapshot")):void 0,a=n.items.some(fs)||!n.items.every(cr);if(i&&a){let l=YP(i);if(!hP(n,l))throw new Error("Rendered cart snapshot does not match the latest cart.");return{...l,...n,items:l.items,sections:o}}if(r.preferCartRead){let l=await _l(e);return o?{...l,sections:o}:l}if(!r.forceRendered&&!n.items.some(fs)&&n.items.every(cr))return n;let s=await _l(e,{forceRendered:!0});return o?{...s,sections:o}:s}function YP(e){let t=e.match(/<script\b[^>]*\bdata-purchase-master-cart-snapshot\b[^>]*>([\s\S]*?)<\/script>/i);if(!t)throw new Error("Cart bundle details could not be loaded. Please refresh the cart.");return LS(JSON.parse(t[1]))}function LS(e){if(!e||typeof e!="object")throw new Error("Invalid cart bundle details.");let t=e,r=kS(t.cart);if(!Array.isArray(t.components))throw new Error("Invalid cart bundle details.");if(!Array.isArray(t.mergedKeys))throw new Error("Invalid cart bundle details.");let n=t.mergedKeys.map(s=>String(s||"").trim());if(n.some(s=>!s)||new Set(n).size!==n.length)throw new Error("Invalid cart bundle details.");let o=new Set(n),i=new Map;for(let s of t.components){let l=String((s==null?void 0:s.key)||"").trim();if(!l||i.has(l)||!Array.isArray(s==null?void 0:s.items))throw new Error("Cart bundle details could not be confirmed.");i.set(l,s.items)}let a=new Set(r.items.map(s=>s.key));if(n.some(s=>!a.has(s))||[...i.keys()].some(s=>!a.has(s))||i.size!==o.size||[...i.keys()].some(s=>!o.has(s)))throw new Error("Cart bundle details could not be confirmed.");return{...r,items:r.items.map(s=>{let l=o.has(s.key),c=bt(s);if(!l&&!c)return s;let d=i.get(s.key);if(!l&&d===void 0)throw new Error("Cart bundle details could not be confirmed.");let u={...s,has_components:!0,item_components:d};if(!cr(u))throw new Error("Cart bundle details could not be confirmed.");return u})}}async function fP(e){let t=ek(),r=new URLSearchParams({_trufit_cart_revision:String(Date.now())});t&&r.set("section_id",t);let n=await e(`cart?${r.toString()}`,{headers:{Accept:"text/html"},cache:"no-store"});if(!n.ok)throw new Error("Cart bundle details could not be loaded. Please retry.");return YP(await n.text())}async function _l(e,t={}){if(t.forceRendered)return fP(e);let r=await e("cart.js",{headers:{Accept:"application/json"},cache:"no-store"});if(!r.ok)throw new Error("Cart could not be loaded.");let n=kS(await r.json());if(!n.items.some(fs)&&n.items.every(cr))return n;let o=await fP(e);if(!hP(n,o))throw new Error("Rendered cart snapshot does not match the latest cart.");return{...o,...n,items:o.items}}var XS=globalThis,xi=XS.__trufitCartQueue||(XS.__trufitCartQueue={queue:Promise.resolve(),pending:0});var yP=e=>Boolean(e&&xi.activeToken===e);var mn=class extends Error{constructor(){super("We could not confirm the cart update. Please retry to check its status."),this.name="UncertainCartMutationError"}},Fd=class extends Error{constructor(r){super(`Cart ${r} was committed; the latest cart state is being refreshed.`);this.operation=r;this.name="CartMutationCommittedError"}},Lo=class extends Error{constructor(r,n,o=""){super(`Cart ${r} failed.`);this.operation=r;this.status=n;this.reason=o;this.name="CartMutationRejectedError"}};async function tk(e){try{let t=await e.clone().json(),r=[t.message,t.description,t.errors].find(n=>typeof n=="string"&&n.trim());return typeof r=="string"?r.replace(/[\u0000-\u001f\u007f]/g," ").trim().slice(0,160):""}catch(t){return""}}function hs(e,t){if(t&&xi.activeToken===t)return e();let r=()=>typeof navigator!="undefined"&&navigator.locks?navigator.locks.request("trufit-cart-mutation",e):e();xi.pending++;let n=xi.queue.then(r,r).finally(()=>{xi.pending--});return xi.queue=n.then(()=>{},()=>{}),n}function Dd(e){let t=Symbol("trufit-cart-mutation");return hs(async()=>{xi.activeToken=t;try{return await e(t)}finally{xi.activeToken===t&&(xi.activeToken=void 0)}})}async function Dr(e,t={}){let r=await _l(e,t);return{...r,items:xe(r),purchaseMasterSnapshotItems:r.items,purchaseMasterTransformSummaries:r.items.filter(n=>bt(n)&&cr(n))}}async function Gm(e,t,r={}){let n=await gP(e,t,r),o=n.items.filter(i=>bt(i)&&cr(i));return r.allowRenderedFallback===!1?{...n,purchaseMasterTransformSummaries:o}:{...n,items:xe(n),purchaseMasterSnapshotItems:n.items,purchaseMasterTransformSummaries:o}}function rk(e){let t=e.map(n=>({...n,properties:ko(n.properties)})),r=new Set(t.map(n=>String(n.properties.__itemId||"").trim()).filter(Boolean));return t.some(n=>{let o=n.properties,i=String(o.__purchaseMasterItemRole||""),a=String(o.__parentItemId||"").trim();return Boolean(o.__purchaseMasterSource==="online-store"&&a&&!r.has(a)&&(i==="cart-addon-product"||i==="id-tag"||i==="edge-type"))})}function Rm(e,t){return Dr(e,{forceRendered:rk(t)})}function pa(e){return ES(e,dt)}var nk=new Set(["__bundlePayload","__bundleTargetPrice","__bundleTargetIncludesExtras","__bundleCompareAtPrice","__bundlePriceAdjustment","__newCustomerDiscountPercent","__bundleImageUrl","Bundle plan","Bundle add-on"]);function SP(e,t={}){let r=lr(t),n=String(r.__personId||"").trim(),o=String(r.__itemId||"").trim();if(r.__purchaseMasterSource!=="online-store"||!n||!o)return dt(e,r);let i=Object.entries(r).filter(([a])=>!nk.has(a));return JSON.stringify([String(e),i.sort(([a],[s])=>a.localeCompare(s))])}function ES(e,t){let r=new Map;for(let n of e){let o=t("variant_id"in n?n.variant_id:n.id,n.properties);r.set(o,(r.get(o)||0)+n.quantity)}return r}function NS(e,t){let r=xe(e),n=pa(r);if([...pa(t)].every(([s,l])=>n.get(s)===l))return!0;let i=ES(r,SP);return[...ES(t,SP)].every(([s,l])=>i.get(s)===l)}async function ok(e,t,r){let n=pa(r),o=xe(t).filter(a=>n.has(dt(a.variant_id,a.properties)));if(o.some(a=>a.quantity!==n.get(dt(a.variant_id,a.properties)))||o.length&&!(await e("cart/update.js",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify({updates:Object.fromEntries(o.map(s=>[s.key,0]))})})).ok)return!1;let i=pa(xe(await Rm(e,r)));return[...n.keys()].every(a=>!i.has(a))}async function _m(e,t,r,n,o,i={}){let a=i.confirm!==!1;return t=t.map(s=>({...s,properties:ko(s.properties)})),hs(async()=>{let s=n&&o?o:a?await Rm(e,t):await Dr(e);if(r.sent){if(NS(s,t))return s;throw new mn}let l=pa(xe(s));if([...pa(t).keys()].some(u=>l.has(u)))throw new Error("This cart attempt already exists. Reload the cart before adding again.");r.sent=!0;let c=!1,d=!1;try{let u=await e("cart/add.js",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify({items:t})});if(!u.ok)throw d=u.status>=400&&u.status<500,new Lo("addition",u.status,await tk(u));if(c=!0,!a)return s;let p=await Rm(e,t);if(!NS(p,t))throw new mn;return p}catch(u){let p=!1;try{let m=await Rm(e,t);if(NS(m,t))return m;let g=pa(xe(m));d&&(![...pa(t).keys()].some(y=>g.has(y))||await ok(e,m,t))&&(r.sent=!1)}catch(m){p=!0}throw c&&p?new Fd("addition"):r.sent?new mn:u}},n)}var pe=T(oe());var ik=/^\$\s*/,ak=/^(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/,sk=/,/g;function bi(e){if(typeof e=="number")return Number.isSafeInteger(Math.round(e*100))&&e>=0&&Math.abs(e*100-Math.round(e*100))<1e-6?Math.round(e*100):null;let t=String(e!=null?e:"").trim().replace(ik,"");if(!ak.test(t))return null;let r=Number(t.replace(sk,""));return Number.isSafeInteger(Math.round(r*100))?Math.round(r*100):null}function xP(e,t){var n;let r=0;for(let[o,i]of Object.entries(t)){if(!i)continue;let a=((e==null?void 0:e[o])||[]).find(l=>l.value===i||l.label===i);if(o==="positions"&&String((a==null?void 0:a.productVariantIds)||"").trim()||!a||!String((n=a.priceAdjustment)!=null?n:"").trim())continue;let s=bi(a.priceAdjustment);if(s===null)return null;r+=s}return r}function Bm(e,t){let r=xP(e,{positions:t.position,strengths:t.strength,edgeTypes:t.edgeType});if(r===null)throw new Error("Selected option price is unavailable.");return r/100}function AS(e){let t=Number(e);if(!Number.isFinite(t))return String(e);let n=Math.round((t+Number.EPSILON)*100)/100;return Number.isInteger(n)?String(n):n.toFixed(2)}var lk=["in-practice","in practice","clinic scan","scan session"],zd=e=>{let t=[e.productHandle,e.productTitle].filter(Boolean).join(" ").toLowerCase();return lk.some(r=>t.includes(r))};var ck=50;function Kd(e){let t=String(e||"").replace(/,/g,"").match(/-?\d+(?:\.\d+)?/);return t?Number(t[0]):0}function RS({baseGuardPrice:e,guardQuantity:t,impressionKitPrice:r}){return Math.max(0,e)*Math.max(1,t)+Math.max(0,r||0)}function bP(e){return Kd(e==null?void 0:e.variantPrice)}function Hd({configuredPrice:e,product:t}){if(String(e||"").trim())return Math.max(0,Kd(e));let r=Math.max(0,bP(t));return r>0?r:ck}function CP(e){return(Array.isArray(e)?e:[]).reduce((t,r)=>t+bP(r)*Math.max(1,Number(r.quantity)||1),0)}function PP(e){return String(e||"").split(",")[0].trim()}function se(e){if(e==null||!String(e).trim())return 0;let t=bi(e);if(t===null)throw new Error("Invalid price. Reload the product to get its current price.");return t/100}function fn(e){return Number.isSafeInteger(e==null?void 0:e.priceCents)&&Number(e==null?void 0:e.priceCents)>=0?Number(e==null?void 0:e.priceCents)/100:se(e==null?void 0:e.price)}function gs(e){return fn({priceCents:e==null?void 0:e.variantPriceCents,price:e==null?void 0:e.variantPrice})}function we(e,t){var r=AS(e);return String(t||"").indexOf("$")!==-1?"$"+r:r}function zr(e){var t=PP(e&&e.variantPrices)||PP(e&&e.variantLabels),r=t.match(/\$\s?\d+(?:\.\d{1,2})?/);return r?r[0].replace(/\s+/g,""):!t||t.toLowerCase()==="default title"?"":t}function Bl(e){var t=zr(e);return t?"+"+we(se(t.replace(/^\+/,"")),"$"):""}function WP({basePrice:e,impressionKitPrice:t,initialsPrice:r,initialsValue:n,initialsCount:o,newCustomerPrice:i,optionPrice:a,upsellPrice:s}){let l=Number.isFinite(o)?Math.max(0,o||0):n?1:0,c=se(e)+se(t)+l*se(r)+(i||0)+(a||0)+(s||0);return we(c,e)}var dk=new Set(["guard","bundle"]);function Zl(e){let t=Number(e);return Number.isFinite(t)&&t>0&&t<=100?t:0}function GS(e){return Array.isArray(e)?e.map(t=>String(t||"").trim()).filter(Boolean):[]}function uk(e){let t=new Set;return e.flatMap(r=>Array.isArray(r)?GS(r):[r]).map(r=>String(r||"").trim()).filter(r=>!r||t.has(r)?!1:(t.add(r),!0))}function $l(e){return String((e==null?void 0:e.discountLabel)||"").trim()}function Zm(e){return String((e==null?void 0:e.cardImageUrl)||"").trim()}function $m(e){return GS(e==null?void 0:e.modalImageUrls)}function Om(e){let t=e&&"variantGid"in e?e.variantGid:void 0,r=e&&"handle"in e?e.handle:void 0;return[e==null?void 0:e.productGid,e==null?void 0:e.productHandle,r,t].flatMap(n=>{let o=String(n||"").trim().toLowerCase();return o?[o]:[]})}function pk(e,t){let r=new Set(Om(e));return Om(t).some(n=>r.has(n))}function mk(e,t){let r=new Set(Om(t));return(e.products||[]).flatMap(Om).some(o=>r.has(o))}function vP(e){var t;return(((t=e==null?void 0:e.discounts)==null?void 0:t.items)||[]).filter(r=>r.enabled!==!1&&r.type==="add-new-customer")}function wP(e){var t;return Array.isArray((t=e==null?void 0:e.discounts)==null?void 0:t.items)}function fk(e,t){return vP(e).find(r=>r.appliesTo==="products"&&mk(r,t))}function Dm(e,t){let r=vP(e).find(p=>p.appliesTo!=="products"),n=e?fk(e,t):void 0,o=e==null?void 0:e.newCustomerOffer,i=t==null?void 0:t.newCustomerOffer;if(wP(e)&&!r&&!n)return{discountPercent:0,discountLabel:"",cardImageUrl:"",modalImageUrls:[]};let a=Zl(n==null?void 0:n.discountPercent)||Zl(r==null?void 0:r.discountPercent)||Zl(i==null?void 0:i.discountPercent)||Zl(o==null?void 0:o.discountPercent),s=$l(n)||$l(r)||$l(i)||$l(o)||(a?`${a}%OFF`:""),l=$m(n),c=$m(r),d=$m(i),u=$m(o);return{discountPercent:a,discountLabel:s,cardImageUrl:Zm(n)||Zm(r)||Zm(i)||Zm(o),modalImageUrls:l.length?l:c.length?c:d.length?d:u}}function _S(e){return(e.stepsRecommendedProducts||[]).filter(t=>String(t.title||"").toLowerCase()==="upsell"&&dk.has(String(t.type||"").toLowerCase())).flatMap(t=>t.products||[])}function gn(e){var d,u;let t=_S(e),r=e.currentProduct,n=r!=null&&r.gid||r!=null&&r.handle?{productGid:r.gid,productTitle:r.title||"Sports Mouthguard",productHandle:r.handle,productImageUrl:r.imageUrl,variantGid:r.variantGid,variantPrice:r.variantPrice,compareAtPrice:r.compareAtPrice,discountLabel:((d=r.newCustomerOffer)==null?void 0:d.discountLabel)||r.discountLabel||"",discountPercent:((u=r.newCustomerOffer)==null?void 0:u.discountPercent)||r.discountPercent,newCustomerOffer:r.newCustomerOffer}:null,o=e.catalogProducts||[],i=o.length?o:t,s=(n?i.find(p=>pk(p,n)):void 0)||(o.length?void 0:n),l=[...s?[s]:[],...i],c=new Set;return l.filter((p,m)=>{let g=String(p.productHandle||p.productGid||p.variantGid||`new-customer-${m}`).trim().toLowerCase();return!g||c.has(g)||!yk(e,p)?!1:(c.add(g),!0)})}function hn(e,t=0){return e.variantGid||e.productGid||e.productHandle||`new-customer-${t}`}function BS(e,t){let r=String(t||"").trim().toLowerCase(),n=r?e.findIndex((o,i)=>[hn(o,i),o.productHandle,o.productGid,o.variantGid].some(a=>String(a||"").trim().toLowerCase()===r)):-1;return n>=0?hn(e[n],n):e.length?hn(e[0],0):""}function Ys(e,t){let r=gn(e);return r.find((n,o)=>hn(n,o)===t.newCustomerProductKey)||r[0]}function Ci(e,t){let r=Dm(t,e),n=Zl(r.discountPercent);if(n)return n;if(wP(t))return 0;let o=$l(r).match(/(\d+(?:\.\d+)?)\s*%/);return o?Zl(o[1]):0}function zm(e,t){let r=Dm(t,e),n=Ci(e,t);return $l(r)||(n?`${n}%OFF`:"")}function hk(e,t){return String(Dm(t,e).cardImageUrl||"").trim()}function Km(e,t){return uk([hk(e,t),e==null?void 0:e.productImageUrl,e==null?void 0:e.productImageUrls,t==null?void 0:t.newCustomerCardImageUrl])}function TP(e,t){return GS(Dm(t,e).modalImageUrls)}function MP(e,t="",r){let n=(e==null?void 0:e.variantPrice)||t,o=se(n),i=Ci(e,r);return o>0?we(o*(1-i/100),n):""}function UP(e){var t;return Boolean((t=e==null?void 0:e.bundlePackages)==null?void 0:t.length)}function Qd(e,t=1){let r=Number(e);return Number.isFinite(r)&&r>0?Math.floor(r):t}function IP(e){let t=Qd(e==null?void 0:e.iconCount),r=String((e==null?void 0:e.title)||"").trim().toLowerCase();return t>=4||r==="ultimate"}function ZS(e,t){let r=(t==null?void 0:t.bundlePackages)||[];return r.length?r:OS(e,t)?e.bundlePackages||[]:[]}function VP(e,t){return ZS(e,t).some(r=>Array.isArray(r.shopProducts)&&r.shopProducts.some(n=>String(n.role||n.variantRole||"").trim().toLowerCase()!=="impression-kit"))}function Fm(e){return String(e||"").trim().split("/").pop()||""}function gk(e,t){let r=[e.impressionKitProduct,e.bundleImpressionKitProduct,t==null?void 0:t.impressionKitProduct,t==null?void 0:t.bundleImpressionKitProduct],n=o=>Boolean(o&&String(o.variantGid||o.productGid||o.productHandle||"").trim());return r.find(o=>Boolean(o==null?void 0:o.variantGid))||r.find(n)}function kP(e,t,r){let n=Fm(r),i=[...(t==null?void 0:t.productVariants)||[],...(t==null?void 0:t.impressionKitProductVariants)||[],...e.productVariants||[],...e.impressionKitProductVariants||[]].find(s=>Fm(s.gid||s.id)===n);if(!i||i.available===!1||i.availableForSale===!1)return null;let a=fn(i);return Number.isFinite(a)&&a>=0?a:null}function LP(e){if(Number.isSafeInteger(e==null?void 0:e.variantPriceCents)){let n=Number(e==null?void 0:e.variantPriceCents);return n>=0?n/100:null}let t=String((e==null?void 0:e.variantPrice)||"").trim();if(!t)return null;let r=se(t);return Number.isFinite(r)&&r>=0?r:null}function Yk(e,t,r){var n;return(n=LP(r))!=null?n:kP(e,t,r.variantGid||"")}function Sk(e,t,r){var s;if(!Array.isArray(r.shopProducts)||!r.shopProducts.length)return null;let n=0,o=new Set;for(let l of r.shopProducts){if(String(l.role||l.variantRole||"").trim().toLowerCase()==="impression-kit")continue;let d=Fm(l.variantGid||"");if(d&&o.add(d),l.freeInBundle)continue;let u=Yk(e,t,l);if(u===null)return null;let p=Qd(l.quantity,1);n+=u*p}let i=gk(e,t),a=Fm((i==null?void 0:i.variantGid)||"");if(a&&!o.has(a)){let l=(s=LP(i))!=null?s:kP(e,t,a);if(l===null)return null;n+=l}return n>0?n:null}function XP(e,t,r,n){var c,d;let o=Sk(e,t,r);if(o!==null)return we(o,"$0");let i=String(r.price||r.compareAtPrice||"").trim();if(i)return i;let a=Qd(r.iconCount,n+1),s=(c=t==null?void 0:t.pricingPalette)==null?void 0:c.bundlePrices,l=(d=e.pricingPalette)==null?void 0:d.bundlePrices;return String(Array.isArray(s)&&s[a-1]||Array.isArray(l)&&l[a-1]||"").trim()}function yk(e,t){return ZS(e,t).some((r,n)=>!IP(r)&&se(XP(e,t,r,n))>0)}function xk(e,t){let r=String(e.title||"").trim();return/^\d+\s+guards?$/i.test(r)?r.replace(/\bguard\b/i,"Guard").replace(/\bguards\b/i,"Guards"):`${t} ${t===1?"Guard":"Guards"}`}function $S(e,t){let r=Ci(t,e);return ZS(e,t).filter(n=>!IP(n)).map((n,o)=>{let i=Qd(n.iconCount,o+1),a=XP(e,t,n,o),s=se(a),l=s>0?we(s*(1-r/100),a):"";return{compareAtPrice:a,discountPercent:r,price:l,quantity:i,title:xk(n,i)}}).filter(n=>n.price||n.compareAtPrice)}function Pi(e,t,r){let n=$S(e,t),o=r===void 0?void 0:Qd(r),i=(o?n.find(l=>l.quantity===o):void 0)||n[0];if(!i)return null;let a=i.compareAtPrice;return se(a)<=0?null:{compareAtPrice:a,discountPercent:i.discountPercent,price:i.price,quantity:i.quantity}}function NP(e,t,r){var n;return((n=Pi(e,t,r))==null?void 0:n.price)||""}function OS(e,t){let r=e.currentProduct;return!t||!r?!1:r.gid&&t.productGid===r.gid||r.variantGid&&t.variantGid===r.variantGid?!0:Boolean(r.handle&&t.productHandle===r.handle)}function Hm({config:e,currentProductPrice:t,fallbackPrice:r="",product:n}){if(OS(e,n)||UP(n)){let i=NP(e,n);if(i)return i;if(VP(e,n))return"";if(se(t)>0)return t||""}return MP(n,r,e)||""}function EP(e,t,r="",n=""){let o=Ys(e,t),i=OS(e,o)||UP(o);return se(n||(i?NP(e,o,t.newCustomerQuantity):"")||(VP(e,o)?"":MP(o,r,e)||(o==null?void 0:o.variantPrice)||r))*Math.max(0,Math.min(99,t.newCustomerQuantity||0))}var bk=/[^a-z0-9]/g;function Wi(e){let t=String(e||"").trim().toLowerCase().replace(bk,"");return{guards:"guard",custommouthguards:"guard",mouthguards:"guard",accessories:"accessory",impressionkits:"impressionkit",insoles:"insole",retainers:"retainer",whiteningtrays:"whiteningtray"}[t]||t}var Qm=e=>String(e||"").trim().toLowerCase();function AP(e=[]){return e.filter(t=>(t==null?void 0:t.type)==="guard-accessories"&&t.enabled!==!1).map(t=>({...t,discountPercent:Number(t.discountPercent),targetProductType:Wi(t.targetProductType)||"accessory"})).filter(t=>Number.isFinite(t.discountPercent)&&t.discountPercent>0&&t.discountPercent<=100)}function RP(e,t,r="web-client"){let n=e.filter(o=>Array.isArray(o.salesChannels)&&!o.salesChannels.includes(r)||Wi(t.productType)!==o.targetProductType?!1:o.appliesTo!=="products"||(o.products||[]).some(i=>i.productGid?Qm(i.productGid)===Qm(t.productGid):i.productHandle&&Qm(i.productHandle)===Qm(t.productHandle)));return n.find(o=>o.appliesTo==="products")||n[0]||null}function GP(e,t){let r=ma(e,t);return r?String(r.badgeLabel||"").trim()||`${r.discountPercent}%OFF`:""}function ma(e,t){return RP(Ck(e),t)}function Ck(e){var r;let t=(((r=e.discounts)==null?void 0:r.items)||[]).filter(n=>n.type==="guard-accessories");return AP(t)}function _P(e,t){let r=ma(e,t),n=gs(t);return!r||n<=0?{compareAtPrice:t.compareAtPrice||"",price:t.variantPrice||""}:{compareAtPrice:we(n,t.variantPrice),price:we(n*(1-r.discountPercent/100),t.variantPrice)}}var Pk="web-client";function jm(e){return String(e||"").trim().toLowerCase()}function FS(e){let t=String(e||"").trim();if(!t||!/(?:Z|[+-]\d{2}:?\d{2})$/i.test(t))return NaN;let r=Date.parse(t);return Number.isFinite(r)?r:NaN}function Wk(e,t){return e.appliesTo!=="products"?!0:(e.products||[]).some(r=>{let n=jm(r.productGid);return n?Boolean(t.productGid)&&n===jm(t.productGid):Boolean(r.productHandle)&&Boolean(t.productHandle)&&jm(r.productHandle)===jm(t.productHandle)})}function vk(e,t){let r=e.value;if((r==null?void 0:r.kind)==="percentage"){let n=Number(r.percentage);return Number.isFinite(n)&&n>0&&n<=100?t*(n/100):0}if((r==null?void 0:r.kind)==="fixed-amount"){let n=Number(r.amountCents);return Number.isFinite(n)&&n>0?Math.min(t,n/100):0}return 0}function wk(e){var r,n;let t=String(e.badgeLabel||"").trim();if(t)return t;if(((r=e.value)==null?void 0:r.kind)==="percentage"){let o=Number(e.value.percentage);return Number.isFinite(o)&&o>0?`${o}% OFF`:""}if(((n=e.value)==null?void 0:n.kind)==="fixed-amount"){let o=Number(e.value.amountCents);return Number.isFinite(o)&&o>0?`${we(o/100,"$0")} OFF`:""}return""}function DS(e,t){if(typeof t=="number")return t;let r=Number(e.discountNowEpoch);if(!Number.isFinite(r))return Date.now();let n=Number(e.discountNowCapturedAtEpoch),o=Number.isFinite(n)?Date.now()-n*1e3:0;return r*1e3+o}function BP(e,t){return DS(e,t)}function Tk(e,t){if(e.enabled===!1)return!1;let r=t!=null?t:Date.now(),n=FS(e.startsAt),o=FS(e.endsAt);return e.startsAt&&!Number.isFinite(n)||e.endsAt&&!Number.isFinite(o)||Number.isFinite(n)&&r<n?!1:!(Number.isFinite(o)&&r>=o)}function ZP(e,t){var o;let r=DS(e,t),n=(((o=e.discounts)==null?void 0:o.items)||[]).filter(i=>i.type==="automatic-product"&&i.enabled!==!1).flatMap(i=>[i.startsAt,i.endsAt].map(a=>FS(a)).filter(a=>Number.isFinite(a)&&a>r));return n.length?Math.min(...n):null}function Mk(e,t){var n;let r=DS(e,t);return(((n=e.discounts)==null?void 0:n.items)||[]).filter(o=>{var i;return o.type==="automatic-product"&&Tk(o,r)&&(!((i=o.salesChannels)!=null&&i.length)||o.salesChannels.includes(Pk))})}function Ol(e,t,r){let n=gs(t);if(n<=0)return null;let o=Mk(e,r).filter(a=>Wk(a,t)).map(a=>({item:a,savings:vk(a,n)})).filter(({savings:a})=>a>0).sort((a,s)=>s.savings-a.savings)[0];if(!o)return null;let i=wk(o.item);return{discount:o.item,discountBadge:i,savings:o.savings,price:we(n-o.savings,t.variantPrice),compareAtPrice:t.variantPriceCents===void 0?t.variantPrice||"":we(n,t.variantPrice),discountLabel:String(o.item.discountLabel||"").trim()||i||"Automatic discount"}}var Uk=new Set(["guard","bundle"]),Ik=new Set(["3dprintedmodel","addextramaterial","extramaterial"]),Vk=new Set(["mouthguard","sportsmouthguard","smg"]),$P={position:["position","productDetails"],details:["details","productThickness"],strength:["strength","productStrength"],customization:["customization","productCustomization"],personDetails:["personDetails","insolePersonDetails","shoeInformation"],impressionKit:["impressionKit","impressionKitProductVariantId","impressionTraySize"],clinicScan:["clinicScan"],upsell:["upsell"],review:["review"]};function OP({guardQuantity:e,step:t,steps:r}){let n=Number.isFinite(e)&&e>0?Math.floor(e):1,i=((r==null?void 0:r.filter(s=>s.key==="customization"))||[]).length>1;return{guardIndex:((t==null?void 0:t.key)==="customization"||(t==null?void 0:t.key)==="details")&&!i?n-1:t==null?void 0:t.guardIndex,guardQuantity:n}}function Xo(e){return String(e||"").trim().toLowerCase()}function FP(e){return Xo(e).replace(/[^a-z0-9]+/g,"")}function kk(e){return Boolean((e==null?void 0:e.productGid)||(e==null?void 0:e.productHandle))}function Lk({currentProduct:e,product:t}){return!e||!t?!1:e.gid&&t.productGid&&Xo(e.gid)===Xo(t.productGid)||e.handle&&t.productHandle&&Xo(e.handle)===Xo(t.productHandle)?!0:Boolean(e.title&&t.productTitle&&Xo(e.title)===Xo(t.productTitle))}function Xk(e){return e?[e.handle,e.title].some(t=>{let r=FP(t);return Vk.has(r)||r.includes("sportsmouthguard")}):!1}function Nk(e){return(e==null?void 0:e.guardIndex)===void 0?!1:!Number.isFinite(e.guardQuantity)||Number(e.guardQuantity)<=1?e.guardIndex===0:e.guardIndex===Number(e.guardQuantity)-1}function Ek(e){return!Uk.has(Xo(e))}function Ak(e){return new Set($P[e].map(Xo))}function Rk(e){return(e.bundleTierUpsellProducts||[]).filter(kk)}function DP(e,t,r){let n=Rk(e),o=(e.sports||[]).length>0||(e.thicknessSizes||[]).length>0;return o&&t!=="details"||!o&&t!=="customization"||!(n.length?n.some(a=>Lk({currentProduct:e.currentProduct,product:a})):Xk(e.currentProduct))?!1:e.showBundleTierUpsellOnLastPassOnly===!1?!0:Nk(r)}function Gk(e,t){return e.variantGid||e.productGid||e.productHandle||t}function _k(e,t){var o,i;let r=`${t.productTitle||""} ${t.productHandle||""}`;if(!/whitening/i.test(r))return!1;let n=`${((o=e.currentProduct)==null?void 0:o.title)||""} ${((i=e.currentProduct)==null?void 0:i.handle)||""} ${e.productAlias||""}`;return!/whitening|^\s*WT\s*$/i.test(n)&&!/\bWT\b/.test(n)}function rt(e,t){let r=Ak(t),n=(e.stepsRecommendedProducts||[]).flatMap((i,a)=>{let s=String(i.title||"").trim();return!r.has(Xo(s))||!Ek(i.type)?[]:(i.products||[]).filter(l=>l.available!==!1&&!_k(e,l)).map((l,c)=>({configuredStep:s||t,index:c,key:Gk(l,`${t}-${a}-${c}`),product:l,step:t}))}).filter(({product:i})=>Boolean(i.variantGid||i.productGid||i.productHandle||i.productTitle)),o=new Set;return n.filter(({key:i})=>o.has(i)?!1:(o.add(i),!0))}function En(e){return String((e==null?void 0:e.alternativeTitle)||"").trim()||String((e==null?void 0:e.productTitle)||"").trim()||String((e==null?void 0:e.productHandle)||"").trim()}function Fl(e){let t=Object.keys($P),r=new Set;return t.flatMap(n=>rt(e,n)).filter(({key:n})=>r.has(n)?!1:(r.add(n),!0))}function qm({product:e,step:t}){return t==="upsell"?0:Number.isFinite(e.quantity)?Math.max(0,Math.min(99,Number(e.quantity))):0}function Ss(e){let t=Array.isArray(e==null?void 0:e.productImageUrls)?e.productImageUrls:[],r=t.length?t:[e==null?void 0:e.productImageUrl];return Array.from(new Set(r.map(n=>String(n||"").trim()).filter(Boolean)))}function Yn(e,t){var n;let r=(n=e.upsellQuantities)==null?void 0:n[t.key];return Number.isFinite(r)?Math.max(0,Math.min(99,Number(r))):qm(t)}function zP(e,t){return Yn(e,t)>0?0:Math.max(1,qm(t))}function zS(e){var t;return Boolean((t=e==null?void 0:e.bundlePackages)==null?void 0:t.length)}function KS(e){return zS(e)||[e.productHandle,e.productTitle].some(t=>Ik.has(FP(t)))}function ro(e,t,r){let n=gs(t),o=Boolean(String(t.productType||"").trim()),i=e.hasGuardInCart||Wi(e.productType)==="guard",a=o&&i?ma(e,t):null,s=a?_P(e,t):{compareAtPrice:t.compareAtPrice||"",price:t.variantPrice||""},l=a?Math.max(0,n-se(s.price)):0,c=Ol(e,t,r);return a&&l>0&&l>=((c==null?void 0:c.savings)||0)?{unitAmount:Math.round((n-l)*100)/100,compareAtPrice:s.compareAtPrice,discountLabel:"",price:s.price,savings:l}:c&&c.savings>0?{unitAmount:Math.round((n-c.savings)*100)/100,compareAtPrice:c.compareAtPrice,discountLabel:c.discountLabel,price:c.price,savings:c.savings}:{unitAmount:n,compareAtPrice:t.compareAtPrice||"",discountLabel:"",price:we(n,t.variantPrice),savings:0}}function Jm(e,t){return Fl(e).reduce((r,n)=>{let o=ro(e,n.product);return r+o.unitAmount*Yn(t,n)},0)}function KP(e,t){return Fl(e).filter(({product:r})=>KS(r)).reduce((r,n)=>r+gs(n.product)*Yn(t,n),0)}function no(e,t,r){var i;let n=e?e.querySelector(t):null;return(n?(i=n.textContent)==null?void 0:i.replace(/\s+/g," ").trim():"")||r}function Sn(e){return e.querySelector('input[name="id"]:checked')||e.querySelector('input[name="id"]')}function Kr(e){return String(e||"").trim().toLowerCase()}function jP(e){return Boolean(e==null?void 0:e.freeInBundle)}function ef(e){return String(e||"").split("/").map(t=>t.trim()).filter(Boolean)}function HS(e,t){var r,n;return((n=(r=e==null?void 0:e.selectedOptions)==null?void 0:r.find(o=>t.includes(Kr(o.name))))==null?void 0:n.value)||""}function HP(e){return Kr(HS(e,["flow"])||ef(e==null?void 0:e.title)[0])}function QP(e){return Kr(HS(e,["type","role"])||ef(e==null?void 0:e.title)[1]||(e==null?void 0:e.title))}function Bk(e){return Kr(HS(e,["position"])||ef(e==null?void 0:e.title)[2])}function QS(e){return Le((e==null?void 0:e.gid)||(e==null?void 0:e.id))}function Cr(e,t){return(e||[]).find(r=>QS(r)===t)}function qd({config:e,selectedVariantId:t,role:r,state:n}){let o=e.productVariants||[],i=Cr(o,t),a=HP(i),s=Kr(n.position),l=Kr(r);return o.some(d=>["starter","bundled","pro","elite","ultimate","return"].includes(QP(d))||/\b(starter|bundled|pro|elite|ultimate|return)\b/i.test(d.title||""))?o.find(d=>{if(d.available===!1||d.availableForSale===!1)return!1;let u=HP(d),p=QP(d),m=Bk(d);return a&&u&&u!==a||p!==l?!1:!m||!s||m===s}):(i==null?void 0:i.available)!==!1&&(i==null?void 0:i.availableForSale)!==!1?i:void 0}function tf(e){return QS(qd(e))}function jS(e){return Array.isArray(e.bundlePackages)?e.bundlePackages:[]}function fa(e,t){let r=jS(e),n=Sn(t);if(!r.length||!n)return;let o=Number.parseInt(n.getAttribute("data-purchase-master-package-index")||"",10),i=Kr(n.getAttribute("data-purchase-master-package-id")||"");if(i){let s=r.find(l=>Kr(l.id)===i);if(s)return s}if(Number.isInteger(o)&&o>=0&&o<r.length)return r[o];let a=Kr(n.getAttribute("data-title")||"");if(a)return r.find(s=>Kr(s.title)===a)}function jd(e,t,r){let n=Sn(t);return(r||(n==null?void 0:n.getAttribute("data-purchase-master-flow"))||e.purchaseMasterFlow||"")==="clinic"?"clinic":"impression-kit"}function Zk(e){return e==="clinic"?"clinic":"impression-kit"}function No(e,t,r){let n=Sn(e);return(n==null?void 0:n.getAttribute(`data-purchase-master-${Zk(t)}-${r}`))||""}function ha(e,t,r,n){let o=fa(e,t);if(!o)return[];let i=jd(e,t,r)==="clinic"&&Array.isArray(o.clinicProducts)&&o.clinicProducts.length?o.clinicProducts:Array.isArray(o.products)?o.products:[],a=Array.isArray(o.shopProducts)?o.shopProducts:[],s=a.length?a.filter(P=>{let Y=Kr(P.role||P.variantRole),h=Kr(P.productType);return Y!=="impression-kit"&&h!=="impressionkit"}):[],l=s.length>0,c=l?s:i,d=jd(e,t,r)==="clinic"?e.bundleClinicScanProduct:l?e.impressionKitProduct||e.bundleImpressionKitProduct:e.bundleImpressionKitProduct||e.impressionKitProduct,u=d!=null&&d.variantGid?c.some(P=>P.variantGid===d.variantGid||d.productGid&&P.productGid===d.productGid):!0,p=d!=null&&d.variantGid&&!u?[...c,{...d,quantity:1,flow:l?"shop":d.flow}]:c,m=Math.floor(Number(n)||0),g=Math.max(oo(o.iconCount),qS(e,p));if(m<=g)return p;let y=c.find(P=>Hr(e,P));return y?[...p,...Array.from({length:m-g},()=>({...y,quantity:1}))]:p}function oo(e){let t=Number(e);return Number.isFinite(t)&&t>0?Math.floor(t):1}function Hr(e,t){let r=e.currentProduct;if(!t||!r)return!1;let n=Kr(t.role);if(["impression-kit","accessory"].includes(n))return!1;if(r.gid&&t.productGid&&t.productGid===r.gid)return!0;let o=Le(t.variantGid);return o&&(e.productVariants||[]).some(i=>QS(i)===o)?!0:Boolean(r.handle&&t.productHandle===r.handle)}function qS(e,t){return(t||[]).reduce((r,n)=>Hr(e,n)?r+oo(n.quantity):r,0)}function Dl(e,t){let r=ef(e==null?void 0:e.variantLabel),n=Kr((e==null?void 0:e.variantRole)||r[1]||(e==null?void 0:e.variantLabel));return n==="starter"?"Starter":n==="bundled"?"Bundled":["pro","elite","ultimate","return"].includes(n)?n[0].toUpperCase()+n.slice(1):t}var JP="__purchaseMasterGuardSlot";function zl(e){return String(e!=null?e:"").trim()}function rf(e){return zl(e).toLowerCase()}function $k(e){return rf(e.__category).replace(/[\s_-]+/g,"")}function JS(e){return rf(e.__purchaseMasterItemRole)}function qP(e){return rf(e.__purchaseMasterAddonType)==="guard"||rf(e.__purchaseMasterPaidGuardAddon)==="true"}function nf(e){let t=Number.parseInt(zl(e),10);return Number.isInteger(t)&&t>0?t:null}function ey(e){let t=lr(e);return nf(t[JP])}function eW(e,t){let r=lr(e),n=nf(t);if(!n)throw new Error("Purchase Master guard slot is invalid");return ko({...r,[JP]:String(n)})}function tW(e){let t=Math.max(1,Math.floor(Number(e)||0));return t===1?"starter":t===2?"pro":t===3?"elite":"ultimate"}function ty(e,t){let r=lr(e.properties),n=zl(r.__personId);if(!n||t&&n!==t||JS(r)==="id-tag"||JS(r)==="edge-type")return!1;let o=$k(r);return["impressionkits","extraproducts","accessories"].includes(o)?qP(r):["guards","guard","retainers","retainer","whiteningtrays","whiteningtray"].includes(o)?!0:qP(r)}function Ok(e,t){let r=zl(t.__itemId),n=zl(t.__parentItemId),o=JS(t);return[n?"child":"root",o==="cart-addon-product"?"addon":"core",r,zl(e.key)]}function Fk(e,t){for(let r=0;r<e.length;r+=1)if(e[r]!==t[r])return e[r].localeCompare(t[r]);return 0}function rW(e,t={}){let r=(Array.isArray(e)?e:[]).filter(n=>{var o;if(!(n!=null&&n.key)||(o=t.removedKeys)!=null&&o.has(n.key))return!1;if(Number(n.quantity||1)!==1)throw new Error("Purchase Master guard quantity must be one per line");return ty(n,t.personId)}).map(n=>{let o=lr(n.properties);return{payload:n,properties:o,storedSlot:ey(o),identity:Ok(n,o)}});return r.sort((n,o)=>{if(n.storedSlot!==null&&o.storedSlot!==null){if(n.storedSlot!==o.storedSlot)return n.storedSlot-o.storedSlot}else{if(n.storedSlot!==null)return-1;if(o.storedSlot!==null)return 1}return Fk(n.identity,o.identity)}),r.map(({payload:n,properties:o},i)=>({payload:n,properties:o,slot:i+1}))}function yn(e){return String(e||"").trim().toLowerCase()}function ys(e){let t=String(e||"").trim();return t&&t.split("/").pop()||""}function Dk(e,t){let r=yn(e),n=yn(t),o=ys(e),i=ys(t);return Boolean(r&&n&&(r===n||o&&i&&o===i))}function oW(e){let t=ys(e);return t?t.toLowerCase():""}function oy(e){return yn(e).replace(/[\s_-]+/g,"")}function ry(e){return oy(e==null?void 0:e.variantPosition)}function zk(e){return oy(e.Position)}function iy(e,t){var r,n;return(n=(r=e.selectedOptions)==null?void 0:r.find(o=>t.includes(oy(o.name))))==null?void 0:n.value}function ay(e){let t=String(e||"").trim();return(t.includes("/")?t.replace(/^.*\s-\s(?=[^/]+\/)/,""):t).split("/").map(yn).filter(Boolean)}function Kk(e){return yn(iy(e,["flow"])||ay(e.title)[0])}function Hk(e){let t=ay(e.title);return yn(iy(e,["type","role"])||t[1])}function ny(e){return yn(iy(e,["position"])||ay(e.title)[2])}function Qk(e,t,r){let n=(e.productVariants||[]).filter(i=>ys(i.gid||i.id)&&i.available!==!1&&i.availableForSale!==!1&&Kk(i)==="shop"&&Hk(i)===t),o=n.filter(i=>ny(i));return r&&o.length?o.find(i=>ny(i)===r):n.find(i=>!ny(i))||n[0]}function jk(e){return oW(e.productGid||e.product_gid||e.product_id||e.productId)}function qk(e){return yn(e.handle||e.productHandle||e.product_handle)}function iW(e){return oW(e.productGid||e.productId)}function aW(e){return yn(e.productHandle||e.handle)}function Jk(e,t){var n;let r=ys((n=t.variant_id)!=null?n:t.variantId);return r?(e.bundlePackages||[]).some(o=>(o.shopProducts||[]).some(i=>yn(i.role)==="guard"&&Dk(i.variantGid,r))):!1}function of(e,t){let r=iW(e),n=jk(t);if(r&&n&&r===n)return!0;let o=aW(e),i=qk(t);return o&&i&&o===i?!0:Jk(e,t)}function e4(e,t){var r;return t?{...t,...e,productGid:e.productGid||e.productId||t.productGid||t.productId,productHandle:e.productHandle||e.handle||t.productHandle||t.handle,productVariants:(r=e.productVariants)!=null&&r.length?e.productVariants:t.productVariants||[]}:e}function nW(e){let t=new Set,r=new Set;return e.filter(n=>{if(!n||t.has(n))return!1;t.add(n);let o=iW(n)||aW(n);return o?r.has(o)?!1:(r.add(o),!0):!0})}function t4(e,t,r=[],n=!1){let o=nW([...r,t].filter(Boolean)),i=nW(r).filter(s=>of(s,e));if(i.length===1)return of(t,e)?e4(t,i[0]):i[0];let a=o.filter(s=>of(s,e));if(n&&of(t,e)||!r.length&&a.length===0)return t;if(a.length!==1)throw new Error("Shop guard product configuration is ambiguous or unavailable");return a[0]}function r4(e){return tW(e)}function n4(e,t){let r=Math.min(4,Math.max(1,Math.floor(Number(t)||1)));return(e.bundlePackages||[]).find(n=>Number(n.iconCount)===r&&Array.isArray(n.shopProducts))}function o4(e,t){if(typeof e=="object"){let r=e;return{slot:ey(r)||1,properties:r}}return{slot:nf(e)||1,properties:t||{}}}function ga(e,t,r=1,n={}){var p;let{slot:o,properties:i}=o4(r,n),a=r4(o),s=n4(e,t),l=((p=s==null?void 0:s.shopProducts)==null?void 0:p.filter(m=>yn(m.role)==="guard"&&yn(m.variantRole)===a))||[],c=zk(i),d=l.filter(m=>ry(m)),u=c?d.length?l.find(m=>ry(m)===c):l[0]:l.find(m=>!ry(m))||l[0];if(c&&d.length&&!u)return"";if(!u){let m=Qk(e,a,c);return ys((m==null?void 0:m.gid)||(m==null?void 0:m.id))}return ys(u==null?void 0:u.variantGid)}function i4(e,t,r){let n=lr(e.properties);if(!ty(e,r))return!1;let o=yn(n.__purchaseMasterItemRole),i=String(n.__itemId||"").trim(),a=String(n.__parentItemId||"").trim();return n.__purchaseMasterVariantModel==="shop-v2"?t?i===t||a===t||o==="cart-addon-product":!0:!1}function sW({config:e,payloads:t,parentPayloadKey:r,parentProperties:n,removedKeys:o=new Set,catalogProducts:i=[],personId:a}){let s=n||{},l=a||String(s.__personId||"").trim()||String(t.map(m=>lr(m.properties).__personId).find(Boolean)||"").trim(),c=t.filter(m=>i4(m,void 0,l||void 0)),d=rW(c,{personId:l||void 0,removedKeys:o});if(!d.length)throw new Error("Shop package guard slots are unavailable");let u=d.map(m=>{let g=m.payload.key===r?lr(s):m.properties,y=t4(m.payload,e,i,m.payload.key===r),P=ga(y,d.length,m.slot,g);if(!P)throw new Error(`Shop package variant is unavailable for guard slot ${m.slot}`);return{payload:m.payload,variantId:P,properties:eW(g,m.slot)}}),p=u.find(m=>m.payload.key===r)||u.find(m=>{let g=lr(m.payload.properties);return!String(g.__parentItemId||"").trim()})||u[0];return{guardCount:d.length,rootVariantId:p.variantId,replacements:u}}function a4({extraProductsAmount:e,initialsAmount:t,packageAmount:r}){return r+t+e}function lW(e,t,r,n,o){var c,d,u,p;let i=Sn(t),a=i?i.closest(".trufit-main-product__package"):null,s=No(t,n,"price"),l=o&&o>0?(u=n==="clinic"?(c=e.pricingPalette)==null?void 0:c.clinicBundlePrices:(d=e.pricingPalette)==null?void 0:d.bundlePrices)==null?void 0:u[o-1]:"";if(l)return l;if(s)return s;if(n==="clinic"){let m=CP(ha(e,t,n,o));if(m>0)return we(m,r||"$0")}return(i==null?void 0:i.getAttribute("data-purchase-master-price"))||((p=fa(e,t))==null?void 0:p.price)||no(a,".trufit-main-product__package-price",r)}function s4(e,t,r,n,o=[]){let i=ha(e,r,t.purchaseMasterFlow,n).filter(d=>Hr(e,d));if(!i.length)return null;let a=0,s=0,l=0,c=i.reduce((d,u)=>d+oo(u.quantity),0);for(let[d,u]of i.entries()){let p=d===0?"Starter":"Bundled",m=Cr(e.productVariants,Le(u.variantGid)),g=oo(u.quantity);for(let y=0;y<g;y++){let P=o[l]||t,Y=Jd(e,r)&&Hr(e,u)?Cr(e.productVariants,ga(e,c,l+1,{Position:P.position})):qd({config:e,selectedVariantId:Le(u.variantGid),role:Dl(u,p),state:P});if(l+=1,!m||!Y)return null;a+=fn(m),s+=fn(Y)}}return{baseline:a,selected:s}}function Jd(e,t){var r,n;return Boolean((n=(r=fa(e,t))==null?void 0:r.shopProducts)==null?void 0:n.length)}function l4(e,t){if(!e||!t)return!1;let r=String(e.productGid||"").trim().toLowerCase(),n=String(t.productGid||"").trim().toLowerCase();if(r&&n)return r===n;let o=String(e.productHandle||"").trim().toLowerCase(),i=String(t.productHandle||"").trim().toLowerCase();return Boolean(o&&i&&o===i)}function cW(e,t,r){let n=e.catalogProducts||[],o=r?n.filter(s=>l4(r,s)):[],a=(o.length?o:n).flatMap(s=>[...s.productVariants||[],...s.impressionKitProductVariants||[]]);return Cr(e.productVariants,t)||Cr(e.impressionKitProductVariants,t)||a.find(s=>Le(s.gid||s.id)===t)}function dW(e,t){let r=Le(t.variantGid);return cW(e,r,t)||(r&&(t.variantPrice||t.variantPriceCents!==void 0)?{id:r,gid:t.variantGid,title:t.variantLabel,price:t.variantPrice,priceCents:t.variantPriceCents,available:t.available}:void 0)}function c4(e,t,r,n,o=[]){let i=ha(e,r,t.purchaseMasterFlow,n);if(!i.length)return null;let a=0,s=0,l=i.reduce((c,d)=>c+(Hr(e,d)?oo(d.quantity):0),0);for(let[c,d]of i.entries()){let u=Hr(e,d),p=c===0?"Starter":"Bundled",m=oo(d.quantity),g=jP(d);for(let y=0;y<m;y+=1){if(g){u&&(s+=1);continue}let P=o[s]||t,Y=u?Jd(e,r)?cW(e,ga(e,l,s+1,{Position:P.position}),d):qd({config:e,selectedVariantId:Le(d.variantGid),role:Dl(d,p),state:P}):dW(e,d);if(u&&(s+=1),!Y||Y.available===!1||Y.availableForSale===!1)return null;a+=fn(Y)}}return a>0?a:null}function d4(e,t,r,n,o=[]){let i=ha(e,r,t.purchaseMasterFlow,n).filter(c=>Hr(e,c));if(!i.length)return null;let a=0,s=0,l=0;for(let[c,d]of i.entries()){let u=c===0?"Starter":"Bundled",p=dW(e,d),m=oo(d.quantity);for(let g=0;g<m;g+=1){let y=qd({config:e,selectedVariantId:Le(d.variantGid),role:Dl(d,u),state:o[l++]||t});if(!p||!y)return null;a+=fn(p),s+=fn(y)}}return{baseline:a,selected:s}}function uW(e,t,r,n,o,i=[],a=!1){if(Jd(e,r)){if(a&&String(n||"").trim()){let l=d4(e,t,r,o,i);return l?se(n)+l.selected-l.baseline:se(n)}return c4(e,t,r,o,i)}let s=s4(e,t,r,o,i);return s?String(n||"").trim()?se(n)+s.selected-s.baseline:s.selected:null}function pW(e){return Number.isFinite(e)?Math.max(0,Math.min(100,Number(e))):0}function mW(e,t){let r=pW(t);return r>0?e*(1-r/100):e}function sy(e,t,r,n,o,i,a,s=[],l=!1){let c=String(o||"").trim()||lW(e,r,n,t.purchaseMasterFlow,i),d=uW(e,t,r,c,i,s,l&&Boolean(String(o||"").trim()));if(Jd(e,r)&&d===null)return"";let u=d===null?se(c):d;return pW(a)>0&&u>0?we(mW(u,a),c||n):d===null?c:we(u,c||n)}function ly(e,t,r,n=[],o,i,a){let s=String(o||"").trim()||lW(e,r,"",t.purchaseMasterFlow,i),l=uW(e,t,r,s,i,n);if(Jd(e,r)&&l===null)return"";let c=l===null?se(s):l,d=mW(c,a),u=n.length?n:[t],p=u.reduce((g,y)=>{var P;return g+(y.initialsOptIn&&y.initials&&((P=e.initials)!=null&&P.variantGids)?se(zr(e.initials)):0)},0),m=a4({packageAmount:d+u.reduce((g,y)=>g+Bm(e,y),0),initialsAmount:p,extraProductsAmount:KP(e,t)});return m>0?m.toFixed(2):""}function u4(e){return String(e||"").trim().toLowerCase().replace(/[^a-z0-9]+/g,"")}function cy(e){let t=u4(e);return t.includes("lower")?"lower":t.includes("upper")?"upper":t}function fW(e){let t=cy(e);return t==="lower"||t==="upper"?[t,"dual"]:["dual"]}var hW="__orderTags";function dy(e){if(typeof e!="string"||!e.trim())return[];try{let t=JSON.parse(e);return Array.isArray(t)?t:[]}catch(t){return[]}}function gW(e){return String(e||"").trim().toLowerCase()}function p4(e){let t=new Set,r=[];for(let n of e){if(typeof n!="string")continue;let o=n.trim(),i=gW(o);!o||t.has(i)||(t.add(i),r.push(o))}return r}function uy(e){return JSON.stringify(p4(e).map(gW).sort())}var CW="withTransform";var PW="false",io=class extends Error{constructor(){super("Your cart changed. Refresh it before editing this item."),this.name="StaleCartError"}},af=class extends Error{constructor(){super("This bundle is still being restored. Refresh the cart before editing it."),this.name="MergedPurchaseMasterLineError"}};function YW(e,t,r){let n=e==null?void 0:e[t],o=String(r!=null?r:"");if(!o)return n==null||n==="";if(n==null)return!1;let i=String(n);return i===o?!0:t!==hW?!1:uy(dy(i))===uy(dy(o))}function m4(e){let t=e.cart_level_discount_applications;return Array.isArray(t)&&t.some(r=>Boolean(r&&typeof r=="object"&&String(r.type||"")==="discount_code"))}function SW(e){let t=he({key:e.key||"",variant_id:e.variant_id||"",quantity:e.quantity||1,properties:e.properties});return!t.isPurchaseMaster||!t.personId||!t.itemId?null:t}function sf(e,t){var d;let r=(d=t.variant_id)!=null?d:t.variantId,n=xe(e),o=r!==void 0&&t.properties?dt(r,t.properties):"",i=u=>t.quantity===void 0||u.quantity===t.quantity,a=u=>!o||dt(u.variant_id,u.properties)===o,s=SW({key:t.key,variant_id:r,quantity:t.quantity,properties:t.properties}),l=u=>{if(!s)return!1;let p=SW(u);return Boolean(p&&p.personId===s.personId&&p.itemId===s.itemId&&p.parentItemId===s.parentItemId&&p.category===s.category)};if(t.key){let u=n.filter(p=>p.key===t.key);if(u.length>1)throw new io;if(u.length===1){let p=u[0];if(i(p)&&(a(p)||l(p)))return p}}let c=o?n.filter(u=>dt(u.variant_id,u.properties)===o):[];if(c.length!==1||!i(c[0])){let u=n.filter(p=>i(p)&&l(p));if(u.length===1)return u[0];throw new io}return c[0]}function f4(e){return e.properties||{}}function h4(e){return f4(e).__purchaseMasterSource==="online-store"}function g4(e){return e.items.some(h4)}function Y4(e){var n,o;let t=String(((n=e.attributes)==null?void 0:n.__salesChannel)||"").trim(),r=String(((o=e.attributes)==null?void 0:o[CW])||"").trim();return(t===""||t==="web-client"||t==="online-store")&&Boolean(r)&&r!==PW}function S4(e,t){return xe(e).filter(r=>!t.has(r.key))}function WW(e,t){let r=xe(e),n=new Map;r.forEach(s=>{let l=dt(s.variant_id,s.properties);n.set(l,[...n.get(l)||[],s])});let o=t.map(s=>{let l=dt(s.variant_id,s.properties),c=n.get(l);return(c==null?void 0:c.shift())||s}),i=new Set(o.map(s=>s.key)),a=r.filter(s=>!i.has(s.key)&&cr(s));return[...o,...a]}function py(e,t,r){if(e.items.every(cr))return e;let n=S4(t,r),o=WW(e,n);return{...e,items:o,purchaseMasterReceiptItems:e.items}}function y4(e,t,r,n,o){if(e.items.every(cr))return e;let i=xe(t).map(a=>a.key===r.key?{...a,quantity:n,properties:o}:a);return{...e,items:WW(e,i),purchaseMasterReceiptItems:e.items}}async function eu(e,t,r,n,o){return hs(async()=>{var p,m;let i=n&&o?o:await Dr(e),a=sf(i,t);if(bt(a))throw new af;let s=(p=r.quantity)!=null?p:a.quantity;if(!Number.isSafeInteger(s)||s<0)throw new Error("Invalid cart quantity.");let l=ko((m=r.properties)!=null?m:a.properties),c=dt(a.variant_id,l),d=dt(a.variant_id,a.properties);if(s===a.quantity&&c===d)return i;let u=g=>{let y=xe(g).filter(P=>dt(P.variant_id,P.properties)===c);return s===0?y.length===0:y.length===1&&y[0].quantity===s&&(d===c||!xe(g).some(P=>dt(P.variant_id,P.properties)===d))};try{let g=await e("cart/change.js",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify({...r,id:a.key,quantity:s,properties:l})});if(!g.ok)throw new Lo("update",g.status);let y=await Gm(e,g,{allowRenderedFallback:!1});return s===0?py(y,i,new Set([a.key])):y4(y,i,a,s,l)}catch(g){if(g instanceof Lo)throw g;try{let y=await Dr(e);if(u(y))return y}catch(y){}throw g}},n)}async function vW(e){return Dd(async t=>{var a;let r=await Dr(e),n=!1,o=String(((a=r.attributes)==null?void 0:a.__salesChannel)||"").trim(),i={};if(Y4(r)&&(i[CW]=PW),(o===""||o==="web-client")&&(i.__salesChannel="online-store"),Object.keys(i).length&&(r=await Kl(e,{attributes:i},t,r),n=!0),!g4(r))return{cart:r,changed:n};for(let s of xe(r)){if(bt(s))continue;let l=ko(s.properties);dt(s.variant_id,l)!==dt(s.variant_id,s.properties)&&(r=await eu(e,s,{properties:l},t,r),n=!0)}return{cart:r,changed:n}})}async function Kl(e,t,r,n){return hs(async()=>{let o=r&&n?n:await Dr(e),a=Object.entries(t.updates||{}).map(([p,m])=>{if(!Number.isSafeInteger(m)||m<0)throw new Error("Invalid cart quantity.");return{line:sf(o,{key:p}),quantity:m}}).filter(({line:p,quantity:m})=>p.quantity!==m),s=t.attributes||{},l=Object.entries(s).filter(([p,m])=>!YW(o.attributes,p,m)),c=Object.prototype.hasOwnProperty.call(t,"discount");if(!a.length&&!l.length&&!c)return o;let d={...a.length?{updates:Object.fromEntries(a.map(({line:p,quantity:m})=>[p.key,m]))}:{},...l.length?{attributes:Object.fromEntries(l)}:{},...c?{discount:t.discount}:{}},u=p=>a.every(({line:m,quantity:g})=>{let y=xe(p).filter(P=>dt(P.variant_id,P.properties)===dt(m.variant_id,m.properties));return g===0?y.length===0:y.length===1&&y[0].quantity===g})&&Object.entries(d.attributes||{}).every(([m,g])=>YW(p.attributes,m,g))&&(!c||t.discount!==""||!m4(p));try{let p=await e("cart/update.js",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify(d)});if(!p.ok)throw new Lo("update",p.status);return await Gm(e,p,{allowRenderedFallback:!1})}catch(p){if(p instanceof Lo)throw p;try{let m=await Dr(e);if(u(m))return m}catch(m){}throw p}},r)}async function wW(e,t,r,n){return r?hs(async()=>{let o=r&&n?n:await Dr(e),i=t.map(l=>sf(o,l));if(i.some(bt))throw new af;let a=Object.fromEntries(i.map(l=>[l.key,0]));if(!Object.keys(a).length)return o;if(i.length===1)return eu(e,i[0],{quantity:0},r,o);let s=await Kl(e,{updates:a},r,o);return py(s,o,new Set(i.map(l=>l.key)))},r):Dd(o=>wW(e,t,o))}function x4(e,t){let r=e.items.filter(n=>{if(!bt(n)||!cr(n))return!1;let o=he(n);return o.personId===t.personId&&o.itemId===t.itemId});if(r.length>1)throw new io;return r[0]}function b4(e,t){let r=xe(e);return t.some(n=>r.some(o=>dt(o.variant_id,o.properties)===dt(n.variant_id,n.properties)))}function yW(e,t){var n;if(t.key&&e.key===t.key)return!0;let r=(n=t.variant_id)!=null?n:t.variantId;return r==null||String(e.variant_id)!==String(r)?!1:dt(e.variant_id,e.properties)===dt(String(r),t.properties)}function C4(e){return he(e).itemId}function TW(e,t,r){var a;let n=he(e);if(!n.isPurchaseMaster||n.personId!==t.personId)return!1;if(n.itemId===t.itemId)return!0;let o=new Set,i=n.parentItemId;for(;i&&!o.has(i);){if(i===t.itemId)return!0;o.add(i);let s=(a=r.get(i))==null?void 0:a.find(l=>he(l).personId===t.personId);i=s?he(s).parentItemId:""}return!1}function MW(e){var t,r,n;return he({key:e.key||"",variant_id:(r=(t=e.variant_id)!=null?t:e.variantId)!=null?r:"",quantity:(n=e.quantity)!=null?n:1,properties:e.properties})}function xW(e,t,r,n){var s;let o=he(e),i=MW(t),a=(s=t.variant_id)!=null?s:t.variantId;return(a===void 0||String(e.variant_id)===String(a))&&(t.quantity===void 0||e.quantity===t.quantity)&&(!i.personId||o.personId===i.personId)&&(!i.itemId||o.itemId===i.itemId)&&(!i.parentItemId||o.parentItemId===i.parentItemId)&&(!i.category||o.category===i.category)&&TW(e,r,n)}function bW(e,t){let r=xe(e),n=new Map,o=new Map;for(let s of r){let l=n.get(s.key)||[];l.push(s),n.set(s.key,l);let c=C4(s);if(c){let d=o.get(c)||[];d.push(s),o.set(c,d)}}if(!t.selections.length)return r.filter(s=>TW(s,t,o));let i=t.selections.map(s=>{var d;let l=s.key?n.get(s.key)||[]:[],c;if(l.length>1)throw new io;if(l.length===1){c=l[0];let u=(d=s.variant_id)!=null?d:s.variantId;if(u!==void 0&&String(c.variant_id)!==String(u)||s.quantity!==void 0&&c.quantity!==s.quantity)throw new io}else{let u=MW(s),p=u.isPurchaseMaster&&u.personId&&u.itemId?r.filter(m=>xW(m,s,t,o)):[];if(p.length>1)throw new io;c=p[0]||sf(e,s)}if(!xW(c,s,t,o))throw new io;return c});if(new Set(i.map(s=>s.key)).size!==i.length)throw new io;return i}function P4(e){if(!e||e.purchaseMasterReceiptItems)return;let t=e.purchaseMasterSnapshotItems||e.items;if(!(new Set(t.map(n=>n.key)).size!==t.length||t.some(n=>!n.key))&&!t.some(n=>bt(n)&&!cr(n))&&!(!e.purchaseMasterSnapshotItems&&(!t.every(cr)||(e.purchaseMasterTransformSummaries||[]).some(o=>!bt(o)||!cr(o)||!t.some(i=>i.key===o.key&&bt(i))))))return t===e.items?e:{...e,items:t}}async function UW(e,t,r,n){return yP(r)?hs(async()=>{let o=P4(n)||await _l(e),i=x4(o,t),a=(i==null?void 0:i.item_components)||[];if(!i||!a.length){if(!t.selections.length){let d=bW(o,t);if(d.length){let u=Object.fromEntries(d.map(p=>[p.key,0]));return d.length===1?eu(e,d[0],{quantity:0},r,o):Kl(e,{updates:u},r,o)}}if(o.items.some(d=>{let u=he(d);return fs(d)&&u.personId===t.personId&&u.itemId===t.itemId}))throw new io;let l=bW(o,t),c=Object.fromEntries(l.map(d=>[d.key,0]));return Object.keys(c).length?l.length===1?eu(e,l[0],{quantity:0},r,o):Kl(e,{updates:c},r,o):o}try{let s=await e("cart/change.js",{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify({id:i.key,quantity:0})});if(!s.ok)throw new Lo("delete",s.status);let l=await Gm(e,s,{allowRenderedFallback:!1}),c=[...a,...t.selections];if(xe(l).some(u=>c.some(p=>yW(u,p)))){let u=await Dr(e),p=u.items.filter(m=>c.some(g=>yW(m,g)));if(p.length)return Kl(e,{updates:Object.fromEntries(p.map(m=>[m.key,0]))},r,u)}return py(l,o,new Set(a.map(u=>u.key)))}catch(s){if(s instanceof Lo)throw s;try{let l=await Dr(e);if(!a.length||!b4(l,a))return l}catch(l){}throw s}},r):Dd(o=>UW(e,t,o))}function IW(e,t,r){return Dd(async n=>{let o=await Dr(e),i=!1,a=c=>(c!==o&&(i=!0),o=c,o),l=await t({read:()=>o,add:async(c,d={sent:!1},u={})=>a(await _m(e,c,d,n,o,u)),change:async(c,d)=>a(await eu(e,c,d,n,o)),remove:async c=>a(await wW(e,c,n,o)),removeBundle:async c=>a(await UW(e,c,n,o)),update:async c=>a(await Kl(e,c,n,o))});return i&&r&&a(await r(o,n)),{value:l,cart:o,changed:i}})}function lf(e,t,r){return t}var W4="trufit-cart-payload",v4="trufit:cart-updated",w4=12e3;function xs(e){window.dispatchEvent(new CustomEvent(v4,{detail:{hasVisibleItems:e.length>0,itemCount:e.reduce((t,r)=>t+(Number(r.quantity)||0),0)}}))}function Ya(){var t,r;return((r=(t=window.Shopify)==null?void 0:t.routes)==null?void 0:r.root)||"/"}async function tu(e,t={},r=w4){if(typeof AbortController!="function"||r<=0)return fetch(e,t);let n=new AbortController,o=window.setTimeout(()=>n.abort(),r);try{return await fetch(e,{...t,signal:n.signal})}finally{window.clearTimeout(o)}}async function VW(){let e=(n,o)=>tu(`${Ya()}${n}`,lf(n,o,Ya())),t=window.TrufitCart,r=null;return typeof(t==null?void 0:t.retry)=="function"?r=await t.retry():r=await vW(e),r==null?void 0:r.cart}async function cf(e,t={sent:!1},r={}){var a;let n=r.beforeCartPage===!0,o=window.TrufitCart;if(typeof(o==null?void 0:o.transaction)=="function"){await o.transaction(s=>s.add(e,t,n?{confirm:!1}:void 0),n?{render:!1}:void 0),xs(e);return}let i;try{i=await _m((s,l)=>tu(`${Ya()}${s}`,lf(s,l,Ya())),e,t,void 0,void 0,n?{confirm:!1}:void 0)}catch(s){if(!(s instanceof Fd))throw s;typeof(o==null?void 0:o.refresh)=="function"&&await o.refresh().catch(()=>{}),xs(e);return}if(n){xs(e);return}typeof(o==null?void 0:o.reconcile)=="function"?await o.reconcile({force:!0}):typeof(o==null?void 0:o.refresh)=="function"?await o.refresh().catch(()=>{}):i.sections&&((a=o==null?void 0:o.render)==null||a.call(o,i.sections)),xs(e)}function T4(){return window.TrufitCart}async function my(e,t){var a;let r={personId:e.personId,itemId:e.bundleItemId,selections:[]},n=T4();if(typeof(n==null?void 0:n.transaction)=="function"){await n.transaction(async s=>{await s.removeBundle(r),await s.add(t)}),xs(t);return}let i=await IW((s,l)=>tu(`${Ya()}${s}`,lf(s,l,Ya())),async s=>(await s.removeBundle(r),s.add(t)));i.cart.sections?(a=n==null?void 0:n.render)==null||a.call(n,i.cart.sections):typeof(n==null?void 0:n.refresh)=="function"&&await n.refresh().catch(()=>{}),xs(t)}function M4(e){let t=new TextEncoder().encode(JSON.stringify(e)),r="";return t.forEach(n=>{r+=String.fromCharCode(n)}),btoa(r).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}function U4({bridgeUrl:e,cartUrl:t,items:r}){let n=new URL(e,window.location.href),o=new URLSearchParams(n.hash.replace(/^#/,""));return o.set(W4,M4({cartUrl:t,items:r})),n.hash=o.toString(),n.toString()}function kW(e){xs(e.items),window.location.assign(U4(e))}function df(e){let t=String(e||"").trim().toLowerCase();return t.includes("lower")?"lower":t.includes("upper")?"upper":t.includes("dual")?"dual":""}function NW(e){let t=Array.from(new Set(((e==null?void 0:e.impressionPositions)||[]).map(df).filter(Boolean)));return t.includes("dual")?["upper","lower"]:t}function uf(e,t){if(!(e!=null&&e.bundleItemId)||!t||e.bundleItemId!==t)return e;let{impressionPositions:r,...n}=e;return{...n,hasImpressionKit:!1}}function bs(e,t){let r=df(t),n=((e==null?void 0:e.impressionPositions)||[]).map(df).filter(Boolean);return n.length?r==="dual"?n.includes("dual")||n.includes("upper")&&n.includes("lower"):n.includes(r)||n.includes("dual"):!1}function kt(e){return typeof e=="string"?e.trim():""}function fy(e){return kt(e.__category).replace(/\s+/g,"").toLowerCase()}function I4(e){return kt(e.__parentItemId)?!0:Boolean(kt(e.__itemId)&&kt(e.__personId)&&["extraproducts","impressionkits"].includes(fy(e)))}function V4(e){return fy(e)==="impressionkits"||Boolean(kt(e["Impression kit"]))}function LW(e){let t=he(e),r=t.properties;return Boolean(t.isPurchaseMaster&&!t.isChild&&t.itemId&&kt(r.__bundleQuantity)&&!kt(r.__purchaseMasterItemRole))}function k4(e){let t=he(e).properties,r=kt(e.variant_title).toLowerCase();return kt(t.__purchaseMasterCustomerType)==="return"||kt(t.__bundleRole)==="return"||/\breturn\b/.test(r)}function L4(e){let t=parseInt(kt(e.__personNumber),10);if(Number.isFinite(t)&&t>0)return t;let r=kt(e["First name"]),n=kt(e["Last name"]);if(r.toLowerCase()!=="person")return 0;let o=n.match(/^#(\d+)$/);return o&&parseInt(o[1],10)||0}function XW(e){let t=Number(kt(e.__personCreatedAt));if(Number.isFinite(t)&&t>0)return t;let n=kt(e.__personId).match(/^(\d{10,})/),o=n?Number(n[1]):0;return Number.isFinite(o)&&o>0?o:0}function X4(e,t=[]){e={...e,items:xe({items:e.items||[]})};let r=new Set(t.map(c=>c.split("/").pop())),n=new Set,o=new Set,i=new Map,a=new Map,s=0,l;return(e.items||[]).forEach(c=>{let d=c.properties||{},u=kt(d.__personId);if(u&&V4(d)){o.add(u);let p=i.get(u)||new Set;String(d["Impression types"]||"").split(",").map(df).filter(Boolean).forEach(m=>p.add(m)),p.size&&i.set(u,p)}u&&fy(d)==="guards"&&a.set(u,(a.get(u)||0)+Math.max(1,Number(c.quantity)||1))}),(e.items||[]).forEach(c=>{let d=c.properties||{};if(I4(d))return;let u=kt(d.__personId),p=u||kt(d.__itemId)||kt(d.__personNumber)||c.key||"";if((l==null?void 0:l.personId)===u&&!l.bundleItemId&&LW(c)&&(l={...l,bundleItemId:he(c).itemId}),!p||n.has(p))return;n.add(p);let m=L4(d)||n.size;if(s=Math.max(s,m),!l&&u&&!k4(c)){let g=kt(d["First name"]),y=kt(d["Last name"]);l={personId:u,...XW(d)?{personCreatedAt:XW(d)}:{},personNumber:m,hasImpressionKit:o.has(u),...i.has(u)?{impressionPositions:Array.from(i.get(u)||[])}:{},guardCount:a.get(u)||0,...LW(c)?{bundleItemId:he(c).itemId}:{},...g?{firstName:g}:{},...y?{lastName:y}:{}}}}),{...(e.items||[]).some(c=>Wi(c.product_type)==="guard"||r.has(String(c.product_id)))?{hasGuardInCart:!0}:{},defaultPersonStartNumber:Math.max(n.size,s)+1,defaultPerson:l}}async function EW(e,t=[]){let r=e.slice(0,e.lastIndexOf("cart.js")),n=await Dr((o,i)=>tu(`${r}${o}`,i));return X4(n,t)}var Cs=4,Hl="[A-Za-z0-9]{0,4}";function ao(e){return e.replace(/[^a-zA-Z0-9]/g,"").toUpperCase().slice(0,Cs)}function Eo(e){let t=Le(String((e==null?void 0:e.variantGids)||"").split(",")[0].trim());return/^\d+$/.test(t)?t:""}function pf(e,t){var r;return t.initialsOptIn?t.initials?Eo(e)?((r=bi(zr(e)))!=null?r:0)<=0?"ID tag price is unavailable. Please try again later.":"":"ID tag is unavailable. Please try again later.":"Enter an ID tag.":""}var mf=["Clinical","Lite"];function ff(e){var r,n;return String(((r=e.currentProduct)==null?void 0:r.handle)||"").toLowerCase()==="whitening-tray"&&!((n=e.strengths)!=null&&n.length)}function Ql(e,t){if(!ff(e))return"";let r=String((t==null?void 0:t.strength)||"");return mf.includes(r)?r:mf[0]}function AW(e,t,r){return ff(e)?{...t,strength:Ql(e,r)}:t}function Sa(e){let t=Sn(e),r=t?parseInt(t.getAttribute("data-purchase-master-quantity")||"",10):1;return Number.isFinite(r)||(r=1),Math.max(1,Math.min(r,99))}function hy(e){let t=Sn(e);if(Sa(e)>1)return!0;let n=t?t.closest(".trufit-main-product__package"):null;return[t?t.getAttribute("data-title"):"",no(n,".trufit-main-product__package-title","")].join(" ").toLowerCase().indexOf("starter")!==-1}var N4=0;function jl(){return`${Date.now()}-${N4++}`}function E4(e){let t=String(e||"").match(/^(\d{10,})/),r=t?Number(t[1]):0;return Number.isFinite(r)&&r>0?r:0}function ru(e){return String(e||"").trim().replace(/[^a-zA-Z0-9]+/g,"-").replace(/^-+|-+$/g,"").toLowerCase()}function A4(e){return Number.isFinite(e)?Math.max(0,Math.min(100,Number(e))):0}function R4(e,t,r,n,o){return["item",ru(String(e.productAlias||e.productType||"product")),ru(n),ru(o),ru(String(r)),ru(t.position)].filter(Boolean).join("-")}function ya(e,t){return!Array.isArray(e)||!e.length?"":ne(Fe(e,t||""))}function G4(e,t){let r=Fe(e,t||"");return typeof(r==null?void 0:r.textColor)=="string"?r.textColor:""}function RW(e){return String(e||"").trim().toLowerCase()}function _4(e){if(zS(e))return!0;let t=Wi(e==null?void 0:e.productType);return["guard","retainer","whiteningtray"].includes(t)?!0:[e==null?void 0:e.productTitle,e==null?void 0:e.productHandle].some(r=>/guard|retainer|mouthguard|whitening/i.test(String(r||"")))}function xa(e){return String(e||"").trim().toLowerCase()}function Yy(e){let t=String(e||"").trim();return(t.includes("/")?t.replace(/^.*\s-\s(?=[^/]+\/)/,""):t).split("/").map(xa).filter(Boolean)}function Sy(e,t){var r,n;return((n=(r=e==null?void 0:e.selectedOptions)==null?void 0:r.find(o=>t.includes(xa(o.name))))==null?void 0:n.value)||""}function ba(e){return xa(Sy(e,["flow"])||Yy(e==null?void 0:e.title)[0])}function gf(e){let t=Yy(e==null?void 0:e.title),r=["starter","bundled","pro","elite","ultimate","return"];return xa(Sy(e,["type","role"])||t.find(n=>r.includes(n))||t[1]||(e==null?void 0:e.title))}function ou(e){let t=Yy(e==null?void 0:e.title),r=t[2]||(t.length===2&&["starter","bundled","return"].includes(t[0])?t[1]:"");return xa(Sy(e,["position"])||r)}function Yf(e){return Le((e==null?void 0:e.gid)||(e==null?void 0:e.id))}function yy(e){return Boolean(e&&e.available!==!1&&e.availableForSale!==!1&&Yf(e))}function GW(e){return gf(e)==="return"}function B4(e,t){let r=Le(t);return Boolean(r&&(e||[]).some(n=>Yf(n)===r&&GW(n)))}function Z4(e,t,r){let n=Cr(e.productVariants,Le(t)),o=ba(n)||"default",i=gf(n)||"return",a=(e.impressionKitProductVariants||[]).filter(d=>yy(d)&&gf(d)===i),s=a.filter(d=>ba(d)===o),l=fW(r),c=l.flatMap(d=>s.filter(u=>ou(u)===d));return o==="shop"?c[0]:c[0]||l.flatMap(d=>a.filter(u=>ba(u)==="default"&&ou(u)===d))[0]||a[0]}function _W({config:e,guardVariantId:t,impressionKitProduct:r=e.bundleImpressionKitProduct||e.impressionKitProduct,useReturnVariant:n,position:o,forceShopReturn:i=!1}){let a=n?Z4(e,t,o):void 0;if(!a&&i)return;if(!a)return r;let s=r||{};return{...s,variantGid:a.gid||a.id,variantLabel:a.title||s.variantLabel,variantPrice:a.price||s.variantPrice}}function $4({config:e,guardQuantity:t,guardVariantId:r,impressionKitProduct:n}){if(t!==1)return"";let o=Cr(e.productVariants,Le(r)),i=fn(o),a=Cr(e.impressionKitProductVariants,Le((n==null?void 0:n.variantGid)||"")),s=fn(a);return i<=0||s<=0?"":(i+s).toFixed(2)}function O4(e,t,r){let n=xa(r);if(RW(e.productType)!=="guard"&&n!=="shop")return"";let o=xa(t.position),i=(e.positions||[]).flatMap(c=>[c.value,c.label]).map(xa).filter(Boolean),a=(e.productVariants||[]).filter(c=>yy(c)&&GW(c));if(!a.length)return"";let s=n?a.filter(c=>ba(c)===n):a;if(n&&!s.length)return"";let l=s.filter(c=>o&&ou(c)===o);if(o&&i.length){let c=s.some(d=>i.includes(ou(d)));if(c&&l.length!==1)return"";if(c)return Yf(l[0])}return s.length===1?Yf(s[0]):""}function F4(e){return e!=null&&e.personId?e.isReturnCustomer||e.hasImpressionScan||e.hasImpressionType?!0:Boolean(e.hasImpressionKit&&!e.bundleItemId):!1}function D4(e){let t=RW(String(e.productType||""));return t!=="retainer"&&t!=="whiteningtray"}function BW(e,t){let r=Fe(e,t||""),n=String((r==null?void 0:r.productVariantIds)||"");return Le(n.split(",")[0])}function z4(e,t,r){return BW(e.positions,t.position)||r}function ZW({config:e,state:t,form:r,targetPerson:n,forceShopReturn:o=!1}){let i=Sn(r),a=jd(e,r,t.purchaseMasterFlow),s=Le(No(r,a,"variant-id"))||(i?i.value:""),l=z4(e,t,s),c=Cr(e.productVariants,s||l),d=ba(c),u=o?"shop":["shop","onlinestore","default","clinic"].includes(d)?d:void 0,p=Boolean(o||n&&F4(n)),m=p?O4(e,t,u):"";if(o&&!m)throw new Error("Shop / Return variant is unavailable for the selected position.");return{purchaseMasterFlow:a,formVariantId:s,mainVariantId:l,returnCustomerVariantId:m,cartMainVariantId:m||l,isReturnCustomerPurchase:p,usesReturnCustomerVariant:Boolean(p||B4(e.productVariants,m||l))}}function $W({config:e,state:t,form:r,targetPerson:n,forceShopReturn:o=!1,guardSlot:i}){let a=ZW({config:e,state:t,form:r,targetPerson:n,forceShopReturn:o}),s=Cr(e.productVariants,a.cartMainVariantId),l=Math.max(1,Number(i||Number((n==null?void 0:n.guardCount)||0)+1)),c=ba(s)==="shop"&&!a.usesReturnCustomerVariant&&!o?Cr(e.productVariants,Sf({config:e,state:t,slot:l,totalGuardQuantity:l})):s,d=fn(c);return d>0?we(d,(c==null?void 0:c.price)||"$0"):""}function K4(e,t,r){let n=`#${Math.max(1,t)}`;return e.recipientType==="someoneElse"?{firstName:e.recipientFirstName.trim()||"Person",lastName:e.recipientLastName.trim()||n}:{firstName:(r==null?void 0:r.firstName)||"Person",lastName:(r==null?void 0:r.lastName)||n}}function iu(e){let t={};return["__itemId","__personId","__personCreatedAt","__isDefaultPerson","__personNumber","__purchaseMasterSource","__purchaseMasterVariantModel","__bundleTransform","__purchaseMasterPackageId","__purchaseMasterFlow","__purchaseMasterCustomerType","__purchaseMasterImpressionKitIntent","__bundleRole","_trufitCartAddonGroupId","First name","Last name"].forEach(r=>{e[r]&&(t[r]=e[r])}),t}var H4=["Position","Sport","Strength","Thickness","Thickness Size","Color","Pad color","Initials","Edge type","Shoe Size Scale","Insole type","Shoe make","Shoe brand","Other shoe brand","Shoe model","Shoe size (Left)","Shoe size (Right)","__isDifferentShoeSize","Notes","Impression types","Compatible","Extra info"];function bf(e){let t={};return H4.forEach(r=>{e[r]&&(t[r]=e[r])}),t}function Q4(e,t){var n,o;return[(n=e.bundleImpressionKitProduct||e.impressionKitProduct)==null?void 0:n.productTitle,(o=e.bundleImpressionKitProduct||e.impressionKitProduct)==null?void 0:o.variantLabel].join(" ").toLowerCase().indexOf("dual")!==-1?"lower, upper":ya(e.positions,t.position).toLowerCase()}function OW({config:e,selectedVariantId:t,state:r,index:n,quantity:o,fallbackToSelected:i=!0}){var l;if(o<=1)return t;let s=tf({config:e,selectedVariantId:t,role:n===1?"Starter":"Bundled",state:r});if(!s&&((l=e.productVariants)!=null&&l.length))throw new Error("This guard variant is unavailable for the selected flow and position.");return s||(i?t:"")}function Sf({config:e,state:t,totalGuardQuantity:r,slot:n}){let o=ga(e,r,n,{Position:t.position});if(!o)throw new Error(`Shop guard variant is unavailable for slot ${Math.max(1,Math.floor(n))}`);return o}function j4({config:e,selectedVariantId:t,state:r,quantity:n}){return Boolean(n>1&&tf({config:e,selectedVariantId:t,role:"Bundled",state:r}))}function yf(e,t,r,n,o=1,i=jl(),a){let s=n||jl(),l=R4(e,t,r||1,s,i),{firstName:c,lastName:d}=K4(t,o,a),u={__itemId:l,__personId:s,__personCreatedAt:String((a==null?void 0:a.personCreatedAt)||E4(s)||Date.now()),__isDefaultPerson:"true",__personNumber:String(Math.max(1,o)),__purchaseMasterSource:"online-store",__category:e.productType==="insole"?"insoles":"guards","First name":c,"Last name":d},p=String(e.productAlias||e.productTitle||"").trim();p&&(u["Bundle plan"]=p);let m=String(e.bundleImageUrl||"").trim();m&&(u.__bundleImageUrl=m);let g={Position:ya(e.positions,t.position),Strength:ya(e.strengths,t.strength)||Ql(e,t),"Edge type":ya(e.edgeTypes,t.edgeType),Initials:t.initialsOptIn?t.initials:""};return D4(e)&&(g.Sport=ya(e.sports,t.sport),g["Thickness Size"]=ya(e.thicknessSizes,t.thicknessSize),g.Color=ya(e.colors,t.color),g["Pad color"]=ya(e.padColors,t.padColor),g.__initialsColor=G4(e.colors,t.color)),Object.keys(g).forEach(y=>{g[y]&&(u[y]=g[y])}),u}function q4(e){var t;return(t=e.additionalProducts)!=null&&t.length?e.additionalProducts:e.bundleProducts||[]}function J4(e,t,r){return jS(e).length?ha(e,t,r):hy(t)?q4(e):[]}function e5(e,t){return Boolean(t&&Le(e==null?void 0:e.variantGid)===t)}function xf(e,t){return[e.bundleImpressionKitProduct,e.impressionKitProduct].filter(Boolean).some(n=>e5(t,Le(n==null?void 0:n.variantGid))||n!=null&&n.productGid&&t.productGid===n.productGid?!0:Boolean((n==null?void 0:n.productHandle)&&t.productHandle===n.productHandle))}function t5(e,t){return t.find(r=>Hr(e,r))||t.find(r=>!xf(e,r))||t[0]}function hf({config:e,fallbackRole:t,product:r,selectedVariantId:n,state:o,guardSlot:i,totalGuardQuantity:a}){var c;let s=Le(r==null?void 0:r.variantGid);if(!Hr(e,r))return s;if(nu(r)&&i)return Sf({config:e,state:o,slot:i,totalGuardQuantity:a||i});let l=tf({config:e,selectedVariantId:n||s,role:Dl(r,t),state:o});if(!l&&((c=e.productVariants)!=null&&c.length))throw new Error("This package variant is unavailable for the selected flow and position.");return l||s}function r5(e,t){return!e||!t?!1:e.productGid&&t.productGid?e.productGid===t.productGid:Boolean(e.productHandle&&t.productHandle&&e.productHandle===t.productHandle)}function n5(e,t,r){return r5(t,r)||Hr(e,t)&&Hr(e,r)}function xy(e){return!e.scanClinicId||!e.scanAppointmentDate||!e.scanAppointmentTime?{}:{__scanClinicId:e.scanClinicId,"Scan center":e.scanClinicName,"Scan center phone":e.scanClinicPhone,"Scan center address":e.scanClinicAddress,"Scan appointment date":e.scanAppointmentDate,"Scan appointment time":e.scanAppointmentTime,"Scan time zone":e.scanClinicTimezone}}function FW({additionalProduct:e,properties:t,state:r}){let n=Le(e.variantGid);return n?{id:n,quantity:e.quantity||1,properties:{...iu(t),...bf(t),__parentItemId:t.__itemId,__category:"extraProducts",...t.__purchaseMasterSource==="online-store"?{}:{__bundleIncluded:"true"},...e.productTitle?{"Bundle add-on":e.productTitle}:{},...t.Initials?{Initials:t.Initials}:{},...zd(e)?xy(r):{}}}:null}function o5({configuredProduct:e,properties:t,state:r}){let{product:n}=e,o=Le(n.variantGid),i=Yn(r,e);if(!o||i<=0)return null;let a=KS(n),s=_4(n);return{id:o,quantity:i,properties:a?{...iu(t),...bf(t),__parentItemId:t.__itemId,__category:"extraProducts",__purchaseMasterStep:e.configuredStep,__purchaseMasterItemRole:"paid-bundle-accessory",...s?{__purchaseMasterAddonType:"guard",__purchaseMasterPaidGuardAddon:"true"}:{},...n.productTitle?{"Bundle add-on":n.productTitle}:{}}:{_trufitCartAccessory:"true"}}}function i5({config:e,mainVariantId:t,parentProperties:r,state:n,defaultPersonNumber:o}){let i=Ys(e,n),a=gn(e).findIndex((p,m)=>hn(p,m)===n.newCustomerProductKey),s=Le(i==null?void 0:i.variantGid)||t,l=Math.max(0,Math.min(99,n.newCustomerQuantity||0)),c=Pi(e,i,l);if(!i||!s||l<=0)return null;let d={...n,recipientType:"someoneElse",recipientFirstName:"New Customer",recipientLastName:""},u=yf(e,d,2,jl(),o+1,jl());if(u.__isDefaultPerson="false",u.__bundleQuantity=String((c==null?void 0:c.quantity)||l),u.__purchaseMasterStep="upsell-new-customer",u.__purchaseMasterFlow=r.__purchaseMasterFlow,r.__purchaseMasterVariantModel&&(u.__purchaseMasterVariantModel=r.__purchaseMasterVariantModel),r.__bundleTransform&&(u.__bundleTransform=r.__bundleTransform),r.__purchaseMasterPackageId&&(u.__purchaseMasterPackageId=r.__purchaseMasterPackageId),u.__newCustomerProductIndex=String(Math.max(0,a)),c&&r.__purchaseMasterSource!=="online-store"){let p=se(c.price),m=se(c.compareAtPrice);p>0&&(u.__bundleTargetPrice=p.toFixed(2),u.__bundleTargetIncludesExtras="true",u.__newCustomerDiscountPercent=String(c.discountPercent)),m>p&&(u.__bundleCompareAtPrice=m.toFixed(2))}return{id:s,quantity:c?1:l,properties:{...u,...i.productTitle?{"Bundle add-on":i.productTitle}:{}}}}function a5({config:e,defaultPerson:t,defaultPersonNumber:r,itemGroupId:n,packageProducts:o,parentProperties:i,personId:a,guardStates:s,state:l}){let c=t5(e,o),d=hf({config:e,fallbackRole:"Starter",product:c,selectedVariantId:Le(c==null?void 0:c.variantGid),state:l,guardSlot:i.__bundleRole==="return"?void 0:1,totalGuardQuantity:s.length});if(!c||!d)return[];zd(c)&&Object.assign(i,xy(l));let u=[{id:d,quantity:1,properties:i}];i.__purchaseMasterVariantModel==="shop-v2"&&(i.__purchaseMasterGuardSlot="1");let p=1;return o.forEach(m=>{if(m===c){let y=oo(m.quantity),P=Math.max(0,y-1);for(let Y=0;Y<P;Y+=1){p+=1;let h=s[p-1]||l,S=nu(m)?hf({config:e,fallbackRole:"Starter",product:m,selectedVariantId:Le(m.variantGid),state:h,guardSlot:i.__bundleRole==="return"?void 0:p,totalGuardQuantity:s.length}):d,b=gy({config:e,explicitVariantId:S,index:p,itemGroupId:n,parentProperties:i,personId:a,defaultPerson:t,defaultPersonNumber:r,quantity:s.length,selectedVariantId:d,state:h,guardSlot:p});b&&u.push(b)}return}if(xf(e,m))return;if(n5(e,m,c)){let y=oo(m.quantity),P=nu(m)?Le(m.variantGid):hf({config:e,fallbackRole:"Bundled",product:m,selectedVariantId:Le(m.variantGid),state:l});if(!P)return;for(let Y=0;Y<y;Y+=1){p+=1;let h=s[p-1]||l,S=nu(m)?hf({config:e,fallbackRole:"Bundled",product:m,selectedVariantId:Le(m.variantGid),state:h,guardSlot:i.__bundleRole==="return"?void 0:p,totalGuardQuantity:s.length}):P,b=gy({config:e,explicitVariantId:S,index:p,itemGroupId:n,parentProperties:i,personId:a,defaultPerson:t,defaultPersonNumber:r,quantity:s.length,selectedVariantId:d,state:h,guardSlot:p});b&&u.push(b)}return}let g=FW({additionalProduct:m,properties:i,state:l});g&&u.push(g)}),i.__bundleQuantity=String(Math.max(1,p)),u}function gy({config:e,explicitVariantId:t,index:r,itemGroupId:n,parentProperties:o,personId:i,defaultPerson:a,defaultPersonNumber:s,quantity:l,selectedVariantId:c,state:d,guardSlot:u}){let p=t||OW({config:e,selectedVariantId:c,state:d,index:r,quantity:l,fallbackToSelected:!1});return p?{id:p,quantity:1,properties:{...yf(e,d,r,i,s,n,a),__parentItemId:o.__itemId,...o.__purchaseMasterVariantModel==="shop-v2"&&u?{__purchaseMasterGuardSlot:String(u)}:{},...o.__purchaseMasterSource==="online-store"?{}:{__bundleIncluded:"true"},__purchaseMasterFlow:o.__purchaseMasterFlow,...o.__purchaseMasterVariantModel?{__purchaseMasterVariantModel:o.__purchaseMasterVariantModel}:{},...o.__bundleTransform?{__bundleTransform:o.__bundleTransform}:{},...o.__purchaseMasterPackageId?{__purchaseMasterPackageId:o.__purchaseMasterPackageId}:{}}}:null}function s5({config:e,impressionKitProduct:t=e.bundleImpressionKitProduct||e.impressionKitProduct,properties:r,state:n,guardVariantId:o="",useReturnVariant:i=!1,position:a,forceShopReturn:s=!1}){let l=_W({config:e,guardVariantId:o,impressionKitProduct:t,useReturnVariant:i,position:a,forceShopReturn:s});if(!(l!=null&&l.variantGid))return null;let c=Le(l.variantGid);if(!c)return null;let d=ne(Fe(e.sizes,n.impressionKitSize))||n.impressionKitSize||l.variantLabel||"";return{id:c,quantity:1,properties:{...iu(r),__parentItemId:r.__itemId,__category:"Impression Kits",__purchaseMasterItemRole:"impression-kit",...r.__purchaseMasterSource==="online-store"?{}:{__bundleIncluded:"true"},...l.productTitle?{"Impression kit":l.productTitle}:{},"Tray size":d,Compatible:e.productType==="insole"?"insole":"guard","Impression types":Q4(e,n)}}}function l5({config:e,parentProperties:t,properties:r,state:n}){var a;if(!n.initialsOptIn||!n.initials||!((a=e.initials)!=null&&a.variantGids))return null;let o=Eo(e.initials);if(!o)return null;let i=iu(r);return delete i.__itemId,{id:o,quantity:1,properties:{...i,...bf(r),__parentItemId:(t==null?void 0:t.__itemId)||r.__itemId,__category:"extraProducts",__purchaseMasterItemRole:"id-tag",...r.__bundleTransform==="shop-v2"?{__bundleRole:"id-tag"}:{},__guardItemId:r.__itemId,Initials:n.initials}}}function c5({config:e,parentProperties:t,properties:r,state:n}){let o=e.edgeTypes||[],i=Fe(o,n.edgeType),a=i?o.indexOf(i):-1,s=BW(o,n.edgeType);return!i||a<=0||!s?null:{id:s,quantity:1,properties:{...iu(r),...bf(r),__parentItemId:(t==null?void 0:t.__itemId)||r.__itemId,__category:"extraProducts",__purchaseMasterItemRole:"edge-type",__guardItemId:r.__itemId,"Edge type":ne(i)}}}function d5(e,t){let r=Sn(e),n=Le(No(e,t,"starter-variant-id")||(r==null?void 0:r.getAttribute("data-purchase-master-starter-variant-id"))||""),o=Le(No(e,t,"bundled-variant-id")||(r==null?void 0:r.getAttribute("data-purchase-master-bundled-variant-id"))||"");return{starterVariantId:n||(r?r.value:""),bundledVariantId:o,hasExplicitPackageVariants:Boolean(n||o)}}function u5(e,t,r,n){return ha(e,t,r,n).filter(o=>Boolean(Le(o.variantGid)))}function nu(e){return e?String(e.variantFlow||"").trim().toLowerCase()==="shop"||String(e.flow||"").trim().toLowerCase()==="shop"?!0:/^shop\s*\//i.test(String(e.variantLabel||"").trim()):!1}function au(e,t,r,n={}){var pt,R,ee,ge;let o=Boolean(n.standaloneGuardOnly),i=Sn(r),a=jd(e,r,t.purchaseMasterFlow),s=Le(No(r,a,"variant-id"))||(i?i.value:""),l=Sa(r),c=o?1:Math.max(l,((pt=n.bundleStates)==null?void 0:pt.length)||0),d=o?[]:u5(e,r,a,c),u=((R=fa(e,r))==null?void 0:R.id)||"",p=o?1:Math.max(c,qS(e,d)),m=Array.from({length:p},(q,me)=>{var Pe;return AW(e,((Pe=n.bundleStates)==null?void 0:Pe[me])||t,t)}),g=m[0]||t,y=ZW({config:e,state:g,form:r,targetPerson:n.standaloneGuardOnly&&!n.forceShopReturn?void 0:n.targetPerson,forceShopReturn:n.forceShopReturn}),{mainVariantId:P,returnCustomerVariantId:Y,cartMainVariantId:h,isReturnCustomerPurchase:S,usesReturnCustomerVariant:b}=y,W=h,C=P,w=[];if(!C)return w;for(let q of m){let me=pf(e.initials,q);if(me)throw new Error(me)}let I=n.replaceExistingBundle?uf(n.defaultPerson,(ee=n.defaultPerson)==null?void 0:ee.bundleItemId):n.defaultPerson,U=n.forceNewPerson?void 0:n.targetPerson||(t.recipientType==="me"&&!(I!=null&&I.isReturnCustomer)?I:void 0);if(b&&Y){let q=Cr(e.productVariants,W),me=d.findIndex(Pe=>Hr(e,Pe));q&&me>=0&&(d=d.map((Pe,Ut)=>Ut===me?{...Pe,variantGid:q.gid||q.id,variantLabel:q.title||Pe.variantLabel,variantPrice:q.price||Pe.variantPrice,variantFlow:ba(q),variantRole:gf(q),variantPosition:ou(q),selectedOptions:q.selectedOptions}:Pe))}let L=(U==null?void 0:U.personId)||jl(),X=jl(),N=d5(r,a),V=e.purchaseMasterFlow==="clinic"&&a==="impression-kit",z=bs(U,g.position),H=(!o||!z||n.includeImpressionKitWithStandaloneGuard===!0)&&a!=="clinic"&&!(z&&!V),E=_W({config:e,guardVariantId:W,impressionKitProduct:d.find(q=>xf(e,q)),useReturnVariant:b,position:g.position,forceShopReturn:n.forceShopReturn});if(n.forceShopReturn&&H&&!(E!=null&&E.variantGid))throw new Error("Shop / Return Impression Kit is unavailable for the selected product.");let Z=Cr(e.productVariants,W),ce=d.some(nu)||ba(Z)==="shop",ie=n.guardSlot||(o?Math.max(1,Number(((ge=n.targetPerson)==null?void 0:ge.guardCount)||0)+1):1),re=o?ie:p;ce&&(o||!d.length)&&!b&&(W=Sf({config:e,state:g,slot:ie,totalGuardQuantity:re}));let $=ce?!1:p>1&&N.hasExplicitPackageVariants?Boolean(N.bundledVariantId):j4({config:e,selectedVariantId:W,state:g,quantity:p}),D=Math.max(1,(U==null?void 0:U.personNumber)||n.defaultPersonStartNumber||1),B=yf(e,g,1,L,D,X,U);ce&&(B.__purchaseMasterVariantModel="shop-v2",B.__bundleTransform="shop-v2",o?B.__bundleRole="addon":u&&(B.__purchaseMasterPackageId=u),B.__purchaseMasterGuardSlot=String(ie));let J=b?0:A4(n.bundleDiscountPercent),A=o?"":ly(e,g,r,m,n.bundleBasePrice,p,J),O=!o&&!d.length&&b&&H&&J<=0&&$4({config:e,guardQuantity:p,guardVariantId:W,impressionKitProduct:E})||A,_=J>0&&!o?ly(e,g,r,m,n.bundleBasePrice,p):"";o||(B.__bundleQuantity=String(p)),B.__purchaseMasterFlow=a,n.impressionKitIntent==="update"&&(B.__purchaseMasterImpressionKitIntent="update"),o&&(B.__bundleRole="addon",B.__purchaseMasterItemRole="cart-addon-product",B.__purchaseMasterAddonType="guard",B.__purchaseMasterPaidGuardAddon="true",B.__category="guards"),b&&(B.__purchaseMasterCustomerType="return",o||(B.__bundleRole="return"));let K=d.some(zd);if(a==="clinic"&&!K&&Object.assign(B,xy(t)),!o&&O&&!ce&&B.__purchaseMasterSource!=="online-store"){B.__bundleTargetPrice=O,B.__bundleTargetIncludesExtras="true";let q=se(O),me=se(_);J>0&&me>q&&(B.__bundleCompareAtPrice=me.toFixed(2),B.__newCustomerDiscountPercent=String(J))}if(d.length?w.push(...a5({config:e,defaultPerson:U,defaultPersonNumber:D,itemGroupId:X,packageProducts:d,parentProperties:B,personId:L,guardStates:m,state:g})):w.push({id:ce?W:$&&N.hasExplicitPackageVariants?N.starterVariantId:$?OW({config:e,selectedVariantId:W,state:g,index:1,quantity:p}):W,quantity:1,properties:B}),!o&&!d.length&&($||ce))for(let q=2;q<=p;q+=1){let me=gy({config:e,explicitVariantId:ce?Sf({config:e,state:m[q-1]||t,slot:q,totalGuardQuantity:p}):N.hasExplicitPackageVariants?N.bundledVariantId:"",index:q,itemGroupId:X,parentProperties:B,personId:L,defaultPerson:U,defaultPersonNumber:D,quantity:p,selectedVariantId:W,state:m[q-1]||t,guardSlot:q});me&&w.push(me)}let Ye=o?[]:d.length?[]:J4(e,r,a);Ye.length&&Ye.forEach(q=>{if(xf(e,q))return;let me=FW({additionalProduct:q,properties:B,state:t});me&&w.push(me)});let Se=H?s5({config:e,impressionKitProduct:E,properties:B,state:g,guardVariantId:W,useReturnVariant:b,position:g.position,forceShopReturn:n.forceShopReturn}):null;Se&&w.push(Se);let Ce=B;if(m.forEach((q,me)=>{let Pe=me===0?B:{...yf(e,q,me+1,L,D,X,U),__parentItemId:B.__itemId,...B.__purchaseMasterSource==="online-store"?{}:{__bundleIncluded:"true"},__purchaseMasterFlow:B.__purchaseMasterFlow,...B.__purchaseMasterVariantModel?{__purchaseMasterVariantModel:B.__purchaseMasterVariantModel}:{},...B.__bundleTransform?{__bundleTransform:B.__bundleTransform}:{},...B.__purchaseMasterPackageId?{__purchaseMasterPackageId:B.__purchaseMasterPackageId}:{},...B.__purchaseMasterVariantModel==="shop-v2"?{__purchaseMasterGuardSlot:String(me+1)}:{}},Ut=l5({config:e,parentProperties:Ce,properties:Pe,state:q});Ut&&w.push(Ut);let st=c5({config:e,parentProperties:Ce,properties:Pe,state:q});st&&w.push(st)}),!o){Fl(e).forEach(me=>{let Pe=o5({configuredProduct:me,properties:B,state:t});Pe&&w.push(Pe)});let q=i5({config:e,mainVariantId:P,parentProperties:B,state:t,defaultPersonNumber:D});q&&w.push(q)}for(let q of w){let me=Cr(e.productVariants,String(q.id));if(me&&!yy(me))throw new Error("A selected variant is no longer available.");q.properties=ko(q.properties)}return w}var er=function(){return er=Object.assign||function(t){for(var r,n=1,o=arguments.length;n<o;n++){r=arguments[n];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t},er.apply(this,arguments)};function Ps(e,t,r){if(r||arguments.length===2)for(var n=0,o=t.length,i;n<o;n++)(i||!(n in t))&&(i||(i=Array.prototype.slice.call(t,0,n)),i[n]=t[n]);return e.concat(i||Array.prototype.slice.call(t))}var nt=T(oe()),vv=T(zW());var He="-ms-",Ws="-moz-",_e="-webkit-",Cf="comm",Ca="rule",ql="decl";var KW="@import";var Pf="@keyframes";var HW="@layer";var by=Math.abs,su=String.fromCharCode,lu=Object.assign;function QW(e,t){return wt(e,0)^45?(((t<<2^wt(e,0))<<2^wt(e,1))<<2^wt(e,2))<<2^wt(e,3):0}function Wf(e){return e.trim()}function so(e,t){return(e=t.exec(e))?e[0]:e}function be(e,t,r){return e.replace(t,r)}function Jl(e,t,r){return e.indexOf(t,r)}function wt(e,t){return e.charCodeAt(t)|0}function Ao(e,t,r){return e.slice(t,r)}function Lr(e){return e.length}function vf(e){return e.length}function vs(e,t){return t.push(e),e}function jW(e,t){return e.map(t).join("")}function Cy(e,t){return e.filter(function(r){return!so(r,t)})}var wf=1,ec=1,qW=0,An=0,Zt=0,tc="";function cu(e,t,r,n,o,i,a,s){return{value:e,root:t,parent:r,type:n,props:o,children:i,line:wf,column:ec,length:a,return:"",siblings:s}}function vi(e,t){return lu(cu("",null,null,"",null,null,0,e.siblings),e,{length:-e.length},t)}function ws(e){for(;e.root;)e=vi(e.root,{children:[e]});vs(e,e.siblings)}function JW(){return Zt}function ev(){return Zt=An>0?wt(tc,--An):0,ec--,Zt===10&&(ec=1,wf--),Zt}function Rn(){return Zt=An<qW?wt(tc,An++):0,ec++,Zt===10&&(ec=1,wf++),Zt}function Pa(){return wt(tc,An)}function du(){return An}function Tf(e,t){return Ao(tc,e,t)}function Py(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function tv(e){return wf=ec=1,qW=Lr(tc=e),An=0,[]}function rv(e){return tc="",e}function Mf(e){return Wf(Tf(An-1,Wy(e===91?e+2:e===40?e+1:e)))}function nv(e){for(;(Zt=Pa())&&Zt<33;)Rn();return Py(e)>2||Py(Zt)>3?"":" "}function ov(e,t){for(;--t&&Rn()&&!(Zt<48||Zt>102||Zt>57&&Zt<65||Zt>70&&Zt<97););return Tf(e,du()+(t<6&&Pa()==32&&Rn()==32))}function Wy(e){for(;Rn();)switch(Zt){case e:return An;case 34:case 39:e!==34&&e!==39&&Wy(Zt);break;case 40:e===41&&Wy(e);break;case 92:Rn();break}return An}function iv(e,t){for(;Rn()&&e+Zt!==47+10;)if(e+Zt===42+42&&Pa()===47)break;return"/*"+Tf(t,An-1)+"*"+su(e===47?e:Rn())}function av(e){for(;!Py(Pa());)Rn();return Tf(e,An)}function cv(e){return rv(Uf("",null,null,null,[""],e=tv(e),0,[0],e))}function Uf(e,t,r,n,o,i,a,s,l){for(var c=0,d=0,u=a,p=0,m=0,g=0,y=1,P=1,Y=1,h=0,S="",b=o,W=i,C=n,w=S;P;)switch(g=h,h=Rn()){case 40:if(g!=108&&wt(w,u-1)==58){Jl(w+=be(Mf(h),"&","&\f"),"&\f",by(c?s[c-1]:0))!=-1&&(Y=-1);break}case 34:case 39:case 91:w+=Mf(h);break;case 9:case 10:case 13:case 32:w+=nv(g);break;case 92:w+=ov(du()-1,7);continue;case 47:switch(Pa()){case 42:case 47:vs(p5(iv(Rn(),du()),t,r,l),l);break;default:w+="/"}break;case 123*y:s[c++]=Lr(w)*Y;case 125*y:case 59:case 0:switch(h){case 0:case 125:P=0;case 59+d:Y==-1&&(w=be(w,/\f/g,"")),m>0&&Lr(w)-u&&vs(m>32?lv(w+";",n,r,u-1,l):lv(be(w," ","")+";",n,r,u-2,l),l);break;case 59:w+=";";default:if(vs(C=sv(w,t,r,c,d,o,s,S,b=[],W=[],u,i),i),h===123)if(d===0)Uf(w,t,C,C,b,i,u,s,W);else switch(p===99&&wt(w,3)===110?100:p){case 100:case 108:case 109:case 115:Uf(e,C,C,n&&vs(sv(e,C,C,0,0,o,s,S,o,b=[],u,W),W),o,W,u,s,n?b:W);break;default:Uf(w,C,C,C,[""],W,0,s,W)}}c=d=m=0,y=Y=1,S=w="",u=a;break;case 58:u=1+Lr(w),m=g;default:if(y<1){if(h==123)--y;else if(h==125&&y++==0&&ev()==125)continue}switch(w+=su(h),h*y){case 38:Y=d>0?1:(w+="\f",-1);break;case 44:s[c++]=(Lr(w)-1)*Y,Y=1;break;case 64:Pa()===45&&(w+=Mf(Rn())),p=Pa(),d=u=Lr(S=w+=av(du())),h++;break;case 45:g===45&&Lr(w)==2&&(y=0)}}return i}function sv(e,t,r,n,o,i,a,s,l,c,d,u){for(var p=o-1,m=o===0?i:[""],g=vf(m),y=0,P=0,Y=0;y<n;++y)for(var h=0,S=Ao(e,p+1,p=by(P=a[y])),b=e;h<g;++h)(b=Wf(P>0?m[h]+" "+S:be(S,/&\f/g,m[h])))&&(l[Y++]=b);return cu(e,t,r,o===0?Ca:s,l,c,d,u)}function p5(e,t,r,n){return cu(e,t,r,Cf,su(JW()),Ao(e,2,-2),0,n)}function lv(e,t,r,n,o){return cu(e,t,r,ql,Ao(e,0,n),Ao(e,n+1,-1),n,o)}function vy(e,t,r){switch(QW(e,t)){case 5103:return _e+"print-"+e+e;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return _e+e+e;case 4789:return Ws+e+e;case 5349:case 4246:case 4810:case 6968:case 2756:return _e+e+Ws+e+He+e+e;case 5936:switch(wt(e,t+11)){case 114:return _e+e+He+be(e,/[svh]\w+-[tblr]{2}/,"tb")+e;case 108:return _e+e+He+be(e,/[svh]\w+-[tblr]{2}/,"tb-rl")+e;case 45:return _e+e+He+be(e,/[svh]\w+-[tblr]{2}/,"lr")+e}case 6828:case 4268:case 2903:return _e+e+He+e+e;case 6165:return _e+e+He+"flex-"+e+e;case 5187:return _e+e+be(e,/(\w+).+(:[^]+)/,_e+"box-$1$2"+He+"flex-$1$2")+e;case 5443:return _e+e+He+"flex-item-"+be(e,/flex-|-self/g,"")+(so(e,/flex-|baseline/)?"":He+"grid-row-"+be(e,/flex-|-self/g,""))+e;case 4675:return _e+e+He+"flex-line-pack"+be(e,/align-content|flex-|-self/g,"")+e;case 5548:return _e+e+He+be(e,"shrink","negative")+e;case 5292:return _e+e+He+be(e,"basis","preferred-size")+e;case 6060:return _e+"box-"+be(e,"-grow","")+_e+e+He+be(e,"grow","positive")+e;case 4554:return _e+be(e,/([^-])(transform)/g,"$1"+_e+"$2")+e;case 6187:return be(be(be(e,/(zoom-|grab)/,_e+"$1"),/(image-set)/,_e+"$1"),e,"")+e;case 5495:case 3959:return be(e,/(image-set\([^]*)/,_e+"$1$`$1");case 4968:return be(be(e,/(.+:)(flex-)?(.*)/,_e+"box-pack:$3"+He+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+_e+e+e;case 4200:if(!so(e,/flex-|baseline/))return He+"grid-column-align"+Ao(e,t)+e;break;case 2592:case 3360:return He+be(e,"template-","")+e;case 4384:case 3616:return r&&r.some(function(n,o){return t=o,so(n.props,/grid-\w+-end/)})?~Jl(e+(r=r[t].value),"span",0)?e:He+be(e,"-start","")+e+He+"grid-row-span:"+(~Jl(r,"span",0)?so(r,/\d+/):+so(r,/\d+/)-+so(e,/\d+/))+";":He+be(e,"-start","")+e;case 4896:case 4128:return r&&r.some(function(n){return so(n.props,/grid-\w+-start/)})?e:He+be(be(e,"-end","-span"),"span ","")+e;case 4095:case 3583:case 4068:case 2532:return be(e,/(.+)-inline(.+)/,_e+"$1$2")+e;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(Lr(e)-1-t>6)switch(wt(e,t+1)){case 109:if(wt(e,t+4)!==45)break;case 102:return be(e,/(.+:)(.+)-([^]+)/,"$1"+_e+"$2-$3$1"+Ws+(wt(e,t+3)==108?"$3":"$2-$3"))+e;case 115:return~Jl(e,"stretch",0)?vy(be(e,"stretch","fill-available"),t,r)+e:e}break;case 5152:case 5920:return be(e,/(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/,function(n,o,i,a,s,l,c){return He+o+":"+i+c+(a?He+o+"-span:"+(s?l:+l-+i)+c:"")+e});case 4949:if(wt(e,t+6)===121)return be(e,":",":"+_e)+e;break;case 6444:switch(wt(e,wt(e,14)===45?18:11)){case 120:return be(e,/(.+:)([^;\s!]+)(;|(\s+)?!.+)?/,"$1"+_e+(wt(e,14)===45?"inline-":"")+"box$3$1"+_e+"$2$3$1"+He+"$2box$3")+e;case 100:return be(e,":",":"+He)+e}break;case 5719:case 2647:case 2135:case 3927:case 2391:return be(e,"scroll-","scroll-snap-")+e}return e}function rc(e,t){for(var r="",n=0;n<e.length;n++)r+=t(e[n],n,e,t)||"";return r}function dv(e,t,r,n){switch(e.type){case HW:if(e.children.length)break;case KW:case ql:return e.return=e.return||e.value;case Cf:return"";case Pf:return e.return=e.value+"{"+rc(e.children,n)+"}";case Ca:if(!Lr(e.value=e.props.join(",")))return""}return Lr(r=rc(e.children,n))?e.return=e.value+"{"+r+"}":""}function uv(e){var t=vf(e);return function(r,n,o,i){for(var a="",s=0;s<t;s++)a+=e[s](r,n,o,i)||"";return a}}function pv(e){return function(t){t.root||(t=t.return)&&e(t)}}function mv(e,t,r,n){if(e.length>-1&&!e.return)switch(e.type){case ql:e.return=vy(e.value,e.length,r);return;case Pf:return rc([vi(e,{value:be(e.value,"@","@"+_e)})],n);case Ca:if(e.length)return jW(r=e.props,function(o){switch(so(o,n=/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":ws(vi(e,{props:[be(o,/:(read-\w+)/,":"+Ws+"$1")]})),ws(vi(e,{props:[o]})),lu(e,{props:Cy(r,n)});break;case"::placeholder":ws(vi(e,{props:[be(o,/:(plac\w+)/,":"+_e+"input-$1")]})),ws(vi(e,{props:[be(o,/:(plac\w+)/,":"+Ws+"$1")]})),ws(vi(e,{props:[be(o,/:(plac\w+)/,He+"input-$1")]})),ws(vi(e,{props:[o]})),lu(e,{props:Cy(r,n)});break}return""})}}var fv={animationIterationCount:1,aspectRatio:1,borderImageOutset:1,borderImageSlice:1,borderImageWidth:1,boxFlex:1,boxFlexGroup:1,boxOrdinalGroup:1,columnCount:1,columns:1,flex:1,flexGrow:1,flexPositive:1,flexShrink:1,flexNegative:1,flexOrder:1,gridRow:1,gridRowEnd:1,gridRowSpan:1,gridRowStart:1,gridColumn:1,gridColumnEnd:1,gridColumnSpan:1,gridColumnStart:1,msGridRow:1,msGridRowSpan:1,msGridColumn:1,msGridColumnSpan:1,fontWeight:1,lineHeight:1,opacity:1,order:1,orphans:1,tabSize:1,widows:1,zIndex:1,zoom:1,WebkitLineClamp:1,fillOpacity:1,floodOpacity:1,stopOpacity:1,strokeDasharray:1,strokeDashoffset:1,strokeMiterlimit:1,strokeOpacity:1,strokeWidth:1};var Ti=typeof process!="undefined"&&process.env!==void 0&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",wv="active",Xf="data-styled-version",oc="6.1.19",Xy=`/*!sc*/
`,Nf=typeof window!="undefined"&&typeof document!="undefined",m5=Boolean(typeof SC_DISABLE_SPEEDY=="boolean"?SC_DISABLE_SPEEDY:typeof process!="undefined"&&process.env!==void 0&&process.env.REACT_APP_SC_DISABLE_SPEEDY!==void 0&&process.env.REACT_APP_SC_DISABLE_SPEEDY!==""?process.env.REACT_APP_SC_DISABLE_SPEEDY!=="false"&&process.env.REACT_APP_SC_DISABLE_SPEEDY:typeof process!="undefined"&&process.env!==void 0&&process.env.SC_DISABLE_SPEEDY!==void 0&&process.env.SC_DISABLE_SPEEDY!==""?process.env.SC_DISABLE_SPEEDY!=="false"&&process.env.SC_DISABLE_SPEEDY:!1),f5={};var Rf=Object.freeze([]),ic=Object.freeze({});function Tv(e,t,r){return r===void 0&&(r=ic),e.theme!==r.theme&&e.theme||t||r.theme}var Mv=new Set(["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","use","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","tspan"]),h5=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,g5=/(^-|-$)/g;function hv(e){return e.replace(h5,"-").replace(g5,"")}var Y5=/(a)(d)/gi,If=52,gv=function(e){return String.fromCharCode(e+(e>25?39:97))};function Uy(e){var t,r="";for(t=Math.abs(e);t>If;t=t/If|0)r=gv(t%If)+r;return(gv(t%If)+r).replace(Y5,"$1-$2")}var wy,Uv=5381,nc=function(e,t){for(var r=t.length;r;)e=33*e^t.charCodeAt(--r);return e},Iv=function(e){return nc(Uv,e)};function Ny(e){return Uy(Iv(e)>>>0)}function S5(e){return e.displayName||e.name||"Component"}function Ty(e){return typeof e=="string"&&!0}var Vv=typeof Symbol=="function"&&Symbol.for,kv=Vv?Symbol.for("react.memo"):60115,y5=Vv?Symbol.for("react.forward_ref"):60112,x5={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},b5={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},Lv={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},C5=((wy={})[y5]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},wy[kv]=Lv,wy);function Yv(e){return("type"in(t=e)&&t.type.$$typeof)===kv?Lv:"$$typeof"in e?C5[e.$$typeof]:x5;var t}var P5=Object.defineProperty,W5=Object.getOwnPropertyNames,Sv=Object.getOwnPropertySymbols,v5=Object.getOwnPropertyDescriptor,w5=Object.getPrototypeOf,yv=Object.prototype;function Xv(e,t,r){if(typeof t!="string"){if(yv){var n=w5(t);n&&n!==yv&&Xv(e,n,r)}var o=W5(t);Sv&&(o=o.concat(Sv(t)));for(var i=Yv(e),a=Yv(t),s=0;s<o.length;++s){var l=o[s];if(!(l in b5||r&&r[l]||a&&l in a||i&&l in i)){var c=v5(t,l);try{P5(e,l,c)}catch(d){}}}}return e}function ac(e){return typeof e=="function"}function Ey(e){return typeof e=="object"&&"styledComponentId"in e}function Ts(e,t){return e&&t?"".concat(e," ").concat(t):e||t||""}function uu(e,t){if(e.length===0)return"";for(var r=e[0],n=1;n<e.length;n++)r+=t?t+e[n]:e[n];return r}function pu(e){return e!==null&&typeof e=="object"&&e.constructor.name===Object.name&&!("props"in e&&e.$$typeof)}function Iy(e,t,r){if(r===void 0&&(r=!1),!r&&!pu(e)&&!Array.isArray(e))return t;if(Array.isArray(t))for(var n=0;n<t.length;n++)e[n]=Iy(e[n],t[n]);else if(pu(t))for(var n in t)e[n]=Iy(e[n],t[n]);return e}function Ay(e,t){Object.defineProperty(e,"toString",{value:t})}function wi(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e," for more information.").concat(t.length>0?" Args: ".concat(t.join(", ")):""))}var T5=function(){function e(t){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=t}return e.prototype.indexOfGroup=function(t){for(var r=0,n=0;n<t;n++)r+=this.groupSizes[n];return r},e.prototype.insertRules=function(t,r){if(t>=this.groupSizes.length){for(var n=this.groupSizes,o=n.length,i=o;t>=i;)if((i<<=1)<0)throw wi(16,"".concat(t));this.groupSizes=new Uint32Array(i),this.groupSizes.set(n),this.length=i;for(var a=o;a<i;a++)this.groupSizes[a]=0}for(var s=this.indexOfGroup(t+1),l=(a=0,r.length);a<l;a++)this.tag.insertRule(s,r[a])&&(this.groupSizes[t]++,s++)},e.prototype.clearGroup=function(t){if(t<this.length){var r=this.groupSizes[t],n=this.indexOfGroup(t),o=n+r;this.groupSizes[t]=0;for(var i=n;i<o;i++)this.tag.deleteRule(n)}},e.prototype.getGroup=function(t){var r="";if(t>=this.length||this.groupSizes[t]===0)return r;for(var n=this.groupSizes[t],o=this.indexOfGroup(t),i=o+n,a=o;a<i;a++)r+="".concat(this.tag.getRule(a)).concat(Xy);return r},e}(),G$=1<<30,kf=new Map,Ef=new Map,Lf=1,Vf=function(e){if(kf.has(e))return kf.get(e);for(;Ef.has(Lf);)Lf++;var t=Lf++;return kf.set(e,t),Ef.set(t,e),t},M5=function(e,t){Lf=t+1,kf.set(e,t),Ef.set(t,e)},U5="style[".concat(Ti,"][").concat(Xf,'="').concat(oc,'"]'),I5=new RegExp("^".concat(Ti,'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),V5=function(e,t,r){for(var n,o=r.split(","),i=0,a=o.length;i<a;i++)(n=o[i])&&e.registerName(t,n)},k5=function(e,t){for(var r,n=((r=t.textContent)!==null&&r!==void 0?r:"").split(Xy),o=[],i=0,a=n.length;i<a;i++){var s=n[i].trim();if(s){var l=s.match(I5);if(l){var c=0|parseInt(l[1],10),d=l[2];c!==0&&(M5(d,c),V5(e,d,l[3]),e.getTag().insertRules(c,o)),o.length=0}else o.push(s)}}},xv=function(e){for(var t=document.querySelectorAll(U5),r=0,n=t.length;r<n;r++){var o=t[r];o&&o.getAttribute(Ti)!==wv&&(k5(e,o),o.parentNode&&o.parentNode.removeChild(o))}};function Vy(){return typeof __webpack_nonce__!="undefined"?__webpack_nonce__:null}var Nv=function(e){var t=document.head,r=e||t,n=document.createElement("style"),o=function(s){var l=Array.from(s.querySelectorAll("style[".concat(Ti,"]")));return l[l.length-1]}(r),i=o!==void 0?o.nextSibling:null;n.setAttribute(Ti,wv),n.setAttribute(Xf,oc);var a=Vy();return a&&n.setAttribute("nonce",a),r.insertBefore(n,i),n},L5=function(){function e(t){this.element=Nv(t),this.element.appendChild(document.createTextNode("")),this.sheet=function(r){if(r.sheet)return r.sheet;for(var n=document.styleSheets,o=0,i=n.length;o<i;o++){var a=n[o];if(a.ownerNode===r)return a}throw wi(17)}(this.element),this.length=0}return e.prototype.insertRule=function(t,r){try{return this.sheet.insertRule(r,t),this.length++,!0}catch(n){return!1}},e.prototype.deleteRule=function(t){this.sheet.deleteRule(t),this.length--},e.prototype.getRule=function(t){var r=this.sheet.cssRules[t];return r&&r.cssText?r.cssText:""},e}(),X5=function(){function e(t){this.element=Nv(t),this.nodes=this.element.childNodes,this.length=0}return e.prototype.insertRule=function(t,r){if(t<=this.length&&t>=0){var n=document.createTextNode(r);return this.element.insertBefore(n,this.nodes[t]||null),this.length++,!0}return!1},e.prototype.deleteRule=function(t){this.element.removeChild(this.nodes[t]),this.length--},e.prototype.getRule=function(t){return t<this.length?this.nodes[t].textContent:""},e}(),N5=function(){function e(t){this.rules=[],this.length=0}return e.prototype.insertRule=function(t,r){return t<=this.length&&(this.rules.splice(t,0,r),this.length++,!0)},e.prototype.deleteRule=function(t){this.rules.splice(t,1),this.length--},e.prototype.getRule=function(t){return t<this.length?this.rules[t]:""},e}(),bv=Nf,E5={isServer:!Nf,useCSSOMInjection:!m5},mu=function(){function e(t,r,n){t===void 0&&(t=ic),r===void 0&&(r={});var o=this;this.options=er(er({},E5),t),this.gs=r,this.names=new Map(n),this.server=!!t.isServer,!this.server&&Nf&&bv&&(bv=!1,xv(this)),Ay(this,function(){return function(i){for(var a=i.getTag(),s=a.length,l="",c=function(u){var p=function(Y){return Ef.get(Y)}(u);if(p===void 0)return"continue";var m=i.names.get(p),g=a.getGroup(u);if(m===void 0||!m.size||g.length===0)return"continue";var y="".concat(Ti,".g").concat(u,'[id="').concat(p,'"]'),P="";m!==void 0&&m.forEach(function(Y){Y.length>0&&(P+="".concat(Y,","))}),l+="".concat(g).concat(y,'{content:"').concat(P,'"}').concat(Xy)},d=0;d<s;d++)c(d);return l}(o)})}return e.registerId=function(t){return Vf(t)},e.prototype.rehydrate=function(){!this.server&&Nf&&xv(this)},e.prototype.reconstructWithOptions=function(t,r){return r===void 0&&(r=!0),new e(er(er({},this.options),t),this.gs,r&&this.names||void 0)},e.prototype.allocateGSInstance=function(t){return this.gs[t]=(this.gs[t]||0)+1},e.prototype.getTag=function(){return this.tag||(this.tag=(t=function(r){var n=r.useCSSOMInjection,o=r.target;return r.isServer?new N5(o):n?new L5(o):new X5(o)}(this.options),new T5(t)));var t},e.prototype.hasNameForId=function(t,r){return this.names.has(t)&&this.names.get(t).has(r)},e.prototype.registerName=function(t,r){if(Vf(t),this.names.has(t))this.names.get(t).add(r);else{var n=new Set;n.add(r),this.names.set(t,n)}},e.prototype.insertRules=function(t,r,n){this.registerName(t,r),this.getTag().insertRules(Vf(t),n)},e.prototype.clearNames=function(t){this.names.has(t)&&this.names.get(t).clear()},e.prototype.clearRules=function(t){this.getTag().clearGroup(Vf(t)),this.clearNames(t)},e.prototype.clearTag=function(){this.tag=void 0},e}(),A5=/&/g,R5=/^\s*\/\/.*$/gm;function Ev(e,t){return e.map(function(r){return r.type==="rule"&&(r.value="".concat(t," ").concat(r.value),r.value=r.value.replaceAll(",",",".concat(t," ")),r.props=r.props.map(function(n){return"".concat(t," ").concat(n)})),Array.isArray(r.children)&&r.type!=="@keyframes"&&(r.children=Ev(r.children,t)),r})}function Av(e){var t,r,n,o=e===void 0?ic:e,i=o.options,a=i===void 0?ic:i,s=o.plugins,l=s===void 0?Rf:s,c=function(p,m,g){return g.startsWith(r)&&g.endsWith(r)&&g.replaceAll(r,"").length>0?".".concat(t):p},d=l.slice();d.push(function(p){p.type===Ca&&p.value.includes("&")&&(p.props[0]=p.props[0].replace(A5,r).replace(n,c))}),a.prefix&&d.push(mv),d.push(dv);var u=function(p,m,g,y){m===void 0&&(m=""),g===void 0&&(g=""),y===void 0&&(y="&"),t=y,r=m,n=new RegExp("\\".concat(r,"\\b"),"g");var P=p.replace(R5,""),Y=cv(g||m?"".concat(g," ").concat(m," { ").concat(P," }"):P);a.namespace&&(Y=Ev(Y,a.namespace));var h=[];return rc(Y,uv(d.concat(pv(function(S){return h.push(S)})))),h};return u.hash=l.length?l.reduce(function(p,m){return m.name||wi(15),nc(p,m.name)},Uv).toString():"",u}var G5=new mu,ky=Av(),Ry=nt.default.createContext({shouldForwardProp:void 0,styleSheet:G5,stylis:ky}),_$=Ry.Consumer,_5=nt.default.createContext(void 0);function Af(){return(0,nt.useContext)(Ry)}function B5(e){var t=(0,nt.useState)(e.stylisPlugins),r=t[0],n=t[1],o=Af().styleSheet,i=(0,nt.useMemo)(function(){var l=o;return e.sheet?l=e.sheet:e.target&&(l=l.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(l=l.reconstructWithOptions({useCSSOMInjection:!1})),l},[e.disableCSSOMInjection,e.sheet,e.target,o]),a=(0,nt.useMemo)(function(){return Av({options:{namespace:e.namespace,prefix:e.enableVendorPrefixes},plugins:r})},[e.enableVendorPrefixes,e.namespace,r]);(0,nt.useEffect)(function(){(0,vv.default)(r,e.stylisPlugins)||n(e.stylisPlugins)},[e.stylisPlugins]);var s=(0,nt.useMemo)(function(){return{shouldForwardProp:e.shouldForwardProp,styleSheet:i,stylis:a}},[e.shouldForwardProp,i,a]);return nt.default.createElement(Ry.Provider,{value:s},nt.default.createElement(_5.Provider,{value:a},e.children))}var Rv=function(){function e(t,r){var n=this;this.inject=function(o,i){i===void 0&&(i=ky);var a=n.name+i.hash;o.hasNameForId(n.id,a)||o.insertRules(n.id,a,i(n.rules,a,"@keyframes"))},this.name=t,this.id="sc-keyframes-".concat(t),this.rules=r,Ay(this,function(){throw wi(12,String(n.name))})}return e.prototype.getName=function(t){return t===void 0&&(t=ky),this.name+t.hash},e}(),Z5=function(e){return e>="A"&&e<="Z"};function Cv(e){for(var t="",r=0;r<e.length;r++){var n=e[r];if(r===1&&n==="-"&&e[0]==="-")return e;Z5(n)?t+="-"+n.toLowerCase():t+=n}return t.startsWith("ms-")?"-"+t:t}var Gv=function(e){return e==null||e===!1||e===""},_v=function(e){var t,r,n=[];for(var o in e){var i=e[o];e.hasOwnProperty(o)&&!Gv(i)&&(Array.isArray(i)&&i.isCss||ac(i)?n.push("".concat(Cv(o),":"),i,";"):pu(i)?n.push.apply(n,Ps(Ps(["".concat(o," {")],_v(i),!1),["}"],!1)):n.push("".concat(Cv(o),": ").concat((t=o,(r=i)==null||typeof r=="boolean"||r===""?"":typeof r!="number"||r===0||t in fv||t.startsWith("--")?String(r).trim():"".concat(r,"px")),";")))}return n};function Wa(e,t,r,n){if(Gv(e))return[];if(Ey(e))return[".".concat(e.styledComponentId)];if(ac(e)){if(!ac(i=e)||i.prototype&&i.prototype.isReactComponent||!t)return[e];var o=e(t);return Wa(o,t,r,n)}var i;return e instanceof Rv?r?(e.inject(r,n),[e.getName(n)]):[e]:pu(e)?_v(e):Array.isArray(e)?Array.prototype.concat.apply(Rf,e.map(function(a){return Wa(a,t,r,n)})):[e.toString()]}function Bv(e){for(var t=0;t<e.length;t+=1){var r=e[t];if(ac(r)&&!Ey(r))return!1}return!0}var $5=Iv(oc),O5=function(){function e(t,r,n){this.rules=t,this.staticRulesId="",this.isStatic=(n===void 0||n.isStatic)&&Bv(t),this.componentId=r,this.baseHash=nc($5,r),this.baseStyle=n,mu.registerId(r)}return e.prototype.generateAndInjectStyles=function(t,r,n){var o=this.baseStyle?this.baseStyle.generateAndInjectStyles(t,r,n):"";if(this.isStatic&&!n.hash)if(this.staticRulesId&&r.hasNameForId(this.componentId,this.staticRulesId))o=Ts(o,this.staticRulesId);else{var i=uu(Wa(this.rules,t,r,n)),a=Uy(nc(this.baseHash,i)>>>0);if(!r.hasNameForId(this.componentId,a)){var s=n(i,".".concat(a),void 0,this.componentId);r.insertRules(this.componentId,a,s)}o=Ts(o,a),this.staticRulesId=a}else{for(var l=nc(this.baseHash,n.hash),c="",d=0;d<this.rules.length;d++){var u=this.rules[d];if(typeof u=="string")c+=u;else if(u){var p=uu(Wa(u,t,r,n));l=nc(l,p+d),c+=p}}if(c){var m=Uy(l>>>0);r.hasNameForId(this.componentId,m)||r.insertRules(this.componentId,m,n(c,".".concat(m),void 0,this.componentId)),o=Ts(o,m)}}return o},e}(),Gy=nt.default.createContext(void 0),B$=Gy.Consumer;var My={};function F5(e,t,r){var n=Ey(e),o=e,i=!Ty(e),a=t.attrs,s=a===void 0?Rf:a,l=t.componentId,c=l===void 0?function(b,W){var C=typeof b!="string"?"sc":hv(b);My[C]=(My[C]||0)+1;var w="".concat(C,"-").concat(Ny(oc+C+My[C]));return W?"".concat(W,"-").concat(w):w}(t.displayName,t.parentComponentId):l,d=t.displayName,u=d===void 0?function(b){return Ty(b)?"styled.".concat(b):"Styled(".concat(S5(b),")")}(e):d,p=t.displayName&&t.componentId?"".concat(hv(t.displayName),"-").concat(t.componentId):t.componentId||c,m=n&&o.attrs?o.attrs.concat(s).filter(Boolean):s,g=t.shouldForwardProp;if(n&&o.shouldForwardProp){var y=o.shouldForwardProp;if(t.shouldForwardProp){var P=t.shouldForwardProp;g=function(b,W){return y(b,W)&&P(b,W)}}else g=y}var Y=new O5(r,p,n?o.componentStyle:void 0);function h(b,W){return function(C,w,I){var U=C.attrs,L=C.componentStyle,X=C.defaultProps,N=C.foldedComponentIds,V=C.styledComponentId,z=C.target,te=nt.default.useContext(Gy),H=Af(),E=C.shouldForwardProp||H.shouldForwardProp,Z=Tv(w,te,X)||ic,ce=function(J,A,O){for(var _,K=er(er({},A),{className:void 0,theme:O}),Ye=0;Ye<J.length;Ye+=1){var Se=ac(_=J[Ye])?_(K):_;for(var Ce in Se)K[Ce]=Ce==="className"?Ts(K[Ce],Se[Ce]):Ce==="style"?er(er({},K[Ce]),Se[Ce]):Se[Ce]}return A.className&&(K.className=Ts(K.className,A.className)),K}(U,w,Z),ie=ce.as||z,re={};for(var $ in ce)ce[$]===void 0||$[0]==="$"||$==="as"||$==="theme"&&ce.theme===Z||($==="forwardedAs"?re.as=ce.forwardedAs:E&&!E($,ie)||(re[$]=ce[$]));var D=function(J,A){var O=Af(),_=J.generateAndInjectStyles(A,O.styleSheet,O.stylis);return _}(L,ce),B=Ts(N,V);return D&&(B+=" "+D),ce.className&&(B+=" "+ce.className),re[Ty(ie)&&!Mv.has(ie)?"class":"className"]=B,I&&(re.ref=I),(0,nt.createElement)(ie,re)}(S,b,W)}h.displayName=u;var S=nt.default.forwardRef(h);return S.attrs=m,S.componentStyle=Y,S.displayName=u,S.shouldForwardProp=g,S.foldedComponentIds=n?Ts(o.foldedComponentIds,o.styledComponentId):"",S.styledComponentId=p,S.target=n?o.target:e,Object.defineProperty(S,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(b){this._foldedDefaultProps=n?function(W){for(var C=[],w=1;w<arguments.length;w++)C[w-1]=arguments[w];for(var I=0,U=C;I<U.length;I++)Iy(W,U[I],!0);return W}({},o.defaultProps,b):b}}),Ay(S,function(){return".".concat(S.styledComponentId)}),i&&Xv(S,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0}),S}function Pv(e,t){for(var r=[e[0]],n=0,o=t.length;n<o;n+=1)r.push(t[n],e[n+1]);return r}var Wv=function(e){return Object.assign(e,{isCss:!0})};function v(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];if(ac(e)||pu(e))return Wv(Wa(Pv(Rf,Ps([e],t,!0))));var n=e;return t.length===0&&n.length===1&&typeof n[0]=="string"?Wa(n):Wv(Wa(Pv(n,t)))}function Ly(e,t,r){if(r===void 0&&(r=ic),!t)throw wi(1,t);var n=function(o){for(var i=[],a=1;a<arguments.length;a++)i[a-1]=arguments[a];return e(t,r,v.apply(void 0,Ps([o],i,!1)))};return n.attrs=function(o){return Ly(e,t,er(er({},r),{attrs:Array.prototype.concat(r.attrs,o).filter(Boolean)}))},n.withConfig=function(o){return Ly(e,t,er(er({},r),o))},n}var Zv=function(e){return Ly(F5,e)},f=Zv;Mv.forEach(function(e){f[e]=Zv(e)});var D5=function(){function e(t,r){this.rules=t,this.componentId=r,this.isStatic=Bv(t),mu.registerId(this.componentId+1)}return e.prototype.createStyles=function(t,r,n,o){var i=o(uu(Wa(this.rules,r,n,o)),""),a=this.componentId+t;n.insertRules(a,a,i)},e.prototype.removeStyles=function(t,r){r.clearRules(this.componentId+t)},e.prototype.renderStyles=function(t,r,n,o){t>2&&mu.registerId(this.componentId+t),this.removeStyles(t,n),this.createStyles(t,r,n,o)},e}();function Ms(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];var n=v.apply(void 0,Ps([e],t,!1)),o="sc-global-".concat(Ny(JSON.stringify(n))),i=new D5(n,o),a=function(l){var c=Af(),d=nt.default.useContext(Gy),u=nt.default.useRef(c.styleSheet.allocateGSInstance(o)).current;return c.styleSheet.server&&s(u,l,c.styleSheet,d,c.stylis),nt.default.useLayoutEffect(function(){if(!c.styleSheet.server)return s(u,l,c.styleSheet,d,c.stylis),function(){return i.removeStyles(u,c.styleSheet)}},[u,l,c.styleSheet,d,c.stylis]),null};function s(l,c,d,u,p){if(i.isStatic)i.renderStyles(l,f5,d,p);else{var m=er(er({},c),{theme:Tv(c,u,a.defaultProps)});i.renderStyles(l,m,d,p)}}return nt.default.memo(a)}function _y(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];var n=uu(v.apply(void 0,Ps([e],t,!1))),o=Ny(n);return new Rv(o,n)}var Z$=function(){function e(){var t=this;this._emitSheetCSS=function(){var r=t.instance.toString();if(!r)return"";var n=Vy(),o=uu([n&&'nonce="'.concat(n,'"'),"".concat(Ti,'="true"'),"".concat(Xf,'="').concat(oc,'"')].filter(Boolean)," ");return"<style ".concat(o,">").concat(r,"</style>")},this.getStyleTags=function(){if(t.sealed)throw wi(2);return t._emitSheetCSS()},this.getStyleElement=function(){var r;if(t.sealed)throw wi(2);var n=t.instance.toString();if(!n)return[];var o=((r={})[Ti]="",r[Xf]=oc,r.dangerouslySetInnerHTML={__html:n},r),i=Vy();return i&&(o.nonce=i),[nt.default.createElement("style",er({},o,{key:"sc-0-0"}))]},this.seal=function(){t.sealed=!0},this.instance=new mu({isServer:!0}),this.sealed=!1}return e.prototype.collectStyles=function(t){if(this.sealed)throw wi(2);return nt.default.createElement(B5,{sheet:this.instance},t)},e.prototype.interleaveWithNodeStream=function(t){throw wi(3)},e}();var $$="__sc-".concat(Ti,"__");var z5=f.div.attrs({className:"form-section","data-purchase-master-form-section":""})`
  position: relative;
  display: grid;
  gap: ${({$variant:e})=>e==="customization"?"8px":"0.75rem"};
  padding-bottom: ${({$variant:e})=>e==="customization"?"0":"1rem"};

  @media screen and (max-width: 749px) {
    gap: ${({$variant:e})=>e==="protection"||e==="strength"?"10px":"6px"};
    padding-bottom: ${({$variant:e})=>e==="customization"||e==="protection"||e==="thickness"?"0":"1.25rem"};
  }
`,K5=f.div.attrs({className:"form-label-row"})`
  display: flex;
  align-items: ${({$variant:e})=>e?"center":"flex-start"};
  justify-content: space-between;
  gap: 1rem;
  ${({$variant:e})=>e==="impression-kit"&&v`
      min-height: 1.5rem;
    `}

  @media screen and (max-width: 749px) {
    min-height: ${({$variant:e})=>e==="impression-kit"?"20px":"24px"};
    align-items: center;
  }
`,H5=f.p.attrs({className:"form-label"})`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: ${({$variant:e})=>e==="position"?"1.35":e==="impression-kit"?"1.25rem":"1.5rem"};

  @media screen and (max-width: 749px) {
    font-size: 18px;
    line-height: ${({$variant:e})=>e==="impression-kit"?"20px":e==="position"?"1.35":"24px"};
  }
`,Q5=f.p.attrs({className:"form-value"})`
  margin: 0;
  font-size: ${({$colorControl:e})=>e?"0.875rem":"1.125rem"};
  font-weight: ${({$colorControl:e})=>e?500:700};
  line-height: 1.5rem;
  ${({$colorControl:e})=>e&&v`
      flex: 0 0 auto;
      color: #1d1d1f;
      white-space: nowrap;
    `}
  @media screen and (max-width: 749px) {
    font-size: ${({$colorControl:e})=>e?"0.875rem":"18px"};
    line-height: 24px;
  }
`,j5=v`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`,q5=f.p.attrs({className:"field-error","data-purchase-master-field-error":""})`
  margin: 0;
  color: #a21616;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.2;

  ${({$placement:e})=>(e==="form"||e==="initials"||e==="bundle-label")&&j5}
  ${({$placement:e,$customization:t})=>e==="initials"&&t&&v`
      top: 100%;
      bottom: auto;
    `}
  ${({$placement:e})=>e==="bundle-label"&&v`
      line-height: 16px;
    `}
  ${({$placement:e})=>e==="bundle-initials"&&v`
      position: absolute;
      right: 0;
      bottom: 3px;
      width: min(100%, 259px);
      overflow: hidden;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  @media screen and (max-width: 749px) {
    ${({$placement:e})=>(e==="bundle-label"||e==="bundle-initials")&&v`
        position: static;
        width: auto;
        max-width: 100%;
        overflow: visible;
        line-height: 16px;
        text-overflow: clip;
        white-space: normal;
      `}
    ${({$placement:e})=>e==="bundle-label"&&v`
        flex: 0 0 100%;
      `}
    ${({$placement:e})=>e==="bundle-initials"&&v`
        grid-column: 2;
      `}
  }
`,J5=f.span`
  margin-left: 0.15rem;
  color: #c62828;
`,e3=f.div`
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: ${({$customization:e})=>e?"flex-start":"flex-end"};
  gap: 0.75rem;
  ${({$customization:e})=>e&&v`
      width: 100%;
      overflow-x: auto;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      @media screen and (max-width: 749px) {
        max-width: 100%;
      }
    `}
`,ht={Section:z5,LabelRow:K5,Label:H5,Value:Q5,FieldError:q5,RequiredMarker:J5,ColorControl:e3};var t3=f.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 84px;
  gap: 8px;
  align-items: start;
  @media screen and (max-width: 749px) {
    grid-template-columns: minmax(0, 1fr) 56px;
  }
`,r3=f.div`
  position: relative;
  display: grid;
  gap: 12px;
  padding-bottom: 0;
`,n3=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`,o3=f.p`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  @media screen and (max-width: 749px) {
    font-size: 18px;
    line-height: 24px;
  }
`,i3=f.p`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  @media screen and (max-width: 749px) {
    font-size: 18px;
    line-height: 24px;
  }
`,a3=f.input`
  width: 100%;
  min-height: 48px;
  border: 1px solid #888888;
  border-radius: 12px;
  padding: 0 15px;
  font: inherit;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-transform: uppercase;
  &::placeholder {
    color: #414144;
    font-weight: 400;
    text-transform: none;
  }
`,s3=f.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  border: 1px solid #ededed;
  @media screen and (max-width: 749px) {
    width: 56px;
    height: 56px;
  }
  border-radius: 0.5rem;
  overflow: hidden;
  background: #f6f6f6;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`,va={Root:t3,Body:r3,Heading:n3,Title:o3,Price:i3,Input:a3,Preview:s3};var l3=f.article`
  position: relative;
  display: grid;
  grid-template-columns: 4.25rem minmax(0, 1fr);
  align-items: center;
  gap: 1rem;
  min-width: 0;
  border: 0;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #ffffff;
  box-shadow: inset 0 0 0 0.5px #888888;
  ${({$selected:e})=>e&&v`
      box-shadow: inset 0 0 0 1.5px #111111;
    `}
  ${({$variant:e})=>e==="new-customer"&&v`
      display: block;
    `}
@media screen and (max-width: 749px) {
    gap: 0.75rem;
    padding: 0.75rem;
  }
  @media screen and (max-width: 749px) {
    grid-template-columns: 56px minmax(0, 1fr);
    gap: 12px;
    min-height: 0;
    border-radius: 12px;
    padding: 12px;
    ${({$variant:e})=>e==="new-customer"&&v`
        min-height: 0;
      `}
    ${({$stepKey:e,$placement:t,$variant:r})=>e==="upsell"&&t==="content"&&r==="new-customer"&&v`
        box-shadow: 0 12px 28px rgba(17, 17, 17, 0.16);
      `}
  }
`,c3=f.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  & img {
    display: block;
    width: 4.25rem;
    height: 4.25rem;
    border-radius: 0.5rem;
    object-fit: contain;
    background: #f8f8f8;
  }
  ${({$variant:e})=>e==="new-customer"&&v`
      width: 68px;
      height: 68px;
      overflow: hidden;

      & img {
        width: 68px;
        height: 68px;
        border-radius: 0;
        background: transparent;
      }
    `}

  @media screen and (max-width: 749px) {
    width: 56px;
    height: 56px;
    & img {
      width: 56px;
      height: 56px;
    }
  }
`,d3=f.div`
  display: flex;
  min-width: 0;
  min-height: 5.25rem;
  flex-direction: column;
  gap: 0.5rem;
  @media screen and (max-width: 749px) {
    min-height: 0;
    gap: 4px;
    ${({$variant:e})=>e==="new-customer"&&v`
        min-height: 0;
      `}
  }
`,u3=f.strong`
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.125rem;
  line-height: 1.5rem;

  @media screen and (max-width: 749px) {
    font-size: 16px;
    line-height: 20px;
  }
`,p3=f.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  margin: 0;
  color: #505050;
  font-size: 1rem;
  line-height: 1.25rem;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media screen and (max-width: 749px) {
    /* Show the whole description on phones instead of clamping it. */
    display: block;
    overflow: visible;
    text-overflow: clip;
    font-size: 13px;
    line-height: 18px;
  }
`,m3=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: auto;
  padding-top: 0;

  @media screen and (max-width: 749px) {
    align-items: center;
    gap: 8px;
  }
`,f3=f.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  flex-wrap: wrap;
  & strong {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
  & del {
    color: #888888;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
  & span {
    flex-basis: 100%;
    color: #39846c;
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    white-space: nowrap;
  }
  ${({$variant:e})=>e==="new-customer"&&v`
      gap: 8px;
      flex-wrap: nowrap;

      & span {
        flex-basis: auto;
      }
    `}
  ${({$variant:e})=>e==="popup"&&v`
      flex: 1 1 auto;
    `}
@media screen and (max-width: 749px) {
    gap: 0.375rem;
    & strong {
      font-size: 1rem;
      line-height: 1.25rem;
    }
    & del {
      font-size: 0.75rem;
      line-height: 1.25rem;
    }
    & span {
      font-size: 0.75rem;
      line-height: 1.25rem;
    }
  }
  @media screen and (max-width: 749px) {
    gap: 6px;
    flex-wrap: nowrap;
    & strong {
      font-size: 16px;
      line-height: 20px;
    }
    & del {
      font-size: 13px;
      line-height: 18px;
    }
    & span {
      flex-basis: auto;
      font-size: 13px;
      line-height: 18px;
    }
    ${({$variant:e})=>e==="popup"&&v`
        flex-wrap: nowrap;
        gap: 0.5rem;

        & span {
          flex-basis: auto;
        }
      `}
  }
`,h3=f.button`
  display: flex;
  align-items: center;
  width: 2.875rem;
  height: 1.5rem;
  border: 0;
  border-radius: 999px;
  background: #d0d0d0;
  padding: 0.125rem;
  cursor: pointer;
  transition: background 160ms ease;
  & span {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
    transition: transform 160ms ease;
  }
  ${({$checked:e,$variant:t})=>e&&v`
      background: ${t==="product"?"#c2a443":"#111111"};
      & span {
        transform: translateX(
          ${t==="product"?"1.25rem":"1.375rem"}
        );
      }
    `}
  ${({$variant:e})=>e==="product"&&v`
      width: 2.75rem;
      flex: 0 0 2.75rem;
    `}
`,Qt={Card:l3,CardMedia:c3,CardBody:d3,CardTitle:u3,CardDescription:p3,CardFooter:m3,Price:f3,Switch:h3};function Us({$objectFit:e,$layer:t}){return{style:{objectFit:e,zIndex:t}}}var g3=f.img.attrs(Us)``;function sc({$guideImageUrl:e}){return{style:e?{"--purchase-master-thickness-guide-image":`url("${e}")`}:void 0}}function Gf({$swatchStyle:e}){return{style:e}}var lo={LayerImage:g3};var Y3=f.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 0.5rem;

  & button {
    min-height: 3rem;
    border: 1px solid #888888;
    border-radius: 999px;
    background: #ffffff;
    color: #111111;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25rem;
  }

  & button:last-child {
    border-color: #111111;
    background: #111111;
    color: #ffffff;
  }
`,S3=f.span.attrs(Gf)`
  flex: 0 0 auto;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid #c6c6c8;
  border-radius: 999px;
  background: #ffffff;
`,y3=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  flex: 0 0 auto;
  width: 1.5rem;
  height: 1.5rem;
  border: 0;
  border-radius: 999px;
  background: #f0f0f0;
  color: #111111;
  cursor: pointer;
  padding: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2;

  @media screen and (max-width: 749px) {
    ${({$hideOnMobile:e})=>e&&v`
        display: none;
      `}

    width: 24px;
    height: 24px;
    font-size: 16px;
    line-height: 19px;
  }
`,Mi={CloseConfirmActions:Y3,DropdownSwatch:S3,HelpButton:y3};var x3=f.div`
  position: fixed;
  z-index: 1000001;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 1.5rem;

  @media screen and (max-width: 749px) {
    align-items: end;
    padding: 0;
  }
`,b3=f.button`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgb(0 0 0 / 50%);
  backdrop-filter: blur(6px);
`,C3=f.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: min(62.5rem, 100%);
  min-height: 31.25rem;
  overflow: hidden;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 0 24px rgb(113 113 113 / 24%);

  @media screen and (max-width: 749px) {
    display: block;
    width: 100%;
    max-height: calc(100dvh - 48px);
    overflow-y: auto;
    border-radius: 16px 16px 0 0;
  }
`,P3=f.div`
  min-height: 31.25rem;
  background: #f7f7f7;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 749px) {
    min-height: 240px;
    height: 240px;
  }
`,W3=f.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: 2.375rem 1.5rem;

  & li {
    margin: 0;
    color: #505050;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  & ul {
    display: grid;
    gap: 0.75rem;
    margin: 0;
    padding-left: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    gap: 24px;
    padding: 24px 20px 32px;
  }
`,v3=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  & h3 {
    margin: 0;
    font-size: 2rem;
    line-height: 2.5rem;
  }

  & button {
    width: 2rem;
    height: 2rem;
    border: 0;
    background: transparent;
    padding: 0.375rem;
    cursor: pointer;
  }

  & svg {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
  }

  @media screen and (max-width: 749px) {
    & h3 {
      font-size: 24px;
      line-height: 30px;
    }
  }
`,$v=f.p`
  margin: 0;
  color: #505050;
  font-size: 1rem;
  line-height: 1.5rem;
`,w3=f($v)`
  margin-top: auto;
  font-weight: 700;
`,T3=f.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5rem;

  @media screen and (max-width: 749px) {
    gap: 8px;
    font-size: 12px;
    line-height: 18px;
  }
`,M3=f.p`
  margin: 0.25rem 0 0;
  color: #667085;
  font-size: 0.75rem;
  font-style: italic;
  line-height: 1.35;
`,U3=f.p`
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
  font-style: italic;
  line-height: 1.25rem;
  text-align: center;
`,I3=f.div`
  display: grid;
  gap: 0.5rem;
  margin-top: 0.25rem;

  & > strong {
    color: #d92d20;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }

  & > p {
    margin: 0;
    color: #505050;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`,V3=f.p`
  border-radius: 0.5rem;
  background: #f1f1f1;
  padding: 0.75rem;
`,Qr={OptionHelp:x3,OptionHelpScrim:b3,OptionHelpPanel:C3,OptionHelpMedia:P3,OptionHelpContent:W3,OptionHelpHeading:v3,OptionHelpParagraph:$v,OptionHelpNote:w3,EdgeOption:T3,Description:M3,FlowNote:U3,FlowWarning:I3,FlowWarningDisclaimer:V3};var qv=T(oe());var k3=f.img`
  display: block;
  flex: 0 0 auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  ${({$variant:e})=>e==="bundle-arrow"&&v`
      display: block;
      width: 24px;
      height: 24px;
      transform: rotate(90deg);
    `}
`,L3=f.span`
  display: block;
  flex: 0 0 1.5rem;
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0.5625rem;
    left: 0.4375rem;
    width: 0.5rem;
    height: 0.5rem;
    border-right: 1.5px solid currentColor;
    border-bottom: 1.5px solid currentColor;
    transform: rotate(-45deg);
  }
  & img {
    display: block;
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
  }
  ${({$hasImage:e})=>e&&v`
      &::after {
        display: none;
      }
    `}
`,By={IconImage:k3,ButtonIcon:L3};var wa=T(k());function Ov({path:e,viewBox:t}){return(0,wa.jsx)("svg",{viewBox:t,preserveAspectRatio:"xMidYMid meet","aria-hidden":"true",focusable:"false",children:(0,wa.jsx)("path",{d:e})})}function Fv(){return(0,wa.jsx)(Ov,{viewBox:"0 0 12 20",path:"M10 2 2 10l8 8"})}function Ro(){return(0,wa.jsx)(Ov,{viewBox:"0 0 20 20",path:"m5 5 10 10M15 5 5 15"})}function tr({className:e,variant:t="default",...r}){return(0,wa.jsx)(By.IconImage,{$variant:t,...r,className:["icon-image",e||""].filter(Boolean).join(" "),alt:"","aria-hidden":"true",draggable:!1})}function Zy({iconUrl:e}){return(0,wa.jsx)(By.ButtonIcon,{$hasImage:Boolean(e),className:"button-icon","aria-hidden":"true",children:e?(0,wa.jsx)(tr,{src:e}):null})}var X3={position:["position","productDetails"],details:["productThickness","details","productDetails"],strength:["strength","productStrength"],impressionKit:["impressionKit","impressionTraySize","impressionKitProductVariantId"],clinicScan:["clinicScan"],personDetails:["personDetails","userSelection","recipient","recipientDetails","whoWillBeTakingTheImpression"],customization:["customization","productCustomization"],review:["review"],upsell:["upsell"]},N3=new Set(["contain","cover","fill","none","scale-down"]);function Is(e){let t=fu(e);return N3.has(t)?t:"contain"}function fu(e){return String(e||"").trim().toLowerCase().replace(/[^a-z0-9]+/g,"")}function E3(e,t){var l,c,d,u,p,m;let r=e==null?void 0:e.image,n=new Set([t.productType,t.compatibleProductType,t.productAlias,t.purchaseMasterFlow].map(fu).filter(Boolean)),i=(Array.isArray(e==null?void 0:e.flowImages)?e.flowImages:[]).find(g=>n.has(fu(g.type))),a=(i==null?void 0:i.imageUrl)||(e==null?void 0:e.imageUrl)||((c=(l=r==null?void 0:r.desktop)==null?void 0:l.image)==null?void 0:c.url)||((d=r==null?void 0:r.desktop)==null?void 0:d.url)||"",s=(i==null?void 0:i.mobileImageUrl)||(e==null?void 0:e.mobileImageUrl)||((p=(u=r==null?void 0:r.mobile)==null?void 0:u.image)==null?void 0:p.url)||((m=r==null?void 0:r.mobile)==null?void 0:m.url)||"";return!a&&!s?null:{url:a||s,mobileUrl:s||void 0,objectFit:Is((i==null?void 0:i.objectFit)||(e==null?void 0:e.objectFit)||(r==null?void 0:r.objectFit))}}function $y(e,t){if(t==="personDetails"){let o=String(e.personDetailsImageUrl||"").trim(),i=String(e.personDetailsMobileImageUrl||"").trim();if(o||i)return{url:o||i,mobileUrl:i||void 0,objectFit:"cover"}}let r=X3[t]||[t],n=e.stepsImages||[];return r.map(o=>E3(n.find(i=>fu(i.title)===fu(o)),e)).find(o=>Boolean(o))||null}function Ui(e,t){return t?{url:t,objectFit:Is(e==null?void 0:e.objectFit)}:null}function A3(e,t){let r=String((e==null?void 0:e.detailsImageUrl)||"").trim(),n=String((e==null?void 0:e.detailsMobileImageUrl)||"").trim();if(!r&&!n)return t;let o=r||(t==null?void 0:t.url)||"",i=n||(t==null?void 0:t.mobileUrl)||(t==null?void 0:t.url)||"";return{url:o||i,mobileUrl:i||void 0,objectFit:"contain"}}function Dv(e){return e?{url:e,objectFit:"contain"}:null}function Vs(e,t,r){var c;let n=Fe(e.positions,t.position),o=Fe(e.thicknessSizes,t.thicknessSize),i=Fe(e.strengths,t.strength),a=Fe(e.edgeTypes,t.edgeType),s=Fe(e.colors,t.color),l=$y(e,r);if(r==="position")return[l||Ui(a,Io(a))||Ui(n,Zd(n,t.position))].filter(d=>Boolean(d));if(r==="strength")return[l||Ui(i,Io(i))].filter(d=>Boolean(d));if(r==="details")return[A3(o,l||Ui(o,Io(o))||Ui(n,Zd(n,t.position)))].filter(d=>Boolean(d));if(r==="personDetails")return l?[l]:[];if(r==="customization"){let d=Ui(s,WS(s,t.position))||Ui(s,Io(s))||Ui(n,Zd(n,t.position))||Ui(o,Io(o))||l,u=eP(e.padColors,t.padColor,t.position).map(Dv).filter(p=>Boolean(p));return d?[d].concat(u):u}return r==="impressionKit"?[l||Dv((c=e.bundleImpressionKitProduct||e.impressionKitProduct)==null?void 0:c.productImageUrl)].filter(d=>Boolean(d)):r==="upsell"?l?[l]:[]:[]}var R3=f.div`
  --purchase-master-color-option-size: ${({$size:e})=>e==="s"?"24px":"40px"};
  --purchase-master-color-swatch-size: ${({$size:e})=>e==="s"?"18px":"30px"};
  --purchase-master-color-ring-width: ${({$size:e})=>e==="s"?"1px":"2px"};
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: ${({$size:e})=>e==="m"?"4px":"0.25rem"};
  max-width: 100%;

  ${({$layout:e})=>e==="customization"&&v`
      gap: 4px;
      min-height: var(--purchase-master-color-option-size);
    `}
  ${({$layout:e})=>e==="guard-editor"&&v`
      flex: 0 1 auto;
      flex-wrap: wrap;
      justify-content: flex-end;
      min-width: 0;
    `}

  @media screen and (max-width: 749px) {
    ${({$size:e})=>e==="m"&&v`
        --purchase-master-color-option-size: 32px;
        --purchase-master-color-swatch-size: 24px;
      `}
    ${({$layout:e})=>e==="customization"&&v`
        min-width: max-content;
      `}
    ${({$layout:e})=>e==="guard-editor"&&v`
        justify-content: flex-start;
        --purchase-master-color-option-size: 24px;
        --purchase-master-color-swatch-size: 18px;
        --purchase-master-color-ring-width: 1px;
      `}
  }
`,G3=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--purchase-master-color-option-size, 40px);
  height: var(--purchase-master-color-option-size, 40px);
  box-sizing: border-box;
  border: var(--purchase-master-color-ring-width, 2px) solid
    ${({$selected:e})=>e?"#111111":"transparent"};
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
  padding: 0;
`,_3=f.span.attrs(Gf)`
  position: relative;
  display: block;
  width: var(--purchase-master-color-swatch-size, 30px);
  height: var(--purchase-master-color-swatch-size, 30px);
  border: 1px solid #d9d9d9;
  border-radius: 999px;
  background: #ffffff;
  overflow: hidden;

  ${({$variant:e})=>(e==="clear"||e==="none")&&v`
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 142%;
        border-bottom: 1px solid #d10000;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    `}
  ${({$variant:e})=>e==="none"&&v`
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 142%;
        border-bottom: 1px solid #d10000;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    `}
`,_f={ColorRow:R3,ColorOption:G3,Swatch:_3};var Bf=T(k());function B3(e){if(!e)return;let t=Io(e);return e.color?{background:e.color}:t?{backgroundImage:`url(${t})`,backgroundPosition:"center",backgroundSize:"cover"}:void 0}function zv({ariaLabel:e,className:t,emptySwatchStyle:r="clear",options:n,size:o="m",layout:i="default",value:a,onSelect:s}){return(0,Bf.jsx)(_f.ColorRow,{$size:o,$layout:i,className:"color-row",role:"radiogroup","aria-label":e,children:n.map(l=>{let c=String(l.value||""),d=ne(l),u=String(a)===c,p=r==="none"&&!QC(l)?"none":l.color?"filled":"clear";return(0,Bf.jsx)(_f.ColorOption,{$selected:u,type:"button",title:d,"aria-label":d,"aria-checked":u,className:"color-option",role:"radio",onClick:()=>s(c),children:(0,Bf.jsx)(_f.Swatch,{className:"swatch",$variant:p,$swatchStyle:B3(l),"aria-hidden":"true"})},c||d)})})}var Z3=f.div.attrs({className:"card-grid"})`
  display: grid;
  grid-template-columns: ${({$position:e,$presentation:t})=>t==="customization"&&e?"repeat(2, minmax(0, 1fr))":e||t==="strength"?"1fr":"repeat(2, minmax(0, 1fr))"};
  gap: ${({$position:e,$presentation:t})=>t==="customization"&&e?"12px":e||t==="strength"?"0.75rem":"1rem"};

  @media screen and (max-width: 749px) {
    grid-template-columns: ${({$position:e,$presentation:t})=>t==="customization"&&e?"repeat(2, minmax(0, 1fr))":"1fr"};
    gap: ${({$position:e,$presentation:t})=>t==="customization"&&e?"12px":e?"8px":t==="strength"?"0.75rem":"1rem"};
  }
`,$3=v`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  min-height: 5.5rem;
  border-radius: 0.75rem;
  & strong {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
  & small {
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
  }
`,O3=f.button.attrs({className:"radio-card"})`
  min-height: 4.5rem;
  border: 0.5px solid
    ${({$selected:e,$error:t})=>e?"#111111":t?"#d92d20":"#888888"};
  border-radius: 0.375rem;
  background: #ffffff;
  padding: 1rem;
  color: #111111;
  cursor: pointer;
  text-align: left;
  ${({$selected:e})=>e&&v`
      box-shadow: inset 0 0 0 1px #111111;
    `}

  & strong {
    display: block;
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
    font-weight: 900;
    line-height: 1.2;
  }
  & small {
    display: block;
    color: #667085;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1.2;
  }

  ${({$presentation:e})=>(e==="position"||e==="strength")&&$3}
  ${({$presentation:e,$hasPrice:t})=>e==="position"&&t&&v`
      & strong,
      & small {
        padding-right: 5rem;
      }
    `}
  ${({$presentation:e})=>e==="customization"&&v`
      display: flex;
      min-height: 56px;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      padding: 16px;
      text-align: center;
      & strong {
        margin: 0;
        font-size: 18px;
        line-height: 24px;
      }
    `}

  @media screen and (max-width: 749px) {
    gap: ${({$presentation:e})=>e==="strength"?"0.75rem":"8px"};
    min-height: ${({$presentation:e})=>e==="strength"?"5.5rem":"48px"};
    border-radius: 12px;
    padding: ${({$presentation:e})=>e==="strength"?"1rem":"10px 12px"};
    & strong {
      margin: 0;
      font-size: 18px;
      line-height: 24px;
    }
    & small {
      color: #505050;
      font-size: ${({$presentation:e})=>e==="strength"?"1rem":"16px"};
      font-weight: 400;
      line-height: ${({$presentation:e})=>e==="strength"?"1.25rem":"20px"};
    }
  }
`,F3=f.span.attrs({className:"radio-card-price"})`
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
`,D3=f.div.attrs({className:"select-grid"})`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  @media screen and (max-width: 749px) {
    gap: 6px;
  }
`,z3=f.button.attrs({className:"select-option"})`
  min-height: 3.5rem;
  border: ${({$selected:e})=>e?"2px solid #d6a51f":"1px solid #d9d9d9"};
  border-radius: 0.375rem;
  background: ${({$selected:e})=>e?"#d6a51f":"#ffffff"};
  padding: 0.75rem 0.625rem;
  color: ${({$selected:e})=>e?"#ffffff":"#667085"};
  cursor: pointer;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  word-break: break-word;

  @media screen and (max-width: 749px) {
    min-height: 40px;
    border-radius: 10px;
    padding: 6px 8px;
    color: ${({$selected:e})=>e?"#ffffff":"#4f4f4f"};
    font-size: 14px;
    line-height: 18px;
    &:focus-visible {
      outline: 2px solid #111111;
      outline-offset: 2px;
    }
  }
`,Ii={CardGrid:Z3,RadioCard:O3,RadioCardPrice:F3,SelectGrid:D3,SelectOption:z3};var K3=f.div.attrs({className:"thickness-visual"})`
  display: ${({$variant:e})=>e==="guide"?"none":"block"};
  grid-template-rows: minmax(0, 1fr) auto;
  min-width: 0;
  background: ${({$variant:e})=>e==="guide"?"#f5f5f5":"transparent"};
`,H3=f.div.attrs({className:"thickness-cards"})`
  display: grid;
  grid-template-columns: ${({$variant:e})=>e==="field"?"1fr":"repeat(3, minmax(0, 1fr))"};
  gap: ${({$variant:e})=>e==="field"?"0.75rem":"8px"};
  align-items: end;
  background: transparent;
  padding: ${({$variant:e})=>e==="unified"?"0 0 24px":"0"};
  ${({$variant:e})=>e==="guide"&&v`
      width: 100%;
    `}
  @media screen and (max-width: 749px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    ${({$variant:e})=>e==="field"&&v`
        padding: 16px 0 0;
      `}
  }
  @media screen and (max-width: 360px) {
    ${({$variant:e})=>e!=="guide"&&v`
        gap: 6px;
      `}
  }
`,Q3=f.button.attrs({className:"thickness-card"})`
  position: relative;
  display: grid;
  justify-items: center;
  align-content: start;
  min-width: 0;
  min-height: 6.95rem;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #111111;
  cursor: pointer;
  padding: 0 0.3rem;
  text-align: center;
  ${({$selected:e})=>e&&v`
      &::after {
        content: "";
        position: absolute;
        inset: -0.35rem 0.05rem -0.45rem;
        border: 2px solid #d6a51f;
        border-radius: 0.25rem;
        pointer-events: none;
      }
    `}
  ${({$variant:e})=>e==="guide"&&v`
      min-height: 11.5rem;
      border-radius: 0.25rem;
      padding: 0.5rem 0.35rem 1.5rem;
      &::after {
        inset: 0;
        border-color: #d6a51f;
        border-radius: 0.25rem;
      }
    `}
  ${({$variant:e,$selected:t})=>e==="unified"&&v`
      min-height: 48px;
      border: 0.5px solid ${t?"#111111":"#888888"};
      border-radius: 12px;
      overflow: visible;
      padding: 8px;
      align-content: center;
      ${t&&v`
        box-shadow: inset 0 0 0 1px #111111;
        &::after {
          content: none;
        }
      `}
    `}
  ${({$variant:e,$selected:t,$error:r})=>e==="field"&&v`
      justify-items: start;
      align-content: center;
      width: 100%;
      min-height: 5.5rem;
      border: 0.5px solid
        ${t?"#111111":r?"#d92d20":"#888888"};
      border-radius: 0.75rem;
      background: #ffffff;
      overflow: hidden;
      padding: 1rem;
      text-align: left;
      &::before {
        content: "";
        position: absolute;
        z-index: 2;
        inset: -0.5px;
        border: 0.5px solid ${t?"#111111":"#888888"};
        border-radius: 0.75rem;
        pointer-events: none;
      }
      ${t&&v`
        box-shadow: inset 0 0 0 1px #111111;
        &::before {
          box-shadow: inset 0 0 0 1px #111111;
        }
        &::after {
          content: none;
        }
      `}
      &:disabled {
        cursor: not-allowed;
        opacity: 0.52;
      }
      @media screen and (max-width: 749px) {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 44px;
        border-radius: 12px;
        overflow: visible;
        padding: 8px 12px;
      }
    `}
  @media screen and (max-width: 430px) {
    ${({$variant:e})=>e!=="guide"&&v`
        min-height: 44px;
        padding: 8px 4px;
      `}
  }
`,j3=f(lo.LayerImage)`
  display: block;
  width: ${({$variant:e})=>e==="guide"?"min(100%, 6rem)":"min(100%, 5.1rem)"};
  aspect-ratio: ${({$variant:e})=>e==="guide"?"1 / 0.68":"1 / 0.72"};
  object-fit: contain;
  transform: ${({$variant:e})=>e==="guide"?"none":"translateY(-1.2rem)"};
  ${({$variant:e})=>e==="guide"&&v`
      margin-bottom: 0.625rem;
    `}
`,q3=f.div`
  display: none;
`,J3=f.div`
  display: none;
`,eL=f.span`
  position: absolute;
  top: -0.625rem;
  left: 50%;
  z-index: 1;
  width: max-content;
  border-radius: 999px;
  background: #111111;
  color: #ffffff;
  padding: 0.45rem 0.8rem;
  font-size: 0.8125rem;
  font-weight: 900;
  line-height: 1;
  transform: translateX(-50%);

  ${({$variant:e})=>e==="field"&&v`
      top: -0.5px;
      right: -0.5px;
      left: auto;
      display: flex;
      isolation: isolate;
      width: 126px;
      height: 30px;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      border-radius: 0;
      background: transparent;
      color: #39846c;
      padding: 0;
      font-family: "DM Sans", Arial, sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 24px;
      overflow: visible;
      transform: none;
      @media screen and (max-width: 749px) {
        top: -16.5px;
        right: auto;
        left: 50%;
        width: 86px;
        height: 24px;
        border-radius: 4px;
        background: #000000;
        color: #ffffff;
        font-size: 10px;
        font-weight: 400;
        overflow: hidden;
        transform: translateX(-50%);
      }
    `}
`,tL=f.img`
  position: absolute;
  top: -4px;
  left: -4px;
  z-index: 0;
  display: block;
  width: 134px;
  height: 38px;
  aspect-ratio: auto;
  overflow: visible;
  object-fit: fill;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.16));
  transform: scaleX(-1);
  pointer-events: none;
  @media screen and (max-width: 749px) {
    display: none;
  }
`,rL=f.span`
  ${({$field:e})=>e&&v`
      position: absolute;
      top: 0;
      right: 0;
      left: 6px;
      z-index: 1;
      display: flex;
      width: 120px;
      height: 24px;
      align-items: center;
      justify-content: center;
      margin: 0;
      font-variation-settings: "opsz" 14;
      @media screen and (max-width: 749px) {
        inset: 0;
        width: 86px;
      }
    `}
`,nL=f.strong`
  display: block;
  margin: 0;
  font-size: ${({$variant:e})=>e==="guide"?"1.55rem":"1.125rem"};
  font-weight: ${({$variant:e})=>e==="guide"?900:700};
  line-height: ${({$variant:e})=>e==="guide"?"1":"1.5rem"};
  text-transform: ${({$variant:e})=>e==="field"?"none":"uppercase"};
  ${({$variant:e})=>e==="unified"&&v`
      max-width: 100%;
      overflow: hidden;
      text-overflow: clip;
      white-space: nowrap;
    `}
  @media screen and (max-width: 749px) {
    ${({$variant:e})=>e==="field"&&v`
        font-size: 18px;
        line-height: 24px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: clip;
        white-space: nowrap;
      `}
  }
  @media screen and (max-width: 430px) {
    ${({$variant:e})=>e!=="guide"&&v`
        font-size: 16px;
        line-height: 20px;
      `}
  }
  @media screen and (max-width: 360px) {
    ${({$variant:e})=>e!=="guide"&&v`
        font-size: 14px;
        line-height: 18px;
      `}
  }
`,oL=f.span`
  display: ${({$variant:e})=>e==="unified"?"none":"block"};
  margin-top: ${({$variant:e})=>e==="guide"?"0.5rem":"0.75rem"};
  color: ${({$variant:e})=>e==="guide"?"#111111":"#505050"};
  font-size: 1rem;
  font-weight: ${({$variant:e})=>e==="guide"?900:400};
  line-height: ${({$variant:e})=>e==="guide"?"1.05":"1.25rem"};
  ${({$variant:e})=>e==="guide"&&v`
      max-width: 8rem;
    `}
  @media screen and (max-width: 749px) {
    ${({$variant:e})=>e==="field"&&v`
        display: none;
        margin-top: 8px;
        font-size: 16px;
        line-height: 20px;
      `}
  }
`,iL=f.span`
  position: absolute;
  top: calc(100% + 4px);
  left: 50%;
  color: #39846c;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
  transform: translateX(-50%);
`,jr={Visual:K3,Cards:H3,Card:Q3,CardImage:j3,Hero:q3,HeroTile:J3,Recommended:eL,RecommendedShape:tL,RecommendedLabel:rL,CardTitle:nL,CardSubtitle:oL,RecommendedUnified:iL};var aL=f.div.attrs({className:"thickness-guide"})`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  min-height: 31.25rem;
  background: #ffffff;

  @media screen and (max-width: 749px) {
    display: block;
    height: auto;
    min-height: 0;
  }
`,sL=f.div`
  min-width: 0;
  min-height: 31.25rem;
  border-radius: 1rem;
  background-color: #f7f7f7;
  background-image: var(--purchase-master-thickness-guide-image);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;

  @media screen and (max-width: 749px) {
    width: 100%;
    min-height: 220px;
    height: 220px;
    border-radius: 0;
  }
`,lL=f.div`
  display: grid;
  align-content: start;
  gap: 1.5rem;
  min-width: 0;
  padding: 6.875rem 1.5rem 2.375rem;

  @media screen and (max-width: 749px) {
    gap: 12px;
    padding: 16px 20px;
  }
`,cL=f.section`
  display: grid;
  gap: 0.5rem;
  border-bottom: 1px solid #888888;
  padding-bottom: 0.5rem;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }

  @media screen and (max-width: 749px) {
    gap: 4px;
    padding-bottom: 10px;
  }
`,dL=f.h4`
  margin: 0;
  font-family: var(
    --trufit-font-display,
    "Joyride STD",
    "DM Sans",
    Arial,
    sans-serif
  );
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-transform: uppercase;

  @media screen and (max-width: 749px) {
    font-size: 14px;
    line-height: 20px;
  }
`,uL=f.p`
  margin: 0;
  color: #111111;
  font-size: 0.75rem;
  line-height: 1.125rem;
  letter-spacing: 0;
  font-family: var(
    --trufit-font-mono,
    "DM Mono",
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace
  );
  text-transform: uppercase;

  @media screen and (max-width: 749px) {
    font-size: 12px;
    line-height: 16px;
  }
`,pL=f.p`
  margin: 0;
  color: #505050;
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-family: var(--trufit-font-body, "DM Sans", Arial, sans-serif);

  @media screen and (max-width: 749px) {
    font-size: 12px;
    line-height: 16px;
  }
`,Vi={Guide:aL,GuideMedia:sL,Copy:lL,CopySection:cL,CopyTitle:dL,CopyMeta:uL,CopySports:pL};var We=T(k());function Oy(e){let t=String(e.description||"").trim(),r=t.split(":");return r.length>1?{meta:r[0].trim(),category:r.slice(1).join(":").trim(),body:""}:{meta:"",category:t,body:""}}function Kv(e){let t=String(e.description||"").trim(),r=Oy(e);return t||[r.meta,r.category].filter(Boolean).join(": ")}function hu(e){return e.sizeImageUrl||e.thumbnailUrl||e.scallopedThumbnailUrl||e.imageUrl||""}function gu(e){return e.bannerImageUrl||""}function ks({action:e,children:t,className:r,error:n,label:o,value:i,variant:a}){let{stepKey:s}=Oe(),l=a||(s==="customization"?"customization":s==="details"?"protection":s==="strength"?"strength":"default");return(0,We.jsxs)(ht.Section,{className:r,$variant:l,children:[(0,We.jsxs)(ht.LabelRow,{children:[(0,We.jsx)(ht.Label,{$variant:s==="position"?"position":void 0,children:o}),e||(i?(0,We.jsx)(ht.Value,{children:i}):null)]}),t,n?(0,We.jsx)(ht.FieldError,{$placement:"form",children:n}):null]})}function Zf({invalid:e,options:t,requiredOptionValues:r,selectedValue:n,variant:o,presentation:i,onSelect:a}){let{stepKey:s}=Oe(),l=i||(s==="position"||s==="strength"||s==="customization"?s:"default");return(0,We.jsx)(Ii.CardGrid,{$presentation:l,$position:o==="position","aria-invalid":e||void 0,children:t.map(c=>{let d=String(c.value||""),u=String(n)===d,p=o!=="position",m=(r==null?void 0:r.includes(d))||!1;return(0,We.jsxs)(Ii.RadioCard,{type:"button",$selected:u,$error:e,$presentation:l==="customization"&&o!=="position"?"default":l,$hasPrice:Boolean(c.priceAdjustment),"aria-pressed":u,onClick:()=>a(d),children:[(0,We.jsxs)("strong",{children:[ne(c),m?(0,We.jsx)(ht.RequiredMarker,{className:"required-marker","aria-hidden":"true",children:"*"}):null]}),p&&c.description?(0,We.jsx)("small",{children:c.description}):null,c.priceAdjustment?(0,We.jsx)(Ii.RadioCardPrice,{children:String(c.priceAdjustment).trim().startsWith("+")?String(c.priceAdjustment):`+${String(c.priceAdjustment)}`}):null]},d||ne(c))})})}function Fy({emptySwatchStyle:e="clear",error:t,label:r,options:n,value:o,onSelect:i}){let{stepKey:a}=Oe(),s=a==="customization";return(0,We.jsx)(ks,{className:"form-section-color",label:r,error:t,children:(0,We.jsx)(ht.ColorControl,{className:"color-control",$customization:s,children:(0,We.jsx)(zv,{ariaLabel:r,layout:s?"customization":"default",emptySwatchStyle:e,options:n,size:"m",value:o,onSelect:i})})})}function Hv({disabled:e,invalid:t,options:r,recommendedBadgeUrl:n,value:o,variant:i="guide",onSelect:a}){var p;let s=i==="field"||i==="unified",l=i==="unified",c=r,d=l?(p=r.find(m=>m.isRecommended))==null?void 0:p.value:"",u=r.map(m=>({option:m,image:gu(m)})).filter(m=>m.image);return(0,We.jsxs)(jr.Visual,{$variant:i,children:[s?null:(0,We.jsx)(jr.Hero,{className:"thickness-hero",hidden:!u.length,children:u.map(({option:m,image:g})=>(0,We.jsx)(jr.HeroTile,{className:"thickness-hero-tile",children:(0,We.jsx)(lo.LayerImage,{src:g,alt:"",loading:"lazy",$objectFit:Is(m.objectFit)})},String(m.value||g)))}),(0,We.jsx)(jr.Cards,{$variant:i,"aria-invalid":t||void 0,children:c.map(m=>{let g=String(m.value||""),y=Oy(m),P=hu(m),Y=String(o)===g,h=m.isRecommended||l&&Boolean(d)&&String(d)===g;return(0,We.jsxs)(jr.Card,{type:"button",$variant:i,$selected:Y,$error:t,"aria-pressed":Y,disabled:e,onClick:()=>a(g),children:[m.isRecommended&&!l?(0,We.jsxs)(jr.Recommended,{$variant:s?"field":"guide",className:"recommended",children:[s?(0,We.jsx)(jr.RecommendedShape,{"aria-hidden":"true",className:"recommended-shape",src:n||"",alt:""}):null,(0,We.jsx)(jr.RecommendedLabel,{$field:s,className:"recommended-label",children:"Recommended"})]}):null,!s&&P?(0,We.jsx)(jr.CardImage,{$variant:i,src:P,alt:"",loading:"lazy",$objectFit:Is(m.objectFit)}):null,(0,We.jsx)(jr.CardTitle,{$variant:i,className:"thickness-card-title",children:ne(m)}),s&&Kv(m)?(0,We.jsx)(jr.CardSubtitle,{$variant:i,className:"thickness-card-subtitle",children:Kv(m)}):null,h&&l?(0,We.jsx)(jr.RecommendedUnified,{className:"recommended-unified",children:"Recommended"}):null,!s&&y.category?(0,We.jsx)(jr.CardSubtitle,{$variant:i,className:"thickness-card-subtitle",children:y.category}):null]},g||ne(m))})})]})}function Qv({options:e,value:t,onSelect:r}){return(0,We.jsx)(Ii.SelectGrid,{children:e.map(n=>{let o=String(n.value||""),i=String(t)===o;return(0,We.jsx)(Ii.SelectOption,{type:"button",$selected:i,onClick:()=>r(o),children:ne(n)},o||ne(n))})})}function jv({options:e,value:t,onSelect:r}){let n=e;return(0,We.jsxs)(Vi.Guide,{children:[(0,We.jsx)(Vi.GuideMedia,{className:"thickness-guide-media"}),(0,We.jsx)(Vi.Copy,{className:"thickness-copy",children:n.map(o=>{let i=Oy(o),a=String(o.value||"");return(0,We.jsxs)(Vi.CopySection,{className:"thickness-copy-section","aria-current":String(t)===a?"true":void 0,role:"button",tabIndex:0,onClick:()=>r(a),onKeyDown:s=>{(s.key==="Enter"||s.key===" ")&&(s.preventDefault(),r(a))},children:[(0,We.jsx)(Vi.CopyTitle,{className:"thickness-copy-title",children:ne(o)}),i.meta||i.category?(0,We.jsxs)(Vi.CopyMeta,{className:"thickness-copy-meta",children:[i.meta||null,i.category?`${i.meta?": ":""}${i.category}`:null]}):null,o.sports?(0,We.jsx)(Vi.CopySports,{className:"thickness-copy-sports",children:o.sports}):null,!o.sports&&i.body?(0,We.jsx)(Vi.CopySports,{className:"thickness-copy-sports",children:i.body}):null]},a||ne(o))})})]})}var Ne=T(k());function mL(e){let t=String(e||"").trim();return t?t.startsWith("+")?t:`+${t}`:""}function fL({option:e,onClose:t}){let r=String(e.helpBenefits||"").split(`
`).map(n=>n.trim()).filter(Boolean);return(0,Ne.jsxs)(Qr.OptionHelp,{className:"option-help",role:"dialog","aria-modal":"true","aria-label":String(e.helpTitle||ne(e)),children:[(0,Ne.jsx)(Qr.OptionHelpScrim,{type:"button",className:"option-help-scrim","aria-label":"Close",onClick:t}),(0,Ne.jsxs)(Qr.OptionHelpPanel,{className:"option-help-panel",children:[(0,Ne.jsx)(Qr.OptionHelpMedia,{className:"option-help-media",children:e.helpImageUrl?(0,Ne.jsx)("img",{src:String(e.helpImageUrl),alt:""}):null}),(0,Ne.jsxs)(Qr.OptionHelpContent,{className:"option-help-content",children:[(0,Ne.jsxs)(Qr.OptionHelpHeading,{className:"option-help-heading",children:[(0,Ne.jsx)("h3",{children:String(e.helpTitle||ne(e))}),(0,Ne.jsx)("button",{type:"button","aria-label":"Close",onClick:t,children:(0,Ne.jsx)(Ro,{})})]}),e.helpDescription?(0,Ne.jsx)(Qr.OptionHelpParagraph,{children:String(e.helpDescription)}):null,r.length?(0,Ne.jsx)("ul",{children:r.map(n=>(0,Ne.jsx)("li",{children:n},n))}):null,e.helpNote?(0,Ne.jsx)(Qr.OptionHelpNote,{className:"option-help-note",children:String(e.helpNote)}):null]})]})]})}function Dy({context:e,label:t}){var S;let{config:r,fieldErrors:n,isReturnCustomerFlow:o,reusableImpressionPositions:i,state:a,setFieldValue:s}=e,[l,c]=(0,qv.useState)(!1),d=r.flowContent||{},u=r.edgeTypes||[],p=u[0],m=u[1],g=a.edgeType||String((p==null?void 0:p.value)||""),y=Boolean(m&&g===String(m.value||"")),P=Boolean(m&&(m.helpTitle||m.helpDescription||m.helpBenefits||m.helpNote||m.helpImageUrl)),Y=o?(r.positions||[]).filter(b=>{let W=cy(b.value);return!Boolean((i==null?void 0:i.some(w=>w===W||w==="dual"))||W==="dual"&&(i==null?void 0:i.includes("upper"))&&(i==null?void 0:i.includes("lower")))}).map(b=>String(b.value||"")):[];if(!((S=r.positions)!=null&&S.length))return null;let h=m?(0,Ne.jsxs)(Qr.EdgeOption,{className:"edge-option",children:[(0,Ne.jsxs)("span",{children:[ne(m)," ",mL(m.priceAdjustment)]}),(0,Ne.jsx)(Qt.Switch,{type:"button",role:"switch",$checked:y,"aria-checked":y,className:"switch",onClick:()=>{var b;return s("edgeType",String(((b=y?p:m)==null?void 0:b.value)||""))},children:(0,Ne.jsx)("span",{})}),P?(0,Ne.jsx)(Mi.HelpButton,{type:"button",className:"help-button","aria-label":`About ${ne(m)}`,onClick:()=>c(!0),children:"?"}):null]}):void 0;return(0,Ne.jsxs)(Ne.Fragment,{children:[(0,Ne.jsxs)(ks,{label:t||d.positionHeading||"Position",action:h,error:n.position,children:[r.positionDescription?(0,Ne.jsx)(Qr.Description,{className:"purchase-master-description",children:r.positionDescription}):null,(0,Ne.jsx)(Zf,{options:r.positions,invalid:Boolean(n.position),requiredOptionValues:Y,selectedValue:a.position,variant:"position",onSelect:b=>s("position",b)}),d.positionNote?(0,Ne.jsx)(Qr.FlowNote,{className:"flow-note",children:d.positionNote}):null,d.warningTitle||d.warningDescription||d.warningDisclaimer?(0,Ne.jsxs)(Qr.FlowWarning,{className:"flow-warning",children:[d.warningTitle?(0,Ne.jsx)("strong",{children:d.warningTitle}):null,d.warningDescription?(0,Ne.jsx)("p",{children:d.warningDescription}):null,d.warningDisclaimer?(0,Ne.jsx)(Qr.FlowWarningDisclaimer,{className:"flow-warning-disclaimer",children:d.warningDisclaimer}):null]}):null]}),l&&m?(0,Ne.jsx)(fL,{option:m,onClose:()=>c(!1)}):null]})}function zy({context:e}){return(0,Ne.jsx)(Dy,{context:e})}var hL=f.div`
  display: grid;
  gap: 0.75rem;
  border-radius: 0.5rem;
  background: #f1f1f1;
  padding: 1rem;

  & p {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    margin: 0;
    color: #505050;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  & p:first-child:not(:has(strong)) {
    display: block;
    font-style: italic;
  }
`,Jv={FlowInfo:hL};var ki=T(k());function Yu({context:e}){let{config:t,fieldErrors:r,state:n,setFieldValue:o}=e,i=t.strengths||[],a=t.flowContent||{};if(!i.length)return null;let s=i.filter(l=>l.detail);return(0,ki.jsxs)(ks,{label:a.strengthHeading||"Strength",error:r.strength,children:[(0,ki.jsx)(Zf,{options:i,invalid:Boolean(r.strength),selectedValue:n.strength,variant:"strength",onSelect:l=>o("strength",l)}),a.strengthNote||s.length?(0,ki.jsxs)(Jv.FlowInfo,{className:"flow-info",children:[a.strengthNote?(0,ki.jsx)("p",{children:a.strengthNote}):null,s.map(l=>(0,ki.jsxs)("p",{children:[(0,ki.jsx)("strong",{children:ne(l)}),(0,ki.jsx)("span",{children:String(l.detail)})]},String(l.value||ne(l))))]}):null]})}var jt=T(k());function gL({context:e}){let{config:t,fieldErrors:r,section:n,state:o,setState:i}=e,a=t.initials,s=Bl(a),l=(a==null?void 0:a.imageUrl)||(a==null?void 0:a.productImageUrl)||"",c=n instanceof HTMLElement?n.dataset.initialsInputLabel:void 0;return a!=null&&a.isAvailable?(0,jt.jsxs)(va.Root,{className:"initials","data-purchase-master-initials":!0,children:[(0,jt.jsxs)(va.Body,{className:"initials-body",children:[(0,jt.jsxs)(va.Heading,{className:"initials-heading",children:[(0,jt.jsx)(va.Title,{className:"initials-title",children:"ID Tag"}),s?(0,jt.jsx)(va.Price,{className:"initials-price",children:s}):null]}),(0,jt.jsx)(va.Input,{className:"initials-input",type:"text",maxLength:Cs,autoComplete:"off",inputMode:"text",pattern:Hl,placeholder:"4 character max",autoCapitalize:"characters","aria-label":c||"ID Tag","aria-invalid":Boolean(r.initials)||void 0,value:o.initials,onChange:d=>{let u=ao(d.currentTarget.value);i(p=>{var m;return{...p,initials:u,initialsOptIn:Boolean(u)||Boolean((m=t.initials)==null?void 0:m.isRequired)}},["initials"])}}),r.initials?(0,jt.jsx)(ht.FieldError,{$placement:"initials",$customization:!0,className:"field-error",children:r.initials}):null]}),(0,jt.jsx)(va.Preview,{className:"initials-preview",children:l?(0,jt.jsx)("img",{src:Xe(l,1e3),alt:"",loading:"lazy"}):null})]}):null}function Ky({context:e}){let{config:t,fieldErrors:r,state:n,setFieldValue:o}=e;return(0,jt.jsxs)(jt.Fragment,{children:[t.positions&&t.positions.length>1?(0,jt.jsx)(Dy,{context:e,label:"Guard Position"}):null,t.strengths&&t.strengths.length>1?(0,jt.jsx)(Yu,{context:e}):null,Ge(t.colors)?(0,jt.jsx)(Fy,{label:"Guard Color",error:r.color,options:t.colors||[],value:n.color,onSelect:i=>o("color",i)}):null,Ge(t.padColors)?(0,jt.jsx)(Fy,{emptySwatchStyle:"none",label:"Compression Pad Color",error:r.padColor,options:t.padColors||[],value:n.padColor,onSelect:i=>o("padColor",i)}):null,(0,jt.jsx)(gL,{context:e})]})}var YL=f.button`
  order: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-sizing: border-box;
  width: 100%;
  min-height: 3rem;
  height: ${({$sticky:e})=>e?"3rem":"auto"};
  border: 0;
  border-radius: 999px;
  padding: 0.5rem 1.25rem;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  cursor: pointer;

  ${({$variant:e})=>e==="primary"&&v`
      background: #111111;
      color: #ffffff;
    `}

  &[hidden] {
    display: none;
  }
  &:disabled {
    cursor: wait;
    opacity: 0.7;
  }

  @media screen and (max-width: 749px) {
    min-height: ${({$sticky:e})=>e?"var(--purchase-master-mobile-sticky-action-height)":"var(--purchase-master-mobile-action-height)"};
    height: ${({$sticky:e})=>e?"var(--purchase-master-mobile-sticky-action-height)":"var(--purchase-master-mobile-action-height)"};
    gap: 12px;
    padding: 8px 20px;
    font-size: ${({$sticky:e})=>e?"18px":"16px"};
    line-height: ${({$sticky:e})=>e?"24px":"20px"};
    & img {
      width: 20px;
      height: 20px;
    }
  }
`,Ls={Button:YL};var SL=f.div`
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
`,yL=f.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  margin: 1rem 1.5rem 0;
  border: 0.5px solid #888888;
  border-radius: 0.75rem;
  background: #efefef;

  @media screen and (max-width: 749px) {
    margin: 16px 20px 0;
    border-radius: 12px;
  }
`,xL=f.div`
  flex: 0 0 auto;
  padding: 0.75rem 1.5rem 1.5rem;

  @media screen and (max-width: 749px) {
    flex: 0 0 var(--purchase-master-mobile-action-shell-height);
    padding: 8px 20px;
  }
`,bL=f.div`
  display: flex;
  min-height: ${({$view:e})=>e?"100%":"0"};
  flex-direction: column;
  gap: ${({$view:e})=>e?"1.5rem":"0"};
  ${({$view:e})=>!e&&v`
      flex: 1 1 auto;
    `}
  @media screen and (max-width: 749px) {
    gap: ${({$view:e})=>e?e==="clinicDate"?"8px":"24px":"0"};
  }
`,CL=f.div`
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 1.5rem;
`,PL=f.p`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.25rem;

  @media screen and (max-width: 749px) {
    font-size: 18px;
    line-height: 20px;
  }
`,WL=f.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  & input {
    min-width: 0;
    height: 2.5rem;
    flex: 1;
    box-sizing: border-box;
    border: 1px solid #c7c7c7;
    border-radius: 0.25rem;
    background: #ffffff;
    color: #111111;
    padding: 0.5rem 1rem;
    font: inherit;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
  }

  & button {
    min-height: 2.5rem;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    cursor: pointer;
    padding: 0.625rem 1.25rem;
    font: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5rem;
  }

  & button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  @media screen and (max-width: 749px) {
    gap: 12px;
    & input {
      height: 40px;
      border-radius: 4px;
      padding: 8px 16px;
      line-height: 24px;
    }
    & button {
      min-height: 40px;
      padding: 8px 24px;
    }
  }
`,vL=f.p`
  margin: 0;
  color: #a21616;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.125rem;
`,wL=f.div`
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  align-content: start;
  gap: 0.5rem;
  overflow-y: auto;
  padding-right: 0.25rem;
  scrollbar-width: thin;
`,TL=f.p`
  margin: 0;
  color: #505050;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.125rem;
`,ML=f.button`
  display: none;

  @media screen and (max-width: 749px) {
    position: sticky;
    bottom: 0;
    display: flex;
    min-height: var(--purchase-master-mobile-action-height);
    height: var(--purchase-master-mobile-action-height);
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    cursor: pointer;
    padding: 8px 20px;
    font: inherit;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin-top: auto;
    & svg {
      width: 24px;
      height: 24px;
      fill: none;
      stroke: currentColor;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 1.75;
    }
  }
`,UL=f.div`
  position: relative;
  z-index: 3;
  display: grid;
  flex: 0 0 auto;
  gap: 0.75rem;
  border-top: 1px solid #e7e7e7;
  background: #ffffff;
  padding-top: 1rem;
  ${({$hasOffer:e})=>e&&v`
      box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
    `}
  @media screen and (max-width: 749px) {
    ${({$hasOffer:e,$view:t})=>e?v`
            gap: 12px;
            border-top: 0;
            padding: 8px 20px;
          `:!t&&v`
            display: none;
          `}
  }
`,Xr={MapView:SL,MapFrame:yL,MapActions:xL,Root:bL,Main:CL,Intro:PL,Search:WL,Error:vL,Results:wL,Empty:TL,MapButton:ML,Summary:UL};var gt=T(oe());var Hy=new Map;function Ta(e){return e?[e.address1,e.address2,[e.city,e.province,e.zip].filter(Boolean).join(", "),e.country].filter(Boolean).join(", "):""}function ew(e,t){if(!e||!t)return"";try{let r=new URL(e,window.location.origin);return r.pathname=r.pathname.replace(/\/public\/clinics\/scan-centers\/?$/,`/public/files/${encodeURIComponent(t)}/preview`),r.search=new URLSearchParams({token:"scan-center-logo",width:"152",height:"152"}).toString(),r.toString()}catch(r){return""}}async function tw({apiUrl:e}){if(!e)throw new Error("Scan centers API URL is not configured.");let r=new URL(e,window.location.origin).toString(),n=Hy.get(r);if(n)return n;let o=fetch(r,{headers:{Accept:"application/json"}}).then(async i=>{if(!i.ok)throw new Error("Scan centers could not be loaded.");let a=await i.json();return Array.isArray(a.data)?a.data:[]}).catch(i=>{throw Hy.delete(r),i});return Hy.set(r,o),o}var IL=f.div`
  display: grid;
  grid-template-columns: 4.75rem minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
  border: 0.5px solid #888888;
  border-radius: 0.75rem;
  background: #ffffff;
  padding: 1rem;

  & strong {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    grid-template-columns: 76px minmax(0, 1fr);
    gap: 12px;
    border-radius: 12px;
    padding: 12px;
  }
`,VL=f.div`
  display: grid;
  min-width: 0;
  gap: 0.25rem;
`,kL=f.div`
  display: grid;
  gap: 0.75rem;
  margin-top: ${({$summary:e})=>e?"0":"auto"};
  ${({$appointment:e})=>e&&v`
      position: absolute;
      z-index: 3;
      right: 1.5rem;
      bottom: 1.5rem;
      left: 1.5rem;
      background: #ffffff;
    `}
  @media screen and (max-width: 749px) {
    z-index: ${({$appointment:e})=>e?3:2};
    margin-top: ${({$summary:e})=>e?"0":"auto"};
    background: #ffffff;
    padding-top: 8px;
    ${({$appointment:e})=>e&&v`
        position: sticky;
        right: auto;
        bottom: 0;
        left: auto;
        min-height: var(--purchase-master-mobile-action-shell-height);
        padding: 8px 20px;
      `}
  }
`,LL=f.div`
  order: 2;
  display: flex;
  min-height: 3rem;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border-radius: 0.5rem;
  background: #ffffff;
  padding: 0.75rem 1.25rem;

  & span {
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.5rem;
  }

  & strong {
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    display: none;
  }
`,Su={SelectedClinic:IL,SelectedClinicCopy:VL,Footer:kL,Total:LL};var XL=f.p`
  margin: 0;
  font-weight: 400;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #1d1d1f;
  font-size: 0.875rem;

  & svg {
    width: 1.25rem;
    height: 1.25rem;
    flex: 0 0 1.25rem;
    fill: currentColor;
    stroke: currentColor;
    stroke-width: 0.4;
  }
`,NL=f.p`
  margin: 0;
  color: #505050;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.25rem;
`,lc={Distance:XL,Address:NL};var EL=f.div`
  display: flex;
  width: 4.75rem;
  height: 4.75rem;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: #f7f7f9;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 749px) {
    width: 76px;
    height: 76px;
  }
`,AL=f.span`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #f7f7f9 0%, #e9ebef 100%);
  color: #292929;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.06em;
`,Qy={Logo:EL,Initials:AL};var rw=T(oe());var $f=T(k());function RL(e){let t=e.trim().split(/\s+/).map(n=>n.replace(/[^\p{L}\p{N}]/gu,"")).filter(Boolean);return t.length?(t.length===1?Array.from(t[0]).slice(0,2).join(""):`${Array.from(t[0])[0]}${Array.from(t[1])[0]}`).toLocaleUpperCase():"SC"}function Of({apiUrl:e,clinic:t,loading:r}){let n=ew(e,t.logoId),[o,i]=(0,rw.useState)(""),a=n&&o!==n;return(0,$f.jsx)(Qy.Logo,{className:"scan-clinic-logo",children:a?(0,$f.jsx)("img",{src:n,alt:"",loading:r,onError:()=>i(n)}):(0,$f.jsx)(Qy.Initials,{className:"scan-clinic-initials","aria-hidden":"true",children:RL(t.name)})})}var xn=T(k());function Ff(){return(0,xn.jsxs)("svg",{viewBox:"0 0 20 20","aria-hidden":"true",children:[(0,xn.jsx)("path",{d:"M10 18s5-5.38 5-10a5 5 0 1 0-10 0c0 4.62 5 10 5 10Z"}),(0,xn.jsx)("circle",{cx:"10",cy:"8",r:"1.75"})]})}function nw(){return(0,xn.jsx)("svg",{viewBox:"0 0 24 24","aria-hidden":"true",children:(0,xn.jsx)("path",{d:"M6.62 10.79a15.5 15.5 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24 11.5 11.5 0 0 0 3.57.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.5 11.5 0 0 0 .57 3.57 1 1 0 0 1-.25 1.02l-2.2 2.2Z"})})}function ow(){return(0,xn.jsxs)("svg",{viewBox:"0 0 24 24","aria-hidden":"true",children:[(0,xn.jsx)("path",{d:"m9 18-6 3V6l6-3 6 3 6-3v15l-6 3-6-3Z"}),(0,xn.jsx)("path",{d:"M9 3v15M15 6v15"})]})}function iw(){return(0,xn.jsxs)("svg",{viewBox:"0 0 20 20","aria-hidden":"true",children:[(0,xn.jsx)("circle",{cx:"10",cy:"10",r:"8"}),(0,xn.jsx)("path",{d:"M2.5 8h4l2-3 2 2h3l1.5 2.5-2 2.5.5 4M8.5 12l-2 1.5.5 3"})]})}var dr=T(k()),aw=["8:15 AM","11:30 AM","1:00 PM"];function sw({apiUrl:e,clinic:t,distanceMiles:r}){let n=Ta(t.address);return(0,dr.jsxs)(Su.SelectedClinic,{className:"scan-selected-clinic",children:[(0,dr.jsx)(Of,{apiUrl:e,clinic:t,loading:"eager"}),(0,dr.jsxs)(Su.SelectedClinicCopy,{className:"scan-selected-clinic-copy",children:[(0,dr.jsx)("strong",{children:t.name}),(0,dr.jsxs)(lc.Distance,{className:"scan-distance",children:[(0,dr.jsx)(Ff,{}),(0,dr.jsx)("span",{children:typeof r=="number"?`${r.toFixed(1)} miles away`:"Nearby scan center"})]}),n?(0,dr.jsx)(lc.Address,{children:n}):null]})]})}function yu({actionDisabled:e=!1,actionLabel:t,onAction:r,totalPrice:n,summary:o=!1,appointment:i=!1}){return(0,dr.jsxs)(Su.Footer,{$summary:o,$appointment:i,className:"scan-footer",children:[t&&r?(0,dr.jsxs)(Ls.Button,{$variant:"primary",type:"button",className:"purchase-master-button purchase-master-button-primary",disabled:e,onClick:r,children:[(0,dr.jsx)("span",{children:t}),(0,dr.jsx)("span",{"aria-hidden":"true",children:"\u2192"})]}):null,(0,dr.jsxs)(Su.Total,{className:"scan-total",children:[(0,dr.jsx)("span",{children:"Total:"}),(0,dr.jsx)("strong",{children:n})]})]})}function lw(e){let t=e.trim();if(!t)return"Clinic time zone unavailable";let n={"America/Los_Angeles":"Pacific Time \u2013 US & Canada","America/Denver":"Mountain Time \u2013 US & Canada","America/Chicago":"Central Time \u2013 US & Canada","America/New_York":"Eastern Time \u2013 US & Canada"}[t]||t.replace(/_/g," ");try{let o=new Intl.DateTimeFormat("en-US",{hour:"numeric",minute:"2-digit",timeZone:t}).format(new Date).replace(/\s+/g,"").toLowerCase();return`${n} (${o})`}catch(o){return n}}var GL=f.h3`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.875rem;
  letter-spacing: -0.06rem;
  text-align: center;

  @media screen and (max-width: 749px) {
    display: none;
  }
`,_L=f.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & strong {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
`,BL=f.span`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #111111;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  & > span {
    min-width: 0;
    flex: 1 1 auto;
  }

  & > svg {
    width: 1.25rem;
    height: 1.25rem;
    flex: 0 0 1.25rem;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5;
  }
`,ZL=f.fieldset`
  display: grid;
  gap: 0.5rem;
  margin: 0;
  border: 0;
  padding: 0;
  & legend {
    margin-bottom: 0.5rem;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
`,$L=f.button`
  width: 100%;
  min-height: 3rem;
  border: 0.5px solid ${({$selected:e})=>e?"#111111":"#888888"};
  border-radius: 0.75rem;
  background: ${({$selected:e})=>e?"#111111":"#ffffff"};
  color: ${({$selected:e})=>e?"#ffffff":"#111111"};
  cursor: pointer;
  padding: 0.75rem;
  font: inherit;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: left;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`,cc={ViewTitle:GL,Timezone:_L,TimezoneValue:BL,Times:ZL,TimeSlot:$L};var OL=f.div`
  display: grid;
  gap: 0.25rem;
`,FL=f.div`
  display: grid;
  grid-template-columns: 2.875rem 1fr 2.875rem;
  align-items: center;

  & strong {
    font-family: Poppins, "DM Sans", Arial, sans-serif;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: normal;
    text-align: center;
  }

  & button {
    width: 2.875rem;
    height: 2.875rem;
    border: 0;
    background: transparent;
    color: #111111;
    cursor: pointer;
    padding: 0;
    font-size: 1.5rem;
  }

  & button:disabled {
    opacity: 0.2;
  }
`,DL=f.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
`,zL=f.button`
  width: 2.875rem;
  height: 2.875rem;
  justify-self: center;
  border: 0;
  border-radius: 50%;
  background: ${({$selected:e})=>e?"#111111":"transparent"};
  color: ${({$selected:e,$outside:t})=>e?"#ffffff":t?"#c7c7c7":"#111111"};
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-family: Poppins, "DM Sans", Arial, sans-serif;
  font-size: 0.875rem;
  &:disabled {
    color: #c7c7c7;
    cursor: not-allowed;
  }
  @media screen and (max-width: 749px) {
    width: 48px;
    height: 48px;
    font-size: 14px;
  }
`,KL=f.span`
  color: #111111;
  font-family: Poppins, "DM Sans", Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 2.875rem;
  text-align: center;

  @media screen and (max-width: 749px) {
    line-height: 48px;
  }
`,dc={Root:OL,Header:FL,Grid:DL,Day:zL,Weekday:KL};var uc=T(oe());function xu(e=new Date){return new Date(e.getFullYear(),e.getMonth(),e.getDate())}function Df(e,t){return new Date(e.getFullYear(),e.getMonth(),e.getDate()+t)}function jy(e){return new Date(e.getFullYear(),e.getMonth(),1)}function qy(e,t){return new Date(e.getFullYear(),e.getMonth()+t,1)}function zf(e,t){return e.getFullYear()===t.getFullYear()&&e.getMonth()===t.getMonth()}function Kf(e){return[e.getFullYear(),String(e.getMonth()+1).padStart(2,"0"),String(e.getDate()).padStart(2,"0")].join("-")}function cw(e,t,r){let n=xu(e).getTime();return n>=t.getTime()&&n<=r.getTime()+864e5-1}var Go=T(k()),HL=["Su","Mo","Tu","We","Th","Fr","Sa"];function QL(e){let t=jy(e),r=Df(t,-t.getDay());return Array.from({length:42},(n,o)=>Df(r,o))}function dw({onChange:e,value:t}){let r=(0,uc.useMemo)(()=>xu(),[]),n=(0,uc.useMemo)(()=>Df(r,21),[r]),[o,i]=(0,uc.useState)(()=>jy(t?new Date(`${t}T12:00:00`):r)),a=(0,uc.useMemo)(()=>QL(o),[o]),s=!zf(o,r),l=!zf(o,n);return(0,Go.jsxs)(dc.Root,{className:"scan-calendar",children:[(0,Go.jsxs)(dc.Header,{className:"scan-calendar-header",children:[(0,Go.jsx)("button",{type:"button","aria-label":"Previous month",disabled:!s,onClick:()=>i(qy(o,-1)),children:"\u2039"}),(0,Go.jsx)("strong",{children:new Intl.DateTimeFormat("en-US",{month:"long",year:"numeric"}).format(o)}),(0,Go.jsx)("button",{type:"button","aria-label":"Next month",disabled:!l,onClick:()=>i(qy(o,1)),children:"\u203A"})]}),(0,Go.jsxs)(dc.Grid,{className:"scan-calendar-grid",role:"grid","aria-label":"Available scan appointment dates",children:[HL.map((c,d)=>(0,Go.jsx)(dc.Weekday,{className:"scan-calendar-weekday",children:c},`${c}-${d}`)),a.map(c=>{let d=Kf(c),u=cw(c,r,n),p=zf(c,o);return(0,Go.jsx)(dc.Day,{type:"button",$selected:d===t,$outside:!p,disabled:!u,"aria-pressed":d===t,onClick:()=>e(d),children:c.getDate()},d)})]})]})}var Tt=T(k());function uw({apiUrl:e,appointmentDate:t,appointmentTime:r,clinic:n,distanceMiles:o,onContinue:i,onDateChange:a,onOpenTime:s,onTimeChange:l,timezone:c,totalPrice:d,view:u}){return(0,Tt.jsxs)(Tt.Fragment,{children:[(0,Tt.jsx)(cc.ViewTitle,{className:"scan-view-title",children:"Select Date & Time"}),(0,Tt.jsx)(sw,{apiUrl:e,clinic:n,distanceMiles:o}),u==="clinicDate"?(0,Tt.jsxs)(Tt.Fragment,{children:[(0,Tt.jsx)(dw,{value:t,onChange:a}),(0,Tt.jsx)(yu,{appointment:!0,actionDisabled:!t,actionLabel:"Confirm this date",onAction:s,totalPrice:d})]}):(0,Tt.jsxs)(Tt.Fragment,{children:[(0,Tt.jsxs)(cc.Timezone,{className:"scan-timezone",children:[(0,Tt.jsx)("strong",{children:"Time zone"}),(0,Tt.jsxs)(cc.TimezoneValue,{className:"scan-timezone-value",children:[(0,Tt.jsx)(iw,{}),(0,Tt.jsx)("span",{children:lw(c)})]})]}),(0,Tt.jsxs)(cc.Times,{className:"scan-times",children:[(0,Tt.jsx)("legend",{children:"Choose an available time below."}),aw.map(p=>(0,Tt.jsx)(cc.TimeSlot,{type:"button",$selected:p===r,"aria-pressed":p===r,onClick:()=>l(p),children:p.toLowerCase().replace(/\s+/g,"")},p))]}),(0,Tt.jsx)(yu,{appointment:!0,actionDisabled:!r,actionLabel:"Continue",onAction:i,totalPrice:d})]})]})}var jL=f.article`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border: 0.5px solid #888888;
  border-radius: 0.75rem;
  background: #ffffff;
  padding: 1rem;

  @media screen and (max-width: 749px) {
    gap: 12px;
    padding: 12px;
  }
`,qL=f.div`
  display: grid;
  grid-template-columns: 4.75rem minmax(0, 1fr);
  gap: 0.75rem;
`,JL=f.div`
  & > button {
    min-height: 2.5rem;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    cursor: pointer;
    padding: 0.625rem 1.25rem;
    font: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5rem;
  }

  display: grid;
  justify-items: start;
  gap: 0.25rem;
  min-width: 0;

  & h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
`,eX=f.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;

  & a {
    display: inline-flex;
    min-width: 0;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #111111;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.5rem;
    text-decoration: none;
  }

  & a svg {
    width: 1.5rem;
    height: 1.5rem;
    flex: 0 0 1.5rem;
    fill: currentColor;
  }

  & > button {
    flex: 0 0 auto;
    min-height: 2.5rem;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    cursor: pointer;
    padding: 0.5rem 1.25rem;
    font: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    & > button {
      min-height: 36px;
      padding: 8px 16px;
    }
  }
`,bu={Card:jL,Main:qL,Copy:JL,Actions:eX};var Pr=T(k());function pw({apiUrl:e,clinic:t,distanceMiles:r,onSchedule:n}){let o=Ta(t.address);return(0,Pr.jsxs)(bu.Card,{className:"scan-clinic-card",children:[(0,Pr.jsxs)(bu.Main,{className:"scan-clinic-main",children:[(0,Pr.jsx)(Of,{apiUrl:e,clinic:t,loading:"lazy"}),(0,Pr.jsxs)(bu.Copy,{className:"scan-clinic-copy",children:[(0,Pr.jsx)("h3",{children:t.name}),(0,Pr.jsxs)(lc.Distance,{className:"scan-distance",children:[(0,Pr.jsx)(Ff,{}),(0,Pr.jsx)("span",{children:typeof r=="number"?`${r.toFixed(1)} miles away`:"Nearby scan center"})]}),o?(0,Pr.jsx)(lc.Address,{children:o}):null]})]}),(0,Pr.jsxs)(bu.Actions,{className:"scan-clinic-actions",children:[t.phoneNumber?(0,Pr.jsxs)("a",{href:`tel:${t.phoneNumber}`,children:[(0,Pr.jsx)(nw,{}),(0,Pr.jsx)("span",{children:t.phoneNumber})]}):null,(0,Pr.jsx)("button",{type:"button",onClick:()=>n(t),children:"Schedule Scan"})]})]})}var tX=f.div`
  ${({$placement:e})=>e==="desktop"&&v`
      position: fixed;
      z-index: 1;
      inset: 0 var(--purchase-master-panel-width) 0 0;
      overflow: hidden;
      background: #efefef;
      @media screen and (max-width: 749px) {
        visibility: hidden;
        inset: 0 auto 0 -100vw;
        width: 100vw;
        pointer-events: none;
      }
    `}
  ${({$placement:e})=>e==="mobile"&&v`
      position: relative;
      width: 100%;
      height: 100%;
      flex: 1 1 auto;
      min-height: 0;
    `}
`,rX=f.div`
  width: 100%;
  height: 100%;
  min-height: 18rem;
`,nX=f.p`
  position: absolute;
  z-index: 2;
  top: 1.5rem;
  right: 1.5rem;
  width: min(22rem, calc(100% - 3rem));
  box-sizing: border-box;
  margin: 0;
  border-radius: 0.75rem;
  background: #ffffff;
  box-shadow: 0 0.25rem 1rem rgba(17, 17, 17, 0.12);
  color: #a21616;
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  line-height: 1.125rem;
`,oX=f.span`
  max-width: min(17rem, 46vw);
  transform: translate(calc(50% + 1.125rem), 0.125rem);
  overflow: visible;
  background: transparent;
  color: #c5221f;
  font-family: Roboto, Arial, sans-serif;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.1875rem;
  letter-spacing: 0;
  text-align: left;
  text-shadow: -2px -2px 0 rgba(255, 255, 255, 0.98),
    0 -2px 0 rgba(255, 255, 255, 0.98), 2px -2px 0 rgba(255, 255, 255, 0.98),
    -2px 0 0 rgba(255, 255, 255, 0.98), 2px 0 0 rgba(255, 255, 255, 0.98),
    -2px 2px 0 rgba(255, 255, 255, 0.98), 0 2px 0 rgba(255, 255, 255, 0.98),
    2px 2px 0 rgba(255, 255, 255, 0.98), 0 0 4px #ffffff;
  white-space: normal;
`,Cu={Frame:tX,Map:rX,Error:nX,MarkerLabel:oX};var Lt=T(oe());var pc=T(k()),iX=10,aX=19,sX=500,lX=1e3,cX=4,dX=60*1e3,uX="__trufitGoogleMapsReady",pX=15*1e3;function mX(e){return 1-(1-Math.min(Math.max(e,0),1))**3}var Xs=null,Hf=new Map,mw=0,fw;function fX(e){let t=(e==null?void 0:e.status)||"";return(e==null?void 0:e.httpStatus)===429||(e==null?void 0:e.httpStatus)===403||t==="RESOURCE_EXHAUSTED"||t==="OVER_QUERY_LIMIT"||t==="PERMISSION_DENIED"||t==="REQUEST_DENIED"}async function hX(e,t,r){let n=new Array(e.length),o=0;return await Promise.all(Array.from({length:Math.min(Math.max(1,t),e.length)},async()=>{for(;o<e.length;){let i=o;o+=1,n[i]=await r(e[i])}})),n}function hw(e){let t=(e==null?void 0:e.status)||"";return(e==null?void 0:e.httpStatus)===429||t==="RESOURCE_EXHAUSTED"||t==="OVER_QUERY_LIMIT"?"Google Geocoding API quota is exhausted.":(e==null?void 0:e.httpStatus)===403||t==="PERMISSION_DENIED"||t==="REQUEST_DENIED"?"Google Geocoding API denied the request. Check billing, API enablement, and key restrictions.":t==="NETWORK_ERROR"?"Google Geocoding API could not be reached.":t&&t!=="ZERO_RESULTS"?`Google Geocoding API failed (${t}).`:"Google Maps could not locate clinic addresses."}async function gw(e){var a;let t={},r={},n={};e.importLibrary&&([t,r,n]=await Promise.all([e.importLibrary("maps"),e.importLibrary("geocoding"),e.importLibrary("marker")]));let o=((a=window.google)==null?void 0:a.maps)||e,i={...o,Map:t.Map||o.Map,Marker:n.Marker||o.Marker,Geocoder:r.Geocoder||o.Geocoder};if(typeof i.Map!="function"||typeof i.Marker!="function"||typeof i.Geocoder!="function"||typeof i.LatLngBounds!="function"||!i.event)throw new Error("Google Maps required libraries could not be initialized.");return i}function gX(e){var t;if(Xs)return Xs;if((t=window.google)!=null&&t.maps)Xs=gw(window.google.maps).catch(r=>{throw Xs=null,r});else if(e)Xs=new Promise((r,n)=>{let o=document.createElement("script"),i,a=()=>{i!==void 0&&window.clearTimeout(i),window.__trufitGoogleMapsReady===l&&delete window.__trufitGoogleMapsReady},s=c=>{a(),Xs=null,n(c)},l=()=>{var c;if(!((c=window.google)!=null&&c.maps)){s(new Error("Google Maps did not initialize."));return}gw(window.google.maps).then(d=>{a(),r(d)},s)};window.__trufitGoogleMapsReady=l,o.src=`https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(e)}&v=weekly&loading=async&callback=${uX}`,o.async=!0,o.defer=!0,o.dataset.trufitGoogleMaps="true",o.addEventListener("error",()=>s(new Error("Google Maps could not be loaded.")),{once:!0}),i=window.setTimeout(()=>s(new Error("Google Maps did not initialize.")),pX),document.head.appendChild(o)});else return Promise.reject(new Error("Google Maps API key is not configured for this theme."));return Xs}async function YX(e,t){var i,a,s;let r=t.trim(),n=/^\d{5}(?:-\d{4})?$/.test(r),o=n?new URL("https://geocode.googleapis.com/v4/geocode/address"):new URL(`https://geocode.googleapis.com/v4/geocode/address/${encodeURIComponent(r)}`);n&&(o.searchParams.set("address.postalCode",r),o.searchParams.set("regionCode","US")),o.searchParams.set("key",e),o.searchParams.set("fields","results.location");try{let l=await fetch(o),c=await l.json().catch(()=>({}));if(!l.ok)return{location:null,failure:{httpStatus:l.status,source:"api-v4",status:(i=c.error)==null?void 0:i.status}};let d=(s=(a=c.results)==null?void 0:a[0])==null?void 0:s.location;return typeof(d==null?void 0:d.latitude)!="number"||typeof d.longitude!="number"?{location:null}:{location:{lat:d.latitude,lng:d.longitude}}}catch(l){return{location:null,failure:{source:"api-v4",status:"NETWORK_ERROR"}}}}function SX(e,t){return new Promise(r=>{new e.Geocoder().geocode({address:t},(o,i)=>{var s;let a=(s=o==null?void 0:o[0])==null?void 0:s.geometry.location;if(i!=="OK"||!a){r({location:null,failure:{source:"maps-js",status:i}});return}r({location:{lat:a.lat(),lng:a.lng()}})})})}function Yw(e,t,r){let n=r.trim().toLowerCase(),o=`${t}:${n}`,i=Hf.get(o);if(i)return i;if(Date.now()<mw)return Promise.resolve({location:null,failure:fw});let a=YX(t,r).then(async s=>{if(s.location)return s;if(fX(s.failure))return mw=Date.now()+dX,fw=s.failure,s;let l=await SX(e,r);return l.location?l:{location:null,failure:s.failure||l.failure}});return Hf.set(o,a),a.then(s=>{s.location||Hf.delete(o)},()=>Hf.delete(o)),a}function yX(e,t){let r=s=>s*Math.PI/180,o=r(t.lat-e.lat),i=r(t.lng-e.lng),a=Math.sin(o/2)**2+Math.cos(r(e.lat))*Math.cos(r(t.lat))*Math.sin(i/2)**2;return 3958.8*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a))}function xX({apiKey:e,clinics:t,className:r="",placement:n,distanceOrigin:o,onClinicSelect:i,onErrorChange:a,onLocationsResolved:s,onVisibleClinicsChange:l,searchRevision:c,focusedClinicId:d,zip:u}){let p=(0,Lt.useRef)(null),m=(0,Lt.useRef)(null),g=(0,Lt.useRef)(null),y=(0,Lt.useRef)(o),P=(0,Lt.useRef)(null),Y=(0,Lt.useRef)(i),h=(0,Lt.useRef)(a),S=(0,Lt.useRef)(s),b=(0,Lt.useRef)(l),W=(0,Lt.useRef)(d),C=(0,Lt.useRef)(u),[w,I]=(0,Lt.useState)("");return y.current=o,Y.current=i,h.current=a,S.current=s,b.current=l,W.current=d,C.current=u,(0,Lt.useEffect)(()=>{let U=!0,L=0,X=null,N,V=null,z=null,te=[],H=[],E=[],Z=ie=>{var re;U&&(I(ie),(re=h.current)==null||re.call(h,ie))};async function ce(){var re;let ie=m.current;if(ie)try{let $=await gX(e);if(!U)return;let D=new $.Map(ie,{center:{lat:39.8283,lng:-98.5795},clickableIcons:!1,fullscreenControl:!1,mapTypeControl:!1,streetViewControl:!1,zoom:4,zoomControl:!0}),B=await hX(t,cX,async R=>{let ee=Ta(R.address),ge=ee?await Yw($,e,ee):{location:null};return{clinic:R,failure:ge.failure,position:ge.location}});if(!U)return;let J=new $.LatLngBounds,A={};B.forEach(({clinic:R,position:ee})=>{var Pe;if(!ee)return;let ge={...ee};A[R._id]=ge,J.extend(ee);let q={className:((Pe=p.current)==null?void 0:Pe.className)||"",color:"#c5221f",fontSize:"16px",fontFamily:"Roboto, Arial, sans-serif",fontWeight:"500",text:R.name},me=new $.Marker({map:D,position:ee,title:R.name});E.push($.event.addListener(me,"click",()=>Y.current(R))),te.push(me),H.push({label:q,marker:me})});let O=t.length>0&&Object.keys(A).length===0,_=(re=B.find(({failure:R})=>R))==null?void 0:re.failure;Z(O?`${hw(_)} Showing clinics as a list; ZIP search uses each clinic's saved ZIP code.`:"");let K=()=>{let R=(D.getZoom()||0)>=iX;H.forEach(({label:ee,marker:ge})=>{ge.setLabel(R?ee:null)})},Ye=()=>{var ge;let R=D.getBounds(),ee=Object.entries(A).filter(([,q])=>!R||R.contains(q)).map(([q])=>q);(ge=b.current)==null||ge.call(b,ee)};E.push($.event.addListener(D,"idle",Ye)),E.push($.event.addListener(D,"zoom_changed",K)),K(),z=new ResizeObserver(()=>{$.event.trigger(D,"resize")}),z.observe(ie);let Se=()=>{X!==null&&(window.cancelAnimationFrame(X),X=null)},Ce=()=>{let R=D.getCenter(),ee=D.getZoom();return!R||typeof ee!="number"?null:{center:{lat:R.lat(),lng:R.lng()},zoom:ee}},pt=(R,ee)=>{Se();let ge=Ce();if(!ge){D.setCenter(R.center),D.setZoom(R.zoom),ee==null||ee();return}let q=Math.min(lX,sX+Math.abs(R.zoom-ge.zoom)*60),me=null,Pe=Ut=>{if(!U)return;me!=null||(me=Ut);let st=Math.min((Ut-me)/q,1),zt=mX(st);D.setCenter({lat:ge.center.lat+(R.center.lat-ge.center.lat)*zt,lng:ge.center.lng+(R.center.lng-ge.center.lng)*zt}),D.setZoom(ge.zoom+(R.zoom-ge.zoom)*zt),st<1?X=window.requestAnimationFrame(Pe):(X=null,ee==null||ee())};X=window.requestAnimationFrame(Pe)};if(P.current=R=>{if(!R){if(!V){N=void 0;return}N=void 0,pt(V,()=>{N||(V=null)});return}let ee=A[R];!ee||N===R||(V||(V=Ce()),N=R,pt({center:ee,zoom:Math.max(D.getZoom()||0,aX)}))},g.current=async(R,ee)=>{var zt;let ge=(ee==null?void 0:ee.preserveCamera)===!0;ge||(Se(),N=void 0,V=null);let q=ge?L:++L,me=R?await Yw($,e,R):{location:null};if(!U||!ge&&q!==L)return;let Pe=me.location,Ut=y.current||Pe,st=Object.fromEntries(Object.entries(A).map(([So,It])=>[So,{...It,...Ut?{distanceMiles:yX(Ut,It)}:{}}]));(zt=S.current)==null||zt.call(S,st),Pe?(!ge&&!N&&(D.setCenter(Pe),D.setZoom(11)),O||Z("")):R?Z(`${hw(me.failure)} Showing clinics matched by their saved ZIP code.`):!ge&&!N&&Object.keys(A).length?D.fitBounds(J):!ge&&!N&&Ye()},await g.current(C.current),W.current){let R=null;R=$.event.addListener(D,"idle",()=>{var ee;R==null||R.remove(),R=null,(ee=P.current)==null||ee.call(P,W.current)}),E.push(R)}}catch($){U&&Z($ instanceof Error&&$.message.includes("API key is not configured")?$.message:"Google Maps is unavailable. Showing clinics as a list.")}}return ce(),()=>{U=!1,L+=1,X!==null&&window.cancelAnimationFrame(X),g.current=null,P.current=null,z==null||z.disconnect(),E.forEach(ie=>ie.remove()),te.forEach(ie=>ie.setMap(null))}},[e,t]),(0,Lt.useEffect)(()=>{var U;(U=g.current)==null||U.call(g,u)},[c,u]),(0,Lt.useEffect)(()=>{var U;(U=g.current)==null||U.call(g,u,{preserveCamera:!0})},[o,u]),(0,Lt.useEffect)(()=>{var U;(U=P.current)==null||U.call(P,d)},[d]),(0,pc.jsxs)(Cu.Frame,{className:r,$placement:n,children:[(0,pc.jsx)(Cu.MarkerLabel,{hidden:!0,"aria-hidden":"true",ref:p}),(0,pc.jsx)(Cu.Map,{className:"scan-google-map",ref:m,"aria-label":"Scan center map"}),w?(0,pc.jsx)(Cu.Error,{className:"scan-map-error",role:"alert","aria-live":"assertive",children:w}):null]})}var Jy=(0,Lt.memo)(xX);var bX=f.section`
  display: grid;
  width: 100%;
  gap: 1rem;
  margin: 0;
  border: 0;
  background: #ffffff;
  color: #111111;
  padding: 0;
  text-align: left;

  @media screen and (max-width: 749px) {
    & {
      gap: 12px;
      border: 0.5px solid #888888;
      border-radius: 12px;
      padding: 16px;
    }
  }
`,CX=f.div`
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  gap: 0.25rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;

  @media screen and (max-width: 749px) {
    & {
      gap: 4px;
    }
    & > span {
      color: #505050;
      font-size: 16px;
      line-height: 20px;
    }
  }
`,PX=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;

  & strong {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }

  & b {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
`,WX=f.button`
  display: flex;
  width: 100%;
  min-height: 3rem;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: #111111;
  color: #ffffff;
  cursor: pointer;
  padding: 0.75rem 1.25rem;
  font: inherit;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;

  @media screen and (max-width: 749px) {
    display: none;
  }
`,Pu={Root:bX,Copy:CX,Heading:PX,Action:WX};var Li=T(k());function Sw(e){let t=se(e);return t?`+$${Number.isInteger(t)?t:t.toFixed(2)}`:""}function yw({actionLabel:e="Add to Order",description:t="Get an easy-to-use at-home impression kit.",onSelect:r,price:n,title:o="Prefer an impression kit?"}){return(0,Li.jsxs)(Pu.Root,{className:"scan-kit-offer",children:[(0,Li.jsxs)(Pu.Copy,{className:"scan-kit-offer-copy",children:[(0,Li.jsxs)(Pu.Heading,{className:"scan-kit-offer-heading",children:[(0,Li.jsx)("strong",{children:o}),Sw(n)?(0,Li.jsx)("b",{children:Sw(n)}):null]}),(0,Li.jsx)("span",{children:t})]}),(0,Li.jsx)(Pu.Action,{type:"button",className:"scan-kit-offer-action",onClick:r,children:e})]})}var Cw=T(xw());function bw(e){let t=e==null?void 0:e.trim();if(!t)return!1;try{return new Intl.DateTimeFormat("en-US",{timeZone:t}).format(),!0}catch(r){return!1}}function wX(e){return Boolean(e&&Number.isFinite(e.lat)&&Number.isFinite(e.lng)&&e.lat>=-90&&e.lat<=90&&e.lng>=-180&&e.lng<=180)}function t0(e,t){var n;let r=(n=e.timezone)==null?void 0:n.trim();if(bw(r))return r||"";if(!wX(t))return"";try{let o=(0,Cw.default)(t.lat,t.lng);return bw(o)?o:""}catch(o){return""}}var Qf=T(oe()),TX={enableHighAccuracy:!1,maximumAge:5*60*1e3,timeout:10*1e3};function Pw(e){let[t,r]=(0,Qf.useState)(null);return(0,Qf.useEffect)(()=>{if(!e||!navigator.geolocation)return;let n=!0;return navigator.geolocation.getCurrentPosition(({coords:o})=>{n&&Number.isFinite(o.latitude)&&Number.isFinite(o.longitude)&&r({lat:o.latitude,lng:o.longitude})},()=>{n&&r(null)},TX),()=>{n=!1}},[e]),t}var ot=T(k()),jf=["scanClinicId","scanClinicName","scanClinicPhone","scanClinicAddress","scanClinicTimezone","scanAppointmentDate","scanAppointmentTime"];function r0(e){return String(e||"").trim().toUpperCase()}function n0({context:e}){var Se,Ce,pt;let{activeSubview:t,closeSubview:r,config:n,continueStep:o,form:i,isModalOpen:a,openSubview:s,setState:l,state:c,totalPrice:d}=e,u=n.clinicApiUrl||"",p=n.googleMapsApiKey||"",[m,g]=(0,gt.useState)([]),[y,P]=(0,gt.useState)({}),[Y,h]=(0,gt.useState)(c.scanZip),[S,b]=(0,gt.useState)(null),[W,C]=(0,gt.useState)(0),[w,I]=(0,gt.useState)(!1),[U,L]=(0,gt.useState)(""),[X,N]=(0,gt.useState)(""),V=(0,gt.useRef)(l),z=Pw(a),te=Boolean(c.scanZip.trim()),H=(0,gt.useMemo)(()=>{var q;let R=se(No(i,"clinic","price")),ge=se(No(i,"impression-kit","price"))-R;return ge>0?String(ge):(q=n.bundleImpressionKitProduct||n.impressionKitProduct)==null?void 0:q.variantPrice},[n,i]),E=(Se=n.scanFlow)==null?void 0:Se.impressionKitOffer,Z=(E==null?void 0:E.isEnabled)!==!1,ce=!te&&Z&&Boolean((Ce=n.bundleImpressionKitProduct||n.impressionKitProduct)==null?void 0:Ce.variantGid);(0,gt.useEffect)(()=>{if(!a)return;let R=!0;return I(!0),L(""),tw({apiUrl:u}).then(ee=>{R&&(g(ee),b(null))}).catch(ee=>{R&&L(ee instanceof Error?ee.message:"Scan centers could not be loaded.")}).finally(()=>{R&&I(!1)}),()=>{R=!1}},[u,a]),V.current=l;let ie=(0,gt.useMemo)(()=>{let R=m.find(ee=>ee._id===c.scanClinicId);return R||(c.scanClinicId?{_id:c.scanClinicId,name:c.scanClinicName,phoneNumber:c.scanClinicPhone,address:null,timezone:c.scanClinicTimezone}:null)},[m,c.scanClinicId,c.scanClinicName,c.scanClinicPhone,c.scanClinicTimezone]),re=(0,gt.useCallback)(R=>{let ee=t0(R,y[R._id]);V.current(ge=>({...ge,scanClinicId:R._id,scanClinicName:R.name,scanClinicPhone:R.phoneNumber||"",scanClinicAddress:Ta(R.address),scanClinicTimezone:ee,scanAppointmentDate:Kf(xu()),scanAppointmentTime:""}),jf),s("clinicDate")},[y,s]),$=(0,gt.useMemo)(()=>ie?t0(ie,y[ie._id]):"",[y,ie]);(0,gt.useEffect)(()=>{!ie||!$||c.scanClinicTimezone===$||V.current(R=>R.scanClinicId===ie._id?{...R,scanClinicTimezone:$}:R,["scanClinicTimezone"])},[ie,$,c.scanClinicTimezone]);let D=(0,gt.useMemo)(()=>{let R=r0(c.scanZip);if(X)return m.filter(q=>{var me;return!R||r0((me=q.address)==null?void 0:me.zip)===R}).sort((q,me)=>q.name.localeCompare(me.name));let ee=S===null?null:new Set(S),ge=(ee==null?void 0:ee.size)===0&&R?new Set(m.filter(q=>{var me;return r0((me=q.address)==null?void 0:me.zip)===R}).map(q=>q._id)):null;return m.filter(q=>ee===null||ee.has(q._id)||(ge==null?void 0:ge.has(q._id))).sort((q,me)=>{var st,zt;let Pe=(st=y[q._id])==null?void 0:st.distanceMiles,Ut=(zt=y[me._id])==null?void 0:zt.distanceMiles;return typeof Pe=="number"&&typeof Ut=="number"?Pe-Ut:typeof Pe=="number"?-1:typeof Ut=="number"?1:q.name.localeCompare(me.name)})},[m,y,X,c.scanZip,S]),B=(0,gt.useCallback)(()=>{L(""),b(null),l(R=>({...R,scanZip:"",scanClinicId:"",scanClinicName:"",scanClinicPhone:"",scanClinicAddress:"",scanClinicTimezone:"",scanAppointmentDate:"",scanAppointmentTime:""}),["scanZip",...jf]),C(R=>R+1)},[l]),J=(0,gt.useCallback)(()=>{let R=Y.trim();if(!R){B();return}L(""),l(ee=>({...ee,scanZip:R,scanClinicId:"",scanClinicName:"",scanClinicPhone:"",scanClinicAddress:"",scanClinicTimezone:"",scanAppointmentDate:"",scanAppointmentTime:""}),["scanZip",...jf]),C(ee=>ee+1)},[B,l,Y]),A=(0,gt.useCallback)(()=>{l(R=>({...R,purchaseMasterFlow:"impression-kit",scanClinicId:"",scanClinicName:"",scanClinicPhone:"",scanClinicAddress:"",scanClinicTimezone:"",scanAppointmentDate:"",scanAppointmentTime:""}),["purchaseMasterFlow",...jf])},[l]),O=R=>{R.key==="Enter"&&(R.preventDefault(),J())},_=t==="clinicDate"||t==="clinicTime"?c.scanClinicId:void 0,K=(0,ot.jsx)(Jy,{apiKey:p,clinics:m,placement:"desktop",className:"scan-desktop-map",distanceOrigin:z,onClinicSelect:re,onErrorChange:N,onLocationsResolved:P,onVisibleClinicsChange:b,searchRevision:W,focusedClinicId:_,zip:c.scanZip});if(t==="clinicMap")return(0,ot.jsxs)(Xr.MapView,{className:"clinic-map-view",children:[(0,ot.jsx)(Xr.MapFrame,{className:"clinic-map-frame",children:(0,ot.jsx)(Jy,{apiKey:p,clinics:m,placement:"mobile",className:"scan-mobile-map",distanceOrigin:z,onClinicSelect:re,onErrorChange:N,onLocationsResolved:P,onVisibleClinicsChange:b,searchRevision:W,focusedClinicId:_,zip:c.scanZip})}),(0,ot.jsx)(Xr.MapActions,{className:"clinic-map-actions",children:(0,ot.jsx)(Ls.Button,{$variant:"primary",type:"button",className:"purchase-master-button purchase-master-button-primary",onClick:r,children:"Close"})})]});let Ye=(t==="clinicDate"||t==="clinicTime")&&ie?(0,ot.jsx)(uw,{apiUrl:u,appointmentDate:c.scanAppointmentDate,appointmentTime:c.scanAppointmentTime,clinic:ie,distanceMiles:(pt=y[ie._id])==null?void 0:pt.distanceMiles,onContinue:o,onDateChange:R=>l(ee=>({...ee,scanAppointmentDate:R,scanAppointmentTime:""}),["scanAppointmentDate","scanAppointmentTime"]),onOpenTime:()=>s("clinicTime"),onTimeChange:R=>l(ee=>({...ee,scanAppointmentTime:R}),["scanAppointmentTime"]),timezone:$,totalPrice:d,view:t}):null;return Ye?(0,ot.jsxs)(Xr.Root,{$view:t,className:"clinic-scan-step",children:[K,Ye]}):(0,ot.jsxs)(Xr.Root,{$view:t,className:"clinic-scan-step",children:[K,(0,ot.jsxs)(Xr.Main,{className:"scan-main",children:[(0,ot.jsx)(Xr.Intro,{className:"scan-intro",children:"Enter your ZIP code to find a nearby scan center."}),(0,ot.jsxs)(Xr.Search,{className:"scan-search",children:[(0,ot.jsx)("input",{type:"text",inputMode:"text",autoComplete:"postal-code","aria-label":"ZIP code",maxLength:10,placeholder:"Enter ZIP Code",value:Y,onChange:R=>{let ee=R.currentTarget.value;h(ee),ee.trim()||B()},onKeyDown:O}),(0,ot.jsx)("button",{type:"button",disabled:w,"aria-busy":w||void 0,onClick:()=>void J(),children:w?"Searching\u2026":"Search"})]}),U?(0,ot.jsx)(Xr.Error,{className:"scan-error",children:U}):null,w?null:m.length?D.length?(0,ot.jsx)(Xr.Results,{className:"scan-results","aria-label":"Visible scan centers","aria-live":"polite",children:D.map(R=>{var ee;return(0,ot.jsx)(pw,{apiUrl:u,clinic:R,distanceMiles:(ee=y[R._id])==null?void 0:ee.distanceMiles,onSchedule:re},R._id)})}):(0,ot.jsx)(Xr.Empty,{className:"scan-empty","aria-live":"polite",children:X?"No scan centers match this ZIP code.":"No scan centers are visible in this map area. Zoom out or move the map to see more."}):U?null:(0,ot.jsx)(Xr.Empty,{className:"scan-empty",children:"No scan centers are currently available."}),te&&m.length&&!X?(0,ot.jsxs)(Xr.MapButton,{type:"button",className:"scan-map-button",onClick:()=>s("clinicMap"),children:["Map View",(0,ot.jsx)(ow,{})]}):null]}),(0,ot.jsxs)(Xr.Summary,{className:"scan-summary",$hasOffer:ce,$view:t,children:[ce?(0,ot.jsx)(yw,{actionLabel:E==null?void 0:E.actionLabel,description:E==null?void 0:E.description,onSelect:A,price:H,title:E==null?void 0:E.title}):null,(0,ot.jsx)(yu,{summary:!0,totalPrice:d})]})]})}var MX=f.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({$customization:e})=>e?"12px":"0.5rem"};
  @media screen and (max-width: 749px) {
    gap: 12px;
  }
`,Ww={InlineGrid:MX};function Ma(e,t){let r=Fe(e.sports,t.sport);return r!=null&&r.recommendedThicknessSize&&Fe(e.thicknessSizes,r.recommendedThicknessSize)?r.recommendedThicknessSize:""}function mc(e,t){let r=Ma(e,t);r?t.thicknessSize=r:t.thicknessSize=Bd(e.thicknessSizes,["Standard","Regular"])}function qf(e,t){let r=Ma(e,t);return(e.thicknessSizes||[]).map(n=>{let o=(e.sports||[]).filter(i=>String(i.recommendedThicknessSize)===String(n.value)).map(i=>ne(i)).filter(Boolean);return{...n,isRecommended:r?String(r)===String(n.value):Boolean(n.isRecommended),sports:o.join(", ")}})}var o0=5,vw={thin:{title:"For facemask sports",description:"Your facemask takes the hit. Thin keeps you talking and breathing.",metrics:[{label:"Protection",score:3},{label:"Durability",score:3},{label:"Comfort",score:5},{label:"Communication",score:5}]},standard:{title:"For open-face",description:"No cage, no striking. The balanced guard most athletes wear.",metrics:[{label:"Protection",score:4},{label:"Durability",score:4},{label:"Comfort",score:4},{label:"Communication",score:4}]},thick:{title:"For striking sports",description:"Built to take a punch. Our highest impact protection.",metrics:[{label:"Protection",score:5},{label:"Durability",score:5},{label:"Comfort",score:3},{label:"Communication",score:3}]}},UX={regular:"standard",heavy:"thick"};function ww(e,t){let r=Fe(e.thicknessSizes,t),n=[r==null?void 0:r.value,r==null?void 0:r.label,t].map(o=>String(o||"").trim().toLowerCase()).filter(Boolean);for(let o of n){let i=vw[o]||vw[UX[o]];if(i)return i}}var Tw=T(oe());var IX=f.div.attrs({className:"thickness-profile"})`
  display: grid;
  gap: 0.75rem;

  @media screen and (max-width: 749px) {
    gap: 8px;
  }
`,VX=f.div`
  display: grid;
  gap: 0.5rem;
`,kX=f.p.attrs({className:"thickness-profile-title"})`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: #111111;
`,LX=f.p.attrs({className:"thickness-profile-description"})`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #555555;
  @media screen and (max-width: 749px) {
    font-size: 13px;
    line-height: 18px;
  }
`,XX=f.dl.attrs({className:"thickness-profile-metrics"})`
  display: grid;
  gap: 0.25rem;
  margin: 0;
  padding: 0.75rem 1rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.5rem;
  background: #ffffff;
  @media screen and (max-width: 749px) {
    padding: 8px 12px;
  }
`,NX=f.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 1rem;
`,EX=f.dt`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #111111;
`,AX=f.dd`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.25rem;
  margin: 0;
`,RX=f.span`
  display: block;
  height: 0.25rem;
  border-radius: 999px;
  background: ${({$filled:e})=>e?"#111111":"#dddddd"};
`,_o={Root:IX,Header:VX,Title:kX,Description:LX,Metrics:XX,Metric:NX,MetricLabel:EX,MetricBars:AX,MetricBar:RX};var bn=T(k());function Mw({profile:e}){return(0,bn.jsxs)(_o.Root,{children:[(0,bn.jsxs)(_o.Header,{children:[(0,bn.jsx)(_o.Title,{children:e.title}),(0,bn.jsx)(_o.Description,{children:(e.description.match(/[^.!?]+[.!?]*/g)||[e.description]).map(t=>t.trim()).filter(Boolean).map((t,r)=>(0,bn.jsxs)(Tw.default.Fragment,{children:[r>0?(0,bn.jsx)("br",{}):null,t]},r))})]}),(0,bn.jsx)(_o.Metrics,{children:e.metrics.map(t=>(0,bn.jsxs)(_o.Metric,{children:[(0,bn.jsx)(_o.MetricLabel,{children:t.label}),(0,bn.jsx)(_o.MetricBars,{"aria-label":`${t.score} out of ${o0}`,children:Array.from({length:o0},(r,n)=>(0,bn.jsx)(_o.MetricBar,{"aria-hidden":"true",$filled:n<t.score},n))})]},t.label))})]})}var GX=f.div.attrs(({$positionStyle:e})=>({style:e}))`
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  width: 100%;
  max-height: ${({$dialog:e})=>e?"min(392px, 45vh)":"24.5rem"};
  overflow-y: auto;
  padding: 0.25rem 0;
  border: 1px solid #c6c6c8;
  border-radius: 0.5rem;
  background: #ffffff;
  ${({$portal:e})=>e&&v`
      right: auto;
      bottom: auto;
      box-sizing: border-box;
      overscroll-behavior: contain;
      box-shadow: 0 12px 28px rgba(17, 17, 17, 0.16);
    `}
`,_X=f.div`
  width: 100%;
  padding: 0.125rem 0.375rem;
`,BX=f.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  min-height: 2.625rem;
  padding: 0.75rem 0.625rem 0.75rem 0.5rem;
  border: 0;
  border-radius: 0.25rem;
  background: ${({$selected:e,$active:t})=>e||t?"#efeff0":"#ffffff"};
  color: #111111;
  cursor: pointer;
  font-family: "DM Sans", Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.125rem;
  text-align: left;
  & > span:last-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:hover {
    background: #efeff0;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`,ZX=f.div`
  position: relative;
  width: ${({$layout:e,$inline:t})=>e==="guard-editor"?"min(100%, 320px)":t?"min(20rem, 100%)":"100%"};
  min-width: 0;
  z-index: ${({$open:e})=>e?30:1};
  ${({$layout:e})=>e==="guard-editor"&&v`
      justify-self: end;
    `}
  @media screen and (max-width: 749px) {
    ${({$layout:e})=>e==="guard-editor"&&v`
        justify-self: stretch;
        width: 100%;
      `}
  }
`,$X=f.button`
  position: relative;
  display: block;
  width: 100%;
  height: 3rem;
  overflow: hidden;
  padding: 0;
  border: 1px solid #c6c6c8;
  border-radius: 0.375rem;
  background: #ffffff;
  color: #414144;
  cursor: pointer;
  font-family: "DM Sans", Arial, sans-serif;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-align: left;
  &:focus-visible {
    outline: 2px solid #111111;
    outline-offset: 2px;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
  ${({$inline:e})=>e&&v`
      height: 1.5rem;
      overflow: visible;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: #1d1d1f;
      font-family: "Poppins", "DM Sans", Arial, sans-serif;
      font-size: 0.875rem;
      line-height: 1.5rem;
    `}
  ${({$dialog:e})=>e&&v`
      height: 64px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
    `}
  ${({$invalid:e,$inline:t})=>e&&!t&&v`
      border-color: #d92d20;
    `}
  @media screen and (max-width: 900px) {
    ${({$dialog:e})=>e&&v`
        height: 56px;
      `}
  }
  @media screen and (max-width: 749px) {
    ${({$stepKey:e})=>e==="details"&&v`
        border-radius: 8px;
      `}
  }
`,OX=f.span`
  position: absolute;
  top: 50%;
  left: ${({$inline:e})=>e?"0":"0.9375rem"};
  right: ${({$inline:e})=>e?"2.25rem":"2.6875rem"};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  transform: translateY(-50%);
  ${({$placeholder:e})=>e&&v`
      color: #6b6b6e;
    `}
  ${({$inline:e})=>e&&v`
      justify-content: flex-end;
    `}
  & > span:last-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`,FX=f.span`
  position: absolute;
  top: 50%;
  right: ${({$inline:e})=>e?"0":"0.4375rem"};
  display: grid;
  place-items: center;
  width: 1.5rem;
  height: 1.5rem;
  pointer-events: none;
  transform: translateY(-50%);
  & img {
    display: block;
    width: 0.6976875rem;
    height: 0.4101875rem;
  }
  & svg {
    display: block;
    width: 0.75rem;
    height: 0.75rem;
    color: #111111;
  }
`,Ua={Menu:GX,OptionWrap:_X,Option:BX,Root:ZX,Trigger:$X,Value:OX,Icon:FX};var Yt=T(oe()),kw=T(ua());var DX=/\s*\((?:optional|required)\)\s*$/i;function fc(e){let t=String(e||"").replace(DX,"").replace(/\s+/g," ").trim();return t?/^select\s/i.test(t)?t:`Select ${t}`:"Select value"}var zX=f.div`
  min-height: 0;
  max-height: calc(100dvh - 10rem);
  overscroll-behavior: contain;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ${({$thickness:e})=>e&&v`
      height: 100%;
      max-height: none;
      overflow: visible;
    `}

  @media screen and (max-width: 749px) {
    flex: 1 1 auto;
    max-height: ${({$appearance:e})=>e==="cart"?"calc(100dvh - 10rem)":"none"};
    padding: 12px 16px 16px;

    ${({$thickness:e})=>e&&v`
        height: auto;
        max-height: calc(100dvh - 88px);
        padding: 0;
        overflow-y: auto;
      `}
  }
`,KX=f.div`
  position: fixed;
  inset: 0;
  z-index: ${({$variant:e,$nested:t})=>e==="returning-customer"?2147483007:t?2147483004:2147483006};
  display: grid;
  place-items: center;
  padding: ${({$variant:e="select"})=>e==="select"?"1.25rem":"60px 24px"};

  ${({$variant:e="select",$thickness:t})=>(e!=="select"||t)&&v`
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(6px);
    `}
  ${({$thickness:e})=>e&&v`
      padding: 60px 72px;
    `}

  &[hidden] {
    display: none;
  }

  @media (max-width: 520px) {
    ${({$variant:e="select"})=>e!=="select"&&v`
        padding: calc(20px + env(safe-area-inset-top))
          calc(16px + env(safe-area-inset-right))
          calc(20px + env(safe-area-inset-bottom))
          calc(16px + env(safe-area-inset-left));
      `}
  }
  @media screen and (max-width: 749px) {
    ${({$variant:e="select",$appearance:t,$thickness:r})=>e==="select"&&v`
        display: ${t==="cart"?"grid":"flex"};
        align-items: center;
        justify-content: center;
        padding: ${r?"12px":t==="cart"?"1.25rem":"calc(20px + env(safe-area-inset-top)) calc(16px + env(safe-area-inset-right)) calc(20px + env(safe-area-inset-bottom)) calc(16px + env(safe-area-inset-left))"};
      `}
  }
`,HX=f.button`
  position: absolute;
  inset: 0;
  border: 0;
  background: ${({$thickness:e})=>e?"transparent":"rgba(0, 0, 0, 0.38)"};
  cursor: pointer;
  @media screen and (max-width: 749px) {
    display: block;
  }
`,QX=f.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: min(100%, 30rem);
  overflow: hidden;
  background: #ffffff;

  ${({$variant:e="select"})=>e==="select"?v`
          max-height: min(100%, 42rem);
          border-radius: 0.5rem;
          padding: 2rem 1.5rem;
          box-shadow: 0 1.5rem 5rem rgba(0, 0, 0, 0.28);
        `:v`
          max-height: calc(100dvh - 120px);
          border: 1px solid #e1e1e1;
          border-radius: 16px;
          box-shadow: 0 0 24px rgba(113, 113, 113, 0.25);
          padding: 0;
          text-align: left;
        `}

  ${({$thickness:e})=>e&&v`
      width: min(100%, 62.5rem);
      height: 31.25rem;
      max-height: min(calc(100dvh - 7.5rem), 31.25rem);
      border-radius: 1rem;
      padding: 0;
      box-shadow: 0 0 1.5rem rgba(113, 113, 113, 0.25);
    `}

  @media (max-width: 520px) {
    ${({$variant:e="select"})=>e!=="select"&&v`
        width: min(calc(100vw - 32px), 358px);
        max-height: calc(
          100dvh - 40px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
        );
      `}
  }
  @media screen and (max-width: 749px) {
    ${({$variant:e="select",$appearance:t,$thickness:r})=>e==="select"&&v`
        padding: 0;
        ${(t!=="cart"||r)&&v`
          width: min(calc(100vw - 40px), 358px);
          max-height: calc(
            100dvh - 40px - env(safe-area-inset-top) -
              env(safe-area-inset-bottom)
          );
          border-radius: 16px;
        `}
        ${t!=="cart"&&!r&&v`
          box-shadow: 0 24px 72px rgba(0, 0, 0, 0.28);
        `}
      ${r&&v`
          height: auto;
          max-height: calc(100dvh - 24px);
        `}
      `}
  }
`,jX=f.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 2rem;

  & h3 {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 1;
  }

  ${({$variant:e="select"})=>e!=="select"&&v`
      min-height: 80px;
      box-sizing: border-box;
      margin: 0;
      border-bottom: 1px solid #d9d9d9;
      padding: 24px;
      & h3 {
        max-width: 25rem;
        color: #111111;
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
      }
    `}
  ${({$thickness:e})=>e&&v`
      position: absolute;
      top: 2.375rem;
      right: 1.5rem;
      z-index: 2;
      width: calc(50% - 3rem);
      margin: 0;
      & h3 {
        font-family: var(--trufit-font-body, "DM Sans", Arial, sans-serif);
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 2rem;
      }
    `}

  @media screen and (max-width: 749px) {
    ${({$variant:e="select",$appearance:t,$thickness:r})=>e==="select"&&v`
        min-height: 64px;
        box-sizing: border-box;
        margin-bottom: ${t==="cart"&&!r?"2rem":"0"};
        border-bottom: 1px solid #d9d9d9;
        padding: 16px 20px;
        & h3 {
          font-size: 22px;
          font-weight: 700;
          line-height: 28px;
        }
      `}
    ${({$thickness:e})=>e&&v`
        position: static;
        width: auto;
        height: 64px;
        margin: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        gap: 16px;
        padding: 16px 20px;
        background: #ffffff;
        & h3 {
          font-size: 22px;
          line-height: 28px;
        }
      `}
  }
`,qX=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  border: 0;
  border-radius: 999px;
  padding: 0;
  background: transparent;
  color: #667085;
  line-height: 0;
  cursor: pointer;
  & svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: 2;
  }
  ${({$thickness:e})=>e&&v`
      width: 1.75rem;
      height: 1.75rem;
      & svg {
        width: 1.5rem;
        height: 1.5rem;
      }
      & > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    `}
  @media screen and (max-width: 749px) {
    ${({$thickness:e})=>e&&v`
        width: 32px;
        height: 32px;
        & svg {
          width: 20px;
          height: 20px;
        }
      `}
  }
`,Bo={Options:zX,Modal:KX,Scrim:HX,Panel:QX,Header:jX,Close:qX};var ka=T(oe()),Iw=T(ua());var Uw=T(oe());var Zo=T(k()),Ia=(0,Uw.forwardRef)(function({children:t,variant:r="select",nested:n=!1,closeIconUrl:o,closeLabel:i,descriptionId:a,hidden:s,modalClassName:l="select-modal",onClose:c,panelClassName:d="select-panel",selectType:u,title:p,titleId:m},g){let y=Oe(),Y={$variant:r,$thickness:u==="thickness",$appearance:y.appearance};return(0,Zo.jsxs)(Bo.Modal,{...Y,$nested:n,className:l,"data-purchase-master-select-type":u||void 0,role:"dialog","aria-labelledby":m,"aria-describedby":a,"aria-modal":"true",hidden:s,children:[(0,Zo.jsx)(Bo.Scrim,{...Y,type:"button",className:"select-scrim","aria-label":i,onClick:c}),(0,Zo.jsxs)(Bo.Panel,{...Y,ref:g,className:d,children:[(0,Zo.jsxs)(Bo.Header,{...Y,className:"select-header",children:[(0,Zo.jsx)("h3",{id:m,children:p}),(0,Zo.jsx)(Bo.Close,{...Y,type:"button",className:"select-close","aria-label":i,onClick:c,children:o?(0,Zo.jsx)(tr,{src:o}):(0,Zo.jsx)(Ro,{})})]}),t]})]})});var Va=T(k());function Vw({ariaLabel:e,closeLabel:t,onClose:r,onSelect:n,options:o,listboxId:i,title:a,value:s}){let l=Oe(),c=`${(0,ka.useId)()}-title`,d=`${(0,ka.useId)()}-listbox`,u=i||d,p=(0,ka.useRef)(null),m=(0,ka.useRef)(null),g=fc(a||e);return(0,ka.useEffect)(()=>{m.current=document.activeElement;let y=document.documentElement.style.overflow,P=document.body.style.overflow;document.documentElement.style.overflow="hidden",document.body.style.overflow="hidden";let Y=h=>{if(h.key==="Escape"){h.preventDefault(),h.stopPropagation(),r();return}if(h.key!=="Tab"||!p.current)return;let S=Array.from(p.current.querySelectorAll("button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex='-1'])"));if(!S.length){h.preventDefault();return}let b=S[0],W=S[S.length-1];h.shiftKey&&document.activeElement===b?(h.preventDefault(),W.focus()):!h.shiftKey&&document.activeElement===W&&(h.preventDefault(),b.focus())};return document.addEventListener("keydown",Y,!0),window.setTimeout(()=>{var h,S;(S=(h=p.current)==null?void 0:h.querySelector("button:not(:disabled)"))==null||S.focus()},0),()=>{var h;document.removeEventListener("keydown",Y,!0),document.documentElement.style.overflow=y,document.body.style.overflow=P,(h=m.current)==null||h.focus()}},[r]),typeof document=="undefined"?null:(0,Iw.createPortal)((0,Va.jsx)(Ia,{ref:p,closeLabel:t,onClose:r,title:g,titleId:c,children:(0,Va.jsx)(Bo.Options,{$variant:"select",$appearance:l.appearance,id:u,className:"select-options",role:"listbox","aria-label":g,children:(0,Va.jsx)(Ii.SelectGrid,{className:"select-grid",children:o.map((y,P)=>{let Y=String(y.value)===String(s);return(0,Va.jsxs)(Ii.SelectOption,{$selected:Y,type:"button",className:"select-option",role:"option","aria-selected":Y,disabled:y.disabled,onClick:()=>{n(y.value),r()},children:[y.swatchStyle?(0,Va.jsx)(Mi.DropdownSwatch,{className:"dropdown-swatch",$swatchStyle:y.swatchStyle,"aria-hidden":"true"}):null,(0,Va.jsx)("span",{children:y.label})]},y.value||`${y.label}-${P}`)})})})}),document.body)}var Xt=T(k());function Lw(e){return(e||[]).map(t=>({label:ne(t),value:String(t.value||"")}))}function Wu(e,t,r){var n;if(!e.length)return-1;for(let o=1;o<=e.length;o+=1){let i=(t+r*o+e.length)%e.length;if(!((n=e[i])!=null&&n.disabled))return i}return-1}function JX(){return(0,Xt.jsx)("svg",{viewBox:"0 0 16 16","aria-hidden":"true",focusable:"false",children:(0,Xt.jsx)("path",{d:"M4 6l4 4 4-4",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"})})}var Jf=(0,Yt.forwardRef)(function({ariaLabel:t,layout:r="default",appearance:n,stepKey:o,inProductDialog:i=!1,className:a,disabled:s=!1,iconUrl:l,invalid:c=!1,onChange:d,options:u,placeholder:p,value:m,variant:g="default"},y){let P=Oe(),Y=i&&(n!=null?n:P.appearance)==="cart",h=(0,Yt.useRef)(null),S=(0,Yt.useRef)(null),b=(0,Yt.useRef)(null),W=`${(0,Yt.useId)()}-listbox`,C=u.findIndex(A=>String(A.value)===String(m)),w=C>=0?u[C]:void 0,I=fc(t),U=p||I,[L,X]=(0,Yt.useState)(!1),[N,V]=(0,Yt.useState)(!1),[z,te]=(0,Yt.useState)(!1),[H,E]=(0,Yt.useState)(C>=0?C:Wu(u,-1,1)),[Z,ce]=(0,Yt.useState)(),ie=(0,Yt.useCallback)(()=>te(!1),[]);(0,Yt.useEffect)(()=>{var _;let A=window.matchMedia("(max-width: 749px)"),O=()=>{V(A.matches),X(!1),te(!1)};return O(),(_=A.addEventListener)==null||_.call(A,"change",O),()=>{var K;return(K=A.removeEventListener)==null?void 0:K.call(A,"change",O)}},[]);let re=(0,Yt.useCallback)(A=>{S.current=A,typeof y=="function"?y(A):y&&(y.current=A)},[y]);(0,Yt.useEffect)(()=>{!L||N||E(C>=0?C:Wu(u,-1,1))},[N,L,u,C]),(0,Yt.useEffect)(()=>{if(!L||N)return;let A=O=>{var K,Ye;let _=O.target;!((K=h.current)!=null&&K.contains(_))&&!((Ye=b.current)!=null&&Ye.contains(_))&&X(!1)};return document.addEventListener("pointerdown",A),()=>document.removeEventListener("pointerdown",A)},[N,L]);let $=(0,Yt.useCallback)(()=>{if(!L||N||g!=="inline"||!S.current)return;let A=S.current.getBoundingClientRect(),O=window.innerWidth,_=window.innerHeight,K=12,Ye=4,Se=Math.min(320,O-K*2),Ce=_-A.bottom-K,pt=A.top-K,R=Ce<160&&pt>Ce,ee=R?pt:Ce,ge=Math.min(Math.max(K,A.right-Se),Math.max(K,O-Se-K));ce({left:ge,maxHeight:Math.max(48,Math.min(392,ee-Ye)),position:"fixed",top:R?A.top-Ye:A.bottom+Ye,transform:R?"translateY(-100%)":void 0,width:Se,zIndex:2147483005})},[N,L,g]);(0,Yt.useLayoutEffect)(()=>{if(!L||N||g!=="inline"){ce(void 0);return}return $(),window.addEventListener("resize",$),window.addEventListener("scroll",$,!0),()=>{window.removeEventListener("resize",$),window.removeEventListener("scroll",$,!0)}},[N,L,$,g]);let D=A=>{var O;A.disabled||(d(A.value),X(!1),(O=S.current)==null||O.focus())},B=A=>{var O,_;if(!s){if(A.key==="Escape"){L?(A.preventDefault(),X(!1),(O=S.current)==null||O.focus()):z&&(A.preventDefault(),te(!1),(_=S.current)==null||_.focus());return}if(A.key==="ArrowDown"||A.key==="ArrowUp"){A.preventDefault();let K=A.key==="ArrowDown"?1:-1;if(!L){N?te(!0):X(!0);return}E(Ye=>Wu(u,Ye,K));return}if(A.key==="Home"&&L){A.preventDefault(),E(Wu(u,-1,1));return}if(A.key==="End"&&L){A.preventDefault(),E(Wu(u,0,-1));return}(A.key==="Enter"||A.key===" ")&&(A.preventDefault(),L?H>=0&&u[H]&&D(u[H]):N?te(!0):X(!0))}},J=L&&!N?(0,Xt.jsx)(Ua.Menu,{$portal:g==="inline",$dialog:Y,ref:b,id:W,className:"dropdown-menu",role:"listbox","aria-label":t,$positionStyle:g==="inline"?Z:void 0,onBlur:A=>{var _;let O=A.relatedTarget;!A.currentTarget.contains(O)&&!((_=h.current)!=null&&_.contains(O))&&X(!1)},onKeyDown:B,children:u.map((A,O)=>{let _=O===C,K=O===H;return(0,Xt.jsx)(Ua.OptionWrap,{className:"dropdown-option-wrap",children:(0,Xt.jsxs)(Ua.Option,{$selected:_,$active:K,id:`${W}-option-${O}`,type:"button",className:"dropdown-option",role:"option","aria-selected":_,disabled:A.disabled,onClick:()=>D(A),onMouseEnter:()=>E(O),children:[A.swatchStyle?(0,Xt.jsx)(Mi.DropdownSwatch,{className:"dropdown-swatch",$swatchStyle:A.swatchStyle,"aria-hidden":"true"}):null,(0,Xt.jsx)("span",{children:A.label})]})},A.value||`${A.label}-${O}`)})}):null;return(0,Xt.jsxs)(Xt.Fragment,{children:[(0,Xt.jsxs)(Ua.Root,{$inline:g==="inline",$layout:r,$open:L||z,ref:h,className:"dropdown",onBlur:A=>{var _;let O=A.relatedTarget;!A.currentTarget.contains(O)&&!((_=b.current)!=null&&_.contains(O))&&X(!1)},onKeyDown:B,children:[(0,Xt.jsxs)(Ua.Trigger,{$inline:g==="inline",$invalid:c,$dialog:Y,$stepKey:o!=null?o:P.stepKey,ref:re,type:"button",className:"dropdown-trigger","aria-controls":W,"aria-expanded":N?z:L,"aria-haspopup":"listbox","aria-label":t,"data-invalid":c?"true":void 0,disabled:s,onClick:()=>{N?te(A=>!A):X(A=>!A)},children:[(0,Xt.jsxs)(Ua.Value,{$inline:g==="inline",$placeholder:!w,className:"dropdown-value",children:[w!=null&&w.swatchStyle?(0,Xt.jsx)(Mi.DropdownSwatch,{className:"dropdown-swatch",$swatchStyle:w.swatchStyle,"aria-hidden":"true"}):null,(0,Xt.jsx)("span",{children:(w==null?void 0:w.label)||U})]}),(0,Xt.jsx)(Ua.Icon,{$inline:g==="inline",className:"dropdown-icon","aria-hidden":"true",children:l?(0,Xt.jsx)(tr,{src:l}):(0,Xt.jsx)(JX,{})})]}),g==="inline"&&typeof document!="undefined"?(0,kw.createPortal)(J,document.body):J]}),N&&z?(0,Xt.jsx)(Vw,{ariaLabel:t,closeLabel:"Close",onClose:ie,onSelect:d,options:u,listboxId:W,title:I,value:m}):null]})});var Wr=T(k());function eN({context:e,thicknessVariant:t="field"}){let{config:r,fieldErrors:n,state:o,setFieldValue:i,setState:a,openSelect:s}=e,{stepKey:l}=Oe(),c=qf(r,o),d=Ge(r.sports),u=Ge(r.thicknessSizes),p=u?ww(r,o.thicknessSize):void 0,m=y=>{a(P=>{let Y={...P,sport:y};return mc(r,Y),Y},["sport","thicknessSize"])},g=()=>s({title:"Thickness Guide",options:c,value:o.thicknessSize,type:"thickness",onSelect:y=>i("thicknessSize",y)});return(0,Wr.jsx)(Wr.Fragment,{children:d||u?(0,Wr.jsxs)(Ww.InlineGrid,{$customization:l==="customization",className:"inline-grid details-fields",children:[d?(0,Wr.jsx)(ks,{label:"Sport (optional)",error:n.sport,className:"sport-field",children:(0,Wr.jsx)(Jf,{stepKey:l,ariaLabel:"Sport (optional)",iconUrl:r.selectChevronIconUrl,invalid:Boolean(n.sport),options:Lw(r.sports),placeholder:"Select Sport",value:o.sport,onChange:m})}):null,u?(0,Wr.jsxs)(ht.Section,{$variant:l==="customization"?"customization":"thickness",className:"form-section form-section-thickness",children:[(0,Wr.jsxs)(ht.LabelRow,{$variant:"thickness",className:"form-label-row form-label-row-thickness",children:[(0,Wr.jsx)(ht.Label,{className:"form-label",children:"Thickness"}),(0,Wr.jsx)(Mi.HelpButton,{type:"button",className:"help-button","aria-label":"Open Thickness Guide",onClick:g,children:"?"})]}),(0,Wr.jsx)(Hv,{invalid:Boolean(n.thicknessSize),options:c,recommendedBadgeUrl:r.recommendedBadgeUrl,value:o.thicknessSize,variant:t,onSelect:y=>i("thicknessSize",y)}),n.thicknessSize?(0,Wr.jsx)(ht.FieldError,{$placement:"form",className:"field-error",children:n.thicknessSize}):null]}):null,p?(0,Wr.jsx)(Mw,{profile:p}):null]}):null})}function i0({context:e}){return(0,Wr.jsx)(eN,{context:e})}var tN=f.div`
  position: relative;
  display: grid;
  gap: 0.75rem;
  padding-bottom: 1rem;

  @media screen and (max-width: 749px) {
    gap: 6px;
  }
`,rN=f.div`
  display: grid;
  gap: 0.75rem;

  @media screen and (max-width: 749px) {
    gap: 6px;
  }
`,nN=f.button`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 3.5rem;
  border: 0.5px solid
    ${({$selected:e,$error:t})=>e?"#111111":t?"#d92d20":"#888888"};
  border-radius: 0.5rem;
  background: #ffffff;
  padding: 1rem;
  color: #111111;
  cursor: pointer;
  text-align: left;

  box-shadow: ${({$selected:e})=>e?"inset 0 0 0 1px #111111":"none"};

  & strong {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    min-height: 44px;
    border-width: 0.5px;
    border-radius: 12px;
    padding: 10px 12px;
    & strong {
      font-size: 18px;
      line-height: 24px;
    }
  }
`,oN=f.p`
  margin: 0;
  color: #323232;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  @media screen and (max-width: 749px) {
    font-size: 14px;
    line-height: 20px;
  }
`,vu={Root:tN,Options:rN,Card:nN,Hint:oN};var $o=T(k());function iN(e){return String(e.value||e.label||"")}function a0({context:e}){let{config:t,fieldErrors:r,labels:n,state:o,setFieldValue:i}=e,a=t.sizes||[];return(0,$o.jsxs)(vu.Root,{className:"impression-kit-step","data-purchase-master-impression-kit":!0,children:[(0,$o.jsx)(ht.LabelRow,{$variant:"impression-kit",className:"form-label-row impression-kit-heading",children:(0,$o.jsx)(ht.Label,{$variant:"impression-kit",className:"form-label",children:n.impressionKitSizeLabel})}),(0,$o.jsx)(vu.Options,{className:"impression-kit-options","aria-invalid":Boolean(r.impressionKitSize)||void 0,children:a.map(s=>{let l=iN(s),c=o.impressionKitSize===l;return(0,$o.jsx)(vu.Card,{type:"button",className:"impression-kit-card",$selected:c,$error:Boolean(r.impressionKitSize),"aria-pressed":c,onClick:()=>i("impressionKitSize",l),children:(0,$o.jsx)("strong",{children:ne(s)})},l||ne(s))})}),(0,$o.jsx)(vu.Hint,{className:"impression-kit-hint",children:n.impressionKitHint}),r.impressionKitSize?(0,$o.jsx)(ht.FieldError,{$placement:"form",className:"field-error",children:r.impressionKitSize}):null]})}var aN=f.button`
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;

  @media screen and (max-width: 749px) {
    grid-template-columns: 56px minmax(0, 1fr);
    gap: 12px;
  }
`,sN=f.div`
  flex: 0 0 auto;
  margin-top: ${({$placement:e})=>e==="sticky"?"0":"0.5rem"};
  @media screen and (max-width: 749px) {
    margin-top: 0;
  }
`,lN=f.div`
  display: flex;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.75rem;
  & > h3 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
  }
  @media screen and (max-width: 749px) {
    height: auto;
    flex: 0 0 auto;
  }
`,cN=f.div`
  display: grid;
  align-content: start;
  gap: 0.75rem;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  scrollbar-width: thin;
  @media screen and (max-width: 749px) {
    flex: 0 0 auto;
    gap: 8px;
    margin-top: 0;
    overflow: visible;
  }
`,wu={CardMain:aN,NewCustomer:sN,Root:lN,List:cN};var Qw=T(oe());var dN=f.div`
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: flex-start;
  flex: 0 0 auto;
  min-height: 1.5rem;
  overflow: hidden;
  border: 0;
  border-radius: 0.375rem;
  background: #ffffff;
  box-shadow: inset 0 0 0 0.5px #111111;
  color: #111111;
  & button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 1rem;
    line-height: 1;
  }
  & span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 1rem;
    line-height: 1;
    width: 2.5rem;
    font-family: Poppins, sans-serif;
  }
  & button img {
    display: block;
    width: 1rem;
    height: 1rem;
  }
  & button {
    cursor: pointer;
  }
  & button:disabled {
    cursor: default;
    opacity: 1;
  }
  ${({$zero:e})=>e&&v`
      & span {
        color: #6e6e73;
      }
    `}
`,uN=f.span`
  display: block;
  width: 3rem;
  height: 0.5rem;
  color: #f5b800;
  font-size: 0.5rem;
  line-height: 0.5rem;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 0;
    background: transparent;
  }
`,pN=f.article`
  display: grid;
  grid-template-columns: 4.25rem minmax(0, 1fr) 2.75rem;
  align-items: center;
  gap: 1rem;
  min-width: 0;
  min-height: 7.25rem;
  box-sizing: border-box;
  border: 0;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #ffffff;
  box-shadow: inset 0 0 0 0.5px #888888;
  @media screen and (max-width: 749px) {
    grid-template-columns: 48px minmax(0, 1fr) auto;
    grid-template-areas:
      "media title price"
      "media description switch";
    column-gap: 12px;
    row-gap: 4px;
    align-items: center;
    min-height: 0;
    border-radius: 12px;
    padding: 10px 12px;
    & > button {
      grid-area: switch;
      justify-self: end;
    }
  }
`,mN=f.div`
  display: flex;
  width: 4.25rem;
  height: 4.25rem;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 0.5rem;
  background: #f8f8f8;
  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media screen and (max-width: 749px) {
    grid-area: media;
    width: 48px;
    height: 48px;
    ${({$stepKey:e})=>e==="impressionKit"&&v`
        & img {
          object-fit: cover;
        }
      `}
  }
`,fN=f.div`
  display: grid;
  min-width: 0;
  gap: 0.5rem;

  & strong {
    overflow: hidden;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & p {
    display: -webkit-box;
    overflow: hidden;
    margin: 0;
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  @media screen and (max-width: 749px) {
    display: contents;
    & > strong {
      grid-area: title;
      font-size: 15px;
      line-height: 20px;
    }
    & > p {
      grid-area: description;
      font-size: 13px;
      line-height: 18px;
      -webkit-line-clamp: 2;
    }
  }
`,hN=f.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  white-space: nowrap;

  & strong {
    flex: 0 0 auto;
  }

  & del {
    flex: 0 0 auto;
    color: #888888;
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
  @media screen and (max-width: 749px) {
    grid-area: price;
    justify-self: end;
    align-self: start;
    & strong {
      font-size: 15px;
      line-height: 20px;
    }
    & del {
      font-size: 13px;
      line-height: 18px;
    }
  }
`,gN=f.div`
  display: grid;
  gap: 0.75rem;
`,La={Quantity:dN,Stars:uN,ProductCard:pN,ProductMedia:mN,ProductCopy:fN,ProductPrice:hN,List:gN};var Oo=T(oe());var Ew=T(k()),Xw=new Map;function s0(e){return Array.from(new Set(e.map(t=>String(t||"").trim()).filter(Boolean)))}function YN(e){var r,n;let t=String(e||"").trim();if(!t||typeof window=="undefined"||!((r=window.location)!=null&&r.origin))return"";try{let o=new URL(t,window.location.origin),i=(n=o.pathname.match(/^\/s\/files\/\d+\/[^/]+\/[^/]+\/files\/(.+)$/))==null?void 0:n[1];return o.hostname!=="cdn.shopify.com"||!i?"":`${window.location.origin}/cdn/shop/files/${i}${o.search}`}catch(o){return""}}function Nw(e){return s0(e.flatMap(t=>[t,YN(t)]))}function SN(e){var o,i;let t=typeof window!="undefined"?window:void 0,r=((i=(o=t==null?void 0:t.Shopify)==null?void 0:o.routes)==null?void 0:i.root)||"/";return`${r.endsWith("/")?r:`${r}/`}products/${encodeURIComponent(e)}.js`}function yN(e){if(!e||typeof e!="object")return[];let t=e,r=[t.featured_image,...Array.isArray(t.images)?t.images:[]].filter(n=>typeof n=="string");return Nw(r)}function xN(e){let t=String(e||"").trim().toLowerCase();if(!t||typeof fetch=="undefined")return Promise.resolve([]);let r=Xw.get(t);if(r)return r;let n=fetch(SN(t),{headers:{Accept:"application/json"}}).then(o=>{if(!o.ok)throw new Error(`Product image lookup failed: ${o.status}`);return o.json()}).then(yN).catch(()=>[]);return Xw.set(t,n),n}function Tu({alt:e,className:t,height:r,imageUrls:n,loading:o="eager",productHandle:i,width:a}){let s=n.join(`
`),l=(0,Oo.useMemo)(()=>Nw(n),[s]),[c,d]=(0,Oo.useState)([]),[u,p]=(0,Oo.useState)(0),[m,g]=(0,Oo.useState)(!1),[y,P]=(0,Oo.useState)(!1),Y=(0,Oo.useMemo)(()=>s0([...l,...c]),[l,c]),h=Y[u]||"";(0,Oo.useEffect)(()=>{d([]),p(0),g(!1),P(!1)},[s,i]);let S=()=>{if(u<Y.length-1){p(b=>b+1);return}if(m||!i){P(!0);return}g(!0),xN(i).then(b=>{let W=s0([...Y,...b]);if(W.length<=Y.length){P(!0);return}d(W.slice(Y.length)),p(Y.length)})};return!h||y?null:(0,Ew.jsx)("img",{src:Xe(h,1e3),alt:e,className:t,width:a,height:r,loading:o,decoding:"async",onError:S})}var Ue=T(k());function bN(e){return e.compareAtPrice&&e.compareAtPrice!==e.variantPrice?e.compareAtPrice:""}function Aw(e){let t=String(e||"").trim();return!t||t.startsWith("+")?t:`+${t}`}function l0(e,t,r){let n=t.step==="upsell"?rt(e.config,"upsell").findIndex(o=>o.key===t.key):-1;e.setState(o=>({...o,upsellProductKey:t.step==="upsell"?t.key:o.upsellProductKey,upsellMediaIndex:n>=0?n:o.upsellMediaIndex,upsellQuantities:{...o.upsellQuantities,[t.key]:Math.max(0,Math.min(99,r))}}))}function CN({disabledMinusIconUrl:e,label:t,minusIconUrl:r,onDecrease:n,onIncrease:o,plusIconUrl:i,quantity:a}){let s=a===0&&e?e:r;return(0,Ue.jsxs)(La.Quantity,{$zero:a===0,className:"upsell-quantity","aria-label":t,children:[(0,Ue.jsx)("button",{type:"button","aria-label":`Decrease ${t}`,disabled:a===0,onClick:n,children:s?(0,Ue.jsx)(tr,{src:s}):"\u2212"}),(0,Ue.jsx)("span",{children:a}),(0,Ue.jsx)("button",{type:"button","aria-label":`Increase ${t}`,onClick:o,children:i?(0,Ue.jsx)(tr,{src:i}):"+"})]})}function c0({configuredProduct:e,context:t,discountLabel:r,showStars:n=!1}){let o=Oe(),{product:i}=e,a=Yn(t.state,e),s=a>0,l=ro(t.config,i),c=l.price||i.variantPrice||"",d=bN({...i,compareAtPrice:l.compareAtPrice,variantPrice:l.price}),u=String(r||"").trim()||l.discountLabel,p=En(i)||"product";return(0,Ue.jsxs)(Qt.Card,{$selected:s,$variant:"default",$stepKey:o.stepKey,$placement:"content",className:"upsell-card",children:[(0,Ue.jsxs)(Qt.CardMedia,{$variant:"default",className:"upsell-card-media",children:[(0,Ue.jsx)(Tu,{alt:p,height:68,imageUrls:Ss(i),productHandle:i.productHandle,width:68}),n?(0,Ue.jsx)(La.Stars,{className:"upsell-stars","aria-label":"5 out of 5 stars",children:t.config.upsellStarsIconUrl?(0,Ue.jsx)(tr,{src:t.config.upsellStarsIconUrl}):"\u2605\u2605\u2605\u2605\u2605"}):null]}),(0,Ue.jsxs)(Qt.CardBody,{$variant:"default",className:"upsell-card-body",children:[(0,Ue.jsx)(Qt.CardTitle,{className:"upsell-card-title",children:p}),i.productDescription?(0,Ue.jsx)(Qt.CardDescription,{className:"upsell-card-description",children:i.productDescription}):null,(0,Ue.jsxs)(Qt.CardFooter,{className:"upsell-card-footer",children:[(0,Ue.jsxs)(Qt.Price,{$variant:"default",className:"upsell-price",children:[i.variantPrice?(0,Ue.jsx)("strong",{children:c}):null,d?(0,Ue.jsx)("del",{children:d}):null,u?(0,Ue.jsx)("span",{children:u}):null]}),(0,Ue.jsx)(CN,{disabledMinusIconUrl:t.config.quantityDisabledMinusIconUrl,label:`Quantity for ${p}`,minusIconUrl:t.config.quantityMinusIconUrl,quantity:a,onDecrease:()=>l0(t,e,a-1),onIncrease:()=>l0(t,e,a+1),plusIconUrl:t.config.quantityPlusIconUrl})]})]})]})}function PN({configuredProduct:e,context:t}){let r=Oe(),{product:n}=e,i=Yn(t.state,e)>0,a=En(n)||"product",s=ro(t.config,n),l=Aw(s.price),c=Aw(s.compareAtPrice);return(0,Ue.jsxs)(La.ProductCard,{$stepKey:r.stepKey,className:"step-product-card",children:[(0,Ue.jsx)(La.ProductMedia,{$stepKey:r.stepKey,className:"step-product-media",children:(0,Ue.jsx)(Tu,{alt:a,height:68,imageUrls:Ss(n),productHandle:n.productHandle,width:68})}),(0,Ue.jsxs)(La.ProductCopy,{className:"step-product-copy",children:[(0,Ue.jsx)("strong",{children:a}),n.productDescription?(0,Ue.jsx)("p",{children:n.productDescription}):null,l||c?(0,Ue.jsxs)(La.ProductPrice,{className:"step-product-price",children:[l?(0,Ue.jsx)("strong",{children:l}):null,c?(0,Ue.jsx)("del",{children:c}):null]}):null,s.discountLabel?(0,Ue.jsx)("small",{children:s.discountLabel}):null]}),(0,Ue.jsx)(Qt.Switch,{$variant:"product",$checked:i,type:"button",className:"switch step-product-switch",role:"switch","aria-checked":i,"aria-label":`${i?"Remove":"Add"} ${a}`,onClick:()=>l0(t,e,zP(t.state,e)),children:(0,Ue.jsx)("span",{})})]})}function Rw({context:e,step:t}){let r=rt(e.config,t);if(!r.length)return null;let n=t==="personDetails"||t==="impressionKit";return(0,Ue.jsx)(La.List,{className:"step-extra-products",children:r.map(o=>n?(0,Ue.jsx)(PN,{configuredProduct:o,context:e},o.key):(0,Ue.jsx)(c0,{configuredProduct:o,context:e},o.key))})}var RD=f.label`
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 0;
  color: #1d1d1d;
  cursor: pointer;
  font-family: Poppins, "DM Sans", Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  white-space: normal;

  & > span:last-child {
    min-width: 0;
  }

  & input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    clip-path: inset(50%);
    white-space: nowrap;
  }

  & input + span {
    display: block;
    box-sizing: border-box;
    flex: 0 0 auto;
    width: 1rem;
    height: 1rem;
    border: 2px solid #c6c6c8;
    border-radius: 999px;
    background: #ffffff;
  }

  & input:checked + span {
    border: 5px solid #3182ce;
  }

  & input:focus-visible + span {
    outline: 2px solid #111111;
    outline-offset: 2px;
  }
`,GD=f.div`
  position: fixed;
  z-index: 2147483001;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);

  @media screen and (max-width: 749px) {
    padding: calc(1.25rem + env(safe-area-inset-top))
      calc(1rem + env(safe-area-inset-right))
      calc(1.25rem + env(safe-area-inset-bottom))
      calc(1rem + env(safe-area-inset-left));
    overflow: hidden;
  }

  & button[aria-busy="true"] {
    cursor: wait;
    opacity: 0.7;
  }
`,_D=f.button`
  position: absolute;
  inset: 0;
  border: 0;
  background: transparent;
  cursor: default;
`,BD=f.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 31.25rem;
  grid-template-rows: auto minmax(0, 1fr);
  grid-template-areas: "image header" "image form";
  row-gap: 2.5rem;
  max-height: calc(100dvh - 3rem);
  width: min(62.5rem, calc(100vw - 3rem));
  overflow: hidden;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 0 1.5rem rgba(113, 113, 113, 0.25);

  @media screen and (max-width: 749px) {
    display: flex;
    max-height: calc(
      100dvh - 2.5rem - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    width: 100%;
    max-width: none;
    height: auto;
    flex-direction: column;
    flex: 0 1 auto;
    gap: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }
`,ZD=f.div`
  grid-area: header;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  min-width: 0;
  padding: 2.375rem 1.5rem 0;
  box-sizing: border-box;
  & h2 {
    min-width: 0;
    flex: 1 1 auto;
    margin: 0;
    color: #111111;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: normal;
    text-align: left;
  }
  & button {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: #111111;
    font-size: 2rem;
    font-weight: 300;
    line-height: 1;
    cursor: pointer;
  }
  & button img {
    display: block;
    width: 2rem;
    height: 2rem;
  }
  @media screen and (max-width: 749px) {
    order: 1;
    min-height: 5rem;
    padding: 1.5rem;
    border-bottom: 1px solid #d9d9d9;
    box-sizing: border-box;
    & h2 {
      display: block;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 2rem;
      letter-spacing: normal;
    }
    ${({$stepKey:e})=>e==="upsell"&&v`
        & h2 {
          line-height: 2rem;
          letter-spacing: normal;
        }
      `}
  }
`,$D=f.div`
  position: relative;
  grid-area: image;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #f7f7f7;
  touch-action: pan-x pan-y;

  @media screen and (max-width: 749px) {
    order: 2;
    width: 100%;
    height: 13.75rem;
    min-height: 13.75rem;
    flex: 0 0 13.75rem;
    aspect-ratio: auto;
  }
`,OD=f.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;

  &::-webkit-scrollbar {
    display: none;
  }
`,FD=f.div`
  position: relative;
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    user-select: none;
    object-fit: cover;
    -webkit-user-drag: none;
  }
`,DD=f.div`
  position: absolute;
  bottom: 4%;
  left: 50%;
  display: flex;
  max-width: calc(100% - 3rem);
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  transform: translateX(-50%);

  @media screen and (max-width: 749px) {
    gap: 0.5rem;
  }
`,zD=f.button`
  appearance: none;
  display: block;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: 1.125rem;
  height: 1.125rem;
  padding: 0;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  ${({$active:e})=>e&&v`
      & {
        border-color: #1d1d1f;
        background: #1d1d1f;
      }
    `}
  &:focus-visible {
    outline: 2px solid #1d1d1f;
    outline-offset: 2px;
  }
  width: 0.75rem;
  height: 0.75rem;
`,KD=f.div`
  grid-area: form;
  display: flex;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  gap: 1.5rem;
  overflow-y: auto;
  padding: 0 1.5rem 2.375rem;
  box-sizing: border-box;

  & p {
    margin: 0;
    color: #505050;
    font-size: 1rem;
    line-height: 1.25rem;
  }

  @media screen and (max-width: 749px) {
    order: 3;
    min-height: 0;
    flex: 0 0 auto;
    gap: 0.5rem;
    padding: 0.5rem 1.25rem calc(2.5rem + env(safe-area-inset-bottom));
    box-sizing: border-box;
    overflow: visible;
    & p {
      line-height: 1.25rem;
    }
  }
`,HD=f.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 1.5rem;
  min-width: 0;
`,QD=f.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
`,jD=f.legend`
  display: block;
  margin: 0 0 0.75rem;
  padding: 0;
  color: #111111;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.25rem;
`,qD=f.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 0;
`,JD=f.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
`,ez=f.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media screen and (max-width: 749px) {
    gap: 0.5rem;
  }
`,tz=f.button`
  box-sizing: border-box;
  width: 100%;
  height: 2.5rem;
  min-height: 2.5rem;
  max-height: 2.5rem;
  padding: 0.5rem 1.25rem;
  border: 0;
  border-radius: 3rem;
  background: #111111;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25rem;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`,rz=f.p`
  margin: -1rem 0 0;
  color: #b42318;
  font-size: 0.875rem;
  line-height: 1.25rem;
`,nz=f.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #111111;
    font-size: 1rem;
    line-height: 1.5rem;
  }

  & div > span:first-child {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    color: #39846c;
    font-weight: 700;
  }

  & div > span:first-child img {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    display: none;
  }
`;var Mt=T(oe()),Fw=T(ua());var WN=Ms`
  html[data-trufit-purchase-master-open] #gorgias-chat-container {
    display: none !important;
  }

`,qr={Document:WN};var hc=f.div`
  position: fixed;
  inset: 0;
  z-index: 2147483004;
  display: grid;
  place-items: center;
  padding: 16px;

  @media screen and (max-width: 749px) {
    align-items: end;
    padding: 12px 0 0;
  }
`,gc=f.button`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  background: rgba(17, 17, 17, 0.45);
  cursor: pointer;
`,Yc=f.div`
  position: relative;
  z-index: 1;
  width: min(${e=>e.$width||520}px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 24px 26px 22px;
  border-radius: 22px;
  background: #ffffff;
  color: #111111;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.3);
  font-family: inherit;
  text-align: left;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  button {
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  .pp-hd {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .pp-hd h2 {
    margin: 0;
    font-size: 21px;
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.25;
  }

  .pp-hd p {
    margin: 4px 0 0;
    font-size: 14px;
    line-height: 1.45;
    color: #505050;
  }

  .pp-x {
    flex: none;
    width: 36px;
    height: 36px;
    margin: -6px -8px 0 0;
    border: 0;
    background: transparent;
    font-size: 24px;
    line-height: 1;
  }

  .pp-note {
    margin: 0;
    font-size: 13.5px;
    line-height: 1.45;
    color: #6b6b6b;
  }

  .pp-cmp {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 10px;
    align-items: center;
  }

  .pp-cmp > div {
    min-width: 0;
    padding: 12px 14px;
    border: 1.5px solid #cfcfcf;
    border-radius: 14px;
  }

  .pp-cmp > div.is-on {
    border: 2px solid #111111;
  }

  .pp-cmp b {
    display: block;
    font-size: 15px;
  }

  .pp-cmp small {
    font-size: 12.5px;
    color: #505050;
  }

  .pp-cmp s {
    margin-left: 4px;
    color: #9a9a9a;
  }

  .pp-arrow {
    font-size: 20px;
  }

  .pp-btns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .pp-btn {
    min-height: 50px;
    padding: 0 14px;
    border-radius: 999px;
    border: 1.5px solid #111111;
    background: #ffffff;
    font-size: 16px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .pp-btn.is-primary {
    background: #111111;
    color: #ffffff !important;
  }

  .pp-btn:disabled {
    opacity: 0.6;
    cursor: default;
  }

  .pp-spin {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid currentColor;
    border-right-color: transparent;
    animation: pp-spin 0.8s linear infinite;
  }

  @keyframes pp-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 749px) {
    width: 100%;
    max-height: calc(100dvh - 12px);
    padding: 10px 18px calc(16px + env(safe-area-inset-bottom, 0px));
    gap: 12px;
    border-radius: 22px 22px 0 0;

    &::before {
      content: "";
      display: block;
      width: 40px;
      height: 5px;
      margin: 0 auto 2px;
      border-radius: 9px;
      background: #d9d9d9;
    }

    .pp-btns {
      grid-template-columns: 1fr;
    }
  }
`;var Gw={"Design your guard":"Concevez votre prot\xE8ge-dents","Design your {product}":"Concevez votre {product}",Design:"Design","Impression kit":"Trousse",Kit:"Trousse","Review & checkout":"R\xE9vision et paiement",Checkout:"Paiement",Review:"R\xE9vision","30-day Perfect Fit guarantee":"Garantie Perfect Fit de 30 jours","Made in the USA":"Fabriqu\xE9 aux \xC9tats-Unis","Free US shipping":"Livraison gratuite aux \xC9tats-Unis","free US shipping":"livraison gratuite aux \xC9.-U.","Why TRUFIT":"Pourquoi TRUFIT","Adding\u2026":"Ajout\u2026","Add to cart \xB7 {total}":"Ajouter au panier \xB7 {total}","Review order":"R\xE9viser la commande","Continue to kit":"Continuer vers la trousse","Impression kit trays: small, regular and large":"Porte-empreintes de la trousse : petit, r\xE9gulier et grand","Live preview \xB7 colors update as you go":"Aper\xE7u en direct \xB7 les couleurs changent au fur et \xE0 mesure",Back:"Retour",Close:"Fermer",Progress:"Progression","Step {current} of {total}":"\xC9tape {current} sur {total}",Total:"Total","{amount} per guard":"{amount} par prot\xE8ge-dents","Guard position":"Position du prot\xE8ge-dents","Change sport and thickness":"Changer le sport et l\u2019\xE9paisseur","Choose sport":"Choisir",Recommended:"Recommand\xE9",Standard:"Standard",Change:"Changer","ID tag":"\xC9tiquette ID","Up to 4 characters":"4 caract\xE8res max.","ID tag, up to 4 characters":"\xC9tiquette ID, 4 caract\xE8res maximum","ID tag example":"Exemple d\u2019\xE9tiquette ID","Same as guard 1":"Comme le n\xB0 1","Guard {number}":"N\xB0 {number}","Guard {number}: {color}":"Prot\xE8ge-dents {number} : {color}",Edit:"Modifier","Live preview":"Aper\xE7u en direct","Guard color":"Couleur du prot\xE8ge-dents","Pad color":"Couleur des coussinets","no pads":"sans coussinets","{color} pads":"coussinets : {color}","Remove {name}":"Retirer {name}","Add {name}":"Ajouter {name}","Added \u2713":"Ajout\xE9 \u2713",Add:"Ajouter","{thickness} recommended for {sport}":"{thickness} recommand\xE9 pour {sport}","More protection":"Plus de protection","Even more protection":"Encore plus de protection","Choose your sport":"Choisissez votre sport","Other / training":"Autre / entra\xEEnement",Thickness:"\xC9paisseur",Done:"Termin\xE9","Kit size":"Taille","Not sure? Regular fits most people":"Incertain? Prenez R\xE9gulier","Ages 6\u201312":"6 \xE0 12 ans","Fits most people":"Pour la plupart","Big jaws":"Grandes m\xE2choires","Please enter a first and last name.":"Veuillez entrer un pr\xE9nom et un nom.","Who is this for?":"Pour qui est-ce?","So we know whose kit and guard this is.":"Pour savoir \xE0 qui sont la trousse et le prot\xE8ge-dents.","First name":"Pr\xE9nom","Last name":"Nom",Save:"Enregistrer","Who is it for?":"Pour qui?",Me:"Moi","For {name}":"Pour {name}","Someone else":"Quelqu\u2019un d\u2019autre","Your impression kit":"Votre trousse d\u2019empreinte","Take it at home, mail it back in the same box.":"Empreinte \xE0 la maison, retour dans la m\xEAme bo\xEEte.","We already have an impression for this guard, so no new kit is needed.":"Nous avons d\xE9j\xE0 une empreinte pour ce prot\xE8ge-dents : aucune nouvelle trousse n\u2019est n\xE9cessaire.",Position:"Position","Extra impression material":"P\xE2te d\u2019empreinte en plus","2 more attempts":"2 essais de plus","Unsure about your impression?":"Un doute?","Email a photo to":"Envoyez une photo \xE0","for a free review before mailing your kit back. If needed, we'll send additional impression material at no charge. Kits returned with faulty impressions will incur a $15 USD replacement fee.":"pour une v\xE9rification gratuite avant de nous retourner votre trousse. Au besoin, nous vous enverrons de la p\xE2te d\u2019empreinte suppl\xE9mentaire sans frais. Les trousses retourn\xE9es avec des empreintes d\xE9fectueuses entra\xEEnent des frais de remplacement de 15 $ US.","Braces?":"Broches?","Don't use the kit: the putty can get stuck in your brackets. Ask your dentist or orthodontist for a digital scan and email the STL file to":"N\u2019utilisez pas la trousse : la p\xE2te peut rester coinc\xE9e dans vos broches. Demandez un balayage num\xE9rique \xE0 votre dentiste ou orthodontiste et envoyez le fichier STL \xE0","Skip the kit, email us a scan.":"Envoyez-nous plut\xF4t un balayage.",How:"Comment","2nd":"2e","3rd":"3e","{number}th":"{number}e","Add another product":"Ajouter un autre produit","{name} added \xB7 you'll pick its options in your cart":"{name} ajout\xE9 \xB7 choisissez ses options dans le panier","{names} added \xB7 you'll pick their options in your cart":"{names} ajout\xE9s \xB7 choisissez leurs options dans le panier","Same impression \xB7 no extra kit":"M\xEAme empreinte \xB7 aucune trousse de plus","Add a {ordinal} guard":"Un {ordinal} prot\xE8ge-dents","Add another new customer":"Ajouter un client",Teammate:"Co\xE9quipier","Add more whitening gel":"Ajouter du gel blanchissant","Gel strength":"Concentration du gel","{name} guards":"prot\xE8ge-dents {name}","for {name}":"pour {name}","for me":"pour moi",Includes:"Comprend","Tray, whitening gel, case":"Goutti\xE8re, gel blanchissant, \xE9tui","Guards 1\u2013{count}":"N\xB0 1\u2013{count}",Guard:"Prot\xE8ge-dents","Custom colors per guard":"Couleurs diff\xE9rentes par prot\xE8ge-dents","same as #1":"comme le n\xBA 1","on {tagged} of {count} guards":"sur {tagged} des {count} prot\xE8ge-dents","Impression on file, not needed":"Empreinte au dossier, non requise",Arrives:"Livraison","Kit in 2\u20135 business days":"Trousse en 2 \xE0 5 jours ouvrables","7\u201310 business days":"7 \xE0 10 jours ouvrables","Add to your order":"Ajouter \xE0 votre commande","One tap":"En un geste","Adding...":"Ajout\u2026","Close the customizer":"Fermer le configurateur","Customizer progress":"Progression du configurateur","Choose a fit position.":"Choisissez une position.","Choose a strength.":"Choisissez une concentration.","Select a thickness.":"Choisissez une \xE9paisseur.","Choose who this will be fit for.":"Choisissez pour qui c\u2019est.","Please enter first name":"Entrez le pr\xE9nom","Please enter last name":"Entrez le nom","Select an impression kit size":"Choisissez la taille de la trousse","Select a guard color.":"Choisissez la couleur du prot\xE8ge-dents.","Select a pad color.":"Choisissez la couleur des coussinets.","Enter an ID tag.":"Entrez une \xE9tiquette d\u2019identification.","ID tag is unavailable. Please try again later.":"L\u2019\xE9tiquette d\u2019identification n\u2019est pas disponible. R\xE9essayez plus tard.","ID tag price is unavailable. Please try again later.":"Le prix de l\u2019\xE9tiquette n\u2019est pas disponible. R\xE9essayez plus tard.",White:"Blanc",Clear:"Transparent",Blue:"Bleu",Yellow:"Jaune",Orange:"Orange",Red:"Rouge",Purple:"Violet",Green:"Vert",Black:"Noir","No Pads":"Sans coussinets",white:"blanc",clear:"transparent",blue:"bleu",yellow:"jaune",orange:"orange",red:"rouge",purple:"violet",green:"vert",black:"noir",Upper:"Haut",Lower:"Bas",upper:"haut",lower:"bas",Thin:"Mince",Heavy:"\xC9pais",thin:"mince",standard:"standard",heavy:"\xE9pais",Small:"Petit",Regular:"R\xE9gulier",Large:"Grand",Football:"Football","Brazilian Jiu-Jitsu":"Jiu-jitsu br\xE9silien","Ice Hockey (visor/open face)":"Hockey (visi\xE8re/ouvert)","Ice Hockey (caged)":"Hockey (grille)","Lacrosse (Men's)":"Crosse (hommes)","Lacrosse (Women's)":"Crosse (femmes)","Baseball/Softball":"Baseball/softball",Basketball:"Basketball",BMX:"BMX",Boxing:"Boxe","Field Hockey":"Hockey sur gazon","Flag Football":"Flag-football",Kickboxing:"Kickboxing","Mixed Martial Arts":"Arts martiaux mixtes","Motor Sports":"Sports motoris\xE9s","Roller Derby":"Roller derby","Skiing/Snowboarding":"Ski/planche \xE0 neige",Soccer:"Soccer",Taekwondo:"Taekwondo","Water Polo":"Water-polo",Wrestling:"Lutte","save {amount}":"\xE9conomisez {amount}","Family, friend or teammate":"Famille, ami ou co\xE9quipier","3D Printed Model of Your Teeth":"Mod\xE8le 3D de vos dents","Remove guard {number}":"Retirer le n\xB0 {number}","Guard {number} added":"N\xB0 {number} ajout\xE9","Tap to remove":"touchez pour retirer","About the 30-day Perfect Fit guarantee":"\xC0 propos de la garantie Perfect Fit de 30 jours","If the fit isn't right, tell us within 30 days and we'll make it right. Signs of chewing or biting damage void the guarantee, as do impressions we flagged as faulty.":"Si l\u2019ajustement n\u2019est pas parfait, dites-le-nous dans les 30 jours et nous arrangerons les choses. Les traces de mastication ou de morsure annulent la garantie, tout comme les empreintes que nous avons signal\xE9es comme d\xE9fectueuses.","Email us a photo for a free review.":"Envoyez une photo, c\u2019est gratuit.",Details:"D\xE9tails","Your kit includes four attempts.":"Quatre essais inclus.","Two upper + two lower. Send photos for a free review before mailing your impressions back.":"Deux du haut + deux du bas. Photos v\xE9rifi\xE9es gratuitement avant le retour.","Me ({name})":"Moi ({name})",Clinical:"Clinique",Lite:"L\xE9g\xE8re","Lite is gentler on sensitive teeth.":"La l\xE9g\xE8re est plus douce pour les dents sensibles.","Whitening gel":"Gel blanchissant","Same impression as guard 1 \xB7 change anything":"M\xEAme empreinte que le prot\xE8ge-dents 1 \xB7 modifiez ce que vous voulez","Save guard {number}":"Enregistrer le prot\xE8ge-dents {number}",optional:"facultatif",Sport:"Sport","Guard preview":"Aper\xE7u du prot\xE8ge-dents","Add someone else":"Ajouter une autre personne","Their own impression kit and custom-fit guard":"Sa propre trousse d\u2019empreinte et son prot\xE8ge-dents sur mesure",Product:"Produit","1 guard":"1 prot\xE8ge-dents","{count} guards":"{count} prot\xE8ge-dents","Add to order":"Ajouter \xE0 la commande","Scan stored for reorders":"Empreinte conserv\xE9e pour les nouvelles commandes","HSA / FSA":"HSA / FSA","Unable to add this product. Please try again.":"Impossible d\u2019ajouter ce produit. Veuillez r\xE9essayer.","Remove guard {number}?":"Retirer le prot\xE8ge-dents {number}?","Your package changes from {from} to {to}.":"Votre forfait passe de {from} \xE0 {to}.","Your total updates right away. You can add a guard back any time before checkout.":"Votre total se met \xE0 jour tout de suite. Vous pouvez rajouter un prot\xE8ge-dents avant de payer.","Keep {count}":"Garder {count}","Updating...":"Mise \xE0 jour...","Leave without adding to cart?":"Quitter sans ajouter au panier?","Your guard isn't in your cart yet.":"Votre prot\xE8ge-dents n\u2019est pas encore dans votre panier.","Keep customizing":"Continuer la personnalisation",Leave:"Quitter","Sports Mouthguard":"Prot\xE8ge-dents de sport",Nightguard:"Prot\xE8ge-dents de nuit",Retainer:"Appareil de r\xE9tention","Whitening Tray":"Goutti\xE8re de blanchiment"};var _w={"Design your guard":"Dise\xF1a tu protector","Design your {product}":"Dise\xF1a tu {product}",Design:"Dise\xF1o","Impression kit":"Kit de impresi\xF3n",Kit:"Kit","Review & checkout":"Revisar y pagar",Checkout:"Pago",Review:"Revisi\xF3n","30-day Perfect Fit guarantee":"Garant\xEDa Perfect Fit de 30 d\xEDas","Made in the USA":"Hecho en EE. UU.","Free US shipping":"Env\xEDo gratis en EE. UU.","free US shipping":"env\xEDo gratis en EE. UU.","Why TRUFIT":"Por qu\xE9 TRUFIT","Adding\u2026":"Agregando\u2026","Add to cart \xB7 {total}":"Agregar al carrito \xB7 {total}","Review order":"Revisar pedido","Continue to kit":"Continuar al kit","Impression kit trays: small, regular and large":"Cubetas del kit de impresi\xF3n: peque\xF1a, regular y grande","Live preview \xB7 colors update as you go":"Vista previa en vivo \xB7 los colores cambian al instante",Back:"Atr\xE1s",Close:"Cerrar",Progress:"Progreso","Step {current} of {total}":"Paso {current} de {total}",Total:"Total","{amount} per guard":"{amount} por protector","Guard position":"Posici\xF3n del protector","Change sport and thickness":"Cambiar deporte y grosor","Choose sport":"Elegir deporte",Recommended:"Recomendado",Standard:"Est\xE1ndar",Change:"Cambiar","ID tag":"Etiqueta ID","Up to 4 characters":"Hasta 4 caracteres","ID tag, up to 4 characters":"Etiqueta ID, hasta 4 caracteres","ID tag example":"Ejemplo de etiqueta ID","Same as guard 1":"Igual al protector 1","Guard {number}":"Protector {number}","Guard {number}: {color}":"Protector {number}: {color}",Edit:"Editar","Live preview":"Vista previa en vivo","Guard color":"Color del protector","Pad color":"Color de almohadillas","no pads":"sin almohadillas","{color} pads":"almohadillas: {color}","Remove {name}":"Quitar {name}","Add {name}":"Agregar {name}","Added \u2713":"Agregado \u2713",Add:"Agregar","{thickness} recommended for {sport}":"{thickness} recomendado para {sport}","More protection":"M\xE1s protecci\xF3n","Even more protection":"A\xFAn m\xE1s protecci\xF3n","Choose your sport":"Elige tu deporte","Other / training":"Otro / entrenamiento",Thickness:"Grosor",Done:"Listo","Kit size":"Tama\xF1o del kit","Not sure? Regular fits most people":"\xBFDudas? Elige Regular","Ages 6\u201312":"6 a 12 a\xF1os","Fits most people":"Para la mayor\xEDa","Big jaws":"Mand\xEDbulas grandes","Please enter a first and last name.":"Ingresa nombre y apellido.","Who is this for?":"\xBFPara qui\xE9n es?","So we know whose kit and guard this is.":"As\xED sabemos de qui\xE9n son el kit y el protector.","First name":"Nombre","Last name":"Apellido",Save:"Guardar","Who is it for?":"\xBFPara qui\xE9n?",Me:"Para m\xED","For {name}":"Para {name}","Someone else":"Otra persona","Your impression kit":"Tu kit de impresi\xF3n","Take it at home, mail it back in the same box.":"T\xF3mala en casa y env\xEDala de vuelta en la misma caja.","We already have an impression for this guard, so no new kit is needed.":"Ya tenemos una impresi\xF3n para este protector, as\xED que no necesitas un kit nuevo.",Position:"Posici\xF3n","Extra impression material":"Material extra","2 more attempts":"2 intentos m\xE1s","Unsure about your impression?":"\xBFDudas sobre tu impresi\xF3n?","Email a photo to":"Env\xEDa una foto a","for a free review before mailing your kit back. If needed, we'll send additional impression material at no charge. Kits returned with faulty impressions will incur a $15 USD replacement fee.":"para una revisi\xF3n gratis antes de devolver tu kit. Si hace falta, te enviamos material de impresi\xF3n adicional sin costo. Los kits devueltos con impresiones defectuosas tienen un cargo de reemplazo de 15 USD.","Braces?":"\xBFBrackets?","Don't use the kit: the putty can get stuck in your brackets. Ask your dentist or orthodontist for a digital scan and email the STL file to":"No uses el kit: la masilla puede quedar atrapada en tus brackets. Pide a tu dentista u ortodoncista un escaneo digital y env\xEDa el archivo STL a","Skip the kit, email us a scan.":"Sin kit: env\xEDanos un escaneo.",How:"C\xF3mo","2nd":"2.\xBA","3rd":"3.\xBA","{number}th":"{number}.\xBA","Add another product":"Agregar otro producto","{name} added \xB7 you'll pick its options in your cart":"{name} agregado \xB7 elige sus opciones en el carrito","{names} added \xB7 you'll pick their options in your cart":"{names} agregados \xB7 elige sus opciones en el carrito","Same impression \xB7 no extra kit":"Misma impresi\xF3n \xB7 sin kit extra","Add a {ordinal} guard":"Agrega un {ordinal} protector","Add another new customer":"Agregar cliente",Teammate:"Compa\xF1ero","Add more whitening gel":"Agrega m\xE1s gel blanqueador","Gel strength":"Concentraci\xF3n del gel","{name} guards":"protectores {name}","for {name}":"para {name}","for me":"para m\xED",Includes:"Incluye","Tray, whitening gel, case":"F\xE9rula, gel blanqueador, estuche","Guards 1\u2013{count}":"N.\xBA 1\u2013{count}",Guard:"Protector","Custom colors per guard":"Colores distintos por protector","same as #1":"igual al n.\xBA 1","on {tagged} of {count} guards":"en {tagged} de {count} protectores","Impression on file, not needed":"Impresi\xF3n en archivo, no se necesita",Arrives:"Llega","Kit in 2\u20135 business days":"Kit en 2 a 5 d\xEDas h\xE1biles","7\u201310 business days":"7 a 10 d\xEDas h\xE1biles","Add to your order":"Agrega a tu pedido","One tap":"Con un toque","Adding...":"Agregando\u2026","Close the customizer":"Cerrar el personalizador","Customizer progress":"Progreso del personalizador","Choose a fit position.":"Elige una posici\xF3n.","Choose a strength.":"Elige una concentraci\xF3n.","Select a thickness.":"Elige un grosor.","Choose who this will be fit for.":"Elige para qui\xE9n es.","Please enter first name":"Escribe el nombre","Please enter last name":"Escribe el apellido","Select an impression kit size":"Elige la talla del kit","Select a guard color.":"Elige el color del protector.","Select a pad color.":"Elige el color de las almohadillas.","Enter an ID tag.":"Escribe una etiqueta de identificaci\xF3n.","ID tag is unavailable. Please try again later.":"La etiqueta de identificaci\xF3n no est\xE1 disponible. Int\xE9ntalo m\xE1s tarde.","ID tag price is unavailable. Please try again later.":"El precio de la etiqueta no est\xE1 disponible. Int\xE9ntalo m\xE1s tarde.",White:"Blanco",Clear:"Transparente",Blue:"Azul",Yellow:"Amarillo",Orange:"Naranja",Red:"Rojo",Purple:"Morado",Green:"Verde",Black:"Negro","No Pads":"Sin almohadillas",white:"blanco",clear:"transparente",blue:"azul",yellow:"amarillo",orange:"naranja",red:"rojo",purple:"morado",green:"verde",black:"negro",Upper:"Superior",Lower:"Inferior",upper:"superior",lower:"inferior",Thin:"Delgado",Heavy:"Grueso",thin:"delgado",standard:"est\xE1ndar",heavy:"grueso",Small:"Chico",Regular:"Regular",Large:"Grande",Football:"F\xFAtbol americano","Brazilian Jiu-Jitsu":"Jiu-jitsu brasile\xF1o","Ice Hockey (visor/open face)":"Hockey (visera/abierto)","Ice Hockey (caged)":"Hockey (rejilla)","Lacrosse (Men's)":"Lacrosse (hombres)","Lacrosse (Women's)":"Lacrosse (mujeres)","Baseball/Softball":"B\xE9isbol/s\xF3ftbol",Basketball:"B\xE1squetbol",BMX:"BMX",Boxing:"Boxeo","Field Hockey":"Hockey sobre c\xE9sped","Flag Football":"Flag football",Kickboxing:"Kickboxing","Mixed Martial Arts":"Artes marciales mixtas","Motor Sports":"Deportes de motor","Roller Derby":"Roller derby","Skiing/Snowboarding":"Esqu\xED/snowboard",Soccer:"F\xFAtbol",Taekwondo:"Taekwondo","Water Polo":"Waterpolo",Wrestling:"Lucha","save {amount}":"ahorra {amount}","Family, friend or teammate":"Familia, amigo o compa\xF1ero","3D Printed Model of Your Teeth":"Modelo 3D de tus dientes","Remove guard {number}":"Quitar el n.\xBA {number}","Guard {number} added":"N.\xBA {number} agregado","Tap to remove":"toca para quitar","About the 30-day Perfect Fit guarantee":"Sobre la garant\xEDa Perfect Fit de 30 d\xEDas","If the fit isn't right, tell us within 30 days and we'll make it right. Signs of chewing or biting damage void the guarantee, as do impressions we flagged as faulty.":"Si el ajuste no es correcto, av\xEDsanos dentro de 30 d\xEDas y lo solucionaremos. Las marcas de masticaci\xF3n o mordidas anulan la garant\xEDa, igual que las impresiones que marcamos como defectuosas.","Email us a photo for a free review.":"Env\xEDanos una foto y la revisamos gratis.",Details:"Detalles","Your kit includes four attempts.":"Tu kit incluye cuatro intentos.","Two upper + two lower. Send photos for a free review before mailing your impressions back.":"Dos superiores + dos inferiores. Env\xEDa fotos para una revisi\xF3n gratis antes de devolver tus impresiones.","Me ({name})":"Yo ({name})",Clinical:"Cl\xEDnica",Lite:"Ligera","Lite is gentler on sensitive teeth.":"La ligera es m\xE1s suave para dientes sensibles.","Whitening gel":"Gel blanqueador","Same impression as guard 1 \xB7 change anything":"Misma impresi\xF3n que el protector 1 \xB7 cambia lo que quieras","Save guard {number}":"Guardar protector {number}",optional:"opcional",Sport:"Deporte","Guard preview":"Vista previa del protector","Add someone else":"Agregar a otra persona","Their own impression kit and custom-fit guard":"Su propio kit de impresi\xF3n y protector a medida",Product:"Producto","1 guard":"1 protector","{count} guards":"{count} protectores","Add to order":"Agregar al pedido","Scan stored for reorders":"Escaneo guardado para nuevos pedidos","HSA / FSA":"HSA / FSA","Unable to add this product. Please try again.":"No se pudo agregar este producto. Int\xE9ntalo de nuevo.","Remove guard {number}?":"\xBFQuitar el protector {number}?","Your package changes from {from} to {to}.":"Tu paquete cambia de {from} a {to}.","Your total updates right away. You can add a guard back any time before checkout.":"Tu total se actualiza al instante. Puedes volver a agregar un protector antes de pagar.","Keep {count}":"Mantener {count}","Updating...":"Actualizando...","Leave without adding to cart?":"\xBFSalir sin agregar al carrito?","Your guard isn't in your cart yet.":"Tu protector a\xFAn no est\xE1 en tu carrito.","Keep customizing":"Seguir personalizando",Leave:"Salir","Sports Mouthguard":"Protector bucal deportivo",Nightguard:"F\xE9rula nocturna",Retainer:"Retenedor","Whitening Tray":"F\xE9rula de blanqueamiento"};var Bw={"Your cart":"Votre panier","Your order":"Votre commande","name from checkout":"nom saisi au paiement","For {name}":"Pour {name}","Cancel rename":"Annuler le changement de nom","Rename person":"Renommer la personne",Edit:"Modifier","First name":"Pr\xE9nom","Last name":"Nom",Cancel:"Annuler",Save:"Enregistrer","Remove customer":"Retirer ce client","Extra guard":"Prot\xE8ge-dents suppl\xE9mentaire",Reorder:"Nouvelle commande","Different per guard":"Diff\xE9rentes par prot\xE8ge-dents","no pads":"sans coussinets","{color} pads":"coussinets : {color}",Guards:"Prot\xE8ge-dents",Position:"Position",Colors:"Couleurs",Thickness:"\xC9paisseur",Kit:"Trousse",Included:"Incluse","Impression On File":"Empreinte au dossier","Same impression":"M\xEAme empreinte",Case:"\xC9tui","1 included":"1 inclus","Guards in this bundle":"Prot\xE8ge-dents de cet ensemble","Edit guard {n}":"Modifier le prot\xE8ge-dents {n}","Add a {ordinal} guard +{price}":"Ajouter un {n}e prot\xE8ge-dents +{price}","Add a {ordinal} tray +{price}":"Ajouter une {n}e goutti\xE8re +{price}","Add a {ordinal} retainer +{price}":"Ajouter une {n}e contention +{price}","Add a {ordinal} nightguard +{price}":"Ajouter un {n}e prot\xE8ge-dents de nuit +{price}","Hide items":"Masquer les articles","All items":"D\xE9tails","Remove {name} from your cart":"Retirer {name} de votre panier","Items in this bundle":"Articles de cet ensemble","Delete this guard from the cart":"Supprimer ce prot\xE8ge-dents du panier","Delete this guard":"Supprimer ce prot\xE8ge-dents","You're {amount} away from {reward}":"Plus que {amount} pour obtenir {reward}","your next reward":"votre prochaine r\xE9compense","You unlocked {rewards}":"Vous avez d\xE9bloqu\xE9 {rewards}",and:"et",Rewards:"R\xE9compenses","Add a guard":"Ajoutez un prot\xE8ge-dents","and unlock":"et d\xE9bloquez","your reward":"votre r\xE9compense","Mystery Gift unlocked":"Cadeau myst\xE8re d\xE9bloqu\xE9",FREE:"GRATUIT","Included with your rewards":"Inclus avec vos r\xE9compenses","Pairs well with your order":"Compl\xE8te bien votre commande","30% off with your guard":"30 % de rabais avec votre prot\xE8ge-dents","{product} quantity":"Quantit\xE9 : {product}","One less":"Un de moins","One more":"Un de plus",Add:"Ajouter","Have a code?":"Vous avez un code?","Discount code":"Code promo",Apply:"Appliquer",Remove:"Retirer","\u2713 Code {code} applied":"\u2713 Code {code} appliqu\xE9","Code removed.":"Code retir\xE9.","This code couldn't be applied.":"Ce code n\u2019a pas pu \xEAtre appliqu\xE9.","Cart totals":"Total du panier",Items:"Articles",Discounts:"Rabais",Reward:"R\xE9compense",Shipping:"Livraison","{method}: Free":"{method} : gratuite",Standard:"Standard",Express:"Express","Code {code}":"Code {code}",Subtotal:"Sous-total","You saved {amount}":"Vous \xE9conomisez {amount}","30-day Perfect Fit guarantee":"Garantie Perfect Fit de 30 jours","Free US shipping":"Livraison gratuite aux \xC9tats-Unis","Kit arrives in 2\u20135 business days":"Trousse livr\xE9e en 2 \xE0 5 jours ouvrables","Secure checkout":"Paiement s\xE9curis\xE9","Checkout \u2192":"Passer au paiement \u2192","Preparing checkout\u2026":"Pr\xE9paration du paiement\u2026","{percent}% off":"{percent} % de rabais","Ordering for a teammate or family member?":"Vous commandez pour un co\xE9quipier ou un proche?","They get their own impression kit and custom-fit guard.":"Cette personne re\xE7oit sa propre trousse d\u2019empreinte et son prot\xE8ge-dents sur mesure.","Add new customer":"Ajouter un client","Your cart is empty":"Votre panier est vide","Most athletes start with a custom-fit Sports Mouthguard.":"La plupart des athl\xE8tes commencent par un prot\xE8ge-dents sportif sur mesure.","Start with the Sports Mouthguard \u2192":"Commencer avec le prot\xE8ge-dents sportif \u2192","Or choose another product":"Ou choisissez un autre produit",from:"\xE0 partir de","Impression kit":"Trousse","$10 Off":"10 $ de rabais","Mystery Gift":"Cadeau myst\xE8re","Free Shipping":"Livraison gratuite",Beanie:"Tuque","Workout Hat":"Casquette d\u2019entra\xEEnement",Color:"Couleur",Black:"Noir",Grey:"Gris"};var Zw={"Your cart":"Tu carrito","Your order":"Tu pedido","name from checkout":"nombre al pagar","For {name}":"Para {name}","Cancel rename":"Cancelar cambio de nombre","Rename person":"Cambiar nombre",Edit:"Editar","First name":"Nombre","Last name":"Apellido",Cancel:"Cancelar",Save:"Guardar","Remove customer":"Quitar cliente","Extra guard":"Protector adicional",Reorder:"Nuevo pedido","Different per guard":"Distintos por protector","no pads":"sin almohadillas","{color} pads":"almohadillas: {color}",Guards:"Protectores",Position:"Posici\xF3n",Colors:"Colores",Thickness:"Grosor",Kit:"Kit",Included:"Incluido","Impression On File":"Impresi\xF3n en archivo","Same impression":"Misma impresi\xF3n",Case:"Estuche","1 included":"1 incluido","Guards in this bundle":"Protectores de este paquete","Edit guard {n}":"Editar protector {n}","Add a {ordinal} guard +{price}":"Agregar un {n}.\xBA protector bucal +{price}","Add a {ordinal} tray +{price}":"Agregar una {n}.\xAA f\xE9rula +{price}","Add a {ordinal} retainer +{price}":"Agregar un {n}.\xBA retenedor +{price}","Add a {ordinal} nightguard +{price}":"Agregar un {n}.\xBA protector nocturno +{price}","Hide items":"Ocultar art\xEDculos","All items":"Detalles","Remove {name} from your cart":"Quitar {name} de tu carrito","Items in this bundle":"Art\xEDculos de este paquete","Delete this guard from the cart":"Eliminar este protector del carrito","Delete this guard":"Eliminar este protector","You're {amount} away from {reward}":"Te faltan {amount} para {reward}","your next reward":"tu pr\xF3xima recompensa","You unlocked {rewards}":"Desbloqueaste {rewards}",and:"y",Rewards:"Recompensas","Add a guard":"Agrega un protector","and unlock":"y desbloquea","your reward":"tu recompensa","Mystery Gift unlocked":"Regalo sorpresa desbloqueado",FREE:"GRATIS","Included with your rewards":"Incluido con tus recompensas","Pairs well with your order":"Combina con tu pedido","30% off with your guard":"30% de descuento con tu protector","{product} quantity":"Cantidad de {product}","One less":"Uno menos","One more":"Uno m\xE1s",Add:"Agregar","Have a code?":"\xBFTienes un c\xF3digo?","Discount code":"C\xF3digo de descuento",Apply:"Aplicar",Remove:"Quitar","\u2713 Code {code} applied":"\u2713 C\xF3digo {code} aplicado","Code removed.":"C\xF3digo eliminado.","This code couldn't be applied.":"No se pudo aplicar este c\xF3digo.","Cart totals":"Totales del carrito",Items:"Art\xEDculos",Discounts:"Descuentos",Reward:"Recompensa",Shipping:"Env\xEDo","{method}: Free":"{method}: gratis",Standard:"Est\xE1ndar",Express:"Expr\xE9s","Code {code}":"C\xF3digo {code}",Subtotal:"Subtotal","You saved {amount}":"Ahorraste {amount}","30-day Perfect Fit guarantee":"Garant\xEDa Perfect Fit de 30 d\xEDas","Free US shipping":"Env\xEDo gratis en EE. UU.","Kit arrives in 2\u20135 business days":"El kit llega en 2 a 5 d\xEDas h\xE1biles","Secure checkout":"Pago seguro","Checkout \u2192":"Pagar \u2192","Preparing checkout\u2026":"Preparando el pago\u2026","{percent}% off":"{percent}% de descuento","Ordering for a teammate or family member?":"\xBFPides para un compa\xF1ero de equipo o familiar?","They get their own impression kit and custom-fit guard.":"Recibe su propio kit de impresi\xF3n y protector a la medida.","Add new customer":"Agregar cliente","Your cart is empty":"Tu carrito est\xE1 vac\xEDo","Most athletes start with a custom-fit Sports Mouthguard.":"La mayor\xEDa de los atletas empieza con un protector bucal deportivo a la medida.","Start with the Sports Mouthguard \u2192":"Empieza con el protector bucal deportivo \u2192","Or choose another product":"O elige otro producto",from:"desde","$10 Off":"$10 de descuento","Mystery Gift":"Regalo sorpresa","Free Shipping":"Env\xEDo gratis",Beanie:"Gorro","Workout Hat":"Gorra deportiva",Color:"Color",Black:"Negro",Grey:"Gris"};var vN={fr:{...Gw,...Bw},es:{..._w,...Zw}},$w="trufit:pm-locale";function d0(){try{let t=new URLSearchParams(window.location.search).get("pm_locale");t&&window.sessionStorage.setItem($w,t.toLowerCase());let r=window.sessionStorage.getItem($w);if(r)return r.slice(0,2)}catch(t){}let e=window.Shopify;return String((e==null?void 0:e.locale)||document.documentElement.lang||"en").slice(0,2).toLowerCase()}function x(e,t){let r=vN[d0()],n=r&&r[e]||e;if(t)for(let[o,i]of Object.entries(t))n=n.split(`{${o}}`).join(String(i));return n}var Ie=T(k()),wN=["Scan stored for reorders","30-day Perfect Fit guarantee","HSA / FSA"],TN=8,MN=4500;function UN(e){let t=String(e||"").trim();return t&&!t.startsWith("+")?`+${t}`:t}function IN(e){return String((e==null?void 0:e.productTitle)||"Sports Mouthguard").replace(/^TRUFIT\s+/i,"")}function VN(e,t){return se(e)>se(t)}function kN(e,t){let r=TP(t,e);if(r.length)return r;let n=(e.newCustomerModalImageUrls||[]).map(i=>String(i||"").trim()).filter(Boolean);if(n.length)return n;let o=String(e.newCustomerModalImageUrl||(t==null?void 0:t.productImageUrl)||"").trim();return o?Array.from({length:TN},()=>o):[]}function Sc({config:e,products:t,initialProductKey:r,getPrice:n,onAdd:o,onClose:i,copy:a="Add a product that is fit to a different user.",title:s="Add New Customer"}){let l=Oe();Am(!0);let c=t[0],[d,u]=(0,Mt.useState)(BS(t,r)),[p,m]=(0,Mt.useState)(1),[g,y]=(0,Mt.useState)(0),[P,Y]=(0,Mt.useState)(!1),[h,S]=(0,Mt.useState)(""),b=(0,Mt.useRef)(null),W=(0,Mt.useRef)(null),C=(0,Mt.useRef)(!1),w=(0,Mt.useRef)(null),I=(0,Mt.useRef)(0),U=(0,Mt.useRef)(null),L=(0,Mt.useRef)(typeof document!="undefined"&&document.activeElement instanceof HTMLElement?document.activeElement:null),X=(0,Mt.useRef)(i);X.current=i;let N=Math.max(0,t.findIndex((_,K)=>hn(_,K)===d)),V=t[N]||c,z=$S(e,V),te=z.find(_=>_.quantity===p)||z[0],H=(te==null?void 0:te.quantity)||1,E=V?Pi(e,V,H):null,Z=z.length>0,ce=(n==null?void 0:n(V))||(V==null?void 0:V.variantPrice)||"",ie=(E==null?void 0:E.price)||(Z?"":ce),re=(E==null?void 0:E.compareAtPrice)||(Z?"":(V==null?void 0:V.variantPrice)||""),$=ie?zm(V,e):"",D=Boolean(V)&&(!Z||Boolean(E)),B=kN(e,V),J=B.length?Math.min(g,B.length-1):0;(0,Mt.useEffect)(()=>{u(BS(t,r))},[r,t]),(0,Mt.useEffect)(()=>{var _;m(((_=z[0])==null?void 0:_.quantity)||1)},[e,V]),(0,Mt.useEffect)(()=>{y(0)},[d]),(0,Mt.useEffect)(()=>{var Se;let _=document.documentElement.style.overflow,K=document.body.style.overflow;document.documentElement.style.overflow="hidden",document.body.style.overflow="hidden",(Se=U.current)==null||Se.focus();let Ye=Ce=>{if(Ce.key==="Escape"){Ce.preventDefault(),Ce.stopPropagation(),X.current();return}if(Ce.key!=="Tab")return;let pt=document.querySelector('[role="dialog"][data-trufit-new-customer-modal]');if(!pt)return;let R=Array.from(pt.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));if(!R.length)return;let ee=R[0],ge=R[R.length-1];Ce.shiftKey&&document.activeElement===ee?(Ce.preventDefault(),ge.focus()):!Ce.shiftKey&&document.activeElement===ge&&(Ce.preventDefault(),ee.focus())};return document.addEventListener("keydown",Ye),()=>{var pt;document.removeEventListener("keydown",Ye);let Ce=document.querySelector("[data-purchase-master-modal]");document.documentElement.style.overflow=Ce?"hidden":_,document.body.style.overflow=Ce?"hidden":K,(pt=L.current)==null||pt.focus(),W.current!==null&&window.cancelAnimationFrame(W.current),w.current!==null&&window.clearTimeout(w.current)}},[]),(0,Mt.useEffect)(()=>{var Ye,Se;let _=b.current;if(!_||B.length<2)return;let K=_.clientWidth*J;I.current=J,C.current=!0,_.scrollTo({behavior:(Se=(Ye=window.matchMedia)==null?void 0:Ye.call(window,"(prefers-reduced-motion: reduce)"))!=null&&Se.matches?"auto":"smooth",left:K}),w.current!==null&&window.clearTimeout(w.current),w.current=window.setTimeout(()=>{C.current=!1},600)},[J,B.length]),(0,Mt.useEffect)(()=>{var K,Ye;if(P||B.length<2||(Ye=(K=window.matchMedia)==null?void 0:K.call(window,"(prefers-reduced-motion: reduce)"))!=null&&Ye.matches)return;let _=window.setInterval(()=>y(Se=>(Se+1)%B.length),MN);return()=>window.clearInterval(_)},[P,B.length]);let A=()=>{W.current!==null&&window.cancelAnimationFrame(W.current),W.current=window.requestAnimationFrame(()=>{W.current=null;let _=b.current;if(!_||!_.clientWidth||B.length<2)return;let K=Math.max(0,Math.min(B.length-1,Math.round(_.scrollLeft/_.clientWidth)));C.current&&Math.abs(_.scrollLeft-_.clientWidth*I.current)>2||(C.current=!1,y(K))})},O=async()=>{if(!(P||!V||Z&&!E)){Y(!0),S("");try{if(!await o({bundleBasePrice:(E==null?void 0:E.compareAtPrice)||(Z?"":V.variantPrice||""),bundleDiscountPercent:(E==null?void 0:E.discountPercent)||(Z?0:Ci(V,e)),bundleQuantity:H,product:V})){S("Unable to add this product. Please try again."),Y(!1);return}i()}catch(_){console.error("Add New Customer failed",_),S("Unable to add this product. Please try again."),Y(!1)}}};return typeof document=="undefined"?null:(0,Fw.createPortal)((0,Ie.jsxs)(Ie.Fragment,{children:[(0,Ie.jsx)(qr.Document,{}),(0,Ie.jsxs)(hc,{className:"new-customer-modal","data-trufit-new-customer-modal":!0,role:"dialog","aria-modal":"true","aria-labelledby":"TruFitNewCustomerTitle",children:[(0,Ie.jsx)(gc,{type:"button",className:"new-customer-modal-scrim","aria-label":x("Close"),onClick:i}),(0,Ie.jsxs)(LN,{className:"new-customer-modal-panel",$width:560,children:[(0,Ie.jsxs)("div",{className:"pp-hd new-customer-modal-header",children:[(0,Ie.jsxs)("div",{children:[(0,Ie.jsx)("h2",{id:"TruFitNewCustomerTitle",children:x("Add someone else")}),(0,Ie.jsxs)("p",{children:[x("Their own impression kit and custom-fit guard"),$?(0,Ie.jsxs)(Ie.Fragment,{children:[" \xB7 ",(0,Ie.jsx)("b",{className:"nc-green",children:Ow($)})]}):null]})]}),(0,Ie.jsx)("button",{ref:U,type:"button",className:"pp-x","aria-label":x("Close"),onClick:i,children:"\xD7"})]}),(0,Ie.jsxs)("div",{className:"new-customer-product-options",children:[(0,Ie.jsx)("p",{className:"nc-lbl",children:x("Product")}),(0,Ie.jsx)("div",{className:"nc-products",role:"radiogroup","aria-label":x("Product"),children:t.map((_,K)=>{var pt;let Ye=hn(_,K),Se=Ye===d,Ce=_.productImageUrl||((pt=_.productImageUrls)==null?void 0:pt[0])||"";return(0,Ie.jsxs)("button",{type:"button",role:"radio","aria-checked":Se,className:`nc-product${Se?" is-on":""}`,onClick:()=>u(Ye),children:[Ce?(0,Ie.jsx)("img",{src:Xe(Ce,160),alt:"",loading:"lazy"}):null,(0,Ie.jsx)("span",{children:x(IN(_))})]},Ye)})})]}),z.length?(0,Ie.jsxs)("div",{className:"new-customer-bundle-options",children:[(0,Ie.jsx)("p",{className:"nc-lbl",children:x("Guards")}),(0,Ie.jsx)("div",{className:"nc-seg",role:"radiogroup","aria-label":x("Guards"),style:{gridTemplateColumns:`repeat(${z.length}, 1fr)`},children:z.map((_,K)=>{let Ye=_.quantity===H;return(0,Ie.jsxs)("button",{type:"button",role:"radio","aria-checked":Ye,className:Ye?"is-on":"",onClick:()=>m(_.quantity),children:[_.quantity===1?x("1 guard"):x("{count} guards",{count:_.quantity}),_.price?(0,Ie.jsx)("small",{children:_.price}):null]},`${_.quantity}-${K}`)})})]}):null,(0,Ie.jsxs)("div",{className:"nc-price new-customer-modal-price-row",children:[(0,Ie.jsxs)("span",{children:[(0,Ie.jsx)("b",{children:UN(ie)}),VN(re,ie)?(0,Ie.jsx)("s",{children:re}):null]}),$?(0,Ie.jsx)("span",{className:"nc-pill",children:Ow($)}):null]}),(0,Ie.jsx)("button",{type:"button",className:"pp-btn is-primary new-customer-add",disabled:P||!D,"aria-busy":P||void 0,onClick:()=>void O(),children:P?x("Adding..."):x("Add to order")}),h?(0,Ie.jsx)("p",{className:"nc-status new-customer-status",role:"alert",children:x(h)}):null,(0,Ie.jsx)("div",{className:"nc-ok new-customer-benefits",children:wN.map(_=>(0,Ie.jsx)("span",{children:x(_)},_))})]})]})]}),document.body)}function Ow(e){return String(e).replace(/(\d+)\s*%\s*off/i,"$1% off")}var LN=f(Yc)`
  gap: 12px;

  .nc-green {
    color: #1b7f3b;
  }

  .nc-lbl {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 700;
  }

  .nc-products {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .nc-product {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 56px;
    padding: 6px 12px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    background: #ffffff;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    line-height: 1.2;
  }

  .nc-product.is-on {
    border: 2px solid #111111;
  }

  .nc-product img {
    flex: none;
    width: 42px;
    height: 34px;
    object-fit: contain;
  }

  .nc-seg {
    display: grid;
    gap: 8px;
  }

  .nc-seg button {
    min-height: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    background: #ffffff;
    font-size: 14px;
    font-weight: 600;
  }

  .nc-seg button small {
    font-size: 11.5px;
    font-weight: 500;
    opacity: 0.85;
  }

  .nc-seg button.is-on {
    border: 2px solid #111111;
    background: #111111;
    color: #ffffff !important;
  }

  .nc-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    font-size: 15px;
  }

  .nc-price b {
    font-size: 20px;
  }

  .nc-price s {
    margin-left: 6px;
    color: #9a9a9a;
  }

  .nc-pill {
    padding: 3px 10px;
    border-radius: 999px;
    background: #e8f5ec;
    color: #1b7f3b;
    font-size: 12px;
    font-weight: 700;
  }

  .nc-status {
    margin: 0;
    font-size: 13px;
    color: #c62828;
  }

  .nc-ok {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
  }

  .nc-ok span {
    font-size: 12.5px;
    color: #333333;
  }

  .nc-ok span::before {
    content: "✓ ";
    color: #1b7f3b;
    font-weight: 700;
  }

  @media screen and (max-width: 749px) {
    .nc-product {
      min-height: 50px;
      padding: 6px 10px;
      font-size: 13.5px;
    }

    .nc-product img {
      width: 34px;
      height: 28px;
    }
  }
`;var eh="trufitPurchaseMasterLaunchV1",u0="trufit-purchase-master-launch",p0=["sport","thicknessSize","color","padColor","strength","edgeType"];function XN(e){if(!e||typeof e!="object"||Array.isArray(e))return;let t={};for(let r of p0){let n=e[r],o=typeof n=="string"?n.trim().slice(0,120):"";o&&(t[r]=o)}return Object.keys(t).length?t:void 0}function Dw(e){return String(e||"").trim().toLowerCase()}function zw(e){return String(e||"").trim().toLowerCase()||void 0}function NN(e){return Array.isArray(e)?Array.from(new Set(e.map(t=>zw(String(t||""))).filter(t=>t==="upper"||t==="lower"||t==="dual"))):[]}function EN(e){let t=String(e||"").replace(/,/g,"").match(/\d+(?:\.\d+)?/),r=t?Number(t[0]):0;return Number.isFinite(r)&&r>0?`$${r.toFixed(2)}`:void 0}function AN(e){let t=Number(e);return Number.isFinite(t)&&t>0&&t<=100?t:void 0}function RN(e){let t=Number(e);return Number.isFinite(t)&&t>0?Math.floor(t):void 0}function GN(e){return e==="add-person"||e==="add-product"}function Kw(e,t){var m,g;if(!e||typeof e!="object")return null;let r=e,n=Dw(r.targetHandle),o=zw(r.position),i=EN(r.bundleBasePrice),a=AN(r.bundleDiscountPercent),s=RN(r.bundleQuantity),l=NN((m=r.person)==null?void 0:m.impressionPositions),c=r.includeImpressionKitWithStandaloneGuard===!0,d=r.impressionKitUpdate===!0,u=r.forceShopReturn===!0,p=XN(r.prefill);return!GN(r.mode)||!n||n!==Dw(t)?null:{mode:r.mode,targetHandle:n,...o?{position:o}:{},...i?{bundleBasePrice:i}:{},...a?{bundleDiscountPercent:a}:{},...s?{bundleQuantity:s}:{},...c?{includeImpressionKitWithStandaloneGuard:!0}:{},...d?{impressionKitUpdate:!0}:{},...u?{forceShopReturn:!0}:{},...p&&r.mode==="add-product"?{prefill:p}:{},...(g=r.person)!=null&&g.personId?{person:{personId:String(r.person.personId),...Number(r.person.personCreatedAt)>0?{personCreatedAt:Number(r.person.personCreatedAt)}:{},...Number(r.person.personNumber)>0?{personNumber:Number(r.person.personNumber)}:{},...r.person.firstName?{firstName:String(r.person.firstName)}:{},...r.person.lastName?{lastName:String(r.person.lastName)}:{},...r.person.hasImpressionKit?{hasImpressionKit:!0}:{},...r.person.hasImpressionScan?{hasImpressionScan:!0}:{},...r.person.hasImpressionType?{hasImpressionType:!0}:{},...r.person.isReturnCustomer?{isReturnCustomer:!0}:{},...l.length?{impressionPositions:l}:{},...Number(r.person.guardCount)>0?{guardCount:Number(r.person.guardCount)}:{},...r.person.bundleItemId?{bundleItemId:String(r.person.bundleItemId)}:{}}}:{}}}function _N(e){if(typeof atob!="function")return null;try{let t=e.replace(/-/g,"+").replace(/_/g,"/"),r=t.padEnd(t.length+(4-t.length%4)%4,"="),n=atob(r),o=Uint8Array.from(n,i=>i.charCodeAt(0));return JSON.parse(new TextDecoder().decode(o))}catch(t){return null}}function BN(e,t){var i;let r=t||(typeof window!="undefined"?window.location:void 0),n=(i=r==null?void 0:r.hash)==null?void 0:i.replace(/^#/,"");if(!n)return null;let o=new URLSearchParams(n).get(u0);return o?Kw(_N(o),e):null}function ZN(){var o;if(typeof window=="undefined"||!((o=window.history)!=null&&o.replaceState))return;let e=window.location.hash.replace(/^#/,"");if(!e)return;let t=new URLSearchParams(e);if(!t.has(u0))return;t.delete(u0);let r=t.toString(),n=`${window.location.pathname}${window.location.search}${r?`#${r}`:""}`;window.history.replaceState(window.history.state,"",n)}function Hw(e,t,r){let n=t||(typeof window!="undefined"?window.sessionStorage:void 0),o=n==null?void 0:n.getItem(eh);if(o)try{let a=Kw(JSON.parse(o),e);if(a)return n==null||n.removeItem(eh),a}catch(a){n==null||n.removeItem(eh)}let i=BN(e,r);return i&&ZN(),i}function yc(e,t){let r=t||(typeof window!="undefined"?window.sessionStorage:void 0);if(!r)return!1;try{return r.setItem(eh,JSON.stringify(e)),!0}catch(n){return!1}}var Ct=T(k());function $N(e,t){return e.getNewCustomerPrice(t)||t.variantPrice||""}function ON(e,t){let r=ro(e.config,t);return r.discountLabel?r.discountLabel:r.savings<=0?"":GP(e.config,t)||String(t.discountLabel||"").trim()}function FN(e){let t=String(e||"").trim();return t&&!t.startsWith("+")?`+${t}`:t}function DN(e,t){return se(e)>se(t)}function zN({context:e,onOpen:t,product:r,placement:n}){let o=Km(r,e.config),i=Pi(e.config,r),a=(i==null?void 0:i.price)||$N(e,r),s=(i==null?void 0:i.compareAtPrice)||r.variantPrice,l=zm(r,e.config);return(0,Ct.jsx)(Qt.Card,{$variant:"new-customer",$placement:n,className:"upsell-card upsell-card-new-customer",children:(0,Ct.jsxs)(wu.CardMain,{type:"button",className:"upsell-card-main",onClick:t,children:[(0,Ct.jsx)(Qt.CardMedia,{$variant:"new-customer",className:"upsell-card-media",children:o.length?(0,Ct.jsx)(Tu,{alt:r.productTitle||"",height:68,imageUrls:o,productHandle:r.productHandle,width:68}):null}),(0,Ct.jsxs)(Qt.CardBody,{$variant:"new-customer",className:"upsell-card-body",children:[(0,Ct.jsx)(Qt.CardTitle,{className:"upsell-card-title",children:"Add another New Customer"}),(0,Ct.jsx)(Qt.CardDescription,{className:"upsell-card-description",children:"Great for friends and family"}),(0,Ct.jsx)(Qt.CardFooter,{className:"upsell-card-footer",children:(0,Ct.jsxs)(Qt.Price,{$variant:"new-customer",className:"upsell-price",children:[(0,Ct.jsx)("strong",{children:FN(a)}),DN(s,a)?(0,Ct.jsx)("del",{children:s}):null,l?(0,Ct.jsx)("span",{children:l}):null]})})]})]})})}function KN(e){var n,o;let r=((o=(n=window.Shopify)==null?void 0:n.routes)==null?void 0:o.root)||"/";return`${r.endsWith("/")?r:`${r}/`}products/${encodeURIComponent(e)}`}function m0({context:e,placement:t="sticky"}){let r=gn(e.config),[n,o]=(0,Qw.useState)(!1),i=r[0];if(!i)return null;let a=async({bundleBasePrice:s,bundleDiscountPercent:l,bundleQuantity:c,product:d})=>{var g;if(!await e.startNewCustomerPurchase({bundleQuantity:c,bundleDiscountPercent:l}))return!1;let p=String(d.productHandle||"").trim().toLowerCase(),m=String(((g=e.config.currentProduct)==null?void 0:g.handle)||"").trim().toLowerCase();return p&&p!==m&&yc({mode:"add-person",targetHandle:p,bundleBasePrice:s,bundleDiscountPercent:l,bundleQuantity:c})&&(window.location.href=KN(p)),!0};return(0,Ct.jsxs)(Ct.Fragment,{children:[(0,Ct.jsx)(wu.NewCustomer,{$placement:t,className:"upsell-new-customer",children:(0,Ct.jsx)(zN,{context:e,placement:t,onOpen:()=>o(!0),product:i})}),n?(0,Ct.jsx)(Sc,{config:e.config,products:r,initialProductKey:e.state.newCustomerProductKey,getPrice:e.getNewCustomerPrice,onAdd:a,onClose:()=>o(!1)}):null]})}function f0({context:e}){let t=rt(e.config,"upsell");return t.length?(0,Ct.jsx)(wu.Root,{className:"upsell-step",children:(0,Ct.jsx)(wu.List,{className:"upsell-list","data-purchase-master-scroll-region":!0,children:t.map(r=>{let{product:n}=r;return(0,Ct.jsx)(c0,{configuredProduct:r,context:e,discountLabel:ON(e,n),showStars:!0},r.key)})})}):null}var HN=f.div`
  display: grid;
  gap: 0.5rem;

  @media screen and (max-width: 749px) {
    gap: 12px;
  }
`,QN=f.div`
  position: relative;
  display: grid;
  gap: 0.75rem;
  padding-bottom: 1rem;

  @media screen and (max-width: 749px) {
    gap: ${({$someoneElse:e})=>e?"12px":"8px"};
    padding-bottom: 0;
  }
`,jN=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  & p {
    margin: 0;
    color: #111111;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.25rem;
  }

  & span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 999px;
    background: #efefef;
    color: #111111;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1;
  }

  @media screen and (max-width: 749px) {
    & p {
      font-size: 18px;
      line-height: 20px;
    }
    & span {
      width: 24px;
      height: 24px;
      font-size: 16px;
    }
  }
`,qN=f.button`
  min-height: 3.5rem;
  border: 1px solid #888888;
  border-radius: 0.75rem;
  background: #ffffff;
  padding: 1rem;
  color: #111111;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: left;

  ${({$selected:e})=>e&&v`
      border-color: #111111;
      background: #111111;
      color: #ffffff;
    `}

  &:disabled {
    border-color: #d0d0d0;
    background: #f5f5f5;
    color: #8c8c8c;
    cursor: not-allowed;
    opacity: 1;
  }

  @media screen and (max-width: 749px) {
    min-height: 48px;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 18px;
    line-height: 24px;
  }
`,JN=f.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  @media screen and (max-width: 749px) {
    gap: 12px;
  }
`,eE=f.input`
  width: 100%;
  min-height: 2.75rem;
  border: 1px solid ${({$error:e})=>e?"#d92d20":"#cccccc"};
  border-radius: 0.375rem;
  background: #ffffff;
  padding: 0.5rem 0.75rem;
  color: #111111;
  font: inherit;
  font-size: 1rem;
  line-height: 1rem;
  &::placeholder {
    color: #c7c7c7;
    opacity: 1;
  }
  @media screen and (max-width: 749px) {
    min-height: 44px;
    border-radius: 6px;
    padding: 8px 12px;
    font-family: Poppins, "DM Sans", Arial, sans-serif;
    font-size: 16px;
    line-height: 16px;
  }
`,tE=f.div`
  display: grid;
  grid-template-columns: 7rem minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;

  & img {
    display: block;
    width: 7rem;
    height: 7rem;
    object-fit: contain;
  }

  & > span {
    display: block;
    width: 7rem;
    height: 7rem;
    object-fit: contain;
  }

  & strong {
    display: block;
    margin: 0 0 0.5rem;
    color: #111111;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.5rem;
  }

  & p {
    margin: 0;
    color: #111111;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
  }

  @media screen and (max-width: 749px) {
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 16px;
    & img {
      width: 72px;
      height: 72px;
    }
    & > span {
      width: 72px;
      height: 72px;
    }
    & strong {
      margin-bottom: 8px;
      font-family: Poppins, "DM Sans", Arial, sans-serif;
      font-size: 14px;
      line-height: 21px;
    }
    & p {
      font-family: Poppins, "DM Sans", Arial, sans-serif;
      font-size: 12px;
      line-height: 18px;
    }
  }
`,Fo={Root:HN,Group:QN,Question:jN,Choice:qN,Fields:JN,Input:eE,BracesWarning:tE};var qw=T(oe()),Nt=T(k()),th="me",jw="someoneElse";function h0({context:e}){let t=(0,qw.useId)(),r=`${t}-first-name-error`,n=`${t}-last-name-error`,{config:o,fieldErrors:i,recipientSelectionPending:a,selectRecipient:s,state:l,setFieldValue:c}=e,d=l.recipientType===jw,u=e.isNewCustomerFlow,p=String(o.bracesWarningImageUrl||""),m=g=>{g===th&&u||s(g)};return(0,Nt.jsxs)(Fo.Root,{className:"customer-selection-step",children:[(0,Nt.jsxs)(Fo.Group,{className:"recipient-group",$someoneElse:d,children:[(0,Nt.jsx)(Fo.Question,{className:"recipient-question",children:(0,Nt.jsx)("p",{children:"Who will this be fit for?"})}),u?null:(0,Nt.jsx)(Fo.Choice,{type:"button",className:"recipient-choice",$selected:l.recipientType===th,"aria-pressed":l.recipientType===th,disabled:a,onClick:()=>m(th),children:"Me"}),u?null:(0,Nt.jsx)(Fo.Choice,{type:"button",className:"recipient-choice",$selected:d,"aria-pressed":d,disabled:a,onClick:()=>m(jw),children:"Someone Else"}),d?(0,Nt.jsxs)(Fo.Fields,{className:"recipient-fields",children:[(0,Nt.jsxs)(ht.Section,{children:[(0,Nt.jsx)(Fo.Input,{$error:Boolean(i.recipientFirstName),type:"text",placeholder:"First Name",autoComplete:"given-name","aria-label":"First Name","aria-invalid":Boolean(i.recipientFirstName),"aria-describedby":i.recipientFirstName?r:void 0,value:l.recipientFirstName,onChange:g=>c("recipientFirstName",g.currentTarget.value)}),i.recipientFirstName?(0,Nt.jsx)(ht.FieldError,{id:r,$placement:"form",children:i.recipientFirstName}):null]}),(0,Nt.jsxs)(ht.Section,{children:[(0,Nt.jsx)(Fo.Input,{$error:Boolean(i.recipientLastName),type:"text",placeholder:"Last Name",autoComplete:"family-name","aria-label":"Last Name","aria-invalid":Boolean(i.recipientLastName),"aria-describedby":i.recipientLastName?n:void 0,value:l.recipientLastName,onChange:g=>c("recipientLastName",g.currentTarget.value)}),i.recipientLastName?(0,Nt.jsx)(ht.FieldError,{id:n,$placement:"form",children:i.recipientLastName}):null]})]}):null]}),(0,Nt.jsxs)(Fo.BracesWarning,{className:"braces-warning",children:[p?(0,Nt.jsx)("img",{src:p,alt:"",loading:"lazy"}):(0,Nt.jsx)("span",{"aria-hidden":"true"}),(0,Nt.jsxs)("div",{children:[(0,Nt.jsx)("strong",{children:"Braces? Do not use the impression kit."}),(0,Nt.jsx)("p",{children:"The putty will get stuck in your brackets and can damage them. Ask your dentist or orthodontist for a digital scan instead and email it to support@trufitcustoms.com."})]})]})]})}var iT=T(oe());var rh=T(oe()),tT=T(k()),Jw=(0,rh.createContext)(null);function eT({value:e,children:t}){return(0,tT.jsx)(Jw.Provider,{value:e,children:t})}function Do(){let e=(0,rh.useContext)(Jw);if(!e)throw new Error("usePurchaseMasterV3 must be used inside the v3 modal.");return e}var rE=f.div`
  ${({$variant:e})=>e==="modal"&&v`
      flex: 0 0 68px;
    `}

  position: relative;
  display: grid;
  place-items: center;
  width: 68px;
  height: 68px;
  overflow: hidden;
  border-radius: 8px;
  background: #f6f6f6;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    ${({$variant:e})=>e==="modal"&&v`
        max-width: none;
        max-height: none;
        user-select: none;
        -webkit-user-drag: none;
      `}
  }

  ${({$layered:e})=>e&&v`
      & img {
        position: absolute;
        inset: 0;
        max-width: none;
        max-height: none;
        margin: auto;
      }
    `}

  @media screen and (max-width: 749px) {
    width: 68px;
    height: 68px;
  }
`,nh={Image:rE};var g0=T(k());function Ns(e,t,r){let n=t?Vs(e,t,"customization"):[];return n.length||!r?n:[{url:r,objectFit:"contain"}]}function Mu({config:e,state:t,variant:r="default",fallbackUrl:n}){let o=Ns(e,t,n);return(0,g0.jsx)(nh.Image,{$variant:r,$layered:o.length>1,className:"bundle-card-image","aria-hidden":"true",children:o.map((i,a)=>(0,g0.jsx)(lo.LayerImage,{src:Xe(i.url),alt:"",loading:"lazy",$objectFit:i.objectFit,$layer:o.length>1?a:void 0},`${i.url}-${a}`))})}var it=T(k()),nE=["white","clear","black","blue","red","purple","green","orange","yellow"],oE=["black","blue","white","red","orange","green","yellow","purple","no pads"];function oh(e){return String(e.value||e.label||"")}function rT(e){return ne(e).trim().toLowerCase()}function xc(e){return Boolean(e&&/no\s*pads?/i.test(ne(e)))}function Es(e=[],t){let r=t==="guard"?nE:oE,n=o=>{let i=rT(o),a=r.findIndex(s=>i===s||s==="no pads"&&xc(o));return a===-1?r.length:a};return e.map((o,i)=>({option:o,index:i})).sort((o,i)=>n(o.option)-n(i.option)||o.index-i.index).map(({option:o})=>o)}var iE=["white","yellow","clear"];function Iu(e){return rT(e)==="clear"?{background:"radial-gradient(circle at 32% 28%, rgba(255,255,255,.95), rgba(255,255,255,0) 45%), linear-gradient(135deg, rgba(230,238,245,.9), rgba(196,210,224,.55))",boxShadow:"inset 0 0 0 1px #c7d1dc"}:xc(e)?{background:"#ffffff",boxShadow:"none",border:"1.5px dashed #9a9a9a"}:{background:String(e.color||"#dddddd")}}function aE({light:e}){return(0,it.jsx)("svg",{className:"v3-tick",viewBox:"0 0 16 16",fill:"none",stroke:e?"#111111":"#ffffff",strokeWidth:"2.4",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",children:(0,it.jsx)("path",{d:"M4 8.5l2.6 2.5L12 5"})})}function Y0({label:e,options:t,value:r,onSelect:n,error:o}){let i=t.find(a=>oh(a)===r);return(0,it.jsxs)("div",{role:"group","aria-label":e,children:[(0,it.jsxs)("p",{className:"v3-lbl",children:[e," ",(0,it.jsx)("span",{children:i?x(ne(i)):""})]}),(0,it.jsx)("div",{className:"v3-sws",children:t.map(a=>{let s=oh(a),l=s===r,c=x(ne(a));return(0,it.jsxs)("button",{type:"button",className:`v3-sw${l?" is-on":""}`,"aria-label":c,"aria-pressed":l,onClick:()=>n(s),children:[(0,it.jsx)("span",{style:Iu(a)}),l?(0,it.jsx)(aE,{light:iE.includes(c.toLowerCase())||xc(a)}):null,(0,it.jsx)("em",{className:"v3-tip","aria-hidden":"true",children:c})]},s)})}),o?(0,it.jsx)("p",{className:"v3-error",children:x(o)}):null]})}function co({config:e,state:t,fallbackUrl:r,width:n=900}){let o=Ns(e,t,r);return(0,it.jsx)(it.Fragment,{children:o.map((i,a)=>(0,it.jsx)("img",{src:Xe(i.url,n),alt:"",loading:"eager",style:{zIndex:a,objectFit:i.objectFit}},`${i.url}-${a}`))})}function Uu(e,t){let r=(e||[]).find(n=>oh(n)===t);return r?x(ne(r)):t}function nT(e,t){let r=Uu(e.colors,t.color),n=(e.padColors||[]).find(a=>oh(a)===t.padColor),o=xc(n)?x("no pads"):x("{color} pads",{color:Uu(e.padColors,t.padColor).toLowerCase()}),i=t.thicknessSize?` \xB7 ${x(t.thicknessSize.toLowerCase())}`:"";return`${r}, ${o}${i}`}function ih(e,t){return e.color===t.color&&e.padColor===t.padColor&&e.position===t.position&&e.thicknessSize===t.thicknessSize&&e.sport===t.sport&&(e.initials||"")===(t.initials||"")}function ah(e,t){let r=se(e.totalPrice),n=Jm(e.config,e.state),o=se(zr(e.config.initials)),i=t.filter(a=>a.initialsOptIn&&a.initials).length;return Math.max(0,r-n-o*i)}function sh({context:e,configuredProduct:t,title:r,subtitle:n,className:o=""}){let{product:i}=t,s=Yn(e.state,t)>0,l=ro(e.config,i),c=l.price||i.variantPrice||"",d=l.compareAtPrice&&se(l.compareAtPrice)>se(c)?l.compareAtPrice:"",u=Ss(i)[0]||"",p=En(i),m=x(r||(/^3D Printed Model$/i.test(String(p).trim())?"3D Printed Model of Your Teeth":p));return(0,it.jsxs)("div",{className:`v3-mini ${o}`.trim(),children:[(0,it.jsx)("span",{className:"v3-mini-img","aria-hidden":"true",children:u?(0,it.jsx)("img",{src:Xe(u,240),alt:"",loading:"lazy"}):null}),(0,it.jsxs)("div",{children:[(0,it.jsx)("b",{children:m}),(0,it.jsxs)("small",{children:[n?`${n} \xB7 `:"",(0,it.jsx)("span",{className:"v3-sv",children:c}),d?(0,it.jsx)("span",{className:"v3-was",children:d}):null]})]}),(0,it.jsx)("button",{type:"button",className:`v3-addb${s?" is-added":""}`,"aria-pressed":s,"aria-label":s?x("Remove {name}",{name:m}):x("Add {name}",{name:m}),onClick:()=>{e.setState(g=>({...g,upsellQuantities:{...g.upsellQuantities,[t.key]:s?0:1}})),uo(s?"addon_remove":"addon_add",{product:i.productHandle||m})},children:s?x("Added \u2713"):x("Add")})]})}function Vu(){try{let e=window.Shopify;return String((e==null?void 0:e.country)||"US").toUpperCase()==="US"}catch(e){return!0}}function uo(e,t={}){try{let r=window;r.dataLayer=r.dataLayer||[],r.dataLayer.push({event:`pm_v3_${e}`,...t})}catch(r){}}var ku=T(oe());var Qe=T(k());function lh(e){return String(e.value||e.label||"")}function sE(e){let t=String(e.description||"").match(/(\d+(?:\.\d+)?)\s*mm/i);return t?`${x(ne(e))} ${t[1]}mm`:x(ne(e))}function lE({label:e}){let t=x(e),r=/^Ice Hockey/i.test(e)?t.match(/^(.+?)\s*(\(.+\))$/):null;return r?(0,Qe.jsxs)("span",{children:[r[1].replace(/ /g,"\xA0"),"\xA0",(0,Qe.jsx)("small",{children:r[2]})]}):(0,Qe.jsx)(Qe.Fragment,{children:t})}function oT({context:e,onClose:t}){let{config:r,state:n,setState:o,setFieldValue:i}=e,a=r.sports||[],s=r.thicknessSizes||[],l=(0,ku.useRef)(null),c=Fe(r.sports,n.sport),d=Ma(r,n),u=s.findIndex(P=>lh(P)===String(d)),p=s.findIndex(P=>lh(P)===n.thicknessSize),m=null;c&&u!==-1&&(p===u?m=(0,Qe.jsx)("span",{className:"v3-pill is-fit",children:x("{thickness} recommended for {sport}",{thickness:x(ne(s[u])),sport:x(ne(c)).replace(/\s*\([^)]*\)\s*/g," ").trim().toLowerCase()})}):p===u+1?m=(0,Qe.jsx)("span",{className:"v3-pill is-blue",children:x("More protection")}):p>u+1&&(m=(0,Qe.jsx)("span",{className:"v3-pill is-blue-dark",children:x("Even more protection")})));let g=(0,ku.useRef)(t);g.current=t,(0,ku.useEffect)(()=>{var Y;(Y=l.current)==null||Y.focus();let P=h=>{h.key==="Escape"&&(h.stopPropagation(),g.current())};return document.addEventListener("keydown",P,!0),()=>document.removeEventListener("keydown",P,!0)},[]);let y=P=>{o(Y=>{let h={...Y,sport:P};return mc(r,h),h},["sport","thicknessSize"]),uo("sport_select",{sport:P||"other"})};return(0,Qe.jsxs)(Qe.Fragment,{children:[(0,Qe.jsx)("div",{className:"v3-dim",onClick:t,"aria-hidden":"true"}),(0,Qe.jsxs)("div",{className:"v3-sheet",role:"dialog","aria-modal":"true","aria-labelledby":"pmV3SportTitle",children:[(0,Qe.jsx)("span",{className:"v3-grab","aria-hidden":"true"}),(0,Qe.jsxs)("div",{className:"v3-row",children:[(0,Qe.jsx)("h2",{className:"v3-sheet-title",id:"pmV3SportTitle",tabIndex:-1,ref:l,children:x("Choose your sport")}),(0,Qe.jsx)("button",{type:"button",className:"v3-icon-btn",style:{width:36,height:36,fontSize:22},"aria-label":x("Close"),onClick:t,children:"\xD7"})]}),(0,Qe.jsxs)("div",{className:"v3-sports",children:[a.map(P=>{let Y=lh(P),h=n.sport===Y;return(0,Qe.jsx)("button",{type:"button",className:`v3-sport${h?" is-on":""}`,"aria-pressed":h,onClick:()=>y(Y),children:(0,Qe.jsx)(lE,{label:ne(P)})},Y)}),(0,Qe.jsx)("button",{type:"button",className:"v3-sport",onClick:()=>y(""),children:x("Other / training")})]}),s.length?(0,Qe.jsxs)("div",{children:[(0,Qe.jsxs)("p",{className:"v3-lbl",style:{fontSize:12.5,alignItems:"center"},children:[x("Thickness")," ",m]}),(0,Qe.jsx)("div",{className:"v3-seg",role:"group","aria-label":x("Thickness"),style:{gridTemplateColumns:`repeat(${s.length}, 1fr)`,gap:6},children:s.map(P=>{let Y=lh(P),h=n.thicknessSize===Y;return(0,Qe.jsx)("button",{type:"button",className:h?"is-on":"","aria-pressed":h,onClick:()=>i("thicknessSize",Y),children:sE(P)},Y)})})]}):null,(0,Qe.jsx)("button",{type:"button",className:"v3-cta",style:{height:46,fontSize:15},onClick:t,children:x("Done")})]})]})}var fe=T(k());function aT(e){return String(e.value||e.label||"")}function ch({context:e}){let{config:t,state:r,setFieldValue:n}=e,o=t.positions||[];return o.length<2?null:(0,fe.jsx)("div",{className:"v3-seg",role:"group","aria-label":x("Guard position"),style:{gridTemplateColumns:`repeat(${o.length}, 1fr)`},children:o.map(i=>{let a=aT(i),s=r.position===a;return(0,fe.jsx)("button",{type:"button",className:s?"is-on":"","aria-pressed":s,onClick:()=>n("position",a),children:x(ne(i))},a)})})}function cE({context:e,onOpen:t}){let{config:r,state:n}=e,o=Fe(r.sports,n.sport),i=Fe(r.thicknessSizes,n.thicknessSize),a=Ma(r,n),s=Boolean(o&&a&&String(a)===String(n.thicknessSize));return!Ge(r.sports)&&!Ge(r.thicknessSizes)?null:(0,fe.jsxs)("button",{type:"button",className:"v3-set is-button",onClick:t,"aria-label":o?x("Change sport and thickness"):x("Choose sport"),children:[o?(0,fe.jsxs)("span",{className:"v3-ellipsis",children:[(0,fe.jsx)("b",{children:i?x(ne(i)):""})," ",s?(0,fe.jsx)("svg",{width:"13",height:"13",viewBox:"0 0 16 16",fill:"none",stroke:"#1b7f3b",strokeWidth:"2.4",strokeLinecap:"round",strokeLinejoin:"round",role:"img","aria-label":x("Recommended"),children:(0,fe.jsx)("path",{d:"M3 8.5l3.2 3L13 4.5"})}):null," ","\xB7 ",x(ne(o))]}):(0,fe.jsx)("span",{className:"v3-ellipsis",children:(0,fe.jsx)("b",{children:i?x(ne(i)):x("Standard")})}),(0,fe.jsx)("span",{className:"v3-chg","aria-hidden":"true",children:o?x("Change"):x("Choose sport")})]})}function dE({context:e}){let{config:t,fieldErrors:r,state:n,setState:o}=e,i=t.initials;if(!(i!=null&&i.isAvailable))return null;let a=Bl(i),s=i.imageUrl||i.productImageUrl||"";return(0,fe.jsxs)("div",{children:[(0,fe.jsxs)("div",{className:"v3-row",children:[(0,fe.jsxs)("p",{className:"v3-lbl",style:{margin:0,whiteSpace:"nowrap"},children:[x("ID tag")," ",a?(0,fe.jsx)("span",{children:a}):null]}),(0,fe.jsx)("input",{className:"v3-in",type:"text",maxLength:Cs,autoComplete:"off",inputMode:"text",pattern:Hl,placeholder:x("Up to 4 characters"),autoCapitalize:"characters","aria-label":x("ID tag, up to 4 characters"),"aria-invalid":Boolean(r.initials)||void 0,value:n.initials,onChange:l=>{let c=ao(l.currentTarget.value);o(d=>({...d,initials:c,initialsOptIn:Boolean(c)||Boolean(i.isRequired)}),["initials"])}}),s?(0,fe.jsx)("img",{className:"v3-idtag-img",src:Xe(s,200),alt:x("ID tag example"),loading:"lazy"}):null]}),r.initials?(0,fe.jsx)("p",{className:"v3-error",children:x(r.initials)}):null]})}function uE({context:e}){let t=Do(),{config:r,state:n}=e,o=Es(r.colors,"guard").slice(0,4),i=Array.from({length:Math.max(0,t.bundleQuantity-1)},(a,s)=>s+1);return i.length?(0,fe.jsx)(fe.Fragment,{children:i.map(a=>{let s=t.bundleStates[a]||n,c=ih(s,n)?x("Same as guard 1"):`${Uu(r.colors,s.color)}, ${Uu(r.padColors,s.padColor).toLowerCase()}`;return(0,fe.jsxs)("div",{className:"v3-guard-row",style:t.bundleQuantity>2?{padding:"3px 10px"}:void 0,children:[(0,fe.jsxs)("span",{className:"v3-guard-row-info",children:[(0,fe.jsx)("span",{className:"v3-guard-thumb","aria-hidden":"true",children:(0,fe.jsx)(co,{config:r,state:s,width:200})}),(0,fe.jsxs)("span",{style:{minWidth:0},children:[(0,fe.jsx)("b",{children:x("Guard {number}",{number:a+1})}),(0,fe.jsx)("small",{children:c})]})]}),(0,fe.jsxs)("span",{className:"v3-dots",children:[o.map(d=>{let u=aT(d),p=s.color===u;return(0,fe.jsx)("button",{type:"button",className:`v3-dot${p?" is-on":""}`,"aria-label":x("Guard {number}: {color}",{number:a+1,color:x(ne(d))}),"aria-pressed":p,onClick:()=>t.setGuardColor(a,u),children:(0,fe.jsx)("span",{style:Iu(d)})},u)}),(0,fe.jsx)("button",{type:"button",className:"v3-addb",style:{padding:"0 10px",marginLeft:2},onClick:()=>t.openGuardEditor(a),children:x("Edit")}),(0,fe.jsx)("button",{type:"button",className:"v3-guard-del","aria-label":x("Remove guard {number}",{number:a+1}),title:x("Remove guard {number}",{number:a+1}),disabled:t.processing,onClick:()=>t.removeGuard(a),children:(0,fe.jsxs)("svg",{viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",children:[(0,fe.jsx)("path",{d:"M3 6h18"}),(0,fe.jsx)("path",{d:"M8 6V4h8v2"}),(0,fe.jsx)("path",{d:"M19 6l-1 14H6L5 6"}),(0,fe.jsx)("path",{d:"M10 11v6M14 11v6"})]})})]})]},a)})}):null}function pE({context:e,showPreview:t=!0,onOpenSport:r}){var d;let{config:n,fieldErrors:o,state:i,setFieldValue:a,mount:s}=e,c=Do().bundleQuantity>2?100:156;return(0,fe.jsxs)(fe.Fragment,{children:[t?(0,fe.jsxs)("div",{className:"v3-preview is-grow",style:{minHeight:c},children:[(0,fe.jsx)("span",{className:"v3-pill is-neutral",children:x("Live preview")}),(0,fe.jsx)("span",{className:"v3-preview-layers","aria-hidden":"true",children:(0,fe.jsx)(co,{config:n,state:i,fallbackUrl:s.dataset.mediaUrl})})]}):null,Ge(n.colors)?(0,fe.jsx)(Y0,{label:x("Guard color"),options:Es(n.colors,"guard"),value:i.color,error:o.color,onSelect:u=>a("color",u)}):null,Ge(n.padColors)?(0,fe.jsx)(Y0,{label:x("Pad color"),options:Es(n.padColors,"pad"),value:i.padColor,error:o.padColor,onSelect:u=>a("padColor",u)}):null,(((d=n.positions)==null?void 0:d.length)||0)>1||Ge(n.sports)||Ge(n.thicknessSizes)?(0,fe.jsxs)("div",{className:"v3-fit",children:[(0,fe.jsx)(ch,{context:e}),(0,fe.jsx)(cE,{context:e,onOpen:r})]}):null,o.position||o.thicknessSize?(0,fe.jsx)("p",{className:"v3-error",children:x(o.position||o.thicknessSize||"")}):null]})}function S0({context:e}){let[t,r]=(0,iT.useState)(!1);return(0,fe.jsxs)("div",{className:"v3-design",style:{display:"contents"},children:[(0,fe.jsx)(pE,{context:e,onOpenSport:()=>r(!0)}),(0,fe.jsx)(dE,{context:e}),(0,fe.jsx)(uE,{context:e}),t?(0,fe.jsx)(oT,{context:e,onClose:()=>r(!1)}):null]})}var Cn=T(oe());var Lu=T(oe());function Xu(e,t){let r=(0,Lu.useRef)(null),n=(0,Lu.useRef)(t);return n.current=t,(0,Lu.useEffect)(()=>{if(!e)return;let o=a=>{let s=r.current;s&&a.target instanceof Node&&s.contains(a.target)||n.current()},i=a=>{a.key==="Escape"&&n.current()};return document.addEventListener("pointerdown",o,!0),document.addEventListener("keydown",i),()=>{document.removeEventListener("pointerdown",o,!0),document.removeEventListener("keydown",i)}},[e]),r}var j=T(k());function mE(){try{let e=document.cookie.split(";").map(r=>r.trim()).find(r=>r.indexOf("trufit_customer_name=")===0),t=e?decodeURIComponent(e.split("=").slice(1).join("=")).trim():"";return t.length>14?t.slice(0,13)+"\u2026":t}catch(e){return""}}var dh="support@trufitcustoms.com";function fE(e){return String(e.value||e.label||"")}var hE={small:{slot:0,caption:"Ages 6\u201312"},regular:{slot:1,caption:"Fits most people"},medium:{slot:1,caption:"Fits most people"},large:{slot:2,caption:"Big jaws"}};function gE({context:e,scale:t=.24}){let{config:r,state:n,setFieldValue:o,fieldErrors:i}=e,a=Do(),s=r.sizes||[];return(0,j.jsxs)("div",{children:[(0,j.jsxs)("p",{className:"v3-lbl",children:[x("Kit size")," ",(0,j.jsx)("span",{children:x("Not sure? Regular fits most people")})]}),(0,j.jsx)("div",{className:"v3-trays",role:"group","aria-label":x("Kit size"),children:s.map((l,c)=>{let d=fE(l),u=n.impressionKitSize===d,p=hE[ne(l).toLowerCase()]||{slot:Math.min(c,2),caption:""};return(0,j.jsxs)("button",{type:"button",className:`v3-tray${u?" is-on":""}`,"aria-pressed":u,onClick:()=>o("impressionKitSize",d),children:[a.kitTraysImageUrl?(0,j.jsx)("span",{className:"v3-tray-img","aria-hidden":"true",style:{width:Math.round(250*t),height:Math.round(315*t),backgroundImage:`url("${a.kitTraysImageUrl}")`,backgroundSize:`${Math.round(751*t)}px ${Math.round(415*t)}px`,backgroundPosition:`-${Math.round(p.slot*250.3*t)}px -${Math.round(100*t)}px`}}):null,(0,j.jsx)("b",{children:x(ne(l))}),p.caption?(0,j.jsx)("small",{children:x(p.caption)}):null]},d)})}),i.impressionKitSize?(0,j.jsx)("p",{className:"v3-error",children:x(i.impressionKitSize)}):null]})}function YE({context:e,onClose:t,onCancel:r}){let{state:n,setFieldValue:o}=e,i=(0,Cn.useRef)(null),a=(0,Cn.useRef)(null),[s,l]=(0,Cn.useState)(""),c=(0,Cn.useRef)(r);c.current=r,(0,Cn.useEffect)(()=>{var p;(p=i.current)==null||p.focus();let u=m=>{m.key==="Escape"&&(m.stopPropagation(),m.preventDefault(),c.current())};return document.addEventListener("keydown",u,!0),()=>document.removeEventListener("keydown",u,!0)},[]);let d=()=>{if(!n.recipientFirstName.trim()||!n.recipientLastName.trim()){l(x("Please enter a first and last name."));return}t()};return(0,j.jsxs)(j.Fragment,{children:[(0,j.jsx)("div",{className:"v3-dim",onClick:r,"aria-hidden":"true"}),(0,j.jsxs)("div",{className:"v3-sheet is-name",role:"dialog","aria-modal":"true","aria-labelledby":"pmV3NameTitle",children:[(0,j.jsxs)("div",{className:"v3-row",children:[(0,j.jsx)("h2",{className:"v3-sheet-title",id:"pmV3NameTitle",children:x("Who is this for?")}),(0,j.jsx)("button",{type:"button",className:"v3-icon-btn",style:{width:36,height:36,fontSize:22},"aria-label":x("Close"),onClick:r,children:"\xD7"})]}),(0,j.jsx)("p",{className:"v3-sub",style:{marginTop:-6},children:x("So we know whose kit and guard this is.")}),(0,j.jsxs)("label",{className:"v3-field",children:[(0,j.jsx)("span",{className:"v3-lbl",style:{margin:0},children:x("First name")}),(0,j.jsx)("input",{ref:i,className:"v3-in",type:"text",autoComplete:"given-name",enterKeyHint:"next",value:n.recipientFirstName,onChange:u=>o("recipientFirstName",u.currentTarget.value),onKeyDown:u=>{var p;u.key==="Enter"&&(u.preventDefault(),(p=a.current)==null||p.focus())}})]}),(0,j.jsxs)("label",{className:"v3-field",children:[(0,j.jsx)("span",{className:"v3-lbl",style:{margin:0},children:x("Last name")}),(0,j.jsx)("input",{ref:a,className:"v3-in",type:"text",autoComplete:"family-name",enterKeyHint:"done",value:n.recipientLastName,onChange:u=>o("recipientLastName",u.currentTarget.value),onKeyDown:u=>{u.key==="Enter"&&(u.preventDefault(),d())}})]}),s?(0,j.jsx)("p",{className:"v3-error",children:s}):null,(0,j.jsx)("button",{type:"button",className:"v3-cta",style:{height:48,fontSize:15},onClick:d,children:x("Save")})]})]})}function sT({context:e,compact:t=!1}){let{fieldErrors:r,isNewCustomerFlow:n,recipientSelectionPending:o,selectRecipient:i,setFieldValue:a,state:s}=e,[l,c]=(0,Cn.useState)(!1),d=s.recipientType==="someoneElse",[u]=(0,Cn.useState)(mE),p=[s.recipientFirstName,s.recipientLastName].map(g=>g.trim()).filter(Boolean).join(" "),m=r.recipientFirstName||r.recipientLastName;return n?(0,j.jsxs)("div",{children:[(0,j.jsx)("p",{className:"v3-lbl",children:x("Who is this for?")}),(0,j.jsxs)("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8},children:[(0,j.jsx)("input",{className:"v3-in",type:"text",placeholder:x("First name"),"aria-label":x("First name"),autoComplete:"off","aria-invalid":Boolean(r.recipientFirstName)||void 0,value:s.recipientFirstName,onChange:g=>a("recipientFirstName",g.currentTarget.value)}),(0,j.jsx)("input",{className:"v3-in",type:"text",placeholder:x("Last name"),"aria-label":x("Last name"),autoComplete:"off","aria-invalid":Boolean(r.recipientLastName)||void 0,value:s.recipientLastName,onChange:g=>a("recipientLastName",g.currentTarget.value)})]}),m?(0,j.jsx)("p",{className:"v3-error",children:x(m)}):null]}):(0,j.jsxs)("div",{children:[(0,j.jsxs)("div",{className:t?"":"v3-row",children:[(0,j.jsx)("p",{className:"v3-lbl",style:t?void 0:{margin:0},children:x("Who is it for?")}),(0,j.jsxs)("div",{className:"v3-seg",style:t?{gridTemplateColumns:"1fr 1.5fr",gap:6}:{gridTemplateColumns:"1fr 1.3fr",width:236},role:"group","aria-label":x("Who is it for?"),children:[(0,j.jsx)("button",{type:"button",className:s.recipientType==="me"?"is-on":"","aria-pressed":s.recipientType==="me",disabled:o,onClick:()=>void i("me"),children:u?x("Me ({name})",{name:u}):x("Me")}),(0,j.jsx)("button",{type:"button",className:d?"is-on":"","aria-pressed":d,disabled:o,onClick:()=>{i("someoneElse"),c(!0)},children:(0,j.jsx)("span",{className:"v3-ellipsis",style:{display:"block"},children:d&&s.recipientFirstName.trim()?x("For {name}",{name:s.recipientFirstName.trim()}):x("Someone else")})})]})]}),d&&m?(0,j.jsx)("p",{className:"v3-error",children:x(m)}):null,l?(0,j.jsx)(YE,{context:e,onClose:()=>c(!1),onCancel:()=>{c(!1),(!s.recipientFirstName.trim()||!s.recipientLastName.trim())&&i("me")}}):null]})}function uh({context:e}){var S,b,W,C,w,I;let t=Do(),{config:r,state:n,shouldReuseImpressionKit:o}=e,[i,a]=(0,Cn.useState)(!1),[s,l]=(0,Cn.useState)(!1),c=Xu(s,()=>l(!1)),d=Xu(i,()=>a(!1)),p=((S=t.steps[t.currentStepIndex])==null?void 0:S.key)==="personDetails",m=Boolean(((W=(b=t.steps[t.currentStepIndex])==null?void 0:b.mergedKeys)==null?void 0:W.includes("customization"))&&(((C=r.positions)==null?void 0:C.length)||0)>1),g=m&&p&&!e.isNewCustomerFlow,y=n.purchaseMasterFlow==="impression-kit"&&!o&&Boolean((w=r.sizes)==null?void 0:w.length)&&Boolean((I=r.bundleImpressionKitProduct||r.impressionKitProduct)==null?void 0:I.variantGid),P=rt(r,"impressionKit"),Y=String(r.bracesWarningImageUrl||""),h=P.map(U=>U.key).join("|");return(0,Cn.useEffect)(()=>{if(y||!h)return;let U=h.split("|");U.some(L=>{var X;return Number(((X=n.upsellQuantities)==null?void 0:X[L])||0)>0})&&e.setState(L=>{let X={...L.upsellQuantities||{}};return U.forEach(N=>{X[N]=0}),{...L,upsellQuantities:X}})},[y,h,n.upsellQuantities,e]),(0,j.jsxs)(j.Fragment,{children:[(0,j.jsxs)("div",{children:[(0,j.jsx)("h3",{className:"v3-h1",children:x("Your impression kit")}),y?(0,j.jsxs)("div",{className:"v3-kitbox",ref:c,children:[(0,j.jsx)("b",{children:x("Your kit includes four attempts.")})," ",(0,j.jsx)("span",{children:x("Two upper + two lower. Send photos for a free review before mailing your impressions back.")})," ",(0,j.jsx)("button",{type:"button",className:"v3-chg","aria-expanded":s,onClick:()=>{l(U=>!U),a(!1)},children:x("Details")}),s?(0,j.jsxs)("div",{className:"v3-info-pop is-below",role:"note",children:[(0,j.jsx)("b",{children:x("Unsure about your impression?")}),(0,j.jsxs)("span",{children:[x("Email a photo to")," ",(0,j.jsx)("a",{href:`mailto:${dh}`,children:dh})," ",x("for a free review before mailing your kit back. If needed, we'll send additional impression material at no charge. Kits returned with faulty impressions will incur a $15 USD replacement fee.")]}),(0,j.jsx)("button",{type:"button",className:"v3-info-close","aria-label":x("Close"),onClick:()=>l(!1),children:"\xD7"})]}):null]}):(0,j.jsx)("p",{className:"v3-sub",children:x("We already have an impression for this guard, so no new kit is needed.")})]}),g?(0,j.jsxs)("div",{style:{display:"grid",gridTemplateColumns:"1fr 1.25fr",gap:12},children:[(0,j.jsxs)("div",{children:[(0,j.jsx)("p",{className:"v3-lbl",children:x("Position")}),(0,j.jsx)(ch,{context:e})]}),(0,j.jsx)(sT,{context:e,compact:!0})]}):(0,j.jsxs)(j.Fragment,{children:[m?(0,j.jsxs)("div",{className:"v3-row",children:[(0,j.jsx)("p",{className:"v3-lbl",style:{margin:0},children:x("Position")}),(0,j.jsx)("div",{style:{width:220},children:(0,j.jsx)(ch,{context:e})})]}):null,p?(0,j.jsx)(sT,{context:e}):null]}),e.fieldErrors.position?(0,j.jsx)("p",{className:"v3-error",children:x(e.fieldErrors.position)}):null,y?(0,j.jsxs)(j.Fragment,{children:[(0,j.jsx)(gE,{context:e,scale:m?.17:.24}),P.map(U=>(0,j.jsx)(sh,{context:e,configuredProduct:U,title:x("Extra impression material"),subtitle:x("2 more attempts")},U.key)),(0,j.jsxs)("div",{className:"v3-note is-red",style:{position:"relative"},ref:d,children:[Y?(0,j.jsx)("img",{src:Y,alt:""}):null,(0,j.jsxs)("span",{children:[(0,j.jsx)("b",{children:x("Braces?")})," ",x("Skip the kit, email us a scan.")," ",(0,j.jsx)("button",{type:"button",className:"v3-chg","aria-expanded":i,onClick:()=>{a(U=>!U),l(!1)},children:x("How")})]}),i?(0,j.jsxs)("div",{className:"v3-info-pop",role:"note",children:[(0,j.jsx)("b",{children:x("Braces?")}),(0,j.jsxs)("span",{children:[x("Don't use the kit: the putty can get stuck in your brackets. Ask your dentist or orthodontist for a digital scan and email the STL file to")," ",(0,j.jsx)("a",{href:`mailto:${dh}`,children:dh}),"."]}),(0,j.jsx)("button",{type:"button",className:"v3-info-close","aria-label":x("Close"),onClick:()=>a(!1),children:"\xD7"})]}):null]})]}):null]})}var Xa=T(oe());var lT="trufit:pm-layout";function SE(){try{let e=new URLSearchParams(window.location.search),t=String(e.get("pm_layout")||"").toLowerCase();if(t==="v3"||t==="classic")return window.sessionStorage.setItem(lT,t),t;let r=window.sessionStorage.getItem(lT);return r==="v3"||r==="classic"?r:""}catch(e){return""}}function yE(e){return String(e.productType||"").toLowerCase()==="guard"&&e.purchaseMasterFlow!=="clinic"}var cT=!1;function dT(e){cT=e}function uT(){return cT}function pT(e,t){if(!yE(t))return!1;if(e.dataset.purchaseMasterLayoutLocked==="true")return e.dataset.purchaseMasterLayout==="v3";let r=SE();return r?r==="v3":e.dataset.purchaseMasterLayout==="v3"}var y0="trufit:pm-cross-sell",xE="trufit-cart-add-product",bE=["night-guard","vaporbite","retainer","whitening-tray","mouthguard"];function mT(e){var r;return(((r=(e.purchaseMasterOptions||{}).bundlePackages)==null?void 0:r.length)||0)>1}function x0(e){var o;let t=String(((o=e.currentProduct)==null?void 0:o.handle)||"").toLowerCase(),r=e.catalogProducts||[],n=r.find(i=>String(i.productHandle||"").toLowerCase()===t);return!t||n&&!mT(n)?[]:bE.filter(i=>i!==t).map(i=>r.find(a=>String(a.productHandle||"").toLowerCase()===i)).filter(Boolean)}function b0(e){return!mT(e)}function C0(){try{return(window.sessionStorage.getItem(y0)||"").split(",").map(e=>e.trim()).filter(Boolean)}catch(e){return[]}}function ph(e){try{e.length?window.sessionStorage.setItem(y0,e.join(",")):window.sessionStorage.removeItem(y0)}catch(t){}}function mh(e){ph(e?[e]:[])}function P0(e){let t=C0();if(!t.length||(ph([]),!uT()))return e;let[r]=e.split("#");return`${r}#${xE}=${t.map(encodeURIComponent).join(",")}`}var G=T(k());function CE(e){var n,o;let r=((o=(n=window.Shopify)==null?void 0:n.routes)==null?void 0:o.root)||"/";return`${r.endsWith("/")?r:`${r}/`}products/${encodeURIComponent(e)}`}function PE(e){return e===2?x("2nd"):e===3?x("3rd"):x("{number}th",{number:e})}function WE(e){var o;let{config:t,state:r,shouldReuseImpressionKit:n}=e;return r.purchaseMasterFlow==="impression-kit"&&!n&&Boolean((o=t.bundleImpressionKitProduct||t.impressionKitProduct)==null?void 0:o.variantGid)}function vE({context:e,paidAmount:t}){let r=Do(),n=x0(e.config),[o,i]=(0,Xa.useState)(()=>C0());if(!n.length||r.fromLaunch)return null;let a=r.nextBundlePackage,s=r.currentBundlePackage,l=se(s==null?void 0:s.price),c=e.isNewCustomerFlow&&l>0&&t>0?t/l:1,d=Y=>{let h=r.bundleQuantity+Y,S=Y===1?s:r.bundlePackageFor(h-1),b=Y===1?a:r.bundlePackageFor(h);return!(b!=null&&b.available)||!S?Y>1?d(Y-1):0:Math.max(0,Math.round((se(b.price)-se(S.price))*c))},u=Y=>{let h=n.find(S=>String(S.productHandle||"")===Y);return h?b0(h):!1},p=Y=>[...Y.filter(h=>!u(h)),...Y.filter(h=>u(h))],m=p(o).filter(Y=>!u(Y)),g=Y=>{if(b0(Y))return Math.round(se(String(Y.variantPrice||"")));let h=String(Y.productHandle||""),S=m.indexOf(h);return d(S>=0?S+1:m.length+1)},y=Y=>String(Y.productTitle||"").replace(/[™®]/g,"").trim(),P=p(o).map(Y=>n.find(h=>String(h.productHandle||"")===Y)).filter(Boolean);return(0,G.jsxs)("div",{className:"v3-xsell",children:[(0,G.jsxs)("div",{className:"v3-xsell-head",children:[(0,G.jsx)("b",{children:x("Add another product")}),(0,G.jsx)("small",{children:P.length===1?x("{name} added \xB7 you'll pick its options in your cart",{name:y(P[0])}):P.length>1?x("{names} added \xB7 you'll pick their options in your cart",{names:P.map(y).join(", ")}):x("Same impression \xB7 no extra kit")})]}),(0,G.jsx)("div",{className:"v3-xsell-grid",role:"group","aria-label":x("Add another product"),children:n.map(Y=>{let h=String(Y.productHandle||""),S=o.includes(h),b=g(Y),W=Y.productImageUrl||"";return(0,G.jsxs)("button",{type:"button",className:`v3-xsell-opt${S?" is-on":""}`,"aria-pressed":S,onClick:()=>{let C=S?o.filter(w=>w!==h):[...o,h];ph(p(C)),i(C),uo(S?"cross_sell_remove":"cross_sell_add",{product:h})},children:[W?(0,G.jsx)("img",{src:Xe(W,160),alt:"",loading:"lazy"}):(0,G.jsx)("span",{}),(0,G.jsxs)("span",{children:[(0,G.jsx)("b",{children:y(Y)}),(0,G.jsx)("small",{children:S?x("Added \u2713"):b>0?`+${we(b,e.totalPrice)}`:x("Add")})]})]},h)})})]})}function wE({context:e,paidAmount:t,addedIndex:r,onAdded:n}){var p;let o=Do(),i=o.nextBundlePackage,a=o.currentBundlePackage;if(r!==null&&r>0&&r<o.bundleQuantity)return(0,G.jsxs)("div",{className:"v3-mini",children:[(0,G.jsx)("span",{className:"v3-mini-img","aria-hidden":"true",children:(0,G.jsx)(co,{config:e.config,state:o.bundleStates[r]||e.state,width:240})}),(0,G.jsxs)("div",{children:[(0,G.jsx)("b",{children:x("Guard {number} added",{number:r+1})}),(0,G.jsxs)("small",{children:[(a==null?void 0:a.title)||"",a!=null&&a.title?" \xB7 ":"",x("Tap to remove")]})]}),(0,G.jsx)("button",{type:"button",className:"v3-addb is-added","aria-pressed":!0,disabled:o.processing,onClick:()=>o.removeGuard(r),children:x("Added \u2713")})]});if(!((((p=e.config.bundlePackages)==null?void 0:p.length)||0)>1)||!(i!=null&&i.available)||!a||o.bundleQuantity>=3||o.fromLaunch)return null;let l=se(a.price),c=l>0&&t>0?t/l:1,d=Math.round(se(i.price)*c-t);if(!(d>0))return null;let u=o.bundleQuantity===1;return(0,G.jsxs)("div",{className:`v3-mini${u?" is-strong":""}`,children:[(0,G.jsx)("span",{className:"v3-mini-img","aria-hidden":"true",children:(0,G.jsx)(co,{config:e.config,state:e.state,width:240})}),(0,G.jsxs)("div",{children:[(0,G.jsx)("b",{children:x("Add a {ordinal} guard",{ordinal:PE(o.bundleQuantity+1)})}),(0,G.jsxs)("small",{children:[i.title," \xB7 ",(0,G.jsxs)("span",{className:"v3-sv",children:["+",we(d,i.price)]}),i.saveLabel&&c===1?` \xB7 ${(()=>{let m=i.saveLabel.replace(/^\s*save\s*/i,"");return m!==i.saveLabel?x("save {amount}",{amount:m}):i.saveLabel.toLowerCase()})()}`:""]})]}),(0,G.jsx)("button",{type:"button",className:`v3-addb${u?" is-solid":""}`,disabled:o.processing,onClick:()=>{n(o.bundleQuantity),o.addIdenticalGuard(),uo("offer_add_guard",{quantity:o.bundleQuantity+1})},children:x("Add")})]})}function TE({context:e}){let[t,r]=(0,Xa.useState)(!1),n=gn(e.config),o=n[0];if(!o||e.isNewCustomerFlow)return null;let i=Pi(e.config,o),a=(i==null?void 0:i.price)||e.getNewCustomerPrice(o)||o.variantPrice,s=(i==null?void 0:i.compareAtPrice)||o.variantPrice||"",l=Km(o,e.config)[0],c=async({bundleBasePrice:d,bundleDiscountPercent:u,bundleQuantity:p,product:m})=>{var Y;if(uo("offer_new_customer",{product:m.productHandle||""}),!await e.startNewCustomerPurchase({bundleQuantity:p,bundleDiscountPercent:u}))return!1;mh("");let y=String(m.productHandle||"").trim().toLowerCase(),P=String(((Y=e.config.currentProduct)==null?void 0:Y.handle)||"").trim().toLowerCase();return y&&y!==P&&yc({mode:"add-person",targetHandle:y,bundleBasePrice:d,bundleDiscountPercent:u,bundleQuantity:p})&&(window.location.href=CE(y)),!0};return(0,G.jsxs)(G.Fragment,{children:[(0,G.jsxs)("div",{className:"v3-mini is-dashed",children:[(0,G.jsx)("span",{className:"v3-mini-img","aria-hidden":"true",children:l?(0,G.jsx)("img",{src:Xe(l,240),alt:"",loading:"lazy"}):null}),(0,G.jsxs)("div",{children:[(0,G.jsx)("b",{children:x("Add another new customer")}),(0,G.jsxs)("small",{children:[x("Family, friend or teammate")," \xB7 ",(0,G.jsxs)("span",{className:"v3-sv",children:["+",String(a||"").replace(/^\+/,"")]}),s&&se(s)>se(a)?(0,G.jsx)("span",{className:"v3-was",children:s}):null]})]}),(0,G.jsx)("button",{type:"button",className:"v3-addb",onClick:()=>r(!0),children:x("Add")})]}),t?(0,G.jsx)(Sc,{config:e.config,products:n,initialProductKey:e.state.newCustomerProductKey,getPrice:e.getNewCustomerPrice,onAdd:c,onClose:()=>r(!1)}):null]})}function ME(e){let t=new Set;return["personDetails","impressionKit","upsell"].flatMap(r=>rt(e.config,r)).filter(r=>t.has(r.key)?!1:(t.add(r.key),Yn(e.state,r)>0))}function UE(e){let t=new Set;return["upsell","personDetails","impressionKit"].flatMap(r=>rt(e.config,r)).filter(r=>t.has(r.key)?!1:(t.add(r.key),!0)).filter(r=>/gel|whitening kit|refill/i.test(En(r.product)))}function W0(e){let t=String(e.product.variantLabel||"");return(t.includes(" - ")?t.split(" - ").pop()||"":t).replace(/\s*strength\s*/i,"").trim()||x("Standard")}function IE({context:e,items:t}){var p;let r=t.find(m=>Yn(e.state,m)>0),n=Ql(e.config,e.state).toLowerCase(),o=n?t.find(m=>W0(m).toLowerCase()===n):void 0,[i,a]=(0,Xa.useState)((r==null?void 0:r.key)||(o==null?void 0:o.key)||((p=t[0])==null?void 0:p.key)||"");(0,Xa.useEffect)(()=>{!r&&o&&a(o.key)},[n]);let s=t.find(m=>m.key===i)||t[0];if(!s)return null;let c=ro(e.config,s.product).price||s.product.variantPrice||"",d=s.product.productImageUrl||"",u=m=>e.setState(g=>({...g,upsellQuantities:{...g.upsellQuantities,...Object.fromEntries(t.map(y=>[y.key,y.key===m?1:0]))}}));return(0,G.jsxs)("div",{className:"v3-mini is-strong",children:[(0,G.jsx)("span",{className:"v3-mini-img","aria-hidden":"true",children:d?(0,G.jsx)("img",{src:Xe(d,240),alt:"",loading:"lazy"}):null}),(0,G.jsxs)("div",{children:[(0,G.jsx)("b",{children:x("Add more whitening gel")}),(0,G.jsxs)("small",{children:[t.length>1?(0,G.jsx)("span",{className:"v3-gel-seg",role:"group","aria-label":x("Gel strength"),children:t.map(m=>{let g=m.key===s.key;return(0,G.jsx)("button",{type:"button",className:g?"is-on":"","aria-pressed":g,onClick:()=>{a(m.key),r&&u(m.key)},children:x(W0(m))},m.key)})}):null,(0,G.jsx)("span",{className:"v3-sv",children:c})]})]}),(0,G.jsx)("button",{type:"button",className:`v3-addb${r?" is-added":""}`,"aria-pressed":Boolean(r),onClick:()=>{u(r?"":s.key),uo(r?"addon_remove":"addon_add",{product:s.product.productHandle||"whitening-gel"})},children:r?x("Added \u2713"):x("Add")})]})}function VE(e){let t=(o,i)=>o.find(a=>i.test(En(a.product))),r=rt(e.config,"personDetails"),n=rt(e.config,"upsell");return[t(r,/3d/i)||t(n,/3d/i),t(n,/case/i)].filter(o=>Boolean(o))}function v0({context:e}){var D,B,J,A;let t=Do(),{config:r,state:n}=e,o=WE(e),i=Vu(),a=t.bundleQuantity,s=String(((D=r.currentProduct)==null?void 0:D.title)||e.mount.dataset.productTitle||"guard").trim(),l=t.currentBundlePackage,c=l!=null&&l.title&&!/^\d+ guards?$/i.test(l.title)?`${l.title} \xB7 `:"",d=s.replace(/[™®]/g,"").trim(),u=a===1?d:/(guard|tray|retainer)$/i.test(d)?`${d}s`:x("{name} guards",{name:d}),p=`${c}${a} ${u}`,m=Boolean((B=r.colors)==null?void 0:B.length),g=O=>x(ne(Fe(r.positions,O))||O),y=/whitening/i.test(s),P=Array.from({length:a},(O,_)=>t.bundleStates[_]||n),Y=P.every(O=>ih(O,n)),h=P.filter(O=>O.initialsOptIn&&O.initials),S=ah(e,P),b=Math.max(se(l==null?void 0:l.compareAtPrice),se(l==null?void 0:l.price)),W=t.steps.findIndex(O=>O.key==="customization"),C=t.steps.findIndex(O=>O.key==="personDetails"||O.key==="impressionKit"),w=Fe(r.sizes,n.impressionKitSize),I=n.recipientType==="someoneElse"?x("for {name}",{name:[n.recipientFirstName,n.recipientLastName].filter(Boolean).join(" ")}):x("for me"),U=ME(e),L=gn(r).length>0&&!e.isNewCustomerFlow,[X,N]=(0,Xa.useState)(null),[V,z]=(0,Xa.useState)(!1),te=Xu(V,()=>z(!1)),E=X!==null&&X>0&&X<a||Boolean(((J=t.nextBundlePackage)==null?void 0:J.available)&&a<3&&!t.fromLaunch&&(((A=r.bundlePackages)==null?void 0:A.length)||0)>1),Z=x0(r).length>0&&!t.fromLaunch,ce=3-(E?1:0)-(L?1:0)-(Z?1:0),ie=y?UE(e):[],re=new Set(ie.map(O=>O.key)),$=VE(e).filter(O=>!re.has(O.key)).slice(0,Math.max(0,ce-(ie.length?1:0)));return(0,G.jsxs)("div",{className:"v3-review",style:{display:"contents"},children:[(0,G.jsx)("div",{className:"v3-preview is-grow is-review",children:(0,G.jsx)("span",{className:"v3-preview-layers","aria-hidden":"true",children:(0,G.jsx)(co,{config:r,state:n,fallbackUrl:e.mount.dataset.mediaUrl})})}),(0,G.jsxs)("div",{className:"v3-card",children:[(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("b",{children:p}),(0,G.jsxs)("b",{children:[we(S,e.totalPrice),b>S+.5&&!e.isReturnCustomerFlow&&!t.fromLaunch?(0,G.jsx)("span",{className:"v3-was",children:we(b,e.totalPrice)}):null]})]}),y?(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{children:x("Includes")}),(0,G.jsx)("span",{className:"v3-ln-right",children:x("Tray, whitening gel, case")})]}):null,ff(r)?(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{title:x("Lite is gentler on sensitive teeth."),children:x("Gel strength")}),(0,G.jsx)("span",{className:"v3-gel-seg",role:"group","aria-label":x("Gel strength"),style:{marginRight:0},children:mf.map(O=>{let _=Ql(r,n)===O;return(0,G.jsx)("button",{type:"button",className:_?"is-on":"","aria-pressed":_,onClick:()=>e.setFieldValue("strength",O),children:x(O)},O)})})]}):null,m?(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{children:a>1?x("Guards 1\u2013{count}",{count:a}):x("Guard")}),(0,G.jsxs)("span",{className:"v3-ln-right",children:[Y?nT(r,n):x("Custom colors per guard"),W>=0?(0,G.jsxs)(G.Fragment,{children:[" \xB7 ",(0,G.jsx)("button",{type:"button",className:"v3-chg",onClick:()=>t.goToStep(W),children:x("Edit")})]}):null]})]}):P.map((O,_)=>(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{children:a>1?`${d} ${_+1}`:x("Position")}),(0,G.jsxs)("span",{className:"v3-ln-right",children:[g(O.position),_>0&&O.position===n.position?` \xB7 ${x("same as #1")}`:"",_>0||C>=0?(0,G.jsxs)(G.Fragment,{children:[" \xB7 ",(0,G.jsx)("button",{type:"button",className:"v3-chg",onClick:()=>_>0?t.openGuardEditor(_):t.goToStep(C),children:x("Edit")})]}):null]})]},`position-${_}`)),h.length?(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{children:x("ID tag")}),(0,G.jsxs)("span",{className:"v3-ln-right",children:[Array.from(new Set(h.map(O=>O.initials))).join(", "),a>1?` \xB7 ${x("on {tagged} of {count} guards",{tagged:h.length,count:a})}`:""]})]}):null,(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{children:x("Impression kit")}),(0,G.jsx)("span",{className:"v3-ln-right",children:o?(0,G.jsxs)(G.Fragment,{children:[w?x(ne(w)):""," \xB7 ",I,C>=0?(0,G.jsxs)(G.Fragment,{children:[" \xB7 ",(0,G.jsx)("button",{type:"button",className:"v3-chg",onClick:()=>t.goToStep(C),children:x("Edit")})]}):null]}):(0,G.jsx)("span",{className:"v3-sv",children:x("Impression on file, not needed")})})]}),U.map(O=>{let _=ro(r,O.product);return(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsxs)("span",{children:[En(O.product),re.has(O.key)?` (${W0(O)})`:""]}),(0,G.jsx)("span",{className:"v3-ln-right",children:_.price||O.product.variantPrice})]},O.key)}),i?(0,G.jsxs)("div",{className:"v3-ln",children:[(0,G.jsx)("span",{children:x("Arrives")}),(0,G.jsx)("span",{className:"v3-ln-right",children:o?x("Kit in 2\u20135 business days"):x("7\u201310 business days")})]}):null,(0,G.jsxs)("div",{className:"v3-ln v3-guarantee-ln",ref:te,children:[(0,G.jsx)("span",{className:"v3-sv",style:{fontWeight:600},children:i?x("Free US shipping"):""}),(0,G.jsxs)("span",{className:"v3-sv v3-guarantee",style:{fontWeight:600},children:[x("30-day Perfect Fit guarantee"),(0,G.jsx)("button",{type:"button",className:"v3-info","aria-label":x("About the 30-day Perfect Fit guarantee"),"aria-expanded":V,onClick:()=>z(O=>!O),children:"i"})]}),V?(0,G.jsxs)("div",{className:"v3-info-pop",role:"note",children:[(0,G.jsx)("b",{children:x("30-day Perfect Fit guarantee")}),(0,G.jsx)("span",{children:x("If the fit isn't right, tell us within 30 days and we'll make it right. Signs of chewing or biting damage void the guarantee, as do impressions we flagged as faulty.")}),(0,G.jsx)("button",{type:"button",className:"v3-info-close","aria-label":x("Close"),onClick:()=>z(!1),children:"\xD7"})]}):null]})]}),(0,G.jsxs)("p",{className:"v3-lbl",style:{margin:"2px 0 -2px"},children:[x("Add to your order")," ",(0,G.jsx)("span",{children:x("One tap")})]}),ie.length?(0,G.jsx)(IE,{context:e,items:ie}):null,(0,G.jsx)(wE,{context:e,paidAmount:S,addedIndex:X,onAdded:N}),Z?(0,G.jsx)(vE,{context:e,paidAmount:S}):null,L?(0,G.jsx)(TE,{context:e}):null,$.map(O=>(0,G.jsx)(sh,{context:e,configuredProduct:O},O.key))]})}var at={POSITION:"position",CUSTOMIZATION:"customization",DETAILS:"details",STRENGTH:"strength",USER_SELECTION:"personDetails",IMPRESSION_KIT:"impressionKit",CLINIC_SCAN:"clinicScan",UPSELL:"upsell"};function M0(e){var t;return Ge(e.positions)&&(((t=e.positions)==null?void 0:t.length)||0)>1}function fh(e){var t;return Ge(e.colors)||Ge(e.padColors)||Boolean((t=e.initials)==null?void 0:t.isAvailable)}function w0(e){let t=String(e.productType||e.compatibleProductType||"").toLowerCase();return t!=="guard"&&t!=="bundle"?!1:Boolean(M0(e)||fT(e)||fh(e))}function U0(e){return Ge(e.sports)||Ge(e.thicknessSizes)}function fT(e){var t;return Ge(e.strengths)&&(((t=e.strengths)==null?void 0:t.length)||0)>1}function hT(e){let t=String(e.productType||e.compatibleProductType||"").toLowerCase();return t==="guard"||t==="bundle"||!t&&(U0(e)||fh(e))}function T0(e){var t;return Ge(e.sizes)&&Boolean((t=e.bundleImpressionKitProduct||e.impressionKitProduct)==null?void 0:t.variantGid)}function kE(e){return e.purchaseMasterFlow==="clinic"}function LE(e){return rt(e,"upsell").some(({product:t})=>Boolean(t.variantGid||t.productHandle))||_S(e).some(t=>Boolean(t.variantGid||t.productHandle))}var XE=[{key:at.POSITION,title:({productTitle:e})=>`${e} Details`,text:"",condition:({config:e})=>M0(e)&&!w0(e),Component:zy},{key:at.STRENGTH,title:({productTitle:e})=>`${e} Details`,text:"",condition:({config:e})=>fT(e)&&!w0(e),Component:Yu},{key:at.CUSTOMIZATION,title:({productTitle:e})=>`${e} Details`,text:"",condition:({config:e})=>fh(e)||w0(e),Component:Ky},{key:at.DETAILS,title:"Protection",text:"",condition:({config:e})=>U0(e),Component:i0},{key:at.USER_SELECTION,title:"User Selection",text:"",condition:({config:e})=>hT(e),Component:h0},{key:at.CLINIC_SCAN,title:({mount:e})=>e.dataset.clinicScanTitle||"Scan Center",text:"",condition:({config:e})=>kE(e),Component:n0},{key:at.IMPRESSION_KIT,title:({mount:e,section:t})=>e.dataset.impressionKitTitle||(t instanceof HTMLElement?t.dataset.impressionKitTitle:"")||"Impression Kit",text:"",condition:({config:e})=>T0(e),Component:a0},{key:at.UPSELL,title:"Protect & Maintain Your Guard",text:"",condition:({config:e})=>LE(e),Component:f0}];function gT({section:e,mount:t,config:r}){let n=t.dataset.productTitle||no(e,".trufit-main-product__title","Product"),o={section:e,mount:t,config:r,productTitle:n};return XE.filter(i=>i.condition(o)).map(i=>({key:i.key,title:typeof i.title=="function"?i.title(o):i.title,text:typeof i.text=="function"?i.text(o):i.text||"",Component:i.Component}))}function YT({config:e}){var s;let t=[],r=fh(e),n=!r&&M0(e),o=String(((s=e.currentProduct)==null?void 0:s.title)||"").trim(),i=!o||/mouth\s*guard/i.test(o)?x("Design your guard"):x("Design your {product}",{product:o.replace(/[™®]/g,"")}),a=l=>[...l?[at.IMPRESSION_KIT]:[],...n?[at.CUSTOMIZATION]:[]];return r&&t.push({key:at.CUSTOMIZATION,title:i,shortLabel:x("Design"),text:"",mergedKeys:U0(e)?[at.DETAILS]:[],Component:S0}),hT(e)&&t.push({key:at.USER_SELECTION,title:x("Impression kit"),shortLabel:x("Kit"),text:"",mergedKeys:a(T0(e)),Component:uh}),T0(e)&&t.push({key:at.IMPRESSION_KIT,title:x("Impression kit"),shortLabel:x("Kit"),text:"",mergedKeys:a(!1),Component:uh}),t.push({key:at.UPSELL,title:x("Review & checkout"),shortLabel:x("Review"),text:"",Component:v0}),t}function zo(e){var o,i,a,s,l,c,d,u,p,m,g;let t=rt(e,"upsell")[0],r=Bd(e.thicknessSizes,["Standard","Regular"]),n=Bd(e.sizes,["Regular","Medium"]);return{purchaseMasterFlow:e.purchaseMasterFlow==="clinic"?"clinic":"impression-kit",recipientType:"me",recipientFirstName:"",recipientLastName:"",position:((i=(o=e.positions)==null?void 0:o[0])==null?void 0:i.value)||"",strength:((s=(a=e.strengths)==null?void 0:a[0])==null?void 0:s.value)||"",edgeType:((c=(l=e.edgeTypes)==null?void 0:l[0])==null?void 0:c.value)||"",sport:"",thicknessSize:r,impressionKitSize:n,color:((u=(d=e.colors)==null?void 0:d[0])==null?void 0:u.value)||"",padColor:((m=(p=e.padColors)==null?void 0:p[0])==null?void 0:m.value)||"",initialsOptIn:Boolean((g=e.initials)==null?void 0:g.isRequired),initials:"",upsellProductKey:(t==null?void 0:t.key)||"",upsellMediaIndex:0,upsellQuantities:Object.fromEntries(Fl(e).map(y=>[y.key,qm(y)])),newCustomerProductKey:gn(e)[0]?hn(gn(e)[0],0):"",newCustomerQuantity:0,scanZip:"",scanClinicId:"",scanClinicName:"",scanClinicPhone:"",scanClinicAddress:"",scanClinicTimezone:"",scanAppointmentDate:"",scanAppointmentTime:""}}function hh({config:e,currentStep:t,state:r}){var o;if((o=t==null?void 0:t.mergedKeys)!=null&&o.length){let i={};return[t.key,...t.mergedKeys].forEach(a=>{Object.assign(i,hh({config:e,currentStep:{...t,key:a,mergedKeys:void 0},state:r}).errors)}),{isValid:!Object.keys(i).length,errors:i}}let n={};if(!t)return{isValid:!0,errors:n};if((t.key===at.POSITION||t.key===at.CUSTOMIZATION)&&Ge(e.positions)&&!r.position&&(n.position="Choose a fit position."),(t.key===at.STRENGTH||t.key===at.CUSTOMIZATION)&&Ge(e.strengths)&&!r.strength&&(n.strength="Choose a strength."),t.key===at.DETAILS&&Ge(e.thicknessSizes)&&!r.thicknessSize&&(n.thicknessSize="Select a thickness."),t.key===at.USER_SELECTION&&(r.recipientType||(n.recipientType="Choose who this will be fit for."),r.recipientType==="someoneElse"&&(r.recipientFirstName.trim()||(n.recipientFirstName="Please enter first name"),r.recipientLastName.trim()||(n.recipientLastName="Please enter last name"))),t.key===at.IMPRESSION_KIT&&Ge(e.sizes)&&!r.impressionKitSize&&(n.impressionKitSize="Select an impression kit size"),t.key===at.CLINIC_SCAN&&(r.scanClinicId||(n.scanClinicId="Select a scan center."),r.scanAppointmentDate||(n.scanAppointmentDate="Select an appointment date"),r.scanAppointmentTime||(n.scanAppointmentTime="Select an appointment time")),t.key===at.CUSTOMIZATION){Ge(e.colors)&&!r.color&&(n.color="Select a guard color."),Ge(e.padColors)&&!r.padColor&&(n.padColor="Select a pad color.");let i=pf(e.initials,r);i&&(n.initials=i)}return{isValid:!Object.keys(n).length,errors:n}}function ST({config:e,state:t}){let r={};return[at.CUSTOMIZATION,at.DETAILS].forEach(o=>{let i=hh({config:e,currentStep:{key:o},state:t});Object.assign(r,i.errors)}),{isValid:!Object.keys(r).length,errors:r}}var NE=new Set(["customization"]);function Nu(e){return Boolean(e&&NE.has(e.key))}function gh(e){return e?{key:e.key,guardIndex:Nu(e)?e.guardIndex||0:null}:null}function yT(e,t){return Boolean(e&&t&&e.key===t.key&&e.guardIndex===t.guardIndex)}function I0(e,t){let r=gh(e[t]);return r?{from:r,target:gh(e[t+1])}:null}function V0(e,t,r){if(!r||!yT(gh(e[t]),r.from))return null;if(!r.target)return"submit";let n=e.findIndex((o,i)=>i>t&&yT(gh(o),r.target));return n>t?n:null}function k0(e){let t=!1;return e.flatMap(r=>Nu(r)?t?[]:(t=!0,[{...r,guardIndex:0}]):[r])}function L0(e,t){var n;if((t==null?void 0:t.mode)!=="add-product"||!((n=t.person)!=null&&n.personId))return e;let r=bs(t.person,t.position);return e.filter(o=>!(o.key==="personDetails"||r&&o.key==="impressionKit"))}function EE(e){let t=Number.parseInt(String(e||""),10);return Number.isFinite(t)&&t>0?t:1}function AE(e){let t=Number.parseInt(String(e||""),10);return Number.isFinite(t)&&t>0?t:0}var RE={sport:"sports",thicknessSize:"thicknessSizes",color:"colors",padColor:"padColors",strength:"strengths",edgeType:"edgeTypes"};function GE(e,t){let r=t.trim().toLowerCase(),n=(e||[]).find(o=>String(o.value||"").trim().toLowerCase()===r||String(o.label||"").trim().toLowerCase()===r);return(n==null?void 0:n.value)||""}function _E(e,t,r){let n=(r==null?void 0:r.mode)==="add-product"?r.prefill:void 0;if(!n)return e;let o={...e};for(let i of p0){let a=n[i];if(!a)continue;let s=GE(t[RE[i]],a);s&&(o[i]=s)}return o}function Yh(e,t,r=!1){var i;let n=zo(e);if(!t&&!r)return n;let o=!r&&(t==null?void 0:t.mode)==="add-product"?t.person:void 0;return _E({...n,position:t!=null&&t.position&&((i=e.positions)!=null&&i.some(a=>a.value===t.position))?t.position:n.position,recipientType:"someoneElse",recipientFirstName:(o==null?void 0:o.firstName)||"",recipientLastName:(o==null?void 0:o.lastName)||""},e,t)}function xT(e,t){let r=t.map(n=>AE(n.properties.__personNumber)).filter(n=>n>0);return Math.max(EE(e.defaultPersonStartNumber),...r.map(n=>n+1))}function X0(e,t){if(!t.length)return e;let r={...e};return t.forEach(n=>{delete r[n]}),r}async function BE(e){return EW(`${Ya()}cart.js`,e)}function ZE(e,t,r){return e instanceof HTMLElement&&e.dataset[t]||r}function N0(e,t){return e.recipientType||e.recipientFirstName||e.recipientLastName||e.position||e.strength||e.sport||e.thicknessSize||e.color||e.padColor||e.initials||e.impressionKitSize||e.scanClinicId||e.scanAppointmentDate||e.scanAppointmentTime||t}function bT({config:e,onConfigRefresh:t,bundleStates:r=[],setBundleStates:n,form:o,labels:i,mount:a,isModalOpen:s=!1,launchContext:l,section:c,steps:d,standaloneGuardState:u,suppressNewCustomerUpsell:p=!1,forceNewPerson:m=!1,onExistingBundlePrompt:g,onBeforeStepAdvance:y}){var ol,zc;let P=(0,pe.useRef)(null),Y=(0,pe.useRef)(!1),[h,S]=(0,pe.useState)(l==null?void 0:l.bundleDiscountPercent),[b,W]=(0,pe.useState)(()=>Yh(e,l,m)),[C,w]=(0,pe.useState)((l==null?void 0:l.mode)==="add-product"?l.person:void 0),[I,U]=(0,pe.useState)(0),[L,X]=(0,pe.useState)({}),[N,V]=(0,pe.useState)(""),[z,te]=(0,pe.useState)(!1),H=(0,pe.useRef)(null),[E,Z]=(0,pe.useState)({defaultPersonStartNumber:1}),[ce,ie]=(0,pe.useState)(!1),re=(0,pe.useRef)(null),[$,D]=(0,pe.useState)(!1),B=(0,pe.useRef)(!1),J=(0,pe.useRef)(null),A=(0,pe.useRef)(null),[O,_]=(0,pe.useState)(""),K=(0,pe.useCallback)(Q=>{A.current=Q,_(String((Q==null?void 0:Q.bundleItemId)||""))},[]),Ye=uf(E.defaultPerson,O),Se=(0,pe.useRef)(null),Ce=(0,pe.useRef)(!1),pt=e.purchaseMasterFlow==="clinic"&&b.purchaseMasterFlow==="impression-kit",R=Boolean(!pt&&(C&&bs(C,b.position)||b.recipientType==="me"&&bs(Ye,b.position))),ee=NW(C||(b.recipientType==="me"?Ye:void 0)),ge=Boolean(!m&&((l==null?void 0:l.forceShopReturn)||(C==null?void 0:C.isReturnCustomer)||b.recipientType==="me"&&((ol=E.defaultPerson)==null?void 0:ol.isReturnCustomer))),q=(l==null?void 0:l.impressionKitUpdate)===!0,me=(l==null?void 0:l.mode)==="add-product",Pe=Boolean(me&&(C==null?void 0:C.personId)),Ut=!Pe||!R||Boolean(l==null?void 0:l.includeImpressionKitWithStandaloneGuard),st=m||me,zt=me?1:Math.max(1,Sa(o),r.length+(u?1:0)),So=me?[b]:u?[...r,u]:r,It=(0,pe.useMemo)(()=>{let Q=L0(d,l).filter(le=>le.key==="clinicScan"?b.purchaseMasterFlow==="clinic":le.key==="impressionKit"?b.purchaseMasterFlow==="impression-kit"&&!R&&Ut:!(p&&le.key==="upsell"&&!rt(e,"upsell").length)),de=Q.some(le=>{var Ae;return(Ae=le.mergedKeys)==null?void 0:Ae.includes("impressionKit")});return k0(de?Q.filter(le=>le.key!=="impressionKit"):Q)},[e,l,R,Ut,b.purchaseMasterFlow,b.position,p,d]),yo=It[I],Dn=Nu(yo)?yo.guardIndex||0:null,$a=Dn===null?b:r[Dn]||b,tp=zr(e.initials),Bc=b.purchaseMasterFlow==="impression-kit"&&Ut&&(!R||Boolean(l==null?void 0:l.includeImpressionKitWithStandaloneGuard)),rp=Boolean(fa(e,o)||o.querySelector(".trufit-main-product__package-input:checked")),si=e.bundleImpressionKitProduct||e.impressionKitProduct,Zc=(zc=e.pricingPalette)==null?void 0:zc.impressionKitPrice,zs=Bc&&!R&&!rp&&(si!=null&&si.variantGid)?we(Hd({configuredPrice:Zc,product:si}),Zc||si.variantPrice||"$0"):"",rn=Pe||l==null?void 0:l.bundleBasePrice,li=h,ci=a.dataset.price||"",Ks=Array.from({length:zt},(Q,de)=>So[de]||b),Oa=Pe?$W({config:e,state:b,form:o,targetPerson:Pe?void 0:C,guardSlot:Pe?Math.max(1,Number((C==null?void 0:C.guardCount)||0)+1):void 0,forceShopReturn:l==null?void 0:l.forceShopReturn}):sy(e,b,o,ci,rn,zt,li,Ks,!1),Hs=(0,pe.useCallback)(Q=>{let de=Q||Ys(e,b),le=Ci(de,e),Ae=sy(e,b,o,ci,rn,zt,le);return Hm({config:e,currentProductPrice:Ae,fallbackPrice:ci,product:de})||(de==null?void 0:de.variantPrice)||""},[e,ci,o,zt,rn,b]),$c=Ks.filter(Q=>Q.initialsOptIn&&Q.initials).length,Qs=Ks.reduce((Q,de)=>Q+Bm(e,de),0),eg=(0,pe.useMemo)(()=>WP({basePrice:Oa,impressionKitPrice:zs,initialsPrice:tp,initialsValue:b.initials,initialsCount:$c,newCustomerPrice:EP(e,b,ci,Hs()),optionPrice:Qs,upsellPrice:Jm(e,b)}),[Oa,h,e,ci,Hs,zs,$c,tp,Qs,b]),xo=(0,pe.useCallback)(()=>{X({}),V("")},[]),Oc=(0,pe.useCallback)(()=>{P.current=null,H.current=null,Ce.current||(J.current=null,K(null),Se.current=null),U(0),te(!1),S(l==null?void 0:l.bundleDiscountPercent),xo()},[xo,K,l==null?void 0:l.bundleDiscountPercent]),np=(0,pe.useCallback)(()=>{Ce.current=!0,Oc(),Ce.current=!1},[Oc]),nn=(0,pe.useCallback)((Q,de=[])=>{Dn===null?W(Q):(Dn===0&&W(Q),n(le=>{if(Dn===0&&!le.length)return le;let Ae=Array.from({length:zt},(_t,an)=>le[an]||b);return Ae[Dn]=Q(le[Dn]||b),Ae})),de.length&&X(le=>X0(le,de))},[Dn,zt,n,b]),Fc=(0,pe.useCallback)((Q,de)=>{nn(le=>({...le,[Q]:de}),[Q]),L[Q]&&N===N0(L,"")&&V(N0(X0(L,[Q]),""))},[L,nn,N]),js=(0,pe.useCallback)(()=>{let Q=hh({config:e,currentStep:yo,state:$a});return X(Q.errors),V(Q.isValid?"":N0(Q.errors,i.requiredMessage)),Q.isValid},[e,$a,yo,i.requiredMessage]),qs=(0,pe.useCallback)(Q=>{U(Math.max(0,Math.min(It.length-1,Q))),xo()},[It.length,xo]),tg=(0,pe.useCallback)(()=>{H.current=I0(It,I)},[It,I]),op=(0,pe.useCallback)(()=>{H.current=null},[]),on=(0,pe.useCallback)(()=>{if(a.dataset.cartBridgeUrl)return ie(!0),Promise.resolve(E);if(re.current)return re.current;let Q=(e.catalogProducts||[]).filter(Ae=>Ae.productType==="guard").flatMap(Ae=>Ae.productGid?[Ae.productGid]:[]),de=BE(Q).then(Ae=>(Z(Ae),ie(!0),Boolean(e.hasGuardInCart)!==Boolean(Ae.hasGuardInCart)&&(t==null||t({...e,hasGuardInCart:Boolean(Ae.hasGuardInCart)})),Ae));re.current=de;let le=()=>{re.current===de&&(re.current=null)};return de.then(le,le),de},[E,e,a,t]),bo=(0,pe.useCallback)(Q=>{var le;let de=String((Q==null?void 0:Q.bundleItemId)||"").trim();!s||st||a.dataset.cartBridgeUrl||!Q||!de||Se.current===de||((le=A.current)==null?void 0:le.bundleItemId)===de||(Se.current=de,J.current=Q,K(null),g==null||g(Q))},[K,s,a,g,st]),Dc=(0,pe.useCallback)(async()=>{var Ae,_t;if(st||a.dataset.cartBridgeUrl)return!1;let Q=ce?E:await on(),de=(Ae=Q.defaultPerson)!=null&&Ae.bundleItemId?Q.defaultPerson:void 0,le=String((de==null?void 0:de.bundleItemId)||"").trim();return!de||!le||((_t=A.current)==null?void 0:_t.bundleItemId)===le?!1:(Se.current=le,J.current=de,K(null),g==null||g(de),!0)},[K,a,E,ce,g,on,st]),ip=(0,pe.useCallback)(async Q=>{var de;if(!B.current){if(Q!=="me"||st){J.current=null,K(null),Se.current=null,nn(le=>({...le,recipientType:Q,recipientFirstName:Q==="someoneElse"?le.recipientFirstName:"",recipientLastName:Q==="someoneElse"?le.recipientLastName:""}),["recipientType","recipientFirstName","recipientLastName"]),V("");return}B.current=!0,D(!0);try{let le=ce?E:await on(),Ae=(de=le.defaultPerson)!=null&&de.bundleItemId?le.defaultPerson:void 0;nn(_t=>({..._t,recipientType:"me",recipientFirstName:"",recipientLastName:""}),["recipientType","recipientFirstName","recipientLastName"]),V(""),Ae?bo(Ae):(J.current=null,K(null))}catch(le){Gl("recipient-cart-check",le),V("We couldn't check your cart. Please try again.")}finally{B.current=!1,D(!1)}}},[K,E,ce,a,bo,on,nn,st]);(0,pe.useEffect)(()=>{var Q;if(!s||st||a.dataset.cartBridgeUrl){(!s||st)&&(Se.current=null);return}bo((Q=E.defaultPerson)!=null&&Q.bundleItemId?E.defaultPerson:void 0)},[E.defaultPerson,s,a,bo,st]);let Js=(0,pe.useCallback)(()=>{var Q;(Q=J.current)!=null&&Q.bundleItemId&&K(J.current),J.current=null},[K]),el=(0,pe.useCallback)(()=>{J.current=null,K(null),Se.current=null,nn(Q=>({...Q,recipientType:"someoneElse"}),["recipientType"])},[K,nn]),rg=(0,pe.useCallback)(Q=>Y.current?!1:(J.current=null,K(null),Se.current=null,P.current=null,w(void 0),S(Q==null?void 0:Q.bundleDiscountPercent),W(Yh(e,void 0,!0)),U(0),X({}),V(""),!0),[e,K]),Fa=(0,pe.useCallback)(()=>a.dataset.cartUrl||ZE(c,"cartUrl","/cart"),[a,c]),Co=(0,pe.useCallback)(()=>a.dataset.cartBridgeUrl||"",[a]),Da=(0,pe.useCallback)(async()=>{if(Co())return E;let Q=await on();if(e.productType!=="guard"&&Boolean(e.hasGuardInCart)!==Boolean(Q.hasGuardInCart))throw new Error("Discount eligibility changed. Review the updated total before adding again.");return Q},[E,e,Co,on]),_r=(0,pe.useCallback)(Q=>{var le,Ae;if(st||a.dataset.cartBridgeUrl||b.recipientType!=="me"||(le=A.current)!=null&&le.bundleItemId)return!1;let de=(Ae=Q.defaultPerson)!=null&&Ae.bundleItemId?Q.defaultPerson:void 0;return de!=null&&de.bundleItemId?(bo(de),!0):!1},[a,bo,b.recipientType,st]),za=(0,pe.useCallback)(async(Q,de={})=>{let le=Fa(),Ae=Co(),_t=de.redirect!==!1;if(Ae){if(!_t)throw new Error("Adding another customer is unavailable while the cart bridge is active.");kW({bridgeUrl:Ae,cartUrl:le,items:Q});return}let an=P.current||{items:Q,sent:!1};P.current=an,await cf(an.items,an,{beforeCartPage:_t}),P.current=null,_t&&(window.location.href=P0(le))},[Co,Fa]),tl=(0,pe.useCallback)(async()=>{var Q;if(!Y.current){Y.current=!0,te(!0),V("");try{let de=await Da();if(_r(de)){te(!1);return}let le=A.current,_t=((Q=P.current)==null?void 0:Q.items)||au(e,b,o,{...de,bundleStates:So,bundleBasePrice:rn,bundleDiscountPercent:li,forceNewPerson:m||(l==null?void 0:l.mode)==="add-person",replaceExistingBundle:Boolean(le==null?void 0:le.bundleItemId),includeImpressionKitWithStandaloneGuard:l==null?void 0:l.includeImpressionKitWithStandaloneGuard,impressionKitIntent:q?"update":void 0,forceShopReturn:l==null?void 0:l.forceShopReturn,standaloneGuardOnly:Pe,targetPerson:C});if(!_t.length){te(!1),V(i.requiredMessage);return}let an=le==null?void 0:le.bundleItemId;an&&!Co()?(await my({personId:le.personId,bundleItemId:an},_t),K(null),J.current=null,window.location.href=P0(Fa())):await za(_t)}catch(de){Gl("submit",de),de instanceof mn||(P.current=null),te(!1),V(de instanceof mn||l!=null&&l.forceShopReturn&&de instanceof Error?de.message:i.addErrorMessage)}finally{Y.current=!1}}},[K,e,So,o,Pe,i.addErrorMessage,i.requiredMessage,rn,li,l==null?void 0:l.mode,l==null?void 0:l.includeImpressionKitWithStandaloneGuard,l==null?void 0:l.forceShopReturn,q,m,Da,Fa,Co,_r,my,za,b,C]),ng=(0,pe.useCallback)(async Q=>{var de;if(Y.current)return!1;Y.current=!0,te(!0),V("");try{let le=await Da();if(_r(le))return te(!1),!1;let _t=((de=P.current)==null?void 0:de.items)||au(e,{...b,newCustomerQuantity:0},o,{...le,bundleStates:So,bundleBasePrice:rn,bundleDiscountPercent:li,forceNewPerson:m||(l==null?void 0:l.mode)==="add-person",includeImpressionKitWithStandaloneGuard:l==null?void 0:l.includeImpressionKitWithStandaloneGuard,impressionKitIntent:q?"update":void 0,forceShopReturn:l==null?void 0:l.forceShopReturn,targetPerson:C});if(!_t.length)return te(!1),V(i.requiredMessage),!1;await za(_t,{redirect:!1});let an=Co()?le:await on().catch(()=>({...le,defaultPersonStartNumber:xT(le,_t)}));return Z(an),w(void 0),S(Q==null?void 0:Q.bundleDiscountPercent),W(Yh(e,void 0,!0)),H.current=null,U(0),X({}),V(""),te(!1),!0}catch(le){return Gl("submit",le),le instanceof mn||(P.current=null),te(!1),V(le instanceof mn||l!=null&&l.forceShopReturn&&le instanceof Error?le.message:i.addErrorMessage),!1}finally{Y.current=!1}},[So,e,o,i.addErrorMessage,i.requiredMessage,rn,li,m,l==null?void 0:l.mode,l==null?void 0:l.includeImpressionKitWithStandaloneGuard,l==null?void 0:l.forceShopReturn,q,Da,Co,on,z,_r,za,b,C]),rl=(0,pe.useCallback)(()=>{let Q=H.current,de=V0(It,I,Q);if(Q&&(H.current=null),de==="submit"){tl();return}if(typeof de=="number"){qs(de);return}if(I>=It.length-1){tl();return}qs(I+1)},[I,qs,z,It.length,It,tl]),nl=(0,pe.useCallback)(()=>{z||!js()||yo&&(y!=null&&y({step:yo,steps:It}))||rl()},[It,rl,yo,y,z,js]),ap=(0,pe.useCallback)(Q=>{Q.preventDefault(),nl()},[nl]);return(0,pe.useEffect)(()=>{I>It.length-1&&U(Math.max(0,It.length-1))},[It.length,I]),{currentStep:yo,currentStepIndex:I,advanceCurrentStep:rl,fieldErrors:L,getNewCustomerPrice:Hs,captureAddedGuardNavigation:tg,clearAddedGuardNavigation:op,goToStep:qs,handleSubmit:ap,processing:z,recipientSelectionPending:$,checkExistingBundleBeforeOpen:Dc,refreshCartContext:on,resetFlow:Oc,resetFlowPreservingExistingBundleChoice:np,cancelExistingBundleChoice:el,confirmExistingBundleReplacement:Js,selectRecipient:ip,setFieldValue:Fc,setProcessing:te,setState:nn,setStatus:V,startNewCustomerFlow:rg,startNewCustomerPurchase:ng,state:b,currentState:$a,currentGuardIndex:Dn,status:N,submitCurrentStep:nl,steps:It,impressionKitPrice:zs,isImpressionKitUpdateFlow:q,isReturnCustomerFlow:ge,reusableImpressionPositions:ee,shouldReuseImpressionKit:R,totalPrice:eg}}var HT=T(oe());var $E=f.div.attrs(sc)`
  &[hidden] {
    display: none;
  }

  --purchase-master-panel-width: 28.125rem;
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  background: #ffffff;
  color: #111111;
  isolation: isolate;

  @media screen and (max-width: 749px) {
    --purchase-master-mobile-action-height: 56px;
    --purchase-master-mobile-action-shell-height: calc(
      var(--purchase-master-mobile-action-height) + 16px
    );
    --purchase-master-mobile-sticky-action-height: 48px;
    overflow: hidden;
  }

  & button[aria-busy="true"] {
    cursor: wait;
    opacity: 0.7;
  }
`,OE=f.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) var(--purchase-master-panel-width);
  height: 100dvh;
  overflow: hidden;
  background: #ffffff;

  @media screen and (max-width: 749px) {
    display: block;
    height: 100dvh;
    overflow: hidden;
  }
`,FE=f.form`
  --purchase-master-progress-height: 4px;
  --purchase-master-topbar-height: 2rem;
  --purchase-master-panel-gap: 1.25rem;
  display: flex;
  width: var(--purchase-master-panel-width);
  max-width: var(--purchase-master-panel-width);
  height: 100dvh;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  gap: var(--purchase-master-panel-gap);
  box-sizing: border-box;
  padding-bottom: 0;
  background: #ffffff;
  border-left: 0;
  box-shadow: -8px 0 32px rgba(17, 17, 17, 0.16);
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  @media screen and (max-width: 749px) {
    --purchase-master-progress-height: 4px;
    --purchase-master-topbar-height: 48px;
    width: 100%;
    max-width: none;
    height: 100dvh;
    border-left: 0;
    border-radius: 0;
    box-shadow: none;
    overflow: hidden;
    gap: 0;
    padding-bottom: 0;
  }
`,DE=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 var(--purchase-master-topbar-height);
  gap: 2rem;
  min-height: var(--purchase-master-topbar-height);
  box-sizing: border-box;
  padding: 0 1.5rem;
  ${({$view:e})=>e==="clinicMap"&&v`
      display: none;
    `}
  @media screen and (max-width: 749px) {
    flex: 0 0 48px;
    min-height: 48px;
    height: 48px;
    gap: 20px;
    padding: 0 20px;
  }
`,zE=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  border: 0;
  border-radius: 999px;
  padding: 0;
  background: transparent;
  color: #667085;
  line-height: 0;
  cursor: pointer;
  visibility: hidden;
  & svg {
    width: 0.75rem;
    height: 1.25rem;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2.2;
  }
  & > img {
    display: block;
    width: 100%;
    height: 100%;
    transform: scaleX(-1);
  }
  ${({$visible:e})=>e&&v`
      visibility: visible;
    `}
  @media screen and (max-width: 749px) {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 0;
    & svg {
      width: 10px;
      height: 20px;
    }
  }
`,KE=f.div`
  display: none;

  @media screen and (max-width: 749px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    min-width: 0;
    gap: 8px;
    color: #111111;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    white-space: nowrap;
    & span {
      font: inherit;
    }
    & strong {
      font: inherit;
    }
  }
`,HE=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  border: 0;
  border-radius: 999px;
  padding: 0;
  background: transparent;
  color: #667085;
  line-height: 0;
  cursor: pointer;

  & > img {
    display: block;
    width: 100%;
    height: 100%;
  }

  & svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: 2;
  }

  @media screen and (max-width: 749px) {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 0;
    & svg {
      width: 20px;
      height: 20px;
    }
  }
`,QE=f.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 0 1.5rem;
  padding: 0.75rem 0;
  scrollbar-width: thin;
  & h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.875rem;
    letter-spacing: -0.06rem;
    text-align: center;
  }
  ${({$stepKey:e})=>e==="upsell"&&v`
      gap: 1.5rem;
      overflow: hidden;

      & h2 {
        font-size: 1.5rem;
        line-height: 1.875rem;
        letter-spacing: -0.06rem;
      }
    `}
  ${({$view:e})=>e==="clinicDate"&&v`
      & > h2 {
        display: none;
      }
    `}
${({$view:e})=>e==="clinicTime"&&v`
      & > h2 {
        display: none;
      }
    `}
${({$view:e})=>e==="clinicDate"&&v`
      padding-bottom: 8.5rem;
    `}
${({$view:e})=>e==="clinicTime"&&v`
      padding-bottom: 8.5rem;
    `}
${({$view:e})=>e==="clinicMap"&&v`
      & > h2 {
        display: none;
      }

      margin: 0;
      padding: 0;
      overflow: hidden;
    `}
${({$stepKey:e})=>e==="impressionKit"&&v`
      & h2 {
        margin: 0;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.875rem;
        text-align: left;
      }
    `}
${({$stepKey:e})=>e==="personDetails"&&v`
      & h2 {
        margin: 0;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.25;
        text-align: left;
      }
    `}
${({$stepKey:e})=>e==="details"&&v`
      & h2 {
        margin: 0;
        font-size: 1.5rem;
        line-height: 1.25;
      }
    `}
${({$stepKey:e})=>e==="customization"&&v`
      & h2 {
        margin: 0;
        font-size: 1.5rem;
        line-height: 1.875rem;
        letter-spacing: -0.06rem;
      }
    `}
${({$stepKey:e,$view:t})=>e==="clinicScan"&&!t&&v`
      overflow: hidden;
    `}
@media screen and (max-width: 749px) {
    ${({$stepKey:e})=>e==="upsell"&&v`
        gap: 1rem;
        padding: 1rem 1.25rem;
      `}
  }
  @media screen and (max-width: 749px) {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
    margin: 0;
    padding: 0 20px 16px 20px;
    gap: 12px;
    scrollbar-width: thin;
    & h2 {
      display: none;
    }
    ${({$stepKey:e})=>e==="upsell"&&v`
        gap: 12px;
        padding-top: 16px;
        overflow-y: auto;
      `}
    ${({$stepKey:e})=>e==="clinicScan"&&v`
        padding-top: 12px;
      `}
${({$view:e})=>e==="clinicDate"&&v`
        padding-bottom: 0;
      `}
${({$view:e})=>e==="clinicTime"&&v`
        padding-bottom: 0;
      `}
${({$stepKey:e})=>e==="impressionKit"&&v`
        padding: 0 20px 16px 20px;
      `}
${({$stepKey:e})=>e==="customization"&&v`
        gap: 12px;
        padding: 0 20px 12px 20px;
      `}
  }
`,jE=f.div`
  display: none;
  ${({$view:e})=>e==="clinicMap"&&v`
      display: none;
    `}
  @media screen and (max-width: 749px) {
    /* Phones: the image takes whatever height the form leaves, edge to edge, so steps fit without scrolling. */
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: auto;
    min-height: 96px;
    max-height: 260px;
    margin: 0 -20px;
    overflow: hidden;
    ${({$stepKey:e})=>e==="details"&&v`
        max-height: 200px;
      `}
    ${({$stepKey:e})=>e==="clinicScan"&&v`
        display: none;
      `}
    ${({$stepKey:e})=>e==="upsell"&&v`
        display: none;
      `}
  }
`,qE=f.p`
  margin: 0;
  color: #6a6a6a;
  font-size: 0.875rem;
  line-height: 1.45;
  &[hidden] {
    display: none;
  }
  ${({$view:e})=>e==="clinicMap"&&v`
      display: none;
    `}
  @media screen and (max-width: 749px) {
    display: none;
  }
`,JE=f.div`
  display: grid;
  gap: 0.5rem;
  ${({$stepKey:e})=>e==="upsell"&&v`
      display: flex;
      min-height: 0;
      flex: 1 1 auto;
      flex-direction: column;
    `}
  ${({$stepKey:e})=>e==="clinicScan"&&v`
      display: flex;
      min-height: 100%;
      flex-direction: column;
      gap: 1.5rem;
    `}
${({$view:e})=>e==="clinicMap"&&v`
      height: 100%;
      gap: 0;
    `}
${({$stepKey:e})=>e==="impressionKit"&&v`
      gap: 1.5rem;
    `}
${({$stepKey:e})=>e==="personDetails"&&v`
      gap: 1.5rem;
    `}
${({$stepKey:e})=>e==="customization"&&v`
      gap: 16px;
    `}
${({$stepKey:e,$view:t})=>e==="clinicScan"&&!t&&v`
      min-height: 0;
      flex: 1 1 auto;
    `}
@media screen and (max-width: 749px) {
    gap: 24px;
    ${({$stepKey:e})=>e==="upsell"&&v`
        display: flex;
        height: auto;
        min-height: 0;
        flex: 0 0 auto;
        flex-direction: column;
      `}
    ${({$stepKey:e})=>e==="clinicScan"&&v`
        gap: 24px;
      `}
${({$stepKey:e})=>e==="impressionKit"&&v`
        gap: 12px;
      `}
${({$stepKey:e})=>e==="personDetails"&&v`
        gap: 12px;
      `}
${({$stepKey:e})=>e==="customization"&&v`
        gap: 16px;
      `}
  }
`,Pn={Modal:$E,Layout:OE,Panel:FE,Topbar:DE,NavButton:zE,MobileTotal:KE,Close:HE,Content:QE,MobileMedia:jE,StepText:qE,Form:JE};var e7=f.div`
  @media screen and (max-width: 749px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    background: #ffffff;
    ${({$image:e})=>e&&v`
        display: flex;
        align-items: center;
        justify-content: center;

        & img {
          display: block;
          width: 100%;
          height: 100%;
          max-width: none;
          max-height: none;
          object-fit: contain;
          object-position: center;
        }
      `}
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        flex: 1 1 auto;
        height: auto;
        min-height: 0;
      `}
  }
`,t7=f.div`
  @media screen and (max-width: 749px) {
    position: relative;
    min-width: 0;
    height: 100%;
    overflow: hidden;
    text-align: center;
    & strong {
      position: absolute;
      right: 0;
      bottom: 5px;
      left: 0;
      color: #111111;
      font-size: 18px;
      font-weight: 900;
      line-height: 24px;
      text-transform: uppercase;
    }
  }
`,r7=f.div`
  @media screen and (max-width: 749px) {
    width: 100%;
    height: 104px;
    overflow: hidden;
    background: #f5f5f5;
    & img {
      display: block;
      width: 100%;
      height: 100%;
      max-width: none;
      max-height: none;
    }
  }
`,n7=f.img.attrs(Us)`
  @media screen and (max-width: 749px) {
    position: absolute;
    top: 82px;
    left: 50%;
    width: 96px;
    height: 96px;
    max-width: none;
    max-height: none;
    transform: translateX(-50%);
  }
`,bc={Root:e7,Tile:t7,Banner:r7,Card:n7};var o7=f.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
  padding: 49px 64px 73px;
  background: #ffffff;
  @media screen and (max-width: 749px) {
    ${({$mobile:e})=>!e&&v`
        display: none;
      `}
    ${({$mobile:e})=>e&&v`
        display: flex;
        flex: 1 1 auto;
        align-items: stretch;
        width: 100%;
        height: 100%;
        min-height: 0;
        padding: 0;
      `}
  }
`,i7=f.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;

  @media screen and (max-width: 749px) {
    ${({$mobile:e})=>e&&v`
        flex: 1 1 auto;
        width: 100%;
        height: 100%;
        min-height: 0;
        padding: 0;
      `}
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      `}
${({$mobile:e,$upsell:t})=>e&&t&&v`
        padding: 0.5rem 1rem;
      `}
  }
`,a7=f.div`
  position: absolute;
  z-index: 4;
  inset: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 1rem 2.5rem;
  pointer-events: none;
  ${({$customize:e})=>e&&v`
      justify-content: space-between;
      gap: 1rem;
      padding-inline: 1.5rem;
    `}
  ${({$stepKey:e,$mobile:t})=>e==="clinicScan"&&!t&&v`
      display: none;
    `}
@media screen and (max-width: 749px) {
    padding: 12px 16px;
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        position: relative;
        inset: auto;
        flex: 0 0 48px;
        height: 48px;
        min-height: 48px;
        align-items: center;
        padding: 8px 20px;
      `}
    ${({$mobile:e,$hasActions:t,$customize:r})=>e&&t&&r&&v`
        gap: 12px;
        padding: 8px 12px;
      `}
  }
`,s7=f.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 1.5rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.4);
  color: #111111;
  padding: 0 0.75rem 0 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  letter-spacing: normal;
  white-space: nowrap;
  &::before {
    content: "";
    display: block;
    flex: 0 0 0.25rem;
    width: 0.25rem;
    height: 1.5rem;
    background: #111111;
  }
  @media screen and (max-width: 749px) {
    gap: 8px;
    min-height: 20px;
    padding-right: 8px;
    font-size: 14px;
    line-height: 20px;
    &::before {
      flex-basis: 3px;
      width: 3px;
      height: 20px;
    }
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        gap: 8px;
        min-height: 24px;
        border-radius: 8px;
        padding-right: 8px;
        font-size: 18px;
        line-height: 24px;

        &::before {
          flex-basis: 4px;
          width: 4px;
          height: 24px;
        }
      `}
  }
`,l7=f.button`
  width: 12rem;
  height: 3.5rem;
  border: 0.5px solid #888888;
  border-radius: 0.75rem;
  background: #ffffff;
  color: #111111;
  cursor: pointer;
  box-sizing: border-box;
  margin-left: auto;
  padding: 1rem;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  letter-spacing: normal;
  pointer-events: auto;
  white-space: nowrap;
  ${({$compact:e})=>e&&v`
      width: auto;
      min-width: 0;
      height: 2rem;
      min-height: 2rem;
      border-radius: 0.5rem;
      padding: 0 0.75rem;
    `}
  @media screen and (max-width: 749px) {
    width: auto;
    height: 40px;
    min-height: 40px;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 20px;
    ${({$compact:e})=>e&&v`
        height: 28px;
        min-height: 28px;
        padding: 0 8px;
      `}
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        width: auto;
        min-width: min(184px, calc(100vw - 120px));
        height: 48px;
        min-height: 48px;
        border-radius: 12px;
        padding: 12px;
        font-size: 18px;
        line-height: 24px;
      `}
${({$mobile:e,$hasActions:t,$compact:r})=>e&&t&&r&&v`
        min-width: 0;
        height: 32px;
        min-height: 32px;
        border-radius: 8px;
        padding: 0 12px;
      `}
  }
`,c7=f.div`
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  ${({$upsell:e})=>e&&v`
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    `}
  @media screen and (max-width: 749px) {
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        flex: 1 1 auto;
        height: auto;
        min-height: 0;
      `}
  }
`,d7=f.img.attrs(Us)`
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  ${({$layered:e})=>e&&v`
      position: absolute;
      inset: 0;
      display: block;
      width: 100%;
      max-width: none;
      height: 100%;
      max-height: none;
      object-fit: contain;
    `}
  @media screen and (max-width: 749px) {
    ${({$mobile:e,$hasActions:t})=>e&&t&&v`
        flex: 1 1 auto;
        height: auto;
        min-height: 0;
      `}
    ${({$layered:e,$mobile:t})=>e&&t&&v`
        /* The renders carry wide transparent margins; scale them up so the guard fills more of the box. */
        transform: scale(1.5);
        transform-origin: 50% 50%;
      `}
    ${({$layered:e,$mobile:t,$hasActions:r})=>e&&t&&r&&v`
        inset: 48px 0 0;
        height: calc(100% - 48px);
      `}
    ${({$stepKey:e,$mobile:t})=>e==="impressionKit"&&t&&v`
        object-fit: contain;
      `}
    ${({$stepKey:e,$mobile:t})=>e==="details"&&t&&v`
        /* The option config sets "contain" inline; on phones the photo should run edge to edge. */
        object-fit: cover !important;
        object-position: center;
      `}
${({$stepKey:e,$mobile:t})=>e==="personDetails"&&t&&v`
        object-fit: contain;
      `}
  }
`,Xi={Media:o7,Frame:i7,Actions:a7,GuardLabel:s7,BundleTrigger:l7,Placeholder:c7,Image:d7};var u7=f.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
  height: 100%;
  min-height: 0;
  &:focus-visible {
    outline: 2px solid #111111;
    outline-offset: -2px;
  }
  @media screen and (max-width: 749px) {
    ${({$mobile:e})=>e&&v`
        grid-template-rows: minmax(0, 1fr) auto;
        gap: 0.5rem;
      `}
  }
`,p7=f.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  & img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  ${({$carousel:e})=>e&&v`
      touch-action: pan-y;
    `}
`,m7=f.div`
  display: grid;
  justify-items: center;
  gap: 0.75rem;
  max-width: 40rem;
  margin: 0 auto;
  color: #111111;
  text-align: center;
  & strong {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.125rem;
    text-transform: uppercase;
  }
  & p {
    display: -webkit-box;
    overflow: hidden;
    margin: 0;
    color: #505050;
    font-size: 1rem;
    line-height: 1.25rem;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  @media screen and (max-width: 749px) {
    ${({$mobile:e})=>e&&v`
        display: none;
      `}
  }
`,f7=f.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;

  @media screen and (max-width: 749px) {
    ${({$mobile:e})=>e&&v`
        gap: 0.5rem;
      `}
  }
`,h7=f.button`
  display: block;
  flex: 0 0 1.125rem;
  width: 1.125rem;
  height: 1.125rem;
  border: 1px solid #c7c7c7;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  padding: 0;
  ${({$active:e})=>e&&v`
      & {
        border-color: #1d1d1f;
        background: #1d1d1f;
      }
    `}
  &:focus-visible {
    outline: 2px solid #111111;
    outline-offset: 2px;
  }
  @media screen and (max-width: 749px) {
    ${({$mobile:e})=>e&&v`
        flex-basis: 0.75rem;
        width: 0.75rem;
        height: 0.75rem;
      `}
  }
`,Cc={Root:u7,Image:p7,Copy:m7,Dots:f7,Dot:h7};var CT=T(oe());function Sh(e,t,r){return t<=1?0:(e+r+t)%t}var je=T(k());function g7({hasActions:e=!1,imageUrl:t,options:r}){return t?(0,je.jsx)(bc.Root,{$mobile:!0,$hasActions:e,$image:Boolean(t),className:"mobile-thickness-guide mobile-thickness-guide-image","aria-label":"Thickness guide",children:(0,je.jsx)("img",{src:Xe(t,1e3),alt:"",loading:"eager"})}):(0,je.jsx)(bc.Root,{$mobile:!0,$hasActions:e,$image:Boolean(t),className:"mobile-thickness-guide","aria-label":"Thickness guide",children:r.map(n=>{let o=gu(n),i=hu(n),a=Is(n.objectFit);return(0,je.jsxs)(bc.Tile,{className:"mobile-thickness-guide-tile",children:[(0,je.jsx)(bc.Banner,{className:"mobile-thickness-guide-banner",children:o?(0,je.jsx)(lo.LayerImage,{src:Xe(o,1e3),alt:"",loading:"eager",$objectFit:a}):null}),i?(0,je.jsx)(bc.Card,{className:"mobile-thickness-guide-card",src:Xe(i,1e3),alt:"",loading:"eager",$objectFit:a}):null,(0,je.jsx)("strong",{children:ne(n)})]},String(n.value||ne(n)))})})}function E0({alt:e,config:t,customizeBundleLabel:r="Customize Bundle",fallbackUrl:n,guardLabel:o="Guard 1",onCustomizeBundle:i,onSelectUpsellAccessory:a,showCustomizeBundle:s=!1,showGuardLabel:l=!1,mobile:c=!1,state:d,step:u}){var z,te;let p=(u==null?void 0:u.key)==="upsell",m=p?rt(t,"upsell"):[],g=Math.min(Math.max(0,d.upsellMediaIndex||0),Math.max(0,m.length-1)),y=(z=m[g])==null?void 0:z.product,P=En(y),Y=Ss(y)[0],h=u&&!p?$y(t,u.key):null,S=u&&!p?Vs(t,d,u.key):[],b=S.length||!n?S:[{url:n,objectFit:"contain"}],W=p?Vs(t,d,"upsell"):[],C=Y?{url:Y,objectFit:"contain"}:W[0]||(n?{url:n,objectFit:"contain"}:null),w=!p&&(l||s),I=c&&(u==null?void 0:u.key)==="details"?(t.thicknessSizes||[]).filter(H=>gu(H)||hu(H)):[],U=c&&(u==null?void 0:u.key)==="details"?String(t.mobileThicknessGuideImageUrl||"").trim():"",L=!h&&(Boolean(U)||I.length>0&&I.some(H=>gu(H))&&I.some(H=>hu(H))),X=(0,CT.useRef)(null),N=m.length>1,V=H=>{N&&(a==null||a(Sh(g,m.length,H)))};return(0,je.jsx)(Xi.Media,{$mobile:c,className:"purchase-master-media",children:(0,je.jsxs)(Xi.Frame,{$upsell:p,$mobile:c,$hasActions:w,className:"media-frame",children:[!p&&(l||s)?(0,je.jsxs)(Xi.Actions,{$customize:Boolean(l&&s),$stepKey:u==null?void 0:u.key,$mobile:c,$hasActions:w,className:"media-actions",children:[l?(0,je.jsx)(Xi.GuardLabel,{$mobile:c,$hasActions:w,className:"guard-label",children:o}):null,s&&i?(0,je.jsx)(Xi.BundleTrigger,{$compact:Boolean(l),$mobile:c,$hasActions:w,type:"button",className:"bundle-trigger",onClick:i,children:r}):null]}):null,p?(0,je.jsxs)(Cc.Root,{$mobile:c,className:"upsell-media",role:N?"group":void 0,"aria-roledescription":N?"carousel":void 0,"aria-label":N?"Accessory carousel":void 0,tabIndex:N?0:void 0,onKeyDown:H=>{H.key==="ArrowLeft"?(H.preventDefault(),V(-1)):H.key==="ArrowRight"&&(H.preventDefault(),V(1))},children:[(0,je.jsx)(Cc.Image,{$carousel:N,className:"upsell-media-image",onPointerDown:H=>{var E,Z;N&&(X.current=H.clientX,(Z=(E=H.currentTarget).setPointerCapture)==null||Z.call(E,H.pointerId))},onPointerCancel:()=>{X.current=null},onPointerUp:H=>{let E=X.current;if(X.current=null,E===null)return;let Z=H.clientX-E;Math.abs(Z)>=40&&V(Z>0?-1:1)},children:C?(0,je.jsx)(lo.LayerImage,{src:Xe(C.url,1e3),alt:P||e,loading:"eager",$objectFit:C.objectFit},(te=m[g])==null?void 0:te.key):(0,je.jsx)(Xi.Placeholder,{$upsell:p,$mobile:c,$hasActions:w,className:"media-placeholder"})}),(0,je.jsxs)(Cc.Copy,{$mobile:c,className:"upsell-media-copy",children:[(0,je.jsx)("strong",{children:P}),y!=null&&y.productDescription?(0,je.jsx)("p",{children:y.productDescription}):null]}),N?(0,je.jsx)(Cc.Dots,{$mobile:c,className:"upsell-media-dots",role:"group","aria-label":"Choose accessory",children:m.map((H,E)=>(0,je.jsx)(Cc.Dot,{$active:E===g,$mobile:c,type:"button","aria-label":`Show accessory ${E+1} of ${m.length}: ${En(H.product)||"Accessory"}`,"aria-pressed":E===g,onClick:()=>a==null?void 0:a(E)},H.key))}):null]}):L?(0,je.jsx)(g7,{hasActions:w,imageUrl:U,options:I}):b.length?b.map((H,E)=>(0,je.jsx)(Xi.Image,{$layered:b.length>1,$mobile:c,$hasActions:w,$stepKey:u==null?void 0:u.key,className:"media-image",src:Xe(c&&H.mobileUrl?H.mobileUrl:H.url,1e3),alt:E===0?e:"",loading:E===0?"eager":"lazy",$objectFit:H.objectFit,$layer:b.length>1?E:void 0,"data-purchase-master-image-fit":H.objectFit},`${H.url}-${E}`)):(0,je.jsx)(Xi.Placeholder,{$upsell:p,$mobile:c,$hasActions:w,className:"media-placeholder"})]})})}var PT={colors:{ink:"#111111",muted:"#505050",border:"#888888",surface:"#ffffff",error:"#a21616",selected:"#d6a51f"},breakpoints:{mobile:"749px"},radii:{control:"0.5rem",card:"0.75rem",pill:"999px"}};var Y7=f.div`
  position: relative;
  width: 100%;
  flex: 0 0 var(--purchase-master-progress-height);
  height: var(--purchase-master-progress-height);
  min-height: var(--purchase-master-progress-height);
  overflow: hidden;
  background: #efefef;
  visibility: ${({$customization:e,$mobile:t})=>e&&!t?"hidden":"visible"};
  ${({$mobile:e})=>e&&v`
      display: none;
      flex: 1;
      border-radius: 999px;
    `}
  @media screen and (max-width: 749px) {
    display: ${({$mobile:e})=>e?"none":"block"};
    ${({$mobile:e})=>!e&&v`
        flex: 0 0 4px;
        height: 4px;
        min-height: 4px;
        border-radius: 0;
      `}
    visibility: visible;
  }
`,S7=f.span.attrs(({$value:e})=>({style:{width:`${e}%`}}))`
  display: block;
  height: 100%;
  border-radius: inherit;
  background: ${PT.colors.ink};
  transition: width 180ms ease;
`,Eu={Track:Y7,Fill:S7};var Au=T(k());function y7(e,t){return e<=0?0:Math.min(Math.max(t+1,0),e)/e*100}function yh({currentStepIndex:e,label:t,mobile:r,steps:n}){let o=Oe(),i=y7(n.length,e),a=Math.min(Math.max(e+1,0),n.length),s={"aria-label":t,"aria-valuemax":100,"aria-valuemin":0,"aria-valuenow":Math.round(i),"aria-valuetext":`Step ${a} of ${n.length}`,role:"progressbar"};return r?(0,Au.jsx)(Eu.Track,{$customization:o.stepKey==="customization",$mobile:!0,className:"mobile-progress",...s,children:(0,Au.jsx)(Eu.Fill,{$value:i})}):(0,Au.jsx)(Eu.Track,{$customization:o.stepKey==="customization",className:"purchase-master-progress",$mobile:!1,...s,children:(0,Au.jsx)(Eu.Fill,{$value:i})})}var Ru=T(oe());var As=T(oe()),x7="[data-purchase-master-scroll-region]";function WT(e){return[e,...Array.from(e.querySelectorAll(x7))]}function b7(e){return e.scrollHeight>e.clientHeight+1}function vT(e,t,r){let[n,o]=(0,As.useState)(!1),i=(0,As.useCallback)(()=>{let a=e.current,s=Boolean(t&&a&&WT(a).some(b7));o(l=>l===s?l:s)},[t,e]);return(0,As.useEffect)(()=>{i()}),(0,As.useEffect)(()=>{let a=e.current;if(!t||!a){o(!1);return}let s=typeof ResizeObserver=="undefined"?null:new ResizeObserver(i);return WT(a).forEach(l=>s==null?void 0:s.observe(l)),window.addEventListener("resize",i),()=>{s==null||s.disconnect(),window.removeEventListener("resize",i)}},[t,r,e,i]),n}var C7=16;function P7(e){let t=e.querySelector('[data-purchase-master-field-error], [aria-invalid="true"]');return(t==null?void 0:t.closest("[data-purchase-master-form-section], [data-purchase-master-initials], [data-purchase-master-impression-kit]"))||t||null}function W7(e,t){let r=e.getBoundingClientRect(),o=t.getBoundingClientRect().top-r.top+e.scrollTop-C7;e.scrollTo({top:Math.max(0,o),behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth"})}function wT({activeStep:e,activeSubview:t,currentStepIndex:r,open:n,status:o}){var l;let i=(0,Ru.useRef)(null),a=[(e==null?void 0:e.key)||"",(l=e==null?void 0:e.guardIndex)!=null?l:"",t||"",o?"with-status":"no-status"].join(":"),s=vT(i,n,a);return(0,Ru.useEffect)(()=>{let c=i.current;!n||!c||c.scrollTo({top:0,behavior:"auto"})},[e==null?void 0:e.key,t,r,n]),(0,Ru.useEffect)(()=>{let c=i.current;if(!n||!o||!c)return;let d=P7(c);d&&W7(c,d)},[e==null?void 0:e.key,r,n,o]),{contentRef:i,hasScrollableContent:s}}var Pc=T(oe());function TT({config:e,open:t,stepKey:r,upsellMediaIndex:n,setState:o}){let i=(0,Pc.useMemo)(()=>rt(e,"upsell"),[e]),a=(0,Pc.useCallback)(s=>{let l=Math.min(Math.max(0,s),Math.max(0,i.length-1)),c=i[l];o(d=>({...d,upsellMediaIndex:l,upsellProductKey:(c==null?void 0:c.key)||d.upsellProductKey}))},[o,i]);return(0,Pc.useEffect)(()=>{if(!t||r!=="upsell"||i.length<=1||window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;let s=window.setTimeout(()=>{a(Sh(n,i.length,1))},5e3);return()=>window.clearTimeout(s)},[r,a,t,n,i.length]),a}var MT=T(oe());var Gu=T(k());function UT({nested:e=!1,closeLabel:t,closeIconUrl:r,request:n,onClose:o}){let i=Oe(),a=(n==null?void 0:n.type)==="thickness",s=`${(0,MT.useId)()}-title`,l=(n==null?void 0:n.type)==="thickness"?n.title:fc(n==null?void 0:n.title);return(0,Gu.jsx)(Ia,{nested:e,closeIconUrl:r,closeLabel:t,hidden:!n,onClose:o,selectType:n==null?void 0:n.type,title:l,titleId:s,children:(0,Gu.jsx)(Bo.Options,{$variant:"select",$thickness:a,$appearance:i.appearance,className:"select-options","aria-label":l,children:n?a?(0,Gu.jsx)(jv,{options:n.options,value:n.value,onSelect:c=>{n.onSelect(c),o()}}):(0,Gu.jsx)(Qv,{options:n.options,value:n.value,onSelect:c=>{n.onSelect(c),o()}}):null})})}var w7=f.div.attrs(sc)`
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 60px 24px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  z-index: 2147483002;

  &[hidden] {
    display: none;
  }

  @media screen and (max-width: 749px) {
    align-items: end;
    padding: 0;
    align-items: center;
    justify-items: center;
    padding: calc(20px + env(safe-area-inset-top))
      calc(20px + env(safe-area-inset-right))
      calc(20px + env(safe-area-inset-bottom))
      calc(20px + env(safe-area-inset-left));
  }

  & button[aria-busy="true"] {
    cursor: wait;
    opacity: 0.7;
  }
`,T7=f.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: min(100%, 600px);
  max-height: calc(100dvh - 120px);
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 0 24px rgba(113, 113, 113, 0.25);
  padding: 38px 24px;

  @media screen and (max-width: 749px) {
    height: auto;
    width: 100%;
    max-height: calc(100dvh - 48px);
    border-radius: 16px 16px 0 0;
    gap: 24px;
    padding: 24px 20px;
    width: min(100%, 600px);
    max-height: calc(
      100dvh - 40px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    border-radius: 16px;
  }
`,M7=f.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  min-height: 0;
  overflow-y: auto;

  @media screen and (max-width: 749px) {
    overflow-y: auto;
  }
`,U7=f.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`,I7=f.article`
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 16px;
  min-height: 68px;

  @media screen and (max-width: 749px) {
    grid-template-columns: 68px minmax(0, 1fr);
    gap: 12px;
  }
`,V7=f.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  & h3 {
    margin: 0;
    color: #111111;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    border-bottom: 1px solid #cccccc;
    padding-bottom: 8px;
  }
`,k7=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;

  & button {
    border: 0;
    background: transparent;
    color: #0059d5;
    cursor: pointer;
    padding: 0;
    font: inherit;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`,L7=f.button`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;

  & img {
    display: block;
    width: 22px;
    height: 22px;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`,X7=f.section`
  display: grid;
  width: 100%;
  gap: 12px;
  border-top: 1px solid #cccccc;
  padding-top: 20px;

  & > h3 {
    margin: 0;
    color: #111111;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }
`,N7=f.div`
  display: grid;
  gap: 12px;
`,E7=f.article`
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  min-height: 68px;
`,A7=f.div`
  min-width: 0;

  & h4 {
    margin: 0;
  }

  & p {
    margin: 0;
  }

  & h4 {
    overflow: hidden;
    color: #111111;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & p {
    margin-top: 4px;
    color: #39846c;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }

  & p del {
    margin-right: 6px;
    color: #6e6e73;
    font-weight: 500;
  }

  & p span {
    color: #39846c;
  }
`,R7=f.button`
  display: grid;
  place-items: center;
  min-width: 24px;
  min-height: 24px;
  border: 0;
  background: transparent;
  color: #0059d5;
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-size: 14px;
  font-weight: 600;

  & img {
    display: block;
    width: 22px;
    height: 22px;
  }
`,G7=f.button`
  flex: 0 0 auto;
  width: 200px;
  min-height: 48px;
  border: 0;
  border-radius: 48px;
  background: #111111;
  color: #ffffff;
  cursor: pointer;
  padding: 12px 24px;
  font: inherit;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
`,Nr={Modal:w7,Panel:T7,Content:M7,List:U7,Card:I7,CardBody:V7,CardActions:k7,CardRemove:L7,Components:X7,ComponentList:N7,Component:E7,ComponentBody:A7,ComponentRemove:R7,Done:G7};var _7=f.button`
  position: absolute;
  inset: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`,B7=f.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  gap: 16px;
  min-height: 32px;

  & h2 {
    margin: 0;
    color: #111111;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
  }
`,Z7=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #667085;
  cursor: pointer;
  padding: 0;

  & img {
    display: block;
    width: 32px;
    height: 32px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: 2;
  }

  & svg {
    display: block;
    width: 32px;
    height: 32px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: 2;
  }
`,$7=f.p`
  min-height: 16px;
  margin: -28px 0;
  color: #a21616;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;

  &:empty {
    display: none;
  }
`,Rs={Scrim:_7,Header:B7,Close:Z7,Status:$7};var O7=f.div`
  ${({$variant:e})=>e==="modal"&&v`
      flex-shrink: 0;
      box-sizing: border-box;
      margin: 0;
      background: #ffffff;
    `}

  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border: 0.5px solid #888888;
  border-radius: 12px;
  padding: 16px;

  @media screen and (max-width: 749px) {
    /* Hairline borders can lose their bottom edge on phone screens. */
    border-width: 1px;
  }
`,F7=f.div`
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 16px;

  @media screen and (max-width: 749px) {
    gap: 12px;
  }
`,D7=f.div`
  & h3 {
    margin: 0;
    color: #111111;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }

  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  & sup {
    font-size: 11px;
    line-height: 1;
  }

  & p {
    margin: 0;
    color: #111111;
    font-size: 16px;
    line-height: 20px;
  }

  & p strong {
    color: #c2a443;
    font-weight: 700;
  }

  @media screen and (max-width: 749px) {
    & p strong {
      display: block;
    }
  }

  & b {
    margin: 0;
    color: #111111;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }
`,z7=f.div`
  & button {
    border: 0;
    background: transparent;
    color: #0059d5;
    cursor: pointer;
    padding: 0;
    font: inherit;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  border-top: 1px solid #cccccc;
  padding-top: 16px;

  @media screen and (max-width: 749px) {
    justify-content: space-between;
    gap: 16px;
    padding-top: 12px;
    & button {
      ${({$variant:e})=>e==="modal"&&v`
          white-space: nowrap;
        `}
      font-size: 16px;
      line-height: 20px;
    }
  }
`,Ko={Card:O7,Main:F7,Copy:D7,Actions:z7};var BT=T(oe());function K7(e,t,r,n){var s,l;let o=Kd((s=e==null?void 0:e.pricingPalette)==null?void 0:s.baseGuardPrice);if(o<=0)return"";let i=RS({baseGuardPrice:o,guardQuantity:t,impressionKitPrice:Hd({configuredPrice:n==="clinic"||(l=e==null?void 0:e.pricingPalette)==null?void 0:l.impressionKitPrice,product:n==="clinic"?e==null?void 0:e.bundleClinicScanProduct:(e==null?void 0:e.bundleImpressionKitProduct)||(e==null?void 0:e.impressionKitProduct)})}),a=Math.max(0,i-se(r));return a>0?`Save ${we(a,r)}`:""}function A0(e,t){return Array.from(e.querySelectorAll(".trufit-main-product__package-input")).find(r=>Number.parseInt(r.getAttribute("data-purchase-master-quantity")||"",10)===t)||null}function H7(e){return Array.from(e.querySelectorAll(".trufit-main-product__package-input"))}function IT(e,t){return Boolean(A0(e,t))}function Ni(e,t,r){var m,g,y,P,Y;let n=A0(e,t);if(!n){let h=(r==null?void 0:r.purchaseMasterFlow)==="clinic"?"clinic":"impression-kit",S=(y=h==="clinic"?(m=r==null?void 0:r.pricingPalette)==null?void 0:m.clinicBundlePrices:(g=r==null?void 0:r.pricingPalette)==null?void 0:g.bundlePrices)==null?void 0:y[t-1];if(!S)return null;let b=RS({baseGuardPrice:Kd((P=r==null?void 0:r.pricingPalette)==null?void 0:P.baseGuardPrice),guardQuantity:t,impressionKitPrice:Hd({configuredPrice:h==="clinic"||(Y=r==null?void 0:r.pricingPalette)==null?void 0:Y.impressionKitPrice,product:h==="clinic"?r==null?void 0:r.bundleClinicScanProduct:(r==null?void 0:r.bundleImpressionKitProduct)||(r==null?void 0:r.impressionKitProduct)})}),W=se(S),C=Math.max(0,b-W);return{available:!0,compareAtPrice:b>W?we(b,S):"",price:S,quantity:t,saveLabel:C>0?`Save ${we(C,S)}`:"",title:`${t} ${t===1?"guard":"guards"}`}}let o=n.closest(".trufit-main-product__package"),i=no(o,"[data-purchase-master-package-compare], .trufit-main-product__package-price s",""),a=n.getAttribute("data-purchase-master-price")||no(o,"[data-purchase-master-package-price-text]",""),s=no(o,'[data-purchase-master-package-line="3"], .trufit-main-product__package-save',""),l=Math.max(0,se(i)-se(a)),c=n.getAttribute("data-purchase-master-flow")==="clinic"?"clinic":"impression-kit",d=K7(r,t,a,c),u=no(o,".trufit-main-product__package-title","")||n.getAttribute("data-title")||"Bundle",p=typeof(o==null?void 0:o.hasAttribute)=="function"&&o.hasAttribute("hidden")||t>=4||u.trim().toLowerCase()==="ultimate";return{available:!n.disabled,compareAtPrice:i,price:a,quantity:t,saveLabel:d||s||(l>0?`Save ${we(l,a)}`:"")||"",title:p?`${t} ${t===1?"guard":"guards"}`:u}}function Ho(e,t){let r=A0(e,t);return!r||r.disabled?!1:(r.click(),r.checked)}function _u(e,t=0){let r=H7(e)[Math.max(0,t)];return!r||r.disabled?!1:(r.click(),r.checked)}function xh(e,t){let r=Q7(e,t);return r<=0?"":`+${we(r,t==null?void 0:t.price)}`}function Q7(e,t){return!e||!t?0:Math.max(0,se(t.price)-se(e.price))}function VT(e){let t=e%100;return t>=11&&t<=13?"th":e%10===1?"st":e%10===2?"nd":e%10===3?"rd":"th"}var Ch=new Set,kT=[];function j7(e){return e.some(t=>/(image|icon|thumbnail)/i.test(t))}function bh(e,t,r){if(typeof e=="string"){let n=e.trim();if(j7(t)&&(/^https?:\/\//i.test(n)||n.startsWith("//")||n.startsWith("/"))&&r.add(n),/imagesByImpressionTypeJson$/i.test(t[t.length-1]||""))try{bh(JSON.parse(n),t,r)}catch(o){}return}if(Array.isArray(e)){e.forEach(n=>bh(n,t,r));return}!e||typeof e!="object"||Object.entries(e).forEach(([n,o])=>bh(o,[...t,n],r))}function q7(e,t){let r=new Set;return bh(e,[],r),t&&r.add(t),Array.from(r)}function LT(e){typeof Image!="undefined"&&e.forEach(t=>{if(!t||Ch.has(t))return;Ch.add(t);let r=new Image;r.decoding="async",r.src=t,kT.push(r)})}function Wc(e,t){typeof Image!="undefined"&&q7(e,t).forEach(r=>{let n=Xe(r,1e3)||r;if(Ch.has(n))return;Ch.add(n);let o=new Image;o.decoding="async",o.fetchPriority="high",o.src=n,kT.push(o)})}var qe=T(k()),Ph=e=>e===1?x("1 guard"):x("{count} guards",{count:e});function XT({packageSummary:e,current:t=!1}){return(0,qe.jsxs)("div",{className:`bundle-tier${t?" is-on":""}`,children:[(0,qe.jsxs)("b",{children:[e.title," \xB7 ",Ph(e.quantity)]}),(0,qe.jsxs)("small",{children:[e.price,e.compareAtPrice?(0,qe.jsx)("s",{children:e.compareAtPrice}):null]})]})}function vc({currentPackage:e,downgradedPackage:t,guardIndex:r,labels:n,onCancel:o,onConfirm:i,saving:a=!1}){let s=`PurchaseMasterRemoveGuard${r}Title`,l=r+1;return(0,qe.jsxs)(hc,{className:"bundle-downgrade-modal",role:"dialog","aria-modal":"true","aria-labelledby":s,"aria-busy":a||void 0,children:[(0,qe.jsx)(gc,{type:"button",className:"bundle-modal-scrim","aria-label":n.closeLabel,disabled:a,onClick:o}),(0,qe.jsxs)(Yc,{className:"bundle-downgrade-panel",$width:520,children:[(0,qe.jsxs)("div",{className:"pp-hd",children:[(0,qe.jsxs)("div",{children:[(0,qe.jsx)("h2",{id:s,children:x("Remove guard {number}?",{number:l})}),(0,qe.jsx)("p",{children:x("Your package changes from {from} to {to}.",{from:Ph(e.quantity),to:Ph(t.quantity)})})]}),(0,qe.jsx)("button",{type:"button",className:"pp-x bundle-modal-close","aria-label":n.closeLabel,disabled:a,onClick:o,children:"\xD7"})]}),(0,qe.jsxs)("div",{className:"pp-cmp bundle-tier-change",children:[(0,qe.jsx)(XT,{packageSummary:e,current:!0}),(0,qe.jsx)("span",{className:"pp-arrow","aria-hidden":"true",children:"\u2192"}),(0,qe.jsx)(XT,{packageSummary:t})]}),(0,qe.jsx)("p",{className:"pp-note",children:x("Your total updates right away. You can add a guard back any time before checkout.")}),(0,qe.jsxs)("div",{className:"pp-btns bundle-downgrade-actions",children:[(0,qe.jsx)("button",{type:"button",className:"pp-btn is-primary",disabled:a,onClick:o,children:x("Keep {count}",{count:Ph(e.quantity)})}),(0,qe.jsx)("button",{type:"button",className:"pp-btn bundle-downgrade-confirm",disabled:a,"aria-busy":a||void 0,onClick:i,children:a?(0,qe.jsxs)(qe.Fragment,{children:[(0,qe.jsx)("span",{className:"pp-spin bundle-downgrade-spinner","aria-hidden":"true"}),(0,qe.jsx)("span",{children:x("Updating...")})]}):x("Remove guard {number}",{number:l})})]})]})]})}var J7=f.aside`
  position: sticky;
  top: 0;
  display: grid;
  align-content: start;
  height: 100%;
  min-width: 0;

  @media screen and (max-width: 749px) {
    position: static;
    height: auto;
    justify-items: center;
  }
`,eA=f.div`
  position: relative;
  display: grid;
  place-items: center;
  height: 100%;
  min-height: 220px;
  overflow: hidden;
  border: 1px solid #e2e2e2;
  border-radius: 16px;
  background: #f7f7f7;

  @media screen and (max-width: 749px) {
    justify-self: center;
    width: min(100%, 440px);
    aspect-ratio: 1.5 / 1;
    height: auto;
    min-height: 160px;
    max-height: 220px;
  }
`,tA=f.span`
  position: absolute;
  z-index: 5;
  top: 12px;
  left: 12px;
  border-radius: 999px;
  background: #ffffff;
  color: #4e4e4f;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`,rA=f.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
`,nA=f.img.attrs(Us)`
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  max-width: none;
  height: 100%;
  max-height: none;
  margin: auto;
  object-fit: contain;
`,oA=f.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  transform: scale(1.1);
`,iA=f.span.attrs(({$color:e})=>({style:{background:e}}))`
  position: absolute;
  display: block;
  border: 1px solid rgba(17, 17, 17, 0.15);
  transform: rotate(-4deg);
  width: 68%;
  height: 35%;
  border-radius: 20% 20% 48% 48%;
  box-shadow: inset 0 -12px 18px rgba(17, 17, 17, 0.14),
    0 10px 16px rgba(17, 17, 17, 0.12);
`,aA=f.span.attrs(({$color:e})=>({style:{background:e}}))`
  position: absolute;
  display: block;
  border: 1px solid rgba(17, 17, 17, 0.15);
  transform: rotate(-4deg);
  width: 44%;
  height: 18%;
  border-radius: 50%;
  opacity: 0.92;
  transform: translateY(9%) rotate(-4deg);
`,sA=f.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 392px);
  align-items: center;
  gap: 16px;
  min-height: 36px;
  border-bottom: 1px solid #cccccc;
  padding: 6px 0;

  ${({$variant:e})=>e==="color"&&v`
      grid-template-columns: minmax(110px, 1fr) minmax(0, 420px);
    `}

  ${({$variant:e})=>e==="initials"&&v`
      position: relative;
      grid-template-columns: minmax(0, 1fr) minmax(0, 259px);
      padding-bottom: 22px;

      & label {
        color: #4e4e4f;
        font-size: 14px;
        line-height: 24px;
      }
    `}

  @media screen and (max-width: 749px) {
    grid-template-columns: minmax(112px, 0.72fr) minmax(0, 1.28fr);
    align-items: center;
    gap: 16px;
    padding: 10px 0;

    ${({$variant:e})=>(e==="thickness"||e==="color"||e==="initials")&&v`
        grid-template-columns: minmax(0, 1fr);
        align-items: start;
      `}

    ${({$variant:e})=>e==="thickness"&&v`
        gap: 8px;
      `}

    ${({$variant:e})=>e==="color"&&v`
        gap: 4px;
      `}

    ${({$variant:e})=>e==="initials"&&v`
        gap: 8px;
        padding-bottom: 10px;

        & > * {
          grid-column: 1 / -1;
        }
      `}
  }
`,lA=f.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #4e4e4f;
  font-size: 14px;
  line-height: 24px;

  ${({$variant:e})=>e==="color"&&v`
      & > span {
        white-space: normal;
      }
    `}

  @media screen and (max-width: 749px) {
    align-self: center;
    flex-wrap: wrap;
    gap: 0 8px;
  }
`,cA=f.button`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 50%;
  background: #f2f2f2;
  color: #111111;
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
`,dA=f.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  min-width: 0;

  @media screen and (max-width: 749px) {
    justify-content: ${({$variant:e})=>e==="position"?"flex-end":"flex-start"};
    flex-wrap: wrap;

    ${({$variant:e})=>e==="thickness"&&v`
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
      `}
  }
`,uA=f.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: #111111;
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;

  & > span:first-child {
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    border: ${({$selected:e})=>e?"5px solid #3182ce":"1px solid #888888"};
    border-radius: 50%;
    background: #ffffff;
  }
`,pA=f.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  row-gap: 4px;
  min-width: 0;
  color: #111111;
  font-size: 14px;
  line-height: 24px;

  @media screen and (max-width: 749px) {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 4px 8px;
  }
`,mA=f.span`
  flex: 0 0 auto;
  min-width: 0;
  color: #1d1d1f;
  font-weight: 500;
  line-height: 24px;
  text-align: right;
  white-space: nowrap;

  @media screen and (max-width: 749px) {
    text-align: left;
  }
`,fA=f.div.attrs(sc)`
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 60px 24px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  z-index: 2147483003;

  @media screen and (max-width: 749px) {
    align-items: center;
    justify-items: center;
    padding: calc(20px + env(safe-area-inset-top))
      calc(20px + env(safe-area-inset-right))
      calc(20px + env(safe-area-inset-bottom))
      calc(20px + env(safe-area-inset-left));
  }
`,hA=f.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: min(100%, 900px);
  max-height: calc(100dvh - 120px);
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 0 24px rgba(113, 113, 113, 0.25);
  padding: 38px 24px;

  @media screen and (max-width: 749px) {
    height: auto;
    gap: 24px;
    padding: 24px 20px;
    width: min(100%, 600px);
    max-height: calc(
      100dvh - 40px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    border-radius: 16px;
  }
`,gA=f.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  @media screen and (max-width: 749px) {
    overflow-y: auto;
  }
`,YA=f.div`
  display: grid;
  grid-template-columns: minmax(220px, 0.8fr) minmax(0, 1.5fr);
  align-items: stretch;
  gap: 32px;

  @media screen and (max-width: 749px) {
    grid-template-columns: 1fr;
    align-items: start;
    gap: 20px;
  }
`,SA=f.div`
  display: flex;
  flex-direction: column;
`,yA=f.div`
  display: grid;
  grid-template-columns: 200px 43px;
  align-items: center;
  justify-content: end;
  gap: 16px;

  @media screen and (max-width: 749px) {
    grid-template-columns: minmax(0, 1fr) 43px;
    width: 100%;
  }
`,xA=f.input`
  width: 200px;
  height: 32px;
  border: 0;
  border-bottom: 1px solid #111111;
  border-radius: 0;
  background: transparent;
  color: #111111;
  padding: 4px 0;
  font: inherit;
  font-size: 14px;
  line-height: 24px;
  text-align: center;

  ${({$invalid:e})=>e&&v`
      border-color: #d92d20;
    `}

  @media screen and (max-width: 749px) {
    width: 100%;
  }
`,bA=f.span`
  display: grid;
  place-items: center;
  width: 43px;
  height: 43px;
  overflow: hidden;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`,CA=f.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  flex: 0 0 auto;

  @media screen and (max-width: 749px) {
    gap: 12px;
  }
`,PA=f.button`
  min-height: 48px;
  border: 1px solid #111111;
  border-radius: 48px;
  cursor: pointer;
  padding: 12px 24px;
  font: inherit;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  background: ${({$variant:e})=>e==="primary"?"#111111":"#ffffff"};
  color: ${({$variant:e})=>e==="primary"?"#ffffff":"#111111"};

  ${({$saving:e})=>e&&v`
      cursor: wait;
      opacity: 0.7;
    `}

  @media screen and (max-width: 749px) {
    min-height: 44px;
    padding: 10px 16px;
    font-size: 16px;
    line-height: 22px;
  }
`,NT={PreviewPanel:J7,PreviewCard:eA,PreviewBadge:tA,PreviewMedia:rA,PreviewLayer:nA,PreviewFallback:oA,PreviewFallbackShell:iA,PreviewFallbackPad:aA,Row:sA,RowLabel:lA,GuideButton:cA,Radios:dA,Radio:uA,ColorControl:pA,ColorValue:mA,Modal:fA,Panel:hA,Content:gA,Layout:YA,Form:SA,InitialsControl:yA,Input:xA,Preview:bA,Actions:CA,Button:PA};var Wh=T(oe());var Na=T(oe());function WA(e,t){let r={...e};return t.forEach(n=>delete r[n]),r}function vA(e){return e.position||e.sport||e.thicknessSize||e.color||e.padColor||e.initials||"Please complete the guard selections."}function ET({config:e,initialState:t,onSave:r}){let[n,o]=(0,Na.useState)(t),[i,a]=(0,Na.useState)({}),[s,l]=(0,Na.useState)(""),[c,d]=(0,Na.useState)(!1),u=(0,Na.useCallback)((b,W=[])=>{o(b),W.length&&a(C=>WA(C,W)),l("")},[]),p=(0,Na.useCallback)((b,W)=>{u(C=>({...C,[b]:W}),[b])},[u]),m=b=>{u(W=>{let C={...W,sport:b};return mc(e,C),C},["sport","thicknessSize"])},g=b=>{let W=ao(b);u(C=>{var w;return{...C,initials:W,initialsOptIn:Boolean(W)||Boolean((w=e.initials)==null?void 0:w.isRequired)}},["initials"])},y=()=>{let b=ST({config:e,state:n});if(a(b.errors),!b.isValid){l(vA(b.errors));return}r(n)},P=()=>d(!0),Y=()=>d(!1),h=qf(e,n),S=c?{title:"Thickness Guide",options:h,value:n.thicknessSize,type:"thickness",onSelect:b=>{p("thicknessSize",b),Y()}}:null;return{draftState:n,fieldErrors:i,status:s,thicknessGuideOpen:c,thicknessGuideRequest:S,thicknessOptions:h,setFieldValue:p,setSport:m,setIdTag:g,openThicknessGuide:P,closeThicknessGuide:Y,saveDraft:y}}var RT=T(oe());var ye=T(k()),Gs=e=>String(e.value||e.label||""),wA=["white","clear","light grey","light gray","silver"];function AT({label:e,options:t,value:r,onSelect:n}){let o=t.find(i=>Gs(i)===r);return(0,ye.jsxs)("div",{role:"group","aria-label":e,children:[(0,ye.jsxs)("p",{className:"ge-lbl",children:[e," ",(0,ye.jsx)("span",{children:o?x(ne(o)):""})]}),(0,ye.jsx)("div",{className:"ge-sws",children:t.map(i=>{let a=Gs(i),s=a===r,l=x(ne(i)),c=wA.includes(String(ne(i)).toLowerCase())||xc(i);return(0,ye.jsx)("button",{type:"button",className:`ge-sw${s?" is-on":""}${c?" is-light":""}`,"aria-label":l,"aria-pressed":s,title:l,onClick:()=>n(a),children:(0,ye.jsx)("span",{style:Iu(i)})},a)})})]})}function TA(e){let t=e.match(/^(.*?)\s*(\([^)]*\))$/);return t?(0,ye.jsxs)(ye.Fragment,{children:[t[1]," ",(0,ye.jsx)("small",{children:t[2]})]}):e}function GT({config:e,errors:t,onFieldChange:r,onIdTagChange:n,onSportChange:o,readOnlyMessage:i,state:a,thicknessOptions:s,titleId:l,fallbackImageUrl:c,onPickerChange:d}){let[u,p]=(0,RT.useState)(!1),m=U=>{p(U),d==null||d(U)},g=e.positions||[],y=Fe(e.sports,a.sport),P=Fe(e.thicknessSizes,a.thicknessSize),Y=Ge(e.sports)||Ge(e.thicknessSizes),h=e.initials,S=h?Bl(h):"",b=t.position||t.thicknessSize||t.sport||t.color||t.padColor||t.initials||"",W=e.thicknessSizes||[],C=W.findIndex(U=>Gs(U)===String(Ma(e,a))),w=W.findIndex(U=>Gs(U)===a.thicknessSize),I=null;return y&&C!==-1&&(w===C?I=(0,ye.jsx)("span",{className:"ge-badge is-fit",children:x("{thickness} recommended for {sport}",{thickness:x(ne(W[C])),sport:x(ne(y)).replace(/\s*\([^)]*\)\s*/g," ").trim().toLowerCase()})}):w===C+1?I=(0,ye.jsx)("span",{className:"ge-badge is-blue",children:x("More protection")}):w>C+1&&(I=(0,ye.jsx)("span",{className:"ge-badge is-blue-dark",children:x("Even more protection")}))),u?(0,ye.jsxs)("div",{className:"ge-body",children:[(0,ye.jsxs)("p",{className:"ge-lbl",children:[x("Sport")," ",(0,ye.jsx)("span",{children:x("optional")})]}),(0,ye.jsx)("div",{className:"ge-chips",role:"group","aria-label":x("Sport"),children:(e.sports||[]).map(U=>{let L=Gs(U),X=L===a.sport;return(0,ye.jsx)("button",{type:"button",className:X?"is-on":"","aria-pressed":X,onClick:()=>o(X?"":L),title:x(ne(U)),children:TA(x(ne(U)))},L)})}),s.length?(0,ye.jsxs)(ye.Fragment,{children:[(0,ye.jsxs)("p",{className:"ge-lbl ge-lbl-thick",children:[x("Thickness")," ",I]}),(0,ye.jsx)("div",{className:"ge-seg",role:"group","aria-label":x("Thickness"),style:{gridTemplateColumns:`repeat(${s.length}, 1fr)`},children:s.map(U=>{let L=Gs(U),X=L===a.thicknessSize;return(0,ye.jsx)("button",{type:"button",className:X?"is-on":"","aria-pressed":X,onClick:()=>r("thicknessSize",L),children:x(ne(U))},L)})})]}):null,(0,ye.jsx)("button",{type:"button",className:"ge-done",onClick:()=>m(!1),children:x("Done")})]}):(0,ye.jsxs)("div",{className:"ge-body",children:[i?(0,ye.jsx)("p",{className:"ge-note",children:i}):null,(0,ye.jsxs)("div",{className:"ge-grid",children:[(0,ye.jsxs)("div",{className:"ge-prev","aria-label":x("Guard preview"),children:[(0,ye.jsx)("span",{className:"ge-pill",children:x("Live preview")}),(0,ye.jsx)("span",{className:"ge-layers","aria-hidden":"true",children:(0,ye.jsx)(co,{config:e,state:a,fallbackUrl:c,width:480})})]}),(0,ye.jsxs)("div",{className:"ge-controls",children:[Ge(e.colors)?(0,ye.jsx)(AT,{label:x("Guard color"),options:Es(e.colors,"guard"),value:a.color,onSelect:U=>r("color",U)}):null,Ge(e.padColors)?(0,ye.jsx)(AT,{label:x("Pad color"),options:Es(e.padColors,"pad"),value:a.padColor,onSelect:U=>r("padColor",U)}):null,g.length>1?(0,ye.jsx)("div",{className:"ge-seg",role:"group","aria-label":x("Guard position"),style:{gridTemplateColumns:`repeat(${g.length}, 1fr)`,marginTop:12},children:g.map(U=>{let L=Gs(U),X=L===a.position;return(0,ye.jsx)("button",{type:"button",className:X?"is-on":"","aria-pressed":X,onClick:()=>r("position",L),children:x(ne(U))},L)})}):null,Y?(0,ye.jsxs)("button",{type:"button",className:"ge-set",onClick:()=>m(!0),children:[(0,ye.jsxs)("span",{className:"ge-ellipsis",children:[(0,ye.jsx)("b",{children:P?x(ne(P)):x("Standard")}),y?` \xB7 ${x(ne(y))}`:""]}),(0,ye.jsx)("u",{children:y?x("Change"):x("Choose sport")})]}):null,h!=null&&h.isAvailable?(0,ye.jsxs)("div",{className:"ge-row",children:[(0,ye.jsxs)("label",{htmlFor:`${l}Initials`,children:[x("ID tag")," ",S?(0,ye.jsx)("span",{children:S}):null]}),(0,ye.jsx)("input",{id:`${l}Initials`,className:"ge-in",type:"text",maxLength:Cs,autoComplete:"off",inputMode:"text",pattern:Hl,autoCapitalize:"characters",placeholder:x("Up to 4 characters"),value:a.initials,"aria-invalid":Boolean(t.initials)||void 0,onChange:U=>n(U.currentTarget.value)})]}):null]})]}),b?(0,ye.jsx)("p",{className:"ge-error",children:x(b)}):null]})}var _T=f.div`
  position: relative;
  z-index: 1;
  width: min(720px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 24px 26px 22px;
  border-radius: 22px;
  background: #ffffff;
  color: #111111;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.3);
  font-family: inherit;
  text-align: left;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  button {
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  .ge-hd {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .ge-hd h2 {
    margin: 0;
    font-size: 21px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  .ge-hd p {
    margin: 3px 0 0;
    font-size: 14px;
    color: #505050;
  }

  .ge-x {
    flex: none;
    width: 36px;
    height: 36px;
    margin: -6px -8px 0 0;
    border: 0;
    background: transparent;
    font-size: 24px;
    line-height: 1;
  }

  .ge-grid {
    display: grid;
    grid-template-columns: 190px 1fr;
    gap: 22px;
    align-items: start;
  }

  .ge-prev {
    position: relative;
    height: 190px;
    border: 1px solid #ececef;
    border-radius: 16px;
    background: radial-gradient(ellipse at 50% 55%, #ffffff 0%, #f4f4f5 75%);
    overflow: hidden;
  }

  .ge-layers {
    position: absolute;
    inset: 6%;
  }

  .ge-layers img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .ge-pill {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 2;
    padding: 4px 10px;
    border-radius: 999px;
    background: #f0f0f0;
    font-size: 12px;
    font-weight: 700;
  }

  .ge-lbl {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 700;
  }

  .ge-lbl span {
    font-weight: 500;
    color: #505050;
  }

  .ge-controls > * + * .ge-lbl,
  .ge-controls > [role="group"] + [role="group"] .ge-lbl {
    margin-top: 12px;
  }

  .ge-sws {
    display: flex;
    flex-wrap: wrap;
    gap: 9px;
  }

  .ge-sw {
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .ge-sw span {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  .ge-sw.is-on {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #111111;
  }

  .ge-seg {
    display: grid;
    gap: 8px;
  }

  .ge-seg button {
    height: 44px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    background: #ffffff;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    padding: 0 6px;
  }

  .ge-seg button.is-on {
    border: 2px solid #111111;
    background: #111111;
    color: #ffffff;
  }

  .ge-set {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    height: 46px;
    margin-top: 8px;
    padding: 0 14px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    background: #ffffff;
    font-size: 14px;
    text-align: left;
  }

  .ge-set u {
    flex: none;
    font-weight: 700;
    text-underline-offset: 3px;
  }

  .ge-ellipsis {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ge-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
  }

  .ge-row label {
    flex: none;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
  }

  .ge-row label span {
    font-weight: 600;
    color: #6b6b6b;
  }

  .ge-in {
    flex: 1;
    min-width: 0;
    height: 44px;
    padding: 0 14px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    font: inherit;
    font-size: 16px;
    text-transform: uppercase;
  }

  .ge-in::placeholder {
    text-transform: none;
    color: #8a8a8a;
  }

  .ge-in[aria-invalid="true"] {
    border-color: #c62828;
  }

  /* Sports in clean columns: 3 on desktop, 2 on phones; equal-size buttons. */
  .ge-chips {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
  }

  .ge-chips button {
    height: 40px;
    min-width: 0;
    padding: 0 8px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    background: #ffffff;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ge-chips button small {
    font-size: 0.82em;
    font-weight: 500;
  }

  /* Thickness badges, same colors as the main customizer. */
  .ge-lbl-thick {
    align-items: center;
    gap: 8px;
  }

  .ge-badge {
    display: inline-flex;
    align-items: center;
    min-height: 22px;
    padding: 2px 9px;
    border-radius: 999px;
    background: #e8f5ec;
    color: #1b7f3b !important;
    font-size: 11.5px;
    font-weight: 700;
    line-height: 1.25;
    text-align: right;
  }

  .ge-badge.is-blue {
    background: #eef2ff;
    color: #1e3a8a !important;
  }

  .ge-badge.is-blue-dark {
    background: #dbe4ff;
    color: #172554 !important;
  }

  .ge-chips button.is-on {
    border-color: #111111;
    background: #111111;
    color: #ffffff;
  }

  .ge-chips + .ge-lbl {
    margin-top: 14px;
  }

  .ge-done {
    width: 100%;
    height: 46px;
    margin-top: 14px;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff !important;
    font-size: 15px;
    font-weight: 700;
  }

  .ge-note {
    margin: 0 0 10px;
    font-size: 13.5px;
    color: #505050;
  }

  .ge-error {
    margin: 10px 0 0;
    font-size: 13px;
    color: #c62828;
  }

  .ge-status:empty {
    display: none;
  }

  .ge-status {
    margin: 0;
    font-size: 13px;
    color: #505050;
  }

  .ge-btns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .ge-btns.has-delete {
    grid-template-columns: 50px 1fr 1fr;
  }

  .ge-btns[hidden] {
    display: none;
  }

  .ge-btn {
    height: 50px;
    border-radius: 999px;
    border: 1.5px solid #111111;
    background: #ffffff;
    font-size: 16px;
    font-weight: 700;
  }

  .ge-btn.is-primary {
    background: #111111;
    color: #ffffff !important;
  }

  .ge-btn:disabled {
    opacity: 0.6;
    cursor: default;
  }

  .ge-del {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1.5px solid #e2e2e2;
    background: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #b42318 !important;
  }

  .ge-del svg {
    width: 20px;
    height: 20px;
  }

  @media screen and (max-width: 749px) {
    width: 100%;
    max-height: calc(100dvh - 24px);
    padding: 10px 18px calc(16px + env(safe-area-inset-bottom, 0px));
    gap: 12px;
    border-radius: 22px 22px 0 0;
    align-self: end;

    &::before {
      content: "";
      display: block;
      width: 40px;
      height: 5px;
      margin: 0 auto 2px;
      border-radius: 9px;
      background: #d9d9d9;
    }

    .ge-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .ge-prev {
      height: 170px;
    }

    .ge-layers {
      inset: 2% 10%;
    }

    .ge-sws {
      gap: 7px;
    }

    .ge-sw {
      width: 28px;
      height: 28px;
    }

    .ge-chips {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 5px;
    }

    .ge-chips button {
      height: 42px;
      padding: 0 6px;
      font-size: 14px;
    }
  }

  /* Short phone screens (iPhone SE, browser bars showing): still no scrolling. */
  @media screen and (max-width: 749px) and (max-height: 760px) {
    gap: 9px;
    padding-top: 8px;

    .ge-hd p {
      display: none;
    }

    .ge-hd h2 {
      font-size: 19px;
    }

    .ge-prev {
      height: 118px;
    }

    .ge-pill {
      top: 6px;
      left: 6px;
      font-size: 11px;
      padding: 3px 8px;
    }

    .ge-grid {
      gap: 8px;
    }

    .ge-lbl {
      margin-bottom: 6px;
      font-size: 13.5px;
    }

    .ge-controls > [role="group"] + [role="group"] .ge-lbl {
      margin-top: 8px;
    }

    .ge-seg button {
      height: 40px;
    }

    .ge-set {
      height: 42px;
    }

    .ge-row {
      margin-top: 8px;
    }

    .ge-in {
      height: 40px;
    }

    .ge-btn,
    .ge-del {
      height: 46px;
    }

    .ge-del {
      width: 46px;
    }

    .ge-btns.has-delete {
      grid-template-columns: 46px 1fr 1fr;
    }

    .ge-chips {
      gap: 3px 4px;
    }

    .ge-chips button {
      height: 34px;
      padding: 0 5px;
      font-size: 12px;
    }

    .ge-chips + .ge-lbl {
      margin-top: 10px;
    }

    .ge-done {
      height: 42px;
      margin-top: 8px;
    }
  }

  /* Very short phone screens (small iPhone SE with browser bars): compact sports so nothing scrolls. */
  @media screen and (max-width: 749px) and (max-height: 600px) {
    .ge-chips button {
      height: 24px;
    }

    .ge-badge {
      min-height: 20px;
      padding: 1px 8px;
      font-size: 11px;
    }
  }
`;var Et=T(k()),MA=f(NT.Modal)`
  padding: 16px;

  @media screen and (max-width: 749px) {
    padding: 12px 0 0;
    align-items: end;
  }
`;function Qo({config:e,guardIndex:t,initialState:r,labels:n,onCancel:o,onSave:i,previewImageUrl:a,thicknessGuideImageUrl:s,saving:l=!1,savingLabel:c="Saving...",externalStatus:d="",readOnlyMessage:u="",saveDisabled:p=!1,onDelete:m}){let g=ET({config:e,initialState:r,onSave:i}),[y,P]=(0,Wh.useState)(!1),Y=`PurchaseMasterBundleGuard${t}Title`;return(0,Wh.useEffect)(()=>{Wc(e,a)},[e,a]),(0,Et.jsxs)(MA,{className:"bundle-edit-modal",role:"dialog","aria-modal":"true","aria-labelledby":Y,"aria-busy":l||void 0,$guideImageUrl:s,onKeyDownCapture:h=>{h.key==="Escape"&&g.thicknessGuideOpen&&(h.stopPropagation(),g.closeThicknessGuide())},children:[(0,Et.jsx)(Rs.Scrim,{type:"button",className:"bundle-modal-scrim","aria-label":n.closeLabel,disabled:l,onClick:o}),(0,Et.jsxs)(_T,{className:"bundle-edit-panel",children:[(0,Et.jsxs)("div",{className:"ge-hd",children:[(0,Et.jsxs)("div",{children:[(0,Et.jsx)("h2",{id:Y,children:d0()==="fr"?`Prot\xE8ge-dents ${t+1}`:x("Guard {number}",{number:t+1})}),t>0?(0,Et.jsx)("p",{children:x("Same impression as guard 1 \xB7 change anything")}):null]}),(0,Et.jsx)("button",{type:"button",className:"ge-x bundle-modal-close","aria-label":n.closeLabel,disabled:l,onClick:o,children:"\xD7"})]}),(0,Et.jsx)(GT,{config:e,errors:g.fieldErrors,fallbackImageUrl:a,onFieldChange:g.setFieldValue,onIdTagChange:g.setIdTag,onSportChange:g.setSport,readOnlyMessage:u,state:g.draftState,thicknessOptions:g.thicknessOptions,titleId:Y,onPickerChange:P}),(0,Et.jsx)("p",{className:"ge-status bundle-modal-status",role:"status",children:d||g.status}),(0,Et.jsxs)("div",{hidden:y,className:`ge-btns bundle-edit-actions${m?" has-delete":""}`,children:[m?(0,Et.jsx)("button",{type:"button",className:"ge-del bundle-edit-delete","aria-label":x("Delete this guard from the cart"),title:x("Delete this guard"),disabled:l,onClick:m,children:(0,Et.jsxs)("svg",{viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",children:[(0,Et.jsx)("path",{d:"M3 6h18"}),(0,Et.jsx)("path",{d:"M8 6V4h8v2"}),(0,Et.jsx)("path",{d:"M19 6l-1 14H6L5 6"}),(0,Et.jsx)("path",{d:"M10 11v6M14 11v6"})]})}):null,(0,Et.jsx)("button",{type:"button",className:"ge-btn bundle-edit-button bundle-edit-button-secondary",disabled:l,onClick:o,children:x("Cancel")}),(0,Et.jsx)("button",{type:"button",className:"ge-btn is-primary bundle-edit-button bundle-edit-button-primary",disabled:l||p,"aria-busy":l||void 0,onClick:g.saveDraft,children:l?c:x("Save guard {number}",{number:t+1})})]})]})]})}var ue=T(k());function UA(e){let t=e.quantity>1?` \xD7 ${e.quantity}`:"";return!e.removable&&e.included?(0,ue.jsxs)(ue.Fragment,{children:["Included",t]}):e.compareAtPriceLabel&&e.priceLabel&&e.compareAtPriceLabel!==e.priceLabel?(0,ue.jsxs)(ue.Fragment,{children:[(0,ue.jsx)("del",{children:e.compareAtPriceLabel}),(0,ue.jsx)("span",{children:e.priceLabel}),t]}):(0,ue.jsxs)(ue.Fragment,{children:[e.priceLabel,t]})}function IA(e,t,r){var n;return((n=Ns(e,t,r)[0])==null?void 0:n.url)||""}function vh({bundleComponents:e=[],bundleStates:t,config:r,currentPackage:n,downgradedPackage:o,editingGuardIndex:i,fallbackMediaUrl:a,labels:s,nextPackage:l,onAddGuard:c,onAddIdenticalGuard:d,onCancelEdit:u,onCancelRemove:p,onClose:m,onDone:g,onConfirmRemove:y,onEdit:P,onRemove:Y,onRemoveBundleComponent:h,onSave:S,removingGuardIndex:b,saving:W=!1,status:C="",allowBundleChanges:w=!0,thicknessGuideImageUrl:I}){let U="PurchaseMasterBundleCustomizeTitle",L=t.length+1,X=l!=null&&l.available?xh(n,l):"";return(0,BT.useEffect)(()=>{Wc(r,a)},[r,a]),(0,ue.jsxs)(ue.Fragment,{children:[(0,ue.jsxs)(Nr.Modal,{className:"bundle-modal",role:"dialog","aria-modal":"true","aria-labelledby":U,hidden:i!==null||b!==null,$guideImageUrl:I,children:[(0,ue.jsx)(Rs.Scrim,{type:"button",className:"bundle-modal-scrim","aria-label":s.closeLabel,onClick:m}),(0,ue.jsxs)(Nr.Panel,{className:"bundle-modal-panel",children:[(0,ue.jsxs)(Rs.Header,{className:"bundle-modal-header",children:[(0,ue.jsx)("h2",{id:U,children:"Customize Bundle"}),(0,ue.jsx)(Rs.Close,{type:"button",className:"bundle-modal-close","aria-label":s.closeLabel,onClick:m,children:r.closeIconUrl?(0,ue.jsx)(tr,{src:r.closeIconUrl}):(0,ue.jsx)(Ro,{})})]}),(0,ue.jsxs)(Nr.Content,{className:"bundle-customize-content",children:[(0,ue.jsx)(Nr.List,{className:"bundle-list",children:t.map((N,V)=>(0,ue.jsxs)(Nr.Card,{className:"bundle-card",children:[(0,ue.jsx)(Mu,{config:r,fallbackUrl:a,state:N}),(0,ue.jsxs)(Nr.CardBody,{className:"bundle-card-body",children:[(0,ue.jsxs)("h3",{children:["Guard ",V+1]}),(0,ue.jsxs)(Nr.CardActions,{className:"bundle-card-actions",children:[(0,ue.jsx)("button",{type:"button",onClick:()=>P(V),children:"Customize bundle"}),w?(0,ue.jsx)(Nr.CardRemove,{type:"button",className:"bundle-card-remove","aria-label":`Remove Guard ${V+1}`,disabled:!(o!=null&&o.available),onClick:()=>Y(V),children:r.bundleTrashIconUrl?(0,ue.jsx)(tr,{src:r.bundleTrashIconUrl}):null}):null]})]})]},`guard-${V+1}`))}),e.length?(0,ue.jsxs)(Nr.Components,{className:"bundle-components",children:[(0,ue.jsx)("h3",{children:"Bundle items"}),(0,ue.jsx)(Nr.ComponentList,{className:"bundle-component-list",children:e.map(N=>(0,ue.jsxs)(Nr.Component,{className:"bundle-component",children:[(0,ue.jsx)(nh.Image,{className:"bundle-card-image",children:N.imageUrl?(0,ue.jsx)("img",{src:Xe(N.imageUrl),alt:"",loading:"lazy"}):null}),(0,ue.jsxs)(Nr.ComponentBody,{className:"bundle-component-body",children:[(0,ue.jsx)("h4",{children:N.title}),(0,ue.jsx)("p",{children:UA(N)})]}),N.removable&&h?(0,ue.jsx)(Nr.ComponentRemove,{type:"button",className:"bundle-component-remove","aria-label":`Remove ${N.title}`,onClick:()=>h(N.key),children:r.bundleTrashIconUrl?(0,ue.jsx)(tr,{src:r.bundleTrashIconUrl}):"Remove"}):null]},N.key))})]}):null,w&&(l!=null&&l.available)?(0,ue.jsxs)(Ko.Card,{className:"bundle-add-card",children:[(0,ue.jsxs)(Ko.Main,{className:"bundle-add-main",children:[(0,ue.jsx)(Mu,{config:r,fallbackUrl:a,state:t[t.length-1]||t[0]}),(0,ue.jsxs)(Ko.Copy,{className:"bundle-add-copy",children:[(0,ue.jsxs)("h3",{children:["Add ",L,(0,ue.jsx)("sup",{children:VT(L)})," guard"]}),(0,ue.jsxs)("p",{children:["Same scan. Same Fit."," ",(0,ue.jsx)("strong",{children:l.saveLabel})]}),X?(0,ue.jsx)("b",{children:X}):null]})]}),(0,ue.jsxs)(Ko.Actions,{className:"bundle-add-actions",children:[(0,ue.jsx)("button",{type:"button",onClick:d,children:"Add Identical Guard"}),(0,ue.jsx)("button",{type:"button",onClick:c,children:"Add Guard"})]})]}):null,(0,ue.jsx)(Rs.Status,{className:"bundle-modal-status",role:"status","aria-live":"polite",children:C}),(0,ue.jsx)(Nr.Done,{type:"button",className:"bundle-done",disabled:W,"aria-busy":W||void 0,onClick:g||m,children:W?"Saving...":"Done"})]})]})]}),i!==null&&t[i]?(0,ue.jsx)(Qo,{config:r,guardIndex:i,initialState:t[i],labels:s,previewImageUrl:IA(r,t[i],a),saving:W,savingLabel:"Saving...",externalStatus:C,thicknessGuideImageUrl:I,onCancel:u,onSave:N=>S(i,N)}):null,b!==null&&n&&o?(0,ue.jsx)(vc,{arrowIconUrl:r.bundleDowngradeArrowIconUrl,closeIconUrl:r.closeIconUrl,currentPackage:n,downgradedPackage:o,guardIconUrl:r.bundleGuardIconUrl,guardIndex:b,labels:s,saving:W,warningIconUrl:r.bundleWarningIconUrl,onCancel:p,onConfirm:y}):null]})}var VA=f.div`
  position: fixed;
  inset: 0;
  z-index: 2147483002;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);

  @media screen and (max-width: 749px) {
    align-items: center;
    justify-content: center;
    padding: calc(20px + env(safe-area-inset-top))
      calc(20px + env(safe-area-inset-right))
      calc(20px + env(safe-area-inset-bottom))
      calc(20px + env(safe-area-inset-left));
  }
`,kA=f.button`
  position: absolute;
  inset: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`,LA=f.section`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 422px;
  grid-template-rows: auto minmax(0, 1fr);
  grid-template-areas:
    "media header"
    "media content";
  width: min(100%, 1000px);
  max-height: calc(100dvh - 48px);
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 0 24px rgba(113, 113, 113, 0.25);

  @media screen and (max-width: 749px) {
    grid-template-rows: auto minmax(0, 1fr);
    grid-template-areas:
      "header"
      "content";
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
    max-height: calc(
      100dvh - 40px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    overflow: hidden;
    border-radius: 16px;
  }
`,XA=f.div`
  grid-area: header;
  display: flex;
  min-height: 32px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 38px 24px 0;

  & h2 {
    margin: 0;
    color: #111111;
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
  }

  @media screen and (max-width: 749px) {
    border-bottom: 1px solid #d9d9d9;
    padding: 24px;
    & h2 {
      font-size: 24px;
      line-height: 32px;
    }
    @media screen and (max-height: 640px) {
      padding: 20px 24px;
    }
  }
`,NA=f.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #111111;
  cursor: pointer;
  padding: 0;

  & img {
    display: block;
    width: 32px;
    height: 32px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: 2;
  }

  & svg {
    display: block;
    width: 32px;
    height: 32px;
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-width: 2;
  }
`,EA=f.div`
  position: relative;
  display: grid;
  grid-area: media;
  min-height: min(620px, calc(100dvh - 48px));
  place-items: center;
  background: #f7f7f7;
  padding: 40px;

  @media screen and (max-width: 749px) {
    display: none;
  }
`,AA=f.div`
  position: relative;
  width: min(100%, 500px);
  aspect-ratio: 1;

  & img {
    display: block;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none;
    object-fit: contain;
    user-select: none;
    -webkit-user-drag: none;
  }
`,RA=f.div`
  grid-area: content;
  display: flex;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  flex-direction: column;
  gap: 20px;
  padding: 24px;

  @media screen and (max-width: 749px) {
    gap: 24px;
    padding: 24px 20px;
    @media screen and (max-height: 640px) {
      gap: 16px;
      padding: 20px;
    }
  }
`,GA=f.button`
  flex-shrink: 0;
  min-height: 64px;
  width: 100%;
  margin-top: auto;
  border: 0;
  border-radius: 48px;
  background: #111111;
  color: #ffffff;
  cursor: pointer;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;

  @media screen and (max-width: 749px) {
    min-height: 40px;
    padding: 8px 20px;
    font-size: 16px;
    line-height: 20px;
  }
`,jo={Modal:VA,Scrim:kA,Panel:LA,Header:XA,Close:NA,Media:EA,HeroImage:AA,Content:RA,Skip:GA};var Er=T(k());function R0({title:e,config:t,state:r,fallbackUrl:n,price:o,saveLabel:i,onAdd:a}){return(0,Er.jsxs)(Ko.Card,{$variant:"modal",as:"article",className:"bundle-add-card bundle-add-card-modal","aria-label":e,children:[(0,Er.jsxs)(Ko.Main,{className:"bundle-add-main",children:[(0,Er.jsx)(Mu,{variant:"modal",config:t,state:r,fallbackUrl:n}),(0,Er.jsxs)(Ko.Copy,{className:"bundle-add-copy",children:[(0,Er.jsx)("h3",{children:e}),(0,Er.jsxs)("p",{children:["Same scan. Same Fit.",i?(0,Er.jsxs)(Er.Fragment,{children:[" ",(0,Er.jsx)("strong",{children:i})]}):null]}),(0,Er.jsx)("b",{children:o})]})]}),(0,Er.jsx)(Ko.Actions,{$variant:"modal",className:"bundle-add-actions",children:(0,Er.jsx)("button",{type:"button",onClick:a,children:e})})]})}var ur=T(k());function ZT({config:e,currentPackage:t,fallbackMediaUrl:r,nextPackage:n,onAddGuard:o,onAddIdenticalGuard:i,onClose:a,state:s}){var g,y,P,Y,h,S,b;if(!(n!=null&&n.available))return null;let l=xh(t,n),c=l?`+${l.replace(/^\+/,"")}`:"",d=((y=(g=e.currentProduct)==null?void 0:g.imageUrls)==null?void 0:y[0])||((P=e.currentProduct)==null?void 0:P.imageUrl)||((h=(Y=e.currentProduct)==null?void 0:Y.productImageUrls)==null?void 0:h[0])||r,u={...e,colors:(S=e.colors)==null?void 0:S.filter(W=>/^(white|clear|transparent|natural)$/i.test(String(W.value||W.label))),padColors:[]},p={...zo(u),padColor:"",initials:""},m="trufit-purchase-master-bundle-tier-upsell-title";return(0,ur.jsxs)(jo.Modal,{className:"bundle-upsell-modal",role:"dialog","aria-modal":"true","aria-labelledby":m,children:[(0,ur.jsx)(jo.Scrim,{type:"button",className:"bundle-upsell-scrim","aria-label":"Skip backup guard offer",onClick:a}),(0,ur.jsxs)(jo.Panel,{className:"bundle-upsell-panel",children:[(0,ur.jsxs)(jo.Header,{className:"bundle-upsell-header",children:[(0,ur.jsx)("h2",{id:m,children:"Want a backup?"}),(0,ur.jsx)(jo.Close,{type:"button",className:"bundle-upsell-close","aria-label":"Skip backup guard offer",onClick:a,children:e.closeIconUrl?(0,ur.jsx)(tr,{src:e.closeIconUrl}):(0,ur.jsx)(Ro,{})})]}),(0,ur.jsx)(jo.Media,{className:"bundle-upsell-media",children:(0,ur.jsx)(jo.HeroImage,{className:"bundle-upsell-hero-image",children:d?(0,ur.jsx)("img",{src:Xe(d,1e3),alt:((b=e.currentProduct)==null?void 0:b.title)||"Guard"}):null})}),(0,ur.jsxs)(jo.Content,{className:"bundle-upsell-content",children:[(0,ur.jsx)(R0,{title:"Add Identical Guard",config:e,state:s,fallbackUrl:r||d,price:c,saveLabel:n.saveLabel,onAdd:i}),(0,ur.jsx)(R0,{title:"Add Different Guard",config:u,state:p,fallbackUrl:e.bundleGuardIconUrl||d,price:c,saveLabel:n.saveLabel,onAdd:o}),(0,ur.jsx)(jo.Skip,{type:"button",className:"bundle-upsell-skip",onClick:a,children:"Skip"})]})]})]})}var _A=f.div`
  padding: 24px;

  & > p {
    max-width: 25rem;
    margin: 0;
    color: #666666;
    font-size: 1rem;
    line-height: 1.5;
  }
`,BA=f.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 24px;
`,ZA=f.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 3.5rem;
  width: 100%;
  border: 1px solid #cfcfcf;
  border-radius: 0.55rem;
  padding: 0.75rem 1rem;
  background: #ffffff;
  color: #111111;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25rem;
  text-align: left;
  transition: border-color 160ms ease, background-color 160ms ease;

  &:hover {
    border-color: #111111;
  }

  &:focus-visible {
    outline: 3px solid rgba(45, 138, 112, 0.32);
    outline-offset: 3px;
  }

  ${({$variant:e})=>e==="replace"&&v`
      border-color: #111111;
      background: #111111;
      color: #ffffff;

      &:hover {
        background: #2b2b2b;
      }
    `}

  & strong {
    font-size: 1rem;
    line-height: 1.2;
  }

  @media (max-width: 520px) {
    min-height: 52px;
    padding: 10px 12px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`,$A=f.span`
  border-radius: 999px;
  background: #d9f7e8;
  padding: 0.35rem 0.55rem;
  color: #23765f;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  white-space: nowrap;
`,wc={Body:_A,Actions:BA,Option:ZA,Discount:$A};var po=T(k());function wh({closeIconUrl:e,discountPercent:t,onAddNewCustomer:r,onClose:n,onReplace:o,open:i}){if(!i)return null;let a=Number.isFinite(t)?Math.max(0,Math.round(t)):0,s=a?`Add New Customer (${a}% Off)`:"Add New Customer";return(0,po.jsx)(Ia,{closeIconUrl:e,closeLabel:"Close bundle choice",descriptionId:"trufit-purchase-master-existing-bundle-copy",modalClassName:"existing-bundle-modal",variant:"existing-bundle",onClose:n,panelClassName:"existing-bundle-panel",title:"It looks like you already have a bundle in your cart.",titleId:"trufit-purchase-master-existing-bundle-title",children:(0,po.jsxs)(wc.Body,{className:"existing-bundle-body",children:[(0,po.jsx)("p",{id:"trufit-purchase-master-existing-bundle-copy",children:"Replace it or add a new customer."}),(0,po.jsxs)(wc.Actions,{className:"close-confirm-actions existing-bundle-actions",children:[(0,po.jsx)(wc.Option,{$variant:"replace",type:"button",className:"existing-bundle-option existing-bundle-option-replace","aria-label":"Replace",onClick:o,children:(0,po.jsx)("strong",{children:"Replace"})}),(0,po.jsxs)(wc.Option,{$variant:"new-customer",type:"button",className:"existing-bundle-option existing-bundle-option-new-customer","aria-label":s,onClick:r,children:[(0,po.jsx)("strong",{children:"Add New Customer"}),a?(0,po.jsxs)(wc.Discount,{className:"existing-bundle-discount",children:[a,"% off"]}):null]})]})]})})}var qo=T(k());function Th({labels:e,config:t,selectRequest:r,onCloseSelect:n,bundleCustomizeOpen:o,bundleStates:i,currentBundlePackage:a,downgradedBundlePackage:s,editingGuardIndex:l,fallbackMediaUrl:c,thicknessGuideImageUrl:d,standaloneGuardState:u,nextBundlePackage:p,onAddBundleGuard:m,onAddIdenticalBundleGuard:g,onCancelBundleGuard:y,onCancelBundleGuardRemoval:P,onCloseBundleCustomize:Y,onConfirmBundleGuardRemoval:h,onEditBundleGuard:S,onRemoveBundleGuard:b,onSaveBundleGuard:W,removingGuardIndex:C,processing:w,standaloneGuardEditOpen:I,bundleQuantity:U,onCancelStandaloneGuard:L,onSaveStandaloneGuard:X,bundleTierUpsellOpen:N,onDismissBundleTierUpsell:V,identicalGuardState:z,existingBundleDiscountPercent:te,onAddNewCustomerFromExistingBundle:H,onCloseExistingBundleChoice:E,onReplaceExistingBundle:Z,existingBundleChoiceOpen:ce}){return(0,qo.jsxs)(qo.Fragment,{children:[(0,qo.jsx)(UT,{closeLabel:e.closeLabel,closeIconUrl:t.closeIconUrl,request:r,onClose:n}),o?(0,qo.jsx)(vh,{bundleStates:i,config:t,currentPackage:a,downgradedPackage:s,editingGuardIndex:l,fallbackMediaUrl:c,thicknessGuideImageUrl:d,labels:e,nextPackage:u?null:p,onAddGuard:m,onAddIdenticalGuard:g,onCancelEdit:y,onCancelRemove:P,onClose:Y,onConfirmRemove:h,onEdit:S,onRemove:b,onSave:W,removingGuardIndex:C,saving:w}):null,I&&u?(0,qo.jsx)(Qo,{config:t,guardIndex:Math.max(0,U-1),initialState:u,labels:e,previewImageUrl:c,thicknessGuideImageUrl:d,onCancel:L,onSave:X}):null,N?(0,qo.jsx)(ZT,{config:t,currentPackage:a,fallbackMediaUrl:c,nextPackage:p,onAddGuard:m,onAddIdenticalGuard:g,onClose:V,state:z}):null,(0,qo.jsx)(wh,{closeIconUrl:t.closeIconUrl,discountPercent:te,onAddNewCustomer:H,onClose:E,onReplace:Z,open:ce})]})}var OA=f.p`
  min-height: 0;
  margin: 0 1.5rem;
  padding: 0;
  color: #a21616;
  font-size: 0.8125rem;
  font-weight: 700;
  &:empty {
    display: none;
  }
  ${({$sticky:e})=>e&&v`
      margin: 0;
      padding: 0;
    `}
  ${({$view:e})=>e==="clinicMap"&&v`
      display: none;
    `}
@media screen and (max-width: 749px) {
    min-height: 0;
    margin: ${({$sticky:e})=>e?"0":"0 20px"};
    padding: 0;
    font-size: 12px;
    line-height: 16px;
  }
`,FA=f.p`
  margin: 0 1.5rem;
  color: #a21616;
  font-size: 0.8125rem;
  font-weight: 700;
  text-align: center;
  ${({$sticky:e})=>e&&v`
      padding: 0;
      margin: 0;
    `}
`,DA=f.div`
  display: grid;
  flex: 0 0 auto;
  gap: 0.75rem;
  box-sizing: border-box;
  margin: 0 1.5rem;
  margin-top: auto;
  padding: 0;
  ${({$sticky:e})=>e&&v`
      flex-basis: auto;
      width: 100%;
      box-sizing: border-box;
      gap: 12px;
      margin: 0;
      padding: 0;
      box-shadow: none;
    `}
  ${({$stepKey:e})=>e==="clinicScan"&&v`
      display: none;
    `}
${({$view:e})=>e==="clinicMap"&&v`
      display: none;
    `}
@media screen and (max-width: 749px) {
    flex: 0 0 auto;
    gap: 12px;
    margin: 0;
    padding: 0;
    ${({$sticky:e})=>e&&v`
        flex-basis: auto;
        gap: 12px;
        padding: 0;
      `}
  }
`,zA=f.div`
  order: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  box-sizing: border-box;
  height: 48px;
  min-height: 48px;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 20px;
  & span {
    color: #111111;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & strong {
    color: #111111;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  @media screen and (min-width: 750px) {
    ${({$sticky:e})=>e&&v`
        display: flex;
      `}
  }
  @media screen and (max-width: 749px) {
    display: none;
    height: 48px;
    min-height: 48px;
    padding: 12px 20px;
  }
`,KA=f.div`
  display: none;

  @media screen and (max-width: 749px) {
    display: block;
  }
`,HA=f.div`
  display: grid;
  gap: 0.75rem;
  margin: 0;
  ${({$sticky:e})=>e&&v`
      margin: 0;
      padding: 0;
    `}
  @media screen and (max-width: 749px) {
    ${({$placement:e})=>e==="content"&&v`
        display: grid;
      `}
    ${({$placement:e})=>e==="sticky"&&v`
        display: none;
      `}
${({$stepKey:e,$placement:t})=>e!=="upsell"&&t==="content"&&v`
        align-self: stretch;
        margin-top: 0;
        padding-top: 0;
        background: transparent;
      `}
  }
`,QA=f.div`
  display: none;
  @media screen and (max-width: 749px) {
    display: block;
    ${({$stepKey:e})=>e==="upsell"&&v`
        order: -1;
      `}
  }
`,jA=f.div`
  display: contents;

  @media screen and (max-width: 749px) {
    display: none;
  }
`,Gn={Status:OA,ImpressionKitRequired:FA,Bottom:DA,Subtotal:zA,StepPromotionMobileOnly:KA,StepPromotions:HA,UpsellContentActions:QA,UpsellStickyActions:jA};var qA=f.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  margin-top: auto;
  box-sizing: border-box;
  padding: 12px 24px;
  background: #ffffff;
  ${({$scrollSeparated:e})=>e&&v`
      box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
    `}
  @media screen and (min-width: 750px) {
    ${({$stepKey:e})=>e==="upsell"&&v`
        margin-top: calc(-1 * var(--purchase-master-panel-gap));
      `}
  }
  @media screen and (max-width: 749px) {
    position: relative;
    z-index: 4;
    flex: 0 0 auto;
    margin-top: 0;
    gap: 12px;
    box-sizing: border-box;
    padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
    background: #ffffff;
    ${({$scrollSeparated:e})=>e&&v`
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
      `}
  }
`,$T={Summary:qA};var FT=T(k());function OT({actions:e,hasScrollableContent:t,impressionKitNotice:r,promotions:n,status:o,stickyActions:i}){let a=Oe();return(0,FT.jsxs)($T.Summary,{$scrollSeparated:t,$stepKey:a.stepKey,className:"purchase-master-sticky-summary",children:[i,n,r,o,e]})}var _n=T(k());function DT({addDisabled:e,iconUrl:t,labels:r,processing:n,totalPrice:o,sticky:i,isLastStep:a,lastStepLabel:s}){let l=Oe();return(0,_n.jsxs)(Gn.Bottom,{$sticky:i,$stepKey:l.stepKey,$view:l.view,className:"purchase-master-bottom",children:[(0,_n.jsxs)(Gn.Subtotal,{$sticky:i,className:"purchase-master-subtotal",children:[(0,_n.jsx)("span",{children:r.priceLabel}),(0,_n.jsx)("strong",{children:o})]}),(0,_n.jsxs)(Ls.Button,{$variant:"primary",$sticky:i,type:"submit",className:"purchase-master-button purchase-master-button-primary",hidden:a||e,disabled:n,"aria-busy":n||void 0,children:[(0,_n.jsx)("span",{children:r.continueLabel}),(0,_n.jsx)(Zy,{iconUrl:t})]}),(0,_n.jsxs)(Ls.Button,{$variant:"primary",$sticky:i,type:"submit",className:"purchase-master-button purchase-master-button-primary",hidden:!a,disabled:e||n,"aria-busy":n||void 0,children:[(0,_n.jsx)("span",{children:n?r.processingLabel:s}),(0,_n.jsx)(Zy,{iconUrl:t})]})]})}var Ei=T(k());function Bu({config:e,context:t,step:r,placement:n,showNewCustomerActions:o}){if((r==null?void 0:r.key)==="upsell")return o?n==="content"?(0,Ei.jsx)(Gn.UpsellContentActions,{$stepKey:r==null?void 0:r.key,className:"upsell-content-actions",children:(0,Ei.jsx)(m0,{placement:n,context:t})}):(0,Ei.jsx)(Gn.UpsellStickyActions,{className:"upsell-sticky-actions",children:(0,Ei.jsx)(m0,{placement:n,context:t})}):null;if(!r||!rt(e,r.key).length)return null;let i=(0,Ei.jsx)(Rw,{context:t,step:r.key});return n==="content"?(0,Ei.jsx)(Gn.StepPromotions,{$sticky:!1,$placement:n,$stepKey:r==null?void 0:r.key,className:"step-promotions step-promotions-content",children:(0,Ei.jsx)(Gn.StepPromotionMobileOnly,{className:"step-promotion-mobile-only",children:i})}):(0,Ei.jsx)(Gn.StepPromotions,{$sticky:!0,$placement:n,$stepKey:r==null?void 0:r.key,className:"step-promotions step-promotions-sticky",children:i})}var mo=T(k());function zT({addDisabled:e,config:t,context:r,currentStepIndex:n,iconUrl:o,labels:i,processing:a,status:s,steps:l,totalPrice:c,activeStep:d,hasInlineFieldError:u,hasScrollableContent:p,showNewCustomerActions:m,statusId:g}){var X,N;let y=Oe(),P=(d==null?void 0:d.key)==="upsell",Y=Boolean(d),h=Boolean(d&&!P&&rt(t,d.key).length),S=l.length>0&&n===l.length-1,b=P?"Go to Cart":i.addLabel,W=u?null:(0,mo.jsx)(Gn.Status,{$sticky:Y,$view:y.view,className:"purchase-master-status",id:g,role:"status","aria-live":"polite",children:s}),C=t.bundleImpressionKitProduct||t.impressionKitProduct,w=String(r.impressionKitPrice||((X=t.pricingPalette)==null?void 0:X.impressionKitPrice)||(C==null?void 0:C.variantPrice)||"").trim(),U=(((N=t.positions)==null?void 0:N.length)||0)>1&&((d==null?void 0:d.key)==="position"||(d==null?void 0:d.key)==="customization")&&r.isReturnCustomerFlow&&!r.isImpressionKitUpdateFlow&&!r.shouldReuseImpressionKit?(0,mo.jsxs)(Gn.ImpressionKitRequired,{$sticky:Y,className:"impression-kit-required",role:"note",children:[i.impressionKitRequiredLabel||"Requires Impression Kit",w?` +${w.replace(/^\+/,"")}`:""]}):null,L=(0,mo.jsx)(DT,{sticky:Y,addDisabled:e,iconUrl:o,labels:i,processing:a,totalPrice:c,isLastStep:S,lastStepLabel:b});return Y?(0,mo.jsx)(OT,{actions:L,hasScrollableContent:p,impressionKitNotice:U,promotions:h?(0,mo.jsx)(Bu,{config:t,context:r,step:d,placement:"sticky",showNewCustomerActions:m}):null,status:W,stickyActions:P&&m?(0,mo.jsx)(Bu,{config:t,context:r,step:d,placement:"sticky",showNewCustomerActions:m}):null}):P?null:(0,mo.jsxs)(mo.Fragment,{children:[U,W,L]})}var Wn=T(k());function KT({config:e,currentStepIndex:t,labels:r,onBack:n,onClose:o,steps:i,totalPrice:a}){let s=Oe(),l=r.priceLabel.endsWith(":")?r.priceLabel:`${r.priceLabel}:`;return(0,Wn.jsxs)(Pn.Topbar,{$view:s.view,className:"purchase-master-topbar",children:[(0,Wn.jsx)(Pn.NavButton,{$visible:t>0,type:"button",className:"purchase-master-nav-button","aria-label":r.backLabel,onClick:n,children:e.backIconUrl?(0,Wn.jsx)(tr,{src:e.backIconUrl}):(0,Wn.jsx)(Fv,{})}),(0,Wn.jsx)(yh,{currentStepIndex:t,label:r.progressLabel,mobile:!0,steps:i}),(0,Wn.jsxs)(Pn.MobileTotal,{className:"purchase-master-mobile-total",children:[(0,Wn.jsx)("span",{children:l}),(0,Wn.jsx)("strong",{children:a})]}),(0,Wn.jsx)(Pn.Close,{type:"button",className:"purchase-master-close","aria-label":r.closeLabel,onClick:o,children:e.closeIconUrl?(0,Wn.jsx)(tr,{src:e.closeIconUrl}):(0,Wn.jsx)(Ro,{})})]})}var $t=T(k()),QT=(0,HT.forwardRef)(function(t,r){let{bundleQuantity:n,config:o,context:i,currentStepIndex:a,fallbackMediaAlt:s,fallbackMediaUrl:l,labels:c,modalId:d,onBack:u,onClose:p,onCustomizeBundle:m,onSubmit:g,open:y,showNewCustomerActions:P=!0,state:Y,status:h,steps:S,thicknessGuideImageUrl:b,totalPrice:W}=t,C=S[a],w=C==null?void 0:C.Component,I=`${d}Title`,U=`${d}Status`,L=Object.values(i.fieldErrors).some(Boolean),X=((C==null?void 0:C.guardIndex)||0)+1,N=(C==null?void 0:C.guardIndex)!==void 0,{contentRef:V,hasScrollableContent:z}=wT({activeStep:C,activeSubview:i.activeSubview,currentStepIndex:a,open:y,status:h}),te=TT({config:o,open:y,stepKey:C==null?void 0:C.key,upsellMediaIndex:Y.upsellMediaIndex,setState:i.setState}),H={alt:s||o.productAlias||"",config:o,customizeBundleLabel:"Customize Bundle",fallbackUrl:l,guardLabel:`Guard ${X} of ${n}`,onCustomizeBundle:m,onSelectUpsellAccessory:te,showCustomizeBundle:n>1&&N,showGuardLabel:n>1&&N,state:i.state,step:C};return(0,$t.jsx)(Mn,{stepKey:C==null?void 0:C.key,view:i.activeSubview||"",children:(0,$t.jsx)(Pn.Modal,{className:"purchase-master","data-purchase-master-modal":!0,"data-purchase-master-step":C==null?void 0:C.key,"data-purchase-master-view":i.activeSubview||void 0,id:d,role:"dialog","aria-modal":"true","aria-labelledby":I,hidden:!y,$guideImageUrl:b,children:(0,$t.jsxs)(Pn.Layout,{className:"purchase-master-layout",tabIndex:-1,ref:r,children:[(0,$t.jsx)(E0,{...H}),(0,$t.jsxs)(Pn.Panel,{className:"purchase-master-panel",noValidate:!0,"aria-describedby":h&&!L?U:void 0,onSubmit:g,children:[(0,$t.jsx)(yh,{currentStepIndex:a,label:c.progressLabel,steps:S}),(0,$t.jsx)(KT,{config:o,currentStepIndex:a,labels:c,onBack:u,onClose:p,steps:S,totalPrice:W}),(0,$t.jsxs)(Pn.Content,{$stepKey:C==null?void 0:C.key,$view:i.activeSubview,className:"purchase-master-content",ref:V,children:[(0,$t.jsx)(Pn.MobileMedia,{$view:i.activeSubview,$stepKey:C==null?void 0:C.key,className:"purchase-master-mobile-media",children:(0,$t.jsx)(E0,{...H,mobile:!0})}),(0,$t.jsx)("h2",{id:I,children:(C==null?void 0:C.title)||""}),(0,$t.jsx)(Pn.StepText,{$view:i.activeSubview,className:"step-text",hidden:!(C!=null&&C.text),children:(C==null?void 0:C.text)||""}),w?C.key==="review"?(0,$t.jsx)(w,{context:i}):(0,$t.jsx)(Pn.Form,{$stepKey:C==null?void 0:C.key,$view:i.activeSubview,className:"purchase-master-form",children:(0,$t.jsx)(w,{context:i})}):null,(0,$t.jsx)(Bu,{config:o,context:i,step:C,placement:"content",showNewCustomerActions:P})]}),(0,$t.jsx)(zT,{addDisabled:t.addDisabled,config:o,context:i,currentStepIndex:a,iconUrl:t.iconUrl,labels:c,processing:t.processing,status:h,steps:S,totalPrice:W,activeStep:C,hasInlineFieldError:L,hasScrollableContent:z,showNewCustomerActions:P,statusId:U})]}),(0,$t.jsx)(Th,{...t})]})})})});var Mh=T(oe());var vn=T(k());function jT({closeLabel:e,open:t,onCancel:r,onConfirm:n}){let o=(0,Mh.useRef)(null),i="PurchaseMasterCloseConfirmTitle",a="PurchaseMasterCloseConfirmMessage";return(0,Mh.useEffect)(()=>{t&&window.setTimeout(()=>{var s;(s=o.current)==null||s.focus()},0)},[t]),t?(0,vn.jsxs)(hc,{className:"close-confirm-modal",role:"alertdialog","aria-modal":"true","aria-labelledby":i,"aria-describedby":a,style:{zIndex:2147483006},children:[(0,vn.jsx)(gc,{type:"button",className:"close-confirm-scrim","aria-label":e,onClick:r}),(0,vn.jsxs)(Yc,{className:"close-confirm-panel",$width:500,children:[(0,vn.jsxs)("div",{className:"pp-hd",children:[(0,vn.jsxs)("div",{children:[(0,vn.jsx)("h2",{id:i,children:x("Leave without adding to cart?")}),(0,vn.jsx)("p",{id:a,children:x("Your guard isn't in your cart yet.")})]}),(0,vn.jsx)("button",{type:"button",className:"pp-x close-confirm-close","aria-label":e,onClick:r,children:"\xD7"})]}),(0,vn.jsxs)("div",{className:"pp-btns close-confirm-actions",children:[(0,vn.jsx)("button",{type:"button",className:"pp-btn is-primary",ref:o,onClick:r,children:x("Keep customizing")}),(0,vn.jsx)("button",{type:"button",className:"pp-btn",onClick:n,children:x("Leave")})]})]})]}):null}var JA=f.div`
  padding: 24px;

  & > p {
    max-width: 25rem;
    margin: 0;
    color: #666666;
    font-size: 1rem;
    line-height: 1.5;
  }
`,eR=f.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 24px;
`,tR=f.a`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3.5rem;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cfcfcf;
  border-radius: 0.55rem;
  padding: 0.75rem 1rem;
  color: #111111;
  font: inherit;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  transition: border-color 160ms ease, background-color 160ms ease;
  cursor: pointer;
  &:hover {
    border-color: #111111;
  }
  &:focus-visible {
    outline: 3px solid rgba(45, 138, 112, 0.32);
    outline-offset: 3px;
  }
  ${({$variant:e})=>e==="dashboard"&&v`
      border-color: #111111;
      background: #111111;
      color: #ffffff;

      &:hover {
        background: #2b2b2b;
      }
    `}
  ${({$variant:e})=>e==="add-person"&&v`
      background: #ffffff;
    `}
@media (max-width: 520px) {
    min-height: 52px;
    padding: 10px 12px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`,Zu={Body:JA,Actions:eR,Option:tR};var Uh=T(oe());var Ea=T(k());function qT({closeIconUrl:e,dashboardUrl:t,onAddNewPerson:r,onClose:n,open:o}){let i=(0,Uh.useRef)(null);return(0,Uh.useEffect)(()=>{o&&window.setTimeout(()=>{var a,s;(s=(a=i.current)==null?void 0:a.querySelector("a, button"))==null||s.focus()},0)},[o]),o?(0,Ea.jsx)(Ia,{variant:"returning-customer",closeIconUrl:e,closeLabel:"Close returning customer options",descriptionId:"trufit-purchase-master-returning-customer-copy",modalClassName:"returning-customer-modal",onClose:n,panelClassName:"returning-customer-panel",ref:i,title:"It looks like you're a returning customer?",titleId:"trufit-purchase-master-returning-customer-title",children:(0,Ea.jsxs)(Zu.Body,{className:"returning-customer-body",children:[(0,Ea.jsx)("p",{id:"trufit-purchase-master-returning-customer-copy",children:"Choose where you would like to continue."}),(0,Ea.jsxs)(Zu.Actions,{className:"returning-customer-actions",children:[(0,Ea.jsx)(Zu.Option,{$variant:"dashboard",className:"returning-customer-option returning-customer-option-dashboard",href:t,children:"Return Customers Dashboard"}),(0,Ea.jsx)(Zu.Option,{$variant:"add-person",as:"button",type:"button",className:"returning-customer-option returning-customer-option-add-person",onClick:r,children:"Add New Person"})]})]})}):null}var rR="trufit_customer_name";function JT(e){let t=`${rR}=`,r=e.split(";").map(n=>n.trim()).find(n=>n.startsWith(t));if(!r)return!1;try{return decodeURIComponent(r.slice(t.length)).trim().length>0}catch(n){return!1}}var Jo=T(oe());var eM=f.div`
  &[hidden] {
    display: none;
  }

  position: fixed;
  inset: 0;
  z-index: 2147483000;
  background: #ffffff;
  color: #111111;
  font-family: inherit;
  isolation: isolate;
  -webkit-font-smoothing: antialiased;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* Only the customizer's own screens; pop-ups keep their own styling. */
  :where(.v3-layout) button {
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  .v3-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 460px;
    height: 100%;
    height: 100dvh;
    outline: none;
  }

  .v3-side {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 32px;
    background: #ffffff;
    min-width: 0;
    overflow: hidden;
  }

  /* Desktop: as big as the left side allows (width, or 82% of screen height). */
  .v3-side-preview {
    position: relative;
    width: min(100%, calc(82vh * 630 / 430), 1400px);
    aspect-ratio: 630 / 430;
  }

  .v3-side-img {
    display: block;
    width: min(100%, 1400px);
    max-height: 88vh;
    object-fit: contain;
  }

  .v3-panel {
    min-width: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    border-left: 1px solid #eeeeee;
    background: #ffffff;
  }

  .v3-top {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 8px;
    border-bottom: 1px solid #eeeeee;
  }

  .v3-icon-btn {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    border: 0;
    background: none;
    font-size: 26px;
    line-height: 1;
  }

  .v3-icon-spacer {
    width: 44px;
  }

  .v3-title {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
  }

  .v3-prog {
    flex: none;
    display: grid;
    gap: 6px;
    padding: 8px 20px 0;
  }

  .v3-prog-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #9a9a9a;
  }

  .v3-prog-item i {
    display: block;
    height: 4px;
    border-radius: 4px;
    background: #e6e6e6;
  }

  .v3-prog-item.is-on {
    color: #111111;
  }

  .v3-prog-item.is-on i {
    background: #111111;
  }

  .v3-main > * {
    min-width: 0;
  }

  .v3-main {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 20px;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .v3-panel-desktop .v3-main {
    padding: 12px 28px 10px;
    gap: 12px;
  }

  .v3-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .v3-lbl {
    margin: 0 0 4px;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 14px;
    font-weight: 700;
  }

  .v3-lbl span {
    margin-left: 6px;
    font-weight: 500;
    color: #505050;
    font-size: 13px;
  }

  .v3-seg {
    display: grid;
    gap: 8px;
  }

  .v3-seg button {
    white-space: nowrap;
    height: 40px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    background: #ffffff;
    font-size: 14px;
    font-weight: 600;
    color: #111111;
    padding: 0 6px;
  }

  .v3-seg button.is-on {
    border: 2px solid #111111;
    background: #111111;
    color: #ffffff;
  }

  .v3-seg button:disabled {
    opacity: 0.55;
    cursor: default;
  }

  /* Whitening gel: Clinical / Lite buttons in the Review step offer. */
  .v3-gel-seg {
    display: inline-flex;
    gap: 4px;
    margin-right: 6px;
    vertical-align: middle;
  }

  .v3-gel-seg button {
    height: 28px;
    padding: 0 10px;
    border: 1.5px solid #cfcfcf;
    border-radius: 999px;
    background: #ffffff;
    font-size: 12px;
    font-weight: 600;
    color: #111111;
    cursor: pointer;
  }

  .v3-gel-seg button.is-on {
    border-color: #111111;
    background: #111111;
    color: #ffffff;
  }

  .v3-preview {
    position: relative;
    flex: none;
    border: 1px solid #ececef;
    border-radius: 16px;
    background: #ffffff;
    overflow: hidden;
  }

  /* Phones: the design preview grows into any free space on the screen
     (never smaller than before, capped so it stays a preview). */
  .v3-preview.is-grow {
    flex: 1 1 auto;
    max-height: 360px;
  }

  /* Review: only uses space that's left over, so it never adds scrolling;
     hidden when there's too little room to be useful. */
  .v3-preview.is-review {
    flex: 1 1 0;
    min-height: 0;
    max-height: 260px;
  }

  @media screen and (min-width: 900px) {
    .v3-preview.is-review {
      display: none;
    }
  }

  /* Phones: the name pop-up opens from the top so the keyboard can't cover
     it, with big, easy-to-tap name boxes. */
  @media screen and (max-width: 899px) {
    .v3-sheet.is-name {
      top: 0;
      bottom: auto;
      border-radius: 0 0 22px 22px;
      padding-top: max(16px, env(safe-area-inset-top));
      padding-bottom: 20px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
    }

    .v3-sheet.is-name .v3-field input.v3-in {
      box-sizing: border-box;
      height: 54px;
      min-height: 54px;
      padding: 0 16px;
      border: 1.5px solid #cfcfcf;
      border-radius: 12px;
      background: #ffffff;
      font-size: 17px;
      line-height: normal;
    }

    .v3-sheet.is-name .v3-field input.v3-in:focus {
      border-color: #111111;
      outline: none;
    }

    .v3-sheet.is-name .v3-cta {
      height: 54px;
    }
  }

  .v3-preview-layers {
    position: absolute;
    inset: 2px;
  }

  .v3-preview-layers img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(1.32);
  }

  /* Desktop preview: a touch smaller than the full side so the photo stays crisp. */
  .v3-side-preview .v3-preview-layers img {
    transform: scale(1.22);
  }

  /* Long sport names wrap onto a second line instead of being cut off. */
  /* "Add another product" (same impression): one card, product boxes. */
  .v3-xsell {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 12px 12px;
    border: 1.5px solid #111111;
    border-radius: 14px;
    background: #ffffff;
  }

  .v3-xsell-head b {
    display: block;
    font-size: 14.5px;
  }

  .v3-xsell-head small {
    font-size: 12.5px;
    color: #505050;
  }

  .v3-xsell-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }

  .v3-xsell-opt {
    display: grid;
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 6px;
    align-items: center;
    min-height: 44px;
    padding: 4px 8px 4px 4px;
    border: 1.5px solid #e2e2e2;
    border-radius: 10px;
    background: #ffffff;
    color: #111111;
    text-align: left;
    cursor: pointer;
  }

  .v3-xsell-opt img {
    width: 34px;
    height: 34px;
    object-fit: contain;
  }

  .v3-xsell-opt b {
    display: block;
    overflow: hidden;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .v3-xsell-opt small {
    font-size: 12px;
    font-weight: 700;
    color: #1b7f3b;
  }

  .v3-xsell-opt.is-on {
    border-color: #111111;
    background: #111111;
    color: #ffffff;
  }

  .v3-xsell-opt.is-on small {
    color: #b9f0c9;
  }

  /* Short phones (e.g. iPhone SE): the four products as one compact row so
     the Review screen fits without scrolling. */
  @media screen and (max-width: 899px) and (max-height: 720px) {
    .v3-xsell {
      gap: 6px;
      padding: 8px 10px 10px;
    }

    .v3-xsell-grid {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 5px;
    }

    .v3-xsell-opt {
      grid-template-columns: minmax(0, 1fr);
      min-height: 0;
      padding: 5px 4px;
      text-align: center;
    }

    .v3-xsell-opt > img,
    .v3-xsell-opt > span:first-child:empty {
      display: none;
    }

    .v3-xsell-opt b {
      font-size: 11.5px;
      line-height: 1.15;
      white-space: normal;
    }

    .v3-xsell-opt small {
      font-size: 11.5px;
    }
  }

  /* Very short phones: slightly tighter spacing so longer French/Spanish text still fits. */
  @media screen and (max-width: 899px) and (max-height: 720px) {
    .v3-main {
      gap: 7px;
      padding-top: 5px;
    }

    .v3-mini {
      padding-top: 6px;
      padding-bottom: 6px;
    }

    .v3-ln {
      padding: 5px 0;
    }
  }

  /* Trash icon on guard 2/3 rows. */
  .v3-guard-del {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-left: 2px;
    padding: 0;
    border: 1.5px solid #e5b4b4;
    border-radius: 50%;
    background: #ffffff;
    color: #b42318;
    cursor: pointer;
    flex: none;
  }

  .v3-guard-del svg {
    width: 15px;
    height: 15px;
  }

  /* Review lines: keep the short label on one line; the value wraps instead. */
  .v3-ln > span:first-child {
    flex: none;
    white-space: nowrap;
  }

  .v3-pill.is-fit {
    min-width: 0;
    max-width: 100%;
    height: auto;
    min-height: 22px;
    padding-top: 2px;
    padding-bottom: 2px;
    white-space: normal;
    line-height: 1.25;
    text-align: right;
  }

  .v3-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 22px;
    padding: 0 9px;
    border-radius: 999px;
    background: #e8f5ec;
    color: #1b7f3b;
    font-size: 11.5px;
    font-weight: 700;
    white-space: nowrap;
  }

  .v3-pill.is-neutral {
    background: #ffffff;
    color: #111111;
  }

  .v3-pill.is-blue {
    background: #eef2ff;
    color: #1e3a8a;
  }

  .v3-pill.is-blue-dark {
    background: #dbe4ff;
    color: #172554;
  }

  .v3-preview .v3-pill {
    position: absolute;
    left: 10px;
    top: 8px;
    z-index: 3;
  }

  .v3-sws {
    display: flex;
    justify-content: space-between;
    margin: 0 -4px;
  }

  .v3-sw {
    position: relative;
    width: 40px;
    height: 40px;
    border: 0;
    background: none;
    padding: 6px;
    border-radius: 50%;
    overflow: visible;
  }

  .v3-sw > span {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
  }

  .v3-sw.is-on > span {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #111111;
  }

  .v3-sw .v3-tick {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 16px;
    height: 16px;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  .v3-sw .v3-tip {
    display: none;
  }

  @media (hover: hover) and (pointer: fine) {
    .v3-sw:hover:not(.is-on) > span {
      box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #c9c9c9;
    }

    .v3-sw:hover .v3-tip,
    .v3-sw:focus-visible .v3-tip {
      display: block;
      position: absolute;
      left: 50%;
      bottom: calc(100% - 2px);
      transform: translateX(-50%);
      width: max-content;
      padding: 3px 9px;
      border-radius: 6px;
      background: #111111;
      color: #ffffff;
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      font-style: normal;
      white-space: nowrap;
      z-index: 5;
      pointer-events: none;
    }
  }

  .v3-set {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 44px;
    padding: 4px 10px;
    border: 1.5px solid #e2e2e2;
    border-radius: 12px;
    font-size: 13.5px;
    min-width: 0;
  }

  .v3-set.is-button {
    width: 100%;
    background: #ffffff;
    color: #111111;
    font: inherit;
    font-size: 13.5px;
    text-align: left;
    cursor: pointer;
  }

  .v3-set.is-button:hover {
    border-color: #111111;
  }

  .v3-chg {
    border: 0;
    background: none;
    font-size: 13.5px;
    font-weight: 700;
    color: #111111;
    text-decoration: underline;
    text-underline-offset: 3px;
    padding: 0 2px;
    white-space: nowrap;
  }

  .v3-fit {
    display: flex;
    gap: 8px;
    align-items: stretch;
  }

  .v3-fit .v3-seg {
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    flex: none;
    width: 132px;
  }

  .v3-fit .v3-seg button {
    height: 44px;
    font-size: 13.5px;
  }

  .v3-fit .v3-set {
    flex: 1;
    min-width: 0;
  }

  .v3-ellipsis {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .v3-in {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    font-size: 16px;
    color: #111111;
    flex: 1;
    min-width: 0;
    background: #ffffff;
  }

  .v3-in::placeholder {
    color: #8a8a8a;
  }

  .v3-in[aria-invalid="true"] {
    border-color: #c62828;
  }

  .v3-idtag-img {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    flex: none;
  }

  .v3-guard-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 10px;
    border-radius: 12px;
    background: #f5f5f7;
  }

  .v3-guard-row-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }

  .v3-guard-row-info > span:last-child {
    min-width: 0;
    overflow: hidden;
  }

  .v3-guard-row-info b {
    display: block;
    white-space: nowrap;
  }

  .v3-guard-thumb {
    position: relative;
    width: 42px;
    height: 28px;
    flex: none;
  }

  .v3-guard-thumb img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(1.5);
  }

  .v3-guard-row small {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #505050;
    font-size: 11px;
    line-height: 1.2;
    overflow: hidden;
  }

  @media (max-width: 420px) {
    .v3-guard-row-info {
      gap: 6px;
      font-size: 12px;
    }

    .v3-guard-row .v3-dots {
      gap: 2px;
    }

    .v3-guard-row .v3-dot {
      width: 24px;
      height: 24px;
    }
  }

  .v3-dots {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: none;
  }

  .v3-dot {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 2px solid transparent;
    padding: 2px;
    background: none;
  }

  .v3-dot span {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.18);
  }

  .v3-dot.is-on {
    border-color: #111111;
  }

  .v3-addb {
    height: 32px;
    padding: 0 14px;
    border: 1.5px solid #111111;
    border-radius: 999px;
    background: #ffffff;
    font-size: 13px;
    font-weight: 700;
    color: #111111;
    white-space: nowrap;
  }

  .v3-addb.is-solid,
  .v3-addb.is-added {
    background: #111111;
    color: #ffffff;
  }

  .v3-addb:disabled {
    opacity: 0.6;
    cursor: default;
  }

  .v3-mini {
    display: grid;
    grid-template-columns: 62px 1fr auto;
    gap: 10px;
    align-items: center;
    padding: 4px 10px 4px 6px;
    border: 1px solid #e6e6e6;
    border-radius: 12px;
  }

  .v3-mini.is-strong {
    border: 2px solid #111111;
  }

  .v3-mini.is-dashed {
    border-style: dashed;
  }

  .v3-mini-img {
    position: relative;
    width: 62px;
    height: 52px;
  }

  .v3-mini-img img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    mix-blend-mode: multiply;
  }

  .v3-mini b {
    display: block;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }

  .v3-mini small {
    display: block;
    font-size: 12px;
    color: #505050;
    margin-top: 2px;
  }

  .v3-mini > div {
    min-width: 0;
  }

  .v3-mini .v3-addb {
    padding: 0 12px;
  }

  .v3-review .v3-mini {
    grid-template-columns: 72px 1fr auto;
  }

  .v3-review .v3-mini-img {
    width: 72px;
    height: 60px;
  }

  .v3-sv {
    color: #1b7f3b;
    font-weight: 700;
  }

  /* Kit step: "Your kit includes four attempts." box under the title. */
  .v3-kitbox {
    position: relative;
    margin-top: 8px;
    padding: 10px 14px;
    border-radius: 12px;
    background: #f5f5f7;
    color: #111111;
    font-size: 13.5px;
    line-height: 1.4;
  }

  .v3-kitbox b {
    display: block;
  }

  @media (max-height: 760px) {
    .v3-kitbox {
      margin-top: 6px;
      padding: 7px 12px;
      font-size: 13px;
      line-height: 1.35;
    }
  }

  .v3-kitbox .v3-info-pop.is-below {
    top: calc(100% + 8px);
    bottom: auto;
    left: 0;
    right: auto;
    width: 100%;
  }

  .v3-kitbox span {
    color: #333333;
  }

  /* (i) beside the guarantee: a small pop-up that explains it. */
  .v3-guarantee-ln {
    position: relative;
  }

  .v3-guarantee {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  :where(.v3-layout) .v3-info {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 0;
    border: 1.5px solid currentColor;
    border-radius: 50%;
    background: transparent;
    color: inherit;
    font: italic 700 11px/1 Georgia, serif;
    cursor: pointer;
    flex: none;
  }

  .v3-info-pop {
    position: absolute;
    right: 0;
    bottom: calc(100% + 8px);
    z-index: 5;
    width: min(320px, 92vw);
    box-sizing: border-box;
    padding: 12px 34px 12px 14px;
    border-radius: 12px;
    background: #111111;
    color: #ffffff;
    font-size: 13px;
    line-height: 1.45;
    text-align: left;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  }

  .v3-info-pop b {
    display: block;
    margin-bottom: 3px;
  }

  /* Pop-ups sit inside boxes with grey text (e.g. the kit box): keep their text light. */
  .v3-info-pop span,
  .v3-kitbox .v3-info-pop span,
  .v3-note .v3-info-pop span {
    color: rgba(255, 255, 255, 0.88);
  }

  .v3-info-pop a {
    color: #ffffff;
    font-weight: 700;
    text-decoration: underline;
  }

  .v3-note .v3-info-pop {
    left: 0;
    right: auto;
    width: 100%;
  }

  :where(.v3-layout) .v3-info-close {
    position: absolute;
    top: 6px;
    right: 8px;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #ffffff;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
  }

  .v3-was {
    color: #9a9a9a;
    margin-left: 3px;
    font-weight: 500;
    text-decoration: line-through;
  }

  .v3-card {
    border: 1px solid #e6e6e6;
    border-radius: 14px;
    padding: 2px 12px;
  }

  .v3-ln {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 6px 0;
    border-top: 1px solid #eeeeee;
    font-size: 13px;
  }

  .v3-ln:first-child {
    border-top: 0;
  }

  .v3-ln > span:first-child {
    color: #505050;
  }

  .v3-ln-right {
    color: #111111;
    text-align: right;
  }

  .v3-ln .v3-chg {
    font-size: 13px;
  }

  .v3-note {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12.5px;
    color: #5b4300;
    border-radius: 10px;
    padding: 7px 10px;
    background: #fdf6e3;
  }

  /* Braces note: red so it stands out. */
  .v3-note.is-red {
    color: #8a1c1c;
    background: #fdecec;
  }

  .v3-note.is-green {
    color: #14532d;
    background: #eef8f1;
  }

  .v3-note img {
    width: 20px;
    height: 20px;
    flex: none;
  }

  .v3-note a {
    color: inherit;
    font-weight: 700;
  }

  .v3-note .v3-chg {
    font-size: 12.5px;
    color: inherit;
  }

  .v3-h1 {
    margin: 0;
    font-size: 21px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
  }

  .v3-sub {
    margin: 3px 0 0;
    font-size: 12.5px;
    color: #505050;
  }

  .v3-trays {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .v3-tray {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 6px 4px 7px;
    border-radius: 12px;
    background: #ffffff;
    color: #111111;
    border: 1.5px solid #d4d4d4;
  }

  .v3-tray.is-on {
    border: 2px solid #111111;
  }

  .v3-tray-img {
    display: block;
    background-repeat: no-repeat;
  }

  .v3-tray b {
    font-size: 14px;
  }

  .v3-tray small {
    font-size: 11px;
    color: #505050;
  }

  .v3-error {
    margin: 2px 0 0;
    font-size: 12.5px;
    color: #c62828;
    font-weight: 600;
  }

  .v3-foot {
    flex: none;
    padding: 10px 20px 14px;
    padding-bottom: max(14px, env(safe-area-inset-bottom));
    border-top: 1px solid #eeeeee;
    background: #ffffff;
    box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.05);
  }

  .v3-panel-desktop .v3-foot {
    padding: 12px 28px 18px;
  }

  .v3-foot-t {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 8px;
    font-size: 13px;
    color: #505050;
  }

  .v3-foot-t b {
    font-size: 17px;
    color: #111111;
  }

  .v3-status {
    margin: 0 0 8px;
    font-size: 13px;
    font-weight: 600;
    color: #c62828;
  }

  .v3-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 52px;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
  }

  .v3-cta:disabled {
    opacity: 0.7;
    cursor: progress;
  }

  .v3-cta.is-ghost {
    background: #ffffff;
    color: #111111;
    border: 1.5px solid #111111;
  }

  .v3-dim {
    position: absolute;
    inset: 0;
    z-index: 20;
    background: rgba(17, 17, 17, 0.55);
  }

  .v3-sheet {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 21;
    max-height: calc(100% - 24px);
    overflow-y: auto;
    border-radius: 22px 22px 0 0;
    background: #ffffff;
    padding: 10px 20px 16px;
    padding-bottom: max(16px, env(safe-area-inset-bottom));
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.25);
  }

  .v3-grab {
    align-self: center;
    width: 40px;
    height: 5px;
    border-radius: 5px;
    background: #d9d9d9;
  }

  .v3-sheet-title {
    outline: none;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
  }

  .v3-sports {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }

  .v3-sport {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    padding: 2px 4px;
    white-space: normal;
    overflow-wrap: anywhere;
    border-radius: 9px;
    border: 1.5px solid #e0e0e0;
    background: #ffffff;
    color: #111111;
    font-size: 12.5px;
    line-height: 1.15;
    font-weight: 600;
    text-align: center;
  }

  .v3-sport.is-on {
    border: 2px solid #111111;
    background: #111111;
    color: #ffffff;
  }

  .v3-sport small {
    font-size: 10px;
    letter-spacing: -0.1px;
    font-weight: 500;
    white-space: nowrap;
  }

  .v3-sheet .v3-seg button {
    height: 38px;
    font-size: 13.5px;
  }

  .v3-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* Desktop: the theme's own input styles made the name boxes very thin. */
  @media screen and (min-width: 900px) {
    .v3-field input.v3-in {
      box-sizing: border-box;
      height: 46px;
      min-height: 46px;
      padding: 0 14px;
      border: 1.5px solid #cfcfcf;
      border-radius: 12px;
      background: #ffffff;
      font-size: 16px;
      line-height: normal;
    }

    .v3-field input.v3-in:focus {
      border-color: #111111;
      outline: none;
    }
  }

  .v3-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  @media screen and (max-width: 899px) {
    .v3-layout {
      grid-template-columns: minmax(0, 1fr);
    }

    .v3-side {
      display: none;
    }

    .v3-panel {
      border-left: 0;
    }
  }

  @media screen and (min-width: 900px) {
    .v3-dim,
    .v3-sheet {
      position: fixed;
    }

    .v3-sheet {
      left: 50%;
      right: auto;
      bottom: auto;
      top: 50%;
      width: 460px;
      max-height: calc(100vh - 48px);
      transform: translate(-50%, -50%);
      border-radius: 20px;
    }

    .v3-sheet .v3-grab {
      display: none;
    }

    /* Desktop: position on its own full-width line, sport/thickness below. */
    .v3-fit {
      flex-direction: column;
    }

    .v3-fit .v3-seg {
      width: 100%;
    }

    /* Desktop sport pop-up: bigger, still sized to fit without scrolling. */
    .v3-sheet {
      width: 640px;
      padding: 22px 28px 24px;
      gap: 12px;
    }

    .v3-sheet-title {
      font-size: 22px;
    }

    .v3-sports {
      gap: 8px;
    }

    .v3-sport {
      min-height: clamp(32px, 4.3vh, 46px);
      font-size: 15px;
      border-radius: 11px;
    }

    .v3-sport small {
      font-size: 12px;
    }

    .v3-sheet .v3-seg button {
      height: clamp(38px, 5vh, 48px);
      font-size: 15px;
    }

    .v3-design .v3-preview {
      display: none;
    }
  }

  /* Desktop right column. It grows in steps with the screen (wider column,
     everything inside scaled evenly) so it stays easy to read and fills the
     space. Pop-ups opt out of that scaling and size themselves to the screen
     height instead, so they are as big as possible without scrolling. */
  @media screen and (min-width: 900px) {
    .v3-panel-desktop .v3-main {
      gap: clamp(12px, 2.3vh, 30px);
      padding-top: clamp(12px, 1.8vh, 24px);
    }

    .v3-panel-desktop .v3-sw {
      width: 44px;
      height: 44px;
    }

    .v3-assure {
      margin: auto 0 0;
      padding: 14px 0 2px;
      border-top: 1px solid #eeeeee;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 6px 14px;
      font-size: 13px;
      font-weight: 600;
      color: #3d3d3d;
    }

    .v3-assure li {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0;
    }

    .v3-assure svg {
      width: 14px;
      height: 14px;
      flex: none;
    }

    .v3-sheet {
      width: clamp(560px, 64vh, 860px);
      max-width: calc(100vw - 48px);
      padding: clamp(18px, 2.2vh, 30px) clamp(22px, 2.6vh, 36px);
      gap: clamp(10px, 1.2vh, 16px);
    }

    .v3-sheet-title {
      font-size: clamp(20px, 2.1vh, 28px);
    }

    .v3-sport {
      min-height: clamp(32px, 4.3vh, 58px);
      font-size: clamp(14px, 1.45vh, 19px);
    }

    .v3-sport small {
      font-size: clamp(11px, 1.1vh, 14px);
    }

    .v3-sheet .v3-seg button,
    .v3-sheet .v3-cta {
      height: clamp(38px, 5vh, 60px);
      font-size: clamp(14px, 1.45vh, 19px);
    }

    .v3-sheet .v3-lbl,
    .v3-sheet .v3-sub {
      font-size: clamp(13px, 1.35vh, 17px);
    }
  }

  @media screen and (min-width: 1280px) and (min-height: 820px) {
    .v3-layout {
      grid-template-columns: minmax(0, 1fr) 520px;
    }

    .v3-panel {
      zoom: 1.1;
    }

    .v3-panel .v3-sheet,
    .v3-panel .v3-dim {
      zoom: 0.9091;
    }
  }

  @media screen and (min-width: 1500px) and (min-height: 920px) {
    .v3-layout {
      grid-template-columns: minmax(0, 1fr) 580px;
    }

    .v3-panel {
      zoom: 1.2;
    }

    .v3-panel .v3-sheet,
    .v3-panel .v3-dim {
      zoom: 0.8333;
    }
  }

  @media screen and (min-width: 1750px) and (min-height: 1050px) {
    .v3-layout {
      grid-template-columns: minmax(0, 1fr) 640px;
    }

    .v3-panel {
      zoom: 1.3;
    }

    .v3-panel .v3-sheet,
    .v3-panel .v3-dim {
      zoom: 0.7692;
    }
  }

  @media screen and (min-width: 2300px) and (min-height: 1300px) {
    .v3-layout {
      grid-template-columns: minmax(0, 1fr) 720px;
    }

    .v3-panel {
      zoom: 1.45;
    }

    .v3-panel .v3-sheet,
    .v3-panel .v3-dim {
      zoom: 0.6897;
    }
  }

`;var rM=T(oe());var tM=v`
  /* Phones: the guard Edit pop-up fits without scrolling.
     Thickness is three boxes across, then guard and pad colors on one line each. */
  @media screen and (max-width: 899px) {
    .bundle-edit-panel {
      max-height: calc(100dvh - 24px);
    }

    .bundle-edit-preview-card {
      min-height: 0;
      max-height: clamp(84px, 22dvh - 40px, 220px);
      aspect-ratio: 2 / 1;
    }

    .bundle-edit-form > [data-kind="thickness"],
    .bundle-edit-form > [data-kind="color"],
    .bundle-edit-form > [data-kind="pad"] {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      padding: 8px 0 10px;
    }

    .bundle-edit-form > [data-kind="thickness"] .bundle-edit-radios {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 8px;
      width: 100%;
    }

    .bundle-edit-form > [data-kind="thickness"] .bundle-edit-radios > button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 42px;
      margin: 0;
      padding: 0 6px;
      border: 1.5px solid #d4d4d4;
      border-radius: 10px;
      background: #ffffff;
      color: #111111;
      font-size: 15px;
      font-weight: 600;
    }

    .bundle-edit-form > [data-kind="thickness"] .bundle-edit-radios > button > span:first-child {
      display: none;
    }

    .bundle-edit-form > [data-kind="thickness"] .bundle-edit-radios > button[aria-checked="true"] {
      border-color: #111111;
      background: #111111;
      color: #ffffff;
    }

    .bundle-edit-form > [data-kind="color"] .bundle-edit-color-control,
    .bundle-edit-form > [data-kind="pad"] .bundle-edit-color-control {
      display: block;
      width: 100%;
    }

    .bundle-edit-form > [data-kind="color"] .bundle-edit-color-value,
    .bundle-edit-form > [data-kind="pad"] .bundle-edit-color-value {
      display: none;
    }

    .bundle-edit-form .bundle-edit-color-options {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      gap: 0;
      width: 100%;
    }

    @media (max-height: 760px) {
      .bundle-edit-form .bundle-edit-row {
        padding-top: 3px;
        padding-bottom: 3px;
        min-height: 32px;
      }

      .bundle-edit-preview-badge {
        display: none;
      }

      .bundle-edit-preview-card {
        max-height: clamp(64px, 22dvh - 66px, 220px);
      }

      .bundle-edit-form > [data-kind="thickness"],
      .bundle-edit-form > [data-kind="color"],
      .bundle-edit-form > [data-kind="pad"] {
        gap: 5px;
        padding: 5px 0 7px;
      }

      .bundle-edit-form > [data-kind="thickness"] .bundle-edit-radios > button {
        height: 38px;
      }
    }
  }
`;var G0="trufit-new-design";function Ih(e){(0,rM.useEffect)(()=>{if(!e)return;let t=document.documentElement;return t.classList.add(G0),()=>t.classList.remove(G0)},[e])}var Vh=Ms`
  html.${G0} {
    ${tM}

    /* "Remove this guard?" pop-up: everything fits, nothing scrolls. */
    .bundle-downgrade-panel {
      max-height: none !important;
      overflow: visible !important;
    }

    .bundle-downgrade-content {
      overflow: visible !important;
    }

    @media screen and (max-width: 749px) {
      .bundle-downgrade-panel .bundle-modal-header {
        padding-top: 14px !important;
        padding-bottom: 14px !important;
      }

      .bundle-downgrade-content {
        gap: 8px !important;
        margin-bottom: 16px !important;
        padding: 16px 20px 0 !important;
      }

      .bundle-downgrade-content .bundle-warning {
        width: 52px !important;
        height: 52px !important;
        padding: 8px !important;
      }

      .bundle-downgrade-content .bundle-warning img {
        width: 36px !important;
        height: 36px !important;
      }

      .bundle-downgrade-content h3 {
        font-size: 18px !important;
        line-height: 24px !important;
      }

      .bundle-downgrade-content p {
        font-size: 14px !important;
        line-height: 19px !important;
      }

      .bundle-downgrade-content .bundle-tier-change {
        padding: 4px 0 !important;
      }
    }

    /* Guard editor: delete (trash) button beside Cancel / Save. */
    .bundle-edit-actions.has-delete {
      grid-template-columns: 48px 1fr 1fr;
      gap: 10px;
    }

    .bundle-edit-delete {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      padding: 0;
      border: 1.5px solid #e5b4b4;
      border-radius: 50%;
      background: #ffffff;
      color: #b42318;
      cursor: pointer;
    }

    .bundle-edit-delete svg {
      width: 20px;
      height: 20px;
    }

    .bundle-edit-delete:hover:not(:disabled) {
      background: #fdecec;
    }

    /* Confirm pop-ups (remove bundle). */
    .cart-confirm-panel {
      border-radius: 20px;
      padding: 28px 24px 22px;
    }

    .cart-confirm-panel h2 {
      margin: 0 0 8px;
      font-size: 22px;
      font-weight: 700;
      line-height: 1.2;
      letter-spacing: 0;
      text-transform: none;
    }

    .cart-confirm-panel p {
      margin: 0 0 18px;
      font-size: 15px;
      color: #505050;
    }

    .cart-confirm-close,
    .new-customer-modal-header button {
      border: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    .cart-confirm-close,
    .new-customer-modal-header button {
      border-radius: 50%;
      outline: none !important;
    }

    .cart-confirm-close:focus-visible,
    .new-customer-modal-header button:focus-visible {
      background: #ececec !important;
    }

    .cart-confirm-actions {
      gap: 10px;
    }

    .cart-confirm-cancel,
    .cart-confirm-remove {
      height: 48px;
      border-radius: 999px;
      font-size: 15px;
      font-weight: 700;
    }

    .cart-confirm-cancel {
      border: 1.5px solid #111111;
      background: #ffffff;
      color: #111111;
    }

    .cart-confirm-remove {
      border: 1.5px solid #111111;
      background: #111111;
      color: #ffffff;
    }

    /* Add new customer: tap-friendly boxes instead of radio lists, and a
       photo that shrinks on short screens so nothing scrolls. */
    .new-customer-modal-panel {
      border-radius: 20px;
      max-height: calc(100dvh - 24px);
    }

    .new-customer-modal-header h2 {
      font-size: 22px;
      font-weight: 700;
      letter-spacing: 0;
      text-transform: none;
    }

    @media screen and (max-width: 899px) {
      .new-customer-modal-image {
        height: clamp(96px, 26dvh - 40px, 240px);
        max-height: none;
        overflow: hidden;
      }

      .new-customer-modal-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    /* The configured close icon draws a box; use a plain × instead. */
    .new-customer-modal-header button img {
      display: none;
    }

    .new-customer-modal-header button:has(img)::after {
      content: "×";
      font-size: 30px;
      line-height: 1;
      color: #111111;
    }

    .new-customer-selection-grid {
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 12px;
    }

    .new-customer-options-title {
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 700;
    }

    .new-customer-product-options .new-customer-options-list {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .new-customer-bundle-options .new-customer-options-list {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 8px;
    }

    .new-customer-option {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 44px;
      margin: 0;
      padding: 6px 8px;
      border: 1.5px solid #d4d4d4;
      border-radius: 10px;
      background: #ffffff;
      color: #111111;
      font-size: 14px;
      font-weight: 600;
      line-height: 1.2;
      text-align: center;
      cursor: pointer;
    }

    .new-customer-option input {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    .new-customer-option > span[aria-hidden="true"] {
      display: none;
    }

    .new-customer-option:has(input:checked) {
      border-color: #111111;
      background: #111111;
      color: #ffffff;
    }

    .new-customer-option:has(input:focus-visible) {
      outline: 2px solid #111111;
      outline-offset: 2px;
    }

    .new-customer-add {
      height: 50px;
      border-radius: 999px;
      font-size: 16px;
      font-weight: 700;
    }
  }
`;var ve=T(k());function nR(){let e=Vu(),t=[x("30-day Perfect Fit guarantee"),x("Made in the USA"),e?x("Free US shipping"):""].filter(Boolean);return(0,ve.jsx)("ul",{className:"v3-assure","aria-label":x("Why TRUFIT"),children:t.map(r=>(0,ve.jsxs)("li",{children:[(0,ve.jsx)("svg",{viewBox:"0 0 16 16",fill:"none",stroke:"#1b7f3b",strokeWidth:"2.2",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",children:(0,ve.jsx)("path",{d:"M3 8.5l3.2 3L13 4.5"})}),r]},r))})}function oR(){let e="(min-width: 900px)",[t,r]=Jo.default.useState(()=>typeof window!="undefined"&&window.matchMedia(e).matches);return(0,Jo.useEffect)(()=>{var i;let n=window.matchMedia(e),o=()=>r(n.matches);return o(),(i=n.addEventListener)==null||i.call(n,"change",o),()=>{var a;return(a=n.removeEventListener)==null?void 0:a.call(n,"change",o)}},[]),t}var nM=(0,Jo.forwardRef)(function(t,r){var O;let{config:n,context:o,currentStepIndex:i,fallbackMediaUrl:a,labels:s,modalId:l,onBack:c,onClose:d,onSubmit:u,open:p,processing:m,status:g,steps:y,totalPrice:P,v3:Y,editingGuardIndex:h,bundleCustomizeOpen:S,removingGuardIndex:b,downgradedBundlePackage:W,onCancelBundleGuardRemoval:C,onConfirmBundleGuardRemoval:w,bundleStates:I,thicknessGuideImageUrl:U,onCloseGuardEditor:L,onSaveGuardState:X}=t,N=oR(),V=y[i],z=V==null?void 0:V.Component,te=y[i+1],H=i>=y.length-1,E=`${l}Title`,Z=(0,Jo.useRef)(null),ce=Object.values(o.fieldErrors).some(Boolean),ie=Math.max(1,Y.bundleQuantity),re=ah(o,Array.from({length:ie},(_,K)=>I[K]||o.state)),$=ie>1&&re>0?we(Math.round(re/ie),(O=Y.currentBundlePackage)==null?void 0:O.price):"",D=(V==null?void 0:V.key)||"",B=m?x(s.processingLabel||"Adding\u2026"):H?x("Add to cart \xB7 {total}",{total:P}):(te==null?void 0:te.key)==="upsell"?x("Review order"):x("Continue to kit");Ih(Boolean(p)),(0,Jo.useEffect)(()=>{p&&mh("")},[p]),(0,Jo.useEffect)(()=>{var _,K,Ye;!p||!D||((K=(_=Z.current)==null?void 0:_.scrollTo)==null||K.call(_,{top:0}),uo("step_view",{step:D,step_number:i+1,product:((Ye=n.currentProduct)==null?void 0:Ye.handle)||"",guards:ie}))},[p,D,i]);let J=!S&&typeof h=="number"&&h>0?h:null,A=null;return D==="personDetails"||D==="impressionKit"?A=Y.kitTraysImageUrl?(0,ve.jsx)("img",{className:"v3-side-img",src:Y.kitTraysImageUrl.replace("trufit-pm-kit-trays.png","trufit-pm-kit-trays-hd.jpg"),onError:_=>{_.currentTarget.src!==Y.kitTraysImageUrl&&(_.currentTarget.src=Y.kitTraysImageUrl)},alt:x("Impression kit trays: small, regular and large")}):null:A=(0,ve.jsxs)("div",{className:"v3-side-preview",children:[D==="customization"?(0,ve.jsx)("span",{className:"v3-pill is-neutral",style:{position:"absolute",left:"50%",bottom:-6,transform:"translateX(-50%)",zIndex:3},children:x("Live preview \xB7 colors update as you go")}):null,(0,ve.jsx)("span",{className:"v3-preview-layers","aria-hidden":"true",children:(0,ve.jsx)(co,{config:n,state:o.state,fallbackUrl:a,width:1400})})]}),(0,ve.jsx)(Mn,{stepKey:V==null?void 0:V.key,view:"",children:(0,ve.jsx)(eT,{value:Y,children:(0,ve.jsxs)(eM,{className:"purchase-master purchase-master-v3","data-purchase-master-modal":!0,"data-purchase-master-layout":"v3","data-purchase-master-step":V==null?void 0:V.key,id:l,role:"dialog","aria-modal":"true","aria-labelledby":E,hidden:!p,children:[(0,ve.jsxs)("div",{className:"v3-layout",tabIndex:-1,ref:r,children:[N?(0,ve.jsx)("div",{className:"v3-side",children:A}):null,(0,ve.jsxs)("form",{className:`v3-panel${N?" v3-panel-desktop":""}`,noValidate:!0,onSubmit:u,children:[(0,ve.jsxs)("div",{className:"v3-top",children:[i>0?(0,ve.jsx)("button",{type:"button",className:"v3-icon-btn","aria-label":x(s.backLabel||"Back"),onClick:c,children:"\u2039"}):(0,ve.jsx)("span",{className:"v3-icon-spacer"}),(0,ve.jsx)("h2",{className:"v3-title",id:E,children:(V==null?void 0:V.title)||""}),(0,ve.jsx)("button",{type:"button",className:"v3-icon-btn","aria-label":x(s.closeLabel||"Close"),onClick:d,children:"\xD7"})]}),y.length>1?(0,ve.jsx)("div",{className:"v3-prog",style:{gridTemplateColumns:`repeat(${y.length}, 1fr)`},role:"progressbar","aria-label":x(s.progressLabel||"Progress"),"aria-valuemin":1,"aria-valuemax":y.length,"aria-valuenow":i+1,"aria-valuetext":x("Step {current} of {total}",{current:i+1,total:y.length}),children:y.map((_,K)=>(0,ve.jsxs)("div",{className:`v3-prog-item${K<=i?" is-on":""}`,children:[(0,ve.jsx)("i",{}),K+1," ",_.shortLabel||_.title]},`${_.key}-${K}`))}):null,(0,ve.jsxs)("div",{className:"v3-main",ref:Z,children:[z?(0,ve.jsx)(z,{context:o}):null,N&&D!=="upsell"?(0,ve.jsx)(nR,{}):null]}),(0,ve.jsxs)("div",{className:"v3-foot",children:[g&&!ce?(0,ve.jsx)("p",{className:"v3-status",role:"status","aria-live":"polite",children:g}):null,(0,ve.jsxs)("div",{className:"v3-foot-t",children:[(0,ve.jsxs)("span",{children:[x("Total"),$?` \xB7 ${x("{amount} per guard",{amount:$})}`:"",H&&Vu()?` \xB7 ${x("free US shipping")}`:""]}),(0,ve.jsx)("b",{children:P})]}),(0,ve.jsxs)("button",{type:"submit",className:"v3-cta",disabled:m||t.addDisabled,onClick:()=>{var _;H&&uo("add_to_cart_click",{product:((_=n.currentProduct)==null?void 0:_.handle)||"",guards:ie,total:P})},children:[B," ",m?null:(0,ve.jsx)("span",{"aria-hidden":"true",children:"\u203A"})]})]})]})]}),(0,ve.jsx)(Vh,{}),!S&&b!==null&&Y.currentBundlePackage&&W?(0,ve.jsx)(vc,{arrowIconUrl:n.bundleDowngradeArrowIconUrl,closeIconUrl:n.closeIconUrl,currentPackage:Y.currentBundlePackage,downgradedPackage:W,guardIconUrl:n.bundleGuardIconUrl,guardIndex:b,labels:s,saving:m,warningIconUrl:n.bundleWarningIconUrl,onCancel:C,onConfirm:w}):null,(0,ve.jsx)(Th,{...t}),J!==null?(0,ve.jsx)(Qo,{config:n,guardIndex:J,initialState:I[J]||o.state,labels:s,previewImageUrl:a,thicknessGuideImageUrl:U,onCancel:L,onSave:_=>X(J,_)}):null]})})})});function Bn(e,t,r){return e instanceof HTMLElement&&e.dataset[t]||r}function oM({mount:e,section:t}){return{addLabel:e.dataset.addLabel||Bn(t,"addLabel","Add to cart"),addErrorMessage:Bn(t,"addErrorMessage",""),backLabel:e.dataset.backLabel||"Back",closeLabel:e.dataset.closeLabel||"Close Purchase Master",continueLabel:e.dataset.continueLabel||"Continue",priceLabel:e.dataset.priceLabel||"Price",processingLabel:Bn(t,"processingLabel","Adding..."),progressLabel:e.dataset.progressLabel||"Purchase Master progress",impressionKitHint:e.dataset.impressionKitHint||Bn(t,"impressionKitHint","If you are unsure, you're a regular."),impressionKitHelpLabel:e.dataset.impressionKitHelpLabel||Bn(t,"impressionKitHelpLabel","Impression kit help"),impressionKitSizeLabel:e.dataset.impressionKitSizeLabel||Bn(t,"impressionKitSizeLabel","Impression Kit Size"),impressionKitTitle:e.dataset.impressionKitTitle||Bn(t,"impressionKitTitle","Impression Kit"),impressionKitRequiredLabel:e.dataset.impressionKitRequiredLabel||Bn(t,"impressionKitRequiredLabel","Requires Impression Kit"),clinicMapAlt:e.dataset.clinicMapAlt||"Clinic scan center map",clinicMapCloseLabel:e.dataset.clinicMapCloseLabel||"Close",clinicMapViewLabel:e.dataset.clinicMapViewLabel||"Map View",requiredMessage:Bn(t,"requiredMessage","Please complete the required selection."),reviewLabel:Bn(t,"reviewLabel","Review selections"),reviewText:Bn(t,"reviewText","Confirm your options before adding everything to the Shopify cart."),selectValueLabel:e.dataset.selectValueLabel||"Select value",summaryEmptyLabel:Bn(t,"summaryEmptyLabel","No options selected yet.")}}function iM(e){return e.dataset.modalId||(e.id?`${e.id}-dialog`:`PurchaseMasterDialog-${Math.random().toString(36).slice(2)}`)}var fo=T(oe());function aM(e){return{...e,recipientType:"me",recipientFirstName:"",recipientLastName:""}}function sM({form:e,launchContext:t,customerAuthenticated:r,open:n,openModal:o,existingBundleChoiceOpen:i,setExistingBundleChoiceOpen:a,setReturningCustomerPromptOpen:s,setNewCustomerFlowActive:l,resetBundleEditor:c,setSelectRequest:d,setActiveSubview:u,closeSubview:p,existingBundleDiscountPercent:m,setState:g,startNewCustomerPurchase:y,checkExistingBundleBeforeOpen:P,cancelExistingBundleChoice:Y,confirmExistingBundleReplacement:h,startNewCustomerFlow:S}){let b=(0,fo.useRef)(!1),W=(0,fo.useRef)(!1),C=(0,fo.useCallback)(async V=>await y(V)?((V!=null&&V.bundleQuantity?Ho(e,V.bundleQuantity):!1)||_u(e,0),l(!0),c(),d(null),p(),!0):!1,[p,e,c,y]),w=(0,fo.useCallback)(()=>{b.current=!1,Y(),a(!1)},[Y]),I=(0,fo.useCallback)(()=>{let V=b.current;b.current=!1,g(aM,["recipientType","recipientFirstName","recipientLastName"]),h(),a(!1),V&&o({preserveExistingBundleChoice:!0})},[h,o,g]),U=(0,fo.useCallback)(()=>{s(!1),o(),S()&&(l(!0),c(),d(null),u(""))},[o,c,S]),L=(0,fo.useCallback)(()=>{let V=b.current;b.current=!1,V&&o(),S({bundleDiscountPercent:m})&&(a(!1),l(!0),c(),d(null),u(""))},[m,o,c,S]),X=(0,fo.useCallback)(async V=>{if(!(n||i||t||W.current)){W.current=!0;try{await P()?b.current=!0:V&&o()}catch(z){V&&o()}finally{W.current=!1}}},[P,i,t,n,o]),N=(0,fo.useCallback)(()=>{if(r){s(!0);return}X(!0)},[r,X]);return{handleStartNewCustomerPurchase:C,closeExistingBundleChoice:w,replaceExistingBundle:I,startNewPersonFromReturningCustomer:U,startNewCustomerFromExistingBundle:L,handleProductFormSubmit:N}}var Tc=T(oe());function iR(e){let t=null,r=null,n=()=>{t=window.setTimeout(e,0)};return document.readyState==="complete"?n():(r=n,window.addEventListener("load",r,{once:!0})),()=>{r&&window.removeEventListener("load",r),t!==null&&window.clearTimeout(t)}}function lM({launchContext:e,openModal:t,refreshCartContext:r}){let n=(0,Tc.useRef)(!1),o=(0,Tc.useRef)(!1);(0,Tc.useEffect)(()=>{if(o.current||e)return;o.current=!0;let i=!1,a=iR(()=>{i||r().catch(()=>{})});return()=>{i=!0,a()}},[e,r]),(0,Tc.useEffect)(()=>{!e||n.current||(n.current=!0,t())},[e,t])}var kh=T(oe());function cM(e){let[t,r]=(0,kh.useState)(0);(0,kh.useEffect)(()=>{let n=ZP(e);if(!n)return;let o=Math.max(250,n-BP(e)+50),i=window.setTimeout(()=>{r(a=>a+1)},o);return()=>window.clearTimeout(i)},[e,t])}var _0=T(oe());function dM({open:e,existingBundleChoiceOpen:t,returningCustomerPromptOpen:r,layoutRef:n,closeConfirmOpen:o,setCloseConfirmOpen:i,setReturningCustomerPromptOpen:a,closeExistingBundleChoice:s,bundleTierUpsellOpen:l,dismissBundleTierUpsell:c,activeSubview:d,closeSubview:u,selectRequest:p,closeSelect:m,removingGuardIndex:g,cancelGuardRemoval:y,editingGuardIndex:P,closeGuardEditor:Y,standaloneGuardEditOpen:h,cancelStandaloneGuard:S,bundleCustomizeOpen:b,closeBundleCustomize:W,requestCloseModal:C}){(0,_0.useEffect)(()=>{if(!(!e&&!t&&!r))return document.documentElement.style.overflow="hidden",document.body.style.overflow="hidden",r||window.setTimeout(()=>{var w;(w=n.current)==null||w.focus()},0),()=>{document.documentElement.style.overflow="",document.body.style.overflow=""}},[t,e,r]),(0,_0.useEffect)(()=>{if(!e&&!t&&!r)return;let w=I=>{I.key==="Escape"&&(o?i(!1):r?a(!1):t?s():l?c():d?u():p?m():g!==null?y():P!==null?Y():h?S():b?W():C())};return document.addEventListener("keydown",w),()=>document.removeEventListener("keydown",w)},[d,y,W,Y,m,u,o,s,t,r,b,l,P,c,e,g,p,h,S,C])}var ho=T(oe());function uM(){let[e,t]=(0,ho.useState)([]),[r,n]=(0,ho.useState)(!1),[o,i]=(0,ho.useState)(!1),[a,s]=(0,ho.useState)(null),[l,c]=(0,ho.useState)(!1),[d,u]=(0,ho.useState)(!1),[p,m]=(0,ho.useState)(null),[g,y]=(0,ho.useState)(null),P=(0,ho.useCallback)(()=>{t([]),n(!1),i(!1),s(null),c(!1),u(!1),m(null),y(null)},[]);return{bundleStates:e,setBundleStates:t,bundleTierUpsellDismissed:r,setBundleTierUpsellDismissed:n,bundleTierUpsellRequested:o,setBundleTierUpsellRequested:i,standaloneGuardState:a,setStandaloneGuardState:s,standaloneGuardEditOpen:l,setStandaloneGuardEditOpen:c,bundleCustomizeOpen:d,setBundleCustomizeOpen:u,editingGuardIndex:p,setEditingGuardIndex:m,removingGuardIndex:g,setRemovingGuardIndex:y,resetBundleEditor:P}}var Ot=T(oe());function pM(e,t,r,n){return n===0?t:{...e,recipientType:t.recipientType,recipientFirstName:t.recipientFirstName,recipientLastName:t.recipientLastName,purchaseMasterFlow:t.purchaseMasterFlow,impressionKitSize:t.impressionKitSize,sport:e.sport===r.sport?t.sport:e.sport,thicknessSize:e.thicknessSize===r.thicknessSize?t.thicknessSize:e.thicknessSize}}function mM({bundleEditor:e,bundleQuantity:t,config:r,form:n,state:o,setState:i,advanceCurrentStep:a,captureAddedGuardNavigation:s,clearAddedGuardNavigation:l}){let{bundleStates:c,setBundleStates:d,setBundleTierUpsellDismissed:u,bundleTierUpsellRequested:p,setBundleTierUpsellRequested:m,standaloneGuardState:g,setStandaloneGuardState:y,setStandaloneGuardEditOpen:P,setBundleCustomizeOpen:Y,setEditingGuardIndex:h,removingGuardIndex:S,setRemovingGuardIndex:b}=e,W=(0,Ot.useRef)(o),C=(0,Ot.useRef)(!1),w=(0,Ot.useRef)(null);(0,Ot.useEffect)(()=>{let re=W.current;re!==o&&(c.length&&d($=>$.map((D,B)=>pM(D,o,re,B))),W.current=o)},[c.length,o]),(0,Ot.useEffect)(()=>{if(g)return;let re=w.current;if(w.current=null,re&&c.includes(re)){C.current=!1,a();return}C.current&&(C.current=!1,l())},[a,c,l,g]);let I=(0,Ot.useCallback)(()=>{d(re=>re.length===t?re:Array.from({length:t},($,D)=>re[D]||o))},[t,o]),U=(0,Ot.useCallback)(()=>{I(),b(null),Y(!0)},[I]),L=(0,Ot.useCallback)(()=>{h(null),b(null),Y(!1)},[]),X=(0,Ot.useCallback)(()=>{h(null)},[]),N=(0,Ot.useCallback)(re=>{I(),b(null),h(re)},[I]),V=(0,Ot.useCallback)(re=>{h(null),b(re)},[]),z=(0,Ot.useCallback)(()=>{b(null)},[]),te=(0,Ot.useCallback)((re,$)=>{d(D=>{let B=Array.from({length:t},(J,A)=>D[A]||o);return B[re]=$,B}),re===0&&i(()=>$),h(null)},[t,i,o]),H=c[t-1]||o,E=(0,Ot.useCallback)(re=>{if(g)return;let $=t+1,D=Ni(n,$,r);if(!(D!=null&&D.available)||IT(n,$)&&!Ho(n,$))return;let B=Array.from({length:t},(A,O)=>c[O]||o),J=re?H:o;if(Y(!1),b(null),h(null),s(),u(!0),m(!1),re){d([...B,{...J}]),p&&a();return}C.current=p,y({...J}),P(!0)},[t,c,p,s,r,a,n,H,g,o]),Z=(0,Ot.useCallback)(re=>{let $=Math.max(1,t-1),D=Array.from({length:$},(B,J)=>c[J]||o);C.current&&(w.current=re),d([...D,re]),u(!0),m(!1),y(null),P(!1)},[t,c,o]),ce=(0,Ot.useCallback)(()=>{Ho(n,Math.max(1,t-1)),C.current=!1,w.current=null,l(),y(null),P(!1)},[t,l,n]),ie=(0,Ot.useCallback)(()=>{if(S===null)return;let re=t-1;if(re<1||!Ho(n,re))return;let D=Array.from({length:t},(B,J)=>c[J]||o).filter((B,J)=>J!==S);d(D),u(!1),m(!1),S===0&&D[0]&&i(()=>D[0]),b(null)},[t,c,n,S,i,o]);return{identicalGuardState:H,openBundleCustomize:U,closeBundleCustomize:L,closeGuardEditor:X,openGuardEditor:N,requestGuardRemoval:V,cancelGuardRemoval:z,saveGuardState:te,addBundleGuard:E,saveStandaloneGuard:Z,cancelStandaloneGuard:ce,confirmGuardRemoval:ie}}var ei=T(k());function hM({config:e,form:t,mount:r,section:n}){var c1;let[o,i]=(0,Be.useState)(e),[a]=(0,Be.useState)(()=>{let mt=pT(r,e);return dT(mt),mt}),s=(0,Be.useMemo)(()=>oM({mount:r,section:n}),[r,n]),l=(0,Be.useMemo)(()=>iM(r),[r]),c=r.dataset.customerAuthenticated==="true"||JT(document.cookie),d=(0,Be.useMemo)(()=>{var mt;return Hw((mt=o.currentProduct)==null?void 0:mt.handle)},[(c1=o.currentProduct)==null?void 0:c1.handle]),u=(d==null?void 0:d.mode)==="add-person",p=(d==null?void 0:d.mode)==="add-product",m=Boolean(d),[g,y]=(0,Be.useState)(!1);Am(g);let[P,Y]=(0,Be.useState)(!1),[h,S]=(0,Be.useState)(null),[b,W]=(0,Be.useState)(""),C=uM(),{bundleStates:w,setBundleStates:I,bundleTierUpsellDismissed:U,setBundleTierUpsellDismissed:L,bundleTierUpsellRequested:X,setBundleTierUpsellRequested:N,standaloneGuardState:V,standaloneGuardEditOpen:z,bundleCustomizeOpen:te,editingGuardIndex:H,removingGuardIndex:E,resetBundleEditor:Z}=C,[ce,ie]=(0,Be.useState)(u),[re,$]=(0,Be.useState)(!1),[D,B]=(0,Be.useState)(!1),J=(0,Be.useRef)(null),A=(0,Be.useRef)(null),O=(0,Be.useCallback)(()=>{$(!0)},[]),_=(0,Be.useMemo)(()=>a?YT({config:o}):gT({section:n,mount:r,config:o}),[o,r,n,a]),K=p?1:Math.max(Sa(t),w.length),Ye=Ni(t,K,o),Se=Ni(t,K+1,o),Ce=Ni(t,K-1,o),pt=(0,Be.useCallback)(({step:mt,steps:Ka})=>{if(a)return!1;let Ha=Boolean(!m&&!U&&DP(o,mt.key,OP({guardQuantity:K,step:mt,steps:Ka}))&&(Se==null?void 0:Se.available)&&!V);return Ha&&N(!0),Ha},[K,U,o,Se==null?void 0:Se.available,V,m,a]),{advanceCurrentStep:R,checkExistingBundleBeforeOpen:ee,currentState:ge,currentStepIndex:q,fieldErrors:me,getNewCustomerPrice:Pe,impressionKitPrice:Ut,isImpressionKitUpdateFlow:st,isReturnCustomerFlow:zt,reusableImpressionPositions:So,shouldReuseImpressionKit:It,captureAddedGuardNavigation:yo,clearAddedGuardNavigation:Dn,goToStep:$a,handleSubmit:tp,processing:Bc,recipientSelectionPending:rp,refreshCartContext:si,resetFlow:Zc,resetFlowPreservingExistingBundleChoice:zs,cancelExistingBundleChoice:rn,confirmExistingBundleReplacement:li,setFieldValue:ci,setProcessing:Ks,setState:Oa,setStatus:Hs,selectRecipient:$c,startNewCustomerFlow:Qs,startNewCustomerPurchase:eg,state:xo,status:Oc,submitCurrentStep:np,steps:nn,totalPrice:Fc}=bT({bundleStates:w,setBundleStates:I,config:o,onConfigRefresh:i,form:t,isModalOpen:g,labels:s,launchContext:d,mount:r,section:n,standaloneGuardState:V,suppressNewCustomerUpsell:ce,forceNewPerson:ce,steps:_,onExistingBundlePrompt:O,onBeforeStepAdvance:pt}),js=(0,Be.useMemo)(()=>Ci(Ys(o,xo),o),[o,xo]);cM(o);let{identicalGuardState:qs,openBundleCustomize:tg,closeBundleCustomize:op,closeGuardEditor:on,openGuardEditor:bo,requestGuardRemoval:Dc,cancelGuardRemoval:ip,saveGuardState:Js,addBundleGuard:el,saveStandaloneGuard:rg,cancelStandaloneGuard:Fa,confirmGuardRemoval:Co}=mM({bundleEditor:C,bundleQuantity:K,config:o,form:t,state:xo,setState:Oa,advanceCurrentStep:R,captureAddedGuardNavigation:yo,clearAddedGuardNavigation:Dn}),Da=(0,Be.useCallback)(()=>{S(null)},[]),_r=(0,Be.useCallback)(()=>{W(mt=>mt==="clinicTime"?"clinicDate":"")},[]),za=(0,Be.useCallback)(mt=>{W(mt)},[]),tl=(0,Be.useCallback)(()=>{W(""),np()},[np]),ng=(0,Be.useCallback)(()=>{V&&Ho(t,Math.max(1,K-1)),Y(!1),y(!1),S(null),Z(),ie(!1),rn(),$(!1),_r(),Ks(!1),Hs(""),document.documentElement.style.overflow="",document.body.style.overflow="";let mt=A.current;mt instanceof HTMLElement&&mt.focus()},[K,_r,t,rn,Z,Ks,Hs,V]),rl=(0,Be.useCallback)(()=>{g&&Y(!0)},[g]),nl=(0,Be.useCallback)(mt=>{var Ha;A.current=document.activeElement,Wc(o,r.dataset.mediaUrl);let Ka=r.dataset.v3KitTraysUrl||"";LT([Ka,Ka&&((Ha=window.matchMedia)!=null&&Ha.call(window,"(min-width: 900px)").matches)?Ka.replace("trufit-pm-kit-trays.png","trufit-pm-kit-trays-hd.jpg"):""]),_r(),Y(!1),mt!=null&&mt.preserveExistingBundleChoice?zs():Zc(),u?d!=null&&d.bundleQuantity&&Ho(t,d.bundleQuantity)||_u(t,0):p&&(Ho(t,1)||_u(t,0)),ie(u),$(!1),B(!1),Z(),y(!0),si().catch(()=>{})},[_r,o,t,d==null?void 0:d.bundleQuantity,u,p,r,si,Z,Zc,zs]),{handleStartNewCustomerPurchase:ap,closeExistingBundleChoice:ol,replaceExistingBundle:zc,startNewPersonFromReturningCustomer:Q,startNewCustomerFromExistingBundle:de,handleProductFormSubmit:le}=sM({form:t,launchContext:d,customerAuthenticated:c,open:g,openModal:nl,existingBundleChoiceOpen:re,setExistingBundleChoiceOpen:$,setReturningCustomerPromptOpen:B,setNewCustomerFlowActive:ie,resetBundleEditor:Z,setSelectRequest:S,setActiveSubview:W,closeSubview:_r,existingBundleDiscountPercent:js,setState:Oa,startNewCustomerPurchase:eg,checkExistingBundleBeforeOpen:ee,cancelExistingBundleChoice:rn,confirmExistingBundleReplacement:li,startNewCustomerFlow:Qs});lM({launchContext:d,openModal:nl,refreshCartContext:si});let Ae=(0,Be.useMemo)(()=>({section:n,mount:r,form:t,config:o,labels:s,state:ge,fieldErrors:me,activeSubview:b,cancelExistingBundleChoice:rn,closeSubview:_r,confirmExistingBundleReplacement:li,continueStep:tl,isNewCustomerFlow:ce,isModalOpen:g,openSubview:za,recipientSelectionPending:rp,selectRecipient:$c,startNewCustomerFlow:Qs,startNewCustomerPurchase:ap,getNewCustomerPrice:Pe,setState:Oa,setFieldValue:ci,openSelect:S,impressionKitPrice:Ut,isImpressionKitUpdateFlow:st,isReturnCustomerFlow:zt,reusableImpressionPositions:So,shouldReuseImpressionKit:It,totalPrice:Fc}),[o,b,rn,_r,li,tl,me,t,s,r,ce,g,za,ap,Pe,n,ci,Oa,rp,$c,Qs,ge,Ut,st,zt,So,It,Fc]),_t=g&&X,an=(0,Be.useCallback)(()=>{L(!0),N(!1),R()},[R]);lP({form:t,onSubmit:le}),dM({open:g,existingBundleChoiceOpen:re,returningCustomerPromptOpen:D,layoutRef:J,closeConfirmOpen:P,setCloseConfirmOpen:Y,setReturningCustomerPromptOpen:B,closeExistingBundleChoice:ol,bundleTierUpsellOpen:_t,dismissBundleTierUpsell:an,activeSubview:b,closeSubview:_r,selectRequest:h,closeSelect:Da,removingGuardIndex:E,cancelGuardRemoval:ip,editingGuardIndex:H,closeGuardEditor:on,standaloneGuardEditOpen:z,cancelStandaloneGuard:Fa,bundleCustomizeOpen:te,closeBundleCustomize:op,requestCloseModal:rl});let o2=(0,Be.useMemo)(()=>({bundleQuantity:K,bundleStates:w,currentBundlePackage:Ye,nextBundlePackage:V?null:Se,bundlePackageFor:mt=>Ni(t,mt,o),steps:nn,currentStepIndex:q,goToStep:$a,openGuardEditor:bo,removeGuard:Dc,addIdenticalGuard:()=>el(!0),setGuardColor:(mt,Ka)=>{let Ha=w[mt]||xo;Js(mt,{...Ha,color:Ka})},kitTraysImageUrl:r.dataset.v3KitTraysUrl||"",fromLaunch:Boolean(d),processing:Bc}),[el,K,w,o,Ye,q,t,$a,d,r,Se,bo,Bc,Dc,Js,V,xo,nn]),i2=a?nM:QT;return(0,fM.createPortal)((0,ei.jsxs)(ei.Fragment,{children:[(0,ei.jsx)(qr.Document,{}),(0,ei.jsx)(i2,{v3:o2,onCloseGuardEditor:on,onSaveGuardState:Js,addDisabled:!nn.length,bundleCustomizeOpen:te,bundleQuantity:K,bundleStates:w,identicalGuardState:qs,bundleTierUpsellOpen:_t,existingBundleChoiceOpen:g&&re,existingBundleDiscountPercent:js,config:o,context:Ae,currentBundlePackage:Ye,currentStepIndex:q,fallbackMediaAlt:r.dataset.mediaAlt||"",fallbackMediaUrl:r.dataset.mediaUrl,iconUrl:r.dataset.nextIconUrl,labels:s,modalId:l,onBack:()=>{if(b){_r();return}$a(q-1)},onClose:rl,onAddBundleGuard:()=>el(!1),onAddIdenticalBundleGuard:()=>el(!0),onDismissBundleTierUpsell:an,onAddNewCustomerFromExistingBundle:de,onCloseExistingBundleChoice:ol,onReplaceExistingBundle:zc,onCancelBundleGuard:on,onCancelBundleGuardRemoval:ip,onCloseBundleCustomize:op,onCloseSelect:Da,onCustomizeBundle:tg,onEditBundleGuard:bo,onConfirmBundleGuardRemoval:Co,onRemoveBundleGuard:Dc,onSaveBundleGuard:Js,onCancelStandaloneGuard:Fa,onSaveStandaloneGuard:rg,onSubmit:tp,open:g,processing:Bc,ref:J,selectRequest:h,showNewCustomerActions:!ce,state:ge,status:Oc,steps:nn,thicknessGuideImageUrl:r.dataset.thicknessGuideImageUrl,totalPrice:Fc,editingGuardIndex:H,downgradedBundlePackage:Ce,nextBundlePackage:Se,removingGuardIndex:E,standaloneGuardEditOpen:z,standaloneGuardState:V}),(0,ei.jsx)(wh,{closeIconUrl:o.closeIconUrl,discountPercent:js,onAddNewCustomer:de,onClose:ol,onReplace:zc,open:!g&&re}),(0,ei.jsx)(qT,{closeIconUrl:o.closeIconUrl,dashboardUrl:r.dataset.customerDashboardUrl||"",onAddNewPerson:Q,onClose:()=>B(!1),open:D}),(0,ei.jsx)(jT,{closeIconUrl:o.closeIconUrl,closeLabel:s.closeLabel,open:g&&P,onCancel:()=>Y(!1),onConfirm:ng})]}),document.body)}var UM=T(oe()),IM=T(ua());var aR=f.section`
  max-width: 864px;
  margin-bottom: ${({$card:e})=>e?"0":"24px"};

  ${({$card:e})=>e&&v`
      padding: 24px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 16px rgba(17, 17, 17, 0.08);
    `}

  @media screen and (max-width: 900px) {
    max-width: none;
    margin-bottom: 16px;
    ${({$card:e})=>e&&v`
        display: flex;
        flex-direction: column;
        padding: 24px 16px;
        border: 1px solid #cccccc;
        box-shadow: none;
      `}
  }
`,sR=f.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  max-width: 864px;
  margin-top: ${({$placement:e})=>e==="new-customer"?"0":"24px"};
  margin-bottom: ${({$placement:e})=>e==="new-customer"?"24px":"0"};

  &[hidden] {
    display: none;
  }

  & > button {
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 12px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #111111;
    font-family: var(--font-body-family, "DM Sans", sans-serif);
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    cursor: pointer;
  }

  & > button:hover:not(:disabled) > span:last-child {
    text-decoration: underline;
  }

  & > button:focus-visible {
    outline: 2px solid #111111;
    outline-offset: 4px;
  }

  & > button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  @media screen and (max-width: 900px) {
    & > button {
      font-size: 12px;
      line-height: 24px;
    }
  }
`,lR=f.span`
  display: grid;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  place-items: center;

  & img {
    display: block;
    width: 24px;
    height: 24px;
  }

  ${({$selected:e})=>e&&v`
      border: 1px solid #d9d9d9;
      border-radius: 50%;
    `}
`,cR=f.svg`
  display: ${({$visible:e})=>e?"block":"none"};
  ${({$visible:e})=>e&&v`
      width: 22px;
      height: 22px;
    `}
`,dR=f.div`
  display: grid;
  grid-column: 1;
  grid-row: ${({$variant:e})=>e==="standalone"||e==="linked"?"1":"1 / span 3"};
  width: ${({$variant:e})=>e==="standalone"?"108px":e==="linked"?"40px":"54px"};
  height: ${({$variant:e})=>e==="standalone"?"108px":e==="linked"?"40px":"54px"};
  border-radius: ${({$variant:e})=>e==="linked"?"6px":"8px"};
  place-items: center;
  overflow: hidden;
  background: #f5f5f5;
  color: #111111;
  font-weight: 800;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  ${({$layered:e})=>e&&v`
      position: relative;
      & img {
        position: absolute;
        inset: 0;
        margin: auto;
        max-width: none;
        max-height: none;
      }
    `}

  @media screen and (max-width: 900px) {
    grid-row: 1;
    width: ${({$variant:e})=>e==="standalone"?"96px":"48px"};
    height: ${({$variant:e})=>e==="standalone"?"96px":"48px"};
  }
`,uR=f.button`
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  cursor: pointer;

  ${({$variant:e})=>e&&v`
      min-width: 120px;
      border: 1px solid #c8c8c8;
      background: #ffffff;
      color: #111111;
    `}

  ${({$placement:e})=>(e==="child"||e==="footer")&&v`
      width: 100%;
    `}

  ${({$placement:e,$variant:t})=>e==="line"&&v`
      min-width: 0;
      min-height: 0;
      width: 22px;
      height: 22px;
      padding: 0;
      border: 0;
      border-radius: 0;
      background: transparent;
      font-family: var(--trufit-font-body);
      line-height: 1;
      font-weight: 600;
      text-align: center;
      color: ${t==="remove"?"#111111":"#000000"};

      &:disabled {
        cursor: not-allowed;
        opacity: 0.32;
      }

      @media screen and (max-width: 900px) {
        color: #111111;
      }
    `}

  ${({$editing:e})=>e&&v`
      border-color: #111111;
    `}
`,pR=f.span`
  ${({$iconOnly:e})=>e&&v`
      position: absolute;
      width: 1px;
      height: 1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      white-space: nowrap;
    `}
`,Pt={PersonGroup:aR,Addons:sR,AddonsIcon:lR,ButtonIcon:cR,ChildMedia:dR,Button:uR,ButtonLabel:pR};var Ai=T(k());function gM({type:e,visible:t=!1}){return e==="edit"?(0,Ai.jsxs)(Pt.ButtonIcon,{$visible:t,className:"cart-button-icon",viewBox:"0 0 22 22","aria-hidden":"true",children:[(0,Ai.jsx)("path",{d:"M11 18.33h8.25",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),(0,Ai.jsx)("path",{d:"M15.13 2.64a2 2 0 0 1 2.83 2.83L6.88 16.56 3.3 17.6l1.04-3.58L15.13 2.64Z",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"})]}):(0,Ai.jsxs)(Pt.ButtonIcon,{$visible:t,className:"cart-button-icon",viewBox:"0 0 22 22","aria-hidden":"true",children:[(0,Ai.jsx)("path",{d:"M3.5 6h15",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),(0,Ai.jsx)("path",{d:"M16.83 6v11.67c0 .44-.18.87-.49 1.18-.31.31-.74.48-1.18.48H6.83c-.44 0-.87-.17-1.18-.48a1.67 1.67 0 0 1-.48-1.18V6m2.5 0V4.33c0-.44.17-.86.48-1.18.32-.31.74-.48 1.18-.48h3.34c.44 0 .86.17 1.18.48.31.32.48.74.48 1.18V6",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),(0,Ai.jsx)("path",{d:"M9.33 10.17v5M12.67 10.17v5",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"})]})}var Je=T(oe());function $u(e,t){if(!e)return t;try{return Uo(JSON.parse(e.textContent||""))}catch(r){return t}}function Ou(e){return String(e||"").trim().toLowerCase()}function YM(e){var t;return Ou(e.dataset.cartProductHandle||((t=e.closest("[data-cart-bundle-card]"))==null?void 0:t.dataset.cartProductHandle))}function SM(){return typeof document=="undefined"?[]:$u(document.querySelector("[data-cart-purchase-master-products]"),[])}function Lh(e){return Array.isArray(e)?e.reduce((t,r)=>{var n;if(Array.isArray(r)&&typeof r[0]=="string")return t[r[0]]=r[1],t;if(r&&typeof r=="object"){let o=r,i=String(o.first||o.name||o.key||"");i&&(t[i]=(n=o.last)!=null?n:o.value)}return t},{}):e&&typeof e=="object"?e:{}}function Xh(e){return Lh($u(Array.from(e.children).find(t=>t.matches("[data-cart-line-properties]"))||null,{}))}function yM(e){return Boolean(String(e.dataset.cartAddonGroupId||"").trim())}function Nh(e){return e.filter(t=>!yM(t))}function Eh(e){let t=e.closest("[data-cart-bundle-card][data-cart-item-id]");return t?t.matches(".trufit-cart-child-card")?[t]:Nh([t,...Array.from(t.querySelectorAll(".trufit-cart-child-card[data-cart-bundle-card]"))]):[]}function Mc(e){return e.closest(".trufit-cart-bundle-card[data-cart-bundle-card][data-cart-item-id]")||e.closest("[data-cart-bundle-card][data-cart-item-id]")}function Uc(e){return e.closest("[data-cart-primary-guard-card], [data-cart-bundle-card][data-cart-item-id]")}function Ah(e){let t=Mc(e);return t?Xh(t):{}}function xM(e){let t=e.closest("[data-cart-bundle-card][data-cart-item-id]");return t?Array.from(t.querySelectorAll("[data-cart-bundle-component]")).map((r,n)=>{let o=r.querySelector("img"),i=r.querySelector("[data-cart-component-properties]"),a=$u(i,{});return{compareAtPriceLabel:r.dataset.cartComponentCompareAtPriceLabel||"",imageUrl:(o==null?void 0:o.currentSrc)||(o==null?void 0:o.src)||"",included:r.dataset.cartComponentIncluded==="true",key:r.dataset.cartLineKey||`component-${n}`,variantId:r.dataset.cartComponentVariantId||"",properties:a,basePriceCents:Math.max(0,Number(r.dataset.cartComponentBasePriceCents)||0),priceCents:Math.max(0,Number(r.dataset.cartComponentPriceCents)||0),priceLabel:r.dataset.cartComponentPriceLabel||"",quantity:Math.max(1,Number(r.dataset.cartComponentQuantity)||1),removable:r.dataset.cartComponentRemovable==="true",title:r.dataset.cartComponentTitle||"Bundle item"}}):[]}function bM(e){let t=Mc(e),r=Uc(e);if(!t||!r)return 0;let n=t.querySelector("[data-cart-primary-guard-card]"),i=Nh([n||t,...Array.from(t.querySelectorAll(".trufit-cart-child-card[data-cart-bundle-card]"))].filter((a,s,l)=>l.indexOf(a)===s)).indexOf(r);return i>=0?i:0}function CM(e){let t=Mc(e),r=t?Eh(t).length:0;if(r>0)return r;let n=Ah(e),o=Number(n.__bundleQuantity);return Number.isFinite(o)&&o>0?Math.max(1,Math.floor(o)):1}function B0(e,t,r=""){var s;if(t<1)return null;let n=Ni(document.createElement("form"),t,e);if(n)return n;let o=se((s=e.pricingPalette)==null?void 0:s.baseGuardPrice),i=se(r)||(o>0?o*t:0);return{available:!0,compareAtPrice:"",price:i>0?we(i,"$75"):"",quantity:t,saveLabel:"",title:`${t} ${t===1?"guard":"guards"}`}}function PM(e,t){return e.filter(r=>t.includes(r.key)).map(({key:r,variantId:n,basePriceCents:o,quantity:i,properties:a})=>({key:r,variantId:n,basePriceCents:o!=null?o:0,quantity:i,properties:a}))}function mR(e){var t;return((t=bi(zr(e)))!=null?t:0)>0}function vM(e){return Boolean(Eo(e)&&mR(e))}function fR(e,t){if(!vM(t))return!1;let r=Eo(e),n=Eo(t);if(r&&n&&r!==n)return!1;let o=Ou(e.productHandle),i=Ou(t==null?void 0:t.productHandle);return!(o&&i&&o!==i)}function hR(e,t){return{...e,productGid:t.productGid||e.productGid,productTitle:t.productTitle||e.productTitle,productHandle:t.productHandle||e.productHandle,productImageUrl:t.productImageUrl||e.productImageUrl,variantGids:t.variantGids||e.variantGids,variantLabels:t.variantLabels||e.variantLabels,variantPrices:t.variantPrices||e.variantPrices}}function Z0(e,t,r=SM()){var a;let n=e.initials;if(!n||vM(n))return e;let o=YM(t),i=(a=r.map(s=>({initials:s.initials&&typeof s.initials=="object"?s.initials:void 0,isProductMatch:Boolean(o)&&[s.handle,s.productHandle].some(c=>Ou(c)===o)})).filter(({initials:s})=>fR(n,s)).sort((s,l)=>Number(l.isProductMatch)-Number(s.isProductMatch))[0])==null?void 0:a.initials;return i?{...e,initials:hR(n,i)}:e}function Ic(e,t){for(let r of t){let n=String(e[r]||"").trim();if(n)return n}return""}function Fu(e,t,r){let n=t.trim().toLowerCase(),o=(e||[]).find(i=>String(i.value||"").trim().toLowerCase()===n||String(i.label||"").trim().toLowerCase()===n);return String((o==null?void 0:o.value)||t||r)}function $0(e,t){var i;let r=Xh(e),n=zo(t),o=Ic(r,["Initials","ID tag","Custom ID tag"]);return{...n,purchaseMasterFlow:r.__purchaseMasterFlow==="clinic"?"clinic":n.purchaseMasterFlow,position:Fu(t.positions,Ic(r,["Position"]),n.position),sport:Fu(t.sports,Ic(r,["Sport"]),n.sport),thicknessSize:Fu(t.thicknessSizes,Ic(r,["Thickness Size"]),n.thicknessSize),color:Fu(t.colors,Ic(r,["Color","Guard Color"]),n.color),padColor:Fu(t.padColors,Ic(r,["Pad color","Pad Color","Compression Pad Color"]),n.padColor),initials:o,initialsOptIn:Boolean(o)||Boolean((i=t.initials)==null?void 0:i.isRequired)}}function WM(e){return String(e||"").trim()}var gR=["purchaseMasterFlow","position","sport","thicknessSize","color","padColor","initials"];function wM(e,t){if(!t.initials)return!0;let r=e.closest("[data-cart-person]"),n=Xh(e),o=String(n.__itemId||"").trim(),i=String(n.__parentItemId||o).trim(),a=String(n.__personId||"").trim();return!r||!o||!i?!1:Array.from(r.querySelectorAll("[data-cart-person-line]")).some(s=>{let l=$u(s,{}),c=Lh(l.properties);return c.__purchaseMasterItemRole==="id-tag"&&String(c.__personId||"").trim()===a&&String(c.__parentItemId||"").trim()===i&&String(c.__guardItemId||"").trim()===o&&(!String(c.__itemId||"").trim()||String(c.__itemId||"").trim()===`id-tag-${o}`)&&String(c.Initials||"").trim()===String(t.initials||"").trim()})}function Rh(e,t,r){if(!e||!t)return!1;let n=r?wM(r,t):!0;return gR.every(o=>WM(e[o])===WM(t[o]))&&Boolean(e.initialsOptIn)===Boolean(t.initialsOptIn)&&n}function TM({config:e,mount:t,errorMessage:r}){let n=(0,Je.useMemo)(()=>Z0(e,t),[e,t]),[o,i]=(0,Je.useState)(!1),[a,s]=(0,Je.useState)(null),[l,c]=(0,Je.useState)(null),[d,u]=(0,Je.useState)([]),[p,m]=(0,Je.useState)([]),[g,y]=(0,Je.useState)([]),[P,Y]=(0,Je.useState)([]),[h,S]=(0,Je.useState)([]),[b,W]=(0,Je.useState)(null),[C,w]=(0,Je.useState)(null),[I,U]=(0,Je.useState)(!1),[L,X]=(0,Je.useState)(""),N=t.dataset.cartBundleCustomizerAction==="remove"?"remove":"edit",V=N==="edit"&&t.dataset.cartOpenGuardEditIndex!==void 0,z=(0,Je.useMemo)(()=>P.filter($=>!h.includes($.key)),[P,h]),te=(0,Je.useCallback)($=>{S(D=>D.includes($)?D:[...D,$])},[]),H=(0,Je.useCallback)(()=>{let $=N==="remove"?[Uc(t)].filter(A=>Boolean(A)):Eh(t),D=$.map(A=>$0(A,n)),B=t.dataset.cartOpenGuardEditIndex===void 0?null:Math.max(0,Number(t.dataset.cartOpenGuardEditIndex)||0),J=B!==null&&B<D.length?B:null;if(y($),u(D),m(D),Y(xM(t)),S([]),W(null),w(null),s(N==="remove"?null:J),c(N==="remove"?bM(t):null),N==="remove"){let A=CM(t),O=Ah(t),_=String(O.__bundleTargetPrice||"");W(B0(n,A,_)),w(B0(n,A-1,""))}U(!1),X(""),i(!0)},[N,n,t]),E=(0,Je.useCallback)(()=>{I||(i(!1),s(null),c(null),X(""))},[I]),Z=(0,Je.useCallback)(()=>{if(V){E();return}s(null),X("")},[E,V]),ce=(0,Je.useCallback)(async($,D)=>{if(V){let B=window.TruFitCartBundleEditor,J=g[$]||Uc(t);if(!B||!J){X(r);return}if(Rh(p[$],D,J)){E();return}U(!0),X("");try{await B.updateBundle([{card:J,config:n,state:D}],[]),E()}catch(A){U(!1),X(r)}return}u(B=>B.map((J,A)=>A===$?D:J)),s(null),X("")},[E,r,g,p,V,t,n]),ie=(0,Je.useCallback)(async()=>{let $=window.TruFitCartBundleEditor;if(!$||g.length!==d.length){X(r);return}U(!0),X("");try{let D=PM(P,h),B=g.map((J,A)=>({card:J,config:n,index:A,state:d[A],changed:!Rh(p[A],d[A],J)})).filter(J=>J.changed||D.length&&J.index===0);if(!B.length&&!D.length){U(!1),E();return}await $.updateBundle(B.map(({card:J,config:A,state:O})=>({card:J,config:A,state:O})),D),E()}catch(D){U(!1),X(r)}},[d,E,P,r,g,p,h,n]),re=(0,Je.useCallback)(async()=>{let $=window.TruFitCartBundleEditor,D=Mc(t),B=Uc(t)||(l!==null?g[l]:null)||g[0],J=D||B;if(!($!=null&&$.removeGuard)||!J||!B||!C){X(r);return}U(!0),X("");try{await $.removeGuard({card:J,targetCard:B,config:n,downgradedPackage:C}),E()}catch(A){U(!1),X(r)}},[E,C,g,r,t,l,n]);return(0,Je.useEffect)(()=>{if(!o)return;let $=document.documentElement.style.overflow;return document.documentElement.style.overflow="hidden",()=>{document.documentElement.style.overflow=$}},[o]),(0,Je.useEffect)(()=>{if(!o)return;let $=D=>{if(D.key==="Escape"){if(l!==null){E();return}if(a!==null){Z();return}E()}};return document.addEventListener("keydown",$),()=>document.removeEventListener("keydown",$)},[Z,E,a,o,l]),{action:N,open:o,resolvedConfig:n,bundleStates:d,visibleComponents:z,currentPackage:b,downgradedPackage:C,editingGuardIndex:a,removingGuardIndex:l,saving:I,status:L,openModal:H,closeModal:E,cancelGuardEdit:Z,saveGuard:ce,saveBundle:ie,confirmGuardRemoval:re,setEditingGuardIndex:s,setRemovingGuardIndex:c,removeBundleComponent:te}}var Zn=T(k()),MM={addLabel:"Add to cart",addErrorMessage:"Unable to update this bundle.",backLabel:"Back",closeLabel:"Close",continueLabel:"Continue",priceLabel:"Total",processingLabel:"Saving...",progressLabel:"Bundle customization progress",requiredMessage:"Please complete the required selection.",impressionKitHint:"",impressionKitHelpLabel:"",impressionKitSizeLabel:"",impressionKitTitle:"",clinicMapAlt:"",clinicMapCloseLabel:"Close",clinicMapViewLabel:"",reviewLabel:"",reviewText:"",selectValueLabel:"Select value",summaryEmptyLabel:""};function VM({config:e,mount:t}){let{action:r,open:n,resolvedConfig:o,bundleStates:i,visibleComponents:a,currentPackage:s,downgradedPackage:l,editingGuardIndex:c,removingGuardIndex:d,saving:u,status:p,openModal:m,closeModal:g,cancelGuardEdit:y,saveGuard:P,saveBundle:Y,confirmGuardRemoval:h,setEditingGuardIndex:S,setRemovingGuardIndex:b,removeBundleComponent:W}=TM({config:e,mount:t,errorMessage:MM.addErrorMessage}),C=t.dataset.fallbackMediaUrl||"",w=t.dataset.thicknessGuideImageUrl||"",I=t.closest(".trufit-cart-child__line-actions")?"line":t.closest(".trufit-cart-child__actions")?"child":t.closest(".trufit-cart-bundle__footer")?"footer":"bundle",U=I==="line",L=(0,UM.useMemo)(()=>n?(0,IM.createPortal)((0,Zn.jsxs)(Zn.Fragment,{children:[(0,Zn.jsx)(qr.Document,{}),(0,Zn.jsx)(vh,{allowBundleChanges:r==="remove",bundleComponents:a,bundleStates:i,config:o,currentPackage:s,downgradedPackage:l,editingGuardIndex:c,fallbackMediaUrl:C,thicknessGuideImageUrl:w,labels:MM,nextPackage:null,onAddGuard:()=>{},onAddIdenticalGuard:()=>{},onCancelEdit:y,onCancelRemove:g,onClose:g,onDone:()=>void Y(),onConfirmRemove:h,onEdit:S,onRemove:b,onRemoveBundleComponent:W,onSave:P,removingGuardIndex:d,saving:u,status:p})]}),document.body):null,[i,y,g,a,r,h,s,l,c,C,w,n,W,d,Y,P,S,b,u,p,o]);return(0,Zn.jsxs)(Zn.Fragment,{children:[(0,Zn.jsxs)(Pt.Button,{$variant:r==="remove"?"remove":"secondary",$placement:I,type:"button",className:"cart-button cart-button-secondary","aria-haspopup":"dialog","aria-expanded":n,onClick:m,children:[(0,Zn.jsx)(gM,{type:r==="remove"?"remove":"edit",visible:U}),(0,Zn.jsx)(Pt.ButtonLabel,{$iconOnly:U,className:"cart-button-label",children:r==="remove"?"Remove":"Edit"})]}),L]})}var wn=T(oe()),kM=T(ua());var _s=T(k()),YR={closeLabel:"Close"};function LM({config:e,context:t,form:r,onClose:n,previewImageUrl:o,thicknessGuideImageUrl:i}){let[a]=(0,wn.useState)(()=>{var y,P;return{...zo(e),recipientType:"someoneElse",recipientFirstName:((y=t.person)==null?void 0:y.firstName)||"",recipientLastName:((P=t.person)==null?void 0:P.lastName)||""}}),[s,l]=(0,wn.useState)(!1),[c,d]=(0,wn.useState)(""),u=(0,wn.useRef)(null),p=(0,wn.useRef)(!1),m=(0,wn.useCallback)(()=>{var y;!s&&!((y=u.current)!=null&&y.sent)&&n()},[n,s]),g=(0,wn.useCallback)(async y=>{if(!p.current){p.current=!0,l(!0),d("");try{if(await VW(),!u.current){let P=au(e,y,r,{bundleStates:[y],standaloneGuardOnly:!0,targetPerson:t.person?{...t.person,hasImpressionKit:!0}:void 0});if(!P.length)throw new Error("No configured cart items were found");u.current={items:P,sent:!1}}await cf(u.current.items,u.current),u.current=null,n()}catch(P){Gl("cart-addon",P),P instanceof mn||(u.current=null),l(!1),d(P instanceof mn?P.message:"Unable to add this product. Please try again.")}finally{p.current=!1}}},[e,t.person,r,n]);return(0,wn.useEffect)(()=>{let y=document.documentElement.style.overflow;return document.documentElement.style.overflow="hidden",()=>{document.documentElement.style.overflow=y}},[]),(0,wn.useEffect)(()=>{let y=P=>{P.key==="Escape"&&m()};return document.addEventListener("keydown",y),()=>document.removeEventListener("keydown",y)},[m]),(0,kM.createPortal)((0,_s.jsxs)(_s.Fragment,{children:[(0,_s.jsx)(qr.Document,{}),(0,_s.jsx)(Qo,{config:e,externalStatus:c,guardIndex:0,initialState:a,labels:YR,previewImageUrl:o,thicknessGuideImageUrl:i,saving:s,savingLabel:"Adding...",onCancel:m,onSave:g})]}),document.body)}var XM="trufit-dashboard-person-context-v2",NM="trufit-purchase-master-styled-runtime-v1";var Ri=T(k());function SR(e,t){return e.querySelector(".trufit-main-product__form")||document.querySelector(t.dataset.formSelector||".trufit-main-product__form")}function GM(e,t){e.initials&&t.dataset.initialsPrice&&!e.initials.variantPrices&&(e.initials.variantPrices=t.dataset.initialsPrice)}function _M(e,t){t.dataset.bracesWarningImageUrl&&(e.bracesWarningImageUrl=t.dataset.bracesWarningImageUrl),t.dataset.mobileThicknessGuideImageUrl&&(e.mobileThicknessGuideImageUrl=t.dataset.mobileThicknessGuideImageUrl),t.dataset.personDetailsImageUrl&&(e.personDetailsImageUrl=t.dataset.personDetailsImageUrl),t.dataset.personDetailsMobileImageUrl&&(e.personDetailsMobileImageUrl=t.dataset.personDetailsMobileImageUrl),t.dataset.clinicMapImageUrl&&(e.clinicMapImageUrl=t.dataset.clinicMapImageUrl)}function EM(e){let t=e;if(!t||t.dataset.purchaseMasterInitialized==="true")return;let r=t.closest("[data-purchase-master-section]")||document,n=$d(t);if(!n||!n.isPurchaseMasterEnabled)return;GM(n,t),_M(n,t);let o=SR(r,t);if(!o)return;let i=document.createElement("div");i.setAttribute("data-trufit-purchase-master-react-root",""),t.appendChild(i);let a=(0,zu.createRoot)(i);a.render((0,Ri.jsx)(Mn,{appearance:document.querySelector("[data-trufit-cart-root]")?"cart":"purchase-master",children:(0,Ri.jsx)(hM,{config:n,form:o,mount:t,section:r})})),t.dataset.purchaseMasterInitialized="true",t._trufitPurchaseMasterRoot=a,t._trufitPurchaseMasterRootNode=i}function AM(e){let t=e;if(t.dataset.cartBundleCustomizeInitialized==="true")return;let r=$d(t);if(!r)return;let n=document.createElement("div");n.setAttribute("data-trufit-cart-bundle-customize-react-root",""),t.appendChild(n);let o=(0,zu.createRoot)(n);o.render((0,Ri.jsx)(Mn,{appearance:"cart",children:(0,Ri.jsx)(VM,{config:r,mount:t})})),t.dataset.cartBundleCustomizeInitialized="true",t._trufitCartBundleCustomizeRoot=o,t._trufitCartBundleCustomizeRootNode=n}function BM(e){let r=new DOMParser().parseFromString(e,"text/html").querySelector("[data-purchase-master-section]"),n=r==null?void 0:r.querySelector(".trufit-main-product__form"),o=r==null?void 0:r.querySelector("[data-trufit-purchase-master]");if(!r||!n||!o)throw new Error("Purchase Master is not configured for this product.");return{sourceForm:n,sourceMount:o,sourceSection:r}}async function ZM(e){let t=await fetch(e,{credentials:"same-origin",headers:{Accept:"text/html"}});if(!t.ok)throw new Error("Purchase Master product page could not be loaded.");return BM(await t.text())}function Vc(e){let t=e||document;t instanceof Element&&t.matches("[data-trufit-purchase-master]")&&EM(t),t.querySelectorAll("[data-trufit-purchase-master]").forEach(r=>EM(r)),t instanceof Element&&t.matches("[data-trufit-cart-bundle-customizer]")&&AM(t),t.querySelectorAll("[data-trufit-cart-bundle-customizer]").forEach(r=>AM(r))}function Du(e){let t=e||document,r=[];t instanceof Element&&t.matches("[data-trufit-purchase-master]")&&r.push(t),t.querySelectorAll("[data-trufit-purchase-master]").forEach(a=>r.push(a)),r.forEach(a=>{var l,c;let s=a;(l=s._trufitPurchaseMasterRoot)==null||l.unmount(),(c=s._trufitPurchaseMasterRootNode)==null||c.remove(),s._trufitPurchaseMasterRoot=null,s._trufitPurchaseMasterRootNode=null,delete s.dataset.purchaseMasterInitialized});let n=[];t instanceof Element&&t.matches("[data-trufit-cart-bundle-customizer]")&&n.push(t),t.querySelectorAll("[data-trufit-cart-bundle-customizer]").forEach(a=>n.push(a)),n.forEach(a=>{var l,c;let s=a;(l=s._trufitCartBundleCustomizeRoot)==null||l.unmount(),(c=s._trufitCartBundleCustomizeRootNode)==null||c.remove(),s._trufitCartBundleCustomizeRoot=null,s._trufitCartBundleCustomizeRootNode=null,delete s.dataset.cartBundleCustomizeInitialized});let o=[];t instanceof Element&&t.matches("[data-cart-purchase-master-host]")&&o.push(t),t.querySelectorAll("[data-cart-purchase-master-host]").forEach(a=>o.push(a)),o.forEach(a=>{var l,c;let s=a;(l=s._trufitCartAddonCustomizeRoot)==null||l.unmount(),(c=s._trufitCartAddonCustomizeRootNode)==null||c.remove(),s._trufitCartAddonCustomizeRoot=null,s._trufitCartAddonCustomizeRootNode=null});let i=[];t instanceof Element&&t.matches("[data-cart-new-customer-modal-host]")&&i.push(t),t.querySelectorAll("[data-cart-new-customer-modal-host]").forEach(a=>i.push(a)),i.forEach(a=>{var l,c;let s=a;(l=s._trufitNewCustomerModalRoot)==null||l.unmount(),(c=s._trufitNewCustomerModalRootNode)==null||c.remove(),s._trufitNewCustomerModalRoot=null,s._trufitNewCustomerModalRootNode=null,s.hidden=!0})}function yR({config:e,products:t,initialProductKey:r,getPrice:n,copy:o,title:i,host:a,onAdd:s}){var p,m;let l=a;(p=l._trufitNewCustomerModalRoot)==null||p.unmount(),(m=l._trufitNewCustomerModalRootNode)==null||m.remove(),l.hidden=!1;let c=document.createElement("div");c.setAttribute("data-trufit-new-customer-modal-root",""),l.append(c);let d=(0,zu.createRoot)(c),u=()=>{l._trufitNewCustomerModalRoot===d&&(d.unmount(),c.remove(),l._trufitNewCustomerModalRoot=null,l._trufitNewCustomerModalRootNode=null,l.hidden=!0)};return l._trufitNewCustomerModalRoot=d,l._trufitNewCustomerModalRootNode=c,d.render((0,Ri.jsx)(Mn,{appearance:document.querySelector("[data-trufit-cart-root]")?"cart":"purchase-master",children:(0,Ri.jsx)(Sc,{config:e,products:t,initialProductKey:r,getPrice:n,copy:o,title:i,onAdd:s,onClose:u})})),{close:u}}function $M({cartBridgeUrl:e,cartUrl:t,context:r,host:n,source:o}){let{sourceForm:i,sourceMount:a,sourceSection:s}=o;Du(n),n.replaceChildren();let l=s.cloneNode(!1),c=i.cloneNode(!0),d=a.cloneNode(!0);delete d.dataset.purchaseMasterInitialized,t&&(l.dataset.cartUrl=t,d.dataset.cartUrl=t),e?(d.dataset.cartBridgeUrl=e,d.dataset.purchaseMasterV3Dashboard!=="true"&&(d.dataset.purchaseMasterLayout="classic",d.dataset.purchaseMasterLayoutLocked="true")):delete d.dataset.cartBridgeUrl;let u=$d(d);if(!u||!u.isPurchaseMasterEnabled)throw new Error("Purchase Master is not enabled for this product.");if(l.append(c,d),n.append(l),!yc(r))throw n.replaceChildren(),new Error("Purchase Master launch context could not be stored.");if(Vc(n),d.dataset.purchaseMasterInitialized!=="true")throw n.replaceChildren(),new Error("Purchase Master could not be initialized.");return!0}async function xR({cartUrl:e,context:t,host:r,productUrl:n}){return $M({cartUrl:e,context:t,host:r,source:await ZM(n)})}async function bR(e){return $M({cartBridgeUrl:e.cartBridgeUrl,cartUrl:e.cartUrl,context:e.context,host:e.host,source:BM(e.productHtml)})}async function CR({context:e,host:t,productUrl:r}){var p;let{sourceForm:n,sourceMount:o}=await ZM(r),i=t,a=n.cloneNode(!0),s=o.cloneNode(!0),l=$d(s);if(!l||!l.isPurchaseMasterEnabled)throw new Error("Purchase Master is not enabled for this product.");GM(l,s),_M(l,s),Du(i),i.replaceChildren();let c=document.createElement("div");c.setAttribute("data-trufit-cart-addon-customize-react-root",""),i.append(c);let d=(0,zu.createRoot)(c),u=()=>{window.setTimeout(()=>{i._trufitCartAddonCustomizeRoot===d&&(d.unmount(),c.remove(),i._trufitCartAddonCustomizeRoot=null,i._trufitCartAddonCustomizeRootNode=null)},0)};return i._trufitCartAddonCustomizeRoot=d,i._trufitCartAddonCustomizeRootNode=c,d.render((0,Ri.jsx)(Mn,{appearance:"cart",children:(0,Ri.jsx)(LM,{config:l,context:e,form:a,previewImageUrl:s.dataset.mediaUrl||((p=l.currentProduct)==null?void 0:p.imageUrl)||"",thicknessGuideImageUrl:s.dataset.thicknessGuideImageUrl,onClose:u})})),!0}function RM(e){let t=e.detail;return Array.isArray(t==null?void 0:t.elements)&&t.elements.length?t.elements:[document]}function OM(){let e=window;e.trufitPurchaseMasterWidgetReady||(e.trufitPurchaseMasterWidgetReady=!0,e.TruFitPurchaseMaster={capabilities:[XM,NM],destroy:Du,init:Vc,launchCartAddonCustomization:CR,openNewCustomerModal:yR,launchFromProductPage:xR,launchFromProductSource:bR},document.readyState==="loading"?document.addEventListener("DOMContentLoaded",()=>{Vc(document)}):Vc(document),document.addEventListener("shopify:section:load",t=>{Vc(t.target)}),document.addEventListener("shopify:section:unload",t=>{Du(t.target)}),document.addEventListener("trufit:cart-sections-will-render",t=>{RM(t).forEach(r=>Du(r))}),document.addEventListener("trufit:cart-sections-rendered",t=>{RM(t).forEach(r=>Vc(r))}))}var t2=T(PS());var O0=globalThis,Ku=O0.__trufitReactCartStore||(O0.__trufitReactCartStore={snapshot:null,listeners:new Set});function Hu(){return Ku.snapshot}function FM(e){return Ku.listeners.add(e),()=>Ku.listeners.delete(e)}function DM(e){if(Ku.snapshot=e,Ku.listeners.forEach(t=>t()),typeof window!="undefined"){window.dispatchEvent(new CustomEvent("trufit:cart-state",{detail:e}));let t=xe(e).some(r=>{var n;return r.quantity>0&&((n=r.properties)==null?void 0:n.__trufit_reward_gift)!=="true"});window.dispatchEvent(new CustomEvent("trufit:cart-updated",{detail:{hasVisibleItems:t,itemCount:Number(e.item_count||0)}}))}}var $i=T(oe());var PR=f.section`
  min-height: 920px;
  background: #f8f8f8;
  border-top: 0.5px solid #888888;
  color: #111111;
  font-family: var(--trufit-font-body);

  & [hidden] {
    display: none !important;
  }

  & h1 {
    margin: 0 0 22px;
    font-size: 32px;
    line-height: 1.18;
    font-weight: 400;
    letter-spacing: 0;
  }

  & button[aria-busy="true"] {
    cursor: wait;
    opacity: 0.7;
  }

  @media screen and (max-width: 900px) {
    min-height: auto;
    background: #ffffff;
    & h1 {
      margin-bottom: 20px;
      font-size: 22px;
      line-height: 1.1;
      font-weight: 400;
    }
  }
`,WR=f.div`
  display: block;
  margin: 0;

  @media screen and (max-width: 900px) {
    padding-bottom: calc(144px + env(safe-area-inset-bottom));
  }
`,vR=f.div`
  display: grid;
  grid-template-columns: minmax(0, 960px) 480px;
  max-width: 1440px;
  margin: 0 auto;

  @media screen and (max-width: 1180px) {
    grid-template-columns: 1fr;
  }
`,wR=f.main`
  padding: 36px 48px 120px;

  @media screen and (max-width: 900px) {
    padding: 24px var(--trufit-mobile-page-padding-x) 0;
    padding-inline: var(--trufit-mobile-page-padding-x);
  }
`,TR=f.div`
  display: grid;
  gap: 8px;
  margin-bottom: 12px;
  color: #b42318;
  font-size: 14px;
  line-height: 20px;

  & p {
    margin: 0;
  }

  @media screen and (max-width: 900px) {
    & {
      width: 100%;
      margin-bottom: 0;
    }
  }
`,MR=f.div`
  display: grid;
  gap: 12px;
  max-width: 864px;
  padding: 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(17, 17, 17, 0.08);

  & h2 {
    margin: 0;
  }

  & p {
    margin: 0;
  }

  & a {
    width: max-content;
    margin-top: 8px;
    color: #111111;
    font-weight: 700;
  }
`,UR=f.section`
  max-width: 864px;
  margin-bottom: 24px;
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(17, 17, 17, 0.08);

  & h2 {
    margin: 0 0 24px;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media screen and (max-width: 900px) {
    padding: 18px;
  }
`,IR=f.div`
  display: grid;
`,ti={Cart:PR,Form:WR,Shell:vR,Content:wR,OperationStatus:TR,Empty:MR,Accessories:UR,AccessoriesList:IR};var zM=f.button`
  padding: 5px 2px;
  border: 0;
  background: transparent;
  color: #555;
  font-size: 13px;
  text-decoration: underline;
  text-underline-offset: 3px;
  &:hover {
    color: #111;
  }
`,VR=f(zM)`
  color: #9f2e24;
  &:hover {
    color: #751e18;
  }
`,kR=f.img`
  display: block;
  width: 72px;
  height: 72px;
  flex: 0 0 auto;
  border-radius: 8px;
  background: #f5f5f5;
  object-fit: contain;
  @media (max-width: 749px) {
    width: 58px;
    height: 58px;
  }
`,LR=f.img`
  display: block;
  width: 20px;
  height: 20px;
  object-fit: contain;
`,XR=f.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  min-height: 62px;
  padding: 11px 18px;
  & + & {
    border-top: 1px solid #ededed;
  }
  @media (max-width: 749px) {
    padding: 10px 14px;
  }
`,NR=f.div`
  display: grid;
  gap: 4px;
  min-width: 0;
  strong {
    overflow-wrap: anywhere;
    font-size: 14px;
    font-weight: 500;
  }
  small {
    color: #737373;
    font-size: 12px;
    line-height: 1.35;
  }
`,ER=f.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  strong {
    white-space: nowrap;
    font-size: 14px;
  }
`,AR=f.s`
  color: #777;
  white-space: nowrap;
  font-size: 13px;
`,RR=f.details`
  margin-top: 3px;
  color: #555;
  font-size: 12px;
  summary {
    width: max-content;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  dl {
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr);
    gap: 4px 10px;
    margin: 8px 0 0;
  }
  dt {
    color: #777;
  }
  dd {
    min-width: 0;
    margin: 0;
    overflow-wrap: anywhere;
    color: #222;
  }
`,GR=f.div`
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d9d9d9;
  border-radius: 999px;
  background: #fff;
  button {
    display: grid;
    width: 32px;
    height: 32px;
    place-items: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: #171717;
    font-size: 18px;
  }
  button:disabled {
    color: #aaa;
    cursor: not-allowed;
  }
  span {
    min-width: 26px;
    text-align: center;
    font-size: 13px;
  }
`,_R=f.p`
  margin: 12px 0 0;
  color: ${({$kind:e})=>e==="success"?"#22643d":"#9f2e24"};
  font-size: 13px;
`,Ar={TextButton:zM,DangerButton:VR,ProductImage:kR,ActionIcon:LR,LineRow:XR,LineInfo:NR,LineControls:ER,ComparePrice:AR,LineDetails:RR,QuantityControl:GR,StatusMessage:_R};function ri(e,...t){for(let r of t){let n=e[r];if(n!=null&&String(n).trim())return String(n).trim()}return""}function Gh(e){return["guard","guards","insole","insoles"].includes(e)}function Jr(e,t){let r=e.product,n=String(e.handle||(r==null?void 0:r.handle)||"");return t.find(o=>{var i;return n&&o.productHandle===n||e.product_id&&((i=o.productGid)==null?void 0:i.split("/").pop())===String(e.product_id)})||null}function BR(e,t){let r=xe(t.snapshot).find(n=>n.product_id&&String(n.product_id)===String(e.product_id));return t.lineMeta[e.key]||(r?t.lineMeta[r.key]:void 0)||{}}function Gi(e,t){var r;return((r=Jr(e,t.catalog))==null?void 0:r.purchaseMasterOptions)||BR(e,t).productOptions}function ut(e){return Gh(he(e).category)}function vr(e){let t=he(e),r=t.properties;return r.__purchaseMasterPaidGuardAddon==="true"||r.__purchaseMasterAddonType==="guard"||Gh(t.category)&&["cart-addon-product","paid-bundle-accessory"].includes(r.__purchaseMasterItemRole)}function Aa(e){let t=he(e).properties;return t.__purchaseMasterCustomerType==="return"||t.__bundleRole==="return"||t.__purchaseMasterReturnCustomer==="true"||String(e.variant_title||"").toLowerCase().split(/[^a-z0-9]+/).includes("return")}function _h(e,t){var o,i;let r=he(e),n=r.properties;return Gh(r.category)&&!vr(e)?!0:n.__purchaseMasterSource==="online-store"?(n.__purchaseMasterItemRole==="impression-kit"||r.category==="impressionkits")&&!Aa(t)&&!Aa(e)?!0:Number((i=(o=e.final_line_price)!=null?o:e.line_price)!=null?i:0)===0:n.__bundleIncluded==="true"}function Bs(e){return Te(e,"__purchaseMasterItemRole")==="id-tag"}function Bh(e,t){let r=Te(e,"__guardItemId")||Te(e,"__itemId").replace(/^id-tag-/,"");return t.find(n=>Te(n,"__itemId")===r)||t[0]}function Zh(e){return e.items.some(t=>{let r=he(t);return ri(r.properties,"__trufit_reward_gift")!=="true"&&!r.parentItemId&&!("_trufitCartAddon"in r.properties)&&!(r.itemId&&r.personId&&["extraproducts","impressionkits"].includes(r.category))})}function Ra(e){return Te(e,"__trufit_reward_gift")==="true"}function KM(e){return xe(e).filter(t=>!Ra(t))}function $h(e,t){var i;let r=he(e),n=r.properties;if(r.personId)return!1;if((i=t.lineMeta[e.key])!=null&&i.isAccessory||ri(n,"_trufitCartAccessory")==="true"||ri(n,"_trufitCartAddon")==="true"||ri(n,"__purchaseMasterItemRole")==="cart-addon-product")return!0;let o=Gi(e,t);return String((o==null?void 0:o.productType)||"").toLowerCase()==="accessory"||t.ui.recommendations.some(a=>a.productId===String(e.product_id))}function ZR(e){let t=he(e),r=ri(t.properties,"__purchaseMasterItemRole");return Boolean(t.parentItemId&&r!=="cart-addon-product"||["extraproducts","impressionkits"].includes(t.category)||r==="impression-kit"||r==="id-tag"||r==="edge-type")}function $R(e,t){let r=Number(ri(t,"__personCreatedAt"));if(Number.isFinite(r)&&r>0)return r;let n=Number(e.split("-")[0]);return Number.isFinite(n)?n:Number.MAX_SAFE_INTEGER}function F0(e,t){let r=KM(e),n=new Map(r.map(i=>[i,he(i)])),o=new Map;return r.forEach(i=>{let a=n.get(i);if($h(i,t)||ZR(i)||!a.isPurchaseMaster||!a.personId)return;let s=o.get(a.personId)||[];s.push(i),o.set(a.personId,s)}),[...o.entries()].map(([i,a])=>{a.sort((u,p)=>{var y,P,Y,h;let m=vr(u),g=vr(p);return m!==g?Number(m)-Number(g):m?Number((P=(y=p.final_line_price)!=null?y:p.line_price)!=null?P:0)-Number((h=(Y=u.final_line_price)!=null?Y:u.line_price)!=null?h:0):0});let s=new Set(a.map(u=>n.get(u).itemId)),l=r.filter(u=>{let p=n.get(u);return p.personId===i||p.itemId===i||p.parentItemId===i||s.has(p.parentItemId)}),c=a[0],d=n.get(c).properties;return{id:i,createdAt:$R(i,d),personNumber:ri(d,"__personNumber"),firstName:ri(d,"First name"),lastName:ri(d,"Last name"),lines:l,roots:a}}).sort((i,a)=>i.createdAt-a.createdAt)}function HM(e,t){let r=KM(e),n=F0(e,t),o=new Set(n.flatMap(i=>i.lines.map(a=>a.key)));return r.filter(i=>!o.has(i.key))}function en(e,t){let r=he(t),n=i=>{let a=he(i);return a.personId===r.personId&&!a.parentItemId&&Boolean(a.itemId)&&Gh(a.category)&&a.properties.__purchaseMasterItemRole!=="cart-addon-product"},o=e.lines.filter(n);return e.lines.filter(i=>{var c;if(i.key===t.key)return!0;let a=he(i);if(a.personId!==r.personId||((c=i.properties)==null?void 0:c.__purchaseMasterItemRole)==="cart-addon-product")return!1;if(a.parentItemId===r.itemId||a.personId===e.id&&a.itemId===r.itemId)return!0;let s=a.category.replace(/[^a-z]/g,"");return(a.properties.__purchaseMasterItemRole==="impression-kit"||s==="impressionkits")&&a.personId===r.personId&&!a.parentItemId&&o.length===1&&o[0].key===t.key})}function QM(e){return e.reduce((t,r)=>t+Math.max(0,Number(r.quantity)||0),0)}function Rr(e){let t=e.product;return String(e.product_title||e.title||(t==null?void 0:t.title)||"Product")}function Te(e,...t){return ri(he(e).properties,...t)}function Ga(){if(!window.TrufitCart)throw new Error("Cart is still loading. Please try again.");return window.TrufitCart}function At(e){return{key:e.key,variant_id:e.variant_id,quantity:e.quantity,properties:e.properties||{}}}async function wr(e){let t=Ga().transaction;if(!t)throw new Error("Cart updates are unavailable.");return t(e)}function Rt(e){return e.properties||{}}function pr(e,t){let r=he(t),n=xe(e).filter(o=>{let i=he(o);return i.isPurchaseMaster&&i.personId===r.personId&&i.itemId===r.itemId&&i.parentItemId===r.parentItemId&&i.category===r.category});if(n.length!==1)throw new Error("This guard changed in another cart update. Refresh and try again.");return n[0]}function D0(e){let t=Rt(e);return String(t.__purchaseMasterItemRole||"").trim().toLowerCase()==="id-tag"}function _i(e,t){let r=Rt(t),n=String(r.__personId||"").trim(),o=String(r.__itemId||"").trim(),i=String(r.__parentItemId||o).trim();return xe(e).filter(a=>{if(!D0(a))return!1;let s=Rt(a),l=String(s.__guardItemId||s.__itemId||"").trim();return String(s.__personId||"").trim()===n&&String(s.__parentItemId||"").trim()===i&&(l===o||!s.__guardItemId&&l===`id-tag-${o}`)})}function kc(e){var r,n,o;let t=e;return Math.max(0,Number((o=(n=(r=t.original_line_price)!=null?r:t.final_line_price)!=null?n:t.line_price)!=null?o:0)||0)}function ni(e){let t=bi(String(e!=null?e:""));return t===null?0:Math.max(0,t)}function OR(e,t){let r=Rt(e),n={};["__personId","__personCreatedAt","__isDefaultPerson","__personNumber","__purchaseMasterSource","__purchaseMasterFlow","_trufitCartAddonGroupId","First name","Last name"].forEach(i=>{let a=r[i];a&&(n[i]=a)});let o=String(r.__itemId||"").trim();return n.__parentItemId=String(r.__parentItemId||o),n.__category="extraProducts",n.__purchaseMasterItemRole="id-tag",n.__itemId=`id-tag-${o}`,n.__guardItemId=o,n.Initials=t,n}function jM(e,t,r){let n=t.find(i=>i.productHandle===String(e.handle||"")),o=n==null?void 0:n.initials;return o!=null&&o.variantGids?o:o||r}function FR(e,t,r){let n=xe(e).filter(o=>{let i=Rt(o);return D0(o)&&String(i.__personId||"")===t.__personId&&String(i.__parentItemId||"")===t.__parentItemId&&String(i.__guardItemId||"")===t.__guardItemId&&String(i.Initials||"")===t.Initials});if(n.length!==1)throw new Error(r);return n[0]}async function DR(e,t,r,n){var g;let o=r.__purchaseMasterVariantModel==="shop-v2"||r.__bundleTransform==="shop-v2",i=String(r.__parentItemId||r.__itemId||"").trim(),a=xe(t).find(y=>{let P=Rt(y);return String(P.__itemId||"").trim()===i&&!String(P.__parentItemId||"").trim()}),s=((g=a==null?void 0:a.properties)==null?void 0:g.__purchaseMasterItemRole)==="cart-addon-product";if(!n||!a||o||s)return t;let l={...Rt(a)},c=ni(l.__bundleTargetPrice);if(!c)throw new Error("Bundle target price is unavailable.");let d=ni(l.__bundleCompareAtPrice),u=Math.max(0,Math.min(100,Number(l.__newCustomerDiscountPercent||0))),p=Math.max(1,Number(a.quantity)||1),m=d>0?Math.round(n*(100-u)/100):n;return l.__bundleTargetPrice=(Math.max(0,Math.round(c+m/p))/100).toFixed(2),d>0&&(l.__bundleCompareAtPrice=(Math.max(0,Math.round(d+n/p))/100).toFixed(2)),l.__bundleTargetIncludesExtras="true",e.change(At(a),{properties:l})}async function qM(e,t,r,n,o){let i=ao(r),a=e.read(),s=pr(a,t),l=_i(a,s),c=l[0],d=jM(s,n,o),u=Rt(s);if(!String(u.__personId||"").trim()||!String(u.__itemId||"").trim())throw new Error("This guard is missing its Purchase Master identity.");let p=Eo(d),m=ni(zr(d));if(i&&!c&&(!p||m<=0))throw new Error("ID Tag variant or price is unavailable.");let g;if(i){let S=OR(s,i);a=c?await e.change(At(c),{quantity:1,properties:S}):await e.add([{id:p,quantity:1,properties:S}]),g=FR(a,S,c?"ID Tag update could not be confirmed.":"ID Tag addition could not be confirmed.")}let y=_i(a,s).filter(S=>S.key!==(g==null?void 0:g.key));y.length&&(a=await e.remove(y.map(At)));let P=l.reduce((S,b)=>S+kc(b),0),Y=g?kc(g)||m:0;a=await DR(e,a,u,Y-P);let h=_i(a,pr(a,s));if(i&&(h.length!==1||String(Rt(h[0]).Initials||"")!==i))throw new Error("ID Tag update could not be confirmed.");if(!i&&h.length)throw new Error("ID Tag removal could not be confirmed.")}async function z0(e,t,r,n){return wr(async o=>{let i=pr(o.read(),e),a={...Rt(i)};["Position","Sport","Thickness Size","Color","Pad color"].forEach(p=>{let m=String(t[p]||"").trim();m?a[p]=m:delete a[p]});let l=ao(String(t.Initials||""));["Initials","ID tag","Custom ID tag"].forEach(p=>delete a[p]),l?a.Initials=l:delete a.__initialsColor;let c=jM(i,r,n);if(l&&!_i(o.read(),i).length&&(!Eo(c)||!ni(zr(c))))throw new Error("ID Tag variant or price is unavailable.");let d=await o.change(At(i),{properties:a}),u=pr(d,i);await qM(o,u,l,r,n)})}async function K0(e,t){return wr(async r=>{let n=pr(r.read(),e);await qM(r,n,"",t);let o=pr(r.read(),n),i={...Rt(o)};["Initials","ID tag","Custom ID tag","__initialsColor"].forEach(a=>delete i[a]),await r.change(At(o),{properties:i})})}function JM(e){return e.replace(/\s+/g," ").trim().slice(0,50)}async function H0(e,t,r){let n=JM(t),o=JM(r);return wr(async i=>{for(let a of e.lines){let s=i.read(),l=xe(s).find(d=>d.key===a.key)||pr(s,a);if(!l)continue;let c={...Rt(l)};n?c["First name"]=n:delete c["First name"],o?c["Last name"]=o:delete c["Last name"],await i.change(At(l),{properties:c})}})}async function Q0(e){return wr(async t=>{var n;for(let o of e.roots){let i=String(((n=o.properties)==null?void 0:n.__itemId)||"");i&&await t.removeBundle({personId:e.id,itemId:i,selections:[]})}let r=xe(t.read()).filter(o=>{let i=Rt(o);return String(i.__personId||i.__purchaseMasterPersonId||"")===e.id});r.length&&await t.remove(r.map(At))})}async function j0(e,t){let n=he(t).itemId,o={personId:e,itemId:n,selections:[]},i=eU(t);return wr(async a=>{let s=i?[]:[...new Set(xe(a.read()).flatMap(c=>{let d=he(c);return d.personId===e&&d.itemId&&d.itemId!==n&&eU(c)?[d.itemId]:[]}))],l=await a.removeBundle(o);for(let c of s)l=await a.removeBundle({personId:e,itemId:c,selections:[]});return l})}function eU(e){let t=he(e),r=t.properties;return t.isPurchaseMaster&&Boolean(t.personId)&&!t.parentItemId&&r.__purchaseMasterItemRole==="cart-addon-product"&&(r.__purchaseMasterAddonType==="guard"||r.__purchaseMasterPaidGuardAddon==="true")}function tU(e,t){let r=Rt(t);if(r.__trufit_reward_gift!=="true"||r.__trufit_reward_id!==String(e.id||""))return!1;let n=String(e.giftProductId||"").split("/").pop();return n?n===String(t.product_id||""):String(e.giftProductHandle||"")===String(t.handle||"")}async function q0(e,t){var P,Y,h,S,b;let r=e.ui.rewards;if(!(r!=null&&r.enabled)||r.discountEnabled===!1)return;let n=String(e.ui.rewardSalesChannel||((P=t.attributes)==null?void 0:P.__salesChannel)||"online-store");if((Y=r.salesChannels)!=null&&Y.length&&!r.salesChannels.includes(n))return;let o=t.items.filter(zR),i=Math.max(0,Number(t.items_subtotal_price||0)-o.reduce((W,C)=>W+Number(C.final_line_price||0),0)),a=[...r.rewards||[]].filter(W=>W.enabled!==!1&&Number(W.thresholdCents||0)>0&&Number(W.thresholdCents)<=i).sort((W,C)=>Number(W.thresholdCents||0)-Number(C.thresholdCents||0)).at(-1),s=r.rewards||[],l=o.filter(W=>s.some(C=>tU(C,W))),c=a?l.find(W=>tU(a,W)):void 0,d=l.filter(W=>W.key!==(c==null?void 0:c.key)||!a);if(d.length){await wr(W=>W.remove(d.map(At)));return}if(!a||c)return;let u=String(a.giftProductHandle||"").trim();if(!u||!Ga().request)return;let p=((S=(h=window.Shopify)==null?void 0:h.routes)==null?void 0:S.root)||"/",m=await Ga().request(`${p}products/${encodeURIComponent(u)}.js`,{headers:{Accept:"application/json"}});if(!m.ok)return;let y=(b=(await m.json()).variants)==null?void 0:b.find(W=>W.available&&W.id);y!=null&&y.id&&await wr(W=>W.add([{id:String(y.id),quantity:1,properties:{__trufit_reward_gift:"true",__trufit_reward_id:String(a.id||"")}}]))}function zR(e){return Rt(e).__trufit_reward_gift==="true"}function rU(e){return JSON.stringify(Object.entries(e).filter(([,t])=>t!=null&&t!=="").sort(([t],[r])=>t.localeCompare(r)))}function KR(e={},t={}){return rU(e)===rU(t)}function nU(e){var t;return{...e,bundlePackages:e.bundlePackages||((t=e.purchaseMasterOptions)==null?void 0:t.bundlePackages)}}function oU(e,t,r){return e.filter(n=>{let o=he(n);return o.personId===t&&ut(n)&&!vr(n)&&(o.itemId===r||o.parentItemId===r)})}function HR(e,t,r){var i;let n={...(t||e).properties,__bundleQuantity:String(r)};if(!t)return n;delete n.__parentItemId,delete n.__bundleIncluded;let o=["__itemId","__personId","__personCreatedAt","__isDefaultPerson","__personNumber","__purchaseMasterSource","__purchaseMasterFlow","__bundleImageUrl","__bundleCompareAtPrice","__newCustomerDiscountPercent","First name","Last name"];for(let a of o){let s=(i=e.properties)==null?void 0:i[a];s&&(n[a]=s)}return n}function QR(e,t,r,n,o,i,a){var p;let s=t.bundlePackages||((p=t.purchaseMasterOptions)==null?void 0:p.bundlePackages),l=s==null?void 0:s.find(m=>Number(m.iconCount)===a),c=ni(l==null?void 0:l.price);if(!c)throw new Error("The updated bundle price is unavailable. Keep this guard and contact support.");let d=r.filter(m=>{let g=he(m);return!n.has(m.key)&&g.personId===o&&g.parentItemId===i&&(g.properties.__purchaseMasterItemRole==="id-tag"||g.properties.__purchaseMasterItemRole==="paid-bundle-accessory")}).reduce((m,g)=>m+kc(g),0),u=Math.max(0,Math.min(100,Number(e.__newCustomerDiscountPercent||0)));e.__bundleTargetPrice=((c+d)*(1-u/100)/100).toFixed(2),u>0?e.__bundleCompareAtPrice=((c+d)/100).toFixed(2):delete e.__bundleCompareAtPrice,e.__bundleTargetIncludesExtras="true"}async function J0(e,t,r,n){return wr(async o=>{let i=o.read(),a=pr(i,t),s=pr(i,r),l=he(a),c=he(s),d=l.itemId;if(c.personId!==e||l.personId!==e||s.key!==a.key&&c.parentItemId!==d)throw new Error("This guard no longer belongs to this bundle.");let u=xe(i),p=oU(u,e,d);if(p.length<2)throw new Error("This is the last guard in the bundle. Remove the bundle instead.");let g=a.key===s.key?p.find(V=>V.key!==a.key):void 0,y=g||s,P=_i(i,s),Y=new Set([y.key,...P.map(V=>V.key)]),h=p.length-1,S=HR(a,g,h),b=g?_i(i,g).map(V=>({line:V,properties:{...V.properties,__itemId:`id-tag-${d}`,__guardItemId:d,__parentItemId:d}})):[],W=Jr(a,n);if(!W)throw new Error("Bundle product settings are unavailable. Refresh and try again.");let C=S.__purchaseMasterVariantModel==="shop-v2"||S.__bundleTransform==="shop-v2",w=C?sW({config:nU(W),catalogProducts:n.map(nU),payloads:u,parentPayloadKey:a.key,parentProperties:S,removedKeys:Y,personId:e}):null;C||QR(S,W,u,Y,e,d,h);let I=((w==null?void 0:w.replacements)||[]).filter(V=>String(V.payload.variant_id)!==V.variantId||!KR(V.payload.properties,V.properties));I.length&&await o.add(I.map(V=>({id:V.variantId,quantity:1,properties:V.properties}))),I.some(V=>V.payload.key===a.key)||await o.change(At(a),{properties:S});for(let V of b)await o.change(At(V.line),{properties:V.properties});let U=[...I.map(V=>V.payload),y,...P],L=new Set,X=U.filter(V=>L.has(V.key)?!1:(L.add(V.key),!0));if(await o.remove(X.map(At)),oU(xe(o.read()),e,d).length!==h)throw new Error("Guard removal could not be confirmed. Refresh before trying again.")})}async function Oh(e,t){let r=Ga(),n=r.changeAndReconcile||r.change;if(!n)throw new Error("Cart updates are unavailable.");return n(At(e),{quantity:t})}async function iU(e,t,r){return wr(async n=>{var d;let o=n.read(),i=pr(o,t),a=xe(o).find(u=>u.key===r.key)||pr(o,r);if(!a)throw new Error("This bundle item is no longer in the cart. Refresh and try again.");let s=Rt(a);if(String(s.__personId||"").trim()!==e)throw new Error("This item no longer belongs to this customer.");if(((d=i.properties)==null?void 0:d.__bundleTargetIncludesExtras)==="true"){let u={...Rt(i)},p=ni(u.__bundleTargetPrice),m=Math.max(0,Number(a.price)||0),g=Math.max(1,Number(a.quantity)||1);p&&m&&(u.__bundleTargetPrice=(Math.max(0,p-m*g)/100).toFixed(2),await n.change(At(i),{properties:u}))}let l=n.read(),c=xe(l).find(u=>u.key===a.key)||pr(l,a);await n.change(At(c),{quantity:0})})}async function aU(e,t){return wr(async r=>{let n=xe(r.read()).find(o=>{var i;return String(o.variant_id)===t&&((i=o.properties)==null?void 0:i._trufitCartAccessory)==="true"});if(n){await r.change(At(n),{quantity:n.quantity+1});return}await r.add([{id:t,quantity:1,properties:{_trufitCartAccessory:"true"}}])})}async function e1(e){var i,a,s;let t=Ga();if(!t.request)throw new Error("Coupon updates are unavailable.");let r=((a=(i=window.Shopify)==null?void 0:i.routes)==null?void 0:a.root)||"/",n=await t.request(`${r}cart/update.js`,{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify({discount:e.trim()})});if(!n.ok)throw new Error("We couldn't update this coupon. Please check the code and try again.");let o=await n.json();if(e.trim()&&((s=o.discount_codes)!=null&&s.some(l=>{var c;return((c=l.code)==null?void 0:c.toLowerCase())===e.trim().toLowerCase()&&l.applicable===!1})))throw new Error("This coupon is invalid or doesn't apply to the items in your cart.")}function sU(e){return e instanceof Error&&e.message?e.message:"We couldn't update your cart. Please try again."}var jR=f.article`
  max-width: 864px;
  margin-bottom: 0;
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(17, 17, 17, 0.08);

  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    padding: 24px 16px;
    border: 1px solid #cccccc;
    box-shadow: none;
  }
`,qR=f.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 24px;

  @media screen and (max-width: 900px) {
    align-items: flex-start;
    flex-direction: column;
    display: contents;
  }
`,JR=f.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  line-height: 1.2;

  @media screen and (max-width: 900px) {
    order: 1;
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 1.2;
    font-weight: 400;
  }
`,e6=f.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  display: inline-grid;
  width: 20px;
  height: 20px;
  place-items: center;

  & svg {
    width: 20px;
    height: 20px;
  }
`,t6=f.div`
  display: flex;
  align-items: center;
  gap: 26px;

  @media screen and (max-width: 900px) {
    order: 4;
    width: 100%;
    justify-content: center;
    gap: 32px;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #d9d9d9;
  }
`,lU=f.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({$muted:e})=>e?"#6e6e73":"inherit"};
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;

  @media screen and (max-width: 900px) {
    max-width: 96px;
    white-space: normal;
    text-align: center;
    line-height: 1.2;
  }
`,r6=f(lU)`
  display: inline-block;
  white-space: nowrap;
  line-height: 1.3;

  @media screen and (max-width: 900px) {
    white-space: normal;
    line-height: 1.2;
  }
`,n6=f.form`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 12px;
  align-items: end;
  margin: -8px 0 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d9d9d9;

  & label {
    display: grid;
    gap: 6px;
    color: #4e4e4f;
    font-size: 12px;
    font-weight: 700;
  }

  & input {
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    color: #111111;
    font: inherit;
    font-size: 14px;
    font-weight: 500;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    margin-top: -4px;
    order: 2;
  }
`,o6=f.div`
  display: flex;
  gap: 10px;
  align-items: center;

  & button {
    min-height: 40px;
    padding: 0 18px;
    border: 1px solid #111111;
    border-radius: 999px;
    background: #ffffff;
    color: #111111;
    font: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
  }

  & button:last-child {
    background: #111111;
    color: #ffffff;
  }

  & button:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media screen and (max-width: 900px) {
    justify-content: flex-start;
  }
`,i6=f.div`
  display: grid;

  @media screen and (max-width: 900px) {
    order: 3;
  }
`,go={Person:jR,Header:qR,Title:JR,IconButton:e6,Actions:t6,Action:lU,AddGuard:r6,Rename:n6,RenameActions:o6,Bundles:i6};var Hh=T(oe());var hU=T(oe());var a6=f.article`
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;

  & + & {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #d9d9d9;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 88px minmax(0, 1fr);
    gap: 16px;
  }
`,s6=f.a`
  display: block;
`,l6=f.div`
  display: grid;
  width: 108px;
  height: 108px;
  place-items: center;
  overflow: hidden;
  border-radius: 8px;
  background: #f6f6f6;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 900px) {
    width: 88px;
    height: 88px;
  }
`,c6=f.div`
  display: grid;
  justify-items: start;
  gap: 6px;
`,d6=f.a`
  color: #111111;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
  text-decoration: none;
`,u6=f.span`
  color: #6e6e73;
  font-size: 14px;
  line-height: 1.3;
`,p6=f.strong`
  color: #2d8a70;
  font-size: 18px;
  line-height: 1.3;

  ${({$sale:e})=>e&&v`
      display: inline-flex;
      align-items: baseline;
      gap: 8px;
    `}

  & s {
    color: #6e6e73;
    font-size: 16px;
    font-weight: 500;
  }

  & span {
    color: #2d8a70;
  }
`,m6=f.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`,f6=f.div`
  display: inline-flex;
  align-self: start;
  align-items: center;
  justify-self: end;
  gap: 24px;

  @media screen and (max-width: 900px) {
    grid-column: 2;
    justify-self: start;
    gap: 16px;
  }
`,h6=f.div`
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  overflow: hidden;
  border: 1px solid #d9d9d9;
  border-radius: 999px;
  background: #ffffff;

  & button {
    display: grid;
    width: 32px;
    height: 32px;
    place-items: center;
    border: 0;
    background: transparent;
    color: #111111;
    cursor: pointer;
    padding: 0;
    font: inherit;
    font-size: 18px;
    line-height: 1;
  }

  & button:hover:not(:disabled) {
    background: #f6f6f6;
  }

  & button:disabled {
    color: #b5b5b5;
    cursor: not-allowed;
  }

  & > span {
    min-width: 28px;
    color: #111111;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
  }
`,g6=f.button`
  appearance: none;
  border: 0;
  padding: 0;
  background: transparent;
  color: #6e6e73;
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
  text-decoration: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`,$n={Root:a6,MediaLink:s6,Media:l6,Details:c6,Title:d6,Variant:u6,Price:p6,Discounts:m6,Actions:f6,QuantityControl:h6,Remove:g6};var Y6=f.svg`
  display: block;
  width: 22px;
  height: 22px;
`,S6=f.span`
  display: inline-flex;
  width: max-content;
  max-width: 100%;
  padding: 5px 9px;
  border-radius: 6px;
  background: #e8e8e8;
  color: #111111;
  font-size: 12px;
  line-height: 1;
`,y6=f.div`
  display: grid;
  grid-template-columns: ${({$standalone:e})=>e?"108px":"54px"} minmax(0, 1fr) 60px;
  grid-template-rows: auto;
  column-gap: 0;
  row-gap: 0;
  align-items: start;

  ${({$standalone:e})=>e&&v`
      min-height: 96px;
      margin-top: 8px;
    `}

  & a {
    color: #6e6e73;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
  }

  & > a {
    grid-column: 3;
    grid-row: 1;
    justify-self: end;
    align-self: start;
    width: max-content;
    max-width: 136px;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: ${({$standalone:e})=>e?"96px":"48px"} minmax(0, 1fr);
    grid-template-rows: auto;
    gap: 12px;
    min-height: 48px;

    & a {
      grid-column: 2;
      grid-row: auto;
      justify-self: start;
      width: auto;
      max-width: 100%;
    }
  }
`,x6=f.div`
  display: grid;
  grid-column: ${({$variant:e})=>e==="linked"?"2":"2 / 4"};
  grid-row: 1;
  grid-template-columns: ${({$variant:e})=>e==="linked"?"minmax(0, 1fr)":"minmax(0, 1fr) 60px"};
  grid-template-rows: ${({$variant:e})=>e==="standalone"||e==="linked"?"auto auto":"20px auto"};
  row-gap: ${({$variant:e})=>e==="linked"?"0":"8px"};
  min-width: 0;
  margin-left: ${({$variant:e})=>e==="linked"?"0":"24px"};

  @media screen and (max-width: 900px) {
    grid-column: 2;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 0;
    margin-left: 0;
  }
`,b6=f.div`
  display: inline-flex;
  grid-column: 1 / 3;
  grid-row: 1;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;

  & p {
    flex: 1 1 auto;
    min-width: 0;
  }

  @media screen and (max-width: 900px) {
    grid-column: auto;
    grid-row: auto;
    align-items: flex-start;
    justify-content: space-between;
  }
`,C6=f.p`
  display: block;
  grid-column: 1;
  grid-row: 1;
  margin: 0;
  font-size: ${({$standalone:e})=>e?"18px":"16px"};
  line-height: ${({$standalone:e})=>e?"1.35":"20px"};
  font-weight: 700;

  @media screen and (max-width: 900px) {
    grid-column: auto;
    grid-row: auto;
  }
`,P6=f.p`
  display: block;
  margin: 0;
  font-size: 18px;
  line-height: 1.35;
  grid-column: 1;
  grid-row: 2;
  color: #39846c;
  font-weight: 700;
`,W6=f.span`
  ${({$standalone:e})=>!e&&v`
      display: block;
      grid-column: auto;
      grid-row: auto;
      margin: 0;
      font-size: 16px;
      line-height: 20px;
      color: #39846c;
      font-weight: 500;
    `}

  ${({$sale:e})=>e&&v`
      display: inline-flex;
      align-items: baseline;
      gap: 8px;

      & s {
        color: #6e6e73;
        font-weight: 500;
      }

      & span {
        color: #39846c;
      }
    `}
`,v6=f.strong`
  display: block;
  grid-column: 1;
  grid-row: 2;
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  color: #39846c;
  font-weight: 500;

  @media screen and (max-width: 900px) {
    grid-column: auto;
    grid-row: auto;
  }
`,w6=f.div`
  display: grid;
  grid-column: 1;
  grid-row: 2;
  align-items: start;
  justify-items: start;
  gap: 6px;
  min-width: 0;
  width: max-content;
  max-width: 100%;

  @media screen and (max-width: 900px) {
    grid-column: auto;
    grid-row: auto;
    margin-top: 4px;
  }
`,T6=f.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: ${({$inPriceRow:e})=>e?"0":"6px"};

  ${({$inPriceRow:e})=>e&&v`
      grid-column: 1 / -1;
      grid-row: 2;
    `}
`,M6=f.div`
  grid-column: 3;
  grid-row: 1;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  align-self: ${({$linked:e})=>e?"center":"end"};
  justify-self: end;
  gap: 16px;
  width: 60px;
  height: 22px;
  white-space: nowrap;

  @media screen and (max-width: 900px) {
    grid-column: 2;
    align-self: end;
    margin-top: 0;
  }
`,U6=f.button`
  display: inline-flex;
  min-width: 0;
  min-height: 0;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-family: var(--trufit-font-body);
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  color: #111111;

  ${({$placement:e})=>e&&e!=="inline"&&v`
      grid-column: 3;
      grid-row: 1;
      align-self: ${e==="linked"?"center":"end"};
      justify-self: end;

      @media screen and (max-width: 900px) {
        grid-column: 2;
        align-self: end;
      }
    `}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.32;
  }
`,I6=f.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`,rr={ChildLineRemoveIcon:Y6,DiscountChip:S6,ChildCard:y6,ChildBody:x6,ChildHeading:b6,ChildStandaloneTitle:C6,ChildStandalonePrice:P6,ChildPrice:W6,ChildIncluded:v6,ChildPriceRow:w6,ChildDiscounts:T6,ChildLineActions:M6,ChildLineRemove:U6,ChildLineRemoveLabel:I6};function Me(e,t,r){let n=Math.max(0,Number(e)||0)/100,o=r==null?void 0:r.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|space|apostrophe)_separator)?)\s*\}\}/);if(r&&o){let i=o[1].includes("no_decimals")?0:2,a=o[1].includes("comma_separator"),s=a?".":o[1].includes("space_separator")?" ":o[1].includes("apostrophe_separator")?"'":",",[l,c]=n.toFixed(i).split("."),d=l.replace(/\B(?=(\d{3})+(?!\d))/g,s)+(c?(a?",":".")+c:"");return r.replace(o[0],d).replace(/<[^>]*>/g,"").replace(/&nbsp;/g,"\xA0")}return new Intl.NumberFormat("en-US",{style:"currency",currency:t,currencyDisplay:"narrowSymbol"}).format(n)}function Lc(e,t,r){return Me(e,t,r).replace(/([.,])00(?=\D|$)/,"")}var mr=T(k());function Zs({allocations:e,small:t=!1}){return(0,mr.jsx)(mr.Fragment,{children:e.map((r,n)=>{var i,a;let o=((i=r.discount_application)==null?void 0:i.title)||((a=r.discount_application)==null?void 0:a.code);return o?(0,mr.jsx)(rr.DiscountChip,{as:t?"small":void 0,className:"cart-discount-chip",children:o},String(o)+"-"+n):null})})}function Fh({quantity:e,busy:t,onQuantity:r}){return(0,mr.jsxs)(mr.Fragment,{children:[(0,mr.jsx)("button",{type:"button","aria-label":"Decrease quantity",disabled:t||e<=1,onClick:()=>r(Math.max(1,e-1)),children:"\u2212"}),(0,mr.jsx)("span",{children:e}),(0,mr.jsx)("button",{type:"button","aria-label":"Increase quantity",disabled:t,onClick:()=>r(e+1),children:"+"})]})}function Qu({item:e,currency:t,moneyFormat:r}){let{linePrice:n,comparePrice:o,discounted:i}=e;return i?(0,mr.jsxs)(mr.Fragment,{children:[(0,mr.jsx)("s",{children:Me(o,t,r)}),(0,mr.jsx)("span",{children:Me(n,t,r)})]}):(0,mr.jsx)(mr.Fragment,{children:Me(n,t,r)})}var ju=T(k());function oi(e){return typeof e=="string"?e:e&&typeof e=="object"?String(e.url||e.src||""):""}function ii({line:e,options:t,bundle:r=!1}){let n=oi(e.image)||oi(e.featured_image),o=!r&&ut(e)&&t?Vs(t,{position:Te(e,"Position"),thicknessSize:Te(e,"Thickness Size"),strength:Te(e,"Strength"),edgeType:Te(e,"Edge type","Edge Type"),color:Te(e,"Color","Guard Color"),padColor:Te(e,"Pad color","Pad Color","Compression Pad Color")},"customization"):[],i=r?[{url:Te(e,"__bundleImageUrl")||String((t==null?void 0:t.bundleImageUrl)||"")||n,objectFit:"contain"}]:o.length?o:[{url:n,objectFit:"contain"}];return(0,ju.jsx)(ju.Fragment,{children:i.filter(a=>a.url).map((a,s)=>(0,ju.jsx)(lo.LayerImage,{src:a.url,alt:s===0?Rr(e):"",loading:"lazy",$objectFit:a.objectFit,$layer:s},`${a.url}-${s}`))})}var fr=T(k());function cU({line:e,item:t,currency:r,moneyFormat:n,busy:o,quantity:i,onQuantity:a,onRemove:s,productOptions:l}){let{productUrl:c,variantTitle:d,allocations:u,discounted:p,label:m}=t,g=(0,fr.jsx)(ii,{line:e,options:l});return(0,fr.jsxs)($n.Root,{className:"cart-accessory",children:[(0,fr.jsx)($n.MediaLink,{className:"cart-accessory-media-link",href:c,"aria-hidden":"true",tabIndex:-1,children:(0,fr.jsx)($n.Media,{className:"cart-accessory-media",children:g})}),(0,fr.jsxs)($n.Details,{className:"cart-accessory-details",children:[(0,fr.jsx)($n.Title,{className:"cart-accessory-title",href:c,children:m}),d&&d!=="Default Title"?(0,fr.jsx)($n.Variant,{className:"cart-accessory-variant",children:d}):null,(0,fr.jsx)($n.Price,{$sale:p,className:"cart-accessory-price",children:(0,fr.jsx)(Qu,{item:t,currency:r,moneyFormat:n})}),u.length?(0,fr.jsx)($n.Discounts,{className:"cart-accessory-discounts","aria-label":"Applied discounts",children:(0,fr.jsx)(Zs,{allocations:u})}):null]}),(0,fr.jsxs)($n.Actions,{className:"cart-accessory-actions",children:[i&&a?(0,fr.jsx)($n.QuantityControl,{className:"cart-accessory-quantity-control","aria-label":"Quantity "+e.quantity,children:(0,fr.jsx)(Fh,{quantity:e.quantity,busy:o,onQuantity:a})}):null,s?(0,fr.jsx)($n.Remove,{className:"cart-accessory-remove",type:"button",disabled:o,onClick:s,"aria-label":"Remove item",children:"Remove"}):null]})]})}var V6=f.button`
  display: grid;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #eeeeee;
  color: #111111;
  font: inherit;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  cursor: pointer;

  @media screen and (max-width: 900px) {
    display: grid;
  }
`,k6=f.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  display: grid;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;
  padding: 20px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);

  &[hidden] {
    display: none !important;
  }
`,L6=f.div`
  width: 100%;
  max-width: 560px;
  overflow: hidden;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 0 24px rgba(113, 113, 113, 0.25);

  @media screen and (max-width: 900px) {
    max-width: 360px;
  }
`,X6=f.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  border-bottom: 1px solid #d9d9d9;

  & h2 {
    margin: 0;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
  }
`,N6=f.button`
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #111111;
  cursor: pointer;

  & svg {
    width: 24px;
    height: 24px;
  }
`,E6=f.div`
  display: grid;
  grid-template-columns: 164px minmax(0, 1fr);
  align-items: center;
  gap: 24px;
  padding: 24px;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 20px;
  }
`,A6=f.div`
  ${({$layered:e})=>e&&v`
      position: relative;
    `}

  ${({$layered:e})=>e&&v`
      & img {
        position: absolute;
        inset: 0;
        margin: auto;
        width: 100%;
        max-width: none;
        height: 100%;
        max-height: none;
        object-fit: contain;
      }
    `}

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  width: 164px;
  height: 132px;
  overflow: hidden;
  border-radius: 8px;
  background: #f7f7f7;

  & span {
    display: grid;
    width: 100%;
    height: 100%;
    place-items: center;
    color: #6e6e73;
    font-size: 42px;
    line-height: 1;
    font-weight: 700;
  }

  @media screen and (max-width: 900px) {
    justify-self: center;
    width: 100%;
    max-width: 220px;
    height: 160px;
  }
`,R6=f.dl`
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 24px;

  & div {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  & dt {
    margin: 0;
    font-weight: 400;
  }

  & dd {
    margin: 0;
    font-weight: 400;
    color: #6e6e73;
  }
`,ai={Trigger:V6,Root:k6,Panel:L6,Header:X6,Close:N6,Body:E6,Media:A6,List:R6};var Ee=T(k());function G6({className:e}){return(0,Ee.jsxs)(rr.ChildLineRemoveIcon,{className:e,viewBox:"0 0 22 22","aria-hidden":"true",children:[(0,Ee.jsx)("path",{d:"M3.5 6h15",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),(0,Ee.jsx)("path",{d:"M16.83 6v11.67c0 .44-.18.87-.49 1.18-.31.31-.74.48-1.18.48H6.83c-.44 0-.87-.17-1.18-.48a1.67 1.67 0 0 1-.48-1.18V6m2.5 0V4.33c0-.44.17-.86.48-1.18.32-.31.74-.48 1.18-.48h3.34c.44 0 .86.17 1.18.48.31.32.48.74.48 1.18V6",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),(0,Ee.jsx)("path",{d:"M9.33 10.17v5M12.67 10.17v5",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"})]})}function _6(){return(0,Ee.jsxs)(Pt.ButtonIcon,{$visible:!0,className:"cart-button-icon",viewBox:"0 0 20 20","aria-hidden":"true",children:[(0,Ee.jsx)("path",{d:"M2.3954 15.0973C2.43368 14.7527 2.45283 14.5804 2.50496 14.4194C2.55121 14.2765 2.61656 14.1405 2.69923 14.0152C2.79241 13.8739 2.91499 13.7513 3.16014 13.5061L14.1654 2.5009C15.0859 1.58043 16.5782 1.58043 17.4987 2.5009C18.4192 3.42138 18.4192 4.91376 17.4987 5.83424L6.49347 16.8395C6.24832 17.0846 6.12574 17.2072 5.98444 17.3004C5.85907 17.383 5.72311 17.4484 5.58024 17.4946C5.4192 17.5468 5.24691 17.5659 4.90234 17.6042L2.08203 17.9176L2.3954 15.0973Z",fill:"none",stroke:"currentColor",strokeWidth:"1.66667",strokeLinecap:"round",strokeLinejoin:"round"}),(0,Ee.jsx)("line",{x1:"9",y1:"18.5",x2:"19",y2:"18.5",stroke:"currentColor"})]})}function dU({line:e,item:t,currency:r,moneyFormat:n,busy:o,onEdit:i,onRemove:a,primary:s,readOnly:l,productOptions:c,standalone:d,onShowDetails:u}){let{linePrice:p,allocations:m,discounted:g,included:y,detailsId:P,label:Y}=t,h=(0,Ee.jsx)(ii,{line:e,options:c});return(0,Ee.jsxs)(rr.ChildCard,{$standalone:d,className:"cart-child-card cart-child",children:[(0,Ee.jsx)(Pt.ChildMedia,{$variant:d?"standalone":"child",$layered:!0,className:"cart-child-media cart-layered-media",children:h}),(0,Ee.jsxs)(rr.ChildBody,{$variant:d?"standalone":"child",className:"cart-child-body",children:[(0,Ee.jsxs)(rr.ChildHeading,{className:"cart-child-heading",children:[(0,Ee.jsx)(rr.ChildStandaloneTitle,{$standalone:d,className:"cart-child-title",children:Y}),u?(0,Ee.jsx)(ai.Trigger,{className:"cart-child-details-trigger",type:"button","aria-haspopup":"dialog","aria-label":"View "+Y+" details","aria-controls":P,onClick:u,children:"i"}):null]}),d?(0,Ee.jsx)(rr.ChildStandalonePrice,{className:"cart-child-standalone-price",children:g?(0,Ee.jsx)(rr.ChildPrice,{$sale:!0,$standalone:!0,className:"cart-child-price",children:(0,Ee.jsx)(Qu,{item:t,currency:r,moneyFormat:n})}):Me(p,r,n)}):(0,Ee.jsxs)(rr.ChildPriceRow,{className:"cart-child-price-row",children:[y?(0,Ee.jsx)(rr.ChildIncluded,{className:"cart-child-included",children:x("Included")}):(0,Ee.jsx)(rr.ChildPrice,{$sale:g,as:"strong",className:"cart-child-price",children:(0,Ee.jsx)(Qu,{item:t,currency:r,moneyFormat:n})}),!y&&m.length?(0,Ee.jsx)(rr.ChildDiscounts,{$inPriceRow:!0,className:"cart-child-discounts","aria-label":"Applied discounts",children:(0,Ee.jsx)(Zs,{allocations:m})}):null]}),d&&m.length?(0,Ee.jsx)(rr.ChildDiscounts,{className:"cart-child-discounts","aria-label":"Applied discounts",children:(0,Ee.jsx)(Zs,{allocations:m})}):null]}),l?null:(0,Ee.jsxs)(rr.ChildLineActions,{className:"cart-child-line-actions",children:[i?(0,Ee.jsxs)(Pt.Button,{$variant:"secondary",$placement:"line",className:"cart-button",type:"button",disabled:o,onClick:i,"aria-label":"Edit item",children:[(0,Ee.jsx)(_6,{}),(0,Ee.jsx)(Pt.ButtonLabel,{$iconOnly:!0,className:"cart-button-label",children:"Edit"})]}):null,a?(0,Ee.jsxs)(rr.ChildLineRemove,{className:"cart-child-line-remove",type:"button",disabled:o,onClick:a,"aria-label":"Remove item",children:[(0,Ee.jsx)(G6,{className:"cart-child-line-remove-icon"}),(0,Ee.jsx)(rr.ChildLineRemoveLabel,{className:"cart-child-line-remove-label",children:"Remove"})]}):null]})]})}var uU=T(oe());var Wt=T(k());function pU({line:e,item:t,currency:r,moneyFormat:n,busy:o,quantity:i,onQuantity:a,onEdit:s,onRemove:l}){let{image:c,label:d,subtitle:u,allocations:p,properties:m,linePrice:g,comparePrice:y,discounted:P}=t;return(0,Wt.jsxs)(Ar.LineRow,{children:[c?(0,Wt.jsx)(Ar.ProductImage,{src:c,alt:"",loading:"lazy"}):null,(0,Wt.jsxs)(Ar.LineInfo,{children:[(0,Wt.jsx)("strong",{children:d}),u?(0,Wt.jsx)("small",{children:u}):null,p.length?(0,Wt.jsx)("div",{children:(0,Wt.jsx)(Zs,{allocations:p,small:!0})}):null,m.length?(0,Wt.jsxs)(Ar.LineDetails,{children:[(0,Wt.jsx)("summary",{children:"View details"}),(0,Wt.jsx)("dl",{children:m.map(([Y,h])=>(0,Wt.jsxs)(uU.default.Fragment,{children:[(0,Wt.jsx)("dt",{children:Y}),(0,Wt.jsx)("dd",{children:String(h)})]},Y))})]}):null,e.quantity>1&&!i?(0,Wt.jsxs)("small",{children:["Qty ",e.quantity]}):null]}),(0,Wt.jsxs)(Ar.LineControls,{children:[i&&a?(0,Wt.jsx)(Ar.QuantityControl,{"aria-label":"Quantity "+e.quantity,children:(0,Wt.jsx)(Fh,{quantity:e.quantity,busy:o,onQuantity:a})}):null,P?(0,Wt.jsx)(Ar.ComparePrice,{children:Me(y,r,n)}):null,(0,Wt.jsx)("strong",{children:Me(g,r,n)}),s?(0,Wt.jsx)(Ar.TextButton,{type:"button",disabled:o,onClick:s,"aria-label":"Edit item",children:"Edit"}):null,l?(0,Wt.jsx)(Ar.DangerButton,{type:"button",disabled:o,onClick:l,"aria-label":"Remove item",children:"Remove"}):null]})]})}var B6=Ms`
  [data-trufit-cart-bundle-customizer] {
    display: contents;
  }

  [data-trufit-cart-bundle-customizer]
    > [data-trufit-cart-bundle-customize-react-root] {
    display: contents;
  }

  @media screen and (max-width: 900px) {
    #gorgias-chat-container #chat-button {
      bottom: calc(96px + env(safe-area-inset-bottom)) !important;
    }
  }
`,Z6=Ms`
  html {
    overflow: hidden;
  }
`,qu={Document:B6,DetailsDocument:Z6};var Xc=T(oe());function _a(e,t,r=!0){let n=(0,Xc.useRef)(null),o=(0,Xc.useRef)(e);o.current=e;let i=(0,Xc.useRef)(t);return i.current=t,(0,Xc.useEffect)(()=>{var u;if(!r)return;let a=document.activeElement instanceof HTMLElement?document.activeElement:null,s=n.current,l='button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',c=()=>Array.from((s==null?void 0:s.querySelectorAll(l))||[]);(u=c()[0])==null||u.focus();let d=p=>{if(p.key==="Escape"){p.preventDefault(),i.current||o.current();return}if(p.key!=="Tab")return;let m=c();m.length&&(p.shiftKey&&document.activeElement===m[0]?(p.preventDefault(),m[m.length-1].focus()):!p.shiftKey&&document.activeElement===m[m.length-1]&&(p.preventDefault(),m[0].focus()))};return document.addEventListener("keydown",d),()=>{document.removeEventListener("keydown",d),a==null||a.focus({preventScroll:!0})}},[r]),n}var Ft=T(k());function mU({line:e,item:t,productOptions:r,enabled:n,open:o,onClose:i}){let a=_a(i,!1,o);if(!n||!o)return null;let{detailsId:s,guardProperties:l}=t,c=(0,Ft.jsx)(ii,{line:e,options:r});return(0,Ft.jsxs)(Ft.Fragment,{children:[(0,Ft.jsx)(qu.DetailsDocument,{}),(0,Ft.jsx)(ai.Root,{className:"cart-child-details",id:s,role:"dialog","aria-modal":"true","aria-labelledby":s+"-title",onClick:i,children:(0,Ft.jsxs)(ai.Panel,{className:"cart-child-details-panel",ref:a,onClick:d=>d.stopPropagation(),children:[(0,Ft.jsxs)(ai.Header,{className:"cart-child-details-header",children:[(0,Ft.jsx)("h2",{id:s+"-title",children:"Details"}),(0,Ft.jsx)(ai.Close,{className:"cart-child-details-close",type:"button","aria-label":"Close details",onClick:i,children:(0,Ft.jsx)("svg",{viewBox:"0 0 24 24","aria-hidden":"true",children:(0,Ft.jsx)("path",{d:"m5 5 14 14M19 5 5 19",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round"})})})]}),(0,Ft.jsxs)(ai.Body,{className:"cart-child-details-body",children:[(0,Ft.jsx)(ai.Media,{$layered:!0,className:"cart-child-details-media cart-layered-media",children:c}),(0,Ft.jsx)(ai.List,{className:"cart-child-details-list",children:l.map(([d,u])=>(0,Ft.jsxs)("div",{children:[(0,Ft.jsxs)("dt",{children:[d,":"]}),(0,Ft.jsx)("dd",{children:String(u)})]},d))})]})]})})]})}var $6=["Position","Sport","Thickness Size","Color","Pad color","Initials"],O6=new Set(["position","sport","thicknesssize","color","guardcolor","padcolor","compressionpadcolor","initials","idtag","customidtag"]);function fU(e,t=!1){var g,y,P,Y,h;let r=e.product,n=String(e.image||e.featured_image||(r==null?void 0:r.featured_image)||(r==null?void 0:r.image)||""),o=String(e.url||(r!=null&&r.handle?"/products/"+r.handle:"#")),i=String(e.variant_title||""),a=(y=(g=e.final_line_price)!=null?g:e.line_price)!=null?y:0,s=(P=e.original_line_price)!=null?P:a,l=e.line_level_discount_allocations||[],c=$6.map(S=>Te(e,S)).filter(Boolean).join(" \xB7 "),d=[i!=="Default Title"?i:"",c].filter(Boolean).join(" \xB7 "),u=Object.entries(e.properties||{}).filter(([S,b])=>!S.startsWith("_")&&String(b||"").trim()),p=u.filter(([S])=>O6.has(S.toLowerCase().replace(/[^a-z]/g,""))),m=t||String(((Y=e.properties)==null?void 0:Y.__bundleIncluded)||"").toLowerCase()==="true"||((h=e.properties)==null?void 0:h.__purchaseMasterSource)==="online-store"&&Number(a)<=0;return{label:Rr(e),image:n,productUrl:o,variantTitle:i,subtitle:d,linePrice:a,comparePrice:s,discounted:Number(s)>Number(a),allocations:l,properties:u,guardProperties:p,included:m,detailsId:"CartChildDetails-"+e.key.replace(/[^a-zA-Z0-9_-]/g,"-")}}var Bi=T(k());function Zi(e){let{line:t,presentation:r="ordinary",readOnly:n=!1}=e,[o,i]=(0,hU.useState)(!1),a=fU(t,e.forceIncluded),s=r==="child"||r==="standalone",l=!n&&s&&ut(t)&&a.guardProperties.length>0,c={...e,item:a},d;return r==="accessory"?d=(0,Bi.jsx)(cU,{...c}):s?d=(0,Bi.jsx)(dU,{...c,standalone:r==="standalone",onShowDetails:l?()=>i(!0):void 0}):d=(0,Bi.jsx)(pU,{...c}),(0,Bi.jsxs)(Bi.Fragment,{children:[d,(0,Bi.jsx)(mU,{line:t,item:a,productOptions:e.productOptions,enabled:l,open:o,onClose:()=>i(!1)})]})}var F6=f.article`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & + & {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #d9d9d9;
  }
`,D6=f.div`
  display: grid;
  grid-template-columns: 108px minmax(190px, 1fr) 206px;
  gap: 24px;
  align-items: start;

  @media screen and (max-width: 900px) {
    grid-template-columns: 96px minmax(0, 1fr);
    gap: 12px;
  }
`,z6=f.div`
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #f5f5f5;
  color: #111111;
  font-weight: 800;
  width: 108px;
  height: 108px;
  border-radius: 8px;

  & img {
    display: block;
    object-fit: contain;
    width: auto;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
  }

  @media screen and (max-width: 900px) {
    width: 96px;
    height: 96px;
  }
`,K6=f.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  display: inline-grid;
  grid-template-columns: minmax(0, auto) 16px;
  gap: 12px;
  align-items: start;
  text-align: left;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;

  & small {
    color: #6e6e73;
    font-weight: 500;
  }

  & svg {
    width: 16px;
    height: 16px;
    margin-top: 4px;
    transition: transform 0.2s ease;
  }

  ${({$expanded:e})=>!e&&v`
      & svg {
        transform: rotate(180deg);
      }
    `}

  @media screen and (max-width: 900px) {
    grid-template-columns: minmax(0, auto) 16px;
    gap: 8px;
    font-size: 18px;
    line-height: 1.4;
  }
`,H6=f.span`
  display: grid;
  min-width: 0;
`,Q6=f.span`
  display: block;
  min-width: 0;
`,j6=f.span`
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
  white-space: nowrap;

  @media screen and (max-width: 900px) {
    white-space: normal;
  }
`,q6=f.p`
  margin: 12px 0 6px;
  color: #39846c;
  font-size: 18px;
  line-height: 1;
  font-weight: 500;

  ${({$sale:e})=>e&&v`
      display: flex;
      align-items: baseline;
      gap: 8px;
    `}

  & s {
    color: #6e6e73;
    font-weight: 500;
  }

  & span {
    color: #39846c;
  }

  @media screen and (max-width: 900px) {
    margin: 8px 0 6px;
    line-height: 24px;
  }
`,J6=f.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  @media screen and (max-width: 900px) {
    grid-column: 1 / -1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
    margin-top: 4px;
    ${({$inHeader:e})=>e&&v`
        display: none;
      `}
  }
`,eG=f.button`
  display: inline-grid;
  width: 22px;
  height: 22px;
  min-width: 0;
  min-height: 0;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #111111;
  font: inherit;
  line-height: 1;
  cursor: pointer;

  &:disabled {
    cursor: wait;
    opacity: 0.55;
  }
`,tG=f.svg`
  display: block;
  width: 22px;
  height: 22px;
`,rG=f.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`,nG=f.div`
  position: relative;
  display: grid;
  gap: 16px;
  margin: 16px 0 0;
  padding-left: 54px;

  &::before {
    content: "";
    position: absolute;
    left: 34px;
    top: 0;
    bottom: 0;
    width: 4px;
    border-radius: 4px;
    background: #d9d9d9;
  }

  &[hidden] {
    display: none;
  }

  @media screen and (max-width: 900px) {
    gap: 16px;
    margin: 24px 0 0;
    padding-left: 48px;
    &::before {
      left: 22px;
    }
  }
`,Gr={Card:F6,Top:D6,Media:z6,Collapse:K6,Title:H6,TitleName:Q6,TitleBundle:j6,Price:q6,Actions:J6,Remove:eG,RemoveIcon:tG,RemoveLabel:rG,Children:nG};var zh=T(oe());var oG=f.div`
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 160px;
  gap: 12px;
  align-items: center;
  margin: 0 0 0 64px;
  padding-top: 14px;
  border-top: 1px solid #e5e5e5;

  & p {
    display: block;
    margin: 0;
    font-size: 16px;
    line-height: 1.25;
    font-weight: 700;
  }

  & strong {
    display: block;
    margin: 4px 0 0;
    font-size: 16px;
    line-height: 1.25;
    color: #39846c;
    font-weight: 700;
  }

  & > button {
    justify-self: end;
    padding: 0;
    border: 0;
    background: transparent;
    color: #6e6e73;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
  }

  & > button:disabled {
    cursor: default;
    opacity: 0.6;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 40px 1fr;
    margin-left: 48px;
    & > button {
      grid-column: 2;
      justify-self: start;
    }
  }
`,iG=f.strong`
  ${({$sale:e})=>e&&v`
      display: inline-flex;
      align-items: baseline;
      gap: 8px;
    `}

  & s {
    color: #6e6e73;
    font-weight: 500;
  }

  & span {
    color: #39846c;
  }
`,t1={Root:oG,PriceSale:iG};var tn=T(k());function Dh({line:e,currency:t,moneyFormat:r,busy:n,onRemove:o}){let i=Me(e.final_line_price,t,r);return(0,tn.jsxs)(t1.Root,{className:"cart-linked-item",children:[(0,tn.jsx)(Pt.ChildMedia,{$variant:"linked",className:"cart-child-media cart-linked-item-media",children:(0,tn.jsx)(ii,{line:e})}),(0,tn.jsxs)("div",{className:"cart-linked-item-content",children:[(0,tn.jsx)("p",{children:Rr(e)}),(0,tn.jsx)(t1.PriceSale,{$sale:Number(e.original_line_price)>Number(e.final_line_price),children:Number(e.original_line_price)>Number(e.final_line_price)?(0,tn.jsxs)(tn.Fragment,{children:[(0,tn.jsx)("s",{children:Me(e.original_line_price,t,r)}),(0,tn.jsx)("span",{children:i})]}):i})]}),(0,tn.jsxs)("button",{type:"button",disabled:n,onClick:o,children:["Remove (-",i,")"]})]})}var Ze=T(k());function YU({root:e,person:t,snapshot:r,bootstrap:n,currency:o,moneyFormat:i,busy:a,onRemoveBundle:s,onEditGuard:l,onRemoveGuard:c,onRemoveComponent:d,onRemoveTag:u}){var X;let[p,m]=(0,zh.useState)(()=>typeof window=="undefined"||!window.matchMedia("(max-width: 900px)").matches),g=en(t,e),y=he(e),P=[...r.purchaseMasterTransformSummaries||[],...r.items].find(N=>bt(N)&&he(N).rootKey===y.rootKey),Y=new Set((X=P==null?void 0:P.item_components)==null?void 0:X.map(N=>N.key)),h=N=>P?Number(P[N]||0)+g.filter(V=>{var z;return!Y.has(V.key)&&(vr(V)||((z=V.properties)==null?void 0:z.__purchaseMasterItemRole)==="paid-bundle-accessory")}).reduce((V,z)=>V+Number(z[N]||0),0):g.reduce((V,z)=>V+Number(z[N]||0),0),S=h("final_line_price"),b=h("original_line_price"),W=g.filter(ut),C=g.filter(Bs),w=g.filter(N=>N.key!==e.key&&!Bs(N)).sort((N,V)=>gU(N)-gU(V)),I=vr(e),U=Gi(e,n),L=N=>(0,Ze.jsxs)(zh.default.Fragment,{children:[(0,Ze.jsx)(Zi,{line:N,presentation:I&&N.key===e.key?"standalone":"child",primary:N.key===e.key,currency:o,moneyFormat:i,busy:a,readOnly:Boolean(P),productOptions:Gi(N,n),forceIncluded:!I&&_h(N,e),onEdit:!P&&ut(N)?()=>l(t,N):void 0,onRemove:P?void 0:ut(N)?()=>c(t,e,N):r1(N)?()=>void d(t,e,N):void 0}),C.filter(V=>{var z;return((z=Bh(V,W))==null?void 0:z.key)===N.key}).map(V=>(0,Ze.jsx)(Dh,{line:V,currency:o,moneyFormat:i,busy:a||Boolean(P),onRemove:()=>u==null?void 0:u(N)},V.key))]},N.key);return I?(0,Ze.jsxs)(Gr.Card,{className:"cart-bundle-card",children:[L(e),w.map(L)]}):(0,Ze.jsx)(Gr.Card,{className:"cart-bundle-card","data-cart-bundle-card":!0,"data-cart-item-id":y.itemId,"data-cart-person-id":t.id,"data-cart-bundle-expanded":p,children:(0,Ze.jsxs)("div",{className:"cart-bundle",children:[(0,Ze.jsxs)(Gr.Top,{className:"cart-bundle-top",children:[(0,Ze.jsx)(Gr.Media,{className:"cart-bundle-media",children:(0,Ze.jsx)(ii,{line:e,options:U,bundle:!0})}),(0,Ze.jsxs)("div",{className:"cart-bundle-summary-main",children:[(0,Ze.jsxs)(Gr.Collapse,{$expanded:p,className:"cart-bundle-collapse",type:"button","aria-expanded":p,"aria-label":p?"Collapse bundle":"Expand bundle",onClick:()=>m(N=>!N),children:[(0,Ze.jsxs)(Gr.Title,{className:"cart-bundle-title",children:[(0,Ze.jsx)(Gr.TitleName,{className:"cart-bundle-title-name",children:Rr(e).replace(/\s+bundle$/i,"")}),(0,Ze.jsxs)(Gr.TitleBundle,{className:"cart-bundle-title-bundle",children:["Bundle ",(0,Ze.jsxs)("small",{children:["(",QM(g)," items)"]})]})]}),(0,Ze.jsx)("svg",{viewBox:"0 0 16 16","aria-hidden":"true",children:(0,Ze.jsx)("path",{d:"m4 10 4-4 4 4",fill:"none",stroke:"currentColor",strokeWidth:"1.8",strokeLinecap:"round",strokeLinejoin:"round"})})]}),(0,Ze.jsx)(Gr.Price,{$sale:b>S,className:"cart-bundle-price",children:b>S?(0,Ze.jsxs)(Ze.Fragment,{children:[(0,Ze.jsx)("s",{children:Me(b,o,i)}),(0,Ze.jsx)("span",{children:Me(S,o,i)})]}):Me(S,o,i)})]}),(0,Ze.jsx)(Gr.Actions,{$inHeader:!0,className:"cart-bundle-actions",children:(0,Ze.jsxs)(Gr.Remove,{className:"cart-bundle-remove",type:"button",disabled:a,"aria-label":"Remove bundle",onClick:()=>void s(t,e),children:[(0,Ze.jsx)(Gr.RemoveIcon,{className:"cart-bundle-remove-icon",viewBox:"0 0 22 22","aria-hidden":"true",children:(0,Ze.jsx)("path",{d:"M3.5 6h15M16.83 6v11.67c0 .92-.75 1.66-1.67 1.66H6.83c-.92 0-1.66-.74-1.66-1.66V6m2.5 0V4.33c0-.92.74-1.66 1.66-1.66h3.34c.92 0 1.66.74 1.66 1.66V6M9.33 10.17v5M12.67 10.17v5",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"})}),(0,Ze.jsx)(Gr.RemoveLabel,{className:"cart-bundle-remove-label",children:"Remove"})]})})]}),(0,Ze.jsxs)(Gr.Children,{className:"cart-bundle-children","aria-label":"Included bundle items",hidden:!p,children:[L(e),w.map(L)]})]})})}function gU(e){var t;return ut(e)?0:he(e).category==="impressionkits"||((t=e.properties)==null?void 0:t.__purchaseMasterItemRole)==="impression-kit"?1:2}function r1(e){let t=he(e);return t.category==="extraproducts"&&t.properties.__bundleIncluded!=="true"&&!Bs(e)&&t.properties.__purchaseMasterStep!=="clinic-scan"&&(Boolean(t.properties.__purchaseMasterStep)||Number(e.original_line_price)>0)}function Kh(e){return e.filter(t=>{var n;let r=String(t.productType||((n=t.purchaseMasterOptions)==null?void 0:n.productType)||"").toLowerCase().replace(/[^a-z]/g,"");return["guard","insole","retainer","whiteningtray"].includes(r)})}function Nc(e,t){let r=Kh(e);return r.find(n=>n.productHandle===t)||r[0]}function Ba(e,t){var s;if(!t||e.roots.some(Aa))return;let r=e.lines.filter(l=>ut(l)||vr(l));if(!r.length||r.some(l=>{var c,d;return((c=l.properties)==null?void 0:c.__purchaseMasterVariantModel)!=="shop-v2"&&((d=l.properties)==null?void 0:d.__bundleTransform)!=="shop-v2"}))return;let n=1+r.reduce((l,c)=>l+Math.max(1,c.quantity),0),o=ga(t,Math.min(n,4),n),i=(s=t.productVariants)==null?void 0:s.find(l=>String(l.gid||l.id).split("/").pop()===o&&l.available!==!1),a=Number(i==null?void 0:i.priceCents);return Number.isFinite(a)&&a>0?a:void 0}function yU(e){return[e.productType,e.productAlias,e.productHandle,e.productTitle].join(" ").toLowerCase()}function SU(e){let t=yU(e);return/night[- ]?guard/.test(t)?0:t.includes("retainer")?1:10}function xU(e,t){return Kh(t).filter(r=>!yU(r).includes("whitening")).flatMap(r=>{let n=Ba(e,r);return n===void 0?[]:[{product:r,price:n}]}).sort((r,n)=>SU(r.product)-SU(n.product)||String(r.product.productTitle).localeCompare(String(n.product.productTitle)))}var $s=T(k()),bU=!1;function aG(e){let t=[e.productType,e.productAlias,e.productHandle,e.productTitle].join(" ").toLowerCase();return/night[- ]?guard/.test(t)?" (for grinding and clenching)":t.includes("retainer")?" (to hold teeth in place)":""}function CU({person:e,bootstrap:t,busy:r,onChoose:n}){if(e.roots.some(Aa))return null;let o=t.ui.cartAddonPlusIconUrl?(0,$s.jsx)(Pt.AddonsIcon,{className:"cart-addons-icon",children:(0,$s.jsx)("img",{src:t.ui.cartAddonPlusIconUrl,width:"24",height:"24",alt:""})}):null;return(0,$s.jsx)(Pt.Addons,{$placement:"person",className:"cart-addons","aria-label":"Quick add products",children:xU(e,t.catalog).map(({product:i,price:a})=>(0,$s.jsxs)("button",{type:"button",disabled:r,onClick:()=>n(i),children:[o,(0,$s.jsxs)("span",{children:["Add"," ",String(i.productTitle||"").replace(/\s+bundle$/i,""),aG(i)," +",Lc(a,t.ui.currency,t.ui.moneyFormat)]})]},i.productHandle))})}var Ke=T(k());function PU({person:e,snapshot:t,bootstrap:r,currency:n,moneyFormat:o,busy:i,onRename:a,onRemovePerson:s,onRemoveBundle:l,onRemoveLine:c,onRemoveComponent:d,onRemoveGuard:u,onAddProduct:p,onQuickAddProduct:m,onEditGuard:g,onRemoveTag:y}){let[P,Y]=(0,Hh.useState)(!1),[h,S]=(0,Hh.useState)(e.firstName),[b,W]=(0,Hh.useState)(e.lastName),C=e.roots,w=Ba(e,Nc(r.catalog)),I=e.lines.filter(X=>!C.some(N=>en(e,N).some(V=>V.key===X.key))),U=[e.firstName,e.lastName].filter(Boolean).join(" ")||("Customer "+(e.personNumber||"")).trim();async function L(X){X.preventDefault(),await a(e,h.trim(),b.trim())!==!1&&Y(!1)}return(0,Ke.jsxs)(Pt.PersonGroup,{className:"cart-person-group","data-cart-person":!0,"data-cart-person-id":e.id,children:[(0,Ke.jsxs)(go.Person,{className:"cart-person","aria-labelledby":"cart-person-"+e.id,children:[(0,Ke.jsxs)(go.Header,{className:"cart-person-header",children:[(0,Ke.jsxs)(go.Title,{className:"cart-person-title",children:[(0,Ke.jsx)("span",{id:"cart-person-"+e.id,children:U}),(0,Ke.jsx)(go.IconButton,{className:"cart-icon-button",type:"button","aria-label":P?"Cancel rename":"Rename person","aria-controls":"CartPersonRename-"+e.id,"aria-expanded":P,onClick:()=>Y(X=>!X),children:(0,Ke.jsxs)("svg",{viewBox:"0 0 20 20","aria-hidden":"true",children:[(0,Ke.jsx)("path",{d:"M2.3954 15.0973C2.43368 14.7527 2.45283 14.5804 2.50496 14.4194C2.55121 14.2765 2.61656 14.1405 2.69923 14.0152C2.79241 13.8739 2.91499 13.7513 3.16014 13.5061L14.1654 2.5009C15.0859 1.58043 16.5782 1.58043 17.4987 2.5009C18.4192 3.42138 18.4192 4.91376 17.4987 5.83424L6.49347 16.8395C6.24832 17.0846 6.12574 17.2072 5.98444 17.3004C5.85907 17.383 5.72311 17.4484 5.58024 17.4946C5.4192 17.5468 5.24691 17.5659 4.90234 17.6042L2.08203 17.9176L2.3954 15.0973Z",fill:"none",stroke:"currentColor",strokeWidth:"1.66667",strokeLinecap:"round",strokeLinejoin:"round"}),(0,Ke.jsx)("line",{x1:"9",y1:"18.5",x2:"19",y2:"18.5",stroke:"currentColor"})]})})]}),(0,Ke.jsxs)(go.Actions,{className:"cart-person-actions",children:[(0,Ke.jsxs)(go.AddGuard,{className:"cart-person-add-guard",type:"button",disabled:i,onClick:()=>p(e),children:[r.ui.addGuardLabel||"Add Guard",w!==void 0?` +${Lc(w,n,o)}`:""]}),(0,Ke.jsx)(go.Action,{$muted:!0,type:"button",disabled:i,onClick:()=>s(e),children:"Remove customer"})]})]}),P?(0,Ke.jsxs)(go.Rename,{className:"cart-person-rename",id:"CartPersonRename-"+e.id,onSubmit:L,children:[(0,Ke.jsxs)("label",{children:[(0,Ke.jsx)("span",{children:"First name"}),(0,Ke.jsx)("input",{autoComplete:"given-name",maxLength:50,value:h,onChange:X=>S(X.target.value)})]}),(0,Ke.jsxs)("label",{children:[(0,Ke.jsx)("span",{children:"Last name"}),(0,Ke.jsx)("input",{autoComplete:"family-name",maxLength:50,value:b,onChange:X=>W(X.target.value)})]}),(0,Ke.jsxs)(go.RenameActions,{className:"cart-person-rename-actions",children:[(0,Ke.jsx)("button",{type:"button",disabled:i,onClick:()=>Y(!1),children:"Cancel"}),(0,Ke.jsx)("button",{type:"submit",disabled:i,children:"Save"})]})]}):null,(0,Ke.jsxs)(go.Bundles,{className:"cart-person-bundles",children:[C.map(X=>{var N;return(0,Ke.jsx)(YU,{root:X,person:e,snapshot:t,bootstrap:r,currency:n,moneyFormat:o,busy:i,onRemoveBundle:l,onEditGuard:g,onRemoveGuard:u,onRemoveComponent:d,onRemoveTag:y},String(((N=X.properties)==null?void 0:N.__itemId)||X.key))}),I.map(X=>(0,Ke.jsx)(Zi,{line:X,presentation:"standalone",currency:n,moneyFormat:o,busy:i,onRemove:()=>c(X)},X.key))]})]}),bU?(0,Ke.jsx)(CU,{person:e,bootstrap:r,busy:i,onChoose:X=>m(e,X.productHandle||"")}):null]})}var Os=T(k());function Ec({lines:e,presentation:t,bootstrap:r,busyKeys:n,onQuantityChange:o}){if(!e.length)return null;let i=e.map(a=>(0,Os.jsx)(Zi,{line:a,currency:r.ui.currency||"USD",moneyFormat:r.ui.moneyFormat,presentation:t,busy:n.has(`line-${a.key}`),onQuantity:s=>void o(a,s),onRemove:()=>void o(a,0),quantity:!0},a.key));return t==="ordinary"?(0,Os.jsx)(Pt.PersonGroup,{$card:!0,className:"cart-person-group cart-person","aria-label":"Other cart items",children:i}):(0,Os.jsxs)(ti.Accessories,{className:"cart-accessories","aria-labelledby":"cart-accessories-title",children:[(0,Os.jsx)("h2",{id:"cart-accessories-title",children:r.ui.accessoriesTitle||"Accessories"}),(0,Os.jsx)(ti.AccessoriesList,{className:"cart-accessories-list",children:i})]})}var WU=T(oe());function sG(e){return window.addEventListener("trufit:cart-checkout-state",e),()=>window.removeEventListener("trufit:cart-checkout-state",e)}function lG(){return typeof window!="undefined"&&Boolean(window.__trufitCartCheckoutBusy)}function vU(){return(0,WU.useSyncExternalStore)(sG,lG,()=>!1)}var cG=f.section`
  order: 2;
  display: grid;
  width: 100%;
  gap: 28px;
  align-content: start;
  box-sizing: border-box;
  padding: 28px;
  border-radius: 28px;
  background: #ffffff;
  box-shadow: 0 0 10px rgba(136, 136, 136, 0.15);

  & p {
    margin: 0;
  }

  & h3 {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
  }

  @media screen and (max-width: 900px) {
    order: 4;
  }
`,dG=f.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px 28px;
`,uG=f.div`
  display: grid;
  flex: 1 1 260px;
  gap: 12px;
  min-width: 0;
`,pG=f.p`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: 0;
`,mG=f.span`
  display: grid;
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  place-items: center;
  border: 3px solid #111111;
  border-radius: 50%;

  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #111111;
  }
`,fG=f.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;

  & strong {
    font-weight: 700;
  }
`,hG=f.p`
  & strong {
    font-weight: 700;
  }

  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
  margin-left: auto;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  white-space: nowrap;

  & img {
    width: 20px;
    height: 20px;
  }
`,gG=f.div.attrs(({$progress:e,$count:t})=>({style:{"--reward-progress":`${e}%`,"--reward-count":t}}))`
  position: relative;
  display: grid;
  grid-template-columns: repeat(var(--reward-count, 3), minmax(0, 1fr));
  gap: 0;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 14px;
    height: 2px;
  }

  &::before {
    right: 0;
    left: 0;
    background: #c8c8c8;
  }

  &::after {
    left: 0;
    width: var(--reward-progress, 0%);
    background: #111111;
  }
`,YG=f.div`
  position: relative;
  display: grid;
  gap: 4px;
  justify-items: center;
  min-width: 0;
  padding-top: 40px;
  text-align: center;

  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 50%;
    width: 28px;
    height: 28px;
    transform: translateX(-50%);
    border: 1px solid #c8c8c8;
    border-radius: 50%;
    background: #ffffff;
  }

  ${({$reached:e,$current:t})=>(e||t)&&v`
      &::after {
        content: "";
        position: absolute;
        z-index: 2;
        left: 50%;
      }
    `}

  ${({$reached:e})=>e&&v`
      &::before {
        border: 0;
        background: #39846c;
      }
      &::after {
        top: 9px;
        width: 9px;
        height: 6px;
        transform: translateX(-50%) rotate(-45deg);
        border-bottom: 2px solid #ffffff;
        border-left: 2px solid #ffffff;
      }
    `}

  ${({$current:e})=>e&&v`
      &::before {
        border: 2px solid #111111;
      }
      &::after {
        top: 11px;
        width: 6px;
        height: 6px;
        transform: translateX(-50%);
        border-radius: 50%;
        background: #111111;
      }
    `}

  & strong {
    font-size: 20px;
    line-height: 24px;
  }

  & span {
    color: #4e4e4f;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
  }
`,SG=f.section`
  max-width: 864px;
  margin-bottom: 24px;
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(17, 17, 17, 0.08);

  & h2 {
    margin: 0 0 24px;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media screen and (max-width: 900px) {
    padding: 18px;
  }
`,yG=f.div`
  display: grid;
`,xG=f.article`
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 88px minmax(0, 1fr);
    gap: 16px;
  }
`,bG=f.div`
  display: grid;
  width: 108px;
  height: 108px;
  place-items: center;
  overflow: hidden;
  border-radius: 8px;
  background: #f6f6f6;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 900px) {
    width: 88px;
    height: 88px;
  }
`,CG=f.div`
  display: grid;
  gap: 6px;

  & > span {
    color: #2d8a70;
    font-size: 14px;
    line-height: 1.3;
    font-weight: 700;
  }
`,PG=f.strong`
  font-size: 18px;
  line-height: 1.25;
`,WG=f.strong`
  color: #2d8a70;
  font-size: 18px;
  line-height: 1.3;

  @media screen and (max-width: 900px) {
    grid-column: 2;
  }
`,nr={Card:cG,CardTop:dG,CardIntro:uG,CardHeadline:pG,CardIcon:mG,CardCopy:fG,CardTotal:hG,Rail:gG,RailStep:YG,Gifts:SG,GiftsList:yG,Gift:xG,GiftMedia:bG,GiftDetails:CG,GiftTitle:PG,GiftPrice:WG};var ze=T(k());function Ac(e){var n,o;let t=e.ui.rewards;if(!(t!=null&&t.enabled))return[];let r=String(e.ui.rewardSalesChannel||((n=e.snapshot.attributes)==null?void 0:n.__salesChannel)||"online-store");return(o=t.salesChannels)!=null&&o.length&&!t.salesChannels.includes(r)?[]:(t.rewards||[]).filter(i=>i.enabled!==!1).sort((i,a)=>Number(i.thresholdCents||0)-Number(a.thresholdCents||0))}function wU({snapshot:e,bootstrap:t}){let{currency:r,moneyFormat:n,rewards:o}=t.ui,i=Ac(t);if(!i.length)return null;let a=e.items.filter(Ra),s=Math.max(0,Number(e.items_subtotal_price||0)-a.reduce((S,b)=>S+Number(b.final_line_price||0),0)),l=Number(e.total_price||0),c=i.filter(S=>s>=Number(S.thresholdCents||0)),d=i.find(S=>s<Number(S.thresholdCents||0)),u=c[c.length-1],p=Number((u==null?void 0:u.thresholdCents)||0),m=Number((d==null?void 0:d.thresholdCents)||p),g=100;if(d){let S=m-p,b=S>0?(s-p)/S*100:0;g=Math.max(0,Math.min(100,b))}let y=d?Math.max(0,Number(d.thresholdCents||0)-s):0,P=d?String((o==null?void 0:o.progressText)||"Spend {remaining} more to unlock {reward}").replace("{remaining}",Me(y,r,n)).replace("{reward}",String(d.label||"your next reward")):"",Y=c.map(S=>String(S.label||"")).filter(Boolean).join(", "),h=o==null?void 0:o.completeHeadline;return d&&(h=c.length?o==null?void 0:o.nextHeadline:o==null?void 0:o.firstHeadline),(0,ze.jsx)(ze.Fragment,{children:(0,ze.jsxs)(nr.Card,{className:"cart-reward-card","aria-label":"Cart rewards",children:[(0,ze.jsxs)(nr.CardTop,{className:"cart-reward-card-top",children:[(0,ze.jsxs)(nr.CardIntro,{className:"cart-reward-card-intro",children:[(0,ze.jsx)("h3",{children:String((o==null?void 0:o.title)||"Rewards")}),(0,ze.jsxs)(nr.CardHeadline,{className:"cart-reward-card-headline",children:[(0,ze.jsx)(nr.CardIcon,{className:"cart-reward-card-icon","aria-hidden":"true"}),(0,ze.jsx)("span",{children:String(h||(d?"Unlock a reward":"Rewards unlocked"))})]}),(0,ze.jsx)(nr.CardCopy,{className:"cart-reward-card-copy",children:d?(0,ze.jsxs)(ze.Fragment,{children:[P,String(o==null?void 0:o.progressText).includes("{reward}")?null:(0,ze.jsxs)(ze.Fragment,{children:[" ",(0,ze.jsx)("strong",{children:String(d.label||"your next reward")})]})]}):(0,ze.jsxs)(ze.Fragment,{children:[String((o==null?void 0:o.completeText)||"You've unlocked {rewards}").split("{rewards}")[0],(0,ze.jsx)("strong",{children:Y})]})})]}),(0,ze.jsxs)(nr.CardTotal,{className:"cart-reward-card-total",children:[t.ui.cartIconUrl?(0,ze.jsx)("img",{src:t.ui.cartIconUrl,alt:"",width:"20",height:"20"}):null,(0,ze.jsx)("span",{children:String((o==null?void 0:o.cartTotalLabel)||"Cart total")}),(0,ze.jsx)("strong",{children:Me(l,r,n)})]})]}),(0,ze.jsx)(nr.Rail,{className:"cart-reward-rail",$progress:g,$count:i.length,"aria-label":"Rewards progress",children:i.map(S=>{let b=Number(S.thresholdCents||0),W=s>=b,C=!W&&d===S;return(0,ze.jsxs)(nr.RailStep,{className:"cart-reward-rail-step",$reached:W,$current:C,children:[(0,ze.jsx)("strong",{children:Me(b,r,n).replace(/\.00(?=\D|$)/,"")}),(0,ze.jsx)("span",{children:String(S.label||"Reward")})]},String(S.id||b))})})]})})}var Qh=T(oe());var Xre=_y`
to {
    transform: rotate(360deg);
  }
`,n1=_y`
to {
    transform: rotate(360deg);
  }
`;var vG=f.section`
  order: 1;
  display: grid;
  gap: 8px;
  padding-top: 24px;
  border-top: 0.5px solid #888888;
  color: #505050;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;

  @media screen and (max-width: 900px) {
    order: 1;
    padding-top: 0;
    border-top: 0;
  }
`,wG=f.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 24px;
  min-height: 24px;

  & strong {
    font-weight: 500;
    text-align: right;
  }

  ${({$subtotal:e})=>e&&v`
      color: #111111;
      font-size: 16px;
    `}
`,TG=f.div`
  order: 3;
  display: block;

  @media screen and (max-width: 1180px) {
    position: sticky;
    bottom: 0;
    z-index: 30;
    padding: 12px 0 max(12px, env(safe-area-inset-bottom));
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0,
      #ffffff 12px,
      #ffffff 100%
    );
  }

  @media screen and (max-width: 900px) {
    ${({$fixedMobile:e})=>e&&v`
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 70;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        justify-content: center;
        box-sizing: border-box;
        padding: 14px var(--trufit-mobile-page-padding-x)
          max(14px, env(safe-area-inset-bottom));
        background: #ffffff;
        box-shadow: 0 -2px 16px rgba(17, 17, 17, 0.08);
      `}
    order: 2;
  }
`,MG=f.a`
  display: inline-flex;
  width: 100%;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 18px;
  border: 0;
  border-radius: 48px;
  background: #111111;
  color: #ffffff;
  font: inherit;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-decoration: none;
  cursor: pointer;

  & svg {
    width: 20px;
    height: 20px;
  }

  ${({$pending:e,$inCart:t})=>e&&v`
      cursor: wait;
      pointer-events: none;
      opacity: ${t?.7:1};
    `}

  @media screen and (max-width: 900px) {
    ${({$inCart:e})=>e&&v`
        max-width: 672px;
      `}
  }
`,UG=f.span`
  display: ${({$pending:e})=>e?"inline-block":"none"};
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${n1} 0.7s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 1.4s;
  }
`,IG=f.svg`
  display: ${({$pending:e})=>e?"none":"inline"};
`,VG=f.section`
  order: 4;
  display: grid;
  gap: 12px;

  @media screen and (max-width: 900px) {
    order: 3;
  }
`,kG=f.form`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 64px;
  gap: 16px;
  min-height: 48px;
  overflow: visible;

  & input {
    min-width: 0;
    box-sizing: border-box;
    height: 48px;
    padding: 0 12px;
    border: 1px solid #cccccc;
    border-radius: 6px;
    background: #ffffff;
    color: #111111;
    font-family: "Poppins", var(--trufit-font-body);
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    outline: none;
  }

  & input::placeholder {
    color: #c7c7c7;
    opacity: 1;
  }

  & button {
    display: inline-flex;
    min-width: 64px;
    height: 48px;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 24px;
    border: 1px solid #111111;
    border-radius: 6px;
    background: #ffffff;
    color: #111111;
    font-family: "Poppins", var(--trufit-font-body);
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    cursor: pointer;
  }

  & button[aria-busy="true"] {
    cursor: wait;
    pointer-events: none;
  }

  @media screen and (max-width: 900px) {
    & input {
      border-color: #cccccc;
    }
  }
`,LG=f.span`
  display: ${({$pending:e})=>e?"inline-block":"none"};
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${n1} 0.7s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 1.4s;
  }
`,XG=f.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`,NG=f.button`
  position: relative;
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  border: 0;
  border-radius: 6px;
  background: #d9d9d9;
  color: #111111;
  font-family: var(--trufit-font-body);
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #111111;
    outline-offset: 2px;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`,EG=f.span`
  position: absolute;
  top: -7px;
  right: -7px;
  display: grid;
  width: 14px;
  height: 14px;
  place-items: center;
  border-radius: 50%;
  background: #111111;
  color: #ffffff;
  font-family: var(--trufit-font-body);
  font-size: 10px;
  line-height: 14px;
  font-weight: 700;
`,hr={Totals:vG,TotalsRow:wG,Shell:TG,Button:MG,Spinner:UG,Arrow:IG,Coupon:VG,CouponForm:kG,CouponSpinner:LG,CouponChips:XG,CouponChip:NG,CouponChipRemove:EG};var Tn=T(k());function TU({snapshot:e,busy:t,onCoupon:r}){let[n,o]=(0,Qh.useState)(""),[i,a]=(0,Qh.useState)(""),[s,l]=(0,Qh.useState)(!1),c=(e.cart_level_discount_applications||[]).filter(p=>p.type==="discount_code");async function d(p){let m=p==="",g=m?"We couldn't remove this coupon.":"We couldn't apply this coupon.";l(!0),a("");try{await r(p),m||o(""),a(m?"Coupon removed.":"Coupon updated.")}catch(y){a(y instanceof Error?y.message:g)}finally{l(!1)}}async function u(p){p.preventDefault(),n.trim()&&await d(n)}return(0,Tn.jsxs)(hr.Coupon,{className:"cart-coupon","aria-label":"Coupon code",children:[(0,Tn.jsxs)(hr.CouponForm,{className:"cart-coupon-form",onSubmit:u,children:[(0,Tn.jsx)("input",{value:n,onChange:p=>o(p.target.value),placeholder:"Coupon",autoComplete:"off",autoCapitalize:"characters","aria-label":"Coupon code"}),(0,Tn.jsxs)("button",{type:"submit","aria-label":"Apply coupon code",disabled:s||t,"aria-busy":s||void 0,children:[(0,Tn.jsx)("span",{hidden:s,"data-cart-discount-submit-label":!0,children:s?"\u2026":"GO"}),(0,Tn.jsx)(hr.CouponSpinner,{$pending:s,className:"cart-coupon-spinner","aria-hidden":"true"})]})]}),c.length?(0,Tn.jsx)(hr.CouponChips,{className:"cart-coupon-chips","aria-label":"Applied coupons",children:c.map((p,m)=>(0,Tn.jsxs)(hr.CouponChip,{className:"cart-coupon-chip",type:"button",disabled:s||t,onClick:()=>void d(""),"aria-label":`Remove discount ${p.title}`,children:[(0,Tn.jsx)("span",{className:"cart-coupon-chip-label",children:p.title}),(0,Tn.jsx)(hr.CouponChipRemove,{className:"cart-coupon-chip-remove","aria-hidden":"true",children:"\xD7"})]},`${p.title}-${m}`))}):null,i?(0,Tn.jsx)(Ar.StatusMessage,{$kind:i.endsWith("updated.")||i.endsWith("removed.")?"success":"error",role:"status",children:i}):null]})}var jh=T(oe());var AG=f.article`
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: 88px minmax(0, 1fr);
  column-gap: 16px;
  align-items: end;
  height: 120px;
  box-sizing: border-box;
  overflow: hidden;
  padding: 16px;
  border: 0.5px solid #888888;
  border-radius: 12px;
  background: #ffffff;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: start;
    min-height: 168px;
    height: auto;
    padding: 12px;
    row-gap: 12px;
  }
`,RG=f.a`
  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  display: grid;
  width: 88px;
  height: 88px;
  place-items: center;
  overflow: hidden;
  border-radius: 0;
  background: #ffffff;
  color: #111111;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
`,GG=f.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
`,_G=f.div`
  display: grid;
  grid-auto-rows: max-content;
  gap: 8px;
  align-content: start;
  align-self: stretch;
  min-width: 0;

  @media screen and (max-width: 900px) {
    justify-items: center;
    gap: 8px;
    width: 100%;
    text-align: center;
  }
`,BG=f.h3`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;

  & a {
    color: inherit;
    text-decoration: none;
  }

  @media screen and (max-width: 900px) {
    justify-content: center;
    text-align: center;
  }
`,ZG=f.span`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 80px;
  height: 30px;
  overflow: visible;

  & > img {
    position: absolute;
    top: -4px;
    left: -4px;
    display: block;
    width: 88px;
    height: 38px;
    max-width: none;
  }

  & > span {
    position: absolute;
    top: 0;
    left: 0;
    display: grid;
    width: 74px;
    height: 24px;
    place-items: center;
    color: #39846c;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
  }
`,$G=f.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  @media screen and (max-width: 900px) {
    justify-content: center;
  }
`,OG=f.button.attrs(({$color:e})=>({style:{"--trufit-rec-swatch":e}}))`
  position: relative;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    inset: 2px;
    border-radius: 50%;
    background: var(--trufit-rec-swatch, #d9d9d9);
  }

  ${({$selected:e})=>e&&v`
      border-color: #1d1d1f;
    `}
`,FG=f.button`
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 8px;
  border: 0;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #111111;
  color: #111111;
  font: inherit;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;

  ${({$selected:e})=>e&&v`
      background: #111111;
      box-shadow: none;
      color: #ffffff;
    `}
`,DG=f.div`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-weight: 500;

  & s {
    color: #888888;
    font-size: 14px;
    font-weight: 400;
  }

  @media screen and (max-width: 900px) {
    justify-content: center;
    text-align: center;
  }
`,zG=f.button`
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-size: 0;
  line-height: 0;
  text-decoration: none;
  cursor: pointer;

  & img {
    display: block;
    width: 32px;
    height: 32px;
    max-width: none;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.45;
  }

  @media screen and (max-width: 900px) {
    top: 12px;
    right: 12px;
    bottom: auto;
  }
`,KG=f.section`
  order: 5;
  width: 100%;
  max-width: 384px;
  font-variation-settings: "opsz" 14;

  @media screen and (max-width: 1180px) {
    max-width: none;
  }

  @media screen and (max-width: 900px) {
    order: 5;
  }
`,HG=f.div`
  width: 100%;
  height: 516px;

  @media screen and (max-width: 900px) {
    height: auto;
  }
`,QG=f.div`
  display: grid;
  grid-auto-rows: 120px;
  gap: 12px;
  width: 100%;
  height: 516px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #c8c8c8;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: auto;
    gap: 12px;
    height: auto;
    overflow: visible;
  }
`,Tr={Card:AG,CardMedia:RG,CardImage:GG,CardBody:_G,CardTitle:BG,CardBadge:ZG,CardOptions:$G,CardOptionSwatch:OG,CardOptionLabel:FG,CardPrice:DG,CardAdd:zG,Section:KG,Frame:HG,List:QG};var or=T(k());function MU({item:e,busy:t,currency:r,moneyFormat:n,settings:o,hasGuard:i,badgeIconUrl:a,addIconUrl:s,onAdd:l}){var I;let c=(0,jh.useMemo)(()=>e.variants.filter(U=>U.available),[e.variants]),[d,u]=(0,jh.useState)(((I=c[0])==null?void 0:I.id)||""),p=c.find(U=>U.id===d)||c[0];if(!p)return null;let m={productGid:`gid://shopify/Product/${e.productId}`,productHandle:e.handle,productTitle:e.title,productType:e.productType,variantPrice:Me(p.priceCents,r,n),variantPriceCents:p.priceCents},g=o,y=Ol(g,m,Date.now()),P=i?ma(g,m):null,Y=Math.round(Number((y==null?void 0:y.savings)||0)*100),h=P?Math.round(p.priceCents*Number(P.discountPercent||0)/100):0,S=p.priceCents,b=Math.max(p.priceCents,Number(p.compareAtPriceCents||0)),W=e.badge;Y>h?(S-=Y,b=p.priceCents,W=y==null?void 0:y.discountBadge):h>0&&(S-=h,b=p.priceCents,W=(P==null?void 0:P.badgeLabel)||`${P==null?void 0:P.discountPercent}%OFF`);let C=`${e.url}?variant=${p.id}`,w=c.length>1&&p.title&&p.title!=="Default Title";return(0,or.jsxs)(Tr.Card,{className:"cart-recommendation-card",children:[(0,or.jsx)(Tr.CardMedia,{className:"cart-recommendation-card-media",href:C,tabIndex:-1,"aria-hidden":"true",children:(0,or.jsx)(Tr.CardImage,{className:"cart-recommendation-card-image",src:p.imageUrl||e.imageUrl||"",alt:"",loading:"lazy"})}),(0,or.jsxs)(Tr.CardBody,{className:"cart-recommendation-card-body",children:[(0,or.jsx)(Tr.CardTitle,{className:"cart-recommendation-card-title",children:(0,or.jsxs)("a",{href:C,children:[e.title,w?` \u2013 ${p.title}`:""]})}),W?(0,or.jsxs)(Tr.CardBadge,{className:"cart-recommendation-card-badge",children:[a?(0,or.jsx)("img",{src:a,alt:"",width:"88",height:"38","aria-hidden":"true"}):null,(0,or.jsx)("span",{children:W})]}):null,c.length>1?(0,or.jsx)(Tr.CardOptions,{className:"cart-recommendation-card-options",role:"group","aria-label":`Choose ${e.title} option`,children:c.map(U=>U.swatchColor?(0,or.jsx)(Tr.CardOptionSwatch,{className:"cart-recommendation-card-option-swatch",type:"button",$color:U.swatchColor,"aria-label":U.title,title:U.title,$selected:U.id===p.id,"aria-pressed":U.id===p.id,onClick:()=>u(U.id)},U.id):(0,or.jsx)(Tr.CardOptionLabel,{className:"cart-recommendation-card-option-label",type:"button",$selected:U.id===p.id,"aria-pressed":U.id===p.id,onClick:()=>u(U.id),children:U.title},U.id))}):null,(0,or.jsxs)(Tr.CardPrice,{className:"cart-recommendation-card-price",children:[Me(S,r,n).replace(/\.00$/,""),b>S?(0,or.jsxs)("s",{children:[" ",Me(b,r,n).replace(/\.00$/,"")]}):null]})]}),(0,or.jsx)(Tr.CardAdd,{className:"cart-recommendation-card-add",type:"button","aria-label":`Add ${e.title} to cart`,disabled:t,onClick:()=>l(e,p.id),children:s?(0,or.jsx)("img",{src:s,alt:"",width:"32",height:"32","aria-hidden":"true"}):null})]})}var Fs=T(k());function UU({snapshot:e,bootstrap:t,busy:r,onAdd:n}){if(!t.ui.recommendations.length)return null;let o=xe(e).some(i=>{var s;let a=String(((s=i.properties)==null?void 0:s.__category)||"").replace(/\s+/g,"").toLowerCase();return a==="guard"||a==="guards"});return(0,Fs.jsxs)(Tr.Section,{className:"cart-recommended","aria-labelledby":"cart-recommended-title",children:[(0,Fs.jsx)("h2",{id:"cart-recommended-title",children:t.ui.recommendedTitle||"Recommended for You"}),(0,Fs.jsx)(Tr.Frame,{className:"cart-recommendations-frame",children:(0,Fs.jsx)(Tr.List,{className:"cart-recommendations",children:t.ui.recommendations.map(i=>{var a,s;return(0,Fs.jsx)(MU,{item:i,busy:r,currency:t.ui.currency,moneyFormat:t.ui.moneyFormat,settings:t.settings,hasGuard:o,badgeIconUrl:(a=t.ui.recommendationIconUrls)==null?void 0:a.discount,addIconUrl:(s=t.ui.recommendationIconUrls)==null?void 0:s.plus,onAdd:n},i.productId)})})})]})}var jG=f.aside`
  min-height: 100%;
  padding: 36px 48px;
  background: #ffffff;
  border-left: 0;
  box-shadow: inset 0.5px 0 0 #888888;

  & h2 {
    display: flex;
    min-height: 32px;
    align-items: center;
    margin: 0 0 24px;
    font-size: 16px;
    line-height: 32px;
    font-weight: 700;
    letter-spacing: -0.64px;
  }

  @media screen and (max-width: 1180px) {
    border-left: 0;
    border-top: 1px solid #d9d9d9;
    box-shadow: none;
  }

  @media screen and (max-width: 900px) {
    padding-inline: var(--trufit-mobile-page-padding-x);
    padding-top: 20px;
    padding-bottom: 40px;
    border-top: 0;
    background: #ffffff;
    & h2 {
      margin-bottom: 12px;
    }
  }
`,qG=f.div`
  position: sticky;
  top: 24px;
  display: grid;
  gap: 24px;
  width: 100%;
  max-width: 384px;

  @media screen and (max-width: 1180px) {
    position: static;
    max-width: 864px;
    margin: 0 auto;
  }

  @media screen and (max-width: 900px) {
    gap: 20px;
    max-width: none;
  }
`,JG=f.div`
  order: 6;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  padding: 24px 0;
  text-align: center;

  @media screen and (max-width: 1180px) {
    padding-bottom: calc(24px + 72px + env(safe-area-inset-bottom));
  }

  @media screen and (max-width: 900px) {
    order: 6;
    padding: 24px 0 0;
  }
`,e_=f.div`
  display: grid;
  gap: 8px;
  justify-items: center;
  min-width: 0;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
`,t_=f.span`
  display: block;
  width: 40px;
  height: 40px;
  line-height: 0;

  & img {
    display: block;
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
`,Rc={Sidebar:jG,SidebarInner:qG,Trust:JG,TrustItem:e_,TrustIcon:t_};var On=T(k());function o1({snapshot:e,bootstrap:t}){let r=e.items.filter(Ra);return r.length?(0,On.jsxs)(nr.Gifts,{className:"cart-reward-gifts","aria-label":t.ui.rewardGiftsTitle||"Your rewards",children:[(0,On.jsx)("h2",{children:t.ui.rewardGiftsTitle||"Your rewards"}),(0,On.jsx)(nr.GiftsList,{className:"cart-reward-gifts-list",children:r.map(n=>{let o=oi(n.featured_image)||oi(n.image),i=Number(n.final_line_price||0);return(0,On.jsxs)(nr.Gift,{className:"cart-reward-gift",children:[(0,On.jsx)(nr.GiftMedia,{className:"cart-reward-gift-media",children:o?(0,On.jsx)("img",{src:o,alt:"",loading:"lazy"}):null}),(0,On.jsxs)(nr.GiftDetails,{className:"cart-reward-gift-details",children:[(0,On.jsx)(nr.GiftTitle,{className:"cart-reward-gift-title",children:Rr(n)}),(0,On.jsx)("span",{children:t.ui.rewardGiftIncluded||"Included with your rewards"})]}),(0,On.jsx)(nr.GiftPrice,{className:"cart-reward-gift-price",children:i<=0?t.ui.rewardFreeLabel||"FREE":Me(i,t.ui.currency,t.ui.moneyFormat)})]},n.key)})})]}):null}var $e=T(k());function IU({snapshot:e,bootstrap:t,busy:r,inCart:n=!1,onCoupon:o,onAddRecommendation:i}){var g,y,P;let a=vU(),{currency:s,moneyFormat:l}=t.ui,c=Number(e.original_total_price||0),d=Number(e.total_discount||0),u=Number(e.total_price||0),p=Zh(e),m=Ac(t).find(Y=>Y.type==="free_shipping"&&Number(Y.thresholdCents)<=Number(e.items_subtotal_price||0));return(0,$e.jsx)(Rc.Sidebar,{className:"cart-sidebar","aria-label":"Cart summary",children:(0,$e.jsxs)(Rc.SidebarInner,{className:"cart-sidebar-inner",children:[(0,$e.jsxs)(hr.Totals,{className:"cart-totals","aria-label":"Cart totals",children:[(0,$e.jsxs)(hr.TotalsRow,{className:"cart-totals-row",children:[(0,$e.jsx)("span",{children:"Item(s) total"}),(0,$e.jsx)("strong",{children:Me(c,s,l)})]}),(0,$e.jsxs)(hr.TotalsRow,{className:"cart-totals-row cart-totals-row-discount",children:[(0,$e.jsx)("span",{children:"Discount total"}),(0,$e.jsx)("strong",{children:Me(d,s,l)})]}),m?(0,$e.jsxs)(hr.TotalsRow,{className:"cart-totals-row",children:[(0,$e.jsx)("span",{children:"Shipping"}),(0,$e.jsxs)("strong",{children:[String(m.shippingMethod||"standard").replace(/^./,Y=>Y.toUpperCase()),": Free"]})]}):null,(0,$e.jsxs)(hr.TotalsRow,{$subtotal:!0,className:"cart-totals-row",children:[(0,$e.jsx)("span",{children:"Subtotal"}),(0,$e.jsx)("strong",{children:Me(u,s,l)})]})]}),(0,$e.jsx)(wU,{snapshot:e,bootstrap:t}),p?(0,$e.jsx)(hr.Shell,{$fixedMobile:n,className:"cart-checkout-shell",children:(0,$e.jsxs)(hr.Button,{$pending:a,$inCart:n,"aria-busy":a||void 0,"aria-disabled":a||void 0,className:"cart-checkout","data-cart-checkout":!0,href:t.ui.checkoutUrl,"data-cart-checkout-default-label":"Checkout","data-cart-checkout-loading-label":"Preparing checkout\u2026",children:[(0,$e.jsx)("span",{"data-cart-checkout-label":!0,children:a?"Preparing checkout\u2026":"Checkout"}),(0,$e.jsx)(hr.Spinner,{$pending:a,className:"cart-checkout-spinner","aria-hidden":"true"}),(0,$e.jsx)(hr.Arrow,{$pending:a,className:"cart-checkout-arrow",viewBox:"0 0 18 16","aria-hidden":"true",children:(0,$e.jsx)("path",{d:"M1 8h15m-6-6 6 6-6 6",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"})})]})}):null,(0,$e.jsx)(TU,{snapshot:e,busy:r,onCoupon:o}),(0,$e.jsx)(UU,{snapshot:e,bootstrap:t,busy:r,onAdd:i}),(0,$e.jsx)(Rc.Trust,{className:"cart-trust","aria-label":"Store guarantees",children:[[(g=t.ui.trustIconUrls)==null?void 0:g.madeInUSA,"Made in USA"],[(y=t.ui.trustIconUrls)==null?void 0:y.printed,"Laser 3D Printed"],[(P=t.ui.trustIconUrls)==null?void 0:P.scanStorage,"Scan Storage"]].map(([Y,h])=>(0,$e.jsxs)(Rc.TrustItem,{className:"cart-trust-item",children:[(0,$e.jsx)(Rc.TrustIcon,{className:"cart-trust-icon",children:Y?(0,$e.jsx)("img",{src:Y,alt:"",width:"40",height:"40",loading:"lazy"}):null}),(0,$e.jsx)("span",{children:h})]},h))})]})})}var Gc=T(oe());var Ds=T(k()),VU=[{key:"Position",config:"positions",state:"position"},{key:"Sport",config:"sports",state:"sport"},{key:"Thickness Size",config:"thicknessSizes",state:"thicknessSize"},{key:"Color",config:"colors",state:"color"},{key:"Pad color",config:"padColors",state:"padColor"}];function i1(e,t){let r=e==null?void 0:e[t];return Array.isArray(r)?r.flatMap(n=>{if(!n||typeof n!="object")return[];let o=String(n.value||""),i=String(n.label||o);return o?[{value:o,label:i}]:[]}):[]}function Ju(e,t,r){var o;let n=r.trim().toLowerCase();return((o=i1(e,t).find(i=>i.value.trim().toLowerCase()===n||i.label.trim().toLowerCase()===n))==null?void 0:o.value)||""}function r_(e,t,r){let n=r.trim().toLowerCase(),o=i1(e,t).find(i=>i.value.trim().toLowerCase()===n||i.label.trim().toLowerCase()===n);return(o==null?void 0:o.label)||(o==null?void 0:o.value)||r}function n_(e,t){var r;return VU.some(n=>i1(e,n.config).length>0)||Boolean(((r=t==null?void 0:t.initials)==null?void 0:r.isAvailable)&&t.initials.variantGids)}function kU({person:e,root:t,catalog:r,settings:n,productOptions:o,onClose:i,onSaved:a,onDelete:s}){var w;let l=Jr(t,r)||void 0,c=(l==null?void 0:l.purchaseMasterOptions)||o,d=String(t.handle||((w=t.product)==null?void 0:w.handle)||""),u=Rr(t),p=String(t.image||""),m=(l==null?void 0:l.initials)||(c==null?void 0:c.initials),g=String((l==null?void 0:l.productImageUrl)||p||""),y=(0,Gc.useMemo)(()=>({...n,...c||{},isPurchaseMasterEnabled:(c==null?void 0:c.isPurchaseMasterEnabled)!==!1,productType:String((c==null?void 0:c.productType)||(l==null?void 0:l.productType)||"guard"),productAlias:(l==null?void 0:l.productAlias)||String((c==null?void 0:c.productAlias)||""),initials:m,productVariants:l==null?void 0:l.productVariants,currentProduct:{handle:(l==null?void 0:l.productHandle)||d,title:(l==null?void 0:l.productTitle)||u,imageUrl:g,imageUrls:l==null?void 0:l.productImageUrls,variantGid:l==null?void 0:l.variantGid,variantPrice:l==null?void 0:l.variantPrice,variantPriceCents:l==null?void 0:l.variantPriceCents,compareAtPrice:l==null?void 0:l.compareAtPrice,discountLabel:l==null?void 0:l.discountLabel,discountPercent:l==null?void 0:l.discountPercent}}),[m,c,l,g,d,u,n]),P=(0,Gc.useMemo)(()=>{let I=Te(t,"Initials","ID tag","Custom ID tag");return{...zo(y),recipientType:"someoneElse",recipientFirstName:e.firstName,recipientLastName:e.lastName,position:Ju(c,"positions",Te(t,"Position")),sport:Ju(c,"sports",Te(t,"Sport")),thicknessSize:Ju(c,"thicknessSizes",Te(t,"Thickness Size")),color:Ju(c,"colors",Te(t,"Color","Guard Color")),padColor:Ju(c,"padColors",Te(t,"Pad color","Pad Color","Compression Pad Color")),initials:I,initialsOptIn:Boolean(I)}},[y,c,e.firstName,e.lastName,t]),Y=n_(c,l),[h,S]=(0,Gc.useState)(!1),[b,W]=(0,Gc.useState)("");async function C(I){if(Y){S(!0),W("");try{let U=Object.fromEntries(VU.map(L=>[L.key,r_(c,L.config,I[L.state])]));await z0(t,{...U,Initials:I.initialsOptIn?ao(I.initials):""},r,m),a()}catch(U){W(U instanceof Error?U.message:"We couldn't save these bundle changes.")}finally{S(!1)}}}return(0,Ds.jsxs)(Ds.Fragment,{children:[(0,Ds.jsx)(qr.Document,{}),(0,Ds.jsx)(Qo,{config:y,guardIndex:Math.max(0,e.lines.filter(ut).sort((I,U)=>{var L,X;return Number(((L=I.properties)==null?void 0:L.__purchaseMasterGuardSlot)||1)-Number(((X=U.properties)==null?void 0:X.__purchaseMasterGuardSlot)||1)}).findIndex(I=>I.key===t.key)),initialState:P,labels:{closeLabel:"Close"},previewImageUrl:g,saving:h,externalStatus:b,readOnlyMessage:Y?"":"These saved product options can\u2019t be edited from the cart. Remove the bundle and add the product again to choose new options.",saveDisabled:!Y,onCancel:i,onSave:C,onDelete:s})]})}var o_=f.div`
  &[hidden] {
    display: none;
  }

  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 24px;

  @media screen and (max-width: 900px) {
    align-items: center;
    padding: calc(20px + env(safe-area-inset-top))
      calc(20px + env(safe-area-inset-right))
      calc(20px + env(safe-area-inset-bottom))
      calc(20px + env(safe-area-inset-left));
  }
`,i_=f.button`
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(17, 17, 17, 0.52);
  cursor: pointer;
`,a_=f.section`
  position: relative;
  z-index: 1;
  display: grid;
  gap: 20px;
  width: min(100%, 520px);
  box-sizing: border-box;
  padding: 28px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.25);

  & header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  & p {
    margin: 0;
  }

  & h2 {
    margin: 0;
    font-size: 24px;
    line-height: 1.2;
  }

  & header button {
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #111111;
    font: inherit;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
  }

  & [data-cart-custom-select-menu][hidden] {
    display: none;
  }

  & > button {
    min-height: 48px;
    border: 0;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    font: inherit;
    font-weight: 700;
    cursor: pointer;
  }

  & > button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  @media screen and (max-width: 900px) {
    width: 100%;
    max-width: 520px;
    max-height: calc(
      100dvh - 40px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    overflow-y: auto;
    padding: 22px;
    border-radius: 12px;
  }
`,s_=f.div`
  display: grid;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;

  &[hidden] {
    display: none;
  }
`,ep={Root:o_,Scrim:i_,Panel:a_,Field:s_};var _c=T(oe());var Dt=T(k());function LU({mode:e,person:t,initialType:r,products:n,busy:o,ui:i,onChoose:a,onClose:s}){let l=(0,_c.useMemo)(()=>Kh(n),[n]),c=Nc(l,r),[d,u]=(0,_c.useState)((c==null?void 0:c.productHandle)||""),p=l.find(y=>y.productHandle===d)||l[0],m=Ba(t,p),g=_a(s,o);return(0,_c.useEffect)(()=>{u((c==null?void 0:c.productHandle)||"")},[c==null?void 0:c.productHandle,r]),(0,Dt.jsxs)(Dt.Fragment,{children:[(0,Dt.jsx)(qr.Document,{}),(0,Dt.jsxs)(ep.Root,{className:"cart-product-modal",role:"presentation",onMouseDown:y=>{y.target===y.currentTarget&&!o&&s()},children:[(0,Dt.jsx)(ep.Scrim,{type:"button",className:"cart-product-modal-scrim","aria-label":i.closeProductSelectionLabel||"Close product selection",disabled:o,onClick:s}),(0,Dt.jsxs)(ep.Panel,{className:"cart-product-modal-panel",ref:g,role:"dialog","aria-modal":"true","aria-labelledby":"cart-product-picker-title","aria-busy":o||void 0,children:[(0,Dt.jsxs)("header",{children:[(0,Dt.jsx)("h2",{id:"cart-product-picker-title",children:i.addProductTitle||"Add product"}),(0,Dt.jsx)("button",{type:"button","aria-label":i.closeProductSelectionLabel||"Close product selection",disabled:o,onClick:s,children:"\xD7"})]}),(0,Dt.jsxs)(ep.Field,{className:"cart-product-modal-field","data-cart-product-field":!0,children:[(0,Dt.jsx)("span",{id:"cart-product-picker-product-label",children:i.productLabel||"Product"}),(0,Dt.jsx)(Jf,{inProductDialog:!0,ariaLabel:i.productLabel||"Product",disabled:!l.length||o,value:(p==null?void 0:p.productHandle)||"",options:l.map(y=>({value:y.productHandle||"",label:y.productTitle||y.productHandle||"Product"})),onChange:u})]}),(0,Dt.jsxs)("p",{children:[i.addProductCopy||"Choose a product to customize for this person.",m!==void 0?(0,Dt.jsxs)(Dt.Fragment,{children:[" ",(0,Dt.jsxs)("strong",{children:["+",Lc(m,i.currency||"USD",i.moneyFormat)]})]}):null]}),(0,Dt.jsx)("button",{type:"button",disabled:o||!p,"aria-busy":o||void 0,onClick:()=>p&&void a(p,t),children:i.continueLabel||"Continue"})]})]})]})}var l_=f.div`
  &[hidden] {
    display: none;
  }

  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`,c_=f.button`
  position: absolute;
  inset: 0;
  width: 100%;
  border: 0;
  background: rgba(0, 0, 0, 0.36);
`,d_=f.div`
  position: relative;
  width: min(100%, 600px);
  padding: 42px 32px 44px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
  text-align: center;

  & h2 {
    margin: 0 0 30px;
    color: #333;
    font-size: 36px;
    font-weight: 400;
    line-height: 1.2;
  }

  & p {
    max-width: 480px;
    margin: 0 auto 34px;
    color: #444;
    font-size: 20px;
    line-height: 1.5;
  }

  @media (max-width: 600px) {
    padding: 48px 20px 24px;
    & h2 {
      margin-bottom: 20px;
      font-size: 28px;
    }
    & p {
      margin-bottom: 24px;
      font-size: 16px;
    }
  }
`,u_=f.button`
  position: absolute;
  top: 14px;
  right: 16px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  color: #777;
  background: transparent;
  font-size: 32px;
  font-weight: 300;
  line-height: 1;
  cursor: pointer;
`,p_=f.div`
  display: flex;
  gap: 16px;
  margin-top: 0;

  & button {
    flex: 1 1 0;
    min-height: 64px;
    padding: 0 16px;
    border: 1px solid #222;
    border-radius: 8px;
    color: #222;
    background: #fff;
    font: inherit;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    gap: 10px;
    & button {
      min-height: 52px;
      padding: 0 8px;
      font-size: 16px;
    }
  }
`,m_=f.button`
  color: #111;
  background: #fff;
`,f_=f.button`
  color: #222;
  background: #fff;
`,Mr={Root:l_,Scrim:c_,Panel:d_,Close:u_,Actions:p_,Cancel:m_,Remove:f_};var Gt=T(k());function XU({currentCount:e,nextCount:t,currentPackage:r,downgradedPackage:n,guardIndex:o,assets:i,busy:a,onCancel:s,onConfirm:l}){let c=_a(s,a);return r&&n?(0,Gt.jsxs)(Gt.Fragment,{children:[(0,Gt.jsx)(qr.Document,{}),(0,Gt.jsx)("div",{ref:c,children:(0,Gt.jsx)(vc,{arrowIconUrl:i==null?void 0:i.arrowIconUrl,closeIconUrl:i==null?void 0:i.closeIconUrl,currentPackage:r,downgradedPackage:n,guardIconUrl:i==null?void 0:i.guardIconUrl,guardIndex:o,labels:{closeLabel:"Close"},saving:a,warningIconUrl:i==null?void 0:i.warningIconUrl,onCancel:s,onConfirm:l})})]}):(0,Gt.jsxs)(Mr.Root,{className:"cart-confirm",role:"presentation",onMouseDown:d=>{d.target===d.currentTarget&&!a&&s()},children:[(0,Gt.jsx)(Mr.Scrim,{className:"cart-confirm-scrim",type:"button",disabled:a,"aria-label":"Close confirmation",onClick:s}),(0,Gt.jsxs)(Mr.Panel,{className:"cart-confirm-panel",ref:c,role:"dialog","aria-modal":"true","aria-labelledby":"cart-remove-guard-title","aria-busy":a||void 0,children:[(0,Gt.jsx)(Mr.Close,{className:"cart-confirm-close",type:"button","aria-label":"Close confirmation",disabled:a,onClick:s,children:"\xD7"}),(0,Gt.jsx)("h2",{id:"cart-remove-guard-title",children:"Remove this guard?"}),(0,Gt.jsxs)("p",{children:["Removing this guard updates the bundle and its Shopify pricing.",(0,Gt.jsx)("br",{}),(0,Gt.jsxs)("strong",{children:[e," guards"]})," \u2192"," ",(0,Gt.jsxs)("strong",{children:[t," ",t===1?"guard":"guards"]}),".",(0,Gt.jsx)("br",{}),"Any ID Tag linked to this guard will also be removed."]}),(0,Gt.jsxs)(Mr.Actions,{className:"cart-confirm-actions",children:[(0,Gt.jsx)(Mr.Cancel,{className:"cart-confirm-cancel",type:"button",disabled:a,onClick:s,children:"Keep bundle"}),(0,Gt.jsx)(Mr.Remove,{className:"cart-confirm-remove",type:"button",disabled:a,"aria-busy":a||void 0,onClick:l,children:a?"Updating\u2026":"Remove and update"})]})]})]})}var Yo=T(k());function NU({busy:e,onCancel:t,onConfirm:r}){let n=_a(t,e);return(0,Yo.jsxs)(Mr.Root,{className:"cart-confirm",role:"presentation",onMouseDown:o=>{o.target===o.currentTarget&&!e&&t()},children:[(0,Yo.jsx)(Mr.Scrim,{className:"cart-confirm-scrim",type:"button",disabled:e,"aria-label":"Close confirmation",onClick:t}),(0,Yo.jsxs)(Mr.Panel,{className:"cart-confirm-panel",ref:n,role:"dialog","aria-modal":"true","aria-labelledby":"cart-remove-bundle-title","aria-busy":e||void 0,children:[(0,Yo.jsx)(Mr.Close,{className:"cart-confirm-close",type:"button","aria-label":"Close confirmation",disabled:e,onClick:t,children:"\xD7"}),(0,Yo.jsx)("h2",{id:"cart-remove-bundle-title",children:"Remove this bundle?"}),(0,Yo.jsx)("p",{children:"The bundle and its associated products will be removed from your cart."}),(0,Yo.jsxs)(Mr.Actions,{className:"cart-confirm-actions",children:[(0,Yo.jsx)(Mr.Cancel,{className:"cart-confirm-cancel",type:"button",disabled:e,onClick:t,children:"Cancel"}),(0,Yo.jsx)(Mr.Remove,{className:"cart-confirm-remove",type:"button",disabled:e,"aria-busy":e||void 0,onClick:r,children:e?"Removing\u2026":"Remove bundle"})]})]})]})}var Za=T(oe());function EU(e,t){let[r,n]=(0,Za.useState)(()=>new Set),[o,i]=(0,Za.useState)(()=>window.__trufitCartBridgeErrorMessage||""),a=(0,Za.useRef)("");(0,Za.useEffect)(()=>{let l=`${t.token||"cart"}:${t.items_subtotal_price}:${t.items.map(c=>`${c.key}:${c.quantity}`).join("|")}`;a.current!==l&&(a.current=l,q0(e,t).catch(c=>console.error("Cart reward gift sync failed",c)))},[e,t]),(0,Za.useEffect)(()=>{var d;(d=e.syncOrderTags)==null||d.call(e,{force:!0,reason:"cart-react-mounted"});let l=u=>{let p=u.detail;i((p==null?void 0:p.message)||"We couldn't add this item to your cart. Please try again.")},c=u=>{let p=u.detail;i((p==null?void 0:p.message)||"The updated cart could not be confirmed. Refresh the page to review it.")};return window.addEventListener("trufit:cart-bridge-error",l),document.addEventListener("trufit:cart-state-error",c),()=>{window.removeEventListener("trufit:cart-bridge-error",l),document.removeEventListener("trufit:cart-state-error",c)}},[e]);let s=async(l,c)=>{n(d=>new Set(d).add(l)),i("");try{return await c(),!0}catch(d){return i(sU(d)),!1}finally{n(d=>{let u=new Set(d);return u.delete(l),u})}};return{busyKeys:r,busy:r.size>0,status:o,setStatus:i,runOperation:s}}var qh=T(oe());function AU(e,t,r){var d;let n=(e==null?void 0:e.bundlePackages)||((d=e==null?void 0:e.purchaseMasterOptions)==null?void 0:d.bundlePackages);if(!Array.isArray(n))return;let o=n.find(u=>Number(u.iconCount)===t);if(!o)return;let i=String(o.price||o.clinicPrice||"");if(!i)return;let a=String(o.compareAtPrice||o.clinicCompareAtPrice||""),s=Number(i.replace(/[^0-9.]/g,"")),l=Number(a.replace(/[^0-9.]/g,"")),c=String(o.line3||"").trim()||(l>s?`Save ${Me(Math.round((l-s)*100),r)}`:"");return{available:!0,compareAtPrice:a,price:i,quantity:t,saveLabel:c,title:String(o.title||`${t} ${t===1?"guard":"guards"}`)}}function RU(e,t,r,n,o){let i=en(e,t).filter(l=>{var d,u;let c=String(((d=l.properties)==null?void 0:d.__category)||"").replace(/[^a-z]/gi,"").toLowerCase();return["guard","guards","insole","insoles"].includes(c)&&((u=l.properties)==null?void 0:u.__purchaseMasterItemRole)!=="cart-addon-product"}).sort((l,c)=>{var d,u;return Number(((d=l.properties)==null?void 0:d.__purchaseMasterGuardSlot)||1)-Number(((u=c.properties)==null?void 0:u.__purchaseMasterGuardSlot)||1)}),a=i.reduce((l,c)=>l+Math.max(1,Number(c.quantity)||1),0);if(a<=1||vr(r))return{kind:"bundle",person:e,root:r};let s=Jr(t,n)||void 0;return{kind:"guard",person:e,root:t,target:r,guardIndex:Math.max(0,i.findIndex(l=>l.key===r.key)),currentCount:a,nextCount:a-1,currentPackage:AU(s,a,o),downgradedPackage:AU(s,a-1,o)}}function GU(e,t,r){let[n,o]=(0,qh.useState)(null),[i,a]=(0,qh.useState)(null),[s,l]=(0,qh.useState)(null);function c(C,w){o({person:C,root:w,productOptions:Gi(w,e)})}function d(C,w,I){let U=RU(C,w,I,e.catalog,e.ui.currency||"USD");U.kind==="bundle"?l(U):a(U)}async function u(C,w){l({person:C,root:w})}async function p(){if(!i)return;let C=i;await t(`guard-remove-${C.target.key}`,()=>J0(C.person.id,C.root,C.target,e.catalog))&&a(null)}async function m(){if(!s)return;let C=s;await t(`bundle-${C.root.key}`,()=>j0(C.person.id,C.root))&&l(null)}function g(){i&&!r.has(`guard-remove-${i.target.key}`)&&a(null)}function y(){s&&!r.has(`bundle-${s.root.key}`)&&l(null)}function P(C,w,I){return t(`rename-${C.id}`,()=>H0(C,w,I))}async function Y(C){await t(`person-${C.id}`,()=>Q0(C))}async function h(C,w){await t(`line-${C.key}`,()=>Oh(C,w))}async function S(C){await h(C,0)}async function b(C,w,I){await t(`component-${I.key}`,()=>iU(C.id,w,I))}function W(C){t(`tag-${C.key}`,()=>K0(C,e.catalog))}return{editing:n,editGuard:c,closeEditor:()=>o(null),guardRemoval:i,requestGuardRemoval:d,confirmGuardRemoval:p,cancelGuardRemoval:g,bundleRemoval:s,requestBundleRemoval:u,confirmBundleRemoval:m,cancelBundleRemoval:y,renamePerson:P,removePerson:Y,changeQuantity:h,removeLine:S,removeComponent:b,removeTag:W}}var Fn=T(oe());function a1(e){let t=e.roots[0],r=(t==null?void 0:t.properties)||{},n=String((t==null?void 0:t.variant_title)||"").toLowerCase().split(/[^a-z0-9]+/).includes("return"),o=e.lines.filter(s=>{let l=s.properties||{};return String(l.__category||"").replace(/[^a-z]/gi,"").toLowerCase()==="impressionkits"||l.__purchaseMasterItemRole==="impression-kit"||Boolean(l["Impression kit"])}),i=Array.from(new Set(o.flatMap(s=>{var l;return String(((l=s.properties)==null?void 0:l["Impression types"])||"").split(",").map(c=>c.trim().toLowerCase()).filter(Boolean)}))),a=e.lines.reduce((s,l)=>{let c=l.properties||{},d=String(c.__category||"").replace(/[^a-z]/gi,"").toLowerCase(),u=String(c.__purchaseMasterItemRole||""),p=c.__purchaseMasterPaidGuardAddon==="true"||u!=="cart-addon-product"&&["guards","guard","insoles","insole"].includes(d);return s+(p?Math.max(1,Number(l.quantity)||1):0)},0);return{personId:e.id,personCreatedAt:e.createdAt,personNumber:Number(e.personNumber)||void 0,firstName:e.firstName,lastName:e.lastName,isReturnCustomer:r.__purchaseMasterCustomerType==="return"||r.__bundleRole==="return"||r.__purchaseMasterReturnCustomer==="true"||n,hasImpressionKit:o.length>0,impressionPositions:i,guardCount:a,bundleItemId:String(r.__itemId||"")}}function _U(e,t,r,n){let[o,i]=(0,Fn.useState)(null),a=(0,Fn.useMemo)(()=>({...e.settings,catalogProducts:e.catalog,stepsRecommendedProducts:[{title:"upsell",type:"guard",products:e.catalog}],newCustomerModalImageUrl:e.ui.newCustomerModalImageUrl,newCustomerCloseIconUrl:e.ui.newCustomerCloseIconUrl,newCustomerCheckIconUrl:e.ui.newCustomerCheckIconUrl}),[e]),s=(0,Fn.useMemo)(()=>gn(a),[a]),l=(0,Fn.useMemo)(()=>{let h=t.at(-1),S=(h==null?void 0:h.roots.map(b=>Jr(b,e.catalog)).filter(Boolean))||[];return s.find(b=>S.some(W=>(W==null?void 0:W.productHandle)===b.productHandle||(W==null?void 0:W.productAlias)&&W.productAlias===b.productAlias))||s.find(b=>{var W;return Boolean((W=b.bundlePackages)==null?void 0:W.length)})||s[0]},[t,e.catalog,s]),c=(0,Fn.useMemo)(()=>l?Hm({config:a,product:l,fallbackPrice:l.variantPrice}):"",[a,l]);async function d(h,S){var I;let b=(I=e.hosts)==null?void 0:I.purchaseMaster,W=window.TruFitPurchaseMaster,C=String(h.productHandle||"");if(!b||!W||!C)throw new Error("Purchase Master product setup is unavailable.");let w=`${e.ui.rootUrl}products/${encodeURIComponent(C)}`;await W.launchCartAddonCustomization({context:{mode:"add-product",targetHandle:C,person:a1(S)},host:b,productUrl:w})}async function u(h,S){(o==null?void 0:o.mode)==="add-product"&&await d(h,S),i(null)}let p=(0,Fn.useRef)(t);p.current=t;let m=(0,Fn.useRef)(!1);(0,Fn.useEffect)(()=>{var X,N;if(m.current||!t.length)return;let h=new URLSearchParams(window.location.hash.replace(/^#/,"")),S=String(h.get("trufit-cart-add-product")||"").split(",").map(V=>V.trim().toLowerCase()).filter(Boolean);if(!S.length)return;m.current=!0,h.delete("trufit-cart-add-product");let b=h.toString();window.history.replaceState(window.history.state,"",`${window.location.pathname}${window.location.search}${b?`#${b}`:""}`);let W=(X=[...t].sort((V,z)=>z.createdAt-V.createdAt)[0])==null?void 0:X.id,C=(N=e.hosts)==null?void 0:N.purchaseMaster;if(!W||!C)return;let w=()=>p.current.find(V=>V.id===W),I=()=>{let V=w();return V&&a1(V).guardCount||0},U=()=>Boolean(C.querySelector("[data-trufit-cart-addon-customize-react-root]")),L=V=>new Promise(z=>window.setTimeout(z,V));(async()=>{for(let[V,z]of S.entries()){let te=e.catalog.find(Z=>String(Z.productHandle||"").toLowerCase()===z),H=w();if(!te||!H)continue;let E=I();if(await r("launch-product",()=>d(te,H)),V===S.length-1)break;for(await L(400);U();)await L(300);for(let Z=0;Z<20&&I()<=E;Z+=1)await L(300)}})()},[e.catalog,e.hosts,t,r]);function g(){var C,w;let h=(C=e.hosts)==null?void 0:C.newCustomer,S=(w=e.hosts)==null?void 0:w.purchaseMaster,b=window.TruFitPurchaseMaster;if(!h||!S||!(b!=null&&b.openNewCustomerModal)){n("The new customer form is unavailable. Refresh the page and try again.");return}if(!s.length){n("No Purchase Master bundles are configured for this cart.");return}let W=l||s[0];b.openNewCustomerModal({config:a,products:s,initialProductKey:hn(W),title:e.ui.newCustomerTitle,copy:e.ui.newCustomerCopy,host:h,onAdd:async I=>{let U=String(I.product.productHandle||"").trim();return U?(await b.launchFromProductPage({context:{mode:"add-person",targetHandle:U,bundleBasePrice:I.bundleBasePrice,bundleDiscountPercent:I.bundleDiscountPercent,bundleQuantity:I.bundleQuantity},host:S,productUrl:`${e.ui.rootUrl}products/${encodeURIComponent(U)}`,cartUrl:`${e.ui.rootUrl}cart`}),!0):!1}})}function y(h,S){i({mode:"add-product",person:h,initialType:S})}function P(h,S){let b=e.catalog.find(W=>String(W.productHandle||"")===S);if(!b){y(h,S);return}r("launch-product",()=>d(b,h))}async function Y(h,S){await r("launch-product",()=>u(h,S))}return{picker:o,openProductPicker:y,addProductFor:P,closeProductPicker:()=>i(null),chooseProduct:Y,openNewCustomerModal:g,newCustomerDisplayPrice:c}}var gr=T(oe());var BU=f.div`
  --cv2-green: #1b7f3b;
  box-sizing: border-box;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 20px 16px 120px;
  color: #111111;
  font-family: inherit;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* Only the cart page's own buttons; pop-ups keep their own styling. */
  :where(.cv2-layout, .cv2-main) button {
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  h1 {
    margin: 4px 0 14px;
    font-size: 26px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
  }

  .cv2-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 400px;
    gap: 28px;
    align-items: start;
  }

  .cv2-main,
  .cv2-side {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
  }

  .cv2-people {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .cv2-people.is-single {
    grid-template-columns: 1fr;
  }

  .cv2-card {
    background: #ffffff;
    border: 1px solid #e6e6e6;
    border-radius: 16px;
    padding: 14px;
  }

  .cv2-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .cv2-muted {
    color: #505050;
  }

  .cv2-sv {
    color: var(--cv2-green);
    font-weight: 700;
  }

  .cv2-was {
    color: #9a9a9a;
    text-decoration: line-through;
    margin-left: 5px;
    font-weight: 500;
  }

  .cv2-link {
    border: 0;
    background: none;
    padding: 0;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .cv2-who {
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: 17px;
    font-weight: 700;
    min-width: 0;
  }

  /* Add-ons in the order (old accessory list restyled to match "Your order"). */
  .cv2-main .cart-accessories {
    margin: 0 !important;
    padding: 14px !important;
    border: 1px solid #e6e6e6 !important;
    border-radius: 16px !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  .cv2-main .cart-accessories > h2 {
    margin: 0 0 4px !important;
    font-size: 17px !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
  }

  .cv2-main .cart-accessories-list {
    display: grid !important;
    gap: 0 !important;
  }

  .cv2-main .cart-accessory {
    display: grid !important;
    grid-template-columns: 48px minmax(0, 1fr) auto !important;
    gap: 12px !important;
    align-items: center !important;
    padding: 8px 0 !important;
    border: 0 !important;
    border-top: 1px solid #eeeeee !important;
    background: transparent !important;
  }

  .cv2-main .cart-accessory:first-child {
    border-top: 0 !important;
  }

  .cv2-main .cart-accessory-media-link,
  .cv2-main .cart-accessory-media {
    width: 48px !important;
    height: 40px !important;
    min-width: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background-color: transparent !important;
  }

  .cv2-main .cart-accessory-media img {
    object-fit: contain !important;
    mix-blend-mode: multiply;
  }

  .cv2-main .cart-accessory-details {
    display: flex !important;
    flex-wrap: wrap;
    align-items: baseline;
    column-gap: 8px;
    row-gap: 2px;
    min-width: 0;
  }

  .cv2-main .cart-accessory-title {
    flex-basis: 100%;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 1.25 !important;
    color: #111111 !important;
    text-decoration: none !important;
  }

  .cv2-main .cart-accessory-details > :not(.cart-accessory-title):not(.cart-accessory-price):not(.cart-accessory-discounts) {
    display: none !important;
  }

  .cv2-main .cart-accessory-price {
    font-size: 13px !important;
    font-weight: 700 !important;
  }

  .cv2-main .cart-accessory-price * {
    font-size: 13px !important;
  }

  .cv2-main .cart-accessory-discounts {
    display: inline-flex !important;
    margin: 0 !important;
  }

  .cv2-main .cart-accessory-discounts > * {
    padding: 1px 8px !important;
    border-radius: 999px !important;
    background: #e9f6ee !important;
    color: #1f7a3d !important;
    font-size: 11px !important;
    font-weight: 700 !important;
  }

  .cv2-main .cart-accessory-actions {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .cv2-main .cart-accessory-quantity-control {
    height: 32px !important;
    border: 1.5px solid #111111 !important;
    border-radius: 999px !important;
  }

  .cv2-main .cart-accessory-remove {
    font-size: 12.5px !important;
    color: #555555 !important;
    text-decoration: underline;
  }

  @media screen and (max-width: 900px) {
    .cv2-main .cart-accessory {
      grid-template-columns: 44px minmax(0, 1fr) !important;
    }

    .cv2-main .cart-accessory-actions {
      grid-column: 2 !important;
    }
  }

  .cv2-who small {
    font-size: 12px;
    font-weight: 500;
    color: #6b6b6b;
  }

  .cv2-item {
    display: grid;
    grid-template-columns: 96px 1fr;
    gap: 12px;
    align-items: center;
    margin-top: 10px;
  }

  .cv2-thumb {
    position: relative;
    width: 96px;
    height: 72px;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    overflow: hidden;
  }

  /* One preview per guard in 2- and 3-guard bundles, each with its own Edit. */
  .cv2-guards {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .cv2-item.is-multi {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
  }

  @media screen and (max-width: 600px) {
    .cv2-item.is-multi {
      grid-template-columns: minmax(0, 1fr);
    }

    .cv2-item.is-multi .cv2-gthumb .cv2-thumb {
      width: 80px;
      height: 60px;
    }
  }

  .cv2-gnum {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 5;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
  }

  .cv2-gthumb {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: 0;
    background: none;
    color: #111111;
    font: inherit;
    cursor: pointer;
  }

  .cv2-gthumb:disabled {
    cursor: default;
  }

  .cv2-gthumb .cv2-thumb {
    width: 92px;
    height: 68px;
  }

  .cv2-gthumb:hover:not(:disabled) .cv2-thumb {
    border-color: #111111;
  }

  .cv2-gthumb small {
    font-size: 12.5px;
    color: #505050;
  }

  .cv2-gthumb small u {
    color: #111111;
    font-weight: 700;
    text-underline-offset: 2px;
  }

  .cv2-thumb img {
    position: absolute;
    inset: 4px;
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    object-fit: contain;
  }

  .cv2-title {
    display: block;
    font-size: 15px;
    font-weight: 700;
  }

  .cv2-price {
    font-size: 15px;
    font-weight: 700;
    margin-top: 4px;
  }

  /* Spec values wrap (longer French/Spanish color names) instead of being cut. */
  .cv2-specs b {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
  }

  .cv2-specs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 14px;
    row-gap: 5px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f0f0f0;
    font-size: 12.5px;
  }

  .cv2-specs div {
    display: flex;
    gap: 6px;
    min-width: 0;
  }

  .cv2-specs span {
    color: #6b6b6b;
    flex: none;
  }

  .cv2-specs span.is-struck {
    text-decoration: line-through;
    text-decoration-color: #e11d48;
    text-decoration-thickness: 1.5px;
  }

  .cv2-specs b {
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cv2-acts {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
  }

  .cv2-pill {
    height: 36px;
    padding: 0 14px;
    border-radius: 999px;
    border: 1.5px solid #111111;
    background: #ffffff;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
  }

  .cv2-pill.is-solid {
    background: #111111;
    color: #ffffff;
  }

  .cv2-pill:disabled {
    opacity: 0.55;
    cursor: default;
  }

  .cv2-trash {
    margin-left: auto;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 1.5px solid #e2e2e2;
    background: #ffffff;
    display: grid;
    place-items: center;
    flex: none;
    color: #505050;
  }

  .cv2-trash svg {
    width: 18px;
    height: 18px;
  }

  .cv2-details {
    margin-top: 10px;
  }

  /* "All items" list (design 2026-11-02): roomy rows, transparent pictures,
     a small green "Included" tag, round edit/remove buttons. */
  .cv2-details .cart-child-card {
    display: grid !important;
    grid-template-columns: 48px minmax(0, 1fr) auto !important;
    gap: 12px !important;
    align-items: center !important;
    min-height: 0;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 8px 0 !important;
    border: 0;
    border-top: 1px solid #eeeeee;
    border-radius: 0;
    background: transparent;
  }

  .cv2-details .cart-child-card,
  .cv2-details .cart-child-body {
    min-height: 0 !important;
    height: auto !important;
  }

  .cv2-details .cart-child-line-actions {
    margin-right: 0 !important;
    padding: 0 !important;
  }

  .cv2-details .cart-child-card > .cart-child-line-actions {
    grid-column: 3 !important;
    grid-row: 1 !important;
    width: auto !important;
    min-width: max-content;
    height: auto !important;
    align-self: center;
  }

  .cv2-details .cart-child-card:first-child {
    border-top: 0;
  }

  /* Tight rows: the picture stays in one row (spanning three added two empty
     12px gaps), and the name and Included tag sit closer together. */
  .cv2-details .cart-child-card > .cart-layered-media,
  .cv2-details .cart-child-card > .cart-child-media {
    grid-column: 1 !important;
    grid-row: 1 !important;
  }

  .cv2-details .cart-child-body {
    row-gap: 2px !important;
  }

  .cv2-details .cart-child-media {
    width: 48px !important;
    height: 40px !important;
    min-width: 0;
    border: 0;
    border-radius: 0;
    background: transparent !important;
  }

  .cv2-details .cart-child-media img {
    object-fit: contain;
  }

  .cv2-details .cart-child-body {
    grid-column: 2 !important;
    grid-row: 1 !important;
    min-width: 0;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto;
    column-gap: 10px;
    row-gap: 3px;
    align-items: center;
  }

  .cv2-details .cart-child-body > .cart-child-heading,
  .cv2-details .cart-child-body > .cart-child-price-row {
    grid-column: 1 !important;
  }

  .cv2-details .cart-child-body > .cart-child-line-actions {
    grid-column: 2 !important;
    grid-row: 1 / span 2 !important;
    align-self: center;
    margin: 0;
  }

  .cv2-details .cart-child-heading {
    display: flex !important;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    min-height: 0;
    margin: 0;
  }

  .cv2-details .cart-child-details-trigger {
    position: static !important;
    flex: none;
    width: 22px;
    height: 22px;
    min-width: 22px;
    margin: 0;
    font-size: 12px;
  }

  .cv2-details .cart-child-price-row {
    margin: 0;
    min-height: 0;
  }

  .cv2-details .cart-child-title {
    flex: 0 1 auto;
    min-width: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
  }

  .cv2-details .cart-child-included {
    display: inline-flex;
    align-items: center;
    width: max-content;
    height: 20px;
    padding: 0 8px;
    border-radius: 999px;
    background: #e8f5ec;
    color: #1b7f3b;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
  }

  .cv2-details .cart-child-line-actions {
    display: flex;
    gap: 6px;
    align-items: center;
  }

  .cv2-details .cart-child-line-actions .cart-button,
  .cv2-details .cart-child-line-remove {
    width: 36px;
    height: 36px;
    min-width: 36px;
    padding: 0;
    border: 1.5px solid #e2e2e2;
    border-radius: 50%;
    background: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #111111;
  }

  .cv2-details .cart-child-line-actions .cart-button-label,
  .cv2-details .cart-child-line-remove-label {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }

  .cv2-details .cart-child-line-actions svg {
    width: 16px;
    height: 16px;
  }

  .cv2-reward .cv2-bar {
    position: relative;
    height: 8px;
    border-radius: 8px;
    background: #ececec;
    margin: 8px 0 6px;
  }

  .cv2-reward .cv2-bar i {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: 8px;
    background: var(--cv2-green);
  }

  .cv2-reward .cv2-bar b {
    position: absolute;
    top: 50%;
    width: 14px;
    height: 14px;
    margin-top: -7px;
    border-radius: 50%;
    background: #ffffff;
    border: 2px solid var(--cv2-green);
  }

  .cv2-ticks {
    display: flex;
    justify-content: space-between;
    font-size: 11.5px;
    color: #505050;
  }

  .cv2-unlock {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    padding: 8px 10px;
    border-radius: 10px;
    background: #f2f8f4;
    font-size: 13px;
  }

  .cv2-unlock span {
    flex: 1;
  }

  .cv2-addb {
    height: 28px;
    padding: 0 14px;
    border: 1.5px solid #111111;
    border-radius: 999px;
    background: #ffffff;
    font-size: 12px;
    font-weight: 700;
  }

  .cv2-nc {
    display: grid;
    grid-template-columns: 78px minmax(0, 1fr);
    gap: 12px;
    align-items: center;
    padding: 12px 14px;
    border-radius: 16px;
    background: linear-gradient(135deg, #f2f8f4, #ffffff);
    border: 1.5px solid #cfe8d6;
  }

  .cv2-nc img {
    width: 78px;
    height: 60px;
    object-fit: contain;
  }

  .cv2-tag {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--cv2-green);
    background: #e2f3e7;
    border-radius: 999px;
    padding: 2px 8px;
  }

  .cv2-nc b {
    display: block;
    font-size: 15px;
    margin: 4px 0 2px;
  }

  .cv2-nc .cv2-go {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    margin-top: 8px;
  }

  .cv2-nc .cv2-go > span {
    white-space: nowrap;
  }

  @media (max-width: 899px) {
    .cv2-nc {
      grid-template-columns: 56px minmax(0, 1fr);
      gap: 10px;
    }

    .cv2-nc img {
      width: 56px;
      height: 46px;
    }

    .cv2-nc b {
      font-size: 14px;
    }
  }

  .cv2-nc .cv2-pill {
    height: 34px;
    padding: 0 12px;
    font-size: 12.5px;
  }

  .cv2-gift {
    display: grid;
    grid-template-columns: 56px 1fr;
    gap: 10px;
    align-items: center;
  }

  .cv2-gift img {
    width: 56px;
    height: 56px;
    object-fit: contain;
    border-radius: 10px;
  }

  .cv2-lbl {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 4px 0 8px;
    font-size: 15px;
    font-weight: 700;
  }

  .cv2-lbl span {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--cv2-green);
  }

  /* Add-ons: a plain grid, no sideways scrolling (2 across on phones). */
  .cv2-strip {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  @media screen and (max-width: 900px) {
    .cv2-strip .cv2-add {
      grid-template-columns: 56px minmax(0, 1fr);
      gap: 6px;
    }

    .cv2-strip .cv2-add .cv2-im,
    .cv2-strip .cv2-add .cv2-im img {
      width: 56px;
      height: 56px;
    }
  }

  /* Black / Grey switch on the Beanie and Workout Hat tiles. */
  .cv2-colors {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 4px 0 2px;
  }

  .cv2-color {
    width: 18px;
    height: 18px;
    padding: 0;
    border: 1px solid #cfcfcf;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 0 2px #ffffff;
  }

  .cv2-color.is-black {
    background: #151515;
  }

  .cv2-color.is-grey {
    background: #a9a9a9;
  }

  .cv2-color.is-on {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 3.5px #111111;
  }

  .cv2-colorname {
    font-size: 11.5px;
    color: #6b6b6b;
  }

  /* Add button (or the quantity stepper) sits in the tile's bottom-right corner. */
  .cv2-strip .cv2-add {
    position: relative;
    align-items: center;
    min-height: 96px;
  }

  /* Desktop: text sits in the middle of the tile, clear of the corner button. */
  @media screen and (min-width: 901px) {
    .cv2-strip .cv2-add > div {
      padding: 4px 0;
    }
  }

  .cv2-strip .cv2-add .cv2-addb,
  .cv2-strip .cv2-add .cv2-step {
    position: absolute;
    right: 8px;
    bottom: 8px;
  }

  .cv2-strip .cv2-add .cv2-p {
    margin-bottom: 0;
  }

  @media screen and (max-width: 900px) {
    /* Narrow tiles: keep a row free under the price for the button. */
    .cv2-strip .cv2-add > div {
      padding-bottom: 34px;
    }
  }

  .cv2-strip::-webkit-scrollbar {
    display: none;
  }

  /* Apple Pay / Google Pay. Shop Pay stays hidden (checkout skips it). */
  .cv2-express {
    display: grid;
    gap: 8px;
  }

  .cv2-express shopify-accelerated-checkout-cart {
    --shopify-accelerated-checkout-button-block-size: 50px;
    --shopify-accelerated-checkout-button-border-radius: 999px;
    --shopify-accelerated-checkout-inline-alignment: center;
  }

  .cv2-express.is-busy {
    opacity: 0.5;
    pointer-events: none;
  }

  /* Apple Pay, Google Pay and PayPal; Shop Pay stays hidden (checkout skips it). */
  .cv2-express shop-pay-wallet-button,
  .cv2-express [data-testid="ShopifyPay-button"],
  .cv2-express .shopify-payment-button__button--branded {
    display: none !important;
  }

  /* Desktop: three cards across, wrapping onto a second row. */
  @media screen and (min-width: 901px) {
    .cv2-strip {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  .cv2-add {
    display: grid;
    grid-template-columns: 84px 1fr;
    gap: 8px;
    align-items: center;
    padding: 6px 8px 6px 4px;
    border: 1px solid #e6e6e6;
    border-radius: 12px;
    background: #ffffff;
    scroll-snap-align: start;
  }

  .cv2-add .cv2-im {
    width: 84px;
    height: 84px;
    overflow: hidden;
    border-radius: 9px;
  }

  .cv2-add .cv2-im img {
    width: 84px;
    height: 84px;
    object-fit: contain;
    transform: scale(1.2);
    mix-blend-mode: multiply;
  }

  .cv2-add b {
    display: block;
    font-size: 12.5px;
    line-height: 1.2;
  }

  .cv2-add .cv2-p {
    display: block;
    font-size: 12px;
    margin: 2px 0 4px;
  }

  .cv2-step {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    height: 28px;
    padding: 0 6px;
    border: 1.5px solid #111111;
    border-radius: 999px;
  }

  .cv2-step button {
    border: 0;
    background: none;
    font-size: 15px;
    font-weight: 700;
    width: 18px;
    padding: 0;
  }

  .cv2-step b {
    font-size: 12.5px;
  }

  .cv2-tot {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
  }

  .cv2-tot .cv2-sub {
    font-size: 17px;
    font-weight: 700;
    border-top: 1px solid #eeeeee;
    padding-top: 8px;
  }

  .cv2-code {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
  }

  .cv2-code input {
    height: 40px;
    padding: 0 12px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    font: inherit;
    font-size: 16px;
    background: #ffffff;
    min-width: 0;
  }

  .cv2-code input.is-ok {
    border-color: var(--cv2-green);
  }

  .cv2-code input.is-bad {
    border-color: #c62828;
  }

  .cv2-code button {
    height: 40px;
    border-radius: 10px;
    padding: 0 16px;
    border: 1.5px solid #111111;
    background: #ffffff;
    font-weight: 700;
  }

  .cv2-codemsg {
    margin: 6px 0 0;
    font-size: 12.5px;
    font-weight: 600;
  }

  .cv2-codemsg.is-ok {
    color: var(--cv2-green);
  }

  .cv2-codemsg.is-bad {
    color: #c62828;
  }

  .cv2-reassure {
    display: grid;
    gap: 5px;
    font-size: 12.5px;
    color: #3d3d3d;
  }

  .cv2-reassure div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px;
    text-align: center;
  }

  .cv2-reassure svg {
    width: 14px;
    height: 14px;
    flex: none;
  }

  .cv2-rename {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    margin-left: 4px;
    padding: 0;
    border: 0;
    background: none;
    color: #505050;
    cursor: pointer;
    vertical-align: middle;
  }

  .cv2-rename svg {
    width: 15px;
    height: 15px;
  }

  .cv2-renameform {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .cv2-renameform label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    font-size: 12px;
    color: #505050;
  }

  .cv2-renameform input {
    height: 38px;
    padding: 0 10px;
    border: 1.5px solid #cfcfcf;
    border-radius: 10px;
    font: inherit;
    font-size: 14px;
    color: #111111;
  }

  .cv2-renameacts {
    grid-column: 1 / -1;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .cv2-cards {
    display: inline-flex;
    gap: 4px;
  }

  .cv2-cards .cv2-payicon {
    display: block;
    width: 34px;
    height: 22px;
  }

  .cv2-cards i {
    font-style: normal;
    font-size: 9.5px;
    font-weight: 800;
    border: 1px solid #d4d4d4;
    border-radius: 4px;
    padding: 1px 4px;
    background: #ffffff;
  }

  .cv2-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 52px;
    border-radius: 999px;
    background: #111111;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;
  }

  .cv2-pinned {
    display: none;
  }

  .cv2-empty {
    text-align: center;
    padding: 22px;
  }

  .cv2-empty .cv2-cta {
    margin-top: 14px;
  }

  .cv2-prod {
    display: grid;
    grid-template-columns: 72px 1fr auto;
    gap: 10px;
    align-items: center;
    padding: 8px 10px;
    border: 1px solid #e6e6e6;
    border-radius: 12px;
    background: #ffffff;
    font-size: 13px;
    color: inherit;
    text-decoration: none;
  }

  .cv2-prod img {
    width: 72px;
    height: 56px;
    object-fit: contain;
  }

  .cv2-prods {
    display: grid;
    gap: 10px;
  }

  /* Phones: the empty cart fits one screen (products 2 x 2, smaller cards). */
  @media screen and (max-width: 900px) {
    &:has(.cv2-empty) {
      padding-bottom: calc(16px + env(safe-area-inset-bottom)) !important;
    }

    .cv2-empty {
      padding: 16px;
    }

    .cv2-empty .cv2-cta {
      margin-top: 12px;
      height: 46px;
      font-size: 15px;
    }

    .cv2-prods {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .cv2-prods .cv2-prod {
      grid-template-columns: 1fr;
      justify-items: center;
      gap: 2px;
      padding: 8px 6px;
      text-align: center;
    }

    .cv2-prods .cv2-prod img {
      width: 64px;
      height: 44px;
    }

    .cv2-empty .cv2-cta {
      white-space: nowrap;
    }
  }

  /* Small phones (iPhone SE): a little tighter still. */
  @media screen and (max-width: 900px) and (max-height: 700px) {
    .cv2-empty {
      padding: 12px 14px;
    }

    .cv2-empty .cv2-cta {
      height: 42px;
      font-size: 14px;
    }

    .cv2-empty ~ .cv2-lbl {
      margin-top: 10px;
      margin-bottom: 6px;
    }

    .cv2-prods .cv2-prod {
      padding: 4px 6px;
    }

    .cv2-prods .cv2-prod img {
      width: 52px;
      height: 34px;
    }
  }

  .cv2-only-phone {
    display: none;
  }

  @media screen and (max-width: 900px) {
    /* Room for the pinned Checkout bar (about 75px) and the iPhone home bar. */
    padding-bottom: calc(88px + env(safe-area-inset-bottom));

    /* The bar is a line taller when it shows "You saved $X". */
    &:has(.cv2-pinned .cv2-msg) {
      padding-bottom: calc(108px + env(safe-area-inset-bottom));
    }

    .cv2-layout {
      grid-template-columns: minmax(0, 1fr);
    }

    .cv2-people {
      grid-template-columns: minmax(0, 1fr);
    }

    .cv2-side .cv2-desk-checkout,
    .cv2-only-desk {
      display: none;
    }

    .cv2-only-phone {
      display: block;
    }

    .cv2-strip {
      margin-right: -16px;
      padding-right: 16px;
    }

    .cv2-pinned {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 14px;
      align-items: center;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 50;
      padding: 10px 16px max(14px, env(safe-area-inset-bottom));
      background: #ffffff;
      border-top: 1px solid #e6e6e6;
      box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.06);
    }

    .cv2-pinned .cv2-msg {
      grid-column: 1 / -1;
      margin: -2px 0 -4px;
      font-size: 12.5px;
      font-weight: 700;
      text-align: center;
    }

    .cv2-pinned .cv2-stot {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      color: #505050;
    }

    .cv2-pinned .cv2-stot b {
      font-size: 17px;
      color: #111111;
    }

    .cv2-pinned .cv2-cta {
      height: 50px;
    }
  }


  /* Desktop: the cart page (not its pop-ups) grows in steps with the screen
     so it's easier to read and fills the space (e.g. Surface Pro), while
     still fitting the screen height. */
  @media screen and (min-width: 1300px) and (min-height: 860px) {
    max-width: 1408px;

    > h1,
    > .cv2-layout,
    > .cv2-main,
    > [role="alert"] {
      zoom: 1.1;
    }
  }

  @media screen and (min-width: 1500px) and (min-height: 960px) {
    max-width: 1536px;

    > h1,
    > .cv2-layout,
    > .cv2-main,
    > [role="alert"] {
      zoom: 1.2;
    }
  }

  @media screen and (min-width: 1800px) and (min-height: 1050px) {
    max-width: 1664px;

    > h1,
    > .cv2-layout,
    > .cv2-main,
    > [role="alert"] {
      zoom: 1.3;
    }
  }

  @media screen and (min-width: 2200px) and (min-height: 1300px) {
    max-width: 1818px;

    > h1,
    > .cv2-layout,
    > .cv2-main,
    > [role="alert"] {
      zoom: 1.42;
    }
  }

`;var M=T(k()),h_=["","Starter","Pro","Elite","Ultimate"];function g_(){try{let e=window.Shopify;return String((e==null?void 0:e.country)||"US").toUpperCase()==="US"}catch(e){return!0}}function Y_(e){return/whitening/i.test(e)?"tray":/retainer/i.test(e)?"retainer":/night\s*guard/i.test(e)?"nightguard":"guard"}function S_(e){return e===2?"2nd":e===3?"3rd":`${e}th`}function y_(e,t,r){let n={ordinal:S_(t),n:t,price:r};return e==="tray"?x("Add a {ordinal} tray +{price}",n):e==="retainer"?x("Add a {ordinal} retainer +{price}",n):e==="nightguard"?x("Add a {ordinal} nightguard +{price}",n):x("Add a {ordinal} guard +{price}",n)}var s1=(0,M.jsx)("svg",{viewBox:"0 0 16 16",fill:"none",stroke:"#1b7f3b",strokeWidth:"2.2",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",children:(0,M.jsx)("path",{d:"M3 8.5l3.2 3L13 4.5"})});function Jh(e){var t;return he(e).category==="impressionkits"||((t=e.properties)==null?void 0:t.__purchaseMasterItemRole)==="impression-kit"}function zU(e,t,r){var s;let n=he(r),o=[...e.purchaseMasterTransformSummaries||[],...e.items].find(l=>bt(l)&&he(l).rootKey===n.rootKey),i=new Set((s=o==null?void 0:o.item_components)==null?void 0:s.map(l=>l.key)),a=l=>o?Number(o[l]||0)+t.filter(c=>{var d;return!i.has(c.key)&&(vr(c)||((d=c.properties)==null?void 0:d.__purchaseMasterItemRole)==="paid-bundle-accessory")}).reduce((c,d)=>c+Number(d[l]||0),0):t.reduce((c,d)=>c+Number(d[l]||0),0);return{price:a("final_line_price"),original:a("original_line_price"),merged:Boolean(o)}}function ZU({root:e,bootstrap:t}){var a;let r=Gi(e,t),n={position:Te(e,"Position")||"",color:Te(e,"Color")||"",padColor:Te(e,"Pad color")||"",thicknessSize:Te(e,"Thickness Size")||"",strength:"",edgeType:""},o=oi(e.featured_image)||oi(e.image),i=n.color&&((a=r==null?void 0:r.colors)!=null&&a.length)?Ns(r,n,o):o?[{url:o,objectFit:"contain"}]:[];return(0,M.jsx)("span",{className:"cv2-thumb","aria-hidden":"true",children:i.map((s,l)=>(0,M.jsx)("img",{src:Xe(s.url,240),alt:"",loading:"lazy",style:{zIndex:l}},`${s.url}-${l}`))})}function x_({person:e,root:t,snapshot:r,bootstrap:n,money:o,busy:i,actions:a,onAddProduct:s,sameProductGuards:l,showAdd:c}){let[d,u]=(0,gr.useState)(!1),p=en(e,t),m=p.filter(ut),g=p.filter(Bs),y=p.find(Jh),{price:P,original:Y,merged:h}=zU(r,p,t),S=Jr(t,n.catalog),b=String((S==null?void 0:S.productTitle)||Rr(t)).replace(/\s+bundle$/i,"").trim(),W=Aa(t),C=he(t).properties.__purchaseMasterItemRole==="cart-addon-product",w=Math.max(1,m.length),I=C&&l>w?x("Extra guard"):W?x("Reorder"):C?"":h_[w]||"",U=[...m].sort((Z,ce)=>{var ie,re;return Number(((ie=Z.properties)==null?void 0:ie.__purchaseMasterGuardSlot)||1)-Number(((re=ce.properties)==null?void 0:re.__purchaseMasterGuardSlot)||1)}),L=Z=>`${Te(Z,"Color")||""}|${Te(Z,"Pad color")||""}`,X=U.length>1&&U.some(Z=>L(Z)!==L(U[0])),N=Te(t,"Pad color")||"",V=X?x("Different per guard"):[Te(t,"Color")?x(Te(t,"Color")||""):"",N?/no\s*pads?/i.test(N)?x("no pads"):x("{color} pads",{color:x(N.toLowerCase())}):""].filter(Boolean).join(" / "),z=[[x("Guards"),C?"":String(w)],[x("Position"),x(Te(t,"Position")||"")],[x("Colors"),V],[x("Thickness"),x(Te(t,"Thickness Size")||"")],[x("Gel strength"),/^(Clinical|Lite)$/.test(Te(t,"Strength")||"")?x(Te(t,"Strength")||""):""],y?[x("Kit"),Te(y,"Tray size")?x(Te(y,"Tray size")||""):x("Included")]:W?[x("Kit"),x("Impression On File"),!0]:C?[x("Kit"),x("Same impression")]:[x("Kit"),""],[x("Case"),C&&!W?"":x("1 included")]].filter(([,Z])=>Boolean(Z)),te=n.catalog.find(Z=>Z.productHandle&&Z.productHandle===(S==null?void 0:S.productHandle)),H=te&&c?Ba(e,te):void 0,E=p.filter(Z=>!Bs(Z)).sort((Z,ce)=>$U(Z)-$U(ce));return(0,M.jsxs)("div",{className:"cv2-bundle","data-cart-bundle-card":!0,"data-cart-person-id":e.id,children:[(0,M.jsxs)("div",{className:`cv2-item${U.length>1?" is-multi":""}`,children:[U.length>1?null:(0,M.jsx)(ZU,{root:t,bootstrap:n}),(0,M.jsxs)("div",{children:[(0,M.jsxs)("b",{className:"cv2-title",children:[b,I?` \xB7 ${I}`:""]}),(0,M.jsxs)("div",{className:"cv2-price",children:[o(P),Y>P?(0,M.jsx)("span",{className:"cv2-was",children:o(Y)}):null]})]}),U.length>1?(0,M.jsx)("div",{className:"cv2-guards",role:"group","aria-label":x("Guards in this bundle"),children:U.map((Z,ce)=>(0,M.jsxs)("button",{type:"button",className:"cv2-gthumb",disabled:i||h,"aria-label":x("Edit guard {n}",{n:ce+1}),onClick:()=>a.editGuard(e,Z),children:[(0,M.jsx)("span",{className:"cv2-gnum","aria-hidden":"true",children:ce+1}),(0,M.jsx)(ZU,{root:Z,bootstrap:n}),h?null:(0,M.jsx)("small",{children:(0,M.jsx)("u",{children:x("Edit")})})]},Z.key))}):null]}),(0,M.jsx)("div",{className:"cv2-specs",children:z.map(([Z,ce,ie])=>(0,M.jsxs)("div",{children:[(0,M.jsx)("span",{className:ie?"is-struck":void 0,children:Z}),(0,M.jsx)("b",{children:ce})]},Z))}),(0,M.jsxs)("div",{className:"cv2-acts",children:[H!==void 0?(0,M.jsx)("button",{type:"button",className:"cv2-pill is-solid",disabled:i,onClick:()=>s(e,te==null?void 0:te.productHandle),children:y_(Y_(b),l+1,o(H))}):null,(0,M.jsx)("button",{type:"button",className:"cv2-link",style:{fontSize:12.5},"aria-expanded":d,onClick:()=>u(Z=>!Z),children:d?x("Hide items"):x("All items")}),(0,M.jsx)("button",{type:"button",className:"cv2-trash","aria-label":x("Remove {name} from your cart",{name:b}),disabled:i,onClick:()=>void a.requestBundleRemoval(e,t),children:(0,M.jsxs)("svg",{viewBox:"0 0 24 24",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",children:[(0,M.jsx)("path",{d:"M3 6h18"}),(0,M.jsx)("path",{d:"M8 6V4h8v2"}),(0,M.jsx)("path",{d:"M19 6l-1 14H6L5 6"}),(0,M.jsx)("path",{d:"M10 11v6M14 11v6"})]})})]}),d?(0,M.jsx)("div",{className:"cv2-details","aria-label":x("Items in this bundle"),children:E.map(Z=>(0,M.jsxs)(gr.default.Fragment,{children:[(0,M.jsx)(Zi,{line:Z,presentation:vr(t)&&Z.key===t.key?"standalone":"child",primary:Z.key===t.key,currency:n.ui.currency,moneyFormat:n.ui.moneyFormat,busy:i,readOnly:h,productOptions:Gi(Z,n),forceIncluded:!vr(t)&&_h(Z,t),onEdit:!h&&ut(Z)?()=>a.editGuard(e,Z):void 0,onRemove:h?void 0:ut(Z)?()=>a.requestGuardRemoval(e,t,Z):r1(Z)?()=>void a.removeComponent(e,t,Z):void 0}),g.filter(ce=>{var ie;return((ie=Bh(ce,m))==null?void 0:ie.key)===Z.key}).map(ce=>(0,M.jsx)(Dh,{line:ce,currency:n.ui.currency,moneyFormat:n.ui.moneyFormat,busy:i||h,onRemove:()=>a.removeTag(Z)},ce.key))]},Z.key))}):null]})}function $U(e){return ut(e)?0:Jh(e)?1:2}function b_(e){let{person:t,bootstrap:r,busy:n,actions:o,snapshot:i}=e,[a,s]=(0,gr.useState)(!1),[l,c]=(0,gr.useState)(t.firstName),[d,u]=(0,gr.useState)(t.lastName),p=!t.firstName||t.firstName==="Person"&&/^#\d+$/.test(t.lastName),m=t.roots.find(ut),g=m?zU(i,en(t,m),m).merged:!1,y=m?en(t,m).filter(ut).length:0,P=g||y>1?void 0:m||t.lines.find(ut),Y=t.lines.filter(h=>!t.roots.some(S=>en(t,S).some(b=>b.key===h.key)));return(0,M.jsxs)("section",{className:"cv2-card","data-cart-person":!0,"data-cart-person-id":t.id,children:[(0,M.jsxs)("div",{className:"cv2-row",children:[(0,M.jsxs)("div",{className:"cv2-who",children:[p?x("Your order"):x("For {name}",{name:[t.firstName,t.lastName].join(" ").trim()}),p?(0,M.jsx)("small",{children:x("name from checkout")}):null,(0,M.jsx)("button",{type:"button",className:"cv2-rename","aria-label":a?x("Cancel rename"):x("Rename person"),"aria-expanded":a,disabled:n,onClick:()=>s(h=>!h),children:(0,M.jsx)("svg",{viewBox:"0 0 20 20","aria-hidden":"true",fill:"none",stroke:"currentColor",strokeWidth:"1.7",strokeLinecap:"round",strokeLinejoin:"round",children:(0,M.jsx)("path",{d:"M2.4 15.1l.1-.7.2-.4L14.2 2.5a2.36 2.36 0 013.3 3.3L6.5 16.8l-.5.3-.4.1-3.5.4.3-2.5z"})})})]}),P?(0,M.jsx)("button",{type:"button",className:"cv2-link",style:{fontSize:13},disabled:n,onClick:()=>o.editGuard(t,P),children:x("Edit")}):null]}),a?(0,M.jsxs)("form",{className:"cv2-renameform",onSubmit:async h=>{h.preventDefault(),await o.renamePerson(t,l.trim(),d.trim())!==!1&&s(!1)},children:[(0,M.jsxs)("label",{children:[(0,M.jsx)("span",{children:x("First name")}),(0,M.jsx)("input",{autoComplete:"given-name",maxLength:50,value:l,onChange:h=>c(h.target.value)})]}),(0,M.jsxs)("label",{children:[(0,M.jsx)("span",{children:x("Last name")}),(0,M.jsx)("input",{autoComplete:"family-name",maxLength:50,value:d,onChange:h=>u(h.target.value)})]}),(0,M.jsxs)("div",{className:"cv2-renameacts",children:[(0,M.jsx)("button",{type:"button",className:"cv2-pill",disabled:n,onClick:()=>s(!1),children:x("Cancel")}),(0,M.jsx)("button",{type:"submit",className:"cv2-pill is-solid",disabled:n,children:x("Save")})]})]}):null,t.roots.map((h,S)=>{var I,U;let b=(I=Jr(h,r.catalog))==null?void 0:I.productHandle,W=t.roots.filter(L=>{var X;return((X=Jr(L,r.catalog))==null?void 0:X.productHandle)===b}),C=W.reduce((L,X)=>L+en(t,X).filter(ut).length,0),w=W[W.length-1]===h;return(0,M.jsx)(x_,{...e,root:h,sameProductGuards:C,showAdd:w},String(((U=h.properties)==null?void 0:U.__itemId)||h.key||S))}),Y.map(h=>(0,M.jsx)(Zi,{line:h,presentation:"standalone",currency:r.ui.currency,moneyFormat:r.ui.moneyFormat,busy:n,onRemove:()=>void o.removeLine(h)},h.key)),t.roots.length+Y.length>1?(0,M.jsx)("button",{type:"button",className:"cv2-link cv2-muted",style:{fontSize:12.5,alignSelf:"flex-start"},disabled:n,onClick:()=>void o.removePerson(t),children:x("Remove customer")}):null]})}function KU(e,t){var s;let r=Ac(t),n=e.items.filter(Ra),o=Math.max(0,Number(e.items_subtotal_price||0)-n.reduce((l,c)=>l+Number(c.final_line_price||0),0)),i=r.find(l=>o<Number(l.thresholdCents||0)),a=Number(((s=r[r.length-1])==null?void 0:s.thresholdCents)||0);return{rewards:r,qualifying:o,next:i,max:a,gifts:n}}function OU({snapshot:e,bootstrap:t,money:r,suggestion:n}){let{rewards:o,qualifying:i,next:a,max:s}=KU(e,t);if(!o.length||!s)return null;let l=o.filter(d=>i>=Number(d.thresholdCents||0)),c=a?x("You're {amount} away from {reward}",{amount:r(Number(a.thresholdCents)-i),reward:a.label?x(String(a.label)):x("your next reward")}):x("You unlocked {rewards}",{rewards:l.map(d=>x(String(d.label||""))).filter(Boolean).join(` ${x("and")} `)});return(0,M.jsxs)("div",{className:"cv2-card cv2-reward","aria-label":x("Rewards"),children:[(0,M.jsx)("b",{style:{fontSize:14},children:c}),(0,M.jsxs)("div",{className:"cv2-bar",children:[(0,M.jsx)("i",{style:{width:`${Math.min(100,i/s*100)}%`}}),o.map(d=>(0,M.jsx)("b",{style:{left:`calc(${Number(d.thresholdCents)/s*100}% - 14px)`}},String(d.id||d.thresholdCents)))]}),(0,M.jsx)("div",{className:"cv2-ticks",children:o.map(d=>(0,M.jsxs)("span",{children:[r(Number(d.thresholdCents||0))," \xB7 ",x(String(d.label||"")),i>=Number(d.thresholdCents||0)?" \u2713":""]},String(d.id||d.thresholdCents)))}),a?n:null]})}function C_(e,t,r){let n=e.variants.find(u=>u.available);if(!n)return null;let o=t.settings,i={productGid:`gid://shopify/Product/${e.productId}`,productHandle:e.handle,productTitle:e.title,productType:e.productType,variantPrice:Me(n.priceCents,t.ui.currency,t.ui.moneyFormat),variantPriceCents:n.priceCents},a=Ol(o,i,Date.now()),s=r?ma(o,i):null,l=Math.round(Number((a==null?void 0:a.savings)||0)*100),c=s?Math.round(n.priceCents*Number(s.discountPercent||0)/100):0,d=Math.max(l,c);return{variant:n,price:n.priceCents-d,compareAt:d>0?n.priceCents:0}}function P_(e){return e.items.some(t=>{var n;let r=String(((n=t.properties)==null?void 0:n.__category)||"").replace(/\s+/g,"").toLowerCase();return r==="guard"||r==="guards"||ut(t)})}function W_(e,t){let r=t.items.map(i=>String(i.handle||i.product_handle||"")).join(" "),n=/whitening/.test(r)?[/gel|whitening/,/case/,/3d/]:[/case/,/3d|model/,/extra-material|material/],o=i=>{let a=`${i.handle} ${i.title}`.toLowerCase(),s=n.findIndex(l=>l.test(a));return s===-1?n.length:s};return e.map((i,a)=>({item:i,index:a})).sort((i,a)=>o(i.item)-o(a.item)||i.index-a.index).map(({item:i})=>i)}function v_({snapshot:e,bootstrap:t,accessories:r,money:n,busy:o,onAdd:i,onQuantity:a,hideInCart:s}){let l=new Set(r.map(u=>String(u.handle||u.product_handle||""))),c=W_(U_(t),e).filter(u=>!s||!l.has(u.handle));if(!c.length)return null;let d=P_(e);return(0,M.jsxs)("section",{"aria-labelledby":"cv2-pairs",children:[(0,M.jsxs)("p",{className:"cv2-lbl",id:"cv2-pairs",children:[t.ui.recommendedTitle&&!/recommended for you/i.test(t.ui.recommendedTitle)?t.ui.recommendedTitle:x("Pairs well with your order"),d?(0,M.jsx)("span",{children:x("30% off with your guard")}):null]}),(0,M.jsx)("div",{className:"cv2-strip",children:T_(c).map(u=>(0,M.jsx)(M_,{group:u,bootstrap:t,hasGuard:d,accessories:r,money:n,busy:o,onAdd:i,onQuantity:a},u.key))})]})}var w_=/^(black|grey|gray)\s+(.+)$/i;function T_(e){let t=[],r=new Map;return e.forEach(n=>{let o=n.title.trim().match(w_);if(!o){t.push({key:n.handle||n.productId,title:n.title,options:[{color:"",item:n}]});return}let i=/^gr[ae]y$/i.test(o[1])?"Grey":"Black",a=o[2].trim(),s=a.toLowerCase(),l=r.get(s);l||(l={key:`color:${s}`,title:a,options:[]},r.set(s,l),t.push(l)),l.options.some(c=>c.color===i)||l.options.push({color:i,item:n})}),t.forEach(n=>{n.options.sort((o,i)=>(o.color==="Black"?-1:0)-(i.color==="Black"?-1:0)),n.options.length===1&&n.options[0].color&&(n.title=n.options[0].item.title)}),t}function M_({group:e,bootstrap:t,hasGuard:r,accessories:n,money:o,busy:i,onAdd:a,onQuantity:s}){let l=h=>n.find(S=>String(S.handle||S.product_handle||"")===h.handle),c=e.options.map(h=>({...h,pricing:C_(h.item,t,r)})).filter(h=>h.pricing),[d,u]=(0,gr.useState)(()=>{var S;return((S=c.find(b=>l(b.item))||c[0])==null?void 0:S.item.handle)||""});if(!c.length)return null;let p=c.find(h=>h.item.handle===d)||c[0],m=p.item,g=p.pricing,y=l(m),P=g.variant.imageUrl||m.imageUrl||"",Y=c.length>1;return(0,M.jsxs)("div",{className:"cv2-add",children:[(0,M.jsx)("span",{className:"cv2-im",children:P?(0,M.jsx)("img",{src:Xe(P,240),alt:"",loading:"lazy"}):null}),(0,M.jsxs)("div",{children:[(0,M.jsx)("b",{children:Y?x(e.title):I_(m.title)}),Y?(0,M.jsxs)("span",{className:"cv2-colors",role:"radiogroup","aria-label":x("Color"),children:[c.map(h=>(0,M.jsx)("button",{type:"button",role:"radio","aria-checked":h.item.handle===m.handle,"aria-label":x(h.color),title:x(h.color),className:`cv2-color is-${h.color.toLowerCase()}${h.item.handle===m.handle?" is-on":""}`,onClick:()=>u(h.item.handle)},h.item.handle)),(0,M.jsx)("span",{className:"cv2-colorname",children:x(p.color)})]}):null,(0,M.jsxs)("span",{className:"cv2-p",children:[(0,M.jsx)("span",{className:"cv2-sv",children:o(g.price)}),g.compareAt?(0,M.jsx)("span",{className:"cv2-was",children:o(g.compareAt)}):null]}),y?(0,M.jsxs)("span",{className:"cv2-step",role:"group","aria-label":x("{product} quantity",{product:m.title}),children:[(0,M.jsx)("button",{type:"button","aria-label":x("One less"),disabled:i,onClick:()=>s(y,Math.max(0,Number(y.quantity||1)-1)),children:"\u2212"}),(0,M.jsx)("b",{children:Number(y.quantity||1)}),(0,M.jsx)("button",{type:"button","aria-label":x("One more"),disabled:i,onClick:()=>s(y,Number(y.quantity||1)+1),children:"+"})]}):(0,M.jsx)("button",{type:"button",className:"cv2-addb",disabled:i,onClick:()=>a(m,g.variant.id),children:x("Add")})]})]})}function U_(e){let t=e.ui.recommendations||[],r=new Set(t.map(o=>o.handle)),n=(e.ui.extraRecommendations||[]).filter(o=>o.handle&&!r.has(o.handle));return[...t,...n]}function I_(e){let t=e.match(/^(.*?)\s+(of your teeth)$/i);return t?(0,M.jsxs)(M.Fragment,{children:[t[1],(0,M.jsx)("br",{}),t[2]]}):e}function V_({snapshot:e,busy:t,onCoupon:r}){var p;let[n,o]=(0,gr.useState)(""),[i,a]=(0,gr.useState)(null),[s,l]=(0,gr.useState)(!1),d=((p=(e.cart_level_discount_applications||[]).filter(m=>m.type==="discount_code")[0])==null?void 0:p.title)||"";async function u(m){l(!0),a(null);try{await r(m),a(m?{ok:!0,text:x("\u2713 Code {code} applied",{code:m.toUpperCase()})}:{ok:!0,text:x("Code removed.")}),o("")}catch(g){a({ok:!1,text:g instanceof Error&&g.message?g.message:x("This code couldn't be applied.")})}finally{l(!1)}}return(0,M.jsxs)("div",{children:[(0,M.jsx)("div",{style:{fontSize:13,fontWeight:600,margin:"4px 0 6px"},children:x("Have a code?")}),(0,M.jsxs)("form",{className:"cv2-code",onSubmit:m=>{m.preventDefault(),d?u(""):n.trim()&&u(n.trim())},children:[(0,M.jsx)("input",{value:d||n,readOnly:Boolean(d),className:d?"is-ok":i&&!i.ok?"is-bad":void 0,onChange:m=>o(m.target.value),placeholder:x("Discount code"),autoComplete:"off",autoCapitalize:"characters","aria-label":x("Discount code")}),(0,M.jsx)("button",{type:"submit",disabled:s||t,"aria-busy":s||void 0,children:s?"\u2026":d?x("Remove"):x("Apply")})]}),i?(0,M.jsx)("p",{className:`cv2-codemsg ${i.ok?"is-ok":"is-bad"}`,role:"status",children:i.text}):null]})}function k_({snapshot:e,bootstrap:t,money:r,busy:n,onCoupon:o}){let i=Number(e.original_total_price||0),a=Number(e.total_price||0),s=Number(e.total_discount||Math.max(0,i-a)),l=(e.cart_level_discount_applications||[]).filter(m=>Number(m.total_allocated_amount||0)>0),c=l.reduce((m,g)=>m+Number(g.total_allocated_amount||0),0),d=Math.max(0,s-c),u=Ac(t).find(m=>m.type==="free_shipping"&&Number(m.thresholdCents)<=Number(e.items_subtotal_price||0)),p=(e.discount_codes||[]).some(m=>m.applicable!==!1);return(0,M.jsxs)("div",{className:"cv2-card cv2-tot","aria-label":x("Cart totals"),children:[(0,M.jsxs)("div",{className:"cv2-row cv2-muted",children:[(0,M.jsx)("span",{children:x("Items")}),(0,M.jsx)("span",{children:r(i)})]}),d>0?(0,M.jsxs)("div",{className:"cv2-row",children:[(0,M.jsx)("span",{className:"cv2-muted",children:p?x("Discounts"):x("Reward")}),(0,M.jsxs)("span",{className:"cv2-sv",children:["\u2212",r(d)]})]}):null,u?(0,M.jsxs)("div",{className:"cv2-row",children:[(0,M.jsx)("span",{className:"cv2-muted",children:x("Shipping")}),(0,M.jsx)("span",{className:"cv2-sv",children:x("{method}: Free",{method:x(String(u.shippingMethod||"standard").replace(/^./,m=>m.toUpperCase()))})})]}):null,l.map((m,g)=>(0,M.jsxs)("div",{className:"cv2-row",children:[(0,M.jsx)("span",{className:"cv2-muted",children:m.type==="discount_code"?x("Code {code}",{code:String(m.title||"")}):x("Reward")}),(0,M.jsxs)("span",{className:"cv2-sv",children:["\u2212",r(Number(m.total_allocated_amount||0))]})]},`${m.title}-${g}`)),(0,M.jsxs)("div",{className:"cv2-row cv2-sub",children:[(0,M.jsx)("span",{children:x("Subtotal")}),(0,M.jsx)("span",{children:r(a)})]}),s>0?(0,M.jsx)("span",{className:"cv2-sv",style:{fontSize:13.5},children:x("You saved {amount}",{amount:r(s)})}):null,(0,M.jsx)(V_,{snapshot:e,busy:n,onCoupon:o})]})}function L_(){var e;try{return((e=document.querySelector("template[data-cart-payment-icons]"))==null?void 0:e.innerHTML.trim())||""}catch(t){return""}}function X_({snapshot:e}){let t=g_(),[r]=(0,gr.useState)(L_),n=e.items.some(o=>Jh(o)||(o.item_components||[]).some(i=>Jh(i)));return(0,M.jsxs)("div",{className:"cv2-reassure",children:[(0,M.jsxs)("div",{children:[s1,(0,M.jsx)("b",{children:x("30-day Perfect Fit guarantee")})]}),t?(0,M.jsxs)("div",{children:[s1,x("Free US shipping")]}):null,t&&n?(0,M.jsxs)("div",{children:[s1,x("Kit arrives in 2\u20135 business days")]}):null,(0,M.jsxs)("div",{children:[(0,M.jsx)("span",{"aria-hidden":"true",children:"\u{1F512}"})," ",x("Secure checkout")," ",r?(0,M.jsx)("span",{className:"cv2-cards","aria-label":"Visa, Mastercard, American Express",dangerouslySetInnerHTML:{__html:r}}):(0,M.jsxs)("span",{className:"cv2-cards","aria-hidden":"true",children:[(0,M.jsx)("i",{children:"VISA"}),(0,M.jsx)("i",{children:"MC"}),(0,M.jsx)("i",{children:"AMEX"})]})]})]})}function N_(){var e;try{let t=new URLSearchParams(window.location.search).get("pm_express");(t==="1"||t==="0")&&window.sessionStorage.setItem("trufit:pm-express",t);let r=window.sessionStorage.getItem("trufit:pm-express");if(r==="1")return!0;if(r==="0")return!1}catch(t){}return((e=document.querySelector("[data-cart-express-source]"))==null?void 0:e.dataset.cartExpressEnabled)==="true"}function E_({busy:e}){let t=(0,gr.useRef)(null),[r,n]=(0,gr.useState)(!1);return(0,gr.useEffect)(()=>{let o=document.querySelector("[data-cart-express-source]"),i=t.current;if(!o||!i||!N_())return;let a=Array.from(o.childNodes);return a.forEach(s=>i.appendChild(s)),n(a.some(s=>s.nodeType===Node.ELEMENT_NODE)),()=>{a.forEach(s=>o.appendChild(s))}},[]),(0,M.jsx)("div",{ref:t,className:`cv2-express${e?" is-busy":""}`,hidden:!r,"aria-busy":e||void 0})}function FU({bootstrap:e}){return(0,M.jsx)("a",{className:"cv2-cta","data-cart-checkout":!0,href:e.ui.checkoutUrl,"data-cart-checkout-default-label":x("Checkout \u2192"),"data-cart-checkout-loading-label":x("Preparing checkout\u2026"),children:(0,M.jsx)("span",{"data-cart-checkout-label":!0,children:x("Checkout \u2192")})})}function DU({snapshot:e,bootstrap:t}){let r=e.items.filter(Ra);return r.length?(0,M.jsx)(M.Fragment,{children:r.map(n=>{let o=oi(n.featured_image)||oi(n.image);return(0,M.jsxs)("div",{className:"cv2-card cv2-gift",children:[o?(0,M.jsx)("img",{src:o,alt:"",loading:"lazy"}):(0,M.jsx)("span",{}),(0,M.jsxs)("div",{children:[(0,M.jsx)("b",{style:{display:"block",fontSize:15},children:Rr(n)}),(0,M.jsx)("div",{className:"cv2-sv",style:{fontSize:15,marginTop:2},children:t.ui.rewardFreeLabel||x("FREE")}),(0,M.jsx)("div",{className:"cv2-muted",style:{fontSize:12.5,marginTop:2},children:t.ui.rewardGiftIncluded||x("Included with your rewards")})]})]},n.key)})}):null}function A_({bootstrap:e,money:t}){let r=e.ui.rootUrl||"/",n=e.catalog.filter(a=>a.productHandle&&a.productHandle!=="mouthguard"),o=a=>`${r}products/${encodeURIComponent(a)}`,i=a=>{let s=Number(a.variantPriceCents||0);return s?t(s):String(a.variantPrice||"")};return(0,M.jsxs)(M.Fragment,{children:[(0,M.jsxs)("div",{className:"cv2-card cv2-empty",children:[(0,M.jsx)("b",{style:{fontSize:17},children:x("Your cart is empty")}),(0,M.jsx)("p",{className:"cv2-muted",style:{margin:"6px 0 0",fontSize:13.5},children:x("Most athletes start with a custom-fit Sports Mouthguard.")}),(0,M.jsx)("a",{className:"cv2-cta",href:o("mouthguard"),children:x("Start with the Sports Mouthguard \u2192")})]}),n.length?(0,M.jsxs)(M.Fragment,{children:[(0,M.jsx)("p",{className:"cv2-lbl",children:x("Or choose another product")}),(0,M.jsx)("div",{className:"cv2-prods",children:n.map(a=>(0,M.jsxs)("a",{className:"cv2-prod",href:o(String(a.productHandle)),children:[a.productImageUrl?(0,M.jsx)("img",{src:Xe(a.productImageUrl,200),alt:"",loading:"lazy"}):(0,M.jsx)("span",{}),(0,M.jsx)("b",{children:String(a.productTitle||"").replace(/[™®]/g,"")}),(0,M.jsxs)("span",{children:[`${x("from")} `,(0,M.jsx)("b",{children:i(a)})]})]},a.productHandle))})]}):null]})}function HU({bootstrap:e,snapshot:t,people:r,accessories:n,ordinary:o,isEmpty:i,busy:a,busyKeys:s,status:l,actions:c,onAddProduct:d,onNewCustomer:u,newCustomerPrice:p,onAddRecommendation:m,onCoupon:g,dialogs:y}){var L,X,N,V;let P=z=>Me(z,e.ui.currency,e.ui.moneyFormat).replace(/\.00$/,""),Y=z=>Me(z,e.ui.currency,e.ui.moneyFormat);Ih(!0);let h=KU(t,e),S=Number(t.total_discount||0),b=Number(((X=(L=e.settings)==null?void 0:L.newCustomerOffer)==null?void 0:X.discountPercent)||20),W=0;try{W=se(String(p||""))}catch(z){W=0}let C=W>0&&b>0&&b<100?Math.round(W*100/(1-b/100)):0,w=null;if(h.next){let z=Number(h.next.thresholdCents)-h.qualifying,te=r[0],H=te!=null&&te.roots[0]?(N=Jr(te.roots[0],e.catalog))==null?void 0:N.productHandle:void 0,E=e.catalog.find(ce=>H&&ce.productHandle===H),Z=te&&E?Ba(te,E):void 0;te&&Z!==void 0&&Z>=z&&(w=(0,M.jsxs)("div",{className:"cv2-unlock",children:[(0,M.jsxs)("span",{children:[`${x("Add a guard")} `,(0,M.jsxs)("b",{children:["+",P(Z)]}),` ${x("and unlock")}`," ",(0,M.jsx)("b",{children:h.next.label?x(String(h.next.label)):x("your reward")})]}),(0,M.jsx)("button",{type:"button",className:"cv2-addb",disabled:a,onClick:()=>d(te,E==null?void 0:E.productHandle),children:x("Add")})]}))}let I=S>0?`${x("You saved {amount}",{amount:P(S)})}${h.gifts.length?` \xB7 ${x("Mystery Gift unlocked")}`:""}`:"",U=(0,M.jsxs)("div",{className:"cv2-nc",children:[(0,M.jsx)("img",{src:Xe(String(((V=Nc(e.catalog,"mouthguard"))==null?void 0:V.productImageUrl)||""),200),alt:"",loading:"lazy"}),(0,M.jsxs)("div",{children:[(0,M.jsx)("span",{className:"cv2-tag",children:x("{percent}% off",{percent:b})}),(0,M.jsx)("b",{children:x("Ordering for a teammate or family member?")}),(0,M.jsx)("div",{className:"cv2-muted",style:{fontSize:12.5},children:x("They get their own impression kit and custom-fit guard.")}),(0,M.jsxs)("div",{className:"cv2-go",children:[(0,M.jsxs)("span",{children:[p?(0,M.jsxs)("span",{className:"cv2-sv",style:{fontSize:15},children:["+",p.replace(/^\+/,"")]}):null,C?(0,M.jsx)("span",{className:"cv2-was",children:P(C)}):null]}),(0,M.jsx)("button",{type:"button",className:"cv2-pill is-solid",disabled:a,onClick:u,children:x("Add new customer")})]})]})]});return(0,M.jsxs)(BU,{className:"cart-page cart-v2","data-cart-react-app":!0,"aria-busy":a||void 0,children:[(0,M.jsx)(Vh,{}),(0,M.jsx)("h1",{id:"cart-title",style:i?{maxWidth:720,marginLeft:"auto",marginRight:"auto"}:void 0,children:x("Your cart")}),l?(0,M.jsx)("p",{className:"cv2-codemsg is-bad",role:"alert","data-cart-operation-error":!0,children:l}):null,i?(0,M.jsx)("div",{className:"cv2-main",style:{maxWidth:720,margin:"0 auto"},children:(0,M.jsx)(A_,{bootstrap:e,money:P})}):(0,M.jsxs)("div",{className:"cv2-layout","data-cart-form":!0,children:[(0,M.jsxs)("div",{className:"cv2-main",children:[(0,M.jsx)("div",{className:"cv2-only-phone",children:(0,M.jsx)(OU,{snapshot:t,bootstrap:e,money:P,suggestion:w})}),(0,M.jsx)("div",{className:`cv2-people${r.length<2?" is-single":""}`,children:r.map(z=>(0,M.jsx)(b_,{person:z,snapshot:t,bootstrap:e,money:P,busy:a,actions:c,onAddProduct:d},z.id))}),(0,M.jsx)(Ec,{lines:o,presentation:"ordinary",bootstrap:e,busyKeys:s,onQuantityChange:c.changeQuantity}),(0,M.jsx)(Ec,{lines:n,presentation:"accessory",bootstrap:e,busyKeys:s,onQuantityChange:c.changeQuantity}),r.length?U:null,(0,M.jsx)("div",{className:"cv2-only-phone",children:(0,M.jsx)(DU,{snapshot:t,bootstrap:e})}),(0,M.jsx)(v_,{snapshot:t,bootstrap:e,accessories:n,hideInCart:!1,money:Y,busy:a,onAdd:m,onQuantity:(z,te)=>void c.changeQuantity(z,te)})]}),(0,M.jsxs)("div",{className:"cv2-side",children:[(0,M.jsx)("div",{className:"cv2-only-desk",children:(0,M.jsx)(OU,{snapshot:t,bootstrap:e,money:P,suggestion:w})}),(0,M.jsx)(k_,{snapshot:t,bootstrap:e,money:Y,busy:a,onCoupon:g}),(0,M.jsx)("div",{className:"cv2-only-desk",children:(0,M.jsx)(DU,{snapshot:t,bootstrap:e})}),(0,M.jsx)("div",{className:"cv2-desk-checkout",children:(0,M.jsx)(FU,{bootstrap:e})}),(0,M.jsx)(E_,{busy:a}),(0,M.jsx)(X_,{snapshot:t})]}),(0,M.jsxs)("div",{className:"cv2-pinned",children:[I?(0,M.jsx)("div",{className:"cv2-msg cv2-sv",children:I}):null,(0,M.jsxs)("div",{className:"cv2-stot",children:[x("Subtotal"),(0,M.jsx)("b",{children:Y(Number(t.total_price||0))})]}),(0,M.jsx)(FU,{bootstrap:e})]})]}),y]})}var Ve=T(k());function QU({bootstrap:e}){let r=(0,$i.useSyncExternalStore)(FM,Hu,Hu)||e.snapshot,n=(0,$i.useMemo)(()=>F0(r,e),[r,e]),o=(0,$i.useMemo)(()=>HM(r,e),[r,e]),i=o.filter(w=>$h(w,e)),a=o.filter(w=>!$h(w,e)),s=!Zh(r),l=e.ui.currency||"USD",{busyKeys:c,busy:d,status:u,runOperation:p,setStatus:m}=EU(e,r),g=GU(e,p,c),y=_U(e,n,p,m),{editing:P,guardRemoval:Y,bundleRemoval:h}=g,S=(0,$i.useRef)(!1);(0,$i.useEffect)(()=>{if(!s||d||S.current||!r.items.length||/trufit-cart-add-product/.test(window.location.hash))return;S.current=!0;let w=[...r.items];p("clear-hidden-lines",async()=>{for(let I of w)try{await Oh(I,0)}catch(U){}})},[s,d,r.items,p]);let{picker:b}=y;function W(w,I){p(`recommendation-${w.productId}`,()=>aU(w,I))}let C=(0,Ve.jsxs)(Ve.Fragment,{children:[b?(0,Ve.jsx)(LU,{mode:b.mode,person:b.person,initialType:b.initialType,products:e.catalog,busy:d,ui:e.ui,onChoose:y.chooseProduct,onClose:y.closeProductPicker}):null,P?(0,Ve.jsx)(kU,{person:P.person,root:P.root,catalog:e.catalog,settings:e.settings,productOptions:P.productOptions,onClose:g.closeEditor,onSaved:g.closeEditor,onDelete:e.layout==="v2"?()=>{let w=P.person,I=P.root,U=w.roots.find(L=>en(w,L).some(X=>X.key===I.key))||I;g.closeEditor(),g.requestGuardRemoval(w,U,I)}:void 0}):null,Y?(0,Ve.jsx)(XU,{currentCount:Y.currentCount,nextCount:Y.nextCount,currentPackage:Y.currentPackage,downgradedPackage:Y.downgradedPackage,guardIndex:Y.guardIndex,assets:e.ui.bundleDowngradeAssets,busy:c.has(`guard-remove-${Y.target.key}`),onCancel:g.cancelGuardRemoval,onConfirm:()=>void g.confirmGuardRemoval()}):null,h?(0,Ve.jsx)(NU,{busy:c.has(`bundle-${h.root.key}`),onCancel:g.cancelBundleRemoval,onConfirm:()=>void g.confirmBundleRemoval()}):null]});return e.layout==="v2"?(0,Ve.jsxs)(Mn,{appearance:"cart",children:[(0,Ve.jsx)(qu.Document,{}),(0,Ve.jsx)(HU,{bootstrap:e,snapshot:r,people:n,accessories:i,ordinary:a,isEmpty:s,busy:d,busyKeys:c,status:u,actions:g,onAddProduct:(w,I)=>I?y.addProductFor(w,I):y.openProductPicker(w),onNewCustomer:y.openNewCustomerModal,newCustomerPrice:y.newCustomerDisplayPrice||"",onAddRecommendation:W,onCoupon:e1,dialogs:C})]}):(0,Ve.jsxs)(Mn,{appearance:"cart",children:[(0,Ve.jsx)(qu.Document,{}),(0,Ve.jsxs)(ti.Cart,{className:"cart-page","data-cart-react-app":!0,"aria-busy":d||void 0,children:[(0,Ve.jsx)(ti.Form,{className:"cart-form","data-cart-form":!0,children:(0,Ve.jsxs)(ti.Shell,{className:"cart-shell","data-cart-shell":!0,children:[(0,Ve.jsxs)(ti.Content,{className:"cart-content","aria-labelledby":"cart-title",children:[(0,Ve.jsx)("h1",{id:"cart-title",children:e.ui.title||"Cart"}),(0,Ve.jsx)(ti.OperationStatus,{className:"cart-operation-status","data-cart-operation-status":!0,hidden:!u,children:(0,Ve.jsx)(Ar.StatusMessage,{"data-cart-operation-error":!0,role:"alert",children:u})}),s?(0,Ve.jsxs)(ti.Empty,{className:"cart-empty",children:[(0,Ve.jsx)("h2",{children:"Your cart is empty"}),(0,Ve.jsx)("p",{children:"Design your custom-fit mouthguard and it will show up here."}),(0,Ve.jsx)("a",{href:e.ui.continueShoppingUrl,children:"Continue shopping"})]}):(0,Ve.jsxs)(Ve.Fragment,{children:[n.map(w=>(0,Ve.jsx)(PU,{person:w,snapshot:r,bootstrap:e,currency:l,moneyFormat:e.ui.moneyFormat,busy:d,onRename:g.renamePerson,onRemovePerson:g.removePerson,onRemoveBundle:g.requestBundleRemoval,onRemoveLine:g.removeLine,onRemoveComponent:g.removeComponent,onRemoveGuard:g.requestGuardRemoval,onAddProduct:y.openProductPicker,onQuickAddProduct:y.openProductPicker,onRemoveTag:g.removeTag,onEditGuard:g.editGuard},w.id)),(0,Ve.jsx)(Ec,{lines:a,presentation:"ordinary",bootstrap:e,busyKeys:c,onQuantityChange:g.changeQuantity}),(0,Ve.jsx)(Pt.Addons,{$placement:"new-customer",className:"cart-addons",children:(0,Ve.jsxs)("button",{type:"button",disabled:d,onClick:y.openNewCustomerModal,children:[e.ui.cartAddonPlusIconUrl?(0,Ve.jsx)(Pt.AddonsIcon,{className:"cart-addons-icon",children:(0,Ve.jsx)(Ar.ActionIcon,{src:e.ui.cartAddonPlusIconUrl,alt:""})}):null,(0,Ve.jsxs)("span",{children:[e.ui.newCustomerTitle||"Add New Customer",y.newCustomerDisplayPrice?` +${y.newCustomerDisplayPrice}`:""]})]})}),(0,Ve.jsx)(o1,{snapshot:r,bootstrap:e}),(0,Ve.jsx)(Ec,{lines:i,presentation:"accessory",bootstrap:e,busyKeys:c,onQuantityChange:g.changeQuantity})]})]}),(0,Ve.jsx)(IU,{inCart:!0,snapshot:r,bootstrap:e,busy:d,onCoupon:e1,onAddRecommendation:W})]})}),C]})]})}var jU="trufit-cart-payload";function R_(e){try{let t=e.replace(/-/g,"+").replace(/_/g,"/"),r=t.padEnd(t.length+(4-t.length%4)%4,"="),n=window.atob(r),o=Uint8Array.from(n,i=>i.charCodeAt(0));return JSON.parse(new TextDecoder().decode(o))}catch(t){return console.error("TRUFIT cart bridge payload could not be decoded",t),null}}function G_(e){var r,n;let t=((n=(r=window.Shopify)==null?void 0:r.routes)==null?void 0:n.root)||"/";try{let o=new URL(String(e||`${t}cart`),window.location.origin);if(o.origin===window.location.origin)return o.toString()}catch(o){}return new URL(`${t.replace(/\/$/,"")}/cart`,window.location.origin).toString()}function __(){let e=new URLSearchParams(window.location.hash.replace(/^#/,""));e.delete(jU),window.history.replaceState(window.history.state,document.title,`${window.location.pathname}${window.location.search}${e.toString()?`#${e}`:""}`)}function qU(){let t=new URLSearchParams(window.location.hash.replace(/^#/,"")).get(jU);if(!t||window.__trufitCartBridgeSubmitting)return;document.documentElement.classList.add("trufit-cart-bridge-loading"),window.__trufitCartBridgeSubmitting=!0;let r=R_(t);if(!r){window.__trufitCartBridgeSubmitting=!1,document.documentElement.classList.remove("trufit-cart-bridge-loading");return}(async()=>{try{if(!window.trufitCartWithApi)throw new Error("Cart bridge is unavailable. Please refresh the cart.");await window.trufitCartWithApi(o=>{if(typeof o.submitBridgePayload!="function")throw new Error("Cart bridge is unavailable. Please refresh the cart.");return o.submitBridgePayload(r)}),__(),window.__trufitCartBridgeSubmitting=!1,document.documentElement.classList.remove("trufit-cart-bridge-loading"),window.history.replaceState(window.history.state,document.title,G_(r.cartUrl))}catch(o){console.error("TRUFIT cart bridge submit failed",o),window.__trufitCartBridgeSubmitting=!1,document.documentElement.classList.remove("trufit-cart-bridge-loading"),window.__trufitCartBridgeErrorMessage=o instanceof Error?o.message:"We couldn't add this Dashboard purchase to your cart.",window.dispatchEvent(new CustomEvent("trufit:cart-bridge-error",{detail:{message:window.__trufitCartBridgeErrorMessage}}))}})()}var n2=T(k());function l1(e,t){let r=document.querySelector(e);if(!(r!=null&&r.textContent))return t;try{return Uo(JSON.parse(r.textContent))}catch(n){return console.error(`Cart bootstrap data is invalid: ${e}`,n),t}}function B_(e){try{let t=new URLSearchParams(window.location.search),r=String(t.get("pm_layout")||"").toLowerCase();(r==="v3"||r==="classic")&&window.sessionStorage.setItem("trufit:pm-layout",r);let n=window.sessionStorage.getItem("trufit:pm-layout");if(n==="v3")return"v2";if(n==="classic")return"classic"}catch(t){}return e.dataset.cartLayout==="v2"?"v2":"classic"}function Z_(e){var g,y,P,Y,h,S,b,W,C,w;let t=document.querySelector("[data-purchase-master-cart-snapshot]");if(!(t!=null&&t.textContent))return null;let r=Uo(JSON.parse(t.textContent)),n=LS(r),o=l1("[data-cart-purchase-master-products]",[]),i=l1("[data-cart-purchase-master-settings]",{}),a=l1("[data-trufit-cart-ui-config]",{}),s=Xm(),l=s?o.map(I=>wS(I,s.rate)):o,c=s?ps(i,s.rate):i,d=s?{...a,lineMeta:a.lineMeta?ps(a.lineMeta,s.rate):a.lineMeta,ui:a.ui?{...a.ui,rewards:a.ui.rewards}:a.ui}:a,p={...{currency:((y=(g=window.Shopify)==null?void 0:g.currency)==null?void 0:y.active)||"USD",locale:((P=window.Shopify)==null?void 0:P.locale)||document.documentElement.lang||"en",moneyFormat:"",rootUrl:((h=(Y=window.Shopify)==null?void 0:Y.routes)==null?void 0:h.root)||"/",checkoutUrl:`${((b=(S=window.Shopify)==null?void 0:S.routes)==null?void 0:b.root)||"/"}checkout?skip_shop_pay=true`,continueShoppingUrl:((C=(W=window.Shopify)==null?void 0:W.routes)==null?void 0:C.root)||"/",sectionId:((w=e.closest("[id^='shopify-section-']"))==null?void 0:w.id.replace(/^shopify-section-/,""))||"",rewardSalesChannel:"online-store",title:"Cart",recommendedTitle:"Recommended for You",accessoriesTitle:"Accessories",recommendations:[]},...d.ui||{}};p.rootUrl=`${String(p.rootUrl||"/").replace(/\/+$/,"")}/`;let m=e.closest("[data-cart-section]")||e.parentElement;return{layout:B_(e),snapshot:n,catalog:l,settings:c,lineMeta:d.lineMeta||{},ui:p,hosts:{purchaseMaster:(m==null?void 0:m.querySelector("[data-cart-purchase-master-host]"))||null,newCustomer:(m==null?void 0:m.querySelector("[data-cart-new-customer-modal-host]"))||null},syncOrderTags:I=>{var U;return((U=window.trufitSyncCartOrderTags)==null?void 0:U.call(window,I))||Promise.resolve(!1)}}}function $_(){let e=window;e.TrufitCartReady||(e.TrufitCartReady=new Promise(t=>{document.addEventListener("trufit:cart-ready",()=>t(e.TrufitCart),{once:!0})})),e.trufitCartWithApi||(e.trufitCartWithApi=t=>e.TrufitCart?Promise.resolve().then(()=>t(e.TrufitCart)):e.TrufitCartReady.then(()=>t(e.TrufitCart))),e.trufitCartRequest||(e.trufitCartRequest=(t,r)=>e.trufitCartWithApi(n=>n.request(t,r))),e.trufitCartChange||(e.trufitCartChange=(t,r)=>e.trufitCartWithApi(n=>n.change(t,r))),e.trufitCartChangeAndReconcile||(e.trufitCartChangeAndReconcile=(t,r)=>e.trufitCartWithApi(n=>n.changeAndReconcile(t,r))),e.trufitCartTransaction||(e.trufitCartTransaction=t=>e.trufitCartWithApi(r=>r.transaction(t)))}function JU(e){let t=e;if(!(t._trufitCartReactRoot||t.dataset.cartReactMounted==="true"))try{let r=Z_(t);if(!r)throw new Error("The cart snapshot is missing.");Hu()||DM(r.snapshot);let n=(0,t2.createRoot)(t);n.render((0,n2.jsx)(QU,{bootstrap:r})),t._trufitCartReactRoot=n,t.dataset.cartReactMounted="true"}catch(r){console.error("TruFit React cart could not start",r),t.dispatchEvent(new CustomEvent("trufit:cart-bridge-error",{bubbles:!0,detail:{message:"We couldn't load your cart. Refresh the page and try again."}}))}}function e2(e){var r;let t=e;(r=t._trufitCartReactRoot)==null||r.unmount(),t._trufitCartReactRoot=null,delete t.dataset.cartReactMounted}function r2(){$_();let e=(r=document)=>{r instanceof Element&&r.matches("[data-trufit-cart-root]")&&JU(r),r.querySelectorAll("[data-trufit-cart-root]").forEach(JU)},t=r=>{r instanceof Element&&r.matches("[data-trufit-cart-root]")&&e2(r),r.querySelectorAll("[data-trufit-cart-root]").forEach(e2)};e(),document.addEventListener("shopify:section:load",r=>{var n;return e(((n=r.detail)==null?void 0:n.section)||document)}),document.addEventListener("shopify:section:unload",r=>{var n;return t(((n=r.detail)==null?void 0:n.section)||document)}),window.addEventListener("pageshow",r=>{r.persisted&&e()}),qU()}OM();r2();})();
